import * as React from 'react';
import React__default, { useMemo, createContext, useRef, useEffect, useCallback, useState, useContext } from 'react';
import { Box, Button, Typography, FormControl, InputLabel, OutlinedInput, InputAdornment, IconButton, FormGroup, TextField, createTheme, ThemeProvider, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Modal, Tooltip, Select, MenuItem, ListItemIcon, FormHelperText, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, FormControlLabel, Switch, Tabs, Tab, List, ListItem, ListItemText, Checkbox, Menu, Link, TableFooter, TablePagination, useTheme, Alert } from '@mui/material';
import TrashIcon from '@mui/icons-material/DeleteOutline';
import CheckIcon from '@mui/icons-material/Check';
import { keyframes, Box as Box$2, ThemeProvider as ThemeProvider$1, useTheme as useTheme$1 } from '@mui/system';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Box$1 from '@mui/system/Box';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { checkRoles } from '@videostream/role-checker';
import WarningIcon from '@mui/icons-material/Warning';
import Avatar from '@mui/material/Avatar';
import PersonIcon from '@mui/icons-material/Person';
import VpnKey from '@mui/icons-material/VpnKey';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import EditIcon from '@mui/icons-material/EditOutlined';
import DeleteIcon from '@mui/icons-material/DeleteOutlineOutlined';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PlusIcon from '@mui/icons-material/Add';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CloseIcon from '@mui/icons-material/Close';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import SyncIcon from '@mui/icons-material/Sync';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import PinDropIcon from '@mui/icons-material/PinDrop';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import GroupsIcon from '@mui/icons-material/Groups';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import MailIcon from '@mui/icons-material/MailOutline';
import 'react/jsx-runtime';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


function __rest$1(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter$1(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

const colors = {
    primaryMain: "#4EBAA1",
    primaryLight: "#78F8D5",
    primaryDark: "#002019",
    primary99: "#FDFEFE",
    primary95: "#F6FCFA",
    primary90: "#EDF8F6",
    primary80: "#DCF1EC",
    primary70: "#C9EAE3",
    primary60: "#B8E3D9",
    primary50: "#A6DDD0",
    primary40: "#95D6C7",
    primary30: "#83CFBD",
    primary20: "#71C8B4",
    primary10: "#61C0AA",
    primary80Black: "#3E9581",
    secondaryMain: "#4B645B",
    secondaryLight: "#CEE9DE",
    secondaryDark: "#072019",
    tertiaryMain: "#416276",
    neutral: "#5C5F5D",
    outline: "#707975",
    buttonLabelFocusedText: "#006B55",
    buttonText: "#008566",
    link: "#00876D",
    seed: "#58DBB9",
    successGreen: "#52C95D",
    error: "#BA1B1B",
    infoBlue: "#58ACDB",
    warningYellow: "#FFC107",
    digitalYellow: "#D6FC51",
    electricBlue: "#0066FF",
    indianRed: "#DB5461",
    darkIndianRed: "#D43544",
    sweetBrown: "#A7353D",
    surface: "#FBFDFA",
    surface1: "#EFF6F2",
    surface2: "#E7F1ED",
    surface3: "#DFEDE8",
    surface4: "#DDEBE6",
    surface5: "#D8E9E3",
    cloudGrey: "#EEF2F6",
    neutral99: "#FBFDFA",
    neutral95: "#EFF1EE",
    neutral90: "#E0E3E0",
    neutral80: "#C4C7C4",
    neutral70: "#A9ACA9",
    neutral60: "#8E928F",
    neutral50: "#757876",
    neutral40: "#5C5F5D",
    neutral30: "#444846",
    neutral20: "#2D312F",
    neutral10: "#191C1B",
    slate: "#20242A",
    slate99: "#FDFDFD",
    slate95: "#F4F4F4",
    slate90: "#E9E9EA",
    slate80: "#D2D3D4",
    slate70: "#BCBDBF",
    slate60: "#A6A7AA",
    slate50: "#8E9295",
    slate40: "#797D7F",
    slate30: "#63666A",
    slate20: "#4D5055",
    slate10: "#363A3F",
    red50: "#ffebee",
    red100: "#ffcdd2",
    red200: "#ef9a9a",
    red300: "#e57373",
    red400: "#ef5350",
    red500: "#f44336",
    red600: "#e53935",
    red700: "#d32f2f",
    red800: "#c62828",
    red900: "#b71c1c",
    redA100: "#ff8a80",
    redA200: "#ff5252",
    redA400: "#ff1744",
    redA700: "#d50000",
};

const TextFieldStyling = (sx = {}) => (Object.assign({ "minHeight": '35px', '& label': {
        pl: '16px',
    }, '& input': {
        "pl": '24px',
        '&:-webkit-autofill': {
            boxShadow: 'white',
            WebkitBoxShadow: '0 0 0 30px white inset',
        },
    }, '& fieldset': {
        pl: '20px',
        borderRadius: '28px',
    }, '& div.MuiSelect-select': {
        py: '13.5px',
        pl: '25px',
    }, '& label.Mui-focused': {
        color: '#006B55',
        transform: 'translate(14px, -9px) scale(0.75)',
    }, '& .MuiOutlinedInput-root': {
        '&.MuiInputBase-multiline': {
            px: '26px',
        },
        '&.Mui-focused fieldset': {
            pl: '20px',
            borderColor: colors.buttonText,
        },
        '& .Mui-error': {
            borderColor: colors.error,
        },
    }, "width": '100%' }, sx));
const FieldControlStyling = (sx = {}) => (Object.assign({ "height": '35px', '& label': {
        pl: '16px',
    }, '& input': {
        "pl": '22px',
        "py": '12.5px',
        '&:-webkit-autofill': {
            boxShadow: 'white',
            WebkitBoxShadow: '0 0 0 30px white inset',
        },
    }, '& div.MuiSelect-select': {
        pl: '25px',
    }, '& label.Mui-focused': {
        color: colors.buttonText,
        transform: 'translate(14px, -9px) scale(0.75)',
    }, '& .MuiOutlinedInput-root': {
        '&.Mui-focused fieldset': {
            pl: '20px',
            borderColor: colors.buttonText,
        },
    }, "width": '100%' }, sx));
const PasswordFieldStyling = (sx = {}) => ({
    '& input': {
        "pl": '25px',
        '&:-webkit-autofill': {
            boxShadow: 'white',
            WebkitBoxShadow: '0 0 0 30px white inset',
        },
    },
    '& fieldset': {
        pl: '20px',
        borderRadius: '28px',
    },
    '& .MuiOutlinedInput-root': {
        '&.Mui-focused fieldset': {
            pl: '20px',
            borderColor: colors.buttonText,
        },
    },
    "width": '100%',
});

const scaleY = keyframes `
  0%, 80%, 100% { transform: scaleY(0.4); }
  40% { transform: scaleY(1.0); }
`;
const CustomScaleLoader = ({ color = colors.primary20, size = "medium" }) => {
    const gapSizes = {
        small: 0.25,
        medium: 0.5,
        large: 0.75
    };
    const barSizes = {
        "small": 16,
        "medium": 20,
        "large": 24
    };
    return (React__default.createElement(Box, { display: "flex", sx: {
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'stretch',
            gap: gapSizes[size],
        } }, [...Array(5)].map((_, index) => (React__default.createElement(Box, { key: index, sx: {
            flexGrow: 1,
            width: '3px',
            height: `${barSizes[size]}px`,
            bgcolor: color,
            borderRadius: '9999px',
            animation: `${scaleY} 1s ${index * 0.15}s infinite ease-in-out`
        } })))));
};

const RTButton = (props) => {
    const { type, text, disabled, startIcon, isLoading } = props;
    const _a = useButtonProps(type, props), { generatedProps } = _a, calculatedProps = __rest$1(_a, ["generatedProps"]);
    const startIconToShow = isLoading ? undefined : (startIcon || generatedProps.startIcon);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Button, Object.assign({ disabled: disabled || isLoading, startIcon: startIconToShow }, calculatedProps),
            isLoading ? React__default.createElement(CustomScaleLoader, { color: colors.primary20 }) : (text || null),
            " ")));
};
const useButtonProps = (type, props) => {
    const generatedProps = useMemo(() => generateProps(type), [type]);
    return {
        generatedProps,
        type: props.isSubmit ? 'submit' : undefined,
        onClick: props.onClick,
        id: props.id,
        variant: props.variant || 'contained',
        sx: Object.assign({ "width": '100%', "marginTop": '25px', "borderRadius": '100px', "height": '48px', "fontSize": '14px', "fontWeight": 700, "backgroundColor": generatedProps.bg, "color": generatedProps.color, "boxShadow": 0, "&:hover": {
                backgroundColor: generatedProps.hover,
            }, "&.Mui-disabled": {
                backgroundColor: theme => theme.palette.action.disabledBackground,
                color: theme => theme.palette.action.disabled
            } }, props.sx)
    };
};
const generateProps = (type) => {
    if (type === 'primary') {
        return { bg: colors.primary10, color: 'white', hover: colors.primary20 };
    }
    if (type === 'secondary') {
        return { bg: 'white', color: colors.primary80Black, hover: 'white' };
    }
    if (type === 'delete') {
        return { bg: colors.red200, color: 'black', hover: colors.red300, startIcon: React__default.createElement(TrashIcon, null) };
    }
    if (type === 'save') {
        return { bg: colors.primary10, color: 'white', hover: colors.primary20, startIcon: React__default.createElement(CheckIcon, null) };
    }
    return { bg: colors.red800, color: 'white', hover: colors.red900 };
};

function useLoadGsiScript(options = {}) {
    const { nonce, onScriptLoadSuccess, onScriptLoadError } = options;
    const [scriptLoadedSuccessfully, setScriptLoadedSuccessfully] = useState(false);
    const onScriptLoadSuccessRef = useRef(onScriptLoadSuccess);
    onScriptLoadSuccessRef.current = onScriptLoadSuccess;
    const onScriptLoadErrorRef = useRef(onScriptLoadError);
    onScriptLoadErrorRef.current = onScriptLoadError;
    useEffect(() => {
        const scriptTag = document.createElement('script');
        scriptTag.src = 'https://accounts.google.com/gsi/client';
        scriptTag.async = true;
        scriptTag.defer = true;
        scriptTag.nonce = nonce;
        scriptTag.onload = () => {
            var _a;
            setScriptLoadedSuccessfully(true);
            (_a = onScriptLoadSuccessRef.current) === null || _a === void 0 ? void 0 : _a.call(onScriptLoadSuccessRef);
        };
        scriptTag.onerror = () => {
            var _a;
            setScriptLoadedSuccessfully(false);
            (_a = onScriptLoadErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onScriptLoadErrorRef);
        };
        document.body.appendChild(scriptTag);
        return () => {
            document.body.removeChild(scriptTag);
        };
    }, [nonce]);
    return scriptLoadedSuccessfully;
}

const GoogleOAuthContext = createContext(null);
function GoogleOAuthProvider({ clientId, nonce, onScriptLoadSuccess, onScriptLoadError, children, }) {
    const scriptLoadedSuccessfully = useLoadGsiScript({
        nonce,
        onScriptLoadSuccess,
        onScriptLoadError,
    });
    const contextValue = useMemo(() => ({
        clientId,
        scriptLoadedSuccessfully,
    }), [clientId, scriptLoadedSuccessfully]);
    return (React__default.createElement(GoogleOAuthContext.Provider, { value: contextValue }, children));
}
function useGoogleOAuth() {
    const context = useContext(GoogleOAuthContext);
    if (!context) {
        throw new Error('Google OAuth components must be used within GoogleOAuthProvider');
    }
    return context;
}

/* eslint-disable import/export */
function useGoogleLogin({ flow = 'implicit', scope = '', onSuccess, onError, onNonOAuthError, overrideScope, state, ...props }) {
    const { clientId, scriptLoadedSuccessfully } = useGoogleOAuth();
    const clientRef = useRef();
    const onSuccessRef = useRef(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = useRef(onError);
    onErrorRef.current = onError;
    const onNonOAuthErrorRef = useRef(onNonOAuthError);
    onNonOAuthErrorRef.current = onNonOAuthError;
    useEffect(() => {
        var _a, _b;
        if (!scriptLoadedSuccessfully)
            return;
        const clientMethod = flow === 'implicit' ? 'initTokenClient' : 'initCodeClient';
        const client = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.oauth2[clientMethod]({
            client_id: clientId,
            scope: overrideScope ? scope : `openid profile email ${scope}`,
            callback: (response) => {
                var _a, _b;
                if (response.error)
                    return (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef, response);
                (_b = onSuccessRef.current) === null || _b === void 0 ? void 0 : _b.call(onSuccessRef, response);
            },
            error_callback: (nonOAuthError) => {
                var _a;
                (_a = onNonOAuthErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onNonOAuthErrorRef, nonOAuthError);
            },
            state,
            ...props,
        });
        clientRef.current = client;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clientId, scriptLoadedSuccessfully, flow, scope, state]);
    const loginImplicitFlow = useCallback((overrideConfig) => { var _a; return (_a = clientRef.current) === null || _a === void 0 ? void 0 : _a.requestAccessToken(overrideConfig); }, []);
    const loginAuthCodeFlow = useCallback(() => { var _a; return (_a = clientRef.current) === null || _a === void 0 ? void 0 : _a.requestCode(); }, []);
    return flow === 'implicit' ? loginImplicitFlow : loginAuthCodeFlow;
}

const blankTenantSSOConfig = {
    ssoProvider: 'RouteThisSSO',
    ssoAllowSelfSignup: false,
    new: true,
    SAMLConfig: {
        cognitoIdentityProvider: {
            AttributeMapping: {},
            ProviderDetails: {},
        }
    }
};
const TenantNumericFields = [
    'customerName',
    'routerName',
    'areaUnits',
    'levelName',
    'podName',
    'wifiName',
    'maxPasswordAge',
    'maxLoginAttempts',
    'loginTimeoutSeconds',
    'maxDaysBetweenLogins',
    'idleTimeoutSeconds',
    'numberOfOldPasswords',
];
const blankUser = {
    email: '',
    displayName: '',
    TenantId: '',
    role: '',
    userApp: '',
    createdAt: 0,
    updatedAt: 0,
    firstName: '',
    lastName: '',
    resolveId: '',
    passwordLastSet: 0,
    lastLoginAttempt: 0,
    failedLoginAttempts: 0,
    lastSuccessfulLogin: 0,
    disabled: false,
    disabledReason: '',
    emailVerified: false,
    lastPasswordHashes: [],
    region: '',
    from_import: false,
    roles: [],
    entitlements: [],
    ssoProvider: '',
    ignoreUsage: false,
    groupUsers: [],
    deleted: false,
};
const blankRavaKinesisDetails = {
    tenant_id: '',
    role_arn: '',
    role_session_name: 'RavaKinesisRole',
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */

var isArray$c = Array.isArray;

var isArray_1 = isArray$c;

/** Detect free variable `global` from Node.js. */

var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal$1;

var freeGlobal = _freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$8 = freeGlobal || freeSelf || Function('return this')();

var _root = root$8;

var root$7 = _root;

/** Built-in value references. */
var Symbol$6 = root$7.Symbol;

var _Symbol = Symbol$6;

var Symbol$5 = _Symbol;

/** Used for built-in method references. */
var objectProto$f = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$d = objectProto$f.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$f.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$5 ? Symbol$5.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$d.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

var _getRawTag = getRawTag$1;

/** Used for built-in method references. */

var objectProto$e = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$e.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}

var _objectToString = objectToString$1;

var Symbol$4 = _Symbol,
    getRawTag = _getRawTag,
    objectToString = _objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol$4 ? Symbol$4.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag$6(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

var _baseGetTag = baseGetTag$6;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike$7(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike$7;

var baseGetTag$5 = _baseGetTag,
    isObjectLike$6 = isObjectLike_1;

/** `Object#toString` result references. */
var symbolTag$1 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$5(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$6(value) && baseGetTag$5(value) == symbolTag$1);
}

var isSymbol_1 = isSymbol$5;

var isArray$b = isArray_1,
    isSymbol$4 = isSymbol_1;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey$3(value, object) {
  if (isArray$b(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol$4(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

var _isKey = isKey$3;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

function isObject$a(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$a;

var baseGetTag$4 = _baseGetTag,
    isObject$9 = isObject_1;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag$1 = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$4(value) {
  if (!isObject$9(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag$4(value);
  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction$4;

var root$6 = _root;

/** Used to detect overreaching core-js shims. */
var coreJsData$1 = root$6['__core-js_shared__'];

var _coreJsData = coreJsData$1;

var coreJsData = _coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked$1(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked$1;

/** Used for built-in method references. */

var funcProto$2 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$2.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource$2;

var isFunction$3 = isFunction_1,
    isMasked = _isMasked,
    isObject$8 = isObject_1,
    toSource$1 = _toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype,
    objectProto$d = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$c = objectProto$d.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString$1.call(hasOwnProperty$c).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative$1(value) {
  if (!isObject$8(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$3(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource$1(value));
}

var _baseIsNative = baseIsNative$1;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue$1(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue$1;

var baseIsNative = _baseIsNative,
    getValue = _getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative$7(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

var _getNative = getNative$7;

var getNative$6 = _getNative;

/* Built-in method references that are verified to be native. */
var nativeCreate$4 = getNative$6(Object, 'create');

var _nativeCreate = nativeCreate$4;

var nativeCreate$3 = _nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}

var _hashClear = hashClear$1;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete$1;

var nativeCreate$2 = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$c = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$b = objectProto$c.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$2) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? undefined : result;
  }
  return hasOwnProperty$b.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet$1;

var nativeCreate$1 = _nativeCreate;

/** Used for built-in method references. */
var objectProto$b = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$b.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1 ? (data[key] !== undefined) : hasOwnProperty$a.call(data, key);
}

var _hashHas = hashHas$1;

var nativeCreate = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet$1;

var hashClear = _hashClear,
    hashDelete = _hashDelete,
    hashGet = _hashGet,
    hashHas = _hashHas,
    hashSet = _hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash$1(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash$1.prototype.clear = hashClear;
Hash$1.prototype['delete'] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;

var _Hash = Hash$1;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */

function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear$1;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq$5(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq$5;

var eq$4 = eq_1;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf$4(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$4(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf$4;

var assocIndexOf$3 = _assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete$1(key) {
  var data = this.__data__,
      index = assocIndexOf$3(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete$1;

var assocIndexOf$2 = _assocIndexOf;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet$1(key) {
  var data = this.__data__,
      index = assocIndexOf$2(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet$1;

var assocIndexOf$1 = _assocIndexOf;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas$1;

var assocIndexOf = _assocIndexOf;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet$1(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet$1;

var listCacheClear = _listCacheClear,
    listCacheDelete = _listCacheDelete,
    listCacheGet = _listCacheGet,
    listCacheHas = _listCacheHas,
    listCacheSet = _listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache$4(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype['delete'] = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;

var _ListCache = ListCache$4;

var getNative$5 = _getNative,
    root$5 = _root;

/* Built-in method references that are verified to be native. */
var Map$4 = getNative$5(root$5, 'Map');

var _Map = Map$4;

var Hash = _Hash,
    ListCache$3 = _ListCache,
    Map$3 = _Map;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map$3 || ListCache$3),
    'string': new Hash
  };
}

var _mapCacheClear = mapCacheClear$1;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */

function isKeyable$1(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable$1;

var isKeyable = _isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData$4(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData$4;

var getMapData$3 = _getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete$1;

var getMapData$2 = _getMapData;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}

var _mapCacheGet = mapCacheGet$1;

var getMapData$1 = _getMapData;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}

var _mapCacheHas = mapCacheHas$1;

var getMapData = _getMapData;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet$1(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet$1;

var mapCacheClear = _mapCacheClear,
    mapCacheDelete = _mapCacheDelete,
    mapCacheGet = _mapCacheGet,
    mapCacheHas = _mapCacheHas,
    mapCacheSet = _mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache$3(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache$3.prototype.clear = mapCacheClear;
MapCache$3.prototype['delete'] = mapCacheDelete;
MapCache$3.prototype.get = mapCacheGet;
MapCache$3.prototype.has = mapCacheHas;
MapCache$3.prototype.set = mapCacheSet;

var _MapCache = MapCache$3;

var MapCache$2 = _MapCache;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$1(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$1.Cache || MapCache$2);
  return memoized;
}

// Expose `MapCache`.
memoize$1.Cache = MapCache$2;

var memoize_1 = memoize$1;

var memoize = memoize_1;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped$1(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped$1;

var memoizeCapped = _memoizeCapped;

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath$1 = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

var _stringToPath = stringToPath$1;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */

function arrayMap$2(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap$2;

var Symbol$3 = _Symbol,
    arrayMap$1 = _arrayMap,
    isArray$a = isArray_1,
    isSymbol$3 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY$3 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = Symbol$3 ? Symbol$3.prototype : undefined,
    symbolToString = symbolProto$1 ? symbolProto$1.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString$1(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$a(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap$1(value, baseToString$1) + '';
  }
  if (isSymbol$3(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$3) ? '-0' : result;
}

var _baseToString = baseToString$1;

var baseToString = _baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$7(value) {
  return value == null ? '' : baseToString(value);
}

var toString_1 = toString$7;

var isArray$9 = isArray_1,
    isKey$2 = _isKey,
    stringToPath = _stringToPath,
    toString$6 = toString_1;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath$2(value, object) {
  if (isArray$9(value)) {
    return value;
  }
  return isKey$2(value, object) ? [value] : stringToPath(toString$6(value));
}

var _castPath = castPath$2;

var isSymbol$2 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY$2 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey$4(value) {
  if (typeof value == 'string' || isSymbol$2(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$2) ? '-0' : result;
}

var _toKey = toKey$4;

var castPath$1 = _castPath,
    toKey$3 = _toKey;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet$3(object, path) {
  path = castPath$1(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey$3(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

var _baseGet = baseGet$3;

var baseGet$2 = _baseGet;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get$1(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet$2(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get$1;

var get$2 = /*@__PURE__*/getDefaultExportFromCjs(get_1);

/** Used for built-in method references. */

var objectProto$a = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$a.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas$1(object, key) {
  return object != null && hasOwnProperty$9.call(object, key);
}

var _baseHas = baseHas$1;

var baseGetTag$3 = _baseGetTag,
    isObjectLike$5 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments$1(value) {
  return isObjectLike$5(value) && baseGetTag$3(value) == argsTag$2;
}

var _baseIsArguments = baseIsArguments$1;

var baseIsArguments = _baseIsArguments,
    isObjectLike$4 = isObjectLike_1;

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$9.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$9.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments$4 = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike$4(value) && hasOwnProperty$8.call(value, 'callee') &&
    !propertyIsEnumerable$1.call(value, 'callee');
};

var isArguments_1 = isArguments$4;

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER$3 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex$3(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$3 : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex$3;

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER$2 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength$3(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$2;
}

var isLength_1 = isLength$3;

var castPath = _castPath,
    isArguments$3 = isArguments_1,
    isArray$8 = isArray_1,
    isIndex$2 = _isIndex,
    isLength$2 = isLength_1,
    toKey$2 = _toKey;

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath$2(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey$2(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength$2(length) && isIndex$2(key, length) &&
    (isArray$8(object) || isArguments$3(object));
}

var _hasPath = hasPath$2;

var baseHas = _baseHas,
    hasPath$1 = _hasPath;

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath$1(object, path, baseHas);
}

var has_1 = has;

var has$1 = /*@__PURE__*/getDefaultExportFromCjs(has_1);

var ListCache$2 = _ListCache;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear$1() {
  this.__data__ = new ListCache$2;
  this.size = 0;
}

var _stackClear = stackClear$1;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function stackDelete$1(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete$1;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function stackGet$1(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet$1;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function stackHas$1(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas$1;

var ListCache$1 = _ListCache,
    Map$2 = _Map,
    MapCache$1 = _MapCache;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE$1 = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet$1(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$1) {
    var pairs = data.__data__;
    if (!Map$2 || (pairs.length < LARGE_ARRAY_SIZE$1 - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$1(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet$1;

var ListCache = _ListCache,
    stackClear = _stackClear,
    stackDelete = _stackDelete,
    stackGet = _stackGet,
    stackHas = _stackHas,
    stackSet = _stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack$3(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack$3.prototype.clear = stackClear;
Stack$3.prototype['delete'] = stackDelete;
Stack$3.prototype.get = stackGet;
Stack$3.prototype.has = stackHas;
Stack$3.prototype.set = stackSet;

var _Stack = Stack$3;

var getNative$4 = _getNative;

var defineProperty$2 = (function() {
  try {
    var func = getNative$4(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty = defineProperty$2;

var defineProperty$1 = _defineProperty;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue$3(object, key, value) {
  if (key == '__proto__' && defineProperty$1) {
    defineProperty$1(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue$3;

var baseAssignValue$2 = _baseAssignValue,
    eq$3 = eq_1;

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue$2(object, key, value) {
  if ((value !== undefined && !eq$3(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue$2(object, key, value);
  }
}

var _assignMergeValue = assignMergeValue$2;

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */

function createBaseFor$1(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

var _createBaseFor = createBaseFor$1;

var createBaseFor = _createBaseFor;

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor$2 = createBaseFor();

var _baseFor = baseFor$2;

var _cloneBuffer = {exports: {}};

_cloneBuffer.exports;

(function (module, exports) {
	var root = _root;

	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

	  buffer.copy(result);
	  return result;
	}

	module.exports = cloneBuffer; 
} (_cloneBuffer, _cloneBuffer.exports));

var _cloneBufferExports = _cloneBuffer.exports;

var root$4 = _root;

/** Built-in value references. */
var Uint8Array$3 = root$4.Uint8Array;

var _Uint8Array = Uint8Array$3;

var Uint8Array$2 = _Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer$1(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$2(result).set(new Uint8Array$2(arrayBuffer));
  return result;
}

var _cloneArrayBuffer = cloneArrayBuffer$1;

var cloneArrayBuffer = _cloneArrayBuffer;

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray$1(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var _cloneTypedArray = cloneTypedArray$1;

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */

function copyArray$1(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

var _copyArray = copyArray$1;

var isObject$7 = isObject_1;

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate$1 = (function() {
  function object() {}
  return function(proto) {
    if (!isObject$7(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

var _baseCreate = baseCreate$1;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */

function overArg$2(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg$2;

var overArg$1 = _overArg;

/** Built-in value references. */
var getPrototype$2 = overArg$1(Object.getPrototypeOf, Object);

var _getPrototype = getPrototype$2;

/** Used for built-in method references. */

var objectProto$8 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype$3(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$8;

  return value === proto;
}

var _isPrototype = isPrototype$3;

var baseCreate = _baseCreate,
    getPrototype$1 = _getPrototype,
    isPrototype$2 = _isPrototype;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject$1(object) {
  return (typeof object.constructor == 'function' && !isPrototype$2(object))
    ? baseCreate(getPrototype$1(object))
    : {};
}

var _initCloneObject = initCloneObject$1;

var isFunction$2 = isFunction_1,
    isLength$1 = isLength_1;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike$6(value) {
  return value != null && isLength$1(value.length) && !isFunction$2(value);
}

var isArrayLike_1 = isArrayLike$6;

var isArrayLike$5 = isArrayLike_1,
    isObjectLike$3 = isObjectLike_1;

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject$1(value) {
  return isObjectLike$3(value) && isArrayLike$5(value);
}

var isArrayLikeObject_1 = isArrayLikeObject$1;

var isBuffer$4 = {exports: {}};

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */

function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

isBuffer$4.exports;

(function (module, exports) {
	var root = _root,
	    stubFalse = stubFalse_1;

	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;

	module.exports = isBuffer; 
} (isBuffer$4, isBuffer$4.exports));

var isBufferExports = isBuffer$4.exports;

var baseGetTag$2 = _baseGetTag,
    getPrototype = _getPrototype,
    isObjectLike$2 = isObjectLike_1;

/** `Object#toString` result references. */
var objectTag$3 = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto$7 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$7.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject$3(value) {
  if (!isObjectLike$2(value) || baseGetTag$2(value) != objectTag$3) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$7.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

var isPlainObject_1 = isPlainObject$3;

var baseGetTag$1 = _baseGetTag,
    isLength = isLength_1,
    isObjectLike$1 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag = '[object Function]',
    mapTag$2 = '[object Map]',
    numberTag$1 = '[object Number]',
    objectTag$2 = '[object Object]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$1 = '[object String]',
    weakMapTag$1 = '[object WeakMap]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$2 = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] =
typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] =
typedArrayTags[dataViewTag$2] = typedArrayTags[dateTag$1] =
typedArrayTags[errorTag$1] = typedArrayTags[funcTag] =
typedArrayTags[mapTag$2] = typedArrayTags[numberTag$1] =
typedArrayTags[objectTag$2] = typedArrayTags[regexpTag$1] =
typedArrayTags[setTag$2] = typedArrayTags[stringTag$1] =
typedArrayTags[weakMapTag$1] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray$1(value) {
  return isObjectLike$1(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag$1(value)];
}

var _baseIsTypedArray = baseIsTypedArray$1;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */

function baseUnary$2(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary$2;

var _nodeUtil = {exports: {}};

_nodeUtil.exports;

(function (module, exports) {
	var freeGlobal = _freeGlobal;

	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;

	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;

	    if (types) {
	      return types;
	    }

	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());

	module.exports = nodeUtil; 
} (_nodeUtil, _nodeUtil.exports));

var _nodeUtilExports = _nodeUtil.exports;

var baseIsTypedArray = _baseIsTypedArray,
    baseUnary$1 = _baseUnary,
    nodeUtil = _nodeUtilExports;

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray$4 = nodeIsTypedArray ? baseUnary$1(nodeIsTypedArray) : baseIsTypedArray;

var isTypedArray_1 = isTypedArray$4;

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function safeGet$2(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

var _safeGet = safeGet$2;

var baseAssignValue$1 = _baseAssignValue,
    eq$2 = eq_1;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$6.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue$2(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$6.call(object, key) && eq$2(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue$1(object, key, value);
  }
}

var _assignValue = assignValue$2;

var assignValue$1 = _assignValue,
    baseAssignValue = _baseAssignValue;

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject$1(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue$1(object, key, newValue);
    }
  }
  return object;
}

var _copyObject = copyObject$1;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */

function baseTimes$1(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes$1;

var baseTimes = _baseTimes,
    isArguments$2 = isArguments_1,
    isArray$7 = isArray_1,
    isBuffer$3 = isBufferExports,
    isIndex$1 = _isIndex,
    isTypedArray$3 = isTypedArray_1;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$5.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys$2(value, inherited) {
  var isArr = isArray$7(value),
      isArg = !isArr && isArguments$2(value),
      isBuff = !isArr && !isArg && isBuffer$3(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray$3(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$5.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex$1(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys$2;

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function nativeKeysIn$1(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

var _nativeKeysIn = nativeKeysIn$1;

var isObject$6 = isObject_1,
    isPrototype$1 = _isPrototype,
    nativeKeysIn = _nativeKeysIn;

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$4.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn$1(object) {
  if (!isObject$6(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype$1(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$4.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

var _baseKeysIn = baseKeysIn$1;

var arrayLikeKeys$1 = _arrayLikeKeys,
    baseKeysIn = _baseKeysIn,
    isArrayLike$4 = isArrayLike_1;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn$2(object) {
  return isArrayLike$4(object) ? arrayLikeKeys$1(object, true) : baseKeysIn(object);
}

var keysIn_1 = keysIn$2;

var copyObject = _copyObject,
    keysIn$1 = keysIn_1;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject$1(value) {
  return copyObject(value, keysIn$1(value));
}

var toPlainObject_1 = toPlainObject$1;

var assignMergeValue$1 = _assignMergeValue,
    cloneBuffer = _cloneBufferExports,
    cloneTypedArray = _cloneTypedArray,
    copyArray = _copyArray,
    initCloneObject = _initCloneObject,
    isArguments$1 = isArguments_1,
    isArray$6 = isArray_1,
    isArrayLikeObject = isArrayLikeObject_1,
    isBuffer$2 = isBufferExports,
    isFunction$1 = isFunction_1,
    isObject$5 = isObject_1,
    isPlainObject$2 = isPlainObject_1,
    isTypedArray$2 = isTypedArray_1,
    safeGet$1 = _safeGet,
    toPlainObject = toPlainObject_1;

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep$1(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet$1(object, key),
      srcValue = safeGet$1(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue$1(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray$6(srcValue),
        isBuff = !isArr && isBuffer$2(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray$2(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray$6(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject$2(srcValue) || isArguments$1(srcValue)) {
      newValue = objValue;
      if (isArguments$1(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject$5(objValue) || isFunction$1(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue$1(object, key, newValue);
}

var _baseMergeDeep = baseMergeDeep$1;

var Stack$2 = _Stack,
    assignMergeValue = _assignMergeValue,
    baseFor$1 = _baseFor,
    baseMergeDeep = _baseMergeDeep,
    isObject$4 = isObject_1,
    keysIn = keysIn_1,
    safeGet = _safeGet;

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge$1(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor$1(source, function(srcValue, key) {
    stack || (stack = new Stack$2);
    if (isObject$4(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge$1, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

var _baseMerge = baseMerge$1;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */

function identity$4(value) {
  return value;
}

var identity_1 = identity$4;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */

function apply$1(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

var _apply = apply$1;

var apply = _apply;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$1 = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest$1(func, start, transform) {
  start = nativeMax$1(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax$1(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

var _overRest = overRest$1;

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */

function constant$1(value) {
  return function() {
    return value;
  };
}

var constant_1 = constant$1;

var constant = constant_1,
    defineProperty = _defineProperty,
    identity$3 = identity_1;

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString$1 = !defineProperty ? identity$3 : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

var _baseSetToString = baseSetToString$1;

/** Used to detect hot functions by number of calls within a span of milliseconds. */

var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut$1(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

var _shortOut = shortOut$1;

var baseSetToString = _baseSetToString,
    shortOut = _shortOut;

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString$1 = shortOut(baseSetToString);

var _setToString = setToString$1;

var identity$2 = identity_1,
    overRest = _overRest,
    setToString = _setToString;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest$2(func, start) {
  return setToString(overRest(func, start, identity$2), func + '');
}

var _baseRest = baseRest$2;

var eq$1 = eq_1,
    isArrayLike$3 = isArrayLike_1,
    isIndex = _isIndex,
    isObject$3 = isObject_1;

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall$4(value, index, object) {
  if (!isObject$3(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike$3(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq$1(object[index], value);
  }
  return false;
}

var _isIterateeCall = isIterateeCall$4;

var baseRest$1 = _baseRest,
    isIterateeCall$3 = _isIterateeCall;

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner$1(assigner) {
  return baseRest$1(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall$3(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

var _createAssigner = createAssigner$1;

var baseMerge = _baseMerge,
    createAssigner = _createAssigner;

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge$1 = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

var merge_1 = merge$1;

var merge$2 = /*@__PURE__*/getDefaultExportFromCjs(merge_1);

/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

var _setCacheAdd = setCacheAdd$1;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */

function setCacheHas$1(value) {
  return this.__data__.has(value);
}

var _setCacheHas = setCacheHas$1;

var MapCache = _MapCache,
    setCacheAdd = _setCacheAdd,
    setCacheHas = _setCacheHas;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache$2(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache$2.prototype.add = SetCache$2.prototype.push = setCacheAdd;
SetCache$2.prototype.has = setCacheHas;

var _SetCache = SetCache$2;

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function baseFindIndex$1(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

var _baseFindIndex = baseFindIndex$1;

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */

function baseIsNaN$1(value) {
  return value !== value;
}

var _baseIsNaN = baseIsNaN$1;

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function strictIndexOf$1(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

var _strictIndexOf = strictIndexOf$1;

var baseFindIndex = _baseFindIndex,
    baseIsNaN = _baseIsNaN,
    strictIndexOf = _strictIndexOf;

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf$1(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

var _baseIndexOf = baseIndexOf$1;

var baseIndexOf = _baseIndexOf;

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes$1(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

var _arrayIncludes = arrayIncludes$1;

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */

function arrayIncludesWith$1(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

var _arrayIncludesWith = arrayIncludesWith$1;

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function cacheHas$2(cache, key) {
  return cache.has(key);
}

var _cacheHas = cacheHas$2;

var getNative$3 = _getNative,
    root$3 = _root;

/* Built-in method references that are verified to be native. */
var Set$3 = getNative$3(root$3, 'Set');

var _Set = Set$3;

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */

function noop$3() {
  // No operation performed.
}

var noop_1 = noop$3;

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */

function setToArray$3(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

var _setToArray = setToArray$3;

var Set$2 = _Set,
    noop$2 = noop_1,
    setToArray$2 = _setToArray;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet$1 = !(Set$2 && (1 / setToArray$2(new Set$2([,-0]))[1]) == INFINITY$1) ? noop$2 : function(values) {
  return new Set$2(values);
};

var _createSet = createSet$1;

var SetCache$1 = _SetCache,
    arrayIncludes = _arrayIncludes,
    arrayIncludesWith = _arrayIncludesWith,
    cacheHas$1 = _cacheHas,
    createSet = _createSet,
    setToArray$1 = _setToArray;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq$1(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray$1(set);
    }
    isCommon = false;
    includes = cacheHas$1;
    seen = new SetCache$1;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

var _baseUniq = baseUniq$1;

var baseUniq = _baseUniq;

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

var uniq_1 = uniq;

var uniq$1 = /*@__PURE__*/getDefaultExportFromCjs(uniq_1);

const defaultLocaleResolver = (i18n, locale) => {
    const locales = [];
    const list = [];
    locales.push(locale);
    if (!locale) {
        locales.push(i18n.locale);
    }
    if (i18n.enableFallback) {
        locales.push(i18n.defaultLocale);
    }
    locales
        .filter(Boolean)
        .map((entry) => entry.toString())
        .forEach(function (currentLocale) {
        if (!list.includes(currentLocale)) {
            list.push(currentLocale);
        }
        if (!i18n.enableFallback) {
            return;
        }
        const codes = currentLocale.split("-");
        if (codes.length === 3) {
            list.push(`${codes[0]}-${codes[1]}`);
        }
        list.push(codes[0]);
    });
    return uniq$1(list);
};
class Locales {
    constructor(i18n) {
        this.i18n = i18n;
        this.registry = {};
        this.register("default", defaultLocaleResolver);
    }
    register(locale, localeResolver) {
        if (typeof localeResolver !== "function") {
            const result = localeResolver;
            localeResolver = (() => result);
        }
        this.registry[locale] = localeResolver;
    }
    get(locale) {
        let locales = this.registry[locale] ||
            this.registry[this.i18n.locale] ||
            this.registry.default;
        if (typeof locales === "function") {
            locales = locales(this.i18n, locale);
        }
        if (!(locales instanceof Array)) {
            locales = [locales];
        }
        return locales;
    }
}

const en$1 = (n, ord) => {
  const s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord) return n10 == 1 && n100 != 11 ? 'one'
    : n10 == 2 && n100 != 12 ? 'two'
    : n10 == 3 && n100 != 13 ? 'few'
    : 'other';
  return n == 1 && v0 ? 'one' : 'other';
};

function useMakePlural({ pluralizer, includeZero = true, ordinal = false, }) {
    return function (_i18n, count) {
        return [
            includeZero && count === 0 ? "zero" : "",
            pluralizer(count, ordinal),
        ].filter(Boolean);
    };
}
const defaultPluralizer = useMakePlural({
    pluralizer: en$1,
    includeZero: true,
});
class Pluralization {
    constructor(i18n) {
        this.i18n = i18n;
        this.registry = {};
        this.register("default", defaultPluralizer);
    }
    register(locale, pluralizer) {
        this.registry[locale] = pluralizer;
    }
    get(locale) {
        return (this.registry[locale] ||
            this.registry[this.i18n.locale] ||
            this.registry["default"]);
    }
}

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */

function baseSlice$1(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

var _baseSlice = baseSlice$1;

var baseSlice = _baseSlice;

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice$1(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

var _castSlice = castSlice$1;

/** Used to compose unicode character classes. */

var rsAstralRange$2 = '\\ud800-\\udfff',
    rsComboMarksRange$3 = '\\u0300-\\u036f',
    reComboHalfMarksRange$3 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$3 = '\\u20d0-\\u20ff',
    rsComboRange$3 = rsComboMarksRange$3 + reComboHalfMarksRange$3 + rsComboSymbolsRange$3,
    rsVarRange$2 = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ$2 = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ$2 + rsAstralRange$2  + rsComboRange$3 + rsVarRange$2 + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode$2(string) {
  return reHasUnicode.test(string);
}

var _hasUnicode = hasUnicode$2;

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */

function asciiToArray$1(string) {
  return string.split('');
}

var _asciiToArray = asciiToArray$1;

/** Used to compose unicode character classes. */

var rsAstralRange$1 = '\\ud800-\\udfff',
    rsComboMarksRange$2 = '\\u0300-\\u036f',
    reComboHalfMarksRange$2 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$2 = '\\u20d0-\\u20ff',
    rsComboRange$2 = rsComboMarksRange$2 + reComboHalfMarksRange$2 + rsComboSymbolsRange$2,
    rsVarRange$1 = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange$1 + ']',
    rsCombo$2 = '[' + rsComboRange$2 + ']',
    rsFitz$1 = '\\ud83c[\\udffb-\\udfff]',
    rsModifier$1 = '(?:' + rsCombo$2 + '|' + rsFitz$1 + ')',
    rsNonAstral$1 = '[^' + rsAstralRange$1 + ']',
    rsRegional$1 = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair$1 = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ$1 = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod$1 = rsModifier$1 + '?',
    rsOptVar$1 = '[' + rsVarRange$1 + ']?',
    rsOptJoin$1 = '(?:' + rsZWJ$1 + '(?:' + [rsNonAstral$1, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsOptVar$1 + reOptMod$1 + ')*',
    rsSeq$1 = rsOptVar$1 + reOptMod$1 + rsOptJoin$1,
    rsSymbol = '(?:' + [rsNonAstral$1 + rsCombo$2 + '?', rsCombo$2, rsRegional$1, rsSurrPair$1, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz$1 + '(?=' + rsFitz$1 + ')|' + rsSymbol + rsSeq$1, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray$1(string) {
  return string.match(reUnicode) || [];
}

var _unicodeToArray = unicodeToArray$1;

var asciiToArray = _asciiToArray,
    hasUnicode$1 = _hasUnicode,
    unicodeToArray = _unicodeToArray;

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray$1(string) {
  return hasUnicode$1(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

var _stringToArray = stringToArray$1;

var castSlice = _castSlice,
    hasUnicode = _hasUnicode,
    stringToArray = _stringToArray,
    toString$5 = toString_1;

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst$1(methodName) {
  return function(string) {
    string = toString$5(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

var _createCaseFirst = createCaseFirst$1;

var createCaseFirst = _createCaseFirst;

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst$1 = createCaseFirst('toUpperCase');

var upperFirst_1 = upperFirst$1;

var toString$4 = toString_1,
    upperFirst = upperFirst_1;

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize$1(string) {
  return upperFirst(toString$4(string).toLowerCase());
}

var capitalize_1 = capitalize$1;

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */

function arrayReduce$1(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

var _arrayReduce = arrayReduce$1;

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */

function basePropertyOf$1(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

var _basePropertyOf = basePropertyOf$1;

var basePropertyOf = _basePropertyOf;

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter$1 = basePropertyOf(deburredLetters);

var _deburrLetter = deburrLetter$1;

var deburrLetter = _deburrLetter,
    toString$3 = toString_1;

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange$1 = '\\u0300-\\u036f',
    reComboHalfMarksRange$1 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$1 = '\\u20d0-\\u20ff',
    rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1;

/** Used to compose unicode capture groups. */
var rsCombo$1 = '[' + rsComboRange$1 + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo$1, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr$1(string) {
  string = toString$3(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

var deburr_1 = deburr$1;

/** Used to match words composed of alphanumeric characters. */

var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords$1(string) {
  return string.match(reAsciiWord) || [];
}

var _asciiWords = asciiWords$1;

/** Used to detect strings that need a more robust regexp to match words. */

var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord$1(string) {
  return reHasUnicodeWord.test(string);
}

var _hasUnicodeWord = hasUnicodeWord$1;

/** Used to compose unicode character classes. */

var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos$1 = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos$1 + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos$1 + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords$1(string) {
  return string.match(reUnicodeWord) || [];
}

var _unicodeWords = unicodeWords$1;

var asciiWords = _asciiWords,
    hasUnicodeWord = _hasUnicodeWord,
    toString$2 = toString_1,
    unicodeWords = _unicodeWords;

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words$1(string, pattern, guard) {
  string = toString$2(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

var words_1 = words$1;

var arrayReduce = _arrayReduce,
    deburr = deburr_1,
    words = words_1;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder$1(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

var _createCompounder = createCompounder$1;

var capitalize = capitalize_1,
    createCompounder = _createCompounder;

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize(word) : word);
});

var camelCase_1 = camelCase;

var camelCase$1 = /*@__PURE__*/getDefaultExportFromCjs(camelCase_1);

function camelCaseKeys(target) {
    if (!target) {
        return {};
    }
    return Object.keys(target).reduce((buffer, key) => {
        buffer[camelCase$1(key)] = target[key];
        return buffer;
    }, {});
}

function isSet(value) {
    return value !== undefined && value !== null;
}

function createTranslationOptions(i18n, scope, options) {
    let translationOptions = [{ scope }];
    if (isSet(options.defaults)) {
        translationOptions = translationOptions.concat(options.defaults);
    }
    if (isSet(options.defaultValue)) {
        const message = typeof options.defaultValue === "function"
            ? options.defaultValue(i18n, scope, options)
            : options.defaultValue;
        translationOptions.push({ message });
        delete options.defaultValue;
    }
    return translationOptions;
}

/*
 *      bignumber.js v9.1.2
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |  sum
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */


var
  isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i,
  mathceil = Math.ceil,
  mathfloor = Math.floor,

  bignumberError = '[BigNumber Error] ',
  tooManyDigits = bignumberError + 'Number primitive has more than 15 significant digits: ',

  BASE = 1e14,
  LOG_BASE = 14,
  MAX_SAFE_INTEGER$1 = 0x1fffffffffffff,         // 2^53 - 1
  // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
  POWS_TEN = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13],
  SQRT_BASE = 1e7,

  // EDITABLE
  // The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
  // the arguments to toExponential, toFixed, toFormat, and toPrecision.
  MAX = 1E9;                                   // 0 to MAX_INT32


/*
 * Create and return a BigNumber constructor.
 */
function clone(configObject) {
  var div, convertBase, parseNumeric,
    P = BigNumber.prototype = { constructor: BigNumber, toString: null, valueOf: null },
    ONE = new BigNumber(1),


    //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------


    // The default values below must be integers within the inclusive ranges stated.
    // The values can also be changed at run-time using BigNumber.set.

    // The maximum number of decimal places for operations involving division.
    DECIMAL_PLACES = 20,                     // 0 to MAX

    // The rounding mode used when rounding to the above decimal places, and when using
    // toExponential, toFixed, toFormat and toPrecision, and round (default value).
    // UP         0 Away from zero.
    // DOWN       1 Towards zero.
    // CEIL       2 Towards +Infinity.
    // FLOOR      3 Towards -Infinity.
    // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
    // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
    // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
    // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
    // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
    ROUNDING_MODE = 4,                       // 0 to 8

    // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]

    // The exponent value at and beneath which toString returns exponential notation.
    // Number type: -7
    TO_EXP_NEG = -7,                         // 0 to -MAX

    // The exponent value at and above which toString returns exponential notation.
    // Number type: 21
    TO_EXP_POS = 21,                         // 0 to MAX

    // RANGE : [MIN_EXP, MAX_EXP]

    // The minimum exponent value, beneath which underflow to zero occurs.
    // Number type: -324  (5e-324)
    MIN_EXP = -1e7,                          // -1 to -MAX

    // The maximum exponent value, above which overflow to Infinity occurs.
    // Number type:  308  (1.7976931348623157e+308)
    // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
    MAX_EXP = 1e7,                           // 1 to MAX

    // Whether to use cryptographically-secure random number generation, if available.
    CRYPTO = false,                          // true or false

    // The modulo mode used when calculating the modulus: a mod n.
    // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
    // The remainder (r) is calculated as: r = a - n * q.
    //
    // UP        0 The remainder is positive if the dividend is negative, else is negative.
    // DOWN      1 The remainder has the same sign as the dividend.
    //             This modulo mode is commonly known as 'truncated division' and is
    //             equivalent to (a % n) in JavaScript.
    // FLOOR     3 The remainder has the same sign as the divisor (Python %).
    // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
    // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
    //             The remainder is always positive.
    //
    // The truncated division, floored division, Euclidian division and IEEE 754 remainder
    // modes are commonly used for the modulus operation.
    // Although the other rounding modes can also be used, they may not give useful results.
    MODULO_MODE = 1,                         // 0 to 9

    // The maximum number of significant digits of the result of the exponentiatedBy operation.
    // If POW_PRECISION is 0, there will be unlimited significant digits.
    POW_PRECISION = 0,                       // 0 to MAX

    // The format specification used by the BigNumber.prototype.toFormat method.
    FORMAT = {
      prefix: '',
      groupSize: 3,
      secondaryGroupSize: 0,
      groupSeparator: ',',
      decimalSeparator: '.',
      fractionGroupSize: 0,
      fractionGroupSeparator: '\xA0',        // non-breaking space
      suffix: ''
    },

    // The alphabet used for base conversion. It must be at least 2 characters long, with no '+',
    // '-', '.', whitespace, or repeated character.
    // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
    ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyz',
    alphabetHasNormalDecimalDigits = true;


  //------------------------------------------------------------------------------------------


  // CONSTRUCTOR


  /*
   * The BigNumber constructor and exported function.
   * Create and return a new instance of a BigNumber object.
   *
   * v {number|string|BigNumber} A numeric value.
   * [b] {number} The base of v. Integer, 2 to ALPHABET.length inclusive.
   */
  function BigNumber(v, b) {
    var alphabet, c, caseChanged, e, i, isNum, len, str,
      x = this;

    // Enable constructor call without `new`.
    if (!(x instanceof BigNumber)) return new BigNumber(v, b);

    if (b == null) {

      if (v && v._isBigNumber === true) {
        x.s = v.s;

        if (!v.c || v.e > MAX_EXP) {
          x.c = x.e = null;
        } else if (v.e < MIN_EXP) {
          x.c = [x.e = 0];
        } else {
          x.e = v.e;
          x.c = v.c.slice();
        }

        return;
      }

      if ((isNum = typeof v == 'number') && v * 0 == 0) {

        // Use `1 / n` to handle minus zero also.
        x.s = 1 / v < 0 ? (v = -v, -1) : 1;

        // Fast path for integers, where n < 2147483648 (2**31).
        if (v === ~~v) {
          for (e = 0, i = v; i >= 10; i /= 10, e++);

          if (e > MAX_EXP) {
            x.c = x.e = null;
          } else {
            x.e = e;
            x.c = [v];
          }

          return;
        }

        str = String(v);
      } else {

        if (!isNumeric.test(str = String(v))) return parseNumeric(x, str, isNum);

        x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
      }

      // Decimal point?
      if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');

      // Exponential form?
      if ((i = str.search(/e/i)) > 0) {

        // Determine exponent.
        if (e < 0) e = i;
        e += +str.slice(i + 1);
        str = str.substring(0, i);
      } else if (e < 0) {

        // Integer.
        e = str.length;
      }

    } else {

      // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
      intCheck(b, 2, ALPHABET.length, 'Base');

      // Allow exponential notation to be used with base 10 argument, while
      // also rounding to DECIMAL_PLACES as with other bases.
      if (b == 10 && alphabetHasNormalDecimalDigits) {
        x = new BigNumber(v);
        return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
      }

      str = String(v);

      if (isNum = typeof v == 'number') {

        // Avoid potential interpretation of Infinity and NaN as base 44+ values.
        if (v * 0 != 0) return parseNumeric(x, str, isNum, b);

        x.s = 1 / v < 0 ? (str = str.slice(1), -1) : 1;

        // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
        if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, '').length > 15) {
          throw Error
           (tooManyDigits + v);
        }
      } else {
        x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
      }

      alphabet = ALPHABET.slice(0, b);
      e = i = 0;

      // Check that str is a valid base b number.
      // Don't use RegExp, so alphabet can contain special characters.
      for (len = str.length; i < len; i++) {
        if (alphabet.indexOf(c = str.charAt(i)) < 0) {
          if (c == '.') {

            // If '.' is not the first character and it has not be found before.
            if (i > e) {
              e = len;
              continue;
            }
          } else if (!caseChanged) {

            // Allow e.g. hexadecimal 'FF' as well as 'ff'.
            if (str == str.toUpperCase() && (str = str.toLowerCase()) ||
                str == str.toLowerCase() && (str = str.toUpperCase())) {
              caseChanged = true;
              i = -1;
              e = 0;
              continue;
            }
          }

          return parseNumeric(x, String(v), isNum, b);
        }
      }

      // Prevent later check for length on converted number.
      isNum = false;
      str = convertBase(str, b, 10, x.s);

      // Decimal point?
      if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
      else e = str.length;
    }

    // Determine leading zeros.
    for (i = 0; str.charCodeAt(i) === 48; i++);

    // Determine trailing zeros.
    for (len = str.length; str.charCodeAt(--len) === 48;);

    if (str = str.slice(i, ++len)) {
      len -= i;

      // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
      if (isNum && BigNumber.DEBUG &&
        len > 15 && (v > MAX_SAFE_INTEGER$1 || v !== mathfloor(v))) {
          throw Error
           (tooManyDigits + (x.s * v));
      }

       // Overflow?
      if ((e = e - i - 1) > MAX_EXP) {

        // Infinity.
        x.c = x.e = null;

      // Underflow?
      } else if (e < MIN_EXP) {

        // Zero.
        x.c = [x.e = 0];
      } else {
        x.e = e;
        x.c = [];

        // Transform base

        // e is the base 10 exponent.
        // i is where to slice str to get the first element of the coefficient array.
        i = (e + 1) % LOG_BASE;
        if (e < 0) i += LOG_BASE;  // i < 1

        if (i < len) {
          if (i) x.c.push(+str.slice(0, i));

          for (len -= LOG_BASE; i < len;) {
            x.c.push(+str.slice(i, i += LOG_BASE));
          }

          i = LOG_BASE - (str = str.slice(i)).length;
        } else {
          i -= len;
        }

        for (; i--; str += '0');
        x.c.push(+str);
      }
    } else {

      // Zero.
      x.c = [x.e = 0];
    }
  }


  // CONSTRUCTOR PROPERTIES


  BigNumber.clone = clone;

  BigNumber.ROUND_UP = 0;
  BigNumber.ROUND_DOWN = 1;
  BigNumber.ROUND_CEIL = 2;
  BigNumber.ROUND_FLOOR = 3;
  BigNumber.ROUND_HALF_UP = 4;
  BigNumber.ROUND_HALF_DOWN = 5;
  BigNumber.ROUND_HALF_EVEN = 6;
  BigNumber.ROUND_HALF_CEIL = 7;
  BigNumber.ROUND_HALF_FLOOR = 8;
  BigNumber.EUCLID = 9;


  /*
   * Configure infrequently-changing library-wide settings.
   *
   * Accept an object with the following optional properties (if the value of a property is
   * a number, it must be an integer within the inclusive range stated):
   *
   *   DECIMAL_PLACES   {number}           0 to MAX
   *   ROUNDING_MODE    {number}           0 to 8
   *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
   *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
   *   CRYPTO           {boolean}          true or false
   *   MODULO_MODE      {number}           0 to 9
   *   POW_PRECISION       {number}           0 to MAX
   *   ALPHABET         {string}           A string of two or more unique characters which does
   *                                       not contain '.'.
   *   FORMAT           {object}           An object with some of the following properties:
   *     prefix                 {string}
   *     groupSize              {number}
   *     secondaryGroupSize     {number}
   *     groupSeparator         {string}
   *     decimalSeparator       {string}
   *     fractionGroupSize      {number}
   *     fractionGroupSeparator {string}
   *     suffix                 {string}
   *
   * (The values assigned to the above FORMAT object properties are not checked for validity.)
   *
   * E.g.
   * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
   *
   * Ignore properties/parameters set to null or undefined, except for ALPHABET.
   *
   * Return an object with the properties current values.
   */
  BigNumber.config = BigNumber.set = function (obj) {
    var p, v;

    if (obj != null) {

      if (typeof obj == 'object') {

        // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
        // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
        if (obj.hasOwnProperty(p = 'DECIMAL_PLACES')) {
          v = obj[p];
          intCheck(v, 0, MAX, p);
          DECIMAL_PLACES = v;
        }

        // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
        // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
        if (obj.hasOwnProperty(p = 'ROUNDING_MODE')) {
          v = obj[p];
          intCheck(v, 0, 8, p);
          ROUNDING_MODE = v;
        }

        // EXPONENTIAL_AT {number|number[]}
        // Integer, -MAX to MAX inclusive or
        // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
        // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
        if (obj.hasOwnProperty(p = 'EXPONENTIAL_AT')) {
          v = obj[p];
          if (v && v.pop) {
            intCheck(v[0], -MAX, 0, p);
            intCheck(v[1], 0, MAX, p);
            TO_EXP_NEG = v[0];
            TO_EXP_POS = v[1];
          } else {
            intCheck(v, -MAX, MAX, p);
            TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
          }
        }

        // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
        // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
        // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
        if (obj.hasOwnProperty(p = 'RANGE')) {
          v = obj[p];
          if (v && v.pop) {
            intCheck(v[0], -MAX, -1, p);
            intCheck(v[1], 1, MAX, p);
            MIN_EXP = v[0];
            MAX_EXP = v[1];
          } else {
            intCheck(v, -MAX, MAX, p);
            if (v) {
              MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
            } else {
              throw Error
               (bignumberError + p + ' cannot be zero: ' + v);
            }
          }
        }

        // CRYPTO {boolean} true or false.
        // '[BigNumber Error] CRYPTO not true or false: {v}'
        // '[BigNumber Error] crypto unavailable'
        if (obj.hasOwnProperty(p = 'CRYPTO')) {
          v = obj[p];
          if (v === !!v) {
            if (v) {
              if (typeof crypto != 'undefined' && crypto &&
               (crypto.getRandomValues || crypto.randomBytes)) {
                CRYPTO = v;
              } else {
                CRYPTO = !v;
                throw Error
                 (bignumberError + 'crypto unavailable');
              }
            } else {
              CRYPTO = v;
            }
          } else {
            throw Error
             (bignumberError + p + ' not true or false: ' + v);
          }
        }

        // MODULO_MODE {number} Integer, 0 to 9 inclusive.
        // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
        if (obj.hasOwnProperty(p = 'MODULO_MODE')) {
          v = obj[p];
          intCheck(v, 0, 9, p);
          MODULO_MODE = v;
        }

        // POW_PRECISION {number} Integer, 0 to MAX inclusive.
        // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
        if (obj.hasOwnProperty(p = 'POW_PRECISION')) {
          v = obj[p];
          intCheck(v, 0, MAX, p);
          POW_PRECISION = v;
        }

        // FORMAT {object}
        // '[BigNumber Error] FORMAT not an object: {v}'
        if (obj.hasOwnProperty(p = 'FORMAT')) {
          v = obj[p];
          if (typeof v == 'object') FORMAT = v;
          else throw Error
           (bignumberError + p + ' not an object: ' + v);
        }

        // ALPHABET {string}
        // '[BigNumber Error] ALPHABET invalid: {v}'
        if (obj.hasOwnProperty(p = 'ALPHABET')) {
          v = obj[p];

          // Disallow if less than two characters,
          // or if it contains '+', '-', '.', whitespace, or a repeated character.
          if (typeof v == 'string' && !/^.?$|[+\-.\s]|(.).*\1/.test(v)) {
            alphabetHasNormalDecimalDigits = v.slice(0, 10) == '0123456789';
            ALPHABET = v;
          } else {
            throw Error
             (bignumberError + p + ' invalid: ' + v);
          }
        }

      } else {

        // '[BigNumber Error] Object expected: {v}'
        throw Error
         (bignumberError + 'Object expected: ' + obj);
      }
    }

    return {
      DECIMAL_PLACES: DECIMAL_PLACES,
      ROUNDING_MODE: ROUNDING_MODE,
      EXPONENTIAL_AT: [TO_EXP_NEG, TO_EXP_POS],
      RANGE: [MIN_EXP, MAX_EXP],
      CRYPTO: CRYPTO,
      MODULO_MODE: MODULO_MODE,
      POW_PRECISION: POW_PRECISION,
      FORMAT: FORMAT,
      ALPHABET: ALPHABET
    };
  };


  /*
   * Return true if v is a BigNumber instance, otherwise return false.
   *
   * If BigNumber.DEBUG is true, throw if a BigNumber instance is not well-formed.
   *
   * v {any}
   *
   * '[BigNumber Error] Invalid BigNumber: {v}'
   */
  BigNumber.isBigNumber = function (v) {
    if (!v || v._isBigNumber !== true) return false;
    if (!BigNumber.DEBUG) return true;

    var i, n,
      c = v.c,
      e = v.e,
      s = v.s;

    out: if ({}.toString.call(c) == '[object Array]') {

      if ((s === 1 || s === -1) && e >= -MAX && e <= MAX && e === mathfloor(e)) {

        // If the first element is zero, the BigNumber value must be zero.
        if (c[0] === 0) {
          if (e === 0 && c.length === 1) return true;
          break out;
        }

        // Calculate number of digits that c[0] should have, based on the exponent.
        i = (e + 1) % LOG_BASE;
        if (i < 1) i += LOG_BASE;

        // Calculate number of digits of c[0].
        //if (Math.ceil(Math.log(c[0] + 1) / Math.LN10) == i) {
        if (String(c[0]).length == i) {

          for (i = 0; i < c.length; i++) {
            n = c[i];
            if (n < 0 || n >= BASE || n !== mathfloor(n)) break out;
          }

          // Last element cannot be zero, unless it is the only element.
          if (n !== 0) return true;
        }
      }

    // Infinity/NaN
    } else if (c === null && e === null && (s === null || s === 1 || s === -1)) {
      return true;
    }

    throw Error
      (bignumberError + 'Invalid BigNumber: ' + v);
  };


  /*
   * Return a new BigNumber whose value is the maximum of the arguments.
   *
   * arguments {number|string|BigNumber}
   */
  BigNumber.maximum = BigNumber.max = function () {
    return maxOrMin(arguments, -1);
  };


  /*
   * Return a new BigNumber whose value is the minimum of the arguments.
   *
   * arguments {number|string|BigNumber}
   */
  BigNumber.minimum = BigNumber.min = function () {
    return maxOrMin(arguments, 1);
  };


  /*
   * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
   * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
   * zeros are produced).
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
   * '[BigNumber Error] crypto unavailable'
   */
  BigNumber.random = (function () {
    var pow2_53 = 0x20000000000000;

    // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
    // Check if Math.random() produces more than 32 bits of randomness.
    // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
    // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
    var random53bitInt = (Math.random() * pow2_53) & 0x1fffff
     ? function () { return mathfloor(Math.random() * pow2_53); }
     : function () { return ((Math.random() * 0x40000000 | 0) * 0x800000) +
       (Math.random() * 0x800000 | 0); };

    return function (dp) {
      var a, b, e, k, v,
        i = 0,
        c = [],
        rand = new BigNumber(ONE);

      if (dp == null) dp = DECIMAL_PLACES;
      else intCheck(dp, 0, MAX);

      k = mathceil(dp / LOG_BASE);

      if (CRYPTO) {

        // Browsers supporting crypto.getRandomValues.
        if (crypto.getRandomValues) {

          a = crypto.getRandomValues(new Uint32Array(k *= 2));

          for (; i < k;) {

            // 53 bits:
            // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
            // 11111 11111111 11111111 11111111 11100000 00000000 00000000
            // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
            //                                     11111 11111111 11111111
            // 0x20000 is 2^21.
            v = a[i] * 0x20000 + (a[i + 1] >>> 11);

            // Rejection sampling:
            // 0 <= v < 9007199254740992
            // Probability that v >= 9e15, is
            // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
            if (v >= 9e15) {
              b = crypto.getRandomValues(new Uint32Array(2));
              a[i] = b[0];
              a[i + 1] = b[1];
            } else {

              // 0 <= v <= 8999999999999999
              // 0 <= (v % 1e14) <= 99999999999999
              c.push(v % 1e14);
              i += 2;
            }
          }
          i = k / 2;

        // Node.js supporting crypto.randomBytes.
        } else if (crypto.randomBytes) {

          // buffer
          a = crypto.randomBytes(k *= 7);

          for (; i < k;) {

            // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
            // 0x100000000 is 2^32, 0x1000000 is 2^24
            // 11111 11111111 11111111 11111111 11111111 11111111 11111111
            // 0 <= v < 9007199254740992
            v = ((a[i] & 31) * 0x1000000000000) + (a[i + 1] * 0x10000000000) +
               (a[i + 2] * 0x100000000) + (a[i + 3] * 0x1000000) +
               (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];

            if (v >= 9e15) {
              crypto.randomBytes(7).copy(a, i);
            } else {

              // 0 <= (v % 1e14) <= 99999999999999
              c.push(v % 1e14);
              i += 7;
            }
          }
          i = k / 7;
        } else {
          CRYPTO = false;
          throw Error
           (bignumberError + 'crypto unavailable');
        }
      }

      // Use Math.random.
      if (!CRYPTO) {

        for (; i < k;) {
          v = random53bitInt();
          if (v < 9e15) c[i++] = v % 1e14;
        }
      }

      k = c[--i];
      dp %= LOG_BASE;

      // Convert trailing digits to zeros according to dp.
      if (k && dp) {
        v = POWS_TEN[LOG_BASE - dp];
        c[i] = mathfloor(k / v) * v;
      }

      // Remove trailing elements which are zero.
      for (; c[i] === 0; c.pop(), i--);

      // Zero?
      if (i < 0) {
        c = [e = 0];
      } else {

        // Remove leading elements which are zero and adjust exponent accordingly.
        for (e = -1 ; c[0] === 0; c.splice(0, 1), e -= LOG_BASE);

        // Count the digits of the first element of c to determine leading zeros, and...
        for (i = 1, v = c[0]; v >= 10; v /= 10, i++);

        // adjust the exponent accordingly.
        if (i < LOG_BASE) e -= LOG_BASE - i;
      }

      rand.e = e;
      rand.c = c;
      return rand;
    };
  })();


   /*
   * Return a BigNumber whose value is the sum of the arguments.
   *
   * arguments {number|string|BigNumber}
   */
  BigNumber.sum = function () {
    var i = 1,
      args = arguments,
      sum = new BigNumber(args[0]);
    for (; i < args.length;) sum = sum.plus(args[i++]);
    return sum;
  };


  // PRIVATE FUNCTIONS


  // Called by BigNumber and BigNumber.prototype.toString.
  convertBase = (function () {
    var decimal = '0123456789';

    /*
     * Convert string of baseIn to an array of numbers of baseOut.
     * Eg. toBaseOut('255', 10, 16) returns [15, 15].
     * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
     */
    function toBaseOut(str, baseIn, baseOut, alphabet) {
      var j,
        arr = [0],
        arrL,
        i = 0,
        len = str.length;

      for (; i < len;) {
        for (arrL = arr.length; arrL--; arr[arrL] *= baseIn);

        arr[0] += alphabet.indexOf(str.charAt(i++));

        for (j = 0; j < arr.length; j++) {

          if (arr[j] > baseOut - 1) {
            if (arr[j + 1] == null) arr[j + 1] = 0;
            arr[j + 1] += arr[j] / baseOut | 0;
            arr[j] %= baseOut;
          }
        }
      }

      return arr.reverse();
    }

    // Convert a numeric string of baseIn to a numeric string of baseOut.
    // If the caller is toString, we are converting from base 10 to baseOut.
    // If the caller is BigNumber, we are converting from baseIn to base 10.
    return function (str, baseIn, baseOut, sign, callerIsToString) {
      var alphabet, d, e, k, r, x, xc, y,
        i = str.indexOf('.'),
        dp = DECIMAL_PLACES,
        rm = ROUNDING_MODE;

      // Non-integer.
      if (i >= 0) {
        k = POW_PRECISION;

        // Unlimited precision.
        POW_PRECISION = 0;
        str = str.replace('.', '');
        y = new BigNumber(baseIn);
        x = y.pow(str.length - i);
        POW_PRECISION = k;

        // Convert str as if an integer, then restore the fraction part by dividing the
        // result by its base raised to a power.

        y.c = toBaseOut(toFixedPoint(coeffToString(x.c), x.e, '0'),
         10, baseOut, decimal);
        y.e = y.c.length;
      }

      // Convert the number as integer.

      xc = toBaseOut(str, baseIn, baseOut, callerIsToString
       ? (alphabet = ALPHABET, decimal)
       : (alphabet = decimal, ALPHABET));

      // xc now represents str as an integer and converted to baseOut. e is the exponent.
      e = k = xc.length;

      // Remove trailing zeros.
      for (; xc[--k] == 0; xc.pop());

      // Zero?
      if (!xc[0]) return alphabet.charAt(0);

      // Does str represent an integer? If so, no need for the division.
      if (i < 0) {
        --e;
      } else {
        x.c = xc;
        x.e = e;

        // The sign is needed for correct rounding.
        x.s = sign;
        x = div(x, y, dp, rm, baseOut);
        xc = x.c;
        r = x.r;
        e = x.e;
      }

      // xc now represents str converted to baseOut.

      // THe index of the rounding digit.
      d = e + dp + 1;

      // The rounding digit: the digit to the right of the digit that may be rounded up.
      i = xc[d];

      // Look at the rounding digits and mode to determine whether to round up.

      k = baseOut / 2;
      r = r || d < 0 || xc[d + 1] != null;

      r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2))
            : i > k || i == k &&(rm == 4 || r || rm == 6 && xc[d - 1] & 1 ||
             rm == (x.s < 0 ? 8 : 7));

      // If the index of the rounding digit is not greater than zero, or xc represents
      // zero, then the result of the base conversion is zero or, if rounding up, a value
      // such as 0.00001.
      if (d < 1 || !xc[0]) {

        // 1^-dp or 0
        str = r ? toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
      } else {

        // Truncate xc to the required number of decimal places.
        xc.length = d;

        // Round up?
        if (r) {

          // Rounding up may mean the previous digit has to be rounded up and so on.
          for (--baseOut; ++xc[--d] > baseOut;) {
            xc[d] = 0;

            if (!d) {
              ++e;
              xc = [1].concat(xc);
            }
          }
        }

        // Determine trailing zeros.
        for (k = xc.length; !xc[--k];);

        // E.g. [4, 11, 15] becomes 4bf.
        for (i = 0, str = ''; i <= k; str += alphabet.charAt(xc[i++]));

        // Add leading zeros, decimal point and trailing zeros as required.
        str = toFixedPoint(str, e, alphabet.charAt(0));
      }

      // The caller will add the sign.
      return str;
    };
  })();


  // Perform division in the specified base. Called by div and convertBase.
  div = (function () {

    // Assume non-zero x and k.
    function multiply(x, k, base) {
      var m, temp, xlo, xhi,
        carry = 0,
        i = x.length,
        klo = k % SQRT_BASE,
        khi = k / SQRT_BASE | 0;

      for (x = x.slice(); i--;) {
        xlo = x[i] % SQRT_BASE;
        xhi = x[i] / SQRT_BASE | 0;
        m = khi * xlo + xhi * klo;
        temp = klo * xlo + ((m % SQRT_BASE) * SQRT_BASE) + carry;
        carry = (temp / base | 0) + (m / SQRT_BASE | 0) + khi * xhi;
        x[i] = temp % base;
      }

      if (carry) x = [carry].concat(x);

      return x;
    }

    function compare(a, b, aL, bL) {
      var i, cmp;

      if (aL != bL) {
        cmp = aL > bL ? 1 : -1;
      } else {

        for (i = cmp = 0; i < aL; i++) {

          if (a[i] != b[i]) {
            cmp = a[i] > b[i] ? 1 : -1;
            break;
          }
        }
      }

      return cmp;
    }

    function subtract(a, b, aL, base) {
      var i = 0;

      // Subtract b from a.
      for (; aL--;) {
        a[aL] -= i;
        i = a[aL] < b[aL] ? 1 : 0;
        a[aL] = i * base + a[aL] - b[aL];
      }

      // Remove leading zeros.
      for (; !a[0] && a.length > 1; a.splice(0, 1));
    }

    // x: dividend, y: divisor.
    return function (x, y, dp, rm, base) {
      var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0,
        yL, yz,
        s = x.s == y.s ? 1 : -1,
        xc = x.c,
        yc = y.c;

      // Either NaN, Infinity or 0?
      if (!xc || !xc[0] || !yc || !yc[0]) {

        return new BigNumber(

         // Return NaN if either NaN, or both Infinity or 0.
         !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN :

          // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
          xc && xc[0] == 0 || !yc ? s * 0 : s / 0
       );
      }

      q = new BigNumber(s);
      qc = q.c = [];
      e = x.e - y.e;
      s = dp + e + 1;

      if (!base) {
        base = BASE;
        e = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
        s = s / LOG_BASE | 0;
      }

      // Result exponent may be one less then the current value of e.
      // The coefficients of the BigNumbers from convertBase may have trailing zeros.
      for (i = 0; yc[i] == (xc[i] || 0); i++);

      if (yc[i] > (xc[i] || 0)) e--;

      if (s < 0) {
        qc.push(1);
        more = true;
      } else {
        xL = xc.length;
        yL = yc.length;
        i = 0;
        s += 2;

        // Normalise xc and yc so highest order digit of yc is >= base / 2.

        n = mathfloor(base / (yc[0] + 1));

        // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
        // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
        if (n > 1) {
          yc = multiply(yc, n, base);
          xc = multiply(xc, n, base);
          yL = yc.length;
          xL = xc.length;
        }

        xi = yL;
        rem = xc.slice(0, yL);
        remL = rem.length;

        // Add zeros to make remainder as long as divisor.
        for (; remL < yL; rem[remL++] = 0);
        yz = yc.slice();
        yz = [0].concat(yz);
        yc0 = yc[0];
        if (yc[1] >= base / 2) yc0++;
        // Not necessary, but to prevent trial digit n > base, when using base 3.
        // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;

        do {
          n = 0;

          // Compare divisor and remainder.
          cmp = compare(yc, rem, yL, remL);

          // If divisor < remainder.
          if (cmp < 0) {

            // Calculate trial digit, n.

            rem0 = rem[0];
            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);

            // n is how many times the divisor goes into the current remainder.
            n = mathfloor(rem0 / yc0);

            //  Algorithm:
            //  product = divisor multiplied by trial digit (n).
            //  Compare product and remainder.
            //  If product is greater than remainder:
            //    Subtract divisor from product, decrement trial digit.
            //  Subtract product from remainder.
            //  If product was less than remainder at the last compare:
            //    Compare new remainder and divisor.
            //    If remainder is greater than divisor:
            //      Subtract divisor from remainder, increment trial digit.

            if (n > 1) {

              // n may be > base only when base is 3.
              if (n >= base) n = base - 1;

              // product = divisor * trial digit.
              prod = multiply(yc, n, base);
              prodL = prod.length;
              remL = rem.length;

              // Compare product and remainder.
              // If product > remainder then trial digit n too high.
              // n is 1 too high about 5% of the time, and is not known to have
              // ever been more than 1 too high.
              while (compare(prod, rem, prodL, remL) == 1) {
                n--;

                // Subtract divisor from product.
                subtract(prod, yL < prodL ? yz : yc, prodL, base);
                prodL = prod.length;
                cmp = 1;
              }
            } else {

              // n is 0 or 1, cmp is -1.
              // If n is 0, there is no need to compare yc and rem again below,
              // so change cmp to 1 to avoid it.
              // If n is 1, leave cmp as -1, so yc and rem are compared again.
              if (n == 0) {

                // divisor < remainder, so n must be at least 1.
                cmp = n = 1;
              }

              // product = divisor
              prod = yc.slice();
              prodL = prod.length;
            }

            if (prodL < remL) prod = [0].concat(prod);

            // Subtract product from remainder.
            subtract(rem, prod, remL, base);
            remL = rem.length;

             // If product was < remainder.
            if (cmp == -1) {

              // Compare divisor and new remainder.
              // If divisor < new remainder, subtract divisor from remainder.
              // Trial digit n too low.
              // n is 1 too low about 5% of the time, and very rarely 2 too low.
              while (compare(yc, rem, yL, remL) < 1) {
                n++;

                // Subtract divisor from remainder.
                subtract(rem, yL < remL ? yz : yc, remL, base);
                remL = rem.length;
              }
            }
          } else if (cmp === 0) {
            n++;
            rem = [0];
          } // else cmp === 1 and n will be 0

          // Add the next digit, n, to the result array.
          qc[i++] = n;

          // Update the remainder.
          if (rem[0]) {
            rem[remL++] = xc[xi] || 0;
          } else {
            rem = [xc[xi]];
            remL = 1;
          }
        } while ((xi++ < xL || rem[0] != null) && s--);

        more = rem[0] != null;

        // Leading zero?
        if (!qc[0]) qc.splice(0, 1);
      }

      if (base == BASE) {

        // To calculate q.e, first get the number of digits of qc[0].
        for (i = 1, s = qc[0]; s >= 10; s /= 10, i++);

        round(q, dp + (q.e = i + e * LOG_BASE - 1) + 1, rm, more);

      // Caller is convertBase.
      } else {
        q.e = e;
        q.r = +more;
      }

      return q;
    };
  })();


  /*
   * Return a string representing the value of BigNumber n in fixed-point or exponential
   * notation rounded to the specified decimal places or significant digits.
   *
   * n: a BigNumber.
   * i: the index of the last digit required (i.e. the digit that may be rounded up).
   * rm: the rounding mode.
   * id: 1 (toExponential) or 2 (toPrecision).
   */
  function format(n, i, rm, id) {
    var c0, e, ne, len, str;

    if (rm == null) rm = ROUNDING_MODE;
    else intCheck(rm, 0, 8);

    if (!n.c) return n.toString();

    c0 = n.c[0];
    ne = n.e;

    if (i == null) {
      str = coeffToString(n.c);
      str = id == 1 || id == 2 && (ne <= TO_EXP_NEG || ne >= TO_EXP_POS)
       ? toExponential(str, ne)
       : toFixedPoint(str, ne, '0');
    } else {
      n = round(new BigNumber(n), i, rm);

      // n.e may have changed if the value was rounded up.
      e = n.e;

      str = coeffToString(n.c);
      len = str.length;

      // toPrecision returns exponential notation if the number of significant digits
      // specified is less than the number of digits necessary to represent the integer
      // part of the value in fixed-point notation.

      // Exponential notation.
      if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {

        // Append zeros?
        for (; len < i; str += '0', len++);
        str = toExponential(str, e);

      // Fixed-point notation.
      } else {
        i -= ne;
        str = toFixedPoint(str, e, '0');

        // Append zeros?
        if (e + 1 > len) {
          if (--i > 0) for (str += '.'; i--; str += '0');
        } else {
          i += e - len;
          if (i > 0) {
            if (e + 1 == len) str += '.';
            for (; i--; str += '0');
          }
        }
      }
    }

    return n.s < 0 && c0 ? '-' + str : str;
  }


  // Handle BigNumber.max and BigNumber.min.
  // If any number is NaN, return NaN.
  function maxOrMin(args, n) {
    var k, y,
      i = 1,
      x = new BigNumber(args[0]);

    for (; i < args.length; i++) {
      y = new BigNumber(args[i]);
      if (!y.s || (k = compare(x, y)) === n || k === 0 && x.s === n) {
        x = y;
      }
    }

    return x;
  }


  /*
   * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
   * Called by minus, plus and times.
   */
  function normalise(n, c, e) {
    var i = 1,
      j = c.length;

     // Remove trailing zeros.
    for (; !c[--j]; c.pop());

    // Calculate the base 10 exponent. First get the number of digits of c[0].
    for (j = c[0]; j >= 10; j /= 10, i++);

    // Overflow?
    if ((e = i + e * LOG_BASE - 1) > MAX_EXP) {

      // Infinity.
      n.c = n.e = null;

    // Underflow?
    } else if (e < MIN_EXP) {

      // Zero.
      n.c = [n.e = 0];
    } else {
      n.e = e;
      n.c = c;
    }

    return n;
  }


  // Handle values that fail the validity test in BigNumber.
  parseNumeric = (function () {
    var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i,
      dotAfter = /^([^.]+)\.$/,
      dotBefore = /^\.([^.]+)$/,
      isInfinityOrNaN = /^-?(Infinity|NaN)$/,
      whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;

    return function (x, str, isNum, b) {
      var base,
        s = isNum ? str : str.replace(whitespaceOrPlus, '');

      // No exception on ±Infinity or NaN.
      if (isInfinityOrNaN.test(s)) {
        x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
      } else {
        if (!isNum) {

          // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
          s = s.replace(basePrefix, function (m, p1, p2) {
            base = (p2 = p2.toLowerCase()) == 'x' ? 16 : p2 == 'b' ? 2 : 8;
            return !b || b == base ? p1 : m;
          });

          if (b) {
            base = b;

            // E.g. '1.' to '1', '.1' to '0.1'
            s = s.replace(dotAfter, '$1').replace(dotBefore, '0.$1');
          }

          if (str != s) return new BigNumber(s, base);
        }

        // '[BigNumber Error] Not a number: {n}'
        // '[BigNumber Error] Not a base {b} number: {n}'
        if (BigNumber.DEBUG) {
          throw Error
            (bignumberError + 'Not a' + (b ? ' base ' + b : '') + ' number: ' + str);
        }

        // NaN
        x.s = null;
      }

      x.c = x.e = null;
    }
  })();


  /*
   * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
   * If r is truthy, it is known that there are more digits after the rounding digit.
   */
  function round(x, sd, rm, r) {
    var d, i, j, k, n, ni, rd,
      xc = x.c,
      pows10 = POWS_TEN;

    // if x is not Infinity or NaN...
    if (xc) {

      // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
      // n is a base 1e14 number, the value of the element of array x.c containing rd.
      // ni is the index of n within x.c.
      // d is the number of digits of n.
      // i is the index of rd within n including leading zeros.
      // j is the actual index of rd within n (if < 0, rd is a leading zero).
      out: {

        // Get the number of digits of the first element of xc.
        for (d = 1, k = xc[0]; k >= 10; k /= 10, d++);
        i = sd - d;

        // If the rounding digit is in the first element of xc...
        if (i < 0) {
          i += LOG_BASE;
          j = sd;
          n = xc[ni = 0];

          // Get the rounding digit at index j of n.
          rd = mathfloor(n / pows10[d - j - 1] % 10);
        } else {
          ni = mathceil((i + 1) / LOG_BASE);

          if (ni >= xc.length) {

            if (r) {

              // Needed by sqrt.
              for (; xc.length <= ni; xc.push(0));
              n = rd = 0;
              d = 1;
              i %= LOG_BASE;
              j = i - LOG_BASE + 1;
            } else {
              break out;
            }
          } else {
            n = k = xc[ni];

            // Get the number of digits of n.
            for (d = 1; k >= 10; k /= 10, d++);

            // Get the index of rd within n.
            i %= LOG_BASE;

            // Get the index of rd within n, adjusted for leading zeros.
            // The number of leading zeros of n is given by LOG_BASE - d.
            j = i - LOG_BASE + d;

            // Get the rounding digit at index j of n.
            rd = j < 0 ? 0 : mathfloor(n / pows10[d - j - 1] % 10);
          }
        }

        r = r || sd < 0 ||

        // Are there any non-zero digits after the rounding digit?
        // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
        // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
         xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);

        r = rm < 4
         ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2))
         : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 &&

          // Check whether the digit to the left of the rounding digit is odd.
          ((i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10) & 1 ||
           rm == (x.s < 0 ? 8 : 7));

        if (sd < 1 || !xc[0]) {
          xc.length = 0;

          if (r) {

            // Convert sd to decimal places.
            sd -= x.e + 1;

            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
            xc[0] = pows10[(LOG_BASE - sd % LOG_BASE) % LOG_BASE];
            x.e = -sd || 0;
          } else {

            // Zero.
            xc[0] = x.e = 0;
          }

          return x;
        }

        // Remove excess digits.
        if (i == 0) {
          xc.length = ni;
          k = 1;
          ni--;
        } else {
          xc.length = ni + 1;
          k = pows10[LOG_BASE - i];

          // E.g. 56700 becomes 56000 if 7 is the rounding digit.
          // j > 0 means i > number of leading zeros of n.
          xc[ni] = j > 0 ? mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
        }

        // Round up?
        if (r) {

          for (; ;) {

            // If the digit to be rounded up is in the first element of xc...
            if (ni == 0) {

              // i will be the length of xc[0] before k is added.
              for (i = 1, j = xc[0]; j >= 10; j /= 10, i++);
              j = xc[0] += k;
              for (k = 1; j >= 10; j /= 10, k++);

              // if i != k the length has increased.
              if (i != k) {
                x.e++;
                if (xc[0] == BASE) xc[0] = 1;
              }

              break;
            } else {
              xc[ni] += k;
              if (xc[ni] != BASE) break;
              xc[ni--] = 0;
              k = 1;
            }
          }
        }

        // Remove trailing zeros.
        for (i = xc.length; xc[--i] === 0; xc.pop());
      }

      // Overflow? Infinity.
      if (x.e > MAX_EXP) {
        x.c = x.e = null;

      // Underflow? Zero.
      } else if (x.e < MIN_EXP) {
        x.c = [x.e = 0];
      }
    }

    return x;
  }


  function valueOf(n) {
    var str,
      e = n.e;

    if (e === null) return n.toString();

    str = coeffToString(n.c);

    str = e <= TO_EXP_NEG || e >= TO_EXP_POS
      ? toExponential(str, e)
      : toFixedPoint(str, e, '0');

    return n.s < 0 ? '-' + str : str;
  }


  // PROTOTYPE/INSTANCE METHODS


  /*
   * Return a new BigNumber whose value is the absolute value of this BigNumber.
   */
  P.absoluteValue = P.abs = function () {
    var x = new BigNumber(this);
    if (x.s < 0) x.s = 1;
    return x;
  };


  /*
   * Return
   *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
   *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
   *   0 if they have the same value,
   *   or null if the value of either is NaN.
   */
  P.comparedTo = function (y, b) {
    return compare(this, new BigNumber(y, b));
  };


  /*
   * If dp is undefined or null or true or false, return the number of decimal places of the
   * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
   *
   * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
   * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
   * ROUNDING_MODE if rm is omitted.
   *
   * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   */
  P.decimalPlaces = P.dp = function (dp, rm) {
    var c, n, v,
      x = this;

    if (dp != null) {
      intCheck(dp, 0, MAX);
      if (rm == null) rm = ROUNDING_MODE;
      else intCheck(rm, 0, 8);

      return round(new BigNumber(x), dp + x.e + 1, rm);
    }

    if (!(c = x.c)) return null;
    n = ((v = c.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE;

    // Subtract the number of trailing zeros of the last number.
    if (v = c[v]) for (; v % 10 == 0; v /= 10, n--);
    if (n < 0) n = 0;

    return n;
  };


  /*
   *  n / 0 = I
   *  n / N = N
   *  n / I = 0
   *  0 / n = 0
   *  0 / 0 = N
   *  0 / N = N
   *  0 / I = 0
   *  N / n = N
   *  N / 0 = N
   *  N / N = N
   *  N / I = N
   *  I / n = I
   *  I / 0 = I
   *  I / N = N
   *  I / I = N
   *
   * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
   * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
   */
  P.dividedBy = P.div = function (y, b) {
    return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
  };


  /*
   * Return a new BigNumber whose value is the integer part of dividing the value of this
   * BigNumber by the value of BigNumber(y, b).
   */
  P.dividedToIntegerBy = P.idiv = function (y, b) {
    return div(this, new BigNumber(y, b), 0, 1);
  };


  /*
   * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
   *
   * If m is present, return the result modulo m.
   * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
   * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
   *
   * The modular power operation works efficiently when x, n, and m are integers, otherwise it
   * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
   *
   * n {number|string|BigNumber} The exponent. An integer.
   * [m] {number|string|BigNumber} The modulus.
   *
   * '[BigNumber Error] Exponent not an integer: {n}'
   */
  P.exponentiatedBy = P.pow = function (n, m) {
    var half, isModExp, i, k, more, nIsBig, nIsNeg, nIsOdd, y,
      x = this;

    n = new BigNumber(n);

    // Allow NaN and ±Infinity, but not other non-integers.
    if (n.c && !n.isInteger()) {
      throw Error
        (bignumberError + 'Exponent not an integer: ' + valueOf(n));
    }

    if (m != null) m = new BigNumber(m);

    // Exponent of MAX_SAFE_INTEGER is 15.
    nIsBig = n.e > 14;

    // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
    if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {

      // The sign of the result of pow when x is negative depends on the evenness of n.
      // If +n overflows to ±Infinity, the evenness of n would be not be known.
      y = new BigNumber(Math.pow(+valueOf(x), nIsBig ? n.s * (2 - isOdd(n)) : +valueOf(n)));
      return m ? y.mod(m) : y;
    }

    nIsNeg = n.s < 0;

    if (m) {

      // x % m returns NaN if abs(m) is zero, or m is NaN.
      if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);

      isModExp = !nIsNeg && x.isInteger() && m.isInteger();

      if (isModExp) x = x.mod(m);

    // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
    // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
    } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0
      // [1, 240000000]
      ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7
      // [80000000000000]  [99999750000000]
      : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {

      // If x is negative and n is odd, k = -0, else k = 0.
      k = x.s < 0 && isOdd(n) ? -0 : 0;

      // If x >= 1, k = ±Infinity.
      if (x.e > -1) k = 1 / k;

      // If n is negative return ±0, else return ±Infinity.
      return new BigNumber(nIsNeg ? 1 / k : k);

    } else if (POW_PRECISION) {

      // Truncating each coefficient array to a length of k after each multiplication
      // equates to truncating significant digits to POW_PRECISION + [28, 41],
      // i.e. there will be a minimum of 28 guard digits retained.
      k = mathceil(POW_PRECISION / LOG_BASE + 2);
    }

    if (nIsBig) {
      half = new BigNumber(0.5);
      if (nIsNeg) n.s = 1;
      nIsOdd = isOdd(n);
    } else {
      i = Math.abs(+valueOf(n));
      nIsOdd = i % 2;
    }

    y = new BigNumber(ONE);

    // Performs 54 loop iterations for n of 9007199254740991.
    for (; ;) {

      if (nIsOdd) {
        y = y.times(x);
        if (!y.c) break;

        if (k) {
          if (y.c.length > k) y.c.length = k;
        } else if (isModExp) {
          y = y.mod(m);    //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
        }
      }

      if (i) {
        i = mathfloor(i / 2);
        if (i === 0) break;
        nIsOdd = i % 2;
      } else {
        n = n.times(half);
        round(n, n.e + 1, 1);

        if (n.e > 14) {
          nIsOdd = isOdd(n);
        } else {
          i = +valueOf(n);
          if (i === 0) break;
          nIsOdd = i % 2;
        }
      }

      x = x.times(x);

      if (k) {
        if (x.c && x.c.length > k) x.c.length = k;
      } else if (isModExp) {
        x = x.mod(m);    //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
      }
    }

    if (isModExp) return y;
    if (nIsNeg) y = ONE.div(y);

    return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
  };


  /*
   * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
   * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
   *
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
   */
  P.integerValue = function (rm) {
    var n = new BigNumber(this);
    if (rm == null) rm = ROUNDING_MODE;
    else intCheck(rm, 0, 8);
    return round(n, n.e + 1, rm);
  };


  /*
   * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
   * otherwise return false.
   */
  P.isEqualTo = P.eq = function (y, b) {
    return compare(this, new BigNumber(y, b)) === 0;
  };


  /*
   * Return true if the value of this BigNumber is a finite number, otherwise return false.
   */
  P.isFinite = function () {
    return !!this.c;
  };


  /*
   * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
   * otherwise return false.
   */
  P.isGreaterThan = P.gt = function (y, b) {
    return compare(this, new BigNumber(y, b)) > 0;
  };


  /*
   * Return true if the value of this BigNumber is greater than or equal to the value of
   * BigNumber(y, b), otherwise return false.
   */
  P.isGreaterThanOrEqualTo = P.gte = function (y, b) {
    return (b = compare(this, new BigNumber(y, b))) === 1 || b === 0;

  };


  /*
   * Return true if the value of this BigNumber is an integer, otherwise return false.
   */
  P.isInteger = function () {
    return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
  };


  /*
   * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
   * otherwise return false.
   */
  P.isLessThan = P.lt = function (y, b) {
    return compare(this, new BigNumber(y, b)) < 0;
  };


  /*
   * Return true if the value of this BigNumber is less than or equal to the value of
   * BigNumber(y, b), otherwise return false.
   */
  P.isLessThanOrEqualTo = P.lte = function (y, b) {
    return (b = compare(this, new BigNumber(y, b))) === -1 || b === 0;
  };


  /*
   * Return true if the value of this BigNumber is NaN, otherwise return false.
   */
  P.isNaN = function () {
    return !this.s;
  };


  /*
   * Return true if the value of this BigNumber is negative, otherwise return false.
   */
  P.isNegative = function () {
    return this.s < 0;
  };


  /*
   * Return true if the value of this BigNumber is positive, otherwise return false.
   */
  P.isPositive = function () {
    return this.s > 0;
  };


  /*
   * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
   */
  P.isZero = function () {
    return !!this.c && this.c[0] == 0;
  };


  /*
   *  n - 0 = n
   *  n - N = N
   *  n - I = -I
   *  0 - n = -n
   *  0 - 0 = 0
   *  0 - N = N
   *  0 - I = -I
   *  N - n = N
   *  N - 0 = N
   *  N - N = N
   *  N - I = N
   *  I - n = I
   *  I - 0 = I
   *  I - N = N
   *  I - I = N
   *
   * Return a new BigNumber whose value is the value of this BigNumber minus the value of
   * BigNumber(y, b).
   */
  P.minus = function (y, b) {
    var i, j, t, xLTy,
      x = this,
      a = x.s;

    y = new BigNumber(y, b);
    b = y.s;

    // Either NaN?
    if (!a || !b) return new BigNumber(NaN);

    // Signs differ?
    if (a != b) {
      y.s = -b;
      return x.plus(y);
    }

    var xe = x.e / LOG_BASE,
      ye = y.e / LOG_BASE,
      xc = x.c,
      yc = y.c;

    if (!xe || !ye) {

      // Either Infinity?
      if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);

      // Either zero?
      if (!xc[0] || !yc[0]) {

        // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
        return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x :

         // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
         ROUNDING_MODE == 3 ? -0 : 0);
      }
    }

    xe = bitFloor(xe);
    ye = bitFloor(ye);
    xc = xc.slice();

    // Determine which is the bigger number.
    if (a = xe - ye) {

      if (xLTy = a < 0) {
        a = -a;
        t = xc;
      } else {
        ye = xe;
        t = yc;
      }

      t.reverse();

      // Prepend zeros to equalise exponents.
      for (b = a; b--; t.push(0));
      t.reverse();
    } else {

      // Exponents equal. Check digit by digit.
      j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;

      for (a = b = 0; b < j; b++) {

        if (xc[b] != yc[b]) {
          xLTy = xc[b] < yc[b];
          break;
        }
      }
    }

    // x < y? Point xc to the array of the bigger number.
    if (xLTy) {
      t = xc;
      xc = yc;
      yc = t;
      y.s = -y.s;
    }

    b = (j = yc.length) - (i = xc.length);

    // Append zeros to xc if shorter.
    // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
    if (b > 0) for (; b--; xc[i++] = 0);
    b = BASE - 1;

    // Subtract yc from xc.
    for (; j > a;) {

      if (xc[--j] < yc[j]) {
        for (i = j; i && !xc[--i]; xc[i] = b);
        --xc[i];
        xc[j] += BASE;
      }

      xc[j] -= yc[j];
    }

    // Remove leading zeros and adjust exponent accordingly.
    for (; xc[0] == 0; xc.splice(0, 1), --ye);

    // Zero?
    if (!xc[0]) {

      // Following IEEE 754 (2008) 6.3,
      // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
      y.s = ROUNDING_MODE == 3 ? -1 : 1;
      y.c = [y.e = 0];
      return y;
    }

    // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
    // for finite x and y.
    return normalise(y, xc, ye);
  };


  /*
   *   n % 0 =  N
   *   n % N =  N
   *   n % I =  n
   *   0 % n =  0
   *  -0 % n = -0
   *   0 % 0 =  N
   *   0 % N =  N
   *   0 % I =  0
   *   N % n =  N
   *   N % 0 =  N
   *   N % N =  N
   *   N % I =  N
   *   I % n =  N
   *   I % 0 =  N
   *   I % N =  N
   *   I % I =  N
   *
   * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
   * BigNumber(y, b). The result depends on the value of MODULO_MODE.
   */
  P.modulo = P.mod = function (y, b) {
    var q, s,
      x = this;

    y = new BigNumber(y, b);

    // Return NaN if x is Infinity or NaN, or y is NaN or zero.
    if (!x.c || !y.s || y.c && !y.c[0]) {
      return new BigNumber(NaN);

    // Return x if y is Infinity or x is zero.
    } else if (!y.c || x.c && !x.c[0]) {
      return new BigNumber(x);
    }

    if (MODULO_MODE == 9) {

      // Euclidian division: q = sign(y) * floor(x / abs(y))
      // r = x - qy    where  0 <= r < abs(y)
      s = y.s;
      y.s = 1;
      q = div(x, y, 0, 3);
      y.s = s;
      q.s *= s;
    } else {
      q = div(x, y, 0, MODULO_MODE);
    }

    y = x.minus(q.times(y));

    // To match JavaScript %, ensure sign of zero is sign of dividend.
    if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;

    return y;
  };


  /*
   *  n * 0 = 0
   *  n * N = N
   *  n * I = I
   *  0 * n = 0
   *  0 * 0 = 0
   *  0 * N = N
   *  0 * I = N
   *  N * n = N
   *  N * 0 = N
   *  N * N = N
   *  N * I = N
   *  I * n = I
   *  I * 0 = N
   *  I * N = N
   *  I * I = I
   *
   * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
   * of BigNumber(y, b).
   */
  P.multipliedBy = P.times = function (y, b) {
    var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc,
      base, sqrtBase,
      x = this,
      xc = x.c,
      yc = (y = new BigNumber(y, b)).c;

    // Either NaN, ±Infinity or ±0?
    if (!xc || !yc || !xc[0] || !yc[0]) {

      // Return NaN if either is NaN, or one is 0 and the other is Infinity.
      if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) {
        y.c = y.e = y.s = null;
      } else {
        y.s *= x.s;

        // Return ±Infinity if either is ±Infinity.
        if (!xc || !yc) {
          y.c = y.e = null;

        // Return ±0 if either is ±0.
        } else {
          y.c = [0];
          y.e = 0;
        }
      }

      return y;
    }

    e = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
    y.s *= x.s;
    xcL = xc.length;
    ycL = yc.length;

    // Ensure xc points to longer array and xcL to its length.
    if (xcL < ycL) {
      zc = xc;
      xc = yc;
      yc = zc;
      i = xcL;
      xcL = ycL;
      ycL = i;
    }

    // Initialise the result array with zeros.
    for (i = xcL + ycL, zc = []; i--; zc.push(0));

    base = BASE;
    sqrtBase = SQRT_BASE;

    for (i = ycL; --i >= 0;) {
      c = 0;
      ylo = yc[i] % sqrtBase;
      yhi = yc[i] / sqrtBase | 0;

      for (k = xcL, j = i + k; j > i;) {
        xlo = xc[--k] % sqrtBase;
        xhi = xc[k] / sqrtBase | 0;
        m = yhi * xlo + xhi * ylo;
        xlo = ylo * xlo + ((m % sqrtBase) * sqrtBase) + zc[j] + c;
        c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
        zc[j--] = xlo % base;
      }

      zc[j] = c;
    }

    if (c) {
      ++e;
    } else {
      zc.splice(0, 1);
    }

    return normalise(y, zc, e);
  };


  /*
   * Return a new BigNumber whose value is the value of this BigNumber negated,
   * i.e. multiplied by -1.
   */
  P.negated = function () {
    var x = new BigNumber(this);
    x.s = -x.s || null;
    return x;
  };


  /*
   *  n + 0 = n
   *  n + N = N
   *  n + I = I
   *  0 + n = n
   *  0 + 0 = 0
   *  0 + N = N
   *  0 + I = I
   *  N + n = N
   *  N + 0 = N
   *  N + N = N
   *  N + I = N
   *  I + n = I
   *  I + 0 = I
   *  I + N = N
   *  I + I = I
   *
   * Return a new BigNumber whose value is the value of this BigNumber plus the value of
   * BigNumber(y, b).
   */
  P.plus = function (y, b) {
    var t,
      x = this,
      a = x.s;

    y = new BigNumber(y, b);
    b = y.s;

    // Either NaN?
    if (!a || !b) return new BigNumber(NaN);

    // Signs differ?
     if (a != b) {
      y.s = -b;
      return x.minus(y);
    }

    var xe = x.e / LOG_BASE,
      ye = y.e / LOG_BASE,
      xc = x.c,
      yc = y.c;

    if (!xe || !ye) {

      // Return ±Infinity if either ±Infinity.
      if (!xc || !yc) return new BigNumber(a / 0);

      // Either zero?
      // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
      if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
    }

    xe = bitFloor(xe);
    ye = bitFloor(ye);
    xc = xc.slice();

    // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
    if (a = xe - ye) {
      if (a > 0) {
        ye = xe;
        t = yc;
      } else {
        a = -a;
        t = xc;
      }

      t.reverse();
      for (; a--; t.push(0));
      t.reverse();
    }

    a = xc.length;
    b = yc.length;

    // Point xc to the longer array, and b to the shorter length.
    if (a - b < 0) {
      t = yc;
      yc = xc;
      xc = t;
      b = a;
    }

    // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
    for (a = 0; b;) {
      a = (xc[--b] = xc[b] + yc[b] + a) / BASE | 0;
      xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
    }

    if (a) {
      xc = [a].concat(xc);
      ++ye;
    }

    // No need to check for zero, as +x + +y != 0 && -x + -y != 0
    // ye = MAX_EXP + 1 possible
    return normalise(y, xc, ye);
  };


  /*
   * If sd is undefined or null or true or false, return the number of significant digits of
   * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
   * If sd is true include integer-part trailing zeros in the count.
   *
   * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
   * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
   * ROUNDING_MODE if rm is omitted.
   *
   * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
   *                     boolean: whether to count integer-part trailing zeros: true or false.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
   */
  P.precision = P.sd = function (sd, rm) {
    var c, n, v,
      x = this;

    if (sd != null && sd !== !!sd) {
      intCheck(sd, 1, MAX);
      if (rm == null) rm = ROUNDING_MODE;
      else intCheck(rm, 0, 8);

      return round(new BigNumber(x), sd, rm);
    }

    if (!(c = x.c)) return null;
    v = c.length - 1;
    n = v * LOG_BASE + 1;

    if (v = c[v]) {

      // Subtract the number of trailing zeros of the last element.
      for (; v % 10 == 0; v /= 10, n--);

      // Add the number of digits of the first element.
      for (v = c[0]; v >= 10; v /= 10, n++);
    }

    if (sd && x.e + 1 > n) n = x.e + 1;

    return n;
  };


  /*
   * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
   * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
   *
   * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
   */
  P.shiftedBy = function (k) {
    intCheck(k, -MAX_SAFE_INTEGER$1, MAX_SAFE_INTEGER$1);
    return this.times('1e' + k);
  };


  /*
   *  sqrt(-n) =  N
   *  sqrt(N) =  N
   *  sqrt(-I) =  N
   *  sqrt(I) =  I
   *  sqrt(0) =  0
   *  sqrt(-0) = -0
   *
   * Return a new BigNumber whose value is the square root of the value of this BigNumber,
   * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
   */
  P.squareRoot = P.sqrt = function () {
    var m, n, r, rep, t,
      x = this,
      c = x.c,
      s = x.s,
      e = x.e,
      dp = DECIMAL_PLACES + 4,
      half = new BigNumber('0.5');

    // Negative/NaN/Infinity/zero?
    if (s !== 1 || !c || !c[0]) {
      return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
    }

    // Initial estimate.
    s = Math.sqrt(+valueOf(x));

    // Math.sqrt underflow/overflow?
    // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
    if (s == 0 || s == 1 / 0) {
      n = coeffToString(c);
      if ((n.length + e) % 2 == 0) n += '0';
      s = Math.sqrt(+n);
      e = bitFloor((e + 1) / 2) - (e < 0 || e % 2);

      if (s == 1 / 0) {
        n = '5e' + e;
      } else {
        n = s.toExponential();
        n = n.slice(0, n.indexOf('e') + 1) + e;
      }

      r = new BigNumber(n);
    } else {
      r = new BigNumber(s + '');
    }

    // Check for zero.
    // r could be zero if MIN_EXP is changed after the this value was created.
    // This would cause a division by zero (x/t) and hence Infinity below, which would cause
    // coeffToString to throw.
    if (r.c[0]) {
      e = r.e;
      s = e + dp;
      if (s < 3) s = 0;

      // Newton-Raphson iteration.
      for (; ;) {
        t = r;
        r = half.times(t.plus(div(x, t, dp, 1)));

        if (coeffToString(t.c).slice(0, s) === (n = coeffToString(r.c)).slice(0, s)) {

          // The exponent of r may here be one less than the final result exponent,
          // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
          // are indexed correctly.
          if (r.e < e) --s;
          n = n.slice(s - 3, s + 1);

          // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
          // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
          // iteration.
          if (n == '9999' || !rep && n == '4999') {

            // On the first iteration only, check to see if rounding up gives the
            // exact result as the nines may infinitely repeat.
            if (!rep) {
              round(t, t.e + DECIMAL_PLACES + 2, 0);

              if (t.times(t).eq(x)) {
                r = t;
                break;
              }
            }

            dp += 4;
            s += 4;
            rep = 1;
          } else {

            // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
            // result. If not, then there are further digits and m will be truthy.
            if (!+n || !+n.slice(1) && n.charAt(0) == '5') {

              // Truncate to the first rounding digit.
              round(r, r.e + DECIMAL_PLACES + 2, 1);
              m = !r.times(r).eq(x);
            }

            break;
          }
        }
      }
    }

    return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
  };


  /*
   * Return a string representing the value of this BigNumber in exponential notation and
   * rounded using ROUNDING_MODE to dp fixed decimal places.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   */
  P.toExponential = function (dp, rm) {
    if (dp != null) {
      intCheck(dp, 0, MAX);
      dp++;
    }
    return format(this, dp, rm, 1);
  };


  /*
   * Return a string representing the value of this BigNumber in fixed-point notation rounding
   * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
   *
   * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
   * but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   */
  P.toFixed = function (dp, rm) {
    if (dp != null) {
      intCheck(dp, 0, MAX);
      dp = dp + this.e + 1;
    }
    return format(this, dp, rm);
  };


  /*
   * Return a string representing the value of this BigNumber in fixed-point notation rounded
   * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
   * of the format or FORMAT object (see BigNumber.set).
   *
   * The formatting object may contain some or all of the properties shown below.
   *
   * FORMAT = {
   *   prefix: '',
   *   groupSize: 3,
   *   secondaryGroupSize: 0,
   *   groupSeparator: ',',
   *   decimalSeparator: '.',
   *   fractionGroupSize: 0,
   *   fractionGroupSeparator: '\xA0',      // non-breaking space
   *   suffix: ''
   * };
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   * [format] {object} Formatting options. See FORMAT pbject above.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   * '[BigNumber Error] Argument not an object: {format}'
   */
  P.toFormat = function (dp, rm, format) {
    var str,
      x = this;

    if (format == null) {
      if (dp != null && rm && typeof rm == 'object') {
        format = rm;
        rm = null;
      } else if (dp && typeof dp == 'object') {
        format = dp;
        dp = rm = null;
      } else {
        format = FORMAT;
      }
    } else if (typeof format != 'object') {
      throw Error
        (bignumberError + 'Argument not an object: ' + format);
    }

    str = x.toFixed(dp, rm);

    if (x.c) {
      var i,
        arr = str.split('.'),
        g1 = +format.groupSize,
        g2 = +format.secondaryGroupSize,
        groupSeparator = format.groupSeparator || '',
        intPart = arr[0],
        fractionPart = arr[1],
        isNeg = x.s < 0,
        intDigits = isNeg ? intPart.slice(1) : intPart,
        len = intDigits.length;

      if (g2) {
        i = g1;
        g1 = g2;
        g2 = i;
        len -= i;
      }

      if (g1 > 0 && len > 0) {
        i = len % g1 || g1;
        intPart = intDigits.substr(0, i);
        for (; i < len; i += g1) intPart += groupSeparator + intDigits.substr(i, g1);
        if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
        if (isNeg) intPart = '-' + intPart;
      }

      str = fractionPart
       ? intPart + (format.decimalSeparator || '') + ((g2 = +format.fractionGroupSize)
        ? fractionPart.replace(new RegExp('\\d{' + g2 + '}\\B', 'g'),
         '$&' + (format.fractionGroupSeparator || ''))
        : fractionPart)
       : intPart;
    }

    return (format.prefix || '') + str + (format.suffix || '');
  };


  /*
   * Return an array of two BigNumbers representing the value of this BigNumber as a simple
   * fraction with an integer numerator and an integer denominator.
   * The denominator will be a positive non-zero value less than or equal to the specified
   * maximum denominator. If a maximum denominator is not specified, the denominator will be
   * the lowest value necessary to represent the number exactly.
   *
   * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
   *
   * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
   */
  P.toFraction = function (md) {
    var d, d0, d1, d2, e, exp, n, n0, n1, q, r, s,
      x = this,
      xc = x.c;

    if (md != null) {
      n = new BigNumber(md);

      // Throw if md is less than one or is not an integer, unless it is Infinity.
      if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) {
        throw Error
          (bignumberError + 'Argument ' +
            (n.isInteger() ? 'out of range: ' : 'not an integer: ') + valueOf(n));
      }
    }

    if (!xc) return new BigNumber(x);

    d = new BigNumber(ONE);
    n1 = d0 = new BigNumber(ONE);
    d1 = n0 = new BigNumber(ONE);
    s = coeffToString(xc);

    // Determine initial denominator.
    // d is a power of 10 and the minimum max denominator that specifies the value exactly.
    e = d.e = s.length - x.e - 1;
    d.c[0] = POWS_TEN[(exp = e % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
    md = !md || n.comparedTo(d) > 0 ? (e > 0 ? d : n1) : n;

    exp = MAX_EXP;
    MAX_EXP = 1 / 0;
    n = new BigNumber(s);

    // n0 = d1 = 0
    n0.c[0] = 0;

    for (; ;)  {
      q = div(n, d, 0, 1);
      d2 = d0.plus(q.times(d1));
      if (d2.comparedTo(md) == 1) break;
      d0 = d1;
      d1 = d2;
      n1 = n0.plus(q.times(d2 = n1));
      n0 = d2;
      d = n.minus(q.times(d2 = d));
      n = d2;
    }

    d2 = div(md.minus(d0), d1, 0, 1);
    n0 = n0.plus(d2.times(n1));
    d0 = d0.plus(d2.times(d1));
    n0.s = n1.s = x.s;
    e = e * 2;

    // Determine which fraction is closer to x, n0/d0 or n1/d1
    r = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(
        div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [n1, d1] : [n0, d0];

    MAX_EXP = exp;

    return r;
  };


  /*
   * Return the value of this BigNumber converted to a number primitive.
   */
  P.toNumber = function () {
    return +valueOf(this);
  };


  /*
   * Return a string representing the value of this BigNumber rounded to sd significant digits
   * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
   * necessary to represent the integer part of the value in fixed-point notation, then use
   * exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
   */
  P.toPrecision = function (sd, rm) {
    if (sd != null) intCheck(sd, 1, MAX);
    return format(this, sd, rm, 2);
  };


  /*
   * Return a string representing the value of this BigNumber in base b, or base 10 if b is
   * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
   * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
   * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
   * TO_EXP_NEG, return exponential notation.
   *
   * [b] {number} Integer, 2 to ALPHABET.length inclusive.
   *
   * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
   */
  P.toString = function (b) {
    var str,
      n = this,
      s = n.s,
      e = n.e;

    // Infinity or NaN?
    if (e === null) {
      if (s) {
        str = 'Infinity';
        if (s < 0) str = '-' + str;
      } else {
        str = 'NaN';
      }
    } else {
      if (b == null) {
        str = e <= TO_EXP_NEG || e >= TO_EXP_POS
         ? toExponential(coeffToString(n.c), e)
         : toFixedPoint(coeffToString(n.c), e, '0');
      } else if (b === 10 && alphabetHasNormalDecimalDigits) {
        n = round(new BigNumber(n), DECIMAL_PLACES + e + 1, ROUNDING_MODE);
        str = toFixedPoint(coeffToString(n.c), n.e, '0');
      } else {
        intCheck(b, 2, ALPHABET.length, 'Base');
        str = convertBase(toFixedPoint(coeffToString(n.c), e, '0'), 10, b, s, true);
      }

      if (s < 0 && n.c[0]) str = '-' + str;
    }

    return str;
  };


  /*
   * Return as toString, but do not accept a base argument, and include the minus sign for
   * negative zero.
   */
  P.valueOf = P.toJSON = function () {
    return valueOf(this);
  };


  P._isBigNumber = true;

  P[Symbol.toStringTag] = 'BigNumber';

  // Node.js v10.12.0+
  P[Symbol.for('nodejs.util.inspect.custom')] = P.valueOf;

  if (configObject != null) BigNumber.set(configObject);

  return BigNumber;
}


// PRIVATE HELPER FUNCTIONS

// These functions don't need access to variables,
// e.g. DECIMAL_PLACES, in the scope of the `clone` function above.


function bitFloor(n) {
  var i = n | 0;
  return n > 0 || n === i ? i : i - 1;
}


// Return a coefficient array as a string of base 10 digits.
function coeffToString(a) {
  var s, z,
    i = 1,
    j = a.length,
    r = a[0] + '';

  for (; i < j;) {
    s = a[i++] + '';
    z = LOG_BASE - s.length;
    for (; z--; s = '0' + s);
    r += s;
  }

  // Determine trailing zeros.
  for (j = r.length; r.charCodeAt(--j) === 48;);

  return r.slice(0, j + 1 || 1);
}


// Compare the value of BigNumbers x and y.
function compare(x, y) {
  var a, b,
    xc = x.c,
    yc = y.c,
    i = x.s,
    j = y.s,
    k = x.e,
    l = y.e;

  // Either NaN?
  if (!i || !j) return null;

  a = xc && !xc[0];
  b = yc && !yc[0];

  // Either zero?
  if (a || b) return a ? b ? 0 : -j : i;

  // Signs differ?
  if (i != j) return i;

  a = i < 0;
  b = k == l;

  // Either Infinity?
  if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;

  // Compare exponents.
  if (!b) return k > l ^ a ? 1 : -1;

  j = (k = xc.length) < (l = yc.length) ? k : l;

  // Compare digit by digit.
  for (i = 0; i < j; i++) if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;

  // Compare lengths.
  return k == l ? 0 : k > l ^ a ? 1 : -1;
}


/*
 * Check that n is a primitive number, an integer, and in range, otherwise throw.
 */
function intCheck(n, min, max, name) {
  if (n < min || n > max || n !== mathfloor(n)) {
    throw Error
     (bignumberError + (name || 'Argument') + (typeof n == 'number'
       ? n < min || n > max ? ' out of range: ' : ' not an integer: '
       : ' not a primitive number: ') + String(n));
  }
}


// Assumes finite n.
function isOdd(n) {
  var k = n.c.length - 1;
  return bitFloor(n.e / LOG_BASE) == k && n.c[k] % 2 != 0;
}


function toExponential(str, e) {
  return (str.length > 1 ? str.charAt(0) + '.' + str.slice(1) : str) +
   (e < 0 ? 'e' : 'e+') + e;
}


function toFixedPoint(str, e, z) {
  var len, zs;

  // Negative exponent?
  if (e < 0) {

    // Prepend zeros.
    for (zs = z + '.'; ++e; zs += z);
    str = zs + str;

  // Positive exponent
  } else {
    len = str.length;

    // Append zeros.
    if (++e > len) {
      for (zs = z, e -= len; --e; zs += z);
      str += zs;
    } else if (e < len) {
      str = str.slice(0, e) + '.' + str.slice(e);
    }
  }

  return str;
}


// EXPORT


var BigNumber = clone();

var RoundingModeMap;
(function (RoundingModeMap) {
    RoundingModeMap[RoundingModeMap["up"] = BigNumber.ROUND_UP] = "up";
    RoundingModeMap[RoundingModeMap["down"] = BigNumber.ROUND_DOWN] = "down";
    RoundingModeMap[RoundingModeMap["truncate"] = BigNumber.ROUND_DOWN] = "truncate";
    RoundingModeMap[RoundingModeMap["halfUp"] = BigNumber.ROUND_HALF_UP] = "halfUp";
    RoundingModeMap[RoundingModeMap["default"] = BigNumber.ROUND_HALF_UP] = "default";
    RoundingModeMap[RoundingModeMap["halfDown"] = BigNumber.ROUND_HALF_DOWN] = "halfDown";
    RoundingModeMap[RoundingModeMap["halfEven"] = BigNumber.ROUND_HALF_EVEN] = "halfEven";
    RoundingModeMap[RoundingModeMap["banker"] = BigNumber.ROUND_HALF_EVEN] = "banker";
    RoundingModeMap[RoundingModeMap["ceiling"] = BigNumber.ROUND_CEIL] = "ceiling";
    RoundingModeMap[RoundingModeMap["ceil"] = BigNumber.ROUND_CEIL] = "ceil";
    RoundingModeMap[RoundingModeMap["floor"] = BigNumber.ROUND_FLOOR] = "floor";
})(RoundingModeMap || (RoundingModeMap = {}));
function expandRoundMode(roundMode) {
    var _a;
    return ((_a = RoundingModeMap[roundMode]) !== null && _a !== void 0 ? _a : RoundingModeMap.default);
}

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER = 9007199254740991;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor;

/**
 * The base implementation of `_.repeat` which doesn't coerce arguments.
 *
 * @private
 * @param {string} string The string to repeat.
 * @param {number} n The number of times to repeat the string.
 * @returns {string} Returns the repeated string.
 */
function baseRepeat$1(string, n) {
  var result = '';
  if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
    return result;
  }
  // Leverage the exponentiation by squaring algorithm for a faster repeat.
  // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
  do {
    if (n % 2) {
      result += string;
    }
    n = nativeFloor(n / 2);
    if (n) {
      string += string;
    }
  } while (n);

  return result;
}

var _baseRepeat = baseRepeat$1;

/** Used to match a single whitespace character. */

var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex$1(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

var _trimmedEndIndex = trimmedEndIndex$1;

var trimmedEndIndex = _trimmedEndIndex;

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim$1(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

var _baseTrim = baseTrim$1;

var baseTrim = _baseTrim,
    isObject$2 = isObject_1,
    isSymbol$1 = isSymbol_1;

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber$1(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol$1(value)) {
    return NAN;
  }
  if (isObject$2(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$2(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var toNumber_1 = toNumber$1;

var toNumber = toNumber_1;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite$2(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

var toFinite_1 = toFinite$2;

var toFinite$1 = toFinite_1;

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger$1(value) {
  var result = toFinite$1(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

var toInteger_1 = toInteger$1;

var baseRepeat = _baseRepeat,
    isIterateeCall$2 = _isIterateeCall,
    toInteger = toInteger_1,
    toString$1 = toString_1;

/**
 * Repeats the given string `n` times.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to repeat.
 * @param {number} [n=1] The number of times to repeat the string.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the repeated string.
 * @example
 *
 * _.repeat('*', 3);
 * // => '***'
 *
 * _.repeat('abc', 2);
 * // => 'abcabc'
 *
 * _.repeat('abc', 0);
 * // => ''
 */
function repeat(string, n, guard) {
  if ((guard ? isIterateeCall$2(string, n, guard) : n === undefined)) {
    n = 1;
  } else {
    n = toInteger(n);
  }
  return baseRepeat(toString$1(string), n);
}

var repeat_1 = repeat;

var repeat$1 = /*@__PURE__*/getDefaultExportFromCjs(repeat_1);

function digitCount(numeric) {
    if (numeric.isZero()) {
        return 1;
    }
    return Math.floor(Math.log10(numeric.abs().toNumber()) + 1);
}
function getAbsolutePrecision(numeric, { precision, significant }) {
    if (significant && precision !== null && precision > 0) {
        return precision - digitCount(numeric);
    }
    return precision;
}
function roundNumber(numeric, options) {
    const precision = getAbsolutePrecision(numeric, options);
    if (precision === null) {
        return numeric.toString();
    }
    const roundMode = expandRoundMode(options.roundMode);
    if (precision >= 0) {
        return numeric.toFixed(precision, roundMode);
    }
    const rounder = Math.pow(10, Math.abs(precision));
    numeric = new BigNumber(numeric.div(rounder).toFixed(0, roundMode)).times(rounder);
    return numeric.toString();
}

function replaceInFormat(format, { formattedNumber, unit }) {
    return format.replace("%n", formattedNumber).replace("%u", unit);
}
function computeSignificand({ significand, whole, precision, }) {
    if (whole === "0" || precision === null) {
        return significand;
    }
    const limit = Math.max(0, precision - whole.length);
    return (significand !== null && significand !== void 0 ? significand : "").substr(0, limit);
}
function formatNumber(input, options) {
    var _a, _b, _c;
    const originalNumber = new BigNumber(input);
    if (options.raise && !originalNumber.isFinite()) {
        throw new Error(`"${input}" is not a valid numeric value`);
    }
    const roundedNumber = roundNumber(originalNumber, options);
    const numeric = new BigNumber(roundedNumber);
    const isNegative = numeric.lt(0);
    const isZero = numeric.isZero();
    let [whole, significand] = roundedNumber.split(".");
    const buffer = [];
    let formattedNumber;
    const positiveFormat = (_a = options.format) !== null && _a !== void 0 ? _a : "%n";
    const negativeFormat = (_b = options.negativeFormat) !== null && _b !== void 0 ? _b : `-${positiveFormat}`;
    const format = isNegative && !isZero ? negativeFormat : positiveFormat;
    whole = whole.replace("-", "");
    while (whole.length > 0) {
        buffer.unshift(whole.substr(Math.max(0, whole.length - 3), 3));
        whole = whole.substr(0, whole.length - 3);
    }
    whole = buffer.join("");
    formattedNumber = buffer.join(options.delimiter);
    if (options.significant) {
        significand = computeSignificand({
            whole,
            significand,
            precision: options.precision,
        });
    }
    else {
        significand = significand !== null && significand !== void 0 ? significand : repeat$1("0", (_c = options.precision) !== null && _c !== void 0 ? _c : 0);
    }
    if (options.stripInsignificantZeros && significand) {
        significand = significand.replace(/0+$/, "");
    }
    if (originalNumber.isNaN()) {
        formattedNumber = input.toString();
    }
    if (significand && originalNumber.isFinite()) {
        formattedNumber += (options.separator || ".") + significand;
    }
    return replaceInFormat(format, {
        formattedNumber,
        unit: options.unit,
    });
}

function getFullScope(i18n, scope, options) {
    let result = "";
    if (scope instanceof String || typeof scope === "string") {
        result = scope;
    }
    if (scope instanceof Array) {
        result = scope.join(i18n.defaultSeparator);
    }
    if (options.scope) {
        result = [options.scope, result].join(i18n.defaultSeparator);
    }
    return result;
}

function inferType(instance) {
    var _a, _b;
    if (instance === null) {
        return "null";
    }
    const type = typeof instance;
    if (type !== "object") {
        return type;
    }
    return ((_b = (_a = instance === null || instance === void 0 ? void 0 : instance.constructor) === null || _a === void 0 ? void 0 : _a.name) === null || _b === void 0 ? void 0 : _b.toLowerCase()) || "object";
}

function interpolate(i18n, message, options) {
    options = Object.keys(options).reduce((buffer, key) => {
        buffer[i18n.transformKey(key)] = options[key];
        return buffer;
    }, {});
    const matches = message.match(i18n.placeholder);
    if (!matches) {
        return message;
    }
    while (matches.length) {
        let value;
        const placeholder = matches.shift();
        const name = placeholder.replace(i18n.placeholder, "$1");
        if (isSet(options[name])) {
            value = options[name].toString().replace(/\$/gm, "_#$#_");
        }
        else if (name in options) {
            value = i18n.nullPlaceholder(i18n, placeholder, message, options);
        }
        else {
            value = i18n.missingPlaceholder(i18n, placeholder, message, options);
        }
        const regex = new RegExp(placeholder.replace(/\{/gm, "\\{").replace(/\}/gm, "\\}"));
        message = message.replace(regex, value);
    }
    return message.replace(/_#\$#_/g, "$");
}

function lookup(i18n, scope, options = {}) {
    options = Object.assign({}, options);
    const locale = "locale" in options ? options.locale : i18n.locale;
    const localeType = inferType(locale);
    const locales = i18n.locales
        .get(localeType === "string" ? locale : typeof locale)
        .slice();
    const keys = getFullScope(i18n, scope, options)
        .split(i18n.defaultSeparator)
        .map((component) => i18n.transformKey(component));
    const entries = locales.map((locale) => keys.reduce((path, key) => path && path[key], i18n.translations[locale]));
    entries.push(options.defaultValue);
    return entries.find((entry) => isSet(entry));
}

function numberToDelimited(input, options) {
    const numeric = new BigNumber(input);
    if (!numeric.isFinite()) {
        return input.toString();
    }
    if (!options.delimiterPattern.global) {
        throw new Error(`options.delimiterPattern must be a global regular expression; received ${options.delimiterPattern}`);
    }
    let [left, right] = numeric.toString().split(".");
    left = left.replace(options.delimiterPattern, (digitToDelimiter) => `${digitToDelimiter}${options.delimiter}`);
    return [left, right].filter(Boolean).join(options.separator);
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */

function arrayPush$2(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var _arrayPush = arrayPush$2;

var Symbol$2 = _Symbol,
    isArguments = isArguments_1,
    isArray$5 = isArray_1;

/** Built-in value references. */
var spreadableSymbol = Symbol$2 ? Symbol$2.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable$1(value) {
  return isArray$5(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

var _isFlattenable = isFlattenable$1;

var arrayPush$1 = _arrayPush,
    isFlattenable = _isFlattenable;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten$1(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten$1(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush$1(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

var _baseFlatten = baseFlatten$1;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */

function arraySome$1(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

var _arraySome = arraySome$1;

var SetCache = _SetCache,
    arraySome = _arraySome,
    cacheHas = _cacheHas;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$5 = 1,
    COMPARE_UNORDERED_FLAG$3 = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays$2(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG$3) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

var _equalArrays = equalArrays$2;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */

function mapToArray$1(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

var _mapToArray = mapToArray$1;

var Symbol$1 = _Symbol,
    Uint8Array$1 = _Uint8Array,
    eq = eq_1,
    equalArrays$1 = _equalArrays,
    mapToArray = _mapToArray,
    setToArray = _setToArray;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$4 = 1,
    COMPARE_UNORDERED_FLAG$2 = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag$1 = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag$1 = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag$1(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$1:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array$1(object), new Uint8Array$1(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag$1:
      var convert = mapToArray;

    case setTag$1:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays$1(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

var _equalByTag = equalByTag$1;

var arrayPush = _arrayPush,
    isArray$4 = isArray_1;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys$1(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$4(object) ? result : arrayPush(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys$1;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */

function arrayFilter$1(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var _arrayFilter = arrayFilter$1;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */

function stubArray$1() {
  return [];
}

var stubArray_1 = stubArray$1;

var arrayFilter = _arrayFilter,
    stubArray = stubArray_1;

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$3.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols$1 = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

var _getSymbols = getSymbols$1;

var overArg = _overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys$1 = overArg(Object.keys, Object);

var _nativeKeys = nativeKeys$1;

var isPrototype = _isPrototype,
    nativeKeys = _nativeKeys;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$2.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys$1(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$3.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys$1;

var arrayLikeKeys = _arrayLikeKeys,
    baseKeys = _baseKeys,
    isArrayLike$2 = isArrayLike_1;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$3(object) {
  return isArrayLike$2(object) ? arrayLikeKeys(object) : baseKeys(object);
}

var keys_1 = keys$3;

var baseGetAllKeys = _baseGetAllKeys,
    getSymbols = _getSymbols,
    keys$2 = keys_1;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys$1(object) {
  return baseGetAllKeys(object, keys$2, getSymbols);
}

var _getAllKeys = getAllKeys$1;

var getAllKeys = _getAllKeys;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$1.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$2.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

var _equalObjects = equalObjects$1;

var getNative$2 = _getNative,
    root$2 = _root;

/* Built-in method references that are verified to be native. */
var DataView$1 = getNative$2(root$2, 'DataView');

var _DataView = DataView$1;

var getNative$1 = _getNative,
    root$1 = _root;

/* Built-in method references that are verified to be native. */
var Promise$2 = getNative$1(root$1, 'Promise');

var _Promise = Promise$2;

var getNative = _getNative,
    root = _root;

/* Built-in method references that are verified to be native. */
var WeakMap$2 = getNative(root, 'WeakMap');

var _WeakMap = WeakMap$2;

var DataView = _DataView,
    Map$1 = _Map,
    Promise$1 = _Promise,
    Set$1 = _Set,
    WeakMap$1 = _WeakMap,
    baseGetTag = _baseGetTag,
    toSource = _toSource;

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag$1 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map$1),
    promiseCtorString = toSource(Promise$1),
    setCtorString = toSource(Set$1),
    weakMapCtorString = toSource(WeakMap$1);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag$1 = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag$1(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map$1 && getTag$1(new Map$1) != mapTag) ||
    (Promise$1 && getTag$1(Promise$1.resolve()) != promiseTag) ||
    (Set$1 && getTag$1(new Set$1) != setTag) ||
    (WeakMap$1 && getTag$1(new WeakMap$1) != weakMapTag)) {
  getTag$1 = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag$1 ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

var _getTag = getTag$1;

var Stack$1 = _Stack,
    equalArrays = _equalArrays,
    equalByTag = _equalByTag,
    equalObjects = _equalObjects,
    getTag = _getTag,
    isArray$3 = isArray_1,
    isBuffer$1 = isBufferExports,
    isTypedArray$1 = isTypedArray_1;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$3(object),
      othIsArr = isArray$3(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer$1(object)) {
    if (!isBuffer$1(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack$1);
    return (objIsArr || isTypedArray$1(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$1.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty$1.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack$1);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack$1);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

var _baseIsEqualDeep = baseIsEqualDeep$1;

var baseIsEqualDeep = _baseIsEqualDeep,
    isObjectLike = isObjectLike_1;

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual$2(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$2, stack);
}

var _baseIsEqual = baseIsEqual$2;

var Stack = _Stack,
    baseIsEqual$1 = _baseIsEqual;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch$1(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

var _baseIsMatch = baseIsMatch$1;

var isObject$1 = isObject_1;

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable$2(value) {
  return value === value && !isObject$1(value);
}

var _isStrictComparable = isStrictComparable$2;

var isStrictComparable$1 = _isStrictComparable,
    keys$1 = keys_1;

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData$1(object) {
  var result = keys$1(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable$1(value)];
  }
  return result;
}

var _getMatchData = getMatchData$1;

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */

function matchesStrictComparable$2(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

var _matchesStrictComparable = matchesStrictComparable$2;

var baseIsMatch = _baseIsMatch,
    getMatchData = _getMatchData,
    matchesStrictComparable$1 = _matchesStrictComparable;

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches$1(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable$1(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

var _baseMatches = baseMatches$1;

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */

function baseHasIn$1(object, key) {
  return object != null && key in Object(object);
}

var _baseHasIn = baseHasIn$1;

var baseHasIn = _baseHasIn,
    hasPath = _hasPath;

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn$1(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

var hasIn_1 = hasIn$1;

var baseIsEqual = _baseIsEqual,
    get = get_1,
    hasIn = hasIn_1,
    isKey$1 = _isKey,
    isStrictComparable = _isStrictComparable,
    matchesStrictComparable = _matchesStrictComparable,
    toKey$1 = _toKey;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty$1(path, srcValue) {
  if (isKey$1(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey$1(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

var _baseMatchesProperty = baseMatchesProperty$1;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */

function baseProperty$1(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

var _baseProperty = baseProperty$1;

var baseGet$1 = _baseGet;

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep$1(path) {
  return function(object) {
    return baseGet$1(object, path);
  };
}

var _basePropertyDeep = basePropertyDeep$1;

var baseProperty = _baseProperty,
    basePropertyDeep = _basePropertyDeep,
    isKey = _isKey,
    toKey = _toKey;

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property$1(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

var property_1 = property$1;

var baseMatches = _baseMatches,
    baseMatchesProperty = _baseMatchesProperty,
    identity$1 = identity_1,
    isArray$2 = isArray_1,
    property = property_1;

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee$1(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity$1;
  }
  if (typeof value == 'object') {
    return isArray$2(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

var _baseIteratee = baseIteratee$1;

var baseFor = _baseFor,
    keys = keys_1;

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn$1(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

var _baseForOwn = baseForOwn$1;

var isArrayLike$1 = isArrayLike_1;

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach$1(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike$1(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

var _createBaseEach = createBaseEach$1;

var baseForOwn = _baseForOwn,
    createBaseEach = _createBaseEach;

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach$1 = createBaseEach(baseForOwn);

var _baseEach = baseEach$1;

var baseEach = _baseEach,
    isArrayLike = isArrayLike_1;

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap$1(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

var _baseMap = baseMap$1;

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */

function baseSortBy$1(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

var _baseSortBy = baseSortBy$1;

var isSymbol = isSymbol_1;

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending$1(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

var _compareAscending = compareAscending$1;

var compareAscending = _compareAscending;

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple$1(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

var _compareMultiple = compareMultiple$1;

var arrayMap = _arrayMap,
    baseGet = _baseGet,
    baseIteratee = _baseIteratee,
    baseMap = _baseMap,
    baseSortBy = _baseSortBy,
    baseUnary = _baseUnary,
    compareMultiple = _compareMultiple,
    identity = identity_1,
    isArray$1 = isArray_1;

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy$1(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray$1(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }

  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

var _baseOrderBy = baseOrderBy$1;

var baseFlatten = _baseFlatten,
    baseOrderBy = _baseOrderBy,
    baseRest = _baseRest,
    isIterateeCall$1 = _isIterateeCall;

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall$1(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall$1(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

var sortBy_1 = sortBy;

var sortBy$1 = /*@__PURE__*/getDefaultExportFromCjs(sortBy_1);

/**
 * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
 *
 * @private
 * @param {Array} props The property identifiers.
 * @param {Array} values The property values.
 * @param {Function} assignFunc The function to assign values.
 * @returns {Object} Returns the new object.
 */

function baseZipObject$1(props, values, assignFunc) {
  var index = -1,
      length = props.length,
      valsLength = values.length,
      result = {};

  while (++index < length) {
    var value = index < valsLength ? values[index] : undefined;
    assignFunc(result, props[index], value);
  }
  return result;
}

var _baseZipObject = baseZipObject$1;

var assignValue = _assignValue,
    baseZipObject = _baseZipObject;

/**
 * This method is like `_.fromPairs` except that it accepts two arrays,
 * one of property identifiers and one of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 0.4.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObject(['a', 'b'], [1, 2]);
 * // => { 'a': 1, 'b': 2 }
 */
function zipObject(props, values) {
  return baseZipObject(props || [], values || [], assignValue);
}

var zipObject_1 = zipObject;

var zipObject$1 = /*@__PURE__*/getDefaultExportFromCjs(zipObject_1);

const DECIMAL_UNITS = {
    "0": "unit",
    "1": "ten",
    "2": "hundred",
    "3": "thousand",
    "6": "million",
    "9": "billion",
    "12": "trillion",
    "15": "quadrillion",
    "-1": "deci",
    "-2": "centi",
    "-3": "mili",
    "-6": "micro",
    "-9": "nano",
    "-12": "pico",
    "-15": "femto",
};
const INVERTED_DECIMAL_UNITS = zipObject$1(Object.values(DECIMAL_UNITS), Object.keys(DECIMAL_UNITS).map((key) => parseInt(key, 10)));
function numberToHuman(i18n, input, options) {
    const roundOptions = {
        roundMode: options.roundMode,
        precision: options.precision,
        significant: options.significant,
    };
    let units;
    if (inferType(options.units) === "string") {
        const scope = options.units;
        units = lookup(i18n, scope);
        if (!units) {
            throw new Error(`The scope "${i18n.locale}${i18n.defaultSeparator}${getFullScope(i18n, scope, {})}" couldn't be found`);
        }
    }
    else {
        units = options.units;
    }
    let formattedNumber = roundNumber(new BigNumber(input), roundOptions);
    const unitExponents = (units) => sortBy$1(Object.keys(units).map((name) => INVERTED_DECIMAL_UNITS[name]), (numeric) => numeric * -1);
    const calculateExponent = (num, units) => {
        const exponent = num.isZero()
            ? 0
            : Math.floor(Math.log10(num.abs().toNumber()));
        return unitExponents(units).find((exp) => exponent >= exp) || 0;
    };
    const determineUnit = (units, exponent) => {
        const expName = DECIMAL_UNITS[exponent.toString()];
        return units[expName] || "";
    };
    const exponent = calculateExponent(new BigNumber(formattedNumber), units);
    const unit = determineUnit(units, exponent);
    formattedNumber = roundNumber(new BigNumber(formattedNumber).div(Math.pow(10, exponent)), roundOptions);
    if (options.stripInsignificantZeros) {
        let [whole, significand] = formattedNumber.split(".");
        significand = (significand || "").replace(/0+$/, "");
        formattedNumber = whole;
        if (significand) {
            formattedNumber += `${options.separator}${significand}`;
        }
    }
    return options.format
        .replace("%n", formattedNumber || "0")
        .replace("%u", unit)
        .trim();
}

const STORAGE_UNITS = ["byte", "kb", "mb", "gb", "tb", "pb", "eb"];
function numberToHumanSize(i18n, input, options) {
    const roundMode = expandRoundMode(options.roundMode);
    const base = 1024;
    const num = new BigNumber(input).abs();
    const smallerThanBase = num.lt(base);
    let numberToBeFormatted;
    const computeExponent = (numeric, units) => {
        const max = units.length - 1;
        const exp = new BigNumber(Math.log(numeric.toNumber()))
            .div(Math.log(base))
            .integerValue(BigNumber.ROUND_DOWN)
            .toNumber();
        return Math.min(max, exp);
    };
    const storageUnitKey = (units) => {
        const keyEnd = smallerThanBase ? "byte" : units[exponent];
        return `number.human.storage_units.units.${keyEnd}`;
    };
    const exponent = computeExponent(num, STORAGE_UNITS);
    if (smallerThanBase) {
        numberToBeFormatted = num.integerValue();
    }
    else {
        numberToBeFormatted = new BigNumber(roundNumber(num.div(Math.pow(base, exponent)), {
            significant: options.significant,
            precision: options.precision,
            roundMode: options.roundMode,
        }));
    }
    const format = i18n.translate("number.human.storage_units.format", {
        defaultValue: "%n %u",
    });
    const unit = i18n.translate(storageUnitKey(STORAGE_UNITS), {
        count: num.integerValue().toNumber(),
    });
    let formattedNumber = numberToBeFormatted.toFixed(options.precision, roundMode);
    if (options.stripInsignificantZeros) {
        formattedNumber = formattedNumber
            .replace(/(\..*?)0+$/, "$1")
            .replace(/\.$/, "");
    }
    return format.replace("%n", formattedNumber).replace("%u", unit);
}

function parseDate(input) {
    if (input instanceof Date) {
        return input;
    }
    if (typeof input === "number") {
        const date = new Date();
        date.setTime(input);
        return date;
    }
    const matches = new String(input).match(/(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}):(\d{2})(?:[.,](\d{1,3}))?)?(Z|\+00:?00)?/);
    if (matches) {
        const parts = matches.slice(1, 8).map((match) => parseInt(match, 10) || 0);
        parts[1] -= 1;
        const [year, month, day, hour, minute, second, milliseconds] = parts;
        const timezone = matches[8];
        if (timezone) {
            return new Date(Date.UTC(year, month, day, hour, minute, second, milliseconds));
        }
        else {
            return new Date(year, month, day, hour, minute, second, milliseconds);
        }
    }
    if (input.match(/([A-Z][a-z]{2}) ([A-Z][a-z]{2}) (\d+) (\d+:\d+:\d+) ([+-]\d+) (\d+)/)) {
        const date = new Date();
        date.setTime(Date.parse([RegExp.$1, RegExp.$2, RegExp.$3, RegExp.$6, RegExp.$4, RegExp.$5].join(" ")));
    }
    const date = new Date();
    date.setTime(Date.parse(input));
    return date;
}

function pluralize({ i18n, count, scope, options, baseScope, }) {
    options = Object.assign({}, options);
    let translations;
    let message;
    if (typeof scope === "object" && scope) {
        translations = scope;
    }
    else {
        translations = lookup(i18n, scope, options);
    }
    if (!translations) {
        return i18n.missingTranslation.get(scope, options);
    }
    const pluralizer = i18n.pluralization.get(options.locale);
    const keys = pluralizer(i18n, count);
    const missingKeys = [];
    while (keys.length) {
        const key = keys.shift();
        if (isSet(translations[key])) {
            message = translations[key];
            break;
        }
        missingKeys.push(key);
    }
    if (!isSet(message)) {
        return i18n.missingTranslation.get(baseScope.split(i18n.defaultSeparator).concat([missingKeys[0]]), options);
    }
    options.count = count;
    return i18n.interpolate(i18n, message, options);
}

const DEFAULT_OPTIONS = {
    meridian: { am: "AM", pm: "PM" },
    dayNames: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
    ],
    abbrDayNames: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    monthNames: [
        null,
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ],
    abbrMonthNames: [
        null,
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ],
};
function strftime(date, format, options = {}) {
    const { abbrDayNames, dayNames, abbrMonthNames, monthNames, meridian: AM_PM, } = Object.assign(Object.assign({}, DEFAULT_OPTIONS), options);
    if (isNaN(date.getTime())) {
        throw new Error("strftime() requires a valid date object, but received an invalid date.");
    }
    const weekDay = date.getDay();
    const day = date.getDate();
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const hour = date.getHours();
    let hour12 = hour;
    const meridian = hour > 11 ? "pm" : "am";
    const secs = date.getSeconds();
    const mins = date.getMinutes();
    const offset = date.getTimezoneOffset();
    const absOffsetHours = Math.floor(Math.abs(offset / 60));
    const absOffsetMinutes = Math.abs(offset) - absOffsetHours * 60;
    const timezoneoffset = (offset > 0 ? "-" : "+") +
        (absOffsetHours.toString().length < 2
            ? "0" + absOffsetHours
            : absOffsetHours) +
        (absOffsetMinutes.toString().length < 2
            ? "0" + absOffsetMinutes
            : absOffsetMinutes);
    if (hour12 > 12) {
        hour12 = hour12 - 12;
    }
    else if (hour12 === 0) {
        hour12 = 12;
    }
    format = format.replace("%a", abbrDayNames[weekDay]);
    format = format.replace("%A", dayNames[weekDay]);
    format = format.replace("%b", abbrMonthNames[month]);
    format = format.replace("%B", monthNames[month]);
    format = format.replace("%d", day.toString().padStart(2, "0"));
    format = format.replace("%e", day.toString());
    format = format.replace("%-d", day.toString());
    format = format.replace("%H", hour.toString().padStart(2, "0"));
    format = format.replace("%-H", hour.toString());
    format = format.replace("%k", hour.toString());
    format = format.replace("%I", hour12.toString().padStart(2, "0"));
    format = format.replace("%-I", hour12.toString());
    format = format.replace("%l", hour12.toString());
    format = format.replace("%m", month.toString().padStart(2, "0"));
    format = format.replace("%-m", month.toString());
    format = format.replace("%M", mins.toString().padStart(2, "0"));
    format = format.replace("%-M", mins.toString());
    format = format.replace("%p", AM_PM[meridian]);
    format = format.replace("%P", AM_PM[meridian].toLowerCase());
    format = format.replace("%S", secs.toString().padStart(2, "0"));
    format = format.replace("%-S", secs.toString());
    format = format.replace("%w", weekDay.toString());
    format = format.replace("%y", year.toString().padStart(2, "0").substr(-2));
    format = format.replace("%-y", year.toString().padStart(2, "0").substr(-2).replace(/^0+/, ""));
    format = format.replace("%Y", year.toString());
    format = format.replace(/%z/i, timezoneoffset);
    return format;
}

/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange$1(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

var _baseRange = baseRange$1;

var baseRange = _baseRange,
    isIterateeCall = _isIterateeCall,
    toFinite = toFinite_1;

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange$1(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

var _createRange = createRange$1;

var createRange = _createRange;

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

var range_1 = range;

var range$1 = /*@__PURE__*/getDefaultExportFromCjs(range_1);

const within = (start, end, actual) => actual >= start && actual <= end;
function timeAgoInWords(i18n, fromTime, toTime, options = {}) {
    const scope = options.scope || "datetime.distance_in_words";
    const t = (name, count = 0) => i18n.t(name, { count, scope });
    fromTime = parseDate(fromTime);
    toTime = parseDate(toTime);
    let fromInSeconds = fromTime.getTime() / 1000;
    let toInSeconds = toTime.getTime() / 1000;
    if (fromInSeconds > toInSeconds) {
        [fromTime, toTime, fromInSeconds, toInSeconds] = [
            toTime,
            fromTime,
            toInSeconds,
            fromInSeconds,
        ];
    }
    const distanceInSeconds = Math.round(toInSeconds - fromInSeconds);
    const distanceInMinutes = Math.round((toInSeconds - fromInSeconds) / 60);
    const distanceInHours = distanceInMinutes / 60;
    const distanceInDays = distanceInHours / 24;
    const distanceInHoursRounded = Math.round(distanceInMinutes / 60);
    const distanceInDaysRounded = Math.round(distanceInDays);
    const distanceInMonthsRounded = Math.round(distanceInDaysRounded / 30);
    if (within(0, 1, distanceInMinutes)) {
        if (!options.includeSeconds) {
            return distanceInMinutes === 0
                ? t("less_than_x_minutes", 1)
                : t("x_minutes", distanceInMinutes);
        }
        if (within(0, 4, distanceInSeconds)) {
            return t("less_than_x_seconds", 5);
        }
        if (within(5, 9, distanceInSeconds)) {
            return t("less_than_x_seconds", 10);
        }
        if (within(10, 19, distanceInSeconds)) {
            return t("less_than_x_seconds", 20);
        }
        if (within(20, 39, distanceInSeconds)) {
            return t("half_a_minute");
        }
        if (within(40, 59, distanceInSeconds)) {
            return t("less_than_x_minutes", 1);
        }
        return t("x_minutes", 1);
    }
    if (within(2, 44, distanceInMinutes)) {
        return t("x_minutes", distanceInMinutes);
    }
    if (within(45, 89, distanceInMinutes)) {
        return t("about_x_hours", 1);
    }
    if (within(90, 1439, distanceInMinutes)) {
        return t("about_x_hours", distanceInHoursRounded);
    }
    if (within(1440, 2519, distanceInMinutes)) {
        return t("x_days", 1);
    }
    if (within(2520, 43199, distanceInMinutes)) {
        return t("x_days", distanceInDaysRounded);
    }
    if (within(43200, 86399, distanceInMinutes)) {
        return t("about_x_months", Math.round(distanceInMinutes / 43200));
    }
    if (within(86400, 525599, distanceInMinutes)) {
        return t("x_months", distanceInMonthsRounded);
    }
    let fromYear = fromTime.getFullYear();
    if (fromTime.getMonth() + 1 >= 3) {
        fromYear += 1;
    }
    let toYear = toTime.getFullYear();
    if (toTime.getMonth() + 1 < 3) {
        toYear -= 1;
    }
    const leapYears = fromYear > toYear
        ? 0
        : range$1(fromYear, toYear).filter((year) => new Date(year, 1, 29).getMonth() == 1).length;
    const minutesInYear = 525600;
    const minuteOffsetForLeapYear = leapYears * 1440;
    const minutesWithOffset = distanceInMinutes - minuteOffsetForLeapYear;
    const distanceInYears = Math.trunc(minutesWithOffset / minutesInYear);
    const diff = parseFloat((minutesWithOffset / minutesInYear - distanceInYears).toPrecision(3));
    if (diff < 0.25) {
        return t("about_x_years", distanceInYears);
    }
    if (diff < 0.75) {
        return t("over_x_years", distanceInYears);
    }
    return t("almost_x_years", distanceInYears + 1);
}

const guessStrategy = function (i18n, scope) {
    if (scope instanceof Array) {
        scope = scope.join(i18n.defaultSeparator);
    }
    const message = scope.split(i18n.defaultSeparator).slice(-1)[0];
    return (i18n.missingTranslationPrefix +
        message
            .replace("_", " ")
            .replace(/([a-z])([A-Z])/g, (_match, p1, p2) => `${p1} ${p2.toLowerCase()}`));
};
const messageStrategy = (i18n, scope, options) => {
    const fullScope = getFullScope(i18n, scope, options);
    const locale = "locale" in options ? options.locale : i18n.locale;
    const localeType = inferType(locale);
    const fullScopeWithLocale = [
        localeType == "string" ? locale : localeType,
        fullScope,
    ].join(i18n.defaultSeparator);
    return `[missing "${fullScopeWithLocale}" translation]`;
};
const errorStrategy = (i18n, scope, options) => {
    const fullScope = getFullScope(i18n, scope, options);
    const fullScopeWithLocale = [i18n.locale, fullScope].join(i18n.defaultSeparator);
    throw new Error(`Missing translation: ${fullScopeWithLocale}`);
};
class MissingTranslation {
    constructor(i18n) {
        this.i18n = i18n;
        this.registry = {};
        this.register("guess", guessStrategy);
        this.register("message", messageStrategy);
        this.register("error", errorStrategy);
    }
    register(name, strategy) {
        this.registry[name] = strategy;
    }
    get(scope, options) {
        var _a;
        return this.registry[(_a = options.missingBehavior) !== null && _a !== void 0 ? _a : this.i18n.missingBehavior](this.i18n, scope, options);
    }
}

var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const DEFAULT_I18N_OPTIONS = {
    defaultLocale: "en",
    availableLocales: ["en"],
    locale: "en",
    defaultSeparator: ".",
    placeholder: /(?:\{\{|%\{)(.*?)(?:\}\}?)/gm,
    enableFallback: false,
    missingBehavior: "message",
    missingTranslationPrefix: "",
    missingPlaceholder: (_i18n, placeholder) => `[missing "${placeholder}" value]`,
    nullPlaceholder: (i18n, placeholder, message, options) => i18n.missingPlaceholder(i18n, placeholder, message, options),
    transformKey: (key) => key,
};
class I18n {
    constructor(translations = {}, options = {}) {
        this._locale = DEFAULT_I18N_OPTIONS.locale;
        this._defaultLocale = DEFAULT_I18N_OPTIONS.defaultLocale;
        this._version = 0;
        this.onChangeHandlers = [];
        this.translations = {};
        this.availableLocales = [];
        this.t = this.translate;
        this.p = this.pluralize;
        this.l = this.localize;
        this.distanceOfTimeInWords = this.timeAgoInWords;
        const { locale, enableFallback, missingBehavior, missingTranslationPrefix, missingPlaceholder, nullPlaceholder, defaultLocale, defaultSeparator, placeholder, transformKey, } = Object.assign(Object.assign({}, DEFAULT_I18N_OPTIONS), options);
        this.locale = locale;
        this.defaultLocale = defaultLocale;
        this.defaultSeparator = defaultSeparator;
        this.enableFallback = enableFallback;
        this.locale = locale;
        this.missingBehavior = missingBehavior;
        this.missingTranslationPrefix = missingTranslationPrefix;
        this.missingPlaceholder = missingPlaceholder;
        this.nullPlaceholder = nullPlaceholder;
        this.placeholder = placeholder;
        this.pluralization = new Pluralization(this);
        this.locales = new Locales(this);
        this.missingTranslation = new MissingTranslation(this);
        this.transformKey = transformKey;
        this.interpolate = interpolate;
        this.store(translations);
    }
    store(translations) {
        merge$2(this.translations, translations);
        this.hasChanged();
    }
    get locale() {
        return this._locale || this.defaultLocale || "en";
    }
    set locale(newLocale) {
        if (typeof newLocale !== "string") {
            throw new Error(`Expected newLocale to be a string; got ${inferType(newLocale)}`);
        }
        const changed = this._locale !== newLocale;
        this._locale = newLocale;
        if (changed) {
            this.hasChanged();
        }
    }
    get defaultLocale() {
        return this._defaultLocale || "en";
    }
    set defaultLocale(newLocale) {
        if (typeof newLocale !== "string") {
            throw new Error(`Expected newLocale to be a string; got ${inferType(newLocale)}`);
        }
        const changed = this._defaultLocale !== newLocale;
        this._defaultLocale = newLocale;
        if (changed) {
            this.hasChanged();
        }
    }
    translate(scope, options) {
        options = Object.assign({}, options);
        const translationOptions = createTranslationOptions(this, scope, options);
        let translation;
        const hasFoundTranslation = translationOptions.some((translationOption) => {
            if (isSet(translationOption.scope)) {
                translation = lookup(this, translationOption.scope, options);
            }
            else if (isSet(translationOption.message)) {
                translation = translationOption.message;
            }
            return translation !== undefined && translation !== null;
        });
        if (!hasFoundTranslation) {
            return this.missingTranslation.get(scope, options);
        }
        if (typeof translation === "string") {
            translation = this.interpolate(this, translation, options);
        }
        else if (typeof translation === "object" &&
            translation &&
            isSet(options.count)) {
            translation = pluralize({
                i18n: this,
                count: options.count || 0,
                scope: translation,
                options,
                baseScope: getFullScope(this, scope, options),
            });
        }
        if (options && translation instanceof Array) {
            translation = translation.map((entry) => typeof entry === "string"
                ? interpolate(this, entry, options)
                : entry);
        }
        return translation;
    }
    pluralize(count, scope, options) {
        return pluralize({
            i18n: this,
            count,
            scope,
            options: Object.assign({}, options),
            baseScope: getFullScope(this, scope, options !== null && options !== void 0 ? options : {}),
        });
    }
    localize(type, value, options) {
        options = Object.assign({}, options);
        if (value === undefined || value === null) {
            return "";
        }
        switch (type) {
            case "currency":
                return this.numberToCurrency(value);
            case "number":
                return formatNumber(value, Object.assign({ delimiter: ",", precision: 3, separator: ".", significant: false, stripInsignificantZeros: false }, lookup(this, "number.format")));
            case "percentage":
                return this.numberToPercentage(value);
            default: {
                let localizedValue;
                if (type.match(/^(date|time)/)) {
                    localizedValue = this.toTime(type, value);
                }
                else {
                    localizedValue = value.toString();
                }
                return interpolate(this, localizedValue, options);
            }
        }
    }
    toTime(scope, input) {
        const date = parseDate(input);
        const format = lookup(this, scope);
        if (date.toString().match(/invalid/i)) {
            return date.toString();
        }
        if (!format) {
            return date.toString();
        }
        return this.strftime(date, format);
    }
    numberToCurrency(input, options = {}) {
        return formatNumber(input, Object.assign(Object.assign(Object.assign({ delimiter: ",", format: "%u%n", precision: 2, separator: ".", significant: false, stripInsignificantZeros: false, unit: "$" }, camelCaseKeys(this.get("number.format"))), camelCaseKeys(this.get("number.currency.format"))), options));
    }
    numberToPercentage(input, options = {}) {
        return formatNumber(input, Object.assign(Object.assign(Object.assign({ delimiter: "", format: "%n%", precision: 3, stripInsignificantZeros: false, separator: ".", significant: false }, camelCaseKeys(this.get("number.format"))), camelCaseKeys(this.get("number.percentage.format"))), options));
    }
    numberToHumanSize(input, options = {}) {
        return numberToHumanSize(this, input, Object.assign(Object.assign(Object.assign({ delimiter: "", precision: 3, significant: true, stripInsignificantZeros: true, units: {
                billion: "Billion",
                million: "Million",
                quadrillion: "Quadrillion",
                thousand: "Thousand",
                trillion: "Trillion",
                unit: "",
            } }, camelCaseKeys(this.get("number.human.format"))), camelCaseKeys(this.get("number.human.storage_units"))), options));
    }
    numberToHuman(input, options = {}) {
        return numberToHuman(this, input, Object.assign(Object.assign(Object.assign({ delimiter: "", separator: ".", precision: 3, significant: true, stripInsignificantZeros: true, format: "%n %u", roundMode: "default", units: {
                billion: "Billion",
                million: "Million",
                quadrillion: "Quadrillion",
                thousand: "Thousand",
                trillion: "Trillion",
                unit: "",
            } }, camelCaseKeys(this.get("number.human.format"))), camelCaseKeys(this.get("number.human.decimal_units"))), options));
    }
    numberToRounded(input, options) {
        return formatNumber(input, Object.assign({ unit: "", precision: 3, significant: false, separator: ".", delimiter: "", stripInsignificantZeros: false }, options));
    }
    numberToDelimited(input, options = {}) {
        return numberToDelimited(input, Object.assign({ delimiterPattern: /(\d)(?=(\d\d\d)+(?!\d))/g, delimiter: ",", separator: "." }, options));
    }
    withLocale(locale, callback) {
        return __awaiter(this, void 0, void 0, function* () {
            const originalLocale = this.locale;
            try {
                this.locale = locale;
                yield callback();
            }
            finally {
                this.locale = originalLocale;
            }
        });
    }
    strftime(date, format, options = {}) {
        return strftime(date, format, Object.assign(Object.assign(Object.assign({}, camelCaseKeys(lookup(this, "date"))), { meridian: {
                am: lookup(this, "time.am") || "AM",
                pm: lookup(this, "time.pm") || "PM",
            } }), options));
    }
    update(path, override, options = { strict: false }) {
        if (options.strict && !has$1(this.translations, path)) {
            throw new Error(`The path "${path}" is not currently defined`);
        }
        const currentNode = get$2(this.translations, path);
        const currentType = inferType(currentNode);
        const overrideType = inferType(override);
        if (options.strict && currentType !== overrideType) {
            throw new Error(`The current type for "${path}" is "${currentType}", but you're trying to override it with "${overrideType}"`);
        }
        let newNode;
        if (overrideType === "object") {
            newNode = Object.assign(Object.assign({}, currentNode), override);
        }
        else {
            newNode = override;
        }
        const components = path.split(this.defaultSeparator);
        const prop = components.pop();
        let buffer = this.translations;
        for (const component of components) {
            if (!buffer[component]) {
                buffer[component] = {};
            }
            buffer = buffer[component];
        }
        buffer[prop] = newNode;
        this.hasChanged();
    }
    toSentence(items, options = {}) {
        const { wordsConnector, twoWordsConnector, lastWordConnector } = Object.assign(Object.assign({ wordsConnector: ", ", twoWordsConnector: " and ", lastWordConnector: ", and " }, camelCaseKeys(lookup(this, "support.array"))), options);
        const size = items.length;
        switch (size) {
            case 0:
                return "";
            case 1:
                return `${items[0]}`;
            case 2:
                return items.join(twoWordsConnector);
            default:
                return [
                    items.slice(0, size - 1).join(wordsConnector),
                    lastWordConnector,
                    items[size - 1],
                ].join("");
        }
    }
    timeAgoInWords(fromTime, toTime, options = {}) {
        return timeAgoInWords(this, fromTime, toTime, options);
    }
    onChange(callback) {
        this.onChangeHandlers.push(callback);
        return () => {
            this.onChangeHandlers.splice(this.onChangeHandlers.indexOf(callback), 1);
        };
    }
    get version() {
        return this._version;
    }
    formatNumber(input, options = {}) {
        options = Object.assign(Object.assign({ delimiter: ",", precision: 3, separator: ".", unit: "", format: "%u%n", significant: false, stripInsignificantZeros: false }, camelCaseKeys(this.get("number.format"))), options);
        return formatNumber(input, options);
    }
    get(scope) {
        return lookup(this, scope);
    }
    runCallbacks() {
        this.onChangeHandlers.forEach((callback) => callback(this));
    }
    hasChanged() {
        this._version += 1;
        this.runCallbacks();
    }
}

const da = {};

const de$1 = {};

const el = {};

const en = {
    // Login/Reset Password
    "login_title_text": 'Login',
    "email": 'Email',
    "password": 'Password',
    "sign_in": 'Sign In',
    "continue": 'Continue',
    "try_again": 'Try Again',
    "login_error_message": 'We were not able to find your user. You may try again or contact your account manager.',
    "invalid_login_credentials_error_message": 'Wrong username and password combination or the user does not exist.',
    "forgot_password": 'Forgot Password',
    "reset_password": 'Reset Password',
    "reset_password_instructions": "To reset your password, enter your email address above and we'll send instructions, if the account exists.",
    "sent_reset_password_code": 'We sent a password reset code to [email] Enter that code and a new password.',
    "enter_password_reset_code": "Please enter the code we sent to the account [email]. ",
    "repeat-new-password": "Repeat New Password",
    "reset_code": 'Reset Code',
    "new_password": 'New Password',
    "reenter_new_password": 'Re-enter New Password',
    "must_include_email": 'Must include email',
    "old_password": 'Old Password',
    "set_new_password": 'Set New Password',
    "password_expired": 'Password Expired',
    "toggle_password_visibility": 'Toggle password visibility',
    "change_your_password": 'Change Your Password',
    "change_password": 'Change Password',
    "set_password": 'Set Password',
    "already_have_reset_code": 'I already have a reset code',
    "confirm_password": 'Confirm Password',
    "idle_logged_out_warning": 'You are idle, and will be logged out in 10 seconds',
    "logged_out": 'You have been logged out',
    "send-code": "Send code",
    "okta-sign-in": "Sign in with Okta",
    "google-sign-in": "Sign in with  Google",
    "microsoft-sign-in": "Sign in with  Microsoft",
    "or": "or",
    "contact_manager_for_account": "For new accounts please contact your manager",
    // ListUsers
    "search_enter_4_chars": 'Please enter at least 4 characters to search',
    "user_search_placeholder_email": 'Search for the start of an email',
    "user_search_placeholder": 'Search for the start of an email, manager, or group',
    "no_users_found": 'No users found',
    // Sidebar
    "users": 'Users',
    "main_settings": 'Main Settings',
    "terminology": 'Terminology',
    "equipment": 'Equipment',
    "security": 'Security',
    "tenants": 'Tenants',
    "collapse": 'Collapse',
    // Users List
    "add_user": 'Add User',
    "edit_user": 'Edit User',
    "bulk_import": 'Bulk Import',
    "bulk_import_users": 'Bulk Import Users',
    "add_group": 'Add Group',
    "manage_users": 'Manage Users',
    "manage_groups": 'Manage Group',
    "show_roles_list": 'Show Roles List',
    "show_disabled_users": 'Show Disabled Users',
    "name": 'Name',
    "role": 'Role',
    "roles": 'Roles',
    "role_name": 'Role Name',
    "role_description": 'Role Description',
    "role_id": 'Role ID',
    "location": 'Location',
    "routethis_group": 'RouteThis Group',
    "manager": 'Manager',
    "download_bulk_template": 'Download Bulk Template',
    "user_id_email": 'User ID (email)',
    "users_for": 'Users for:',
    // Valid User roles
    "user_role": 'user',
    "tenant_admin_role": 'TenantAdmin',
    "super_admin_role": 'SuperAdmin',
    "user": 'User',
    "tenant_admin": 'Tenant Admin',
    "super_admin": 'Super Admin',
    // Create/Edit User Modal
    "create_user": 'Create User',
    "email_required": 'Email (Required)',
    "first_name": 'First Name',
    "last_name": 'Last Name',
    "force_password_reset": 'Force Password Reset',
    "resend_welcome_email": 'Resend Welcome Email',
    "resend_validation_code": 'Resend Validation Code',
    "enable_users": 'Enable Users',
    "disable_users": 'Disable Users',
    "certify": 'Certify',
    "unverified": 'Unverified',
    "verified": 'Verified',
    "locked_out": 'Locked Out',
    "disabled": 'Disabled',
    "save": 'Save',
    "reset_user_password_confirmation": "Are you sure you want to reset this user's password?",
    "resend_validation_code_confirmation": 'Are you sure you want to resend validation code?',
    "cannot_disable_yourself": 'Cannot disable yourself',
    "cancel_changes": 'Cancel changes',
    "required": 'Required',
    "password_email_template": 'Password e-mail template',
    "include_in_resolve_usage_reports": 'Include in Resolve Usage Reports',
    "delete_user": 'Delete User',
    "delete_are_you_sure": "Are you sure you want to delete this user? WARNING : This action is irreversible.",
    "delete": "Delete",
    // Create Edit Group modal
    "create_group": "Create Group",
    "edit_group": "Edit Group",
    "group_name": "Group Name",
    "group_type": "Group Type",
    "search_by_group_name": "Search By Group Name",
    "search_by_role_name": "Search By Role Name",
    // Snackbar Messages
    "snackbar_disable_success": 'Successfully disabled user:',
    "snackbar_disable_error": 'Error disabling user:',
    "snackbar_enable_success": 'Successfully enabled user:',
    "snackbar_enable_error": 'Error enabling user:',
    "snackbar_password_reset_success": 'Successfully reset the password for user:',
    "snackbar_password_reset_error": 'Error resetting the password for user:',
    // Bulk Import Modal
    "csv_format_requirements": 'Your CSV Format needs to be formatted properly. If you are unsure of the format You can also',
    "csv_format_download_link": 'download a template file here.',
    "csv_format_error": "We couldn't process your uploaded file, please ensure that your file is in the correct format and includes the 'email' and 'manager_0' headers.",
    "select_csv": 'Browse CSV file',
    "import": 'Import',
    "file_too_large": 'File too large (Maximum of IMPORT_LIMIT users)',
    "required_headers_missing": 'Required headers missing: email',
    "user_import_starting": 'User import starting. You will receive an import summary email in a few minutes.',
    "change_file": 'Change File',
    "invalid_email_error": 'Email contains invalid characters',
    // Bulk Import Messaging
    "bulk_processing_1": 'We are processing the file:',
    "bulk_processing_2": "As soon as we're done, we'll send you an email with all the details.",
    "bulk_complete_1": "Completed:",
    "bulk_complete_2": "is now uploaded.",
    "bulk_error": "An error occurred and your file did not upload to the server. Please check your email for details.",
    "bulk_thanks_header": 'Thanks for uploading your file!',
    "bulk_thanks_content": "We're working on processing it now, and as soon as we're done, we'll send you an email with all the details. You can also keep an eye on the app for updates on you file's status.",
    // Tenant Main Settings
    "email_language": 'Email Language',
    "country": 'Country',
    "description_optional": 'Description (Optional)',
    "units_feet_meters": 'Units (Feet, Meters)',
    "certify_id": 'Certify ID',
    "resolve_id": 'Resolve ID',
    "sms_from": 'SMS From',
    "sms_body": 'SMS Body',
    "default_sms_body": 'Your WiFi installation is complete and has been certified by [NAME]! \n View your certificate here: [LINK]',
    "sms_body_helper_text": 'Certify will text this message to the customer. [LINK] will be replaced with a link to the certificate (required). [NAME] will be replaced with the contents of the Name field (optional)',
    "link_must_be_in_sms_body": '[LINK] must be in the SMS body.',
    "update_successful": 'Update Successful',
    "creation_successful": 'Creation Successful',
    // Tenant Terminology Settings
    "term": 'Term',
    "example_usage": 'Example Usage',
    "customer_example_usage_1": 'In consultation with the customer, confirm the selected building, or go back to edit the address.',
    "customer_example_usage_2": 'In consultation with the subscriber, confirm the selected building, or go back to edit the address.',
    "router_example_usage_1": 'Tap the proposed router location below.',
    "router_example_usage_2": 'Tap the proposed modem location below.',
    "router_example_usage_3": 'Tap the proposed gateway location below.',
    "router_example_usage_4": 'Tap the proposed hub location below.',
    "router_example_usage_5": 'Tap the proposed internet box location below.',
    "level_example_usage_1": 'Go to level 2 and tap your location.',
    "level_example_usage_2": 'Go to floor 2 and tap your location.',
    "mesh_pod_example_usage_1": 'Estimating signal strength and optimum mesh pod placement.',
    "mesh_pod_example_usage_2": 'Estimating signal strength and optimum access point placement.',
    "mesh_pod_example_usage_3": 'Estimating signal strength and optimum mesh node placement.',
    "mesh_pod_example_usage_4": 'Estimating signal strength and optimum mesh puck placement.',
    "mesh_pod_example_usage_5": 'Estimating signal strength and optimum beacon placement.',
    "mesh_pod_example_usage_6": 'Estimating signal strength and optimum range extender placement.',
    "mesh_pod_example_usage_7": 'Estimating signal strength and optimum booster placement.',
    "wifi_example_usage_1": 'WiFi Mapping',
    "wifi_example_usage_2": 'Wi-Fi Mapping',
    "wifi_example_usage_3": 'Wifi Mapping',
    "wifi_example_usage_4": 'WIFI Mapping',
    // Tenant Equipment Settings (Certify)
    "router_options_1": 'Router Options',
    "router_options_2": 'Modem Options',
    "router_options_3": 'Gateway Options',
    "router_options_4": 'Hub Options',
    "router_options_5": 'Internet Box Options',
    "new_router_options_1": 'New Router Options',
    "new_router_options_2": 'New Modem Options',
    "new_router_options_3": 'New Gateway Options',
    "new_router_options_4": 'New Hub Options',
    "new_router_options_5": 'New Internet Box Options',
    "mesh_pod_options_1": 'Mesh Pod Options',
    "mesh_pod_options_2": 'Access Point Options',
    "mesh_pod_options_3": 'Mesh Node Options',
    "mesh_pod_options_4": 'Mesh Puck Options',
    "mesh_pod_options_5": 'Beacon Options',
    "mesh_pod_options_6": 'Range Extender Options',
    "mesh_pod_options_7": 'Booster Options',
    "new_mesh_pod_options_1": 'New Mesh Pod Options',
    "new_mesh_pod_options_2": 'New Access Point Options',
    "new_mesh_pod_options_3": 'New Mesh Node Options',
    "new_mesh_pod_options_4": 'New Mesh Puck Options',
    "new_mesh_pod_options_5": 'New Beacon Options',
    "new_mesh_pod_options_6": 'New Range Extender Options',
    "new_mesh_pod_options_7": 'New Booster Options',
    "missing_required_router_info_1": 'Missing Required Router Info',
    "missing_required_router_info_2": 'Missing Required Modem Info',
    "missing_required_router_info_3": 'Missing Required Gateway Info',
    "missing_required_router_info_4": 'Missing Required Hub Info',
    "missing_required_router_info_5": 'Missing Required Internet Box Info',
    "missing_required_mesh_pod_info_1": 'Missing Required Mesh Pod Info',
    "missing_required_mesh_pod_info_2": 'Missing Required Access Point Info',
    "missing_required_mesh_pod_info_3": 'Missing Required Mesh Node Info',
    "missing_required_mesh_pod_info_4": 'Missing Required Mesh Puck Info',
    "missing_required_mesh_pod_info_5": 'Missing Required Beacon Info',
    "missing_required_mesh_pod_info_6": 'Missing Required Range Extender Info',
    "missing_required_mesh_pod_info_7": 'Missing Required Booster Info',
    "display_name": 'Display Name',
    "description": 'Description',
    "range_in_unit_1": 'Range in Feet',
    "range_in_unit_2": 'Range in Meters',
    "area_in_unit_1": 'Area in Square Feet',
    "area_in_unit_2": 'Area in Square Meters',
    "default_active": 'Default Active',
    "average_range": 'Average Range',
    "certify_default": 'Certify default',
    "default": 'Default',
    "active": 'Active',
    "one_option_must_be_default": 'One option must be default',
    "set_as_default": 'Set as default',
    "default_option_must_be_active": 'Default option must be active',
    "deactivate": 'Deactivate',
    "activate": 'Activate',
    "name_is_required": 'Name is required',
    "show_terminology_fields": 'Show Certify Terminology Fields',
    // Customer Name
    "customer_1": "Customer",
    "customer_2": "Subscriber",
    // Pod Name
    "pod_1": "Mesh Pod",
    "pod_2": "Access Point",
    "pod_3": "Mesh Node",
    "pod_4": "Mesh Puck",
    "pod_5": "Beacon",
    "pod_6": "Range Extender",
    "pod_7": 'Booster',
    "pods_1": "Mesh Pods",
    "pods_2": "Access Points",
    "pods_3": "Mesh Nodes",
    "pods_4": "Mesh Pucks",
    "pods_5": "Beacons",
    "pods_6": "Range Extenders",
    "pods_7": 'Boosters',
    // Router Name
    "router_1": "Router",
    "router_2": "Modem",
    "router_3": "Gateway",
    "router_4": "Hub",
    "router_5": "Internet Box",
    // Level Name
    "level_1": "Level",
    "level_2": "Floor",
    "levels_1": "Levels",
    "levels_2": "Floors",
    // Wifi Name
    "wifi_1": 'WiFi',
    "wifi_2": 'Wi-Fi',
    "wifi_3": 'Wifi',
    "wifi_4": 'WIFI',
    // Units
    "units_1": 'Feet',
    "units_2": 'Meters',
    // Pod Info
    "recommended": "Recommended",
    "installed": "Installed",
    "total": "Total",
    // Platform Fields
    "platform": 'Platform',
    // Misc
    "confirm": 'Confirm',
    "units": 'Units',
    "region": 'Region',
    "edit": 'Edit',
    "modified": 'Modified',
    "create": 'Create',
    "created": 'Created',
    "routethis_app": 'RouteThis App',
    "loading": 'Loading...',
    "redirecting": 'Redirecting...',
    "error": 'Error',
    "cancel": 'Cancel',
    "close": 'Close',
    "edit_user_x": 'Edit user [X]',
    "search": 'Search',
    "all": 'All',
    "dismiss": 'DISMISS',
    "account_holder": 'Account Holder',
    "unauthenticated_login_again": "Unauthenticated. Please log in again.",
    // HelpDropdown
    "need_help": 'Need Help?',
    "knowledge_base": 'Knowledge Base',
    "contact_us": 'Contact Us',
    // UserDropdown
    "hello": 'Hello',
    "sign_out": 'Sign Out',
    // Languages
    "en": 'English (US)',
    'en-GB': 'English (GB)',
    "da": 'Danish',
    "fi": 'Finnish',
    "fr": 'French',
    'fr-CA': 'French (Canada)',
    "de": 'German',
    "el": 'Greek',
    "it": 'Italian',
    "pt": 'Portuguese',
    'pt-BR': 'Portuguese (Brazil',
    "es": 'Spanish',
    'es-419': 'Spanish (Latin America)',
    "sv": 'Swedish',
    // Client-side validation errors
    "incorrect_email_or_password": 'Incorrect email or password, or disabled account. Try again or contact an administrator.',
    "invalid_reset_code": 'Invalid reset code',
    "password_minimum_requirements": 'Your password must be a minimum of 8 characters and include at least one lowercase, one uppercase, and one numeric character.',
    "password_minimum_requirements_shortened": 'Minimum 8 characters, one uppercase, and one numeric',
    "passwords_must_match": 'Passwords must match',
    "must_include_new_password_email": 'Must include new password and user email',
    "must_include_new_password_confirmation_code": 'Must include new password and confirmationCode',
    "cannot_send_reset_code_without_email": 'Cannot send reset code without email',
    "must_enter_old_password": 'Must enter Old Password',
    "must_enter_reset_code": 'Must enter Reset Code',
    "must_enter_new_password": 'Must enter New Password',
    "passwords_cannot_begin_or_end_with_spaces": 'Passwords cannot begin or end with spaces',
    // Server-side errors
    'User with that email already exists': "User with that email already exists",
    'Try another display name': "Try another display name",
    'Password cannot be a previously used password': "Password cannot be a previously used password",
    'Invalid reset code': "Invalid reset code",
    'Incorrect email or password, or disabled account. Try again or contact an administrator.': "Incorrect email or password, or disabled account. Try again or contact an administrator.",
    'Invalid code provided, please request a code again.': 'Invalid code provided, please request a code again.',
    'Password cannot begin or end with spaces': "Password cannot begin or end with spaces",
    'LimitExceededException - Attempt limit exceeded, please try after some time.': "LimitExceededException - Attempt limit exceeded, please try after some time.",
    'User is not Authorized': "User is not Authorized",
    'Your session timed out. Sign in again with your temporary password.': "Your session timed out. Sign in again with your temporary password.",
    'Internal Service Failure - Cognito Unavailable': "Internal Service Failure - Cognito Unavailable",
    'Internal Service Failure - Unknown Failure': "Internal Service Failure - Unknown Failure",
    'Must enter Reset Code': 'Must enter Reset Code',
    // Change Password Challenges
    "step_1_of_2": 'Step 1 of 2',
    "step_2_of_2": 'Step 2 of 2',
    "set_password_challenge": 'You must set a new password the first time you sign in for security purposes.',
    "reset_password_challenge": 'We sent a password reset code to [EMAIL]. Enter that code and a new password.',
    "reset_password_challenge_instructions": 'We will send to the account [EMAIL] a reset code and further instructions to create a new password.',
    "set_new_password_challenge": 'Your company&apos;s policy requires that your password expires after some time. We sent a password reset code to [EMAIL]. Enter that code and a new password.',
    "change_your_password_challenge": 'Enter your current password and a new password below to change it.',
    "change_password_challenge": 'Enter a new password for the user',
    AF: 'Afghanistan',
    AX: 'Åland Islands',
    AL: 'Albania',
    DZ: 'Algeria',
    AS: 'American Samoa',
    AD: 'Andorra',
    AO: 'Angola',
    AI: 'Anguilla',
    AQ: 'Antarctica',
    AG: 'Antigua and Barbuda',
    AR: 'Argentina',
    AM: 'Armenia',
    AW: 'Aruba',
    AU: 'Australia',
    AT: 'Austria',
    AZ: 'Azerbaijan',
    BS: 'Bahamas',
    BH: 'Bahrain',
    BD: 'Bangladesh',
    BB: 'Barbados',
    BY: 'Belarus',
    BE: 'Belgium',
    BZ: 'Belize',
    BJ: 'Benin',
    BM: 'Bermuda',
    BT: 'Bhutan',
    BO: 'Bolivia (Plurinational State of)',
    BQ: 'Bonaire, Sint Eustatius and Saba',
    BA: 'Bosnia and Herzegovina',
    BW: 'Botswana',
    BV: 'Bouvet Island',
    BR: 'Brazil',
    IO: 'British Indian Ocean Territory',
    BN: 'Brunei Darussalam',
    BG: 'Bulgaria',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    CV: 'Cabo Verde',
    KH: 'Cambodia',
    CM: 'Cameroon',
    CA: 'Canada',
    KY: 'Cayman Islands',
    CF: 'Central African Republic',
    TD: 'Chad',
    CL: 'Chile',
    CN: 'China',
    CX: 'Christmas Island',
    CC: 'Cocos (Keeling) Islands',
    CO: 'Colombia',
    KM: 'Comoros',
    CG: 'Congo',
    CD: 'Congo, Democratic Republic of the',
    CK: 'Cook Islands',
    CR: 'Costa Rica',
    CI: "Côte d'Ivoire",
    HR: 'Croatia',
    CU: 'Cuba',
    CW: 'Curaçao',
    CY: 'Cyprus',
    CZ: 'Czechia',
    DK: 'Denmark',
    DJ: 'Djibouti',
    DM: 'Dominica',
    DO: 'Dominican Republic',
    EC: 'Ecuador',
    EG: 'Egypt',
    SV: 'El Salvador',
    GQ: 'Equatorial Guinea',
    ER: 'Eritrea',
    EE: 'Estonia',
    SZ: 'Eswatini',
    ET: 'Ethiopia',
    FK: 'Falkland Islands (Malvinas)',
    FO: 'Faroe Islands',
    FJ: 'Fiji',
    FI: 'Finland',
    FR: 'France',
    GF: 'French Guiana',
    PF: 'French Polynesia',
    TF: 'French Southern Territories',
    GA: 'Gabon',
    GM: 'Gambia',
    GE: 'Georgia',
    DE: 'Germany',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GR: 'Greece',
    GL: 'Greenland',
    GD: 'Grenada',
    GP: 'Guadeloupe',
    GU: 'Guam',
    GT: 'Guatemala',
    GG: 'Guernsey',
    GN: 'Guinea',
    GW: 'Guinea-Bissau',
    GY: 'Guyana',
    HT: 'Haiti',
    HM: 'Heard Island and McDonald Islands',
    VA: 'Holy See',
    HN: 'Honduras',
    HK: 'Hong Kong',
    HU: 'Hungary',
    IS: 'Iceland',
    IN: 'India',
    ID: 'Indonesia',
    IR: 'Iran (Islamic Republic of)',
    IQ: 'Iraq',
    IE: 'Ireland',
    IM: 'Isle of Man',
    IL: 'Israel',
    IT: 'Italy',
    JM: 'Jamaica',
    JP: 'Japan',
    JE: 'Jersey',
    JO: 'Jordan',
    KZ: 'Kazakhstan',
    KE: 'Kenya',
    KI: 'Kiribati',
    KP: "Korea (Democratic People's Republic of)",
    KR: 'Korea, Republic of',
    KW: 'Kuwait',
    KG: 'Kyrgyzstan',
    LA: "Lao People's Democratic Republic",
    LV: 'Latvia',
    LB: 'Lebanon',
    LS: 'Lesotho',
    LR: 'Liberia',
    LY: 'Libya',
    LI: 'Liechtenstein',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    MO: 'Macao',
    MG: 'Madagascar',
    MW: 'Malawi',
    MY: 'Malaysia',
    MV: 'Maldives',
    ML: 'Mali',
    MT: 'Malta',
    MH: 'Marshall Islands',
    MQ: 'Martinique',
    MR: 'Mauritania',
    MU: 'Mauritius',
    YT: 'Mayotte',
    MX: 'Mexico',
    FM: 'Micronesia (Federated States of)',
    MD: 'Moldova, Republic of',
    MC: 'Monaco',
    MN: 'Mongolia',
    ME: 'Montenegro',
    MS: 'Montserrat',
    MA: 'Morocco',
    MZ: 'Mozambique',
    MM: 'Myanmar',
    NA: 'Namibia',
    NR: 'Nauru',
    NP: 'Nepal',
    NL: 'Netherlands',
    NC: 'New Caledonia',
    NZ: 'New Zealand',
    NI: 'Nicaragua',
    NE: 'Niger',
    NG: 'Nigeria',
    NU: 'Niue',
    NF: 'Norfolk Island',
    MK: 'North Macedonia',
    MP: 'Northern Mariana Islands',
    NO: 'Norway',
    OM: 'Oman',
    PK: 'Pakistan',
    PW: 'Palau',
    PS: 'Palestine, State of',
    PA: 'Panama',
    PG: 'Papua New Guinea',
    PY: 'Paraguay',
    PE: 'Peru',
    PH: 'Philippines',
    PN: 'Pitcairn',
    PL: 'Poland',
    PT: 'Portugal',
    PR: 'Puerto Rico',
    QA: 'Qatar',
    RE: 'Réunion',
    RO: 'Romania',
    RU: 'Russian Federation',
    RW: 'Rwanda',
    BL: 'Saint Barthélemy',
    SH: 'Saint Helena, Ascension and Tristan da Cunha',
    KN: 'Saint Kitts and Nevis',
    LC: 'Saint Lucia',
    MF: 'Saint Martin (French part)',
    PM: 'Saint Pierre and Miquelon',
    VC: 'Saint Vincent and the Grenadines',
    WS: 'Samoa',
    SM: 'San Marino',
    ST: 'Sao Tome and Principe',
    SA: 'Saudi Arabia',
    SN: 'Senegal',
    RS: 'Serbia',
    SC: 'Seychelles',
    SL: 'Sierra Leone',
    SG: 'Singapore',
    SX: 'Sint Maarten (Dutch part)',
    SK: 'Slovakia',
    SI: 'Slovenia',
    SB: 'Solomon Islands',
    SO: 'Somalia',
    ZA: 'South Africa',
    GS: 'South Georgia and the South Sandwich Islands',
    SS: 'South Sudan',
    ES: 'Spain',
    LK: 'Sri Lanka',
    SD: 'Sudan',
    SR: 'Suriname',
    SJ: 'Svalbard and Jan Mayen',
    SE: 'Sweden',
    CH: 'Switzerland',
    SY: 'Syrian Arab Republic',
    TW: 'Taiwan, Province of China',
    TJ: 'Tajikistan',
    TZ: 'Tanzania, United Republic of',
    TH: 'Thailand',
    TL: 'Timor-Leste',
    TG: 'Togo',
    TK: 'Tokelau',
    TO: 'Tonga',
    TT: 'Trinidad and Tobago',
    TN: 'Tunisia',
    TR: 'Türkiye',
    TM: 'Turkmenistan',
    TC: 'Turks and Caicos Islands',
    TV: 'Tuvalu',
    UG: 'Uganda',
    UA: 'Ukraine',
    AE: 'United Arab Emirates',
    GB: 'United Kingdom of Great Britain and Northern Ireland',
    US: 'United States of America',
    UM: 'United States Minor Outlying Islands',
    UY: 'Uruguay',
    UZ: 'Uzbekistan',
    VU: 'Vanuatu',
    VE: 'Venezuela (Bolivarian Republic of)',
    VN: 'Viet Nam',
    VG: 'Virgin Islands (British)',
    VI: 'Virgin Islands (U.S.)',
    WF: 'Wallis and Futuna',
    EH: 'Western Sahara',
    YE: 'Yemen',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
};

const en_GB = {};

const en_XA = {
    // Login/Reset Password
    "email": "[!!! É₥áïℓ ℓ !!!]",
    "password": "[!!! Þáƨƨωôřδ ℓ !!!]",
    "sign_in": "[!!! §ïϱñ Ìñ ℓ !!!]",
    "continue": "[Cóntínúe]",
    "forgot_password": "[!!! Fôřϱôƭ Þáƨƨωôřδ ℓôřè !!!]",
    "reset_password": "[!!! Rèƨèƭ Þáƨƨωôřδ ℓôř !!!]",
    "reset_password_instructions": "[!!! Tô řèƨèƭ ¥ôúř ƥáƨƨωôřδ, èñƭèř ¥ôúř è₥áïℓ áδδřèƨƨ áβôƲè áñδ ωè'ℓℓ ƨèñδ ïñƨƭřúçƭïôñƨ, ïƒ ƭλè áççôúñƭ èжïƨƭƨ. ℓôřè₥ ïƥƨú₥ δôℓôř ƨïƭ á₥èƭ, çôñ !!!]",
    "sent_reset_password_code": "[!!! Wè ƨèñƭ á ƥáƨƨωôřδ řèƨèƭ çôδè ƭô [email] Éñƭèř ƭλáƭ çôδè áñδ á ñèω ƥáƨƨωôřδ. ℓôřè₥ ïƥƨú₥ δôℓôř ƨïƭ  !!!]",
    "reset_code": "[!!! Rèƨèƭ Çôδè ℓô !!!]",
    "new_password": "[!!! Nèω Þáƨƨωôřδ ℓôř !!!]",
    "reenter_new_password": "[!!! Rè-èñƭèř Nèω Þáƨƨωôřδ ℓôřè₥ !!!]",
    "must_include_email": '[!!! Múƨƭ ïñçℓúδè è₥áïℓ ℓôřè !!!]',
    "old_password": "[!!! Óℓδ Þáƨƨωôřδ ℓôř !!!]",
    "set_new_password": "[!!! §èƭ Nèω Þáƨƨωôřδ ℓôřè !!!]",
    "password_expired": "[!!! Þáƨƨωôřδ Éжƥïřèδ ℓôřè !!!]",
    "change_your_password": '[!!! Çλáñϱè Ýôúř Þáƨƨωôřδ ℓôřè₥ !!!]',
    "change_password": '[!!! Çλáñϱè Þáƨƨωôřδ ℓôřè !!!]',
    "set_password": '[!!! §èƭ Þáƨƨωôřδ ℓôř !!!]',
    "already_have_reset_code": "[!!! I Áℓřèáδ¥ λáνè á řèƨèƭ çôδè ℓôřè₥ ïƥ !!!]",
    "login_title_text": "[Lógin]",
    "try_again": "[Try Ágain]",
    "login_error_message": "[We wére not áble to fínd your úser. You máy try ágáin or cóntact your accóúnt mánaǵér.]",
    "invalid_login_credentials_error_message": "[Wróng úsernáme ánd pássword cómbinátion ór the úser dóes nót éxíst.]",
    "enter_password_reset_code": "[Please énter the códe we sént to the accóunt [email].]",
    "repeat-new-password": "[Repeát New Pássword]",
    "send-code": "[Send códe]",
    "okta-sign-in": "[Sign ín wíth Ókta]",
    "google-sign-in": "[Sign ín wíth Goógle]",
    "microsoft-sign-in": "[Sign ín wíth Micrósoft]",
    "or": "[ÓR]",
    "contact_manager_for_account": "[Fór new accóunts pleáse cóntact your mánaǵer]",
    // Sidebar
    "users": "[!!! Ûƨèřƨ ℓ !!!]",
    "main_settings": "[!!! Máïñ §èƭƭïñϱƨ ℓôř !!!]",
    "terminology": "[!!! Tèř₥ïñôℓôϱ¥ ℓô !!!]",
    "equipment": "[!!! É9úïƥ₥èñƭ ℓô !!!]",
    "security": "[!!! §èçúřïƭ¥ ℓ !!!]",
    "tenants": "[!!! Tèñáñƭƨ ℓ !!!]",
    "collapse": "[!!! Çôℓℓáƥƨè ℓ !!!]",
    // Users List
    "new_user": "[!!! Nèω Ûƨèř ℓ !!!]",
    "edit_user": "[!!! Éδïƭ Ûƨèř ℓô !!!]",
    "bulk_import": "[!!! ßúℓƙ Ì₥ƥôřƭ ℓô !!!]",
    "show_disabled_users": "[!!! §λôω Ðïƨáβℓèδ Ûƨèřƨ ℓôřè₥ !!!]",
    "name": "[!!! Ná₥è  !!!]",
    "role": "[!!! Rôℓè  !!!]",
    // Valid User roles
    "user_role": "[!!! úƨèř  !!!]",
    "tenant_admin_role": "[!!! TèñáñƭÂδ₥ïñ ℓô !!!]",
    "super_admin_role": "[!!! §úƥèřÂδ₥ïñ ℓô !!!]",
    "user": "[!!! Ûƨèř  !!!]",
    "tenant_admin": "[!!! Tèñáñƭ Âδ₥ïñ ℓôř !!!]",
    "super_admin": "[!!! §úƥèř Âδ₥ïñ ℓô !!!]",
    // Create/Edit User Modal
    "email_required": "[!!! É₥áïℓ (Rè9úïřèδ) ℓôřè !!!]",
    "first_name": "[!!! Fïřƨƭ Ná₥è ℓô !!!]",
    "last_name": "[!!! £áƨƭ Ná₥è ℓô !!!]",
    "force_password_reset": "[!!! Fôřçè Þáƨƨωôřδ Rèƨèƭ ℓôřè₥ !!!]",
    "resend_validation_code": "[!!! Rèƨèñδ Váℓïδáƭïôñ Çôδè ℓôřè₥  !!!]",
    "enable_user": "[!!! Éñáβℓè Ûƨèř ℓô !!!]",
    "disable_user": "[!!! Ðïƨáβℓè Ûƨèř ℓôř !!!]",
    "certify": "[!!! Çèřƭïƒ¥ ℓ !!!]",
    "unverified": "[!!! ÛñƲèřïƒïèδ ℓô !!!]",
    "verified": "[!!! Vèřïƒïèδ ℓô !!!]",
    "locked_out": "[!!! £ôçƙèδ Óúƭ ℓô !!!]",
    "disabled": "[!!! Ðïƨáβℓèδ ℓ !!!]",
    "save": "[!!! §áƲè  !!!]",
    "reset_user_password_confirmation": "[!!! Âřè ¥ôú ƨúřè ¥ôú ωáñƭ ƭô řèƨèƭ ƭλïƨ úƨèř'ƨ ƥáƨƨωôřδ? ℓôřè₥ ïƥƨú₥ δôℓ !!!]",
    "resend_validation_code_confirmation": "[!!! Âřè ¥ôú ƨúřè ¥ôú ωáñƭ ƭô řèƨèñδ Ʋáℓïδáƭïôñ çôδè? ℓôřè₥ ïƥƨú₥ δ !!!]",
    "cannot_disable_yourself": "[!!! Çáññôƭ δïƨáβℓè ¥ôúřƨèℓƒ ℓôřè₥  !!!]",
    "cancel_changes": "[!!! Çáñçèℓ çλáñϱèƨ ℓôř !!!]",
    "required": "[!!! (Rè9úïřèδ) ℓô !!!]",
    // Bulk Import Modal
    "csv_format_requirements": "[!!! Ç§V Fôř₥áƭ: è₥áïℓ, ƒïřƨƭNá₥è, ℓáƨƭNá₥è, řôℓè (ôñℓ¥ è₥áïℓ ïƨ řè9úïřèδ) ℓôřè₥ ïƥƨú₥ δôℓôř ƨï !!!]",
    "valid_user_roles": '[!!! Váℓïδ úƨèř řôℓèƨ: "úƨèř", "TèñáñƭÂδ₥ïñ", "§úƥèřÂδ₥ïñ" ℓôřè₥ ïƥƨú₥ δôℓ !!!]',
    "select_csv": "[!!! §èℓèçƭ Ç§V ℓô !!!]",
    "import": "[!!! Ì₥ƥôřƭ ℓ !!!]",
    "file_too_large": "[!!! Fïℓè ƭôô ℓářϱè (Máжï₥ú₥ ôƒ ÌMÞÓRT_£ÌMÌT úƨèřƨ) ℓôřè₥ ïƥƨú₥ δ !!!]",
    "required_headers_missing": "[!!! Rè9úïřèδ λèáδèřƨ ₥ïƨƨïñϱ: è₥áïℓ ℓôřè₥ ïƥ !!!]",
    "user_import_starting": "[!!! Ûƨèř ï₥ƥôřƭ ƨƭářƭïñϱ. Ýôú ωïℓℓ řèçèïƲè áñ ï₥ƥôřƭ ƨú₥₥ář¥ è₥áïℓ ïñ á ƒèω ₥ïñúƭèƨ. ℓôřè₥ ïƥƨú₥ δôℓôř ƨïƭ á !!!]",
    // Tenant Main Settings
    "email_language": "[!!! É₥áïℓ £áñϱúáϱè ℓôř !!!]",
    "country": "[!!! Çôúñƭř¥ ℓ !!!]",
    "description_optional": "[!!! Ðèƨçřïƥƭïôñ (Óƥƭïôñáℓ) ℓôřè₥  !!!]",
    "units_feet_meters": "[!!! Ûñïƭƨ (Fèèƭ, Mèƭèřƨ) ℓôřè₥ !!!]",
    "certify_id": "[!!! Çèřƭïƒ¥ ÌÐ ℓô !!!]",
    "resolve_id": "[!!! RèƨôℓƲè ÌÐ ℓô !!!]",
    "sms_from": "[!!! §M§ Fřô₥ ℓ !!!]",
    "sms_body": "[!!! §M§ ßôδ¥ ℓ !!!]",
    "default_sms_body": "[!!! Ýôúř WïFï ïñƨƭáℓℓáƭïôñ ïƨ çô₥ƥℓèƭè áñδ λáƨ βèèñ çèřƭïƒïèδ β¥ [NÂMÉ]! ℓôřè₥ ïƥƨú₥ δôℓôř ƨ Vïèω ¥ôúř çèřƭïƒïçáƭè λèřè: [£ÌNK] ℓôřè₥ ïƥƨ !!!]",
    "sms_body_helper_text": "[!!! Çèřƭïƒ¥ ωïℓℓ ƭèжƭ ƭλïƨ ₥èƨƨáϱè ƭô ƭλè çúƨƭô₥èř. [£ÌNK] ωïℓℓ βè řèƥℓáçèδ ωïƭλ á ℓïñƙ ƭô ƭλè çèřƭïƒïçáƭè (řè9úïřèδ). [NÂMÉ] ωïℓℓ βè řèƥℓáçèδ ωïƭλ ƭλè çôñƭèñƭƨ ôƒ ƭλè Ná₥è ƒïèℓδ (ôƥƭïôñáℓ) ℓôřè₥ ïƥƨú₥ δôℓôř ƨïƭ á₥èƭ, çôñƨèçƭèƭúř áδïƥïƨçïñϱ èℓïƭ !!!]",
    "link_must_be_in_sms_body": "[!!! [£ÌNK] ₥úƨƭ βè ïñ ƭλè §M§ βôδ¥. ℓôřè₥ ïƥ !!!]",
    "update_successful": "[!!! Ûƥδáƭè §úççèƨƨƒúℓ ℓôřè !!!]",
    "creation_successful": "[!!! Çřèáƭïôñ §úççèƨƨƒúℓ ℓôřè₥ !!!]",
    // Tenant Terminology Settings
    "term": "[!!! Tèř₥  !!!]",
    "example_usage": "[!!! Éжá₥ƥℓè Ûƨáϱè ℓôř !!!]",
    "customer_example_usage_1": "[!!! Ìñ çôñƨúℓƭáƭïôñ ωïƭλ ƭλè çúƨƭô₥èř, çôñƒïř₥ ƭλè ƨèℓèçƭèδ βúïℓδïñϱ, ôř ϱô βáçƙ ƭô èδïƭ ƭλè áδδřèƨƨ. ℓôřè₥ ïƥƨú₥ δôℓôř ƨïƭ á₥èƭ,  !!!]",
    "customer_example_usage_2": "[!!! Ìñ çôñƨúℓƭáƭïôñ ωïƭλ ƭλè ƨúβƨçřïβèř, çôñƒïř₥ ƭλè ƨèℓèçƭèδ βúïℓδïñϱ, ôř ϱô βáçƙ ƭô èδïƭ ƭλè áδδřèƨƨ. ℓôřè₥ ïƥƨú₥ δôℓôř ƨïƭ á₥èƭ, ç !!!]",
    "router_example_usage_1": "[!!! Táƥ ƭλè ƥřôƥôƨèδ řôúƭèř ℓôçáƭïôñ βèℓôω. ℓôřè₥ ïƥƨú₥ !!!]",
    "router_example_usage_2": "[!!! Táƥ ƭλè ƥřôƥôƨèδ ₥ôδè₥ ℓôçáƭïôñ βèℓôω. ℓôřè₥ ïƥƨú !!!]",
    "router_example_usage_3": "[!!! Táƥ ƭλè ƥřôƥôƨèδ ϱáƭèωá¥ ℓôçáƭïôñ βèℓôω. ℓôřè₥ ïƥƨú₥ !!!]",
    "router_example_usage_4": "[!!! Táƥ ƭλè ƥřôƥôƨèδ λúβ ℓôçáƭïôñ βèℓôω. ℓôřè₥ ïƥƨú !!!]",
    "router_example_usage_5": '[!!! Táƥ ƭλè ƥřôƥôƨèδ řèƨïδèñƭïáℓ ϱáƭèωá¥ ℓôçáƭïôñ βèℓôω. ℓôřè₥ ïƥƨú₥ δôℓ !!!]',
    "level_example_usage_1": "[!!! Gô ƭô ℓèƲèℓ 2 áñδ ƭáƥ ¥ôúř ℓôçáƭïôñ. ℓôřè₥ ïƥƨú !!!]",
    "level_example_usage_2": "[!!! Gô ƭô ƒℓôôř 2 áñδ ƭáƥ ¥ôúř ℓôçáƭïôñ. ℓôřè₥ ïƥƨú !!!]",
    "mesh_pod_example_usage_1": "[!!! Éƨƭï₥áƭïñϱ ƨïϱñáℓ ƨƭřèñϱƭλ áñδ ôƥƭï₥ú₥ ₥èƨλ ƥôδ ƥℓáçè₥èñƭ. ℓôřè₥ ïƥƨú₥ δôℓô !!!]",
    "mesh_pod_example_usage_2": "[!!! Éƨƭï₥áƭïñϱ ƨïϱñáℓ ƨƭřèñϱƭλ áñδ ôƥƭï₥ú₥ áççèƨƨ ƥôïñƭ ƥℓáçè₥èñƭ. ℓôřè₥ ïƥƨú₥ δôℓôř  !!!]",
    "mesh_pod_example_usage_3": "[!!! Éƨƭï₥áƭïñϱ ƨïϱñáℓ ƨƭřèñϱƭλ áñδ ôƥƭï₥ú₥ ₥èƨλ ñôδè ƥℓáçè₥èñƭ. ℓôřè₥ ïƥƨú₥ δôℓôř !!!]",
    "mesh_pod_example_usage_4": "[!!! Éƨƭï₥áƭïñϱ ƨïϱñáℓ ƨƭřèñϱƭλ áñδ ôƥƭï₥ú₥ ₥èƨλ ƥúçƙ ƥℓáçè₥èñƭ. ℓôřè₥ ïƥƨú₥ δôℓôř !!!]",
    "mesh_pod_example_usage_5": "[!!! Éƨƭï₥áƭïñϱ ƨïϱñáℓ ƨƭřèñϱƭλ áñδ ôƥƭï₥ú₥ βèáçôñ ƥℓáçè₥èñƭ. ℓôřè₥ ïƥƨú₥ δôℓô !!!]",
    "mesh_pod_example_usage_6": '[!!! Éƨƭï₥áƭïñϱ ƨïϱñáℓ ƨƭřèñϱƭλ áñδ ôƥƭï₥ú₥ řáñϱè èжƭèñδèř ƥℓáçè₥èñƭ. ℓôřè₥ ïƥƨú₥ δôℓôř  !!!]',
    "wifi_example_usage_1": "[!!! WïFï Máƥƥïñϱ ℓôř !!!]",
    "wifi_example_usage_2": "[!!! Wï-Fï Máƥƥïñϱ ℓôř !!!]",
    "wifi_example_usage_3": "[!!! Wïƒï Máƥƥïñϱ ℓôř !!!]",
    "wifi_example_usage_4": "[!!! WÌFÌ Máƥƥïñϱ ℓôř !!!]",
    "show_terminology_fields": "[!!! §λôω ƭèř₥ïñôℓôϱ¥ ƒïèℓδƨ ℓô !!!]",
    // Tenant Equipment Settings (Certify)
    "router_options_1": "[!!! Rôúƭèř Óƥƭïôñƨ ℓôř !!!]",
    "router_options_2": "[!!! Môδè₥ Óƥƭïôñƨ ℓôř !!!]",
    "router_options_3": "[!!! Gáƭèωá¥ Óƥƭïôñƨ ℓôřè !!!]",
    "router_options_4": "[!!! Húβ Óƥƭïôñƨ ℓô !!!]",
    "router_options_5": '[!!! Rèƨïδèñƭïáℓ Gáƭèωá¥ Óƥƭïôñƨ ℓôřè₥ ï !!!]',
    "new_router_options_1": "[!!! Nèω Rôúƭèř Óƥƭïôñƨ ℓôřè !!!]",
    "new_router_options_2": "[!!! Nèω Môδè₥ Óƥƭïôñƨ ℓôřè !!!]",
    "new_router_options_3": "[!!! Nèω Gáƭèωá¥ Óƥƭïôñƨ ℓôřè₥ !!!]",
    "new_router_options_4": "[!!! Nèω Húβ Óƥƭïôñƨ ℓôřè !!!]",
    "new_router_options_5": '[!!! Nèω Rèƨïδèñƭïáℓ Gáƭèωá¥ Óƥƭïôñƨ ℓôřè₥ ïƥ !!!]',
    "mesh_pod_options_1": "[!!! Mèƨλ Þôδ Óƥƭïôñƨ ℓôřè !!!]",
    "mesh_pod_options_2": "[!!! Âççèƨƨ Þôïñƭ Óƥƭïôñƨ ℓôřè₥ !!!]",
    "mesh_pod_options_3": "[!!! Mèƨλ Nôδè Óƥƭïôñƨ ℓôřè !!!]",
    "mesh_pod_options_4": "[!!! Mèƨλ Þúçƙ Óƥƭïôñƨ ℓôřè !!!]",
    "mesh_pod_options_5": "[!!! ßèáçôñ Óƥƭïôñƨ ℓôř !!!]",
    "mesh_pod_options_6": '[!!! Ráñϱè Éжƭèñδèř Óƥƭïôñƨ ℓôřè₥  !!!]',
    "new_mesh_pod_options_1": "[!!! Nèω Mèƨλ Þôδ Óƥƭïôñƨ ℓôřè₥ !!!]",
    "new_mesh_pod_options_2": "[!!! Nèω Âççèƨƨ Þôïñƭ Óƥƭïôñƨ ℓôřè₥  !!!]",
    "new_mesh_pod_options_3": "[!!! Nèω Mèƨλ Nôδè Óƥƭïôñƨ ℓôřè₥ !!!]",
    "new_mesh_pod_options_4": "[!!! Nèω Mèƨλ Þúçƙ Óƥƭïôñƨ ℓôřè₥ !!!]",
    "new_mesh_pod_options_5": "[!!! Nèω ßèáçôñ Óƥƭïôñƨ ℓôřè !!!]",
    "new_mesh_pod_options_6": '[!!! Nèω Ráñϱè Éжƭèñδèř Óƥƭïôñƨ ℓôřè₥ ï !!!]',
    "missing_required_router_info_1": "[!!! Mïƨƨïñϱ Rè9úïřèδ Rôúƭèř Ìñƒô ℓôřè₥ ï !!!]",
    "missing_required_router_info_2": "[!!! Mïƨƨïñϱ Rè9úïřèδ Môδè₥ Ìñƒô ℓôřè₥ ï !!!]",
    "missing_required_router_info_3": "[!!! Mïƨƨïñϱ Rè9úïřèδ Gáƭèωá¥ Ìñƒô ℓôřè₥ ïƥ !!!]",
    "missing_required_router_info_4": "[!!! Mïƨƨïñϱ Rè9úïřèδ Húβ Ìñƒô ℓôřè₥ ï !!!]",
    "missing_required_router_info_5": '[!!! Mïƨƨïñϱ Rè9úïřèδ Rèƨïδèñƭïáℓ Gáƭèωá¥ Ìñƒô ℓôřè₥ ïƥƨú₥ !!!]',
    "missing_required_mesh_pod_info_1": "[!!! Mïƨƨïñϱ Rè9úïřèδ Mèƨλ Þôδ Ìñƒô ℓôřè₥ ïƥ !!!]",
    "missing_required_mesh_pod_info_2": "[!!! Mïƨƨïñϱ Rè9úïřèδ Âççèƨƨ Þôïñƭ Ìñƒô ℓôřè₥ ïƥƨ !!!]",
    "missing_required_mesh_pod_info_3": "[!!! Mïƨƨïñϱ Rè9úïřèδ Mèƨλ Nôδè Ìñƒô ℓôřè₥ ïƥ !!!]",
    "missing_required_mesh_pod_info_4": "[!!! Mïƨƨïñϱ Rè9úïřèδ Mèƨλ Þúçƙ Ìñƒô ℓôřè₥ ïƥ !!!]",
    "missing_required_mesh_pod_info_5": "[!!! Mïƨƨïñϱ Rè9úïřèδ ßèáçôñ Ìñƒô ℓôřè₥ ï !!!]",
    "missing_required_mesh_pod_info_6": '[!!! Mïƨƨïñϱ Rè9úïřèδ Ráñϱè Éжƭèñδèř Ìñƒô ℓôřè₥ ïƥƨú !!!]',
    "description": '[!!! δèƨçřïƥƭïôñ ℓô !!!]',
    "display_name": "[!!! Ðïƨƥℓá¥ Ná₥è ℓôř !!!]",
    "range_in_unit_1": "[!!! Ráñϱè ïñ Fèèƭ ℓôř !!!]",
    "range_in_unit_2": "[!!! Ráñϱè ïñ Mèƭèřƨ ℓôřè !!!]",
    "area_in_unit_1": '[!!! Âřèá ïñ §9úářè Fèèƭ ℓôřè₥ !!!]',
    "area_in_unit_2": '[!!! Âřèá ïñ §9úářè Mèƭèřƨ ℓôřè₥ !!!]',
    "default_active": "[!!! Ðèƒáúℓƭ ÂçƭïƲè ℓôř !!!]",
    "average_range": "[!!! ÂƲèřáϱè Ráñϱè ℓôř !!!]",
    "certify_default": "[!!! Çèřƭïƒ¥ δèƒáúℓƭ ℓôřè !!!]",
    "default": "[!!! Ðèƒáúℓƭ ℓ !!!]",
    "active": "[!!! ÂçƭïƲè ℓ !!!]",
    "one_option_must_be_default": "[!!! Óñè ôƥƭïôñ ₥úƨƭ βè δèƒáúℓƭ ℓôřè₥ ï !!!]",
    "set_as_default": "[!!! §èƭ áƨ δèƒáúℓƭ ℓôř !!!]",
    "default_option_must_be_active": "[!!! Ðèƒáúℓƭ ôƥƭïôñ ₥úƨƭ βè áçƭïƲè ℓôřè₥ ïƥ !!!]",
    "deactivate": "[!!! ÐèáçƭïƲáƭè ℓô !!!]",
    "activate": "[!!! ÂçƭïƲáƭè ℓ !!!]",
    "name_is_required": "[!!! Ná₥è ïƨ řè9úïřèδ ℓôřè !!!]",
    // Customer Name
    "customer_1": "[!!! Çúƨƭô₥èř ℓ !!!]",
    "customer_2": "[!!! §úβƨçřïβèř ℓô !!!]",
    // Pod Name
    "pod_1": "[!!! Mèƨλ Þôδ ℓ !!!]",
    "pod_2": "[!!! Âççèƨƨ Þôïñƭ ℓôř !!!]",
    "pod_3": "[!!! Mèƨλ Nôδè ℓô !!!]",
    "pod_4": "[!!! Mèƨλ Þúçƙ ℓô !!!]",
    "pod_5": "[!!! ßèáçôñ ℓ !!!]",
    "pod_6": "[!!! Ráñϱè Éжƭèñδèř ℓôř !!!]",
    "pod_7": "[!!! Booster !!!]",
    "pods_1": "[!!! Mèƨλ Þôδƨ ℓô !!!]",
    "pods_2": "[!!! Âççèƨƨ Þôïñƭƨ ℓôř !!!]",
    "pods_3": "[!!! Mèƨλ Nôδèƨ ℓô !!!]",
    "pods_4": "[!!! Mèƨλ Þúçƙƨ ℓô !!!]",
    "pods_5": "[!!! ßèáçôñƨ ℓ !!!]",
    "pods_6": "[!!! Ráñϱè Éжƭèñδèřƨ ℓôřè !!!]",
    "pods_7": "[!!! Boosters !!!]",
    // Router Name
    "router_1": "[!!! Rôúƭèř ℓ !!!]",
    "router_2": "[!!! Môδè₥ ℓ !!!]",
    "router_3": "[!!! Gáƭèωá¥ ℓ !!!]",
    "router_4": "[!!! Húβ  !!!]",
    "router_5": "[!!! Internet Box !!!]",
    // Level Name
    "level_1": "[!!! £èƲèℓ ℓ !!!]",
    "level_2": "[!!! Fℓôôř ℓ !!!]",
    "levels_1": "[!!! £èƲèℓƨ ℓ !!!]",
    "levels_2": "[!!! Fℓôôřƨ ℓ !!!]",
    // Wifi Name
    "wifi_1": "[!!! WïFï  !!!]",
    "wifi_2": "[!!! Wï-Fï ℓ !!!]",
    "wifi_3": "[!!! Wïƒï  !!!]",
    "wifi_4": "[!!! WÌFÌ  !!!]",
    // Units
    "units_1": "[!!! Fèèƭ  !!!]",
    "units_2": "[!!! Mèƭèřƨ ℓ !!!]",
    // Certificate Pod Info
    "recommended": "[!!! Rèçô₥₥èñδèδ ℓô !!!]",
    "installed": "[!!! Ìñƨƭáℓℓèδ ℓô !!!]",
    "total": "[!!! Tôƭáℓ ℓ !!!]",
    // Misc
    "confirm": "[!!! Çôñƒïř₥ ℓ !!!]",
    "units": "[!!! Ûñïƭƨ ℓ !!!]",
    "region": "[!!! Rèϱïôñ ℓ !!!]",
    "edit": "[!!! Éδïƭ  !!!]",
    "modified": "[!!! Môδïƒïèδ ℓ !!!]",
    "create": '[!!! Çřèáƭè ℓ !!!]',
    "created": "[!!! Çřèáƭèδ ℓ !!!]",
    "routethis_app": "[!!! RôúƭèTλïƨ Âƥƥ ℓôř !!!]",
    "loading": "[!!! £ôáδïñϱ... ℓô !!!]",
    "redirecting": "[!!! Rèδïřèçƭïñϱ... ℓôř !!!]",
    "error": "[!!! Éřřôř ℓ !!!]",
    "cancel": '[!!! Çáñçèℓ ℓ !!!]',
    "close": "[!!! Çℓôƨè ℓ !!!]",
    "account_holder": "[!!! Áççôúñƭ Hôℓδèř ℓ !!!]",
    "search": "[!!! ƨèářçλ ℓ !!!]",
    // Languages
    "en": "[!!! Éñϱℓïƨλ (Û§) ℓôř !!!]",
    "en-GB": "[!!! Éñϱℓïƨλ (Gß) ℓôř !!!]",
    "da": "[!!! Ðáñïƨλ ℓ !!!]",
    "fi": "[!!! Fïññïƨλ ℓ !!!]",
    "fr": "[!!! Fřèñçλ ℓ !!!]",
    "fr-CA": "[!!! Fřèñçλ (Çáñáδá) ℓôřè !!!]",
    "de": "[!!! Gèř₥áñ ℓ !!!]",
    "el": "[!!! Gřèèƙ ℓ !!!]",
    "it": "[!!! Ìƭáℓïáñ ℓ !!!]",
    "pt": "[!!! Þôřƭúϱúèƨè ℓô !!!]",
    "pt-BR": "[!!! Þôřƭúϱúèƨè (ßřáƺïℓ ℓôřè !!!]",
    "es": "[!!! §ƥáñïƨλ ℓ !!!]",
    "es-419": "[!!! §ƥáñïƨλ (£áƭïñ Â₥èřïçá) ℓôřè₥  !!!]",
    "sv": "[!!! §ωèδïƨλ ℓ !!!]",
    // Client-side validation errors
    "incorrect_email_or_password": "[!!! Ìñçôřřèçƭ è₥áïℓ ôř ƥáƨƨωôřδ, ôř δïƨáβℓèδ áççôúñƭ. Tř¥ áϱáïñ ôř çôñƭáçƭ áñ áδ₥ïñïƨƭřáƭôř. ℓôřè₥ ïƥƨú₥ δôℓôř ƨïƭ á₥è !!!]",
    "invalid_reset_code": "[!!! ÌñƲáℓïδ řèƨèƭ çôδè ℓôřè !!!]",
    "password_minimum_requirements": "[!!! Ýôúř ƥáƨƨωôřδ ₥úƨƭ βè á ₥ïñï₥ú₥ ôƒ 8 çλářáçƭèřƨ áñδ ïñçℓúδè áƭ ℓèáƨƭ ôñè ℓôωèřçáƨè, ôñè úƥƥèřçáƨè, áñδ ôñè ñú₥èřïç çλářáçƭèř. ℓôřè₥ ïƥƨú₥ δôℓôř ƨïƭ á₥èƭ, çôñƨèçƭèƭ !!!]",
    "password_minimum_requirements_shortened": "[Minímum 8 cháracters, óne úppercáse, ánd óne númeric]",
    "passwords_must_match": "[!!! Þáƨƨωôřδƨ ₥úƨƭ ₥áƭçλ ℓôřè₥ !!!]",
    "must_include_new_password_email": "[!!! Múƨƭ ïñçℓúδè ñèω ƥáƨƨωôřδ áñδ úƨèř è₥áïℓ ℓôřè₥ ïƥƨú₥ !!!]",
    "must_include_new_password_confirmation_code": "[!!! Múƨƭ ïñçℓúδè ñèω ƥáƨƨωôřδ áñδ çôñƒïř₥áƭïôñÇôδè ℓôřè₥ ïƥƨú₥ δ !!!]",
    "cannot_send_reset_code_without_email": "[!!! Çáññôƭ ƨèñδ řèƨèƭ çôδè ωïƭλôúƭ è₥áïℓ ℓôřè₥ ïƥƨú !!!]",
    "must_enter_old_password": "[!!! Múƨƭ èñƭèř Óℓδ Þáƨƨωôřδ ℓôřè₥  !!!]",
    "must_enter_reset_code": "[!!! Múƨƭ èñƭèř Rèƨèƭ Çôδè ℓôřè₥ !!!]",
    "must_enter_new_password": "[!!! Múƨƭ èñƭèř Nèω Þáƨƨωôřδ ℓôřè₥  !!!]",
    "passwords_cannot_begin_or_end_with_spaces": "[!!! Þáƨƨωôřδƨ çáññôƭ βèϱïñ ôř èñδ ωïƭλ ƨƥáçèƨ ℓôřè₥ ïƥƨú₥ !!!]",
    // Server-side errors
    'User with that email already exists': "[!!! Ûƨèř ωïƭλ ƭλáƭ è₥áïℓ áℓřèáδ¥ èжïƨƭƨ ℓôřè₥ ïƥƨú !!!]",
    'Try another display name': "[!!! Tř¥ áñôƭλèř δïƨƥℓá¥ ñá₥è ℓôřè₥  !!!]",
    'Password cannot be a previously used password': "[!!! 'Þáƨƨωôřδ çáññôƭ βè á ƥřèƲïôúƨℓ¥ úƨèδ ƥáƨƨωôřδ' ℓôřè₥ ïƥƨú₥ δ !!!]",
    'Invalid reset code': "[!!! ÌñƲáℓïδ řèƨèƭ çôδè ℓôřè !!!]",
    'Incorrect email or password, or disabled account. Try again or contact an administrator.': "[!!! Ìñçôřřèçƭ è₥áïℓ ôř ƥáƨƨωôřδ, ôř δïƨáβℓèδ áççôúñƭ. Tř¥ áϱáïñ ôř çôñƭáçƭ áñ áδ₥ïñïƨƭřáƭôř. ℓôřè₥ ïƥƨú₥ δôℓôř ƨïƭ á₥è !!!]",
    'Invalid code provided, please request a code again.': '[!!! ÌñƲáℓïδ çôδè ƥřôƲïδèδ, ƥℓèáƨè řè9úèƨƭ á çôδè áϱáïñ. ℓôřè₥ ïƥƨú₥ δô !!!]',
    'Password cannot begin or end with spaces': "[!!! Þáƨƨωôřδƨ çáññôƭ βèϱïñ ôř èñδ ωïƭλ ƨƥáçèƨ ℓôřè₥ ïƥƨú₥ !!!]",
    'LimitExceededException - Attempt limit exceeded, please try after some time.': "[!!! Âƭƭè₥ƥƭ ℓï₥ïƭ èжçèèδèδ, ƥℓèáƨè ƭř¥ áƒƭèř ƨô₥è ƭï₥è. ℓôřè₥ ïƥƨú₥ δô !!!]",
    'User is not Authorized': "[!!! Ûƨèř ïƨ ñôƭ Âúƭλôřïƺèδ ℓôřè₥  !!!]",
    'Your session timed out. Sign in again with your temporary password.': "[!!! Ýôúř ƨèƨƨïôñ ƭï₥èδ ôúƭ. §ïϱñ ïñ áϱáïñ ωïƭλ ¥ôúř ƭè₥ƥôřář¥ ƥáƨƨωôřδ. ℓôřè₥ ïƥƨú₥ δôℓôř ƨ !!!]",
    'Internal Service Failure - Cognito Unavailable': "[!!! Çôϱñïƭô ÛñáƲáïℓáβℓè ℓôřè₥ !!!]",
    'Internal Service Failure - Unknown Failure': "[!!! Ûñƙñôωñ Fáïℓúřè ℓôřè !!!]",
    'Must enter Reset Code': '[!!! Múƨƭ èñƭèř Rèƨèƭ Çôδè ℓôřè₥ !!!]',
    // Challenge Responses
    "step_1_of_2": "[Step 1 óf 2]",
    "step_2_of_2": "[Step 2 óf 2]",
    "set_password_challenge": "[!!! Ýôú ₥úƨƭ ƨèƭ á ñèω ƥáƨƨωôřδ ƭλè ƒïřƨƭ ƭï₥è ¥ôú ƨïϱñ ïñ ƒôř ƨèçúřïƭ¥ ƥúřƥôƨèƨ. ℓôřè₥ ïƥƨú₥ δôℓôř ƨïƭ  !!!]",
    "reset_password_challenge": "[!!! Wè ƨèñƭ á ƥáƨƨωôřδ řèƨèƭ çôδè ƭô [EMAIL]. Éñƭèř ƭλáƭ çôδè áñδ á ñèω ƥáƨƨωôřδ. ℓôřè₥ ïƥƨú₥ δôℓôř ƨïƭ  !!!]",
    "set_new_password_challenge": "[!!! Ýôúř çô₥ƥáñ¥'ƨ ƥôℓïç¥ řè9úïřèƨ ƭλáƭ ¥ôúř ƥáƨƨωôřδ èжƥïřèƨ áƒƭèř ƨô₥è ƭï₥è. Wè ƨèñƭ á ƥáƨƨωôřδ řèƨèƭ çôδè ƭô [EMAIL]. Éñƭèř ƭλáƭ çôδè áñδ á ñèω ƥáƨƨωôřδ. ℓôřè₥ ïƥƨú₥ δôℓôř ƨïƭ á₥èƭ, çôñƨèçƭèƭúř áδïƥ !!!]",
    "change_your_password_challenge": "[!!! Éñƭèř ¥ôúř çúřřèñƭ ƥáƨƨωôřδ áñδ á ñèω ƥáƨƨωôřδ βèℓôω ƭô çλáñϱè ïƭ. ℓôřè₥ ïƥƨú₥ δôℓôř ƨ !!!]",
    "change_password_challenge": "[!!! Éñƭèř á ñèω ƥáƨƨωôřδ ƒôř ƭλè úƨèř ℓôřè₥ ïƥƨ !!!]",
    "reset_password_challenge_instructions": "[We wíll sénd to the accóunt [EMAIL] á reset códe ánd fúrther instrúctions to creáte á new pássword.]",
    AF: "[!!! Âƒϱλáñïƨƭáñ ℓô !!!]",
    AX: "[!!! Åℓáñδ Ìƨℓáñδƨ ℓôř !!!]",
    AL: "[!!! Âℓβáñïá ℓ !!!]",
    DZ: "[!!! Âℓϱèřïá ℓ !!!]",
    AS: "[!!! Â₥èřïçáñ §á₥ôá ℓôř !!!]",
    AD: "[!!! Âñδôřřá ℓ !!!]",
    AO: "[!!! Âñϱôℓá ℓ !!!]",
    AI: "[!!! Âñϱúïℓℓá ℓ !!!]",
    AQ: "[!!! Âñƭářçƭïçá ℓô !!!]",
    AG: "[!!! Âñƭïϱúá áñδ ßářβúδá ℓôřè₥ !!!]",
    AR: "[!!! Âřϱèñƭïñá ℓô !!!]",
    AM: "[!!! Âř₥èñïá ℓ !!!]",
    AW: "[!!! Âřúβá ℓ !!!]",
    AU: "[!!! Âúƨƭřáℓïá ℓô !!!]",
    AT: "[!!! Âúƨƭřïá ℓ !!!]",
    AZ: "[!!! ÂƺèřβáïJáñ ℓô !!!]",
    BS: "[!!! ßáλá₥áƨ ℓ !!!]",
    BH: "[!!! ßáλřáïñ ℓ !!!]",
    BD: "[!!! ßáñϱℓáδèƨλ ℓô !!!]",
    BB: "[!!! ßářβáδôƨ ℓ !!!]",
    BY: "[!!! ßèℓářúƨ ℓ !!!]",
    BE: "[!!! ßèℓϱïú₥ ℓ !!!]",
    BZ: "[!!! ßèℓïƺè ℓ !!!]",
    BJ: "[!!! ßèñïñ ℓ !!!]",
    BM: "[!!! ßèř₥úδá ℓ !!!]",
    BT: "[!!! ßλúƭáñ ℓ !!!]",
    BO: "[!!! ßôℓïƲïá (Þℓúřïñáƭïôñáℓ §ƭáƭè ôƒ) ℓôřè₥ ïƥƨ !!!]",
    BQ: "[!!! ßôñáïřè, §ïñƭ Éúƨƭáƭïúƨ áñδ §áβá ℓôřè₥ ïƥƨ !!!]",
    BA: "[!!! ßôƨñïá áñδ HèřƺèϱôƲïñá ℓôřè₥  !!!]",
    BW: "[!!! ßôƭƨωáñá ℓ !!!]",
    BV: "[!!! ßôúƲèƭ Ìƨℓáñδ ℓôř !!!]",
    BR: "[!!! ßřáƺïℓ ℓ !!!]",
    IO: "[!!! ßřïƭïƨλ Ìñδïáñ Óçèáñ Tèřřïƭôř¥ ℓôřè₥ ïƥ !!!]",
    BN: "[!!! ßřúñèï Ðářúƨƨáℓá₥ ℓôřè !!!]",
    BG: "[!!! ßúℓϱářïá ℓ !!!]",
    BF: "[!!! ßúřƙïñá Fáƨô ℓôř !!!]",
    BI: "[!!! ßúřúñδï ℓ !!!]",
    CV: "[!!! Çáβô Vèřδè ℓô !!!]",
    KH: "[!!! Çá₥βôδïá ℓ !!!]",
    CM: "[!!! Çá₥èřôôñ ℓ !!!]",
    CA: "[!!! Çáñáδá ℓ !!!]",
    KY: "[!!! Çá¥₥áñ Ìƨℓáñδƨ ℓôř !!!]",
    CF: "[!!! Çèñƭřáℓ Âƒřïçáñ Rèƥúβℓïç ℓôřè₥  !!!]",
    TD: "[!!! Çλáδ  !!!]",
    CL: "[!!! Çλïℓè ℓ !!!]",
    CN: "[!!! Çλïñá ℓ !!!]",
    CX: "[!!! Çλřïƨƭ₥áƨ Ìƨℓáñδ ℓôřè !!!]",
    CC: "[!!! Çôçôƨ (Kèèℓïñϱ) Ìƨℓáñδƨ ℓôřè₥  !!!]",
    CO: "[!!! Çôℓô₥βïá ℓ !!!]",
    KM: "[!!! Çô₥ôřôƨ ℓ !!!]",
    CG: "[!!! Çôñϱô ℓ !!!]",
    CD: "[!!! Çôñϱô, Ðè₥ôçřáƭïç Rèƥúβℓïç ôƒ ƭλè ℓôřè₥ ïƥƨ !!!]",
    CK: "[!!! Çôôƙ Ìƨℓáñδƨ ℓôř !!!]",
    CR: "[!!! Çôƨƭá Rïçá ℓô !!!]",
    CI: "[!!! Çôƭè δ'ÌƲôïřè ℓôř !!!]",
    HR: "[!!! Çřôáƭïá ℓ !!!]",
    CU: "[!!! Çúβá  !!!]",
    CW: "[!!! Çúřáçáô ℓ !!!]",
    CY: "[!!! Ç¥ƥřúƨ ℓ !!!]",
    CZ: "[!!! Çƺèçλïá ℓ !!!]",
    DK: "[!!! Ðèñ₥ářƙ ℓ !!!]",
    DJ: "[!!! ÐJïβôúƭï ℓ !!!]",
    DM: "[!!! Ðô₥ïñïçá ℓ !!!]",
    DO: "[!!! Ðô₥ïñïçáñ Rèƥúβℓïç ℓôřè !!!]",
    EC: "[!!! Éçúáδôř ℓ !!!]",
    EG: "[!!! Éϱ¥ƥƭ ℓ !!!]",
    SV: "[!!! Éℓ §áℓƲáδôř ℓô !!!]",
    GQ: "[!!! É9úáƭôřïáℓ Gúïñèá ℓôřè !!!]",
    ER: "[!!! Éřïƭřèá ℓ !!!]",
    EE: "[!!! Éƨƭôñïá ℓ !!!]",
    SZ: "[!!! Éƨωáƭïñï ℓ !!!]",
    ET: "[!!! Éƭλïôƥïá ℓ !!!]",
    FK: "[!!! Fáℓƙℓáñδ Ìƨℓáñδƨ (MáℓƲïñáƨ) ℓôřè₥ ï !!!]",
    FO: "[!!! Fářôè Ìƨℓáñδƨ ℓôř !!!]",
    FJ: "[!!! FïJï  !!!]",
    FI: "[!!! Fïñℓáñδ ℓ !!!]",
    FR: "[!!! Fřáñçè ℓ !!!]",
    GF: "[!!! Fřèñçλ Gúïáñá ℓôř !!!]",
    PF: "[!!! Fřèñçλ Þôℓ¥ñèƨïá ℓôřè !!!]",
    TF: "[!!! Fřèñçλ §ôúƭλèřñ Tèřřïƭôřïèƨ ℓôřè₥ ï !!!]",
    GA: "[!!! Gáβôñ ℓ !!!]",
    GM: "[!!! Gá₥βïá ℓ !!!]",
    GE: "[!!! Gèôřϱïá ℓ !!!]",
    DE: "[!!! Gèř₥áñ¥ ℓ !!!]",
    GH: "[!!! Gλáñá ℓ !!!]",
    GI: "[!!! Gïβřáℓƭář ℓô !!!]",
    GR: "[!!! Gřèèçè ℓ !!!]",
    GL: "[!!! Gřèèñℓáñδ ℓô !!!]",
    GD: "[!!! Gřèñáδá ℓ !!!]",
    GP: "[!!! Gúáδèℓôúƥè ℓô !!!]",
    GU: "[!!! Gúá₥  !!!]",
    GT: "[!!! Gúáƭè₥áℓá ℓô !!!]",
    GG: "[!!! Gúèřñƨè¥ ℓ !!!]",
    GN: "[!!! Gúïñèá ℓ !!!]",
    GW: "[!!! Gúïñèá-ßïƨƨáú ℓôř !!!]",
    GY: "[!!! Gú¥áñá ℓ !!!]",
    HT: "[!!! Háïƭï ℓ !!!]",
    HM: "[!!! Hèářδ Ìƨℓáñδ áñδ MçÐôñáℓδ Ìƨℓáñδƨ ℓôřè₥ ïƥƨ !!!]",
    VA: "[!!! Hôℓ¥ §èè ℓ !!!]",
    HN: "[!!! Hôñδúřáƨ ℓ !!!]",
    HK: "[!!! Hôñϱ Kôñϱ ℓô !!!]",
    HU: "[!!! Húñϱář¥ ℓ !!!]",
    IS: "[!!! Ìçèℓáñδ ℓ !!!]",
    IN: "[!!! Ìñδïá ℓ !!!]",
    ID: "[!!! Ìñδôñèƨïá ℓô !!!]",
    IR: "[!!! Ìřáñ (Ìƨℓá₥ïç Rèƥúβℓïç ôƒ) ℓôřè₥ ï !!!]",
    IQ: "[!!! Ìřá9  !!!]",
    IE: "[!!! Ìřèℓáñδ ℓ !!!]",
    IM: "[!!! Ìƨℓè ôƒ Máñ ℓô !!!]",
    IL: "[!!! Ìƨřáèℓ ℓ !!!]",
    IT: "[!!! Ìƭáℓ¥ ℓ !!!]",
    JM: "[!!! Já₥áïçá ℓ !!!]",
    JP: "[!!! Jáƥáñ ℓ !!!]",
    JE: "[!!! Jèřƨè¥ ℓ !!!]",
    JO: "[!!! Jôřδáñ ℓ !!!]",
    KZ: "[!!! Káƺáƙλƨƭáñ ℓô !!!]",
    KE: "[!!! Kèñ¥á ℓ !!!]",
    KI: "[!!! Kïřïβáƭï ℓ !!!]",
    KP: "[!!! Kôřèá (Ðè₥ôçřáƭïç Þèôƥℓè'ƨ Rèƥúβℓïç ôƒ) ℓôřè₥ ïƥƨú₥ !!!]",
    KR: "[!!! Kôřèá, Rèƥúβℓïç ôƒ ℓôřè !!!]",
    KW: "[!!! Kúωáïƭ ℓ !!!]",
    KG: "[!!! K¥řϱ¥ƺƨƭáñ ℓô !!!]",
    LA: "[!!! £áô Þèôƥℓè'ƨ Ðè₥ôçřáƭïç Rèƥúβℓïç ℓôřè₥ ïƥƨ !!!]",
    LV: "[!!! £áƭƲïá ℓ !!!]",
    LB: "[!!! £èβáñôñ ℓ !!!]",
    LS: "[!!! £èƨôƭλô ℓ !!!]",
    LR: "[!!! £ïβèřïá ℓ !!!]",
    LY: "[!!! £ïβ¥á ℓ !!!]",
    LI: "[!!! £ïèçλƭèñƨƭèïñ ℓôř !!!]",
    LT: "[!!! £ïƭλúáñïá ℓô !!!]",
    LU: "[!!! £úжè₥βôúřϱ ℓô !!!]",
    MO: "[!!! Máçáô ℓ !!!]",
    MG: "[!!! Máδáϱáƨçář ℓô !!!]",
    MW: "[!!! Máℓáωï ℓ !!!]",
    MY: "[!!! Máℓá¥ƨïá ℓ !!!]",
    MV: "[!!! MáℓδïƲèƨ ℓ !!!]",
    ML: "[!!! Máℓï  !!!]",
    MT: "[!!! Máℓƭá ℓ !!!]",
    MH: "[!!! Mářƨλáℓℓ Ìƨℓáñδƨ ℓôřè !!!]",
    MQ: "[!!! Mářƭïñï9úè ℓô !!!]",
    MR: "[!!! Máúřïƭáñïá ℓô !!!]",
    MU: "[!!! Máúřïƭïúƨ ℓô !!!]",
    YT: "[!!! Má¥ôƭƭè ℓ !!!]",
    MX: "[!!! Mèжïçô ℓ !!!]",
    FM: "[!!! Mïçřôñèƨïá (Fèδèřáƭèδ §ƭáƭèƨ ôƒ) ℓôřè₥ ïƥƨ !!!]",
    MD: "[!!! MôℓδôƲá, Rèƥúβℓïç ôƒ ℓôřè₥ !!!]",
    MC: "[!!! Môñáçô ℓ !!!]",
    MN: "[!!! Môñϱôℓïá ℓ !!!]",
    ME: "[!!! Môñƭèñèϱřô ℓô !!!]",
    MS: "[!!! Môñƭƨèřřáƭ ℓô !!!]",
    MA: "[!!! Môřôççô ℓ !!!]",
    MZ: "[!!! Môƺá₥βï9úè ℓô !!!]",
    MM: "[!!! M¥áñ₥ář ℓ !!!]",
    NA: "[!!! Ná₥ïβïá ℓ !!!]",
    NR: "[!!! Náúřú ℓ !!!]",
    NP: "[!!! Nèƥáℓ ℓ !!!]",
    NL: "[!!! Nèƭλèřℓáñδƨ ℓô !!!]",
    NC: "[!!! Nèω Çáℓèδôñïá ℓôř !!!]",
    NZ: "[!!! Nèω Zèáℓáñδ ℓô !!!]",
    NI: "[!!! Nïçářáϱúá ℓô !!!]",
    NE: "[!!! Nïϱèř ℓ !!!]",
    NG: "[!!! Nïϱèřïá ℓ !!!]",
    NU: "[!!! Nïúè  !!!]",
    NF: "[!!! Nôřƒôℓƙ Ìƨℓáñδ ℓôř !!!]",
    MK: "[!!! Nôřƭλ Máçèδôñïá ℓôřè !!!]",
    MP: "[!!! Nôřƭλèřñ Mářïáñá Ìƨℓáñδƨ ℓôřè₥  !!!]",
    NO: "[!!! Nôřωá¥ ℓ !!!]",
    OM: "[!!! Ó₥áñ  !!!]",
    PK: "[!!! Þáƙïƨƭáñ ℓ !!!]",
    PW: "[!!! Þáℓáú ℓ !!!]",
    PS: "[!!! Þáℓèƨƭïñè, §ƭáƭè ôƒ ℓôřè₥ !!!]",
    PA: "[!!! Þáñá₥á ℓ !!!]",
    PG: "[!!! Þáƥúá Nèω Gúïñèá ℓôřè !!!]",
    PY: "[!!! Þářáϱúá¥ ℓ !!!]",
    PE: "[!!! Þèřú  !!!]",
    PH: "[!!! Þλïℓïƥƥïñèƨ ℓô !!!]",
    PN: "[!!! Þïƭçáïřñ ℓ !!!]",
    PL: "[!!! Þôℓáñδ ℓ !!!]",
    PT: "[!!! Þôřƭúϱáℓ ℓ !!!]",
    PR: "[!!! Þúèřƭô Rïçô ℓô !!!]",
    QA: "[!!! Qáƭář ℓ !!!]",
    RE: "[!!! Réúñïôñ ℓ !!!]",
    RO: "[!!! Rô₥áñïá ℓ !!!]",
    RU: "[!!! Rúƨƨïáñ Fèδèřáƭïôñ ℓôřè !!!]",
    RW: "[!!! Rωáñδá ℓ !!!]",
    BL: "[!!! §áïñƭ ßářƭλéℓè₥¥ ℓôřè !!!]",
    SH: "[!!! §áïñƭ Hèℓèñá, Âƨçèñƨïôñ áñδ Třïƨƭáñ δá Çúñλá ℓôřè₥ ïƥƨú₥  !!!]",
    KN: "[!!! §áïñƭ Kïƭƭƨ áñδ NèƲïƨ ℓôřè₥ !!!]",
    LC: "[!!! §áïñƭ £úçïá ℓô !!!]",
    MF: "[!!! §áïñƭ Mářƭïñ (Fřèñçλ ƥářƭ) ℓôřè₥ ï !!!]",
    PM: "[!!! §áïñƭ Þïèřřè áñδ Mï9úèℓôñ ℓôřè₥ ï !!!]",
    VC: "[!!! §áïñƭ Vïñçèñƭ áñδ ƭλè Gřèñáδïñèƨ ℓôřè₥ ïƥƨ !!!]",
    WS: "[!!! §á₥ôá ℓ !!!]",
    SM: "[!!! §áñ Mářïñô ℓô !!!]",
    ST: "[!!! §áô Tô₥è áñδ Þřïñçïƥè ℓôřè₥ !!!]",
    SA: "[!!! §áúδï Âřáβïá ℓôř !!!]",
    SN: "[!!! §èñèϱáℓ ℓ !!!]",
    RS: "[!!! §èřβïá ℓ !!!]",
    SC: "[!!! §è¥çλèℓℓèƨ ℓô !!!]",
    SL: "[!!! §ïèřřá £èôñè ℓôř !!!]",
    SG: "[!!! §ïñϱáƥôřè ℓô !!!]",
    SX: "[!!! §ïñƭ Máářƭèñ (Ðúƭçλ ƥářƭ) ℓôřè₥ ï !!!]",
    SK: "[!!! §ℓôƲáƙïá ℓ !!!]",
    SI: "[!!! §ℓôƲèñïá ℓ !!!]",
    SB: "[!!! §ôℓô₥ôñ Ìƨℓáñδƨ ℓôřè !!!]",
    SO: "[!!! §ô₥áℓïá ℓ !!!]",
    ZA: "[!!! §ôúƭλ Âƒřïçá ℓôř !!!]",
    GS: "[!!! §ôúƭλ Gèôřϱïá áñδ ƭλè §ôúƭλ §áñδωïçλ Ìƨℓáñδƨ ℓôřè₥ ïƥƨú₥  !!!]",
    SS: "[!!! §ôúƭλ §úδáñ ℓô !!!]",
    ES: "[!!! §ƥáïñ ℓ !!!]",
    LK: "[!!! §řï £áñƙá ℓô !!!]",
    SD: "[!!! §úδáñ ℓ !!!]",
    SR: "[!!! §úřïñá₥è ℓ !!!]",
    SJ: "[!!! §Ʋáℓβářδ áñδ Jáñ Má¥èñ ℓôřè₥  !!!]",
    SE: "[!!! §ωèδèñ ℓ !!!]",
    CH: "[!!! §ωïƭƺèřℓáñδ ℓô !!!]",
    SY: "[!!! §¥řïáñ Âřáβ Rèƥúβℓïç ℓôřè₥ !!!]",
    TW: "[!!! Táïωáñ, ÞřôƲïñçè ôƒ Çλïñá ℓôřè₥ ï !!!]",
    TJ: "[!!! TáJïƙïƨƭáñ ℓô !!!]",
    TZ: "[!!! Táñƺáñïá, Ûñïƭèδ Rèƥúβℓïç ôƒ ℓôřè₥ ï !!!]",
    TH: "[!!! Tλáïℓáñδ ℓ !!!]",
    TL: "[!!! Tï₥ôř-£èƨƭè ℓô !!!]",
    TG: "[!!! Tôϱô  !!!]",
    TK: "[!!! Tôƙèℓáú ℓ !!!]",
    TO: "[!!! Tôñϱá ℓ !!!]",
    TT: "[!!! Třïñïδáδ áñδ Tôβáϱô ℓôřè₥ !!!]",
    TN: "[!!! Túñïƨïá ℓ !!!]",
    TR: "[!!! Tüřƙï¥è ℓ !!!]",
    TM: "[!!! Túřƙ₥èñïƨƭáñ ℓôř !!!]",
    TC: "[!!! Túřƙƨ áñδ Çáïçôƨ Ìƨℓáñδƨ ℓôřè₥  !!!]",
    TV: "[!!! TúƲáℓú ℓ !!!]",
    UG: "[!!! Ûϱáñδá ℓ !!!]",
    UA: "[!!! Ûƙřáïñè ℓ !!!]",
    AE: "[!!! Ûñïƭèδ Âřáβ É₥ïřáƭèƨ ℓôřè₥ !!!]",
    GB: "[!!! Ûñïƭèδ Kïñϱδô₥ ôƒ Gřèáƭ ßřïƭáïñ áñδ Nôřƭλèřñ Ìřèℓáñδ ℓôřè₥ ïƥƨú₥ δôℓ !!!]",
    US: "[!!! Ûñïƭèδ §ƭáƭèƨ ôƒ Â₥èřïçá ℓôřè₥  !!!]",
    UM: "[!!! Ûñïƭèδ §ƭáƭèƨ Mïñôř Óúƭℓ¥ïñϱ Ìƨℓáñδƨ ℓôřè₥ ïƥƨú !!!]",
    UY: "[!!! Ûřúϱúá¥ ℓ !!!]",
    UZ: "[!!! Ûƺβèƙïƨƭáñ ℓô !!!]",
    VU: "[!!! Váñúáƭú ℓ !!!]",
    VE: "[!!! Vèñèƺúèℓá (ßôℓïƲářïáñ Rèƥúβℓïç ôƒ) ℓôřè₥ ïƥƨ !!!]",
    VN: "[!!! Vïèƭ Ná₥ ℓ !!!]",
    VG: "[!!! Vïřϱïñ Ìƨℓáñδƨ (ßřïƭïƨλ) ℓôřè₥  !!!]",
    VI: "[!!! Vïřϱïñ Ìƨℓáñδƨ (Û.§.) ℓôřè₥ !!!]",
    WF: "[!!! Wáℓℓïƨ áñδ Fúƭúñá ℓôřè !!!]",
    EH: "[!!! Wèƨƭèřñ §áλářá ℓôř !!!]",
    YE: "[!!! Ýè₥èñ ℓ !!!]",
    ZM: "[!!! Zá₥βïá ℓ !!!]",
    ZW: "[!!! Zï₥βáβωè ℓ !!!]",
};

const es = {
    // Login/Reset Password
    "email": 'Correo electrónico',
    "password": 'Contraseña',
    "sign_in": 'Acceder',
    "continue": "Continuar",
    "forgot_password": 'Olvidé mi contraseña',
    "reset_password": 'Restablecer contraseña',
    "reset_password_instructions": 'Para restablecer su contraseña, ingrese su dirección de correo electrónico arriba y le enviaremos instrucciones, si la cuenta existe.',
    "sent_reset_password_code": 'Hemos enviado un código de restablecimiento de contraseña a [email]. Ingrese dicho código y una nueva contraseña.',
    "reset_code": 'Código de restablecimiento',
    "new_password": 'Nueva contraseña',
    "reenter_new_password": 'Vuelva a ingresar la nueva contraseña',
    "must_include_email": 'Debe incluir correo electrónico',
    "old_password": 'Contraseña anterior',
    "set_new_password": 'Establecer nueva contraseña',
    "password_expired": 'La contraseña ha expirado',
    "toggle_password_visibility": 'Alternar la visibilidad de la contraseña',
    "change_your_password": 'Cambia la contraseña',
    "change_password": 'Cambia tu contraseña',
    "set_password": 'Configurar la contraseña',
    "login_title_text": "Iniciar Sesión",
    "try_again": "Intentar de Nuevo",
    "login_error_message": "No pudimos encontrar a su usuario. Puede intentarlo de nuevo o contactar a su administrador de cuentas.",
    "invalid_login_credentials_error_message": "Combinación incorrecta de usuario y contraseña o el usuario no existe.",
    "enter_password_reset_code": "Por favor, introduzca el código que enviamos a la cuenta [email].",
    "repeat-new-password": "Repetir Nueva Contraseña",
    "send-code": "Enviar código",
    "okta-sign-in": "Iniciar sesión con Okta",
    "google-sign-in": "Iniciar sesión con Google",
    "microsoft-sign-in": "Iniciar sesión con Microsoft",
    "or": "O",
    "already_have_reset_code": "Ya tengo un código de restablecimiento",
    "contact_manager_for_account": "Para nuevas cuentas, por favor contacte a su gerente",
    // ListUsers
    "search_enter_4_chars": 'Por favor, ingrese al menos 4 caracteres para buscar',
    "user_search_placeholder_email": 'Buscar por el comienzo de un correo electrónico',
    "user_search_placeholder": 'Buscar por el comienzo de un correo electrónico, gerente o grupo',
    "no_users_found": 'No se encontraron usuarios',
    // Sidebar
    "users": 'Usuarios',
    "main_settings": 'Configuración principal',
    "terminology": 'Terminología',
    "equipment": 'Equipo',
    "security": 'Seguridad',
    "tenants": 'Inquilinos',
    "collapse": 'Contraer',
    // Users List
    "add_user": 'Agregar usuario',
    "edit_user": 'Editar usuario',
    "bulk_import": 'Importación masiva',
    "bulk_import_users": 'Importación masiva de usuarios',
    "add_group": 'Agregar grupo',
    "manage_users": 'Gestionar usuarios',
    "manage_groups": 'Gestionar grupo',
    "show_roles_list": 'Mostrar lista de roles',
    "show_disabled_users": 'Mostrar usuarios deshabilitados',
    "name": 'Nombre',
    "role": 'Rol',
    "roles": 'Roles',
    "role_name": 'Nombre del rol',
    "role_description": 'Descripción del rol',
    "role_id": 'ID del rol',
    "location": 'Ubicación',
    "routethis_group": 'Grupo RouteThis',
    "manager": 'Gerente',
    "download_bulk_template": 'Descargar plantilla masiva',
    "user_id_email": 'ID de usuario (correo electrónico)',
    "users_for": 'Usuarios para:',
    // Valid User roles
    "user_role": 'usuario',
    "tenant_admin_role": 'AdminInquilinos',
    "super_admin_role": 'SuperAdmin',
    "user": 'Usuario',
    "tenant_admin": 'Administrador de inquilinos',
    "super_admin": 'Superadministrador',
    // Create/Edit User Modal
    "email_required": 'Correo electrónico (obligatorio)',
    "first_name": 'Nombre',
    "last_name": 'Apellidos',
    "force_password_reset": 'Forzar restablecimiento de contraseña',
    "resend_validation_code": 'Reenviar código de validación',
    "enable_users": 'Habilitar usuarios',
    "disable_users": 'Deshabilitar usuarios',
    "certify": 'Certificar',
    "unverified": 'No verificado',
    "verified": 'Verificado',
    "locked_out": 'Bloqueado',
    "disabled": 'Deshabilitado',
    "save": 'Guardar',
    "reset_user_password_confirmation": '¿Está seguro de que desea restablecer la contraseña de este usuario?',
    "resend_validation_code_confirmation": '¿Está seguro de que desea reenviar el código de validación?',
    "cannot_disable_yourself": 'No puede deshabilitarse a sí mismo',
    "cancel_changes": 'Cancelar cambios',
    "required": 'Requerido',
    "password_email_template": 'Plantilla de correo electrónico para la contraseña',
    "include_in_resolve_usage_reports": 'Incluir en los informes de uso de Resolve',
    "delete_user": 'Eliminar usuario',
    "delete_are_you_sure": '¿Está seguro de que desea eliminar este usuario? ADVERTENCIA: Esta acción es irreversible.',
    "delete": 'Eliminar',
    // Create/Edit Group modal:
    "create_group": 'Crear grupo',
    "edit_group": 'Editar grupo',
    "group_name": 'Nombre del grupo',
    "group_type": 'Tipo de grupo',
    "search_by_group_name": 'Buscar por nombre de grupo',
    "search_by_role_name": 'Buscar por nombre de rol',
    // Bulk Import Modal
    "csv_format_requirements": 'Formato de CSV: correo electrónico, nombre, apellidos, rol (solo es obligatorio el correo electrónico)',
    "valid_user_roles": 'Roles de usuario válidos: "user", "TenantAdmin", "SuperAdmin"',
    "select_csv": 'Seleccionar CSV',
    "import": 'Importar',
    "file_too_large": 'Archivo demasiado grande (máximo 500 usuarios)',
    "required_headers_missing": 'Faltan encabezados obligatorios: correo electrónico',
    "user_import_starting": 'Importación de usuarios iniciada. Recibirá un correo electrónico con el resumen de la importación en unos minutos.',
    // Tenant Main Settings
    "email_language": 'Idioma de correo electrónico',
    "country": 'País',
    "description_optional": 'Descripción (opcional)',
    "units_feet_meters": 'Unidades (pies, metros)',
    "certify_id": 'Certify ID',
    "resolve_id": 'Resolve ID',
    "sms_from": 'SMS de',
    "sms_body": 'Cuerpo del SMS',
    "default_sms_body": '¡Su instalación wifi se ha completado y ha sido certificada por [NAME]! Vea su certificado aquí: [LINK]',
    "sms_body_helper_text": 'Al certificar, se enviará este mensaje de texto al cliente. [LINK] se sustituirá por un enlace al certificado (obligatorio). [NAME] se sustituirá por el contenido del campo "Nombre" (opcional)',
    "link_must_be_in_sms_body": '[LINK] debe estar en el cuerpo del SMS.',
    "update_successful": 'Actualización correcta',
    "creation_successful": 'Creación correcta',
    // Tenant Terminology Settings
    "term": 'Término',
    "example_usage": 'Ejemplo de uso',
    "customer_example_usage_1": 'Tras consultar al cliente, confirme el edificio seleccionado o vuelva a editar la dirección.',
    "customer_example_usage_2": 'Tras consultar al abonado, confirme el edificio seleccionado o vuelva a editar la dirección.',
    "router_example_usage_1": 'Pulse en la ubicación propuesta del enrutador a continuación.',
    "router_example_usage_2": 'Pulse en la ubicación propuesta del módem a continuación.',
    "router_example_usage_3": 'Pulse en la ubicación propuesta de la puerta de enlace a continuación.',
    "router_example_usage_4": 'Pulse en la ubicación propuesta del concentrador a continuación.',
    "router_example_usage_5": 'Pulse en la ubicación propuesta del enrutador a continuación.',
    "level_example_usage_1": 'Vaya al 2.º nivel y pulse en su ubicación.',
    "level_example_usage_2": 'Vaya al 2.º piso y pulse en su ubicación.',
    "mesh_pod_example_usage_1": 'Estimación de la intensidad de la señal y ubicación óptima de las cápsulas de malla.',
    "mesh_pod_example_usage_2": 'Estimación de la intensidad de la señal y ubicación óptima de los puntos de acceso.',
    "mesh_pod_example_usage_3": 'Estimación de la intensidad de la señal y ubicación óptima de los nodos de malla.',
    "mesh_pod_example_usage_4": 'Estimación de la intensidad de la señal y ubicación óptima de los discos de malla.',
    "mesh_pod_example_usage_5": 'Estimación de la intensidad de la señal y ubicación óptima de las balizas.',
    "mesh_pod_example_usage_6": 'Estimación de la intensidad de la señal y ubicación óptima de las cápsulas de malla.',
    "wifi_example_usage_1": 'Mapeo WiFi',
    "wifi_example_usage_2": 'Mapeo Wi-Fi',
    "wifi_example_usage_3": 'Mapeo wifi',
    "wifi_example_usage_4": 'Mapeo WIFI',
    // Tenant Equipment Settings (Certify)
    "router_options_1": 'Opciones del enrutador',
    "router_options_2": 'Opciones del módem',
    "router_options_3": 'Opciones de la puerta de enlace',
    "router_options_4": 'Opciones del concentrador',
    "router_options_5": 'Opciones del enrutador',
    "new_router_options_1": 'Nuevas opciones del enrutador',
    "new_router_options_2": 'Nuevas opciones de módem',
    "new_router_options_3": 'Nuevas opciones de la puerta de enlace',
    "new_router_options_4": 'Nuevas opciones del concentrador',
    "new_router_options_5": 'Nuevas opciones del enrutador',
    "mesh_pod_options_1": 'Opciones de las cápsulas de malla',
    "mesh_pod_options_2": 'Opciones de los puntos de acceso',
    "mesh_pod_options_3": 'Opciones de los nodos de malla',
    "mesh_pod_options_4": 'Opciones de los discos de malla',
    "mesh_pod_options_5": 'Opciones de las balizas',
    "mesh_pod_options_6": 'Opciones de las cápsulas de malla',
    "new_mesh_pod_options_1": 'Nuevas opciones de vainas de malla',
    "new_mesh_pod_options_2": 'Nuevas opciones de puntos de acceso',
    "new_mesh_pod_options_3": 'Nuevas opciones de nodos de malla',
    "new_mesh_pod_options_4": 'Nuevas opciones de discos de malla',
    "new_mesh_pod_options_5": 'Nuevas opciones de señalización',
    "new_mesh_pod_options_6": 'Nuevas opciones de vainas de malla',
    "missing_required_router_info_1": 'Falta la información requerida del router',
    "missing_required_router_info_2": 'Falta la información requerida del módem',
    "missing_required_router_info_3": 'Falta la información requerida de la puerta de enlace',
    "missing_required_router_info_4": 'Falta la información requerida del hub',
    "missing_required_router_info_5": 'Falta la información requerida del router',
    "missing_required_mesh_pod_info_1": 'Falta la información requerida de la vaina de malla',
    "missing_required_mesh_pod_info_2": 'Falta información del punto de acceso requerido',
    "missing_required_mesh_pod_info_3": 'Falta información requerida del nodo de malla',
    "missing_required_mesh_pod_info_4": 'Falta información sobre el disco de malla requerido',
    "missing_required_mesh_pod_info_5": 'Falta la información de la baliza requerida',
    "missing_required_mesh_pod_info_6": 'Falta la información requerida de la vaina de malla',
    "display_name": 'Alias',
    "description": 'Descripción',
    "range_in_unit_1": 'Alcance en pies',
    "range_in_unit_2": 'Alcance en metros',
    "area_in_unit_1": 'Área en Pies Cuadrados',
    "area_in_unit_2": 'Área en Metros Cuadrado',
    "default_active": 'Activo por defecto',
    "average_range": 'Alcance medio',
    "certify_default": 'Certificar por defecto',
    "default": 'Predeterminado',
    "active": 'Activo',
    "one_option_must_be_default": 'Una opción debe ser la predeterminada',
    "set_as_default": 'Establecer como predeterminado',
    "default_option_must_be_active": 'La opción predeterminada debe estar activa',
    "deactivate": 'Desactivar',
    "activate": 'Activar',
    "name_is_required": 'El nombre es obligatorio',
    // Customer Name
    "customer_1": 'Cliente',
    "customer_2": 'Abonado',
    // Pod Name
    "pod_1": "Pod de malla",
    "pod_2": "Punto de acceso",
    "pod_3": "Nodo de malla",
    "pod_4": "Puck de malla",
    "pod_5": "Baliza",
    "pod_6": "Pod de malla",
    "pod_7": 'Amplificador Wi-Fi',
    "pods_1": "Pods de malla",
    "pods_2": "Puntos de acceso",
    "pods_3": "Nodos de malla",
    "pods_4": "Pucks de malla",
    "pods_5": "Balizas",
    "pods_6": "Pods de malla",
    "pods_7": 'Amplificadores Wi-Fi',
    // Router Name
    "router_1": "Router",
    "router_2": "Módem",
    "router_3": "Puerta de enlace",
    "router_4": "Concentrador",
    "router_5": "Módem de Internet",
    // Level Name
    "level_1": "Nivel",
    "level_2": "Piso",
    "levels_1": "Niveles",
    "levels_2": "Plantas",
    // Wifi Name
    "wifi_1": 'WiFi',
    "wifi_2": 'Wi-Fi',
    "wifi_3": 'Wifi',
    "wifi_4": 'WIFI',
    // Units
    "units_1": 'Pies',
    "units_2": 'Metros',
    // Pod Info
    "recommended": 'Recom.',
    "installed": 'Instalado',
    "total": 'Total',
    // Misc
    "confirm": 'Confirmar',
    "units": 'Unidades',
    "region": 'Región',
    "edit": 'Edit',
    "modified": 'Modificada',
    "create": 'Crear',
    "created": 'Creada',
    "routethis_app": 'Aplicación RouteThis',
    "loading": 'Cargando…',
    "redirecting": 'Redirigiendo…',
    "error": 'Error',
    "cancel": 'Cancelar',
    "close": 'Cerrar',
    "account_holder": 'Titular de la cuenta',
    "all": 'Todos',
    "dismiss": 'DESCARTAR',
    "search": 'Buscar',
    "unauthenticated_login_again": "No autenticado. Por favor, inicie sesión nuevamente.",
    // Languages
    "en": 'Inglés (Estados Unidos)',
    'en-GB': 'Inglés (Reino Unido)',
    "da": 'Danés',
    "fi": 'Finlandés',
    "fr": 'Francés',
    'fr-CA': 'Francés (Canadá)',
    "de": 'Alemán',
    "el": 'Griego',
    "it": 'Italiano',
    "pt": 'Portugués',
    'pt-BR': 'Portugués (Brasil)',
    "es": 'Español',
    'es-419': 'Español (Latinoamérica)',
    "sv": 'Sueco',
    // Client-side validation errors
    "incorrect_email_or_password": 'Correo electrónico o contraseña incorrectos, o cuenta desactivada. Inténtelo de nuevo o póngase en contacto con un administrador.',
    "invalid_reset_code": 'Código de restablecimiento no válido',
    "password_minimum_requirements": 'La contraseña debe tener un mínimo de 8 caracteres e incluir al menos una minúscula, una mayúscula y un número.',
    "password_minimum_requirements_shortened": "Mínimo 8 caracteres, una mayúscula y un número",
    "passwords_must_match": 'Las contraseñas deben coincidir',
    "must_include_new_password_email": 'Debe incluir una nueva contraseña y un correo electrónico de usuario',
    "must_include_new_password_confirmation_code": 'Debe incluir una nueva contraseña y un código de confirmación',
    "cannot_send_reset_code_without_email": 'No se puede enviar el código de restablecimiento sin correo electrónico',
    "must_enter_old_password": 'Debes ingresar tu antigua contraseña',
    "must_enter_reset_code": 'Debe introducir el código de reinicio',
    "must_enter_new_password": 'Debe introducir una nueva contraseña',
    "passwords_cannot_begin_or_end_with_spaces": 'Las contraseñas no pueden empezar ni terminar con espacios',
    // Server-side errors
    'User with that email already exists': "El usuario con ese correo electrónico ya existe",
    'Try another display name': "Pruebe con otro nombre de usuario",
    'Password cannot be a previously used password': "La contraseña no puede ser una contraseña utilizada anteriormente",
    'Invalid reset code': "Código de restablecimiento no válido",
    'Incorrect email or password, or disabled account. Try again or contact an administrator.': "Correo electrónico o contraseña incorrectos, o cuenta desactivada. Inténtelo de nuevo o póngase en contacto con un administrador.",
    'Invalid code provided, please request a code again.': 'El código proporcionado es inválido. Solicite un código de nuevo.',
    'Password cannot begin or end with spaces': "Las contraseñas no pueden empezar ni terminar con espacios",
    'LimitExceededException - Attempt limit exceeded, please try after some time.': "Ha excedido el límite de intentos permitidos. Vuelva a intentarlo más tarde.",
    'User is not Authorized': "Usuario no autorizado",
    'Your session timed out. Sign in again with your temporary password.': "Su sesión ha finalizado. Inicie sesión de nuevo con su contraseña temporal.",
    'Internal Service Failure - Cognito Unavailable': "Cognito no disponible",
    'Internal Service Failure - Unknown Failure': "Falla desconocida",
    'Must enter Reset Code': 'Debe introducir el código de reinicio',
    // Change Password Challenges
    "step_1_of_2": "Paso 1 de 2",
    "step_2_of_2": "Paso 2 de 2",
    "set_password_challenge": 'Por motivos de seguridad, debe establecer una nueva contraseña la primera vez que inicie sesión.',
    "reset_password_challenge": 'Hemos enviado un código de restablecimiento de contraseña a [EMAIL]. Introduzca ese código y una nueva contraseña.',
    "set_new_password_challenge": 'La política de su empresa requiere que su contraseña caduque después de un tiempo. Hemos enviado un código de restablecimiento de contraseña a [EMAIL]. Introduzca ese código y una nueva contraseña.',
    "change_your_password_challenge": 'Introduzca su contraseña actual y una nueva contraseña a continuación para cambiarla.',
    "change_password_challenge": 'Introduzca una nueva contraseña para el usuario',
    "reset_password_challenge_instructions": "Enviaremos al correo [EMAIL] un código de restablecimiento y más instrucciones para crear una nueva contraseña.",
    AF: 'Afganistán',
    AX: 'Islas Åland',
    AL: 'Albania',
    DZ: 'Argelia',
    AS: 'Samoa Americana',
    AD: 'Andorra',
    AO: 'Angola',
    AI: 'Anguila',
    AQ: 'Antártida',
    AG: 'Antigua y Barbuda',
    AR: 'Argentina',
    AM: 'Armenia',
    AW: 'Aruba',
    AU: 'Australia',
    AT: 'Austria',
    AZ: 'Azerbaiyán',
    BS: 'Bahamas',
    BH: 'Baréin',
    BD: 'Bangladés',
    BB: 'Barbados',
    BY: 'Bielorrusia',
    BE: 'Bélgica',
    BZ: 'Belice',
    BJ: 'Benín',
    BM: 'Bermudas',
    BT: 'Bután',
    BO: 'Bolivia (Estado Plurinacional de)',
    BQ: 'Bonaire, San Eustaquio y Saba',
    BA: 'Bosnia y Herzegovina',
    BW: 'Botsuana',
    BV: 'Isla Bouvet',
    BR: 'Brasil',
    IO: 'Territorio Británico del Océano Índico',
    BN: 'Brunéi',
    BG: 'Bulgaria',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    CV: 'Cabo Verde',
    KH: 'Camboya',
    CM: 'Camerún',
    CA: 'Canadá',
    KY: 'Islas Caimán',
    CF: 'República Centroafricana',
    TD: 'Chad',
    CL: 'Chile',
    CN: 'China',
    CX: 'Isla de Navidad',
    CC: 'Islas Cocos (Keeling)',
    CO: 'Colombia',
    KM: 'Comoras',
    CG: 'Congo',
    CD: 'Congo, República Democrática del',
    CK: 'Islas Cook',
    CR: 'Costa Rica',
    CI: 'Costa de Marfil',
    HR: 'Croacia',
    CU: 'Cuba',
    CW: 'Curazao',
    CY: 'Chipre',
    CZ: 'República Checa',
    DK: 'Dinamarca',
    DJ: 'Yibuti',
    DM: 'Dominica',
    DO: 'República Dominicana',
    EC: 'Ecuador',
    EG: 'Egipto',
    SV: 'El Salvador',
    GQ: 'Guinea Ecuatorial',
    ER: 'Eritrea',
    EE: 'Estonia',
    SZ: 'Suazilandia',
    ET: 'Etiopía',
    FK: 'Islas Malvinas',
    FO: 'Islas Feroe',
    FJ: 'Fiyi',
    FI: 'Finlandia',
    FR: 'Francia',
    GF: 'Guayana Francesa',
    PF: 'Polinesia Francesa',
    TF: 'Territorios Australes Franceses',
    GA: 'Gabón',
    GM: 'Gambia',
    GE: 'Georgia',
    DE: 'Alemania',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GR: 'Grecia',
    GL: 'Groenlandia',
    GD: 'Granada',
    GP: 'Guadalupe',
    GU: 'Guam',
    GT: 'Guatemala',
    GG: 'Guernsey',
    GN: 'Guinea',
    GW: 'Guinea-Bisáu',
    GY: 'Guyana',
    HT: 'Haití',
    HM: 'Isla Heard e Islas McDonald',
    VA: 'Santa Sede',
    HN: 'Honduras',
    HK: 'Hong Kong',
    HU: 'Hungría',
    IS: 'Islandia',
    IN: 'India',
    ID: 'Indonesia',
    IR: 'Irán (República Islámica de)',
    IQ: 'Irak',
    IE: 'Irlanda',
    IM: 'Isla de Man',
    IL: 'Israel',
    IT: 'Italia',
    JM: 'Jamaica',
    JP: 'Japón',
    JE: 'Jersey',
    JO: 'Jordania',
    KZ: 'Kazajistán',
    KE: 'Kenia',
    KI: 'Kiribati',
    KP: 'Corea (República Popular Democrática de)',
    KR: 'Corea, República de',
    KW: 'Kuwait',
    KG: 'Kirguistán',
    LA: 'República Democrática Popular Lao',
    LV: 'Letonia',
    LB: 'Líbano',
    LS: 'Lesoto',
    LR: 'Liberia',
    LY: 'Libia',
    LI: 'Liechtenstein',
    LT: 'Lituania',
    LU: 'Luxemburgo',
    MO: 'Macao',
    MG: 'Madagascar',
    MW: 'Malaui',
    MY: 'Malasia',
    MV: 'Maldivas',
    ML: 'Mali',
    MT: 'Malta',
    MH: 'Islas Marshall',
    MQ: 'Martinica',
    MR: 'Mauritania',
    MU: 'Mauricio',
    YT: 'Mayotte',
    MX: 'México',
    FM: 'Micronesia (Estados Federados de)',
    MD: 'Moldavia, República de',
    MC: 'Mónaco',
    MN: 'Mongolia',
    ME: 'Montenegro',
    MS: 'Montserrat',
    MA: 'Marruecos',
    MZ: 'Mozambique',
    MM: 'Birmania',
    NA: 'Namibia',
    NR: 'Nauru',
    NP: 'Nepal',
    NL: 'Países Bajos',
    NC: 'Nueva Caledonia',
    NZ: 'Nueva Zelanda',
    NI: 'Nicaragua',
    NE: 'Níger',
    NG: 'Nigeria',
    NU: 'Niue',
    NF: 'Isla de Norfolk',
    MK: 'Macedonia del Norte',
    MP: 'Islas Marianas del Norte',
    NO: 'Noruega',
    OM: 'Omán',
    PK: 'Pakistán',
    PW: 'Palaos',
    PS: 'Palestina, Estado de',
    PA: 'Panamá',
    PG: 'Papúa Nueva Guinea',
    PY: 'Paraguay',
    PE: 'Perú',
    PH: 'Filipinas',
    PN: 'Pitcairn',
    PL: 'Polonia',
    PT: 'Portugal',
    PR: 'Puerto Rico',
    QA: 'Catar',
    RE: 'Reunión',
    RO: 'Rumanía',
    RU: 'Federación de Rusia',
    RW: 'Ruanda',
    BL: 'San Bartolomé',
    SH: 'Santa Elena, Ascensión y Tristán da Acuña',
    KN: 'San Cristóbal y Nieves',
    LC: 'Santa Lucía',
    MF: 'San Martín (Francia)',
    PM: 'San Pedro y Miquelón',
    VC: 'San Vicente y las Granadinas',
    WS: 'Samoa',
    SM: 'San Marino',
    ST: 'Santo Tomé y Príncipe',
    SA: 'Arabia Saudí',
    SN: 'Senegal',
    RS: 'Serbia',
    SC: 'Seychelles',
    SL: 'Sierra Leona',
    SG: 'Singapur',
    SX: 'San Martín (Países Bajos)',
    SK: 'Eslovaquia',
    SI: 'Eslovenia',
    SB: 'Islas Salomón',
    SO: 'Somalia',
    ZA: 'Sudáfrica',
    GS: 'Islas Georgias del Sur y Sandwich del Sur',
    SS: 'Sudán del Sur',
    ES: 'España',
    LK: 'Sri Lanka',
    SD: 'Sudán',
    SR: 'Surinam',
    SJ: 'Svalbard y Jan Mayen',
    SE: 'Suecia',
    CH: 'Suiza',
    SY: 'República Árabe Siria',
    TW: 'Taiwán, provincia de China',
    TJ: 'Tayikistán',
    TZ: 'Tanzania, República Unida de',
    TH: 'Tailandia',
    TL: 'Timor Oriental',
    TG: 'Togo',
    TK: 'Tokelau',
    TO: 'Tonga',
    TT: 'Trinidad y Tobago',
    TN: 'Túnez',
    TR: 'Turquía',
    TM: 'Turkmenistán',
    TC: 'Islas Turcas y Caicos',
    TV: 'Tuvalu',
    UG: 'Uganda',
    UA: 'Ucrania',
    AE: 'Emiratos Árabes Unidos',
    GB: 'Reino Unido de Gran Bretaña e Irlanda del Norte',
    US: 'Estados Unidos de América',
    UM: 'Islas Ultramarinas Menores de los Estados Unidos',
    UY: 'Uruguay',
    UZ: 'Uzbekistán',
    VU: 'Vanuatu',
    VE: 'Venezuela (República Bolivariana de)',
    VN: 'Vietnam',
    VG: 'Islas Vírgenes Británicas',
    VI: 'Islas Vírgenes de los Estados Unidos',
    WF: 'Wallis y Futuna',
    EH: 'Sahara Occidental',
    YE: 'Yemen',
    ZM: 'Zambia',
    ZW: 'Zimbabue',
};

const es_419 = {
    // Header/Sidebar
    "user": 'Usuario',
    "users": 'Usuarios',
    "installations": 'Instalaciones',
    "settings": 'Configuraciones',
    "certificate": 'Certificado',
    "main_settings": 'Configuración principal',
    "terminology": 'Terminología',
    "equipment": 'Equipo',
    "security": 'Seguridad',
    "tenants": 'Inquilinos',
    "collapse": 'Contraer',
    "branding": 'Gestión de marca',
    "sign_out": 'Salir',
    "hello": '¡Hola!',
    // Misc
    "save": 'Guardar',
    "cancel": 'Cancelar',
    // Installation Table
    "status": 'Estado',
    "clear": 'Eliminar',
    "date": 'Fecha',
    "technician": 'Técnico',
    "customer_phone": 'Teléfono del cliente',
    "address": 'Dirección',
    "unit": 'Unidad',
    "city": 'Ciudad',
    "state_prov": 'Estado/Prov.',
    "rooms_tested": 'Prueba de habitaciones',
    "tested": 'Probado',
    "plan": 'Plan',
    "rows_per_page": 'Filas por página',
    "recommended_short": 'Recomm.',
    "notes": 'Notas',
    // Certificate Branding Tab
    "current_image": 'Imagen actual: ',
    "using_default_logo": 'Uso del logotipo predeterminado',
    "new_image": 'Nueva imagen',
    "branding_loading_error": 'Error de carga de marca. Inténtelo de nuevo más tarde.',
    "upload_new_image": 'Subir nueva imagen',
    "clear_custom_image": 'Limpiar Imagen personalizada',
    "clear_custom_color": 'Borrar color personalizado',
    "brand_color": 'Color de marca',
    "header_message": 'Mensaje de encabezado',
    "header_education_message": 'Mensaje instructivo de encabezado',
    "footer_education_message": 'Mensaje instructivo de pie de página',
    "preview": 'Vista previa',
    "file_must_be_less_than_size_limit": 'El archivo debe ser inferior a 30KB',
    // Certificate Headers
    "congrats_message": "¡Tu instalación de WiFi está completa y ha sido certificada por RouteThis!",
    "installation_details": "Detalles de la instalación",
    "wireless_speed_test": "Prueba de velocidad inalámbrica",
    "wireless_performance": "Desempeño inalámbrico",
    "photos": "Fotos",
    "signal_maps": "Mapas de señal",
    "wifi_information": "Información de wifi",
    // Certificate Room Names
    "singular_room": "Habitación",
    "room_type_bathroom": "Cuarto de baño",
    "room_type_bedroom": "Dormitorio",
    "room_type_dining_room": "Comedor",
    "room_type_entry_or_hall": "Entrada/Salón",
    "room_type_garage": "Garaje",
    "room_type_kitchen": "Cocina",
    "room_type_living_room": "Sala de estar",
    "room_type_office": "Oficina",
    "room_type_other": "Otros",
    // Pod Name
    "pod_1": "Pod de malla",
    "pod_2": "Punto de acceso",
    "pod_3": "Nodo de malla",
    "pod_4": "Puck de malla",
    "pod_5": "Baliza",
    "pod_6": "Pod de malla",
    "pod_7": 'Amplificador Wi-Fi',
    "pods_1": "Pods de malla",
    "pods_2": "Puntos de acceso",
    "pods_3": "Nodos de malla",
    "pods_4": "Pucks de malla",
    "pods_5": "Balizas",
    "pods_6": "Pods de malla",
    "pods_7": 'Amplificadores Wi-Fi',
    // Router Name
    "router_1": "Router",
    "router_2": "Módem",
    "router_3": "Puerta de enlace",
    "router_4": "Concentrador",
    "router_5": "Módem de Internet",
    // Level Name
    "level_1": "Nivel",
    "level_2": "Piso",
    "levels_1": "Niveles",
    "levels_2": "Plantas",
    // a11y Labels
    "go_to_homepage": 'Ir a la página principal',
    "edit_user_x": 'Editar usuario [X]',
    "open_certificate_for_addr": 'Certificado abierto para [ADDR]',
    "clear_all_filters": 'Borrar todos los filtros',
    "expand_sidebar": 'Desplegar barra lateral',
    "current_tenant_branding_image": 'Imagen de marca del inquilino actual',
    "new_tenant_branding_image": 'Nueva imagen de marca del inquilino',
    // Certificate Pod Info
    "recommended": "Recomendado",
    "installed": "Instalado",
    "total": "Total",
    // Certificate Signal Table
    "front_building": "Frente del edificio",
    "speed": "Veloc.",
    "video": "Video",
    "rssi": "RSSI",
    "rssi_description": "dBm",
    "link": "Enlace",
    "frequency_short": "Frec.",
    "frequency_description": "MHz",
    "channel_short": "Can.",
    // Certificate Legend
    "legend": "Leyenda",
    "measured_speed": "Velocidad medida",
    "measured_speed_description": "Mbps",
    // Certificate Speedtest Result
    "speedtest_passed": "La velocidad está dentro del rango esperado para la mayoría de los dispositivos móviles. No todos los dispositivos inalámbricos son capacides de alcanzar la velocidad máxima del plan. Ver debajo para pruebas individuales de espacio.",
    "speedtest_failed": "Probado en un teléfono o tablet. No todos los dispositivos inalámbricos son capacides de alcanzar la velocidad máxima del plan. Ver debajo para pruebas individuales de espacio.",
    // Login/Reset Password
    "email": 'Correo electrónico',
    "password": 'Contraseña',
    "sign_in": 'Acceder',
    "continue": "Continuar",
    "forgot_password": 'Olvidé mi contraseña',
    "reset_password": 'Restablecer contraseña',
    "reset_password_instructions": 'Para restablecer su contraseña, ingrese su dirección de correo electrónico arriba y le enviaremos instrucciones, si la cuenta existe.',
    "sent_reset_password_code": 'Hemos enviado un código de restablecimiento de contraseña a [email]. Ingrese dicho código y una nueva contraseña.',
    "reset_code": 'Código de restablecimiento',
    "new_password": 'Nueva contraseña',
    "reenter_new_password": 'Vuelva a ingresar la nueva contraseña',
    "must_include_email": 'Debe incluir correo electrónico',
    "old_password": 'Contraseña anterior',
    "set_new_password": 'Establecer nueva contraseña',
    "password_expired": 'La contraseña ha expirado',
    "toggle_password_visibility": 'Alternar la visibilidad de la contraseña',
    "change_your_password": 'Cambia la contraseña',
    "change_password": 'Cambia tu contraseña',
    "set_password": 'Configurar la contraseña',
    "login_title_text": "Iniciar Sesión",
    "try_again": "Intentar Nuevamente",
    "login_error_message": "No pudimos encontrar a su usuario. Puede intentar nuevamente o contactar a su administrador de cuentas.",
    "invalid_login_credentials_error_message": "Combinación incorrecta de nombre de usuario y contraseña o el usuario no existe.",
    "enter_password_reset_code": "Por favor, ingrese el código que enviamos a la cuenta [email].",
    "repeat-new-password": "Repetir Nueva Contraseña",
    "send-code": "Enviar código",
    "okta-sign-in": "Iniciar sesión con Okta",
    "google-sign-in": "Iniciar sesión con Google",
    "microsoft-sign-in": "Iniciar sesión con Microsoft",
    "or": "O",
    "already_have_reset_code": "Ya tengo un código de restablecimiento",
    "contact_manager_for_account": "Para nuevas cuentas, por favor contacte a su gerente",
    // ListUsers
    "search_enter_4_chars": 'Por favor, ingrese al menos 4 caracteres para buscar',
    "user_search_placeholder_email": 'Buscar por el comienzo de un correo electrónico',
    "user_search_placeholder": 'Buscar por el comienzo de un correo electrónico, gerente o grupo',
    "no_users_found": 'No se encontraron usuarios',
    // Users List
    "add_user": 'Agregar usuario',
    "edit_user": 'Editar usuario',
    "bulk_import": 'Importación masiva',
    "bulk_import_users": 'Importación masiva de usuarios',
    "add_group": 'Agregar grupo',
    "manage_users": 'Gestionar usuarios',
    "manage_groups": 'Gestionar grupo',
    "show_roles_list": 'Mostrar lista de roles',
    "show_disabled_users": 'Mostrar usuarios deshabilitados',
    "name": 'Nombre',
    "role": 'Rol',
    "roles": 'Roles',
    "role_name": 'Nombre del rol',
    "role_description": 'Descripción del rol',
    "role_id": 'ID del rol',
    "location": 'Ubicación',
    "routethis_group": 'Grupo RouteThis',
    "manager": 'Gerente',
    "download_bulk_template": 'Descargar plantilla masiva',
    "user_id_email": 'ID de usuario (correo electrónico)',
    "users_for": 'Usuarios para:',
    // Valid User roles
    "user_role": 'usuario',
    "tenant_admin_role": 'AdminInquilinos',
    "super_admin_role": 'SuperAdmin',
    "tenant_admin": 'Administrador de inquilinos',
    "super_admin": 'Superadministrador',
    // Create/Edit User Modal
    "email_required": 'Correo electrónico (obligatorio)',
    "first_name": 'Nombre',
    "last_name": 'Apellidos',
    "force_password_reset": 'Forzar restablecimiento de contraseña',
    "resend_validation_code": 'Reenviar código de validación',
    "enable_users": 'Habilitar usuarios',
    "disable_users": 'Deshabilitar usuarios',
    "certify": 'Certificar',
    "unverified": 'No verificado',
    "verified": 'Verificado',
    "locked_out": 'Bloqueado',
    "disabled": 'Deshabilitado',
    "reset_user_password_confirmation": '¿Está seguro de que desea restablecer la contraseña de este usuario?',
    "resend_validation_code_confirmation": '¿Está seguro de que desea reenviar el código de validación?',
    "cannot_disable_yourself": 'No puede deshabilitarse a sí mismo',
    "cancel_changes": 'Cancelar cambios',
    "required": 'Requerido',
    "password_email_template": 'Plantilla de correo electrónico para la contraseña',
    "include_in_resolve_usage_reports": 'Incluir en los informes de uso de Resolve',
    "delete_user": 'Eliminar usuario',
    "delete_are_you_sure": '¿Está seguro de que desea eliminar este usuario? ADVERTENCIA: Esta acción es irreversible.',
    "delete": 'Eliminar',
    // Create/Edit Group modal:
    "create_group": 'Crear grupo',
    "edit_group": 'Editar grupo',
    "group_name": 'Nombre del grupo',
    "group_type": 'Tipo de grupo',
    "search_by_group_name": 'Buscar por nombre de grupo',
    "search_by_role_name": 'Buscar por nombre de rol',
    // Bulk Import Modal
    "csv_format_requirements": 'Formato de CSV: correo electrónico, nombre, apellidos, rol (solo es obligatorio el correo electrónico)',
    "valid_user_roles": 'Roles de usuario válidos: "user", "TenantAdmin", "SuperAdmin"',
    "select_csv": 'Seleccionar CSV',
    "import": 'Importar',
    "file_too_large": 'Archivo demasiado grande (máximo 500 usuarios)',
    "required_headers_missing": 'Faltan encabezados obligatorios: correo electrónico',
    "user_import_starting": 'Importación de usuarios iniciada. Recibirá un correo electrónico con el resumen de la importación en unos minutos.',
    // Tenant Main Settings
    "email_language": 'Idioma de correo electrónico',
    "country": 'País',
    "description_optional": 'Descripción (opcional)',
    "units_feet_meters": 'Unidades (pies, metros)',
    "certify_id": 'Certify ID',
    "resolve_id": 'Resolve ID',
    "sms_from": 'SMS de',
    "sms_body": 'Cuerpo del SMS',
    "default_sms_body": '¡Su instalación wifi se ha completado y ha sido certificada por [NAME]! Vea su certificado aquí: [LINK]',
    "sms_body_helper_text": 'Al certificar, se enviará este mensaje de texto al cliente. [LINK] se sustituirá por un enlace al certificado (obligatorio). [NAME] se sustituirá por el contenido del campo "Nombre" (opcional)',
    "link_must_be_in_sms_body": '[LINK] debe estar en el cuerpo del SMS.',
    "update_successful": 'Actualización correcta',
    "creation_successful": 'Creación correcta',
    // Tenant Terminology Settings
    "term": 'Término',
    "example_usage": 'Ejemplo de uso',
    "customer_example_usage_1": 'Tras consultar al cliente, confirme el edificio seleccionado o vuelva a editar la dirección.',
    "customer_example_usage_2": 'Tras consultar al abonado, confirme el edificio seleccionado o vuelva a editar la dirección.',
    "router_example_usage_1": 'Pulse en la ubicación propuesta del enrutador a continuación.',
    "router_example_usage_2": 'Pulse en la ubicación propuesta del módem a continuación.',
    "router_example_usage_3": 'Pulse en la ubicación propuesta de la puerta de enlace a continuación.',
    "router_example_usage_4": 'Pulse en la ubicación propuesta del concentrador a continuación.',
    "router_example_usage_5": 'Pulse en la ubicación propuesta del enrutador a continuación.',
    "level_example_usage_1": 'Vaya al 1.º nivel y pulse en su ubicación.',
    "level_example_usage_2": 'Vaya al 2.º piso y pulse en su ubicación.',
    "mesh_pod_example_usage_1": 'Estimación de la intensidad de la señal y ubicación óptima de las cápsulas de malla.',
    "mesh_pod_example_usage_2": 'Estimación de la intensidad de la señal y ubicación óptima de los puntos de acceso.',
    "mesh_pod_example_usage_3": 'Estimación de la intensidad de la señal y ubicación óptima de los nodos de malla.',
    "mesh_pod_example_usage_4": 'Estimación de la intensidad de la señal y ubicación óptima de los discos de malla.',
    "mesh_pod_example_usage_5": 'Estimación de la intensidad de la señal y ubicación óptima de las balizas.',
    "mesh_pod_example_usage_6": 'Estimación de la intensidad de la señal y ubicación óptima de las cápsulas de malla.',
    "wifi_example_usage_1": 'Mapeo WiFi',
    "wifi_example_usage_2": 'Mapeo Wi-Fi',
    "wifi_example_usage_3": 'Mapeo wifi',
    "wifi_example_usage_4": 'Mapeo WIFI',
    // Tenant Equipment Settings (Certify)
    "router_options_1": 'Opciones del enrutador',
    "router_options_2": 'Opciones del módem',
    "router_options_3": 'Opciones de la puerta de enlace',
    "router_options_4": 'Opciones del concentrador',
    "router_options_5": 'Opciones del enrutador',
    "new_router_options_1": 'Nuevas opciones del enrutador',
    "new_router_options_2": 'Nuevas opciones de módem',
    "new_router_options_3": 'Nuevas opciones de la puerta de enlace',
    "new_router_options_4": 'Nuevas opciones del concentrador',
    "new_router_options_5": 'Nuevas opciones del enrutador',
    "mesh_pod_options_1": 'Opciones de las cápsulas de malla',
    "mesh_pod_options_2": 'Opciones de los puntos de acceso',
    "mesh_pod_options_3": 'Opciones de los nodos de malla',
    "mesh_pod_options_4": 'Opciones de los discos de malla',
    "mesh_pod_options_5": 'Opciones de las balizas',
    "mesh_pod_options_6": 'Opciones de las cápsulas de malla',
    "new_mesh_pod_options_1": 'Nuevas opciones de vainas de malla',
    "new_mesh_pod_options_2": 'Nuevas opciones de puntos de acceso',
    "new_mesh_pod_options_3": 'Nuevas opciones de nodos de malla',
    "new_mesh_pod_options_4": 'Nuevas opciones de discos de malla',
    "new_mesh_pod_options_5": 'Nuevas opciones de señalización',
    "new_mesh_pod_options_6": 'Nuevas opciones de vainas de malla',
    "missing_required_router_info_1": 'Falta la información requerida del router',
    "missing_required_router_info_2": 'Falta la información requerida del módem',
    "missing_required_router_info_3": 'Falta la información requerida de la puerta de enlace',
    "missing_required_router_info_4": 'Falta la información requerida del hub',
    "missing_required_router_info_5": 'Falta la información requerida del router',
    "missing_required_mesh_pod_info_1": 'Falta la información requerida de la vaina de malla',
    "missing_required_mesh_pod_info_2": 'Falta información del punto de acceso requerido',
    "missing_required_mesh_pod_info_3": 'Falta información requerida del nodo de malla',
    "missing_required_mesh_pod_info_4": 'Falta información sobre el disco de malla requerido',
    "missing_required_mesh_pod_info_5": 'Falta la información de la baliza requerida',
    "missing_required_mesh_pod_info_6": 'Falta la información requerida de la vaina de malla',
    "display_name": 'Alias',
    "description": 'Descripción',
    "range_in_unit_1": 'Alcance en pies',
    "range_in_unit_2": 'Alcance en metros',
    "default_active": 'Activo por defecto',
    "area_in_unit_1": 'Área en Pies Cuadrados',
    "area_in_unit_2": 'Área en Metros Cuadrado',
    "average_range": 'Alcance medio',
    "certify_default": 'Certificar por defecto',
    "default": 'Predeterminado',
    "active": 'Activo',
    "one_option_must_be_default": 'Una opción debe ser la predeterminada',
    "set_as_default": 'Establecer como predeterminado',
    "default_option_must_be_active": 'La opción predeterminada debe estar activa',
    "deactivate": 'Desactivar',
    "activate": 'Activar',
    "name_is_required": 'El nombre es obligatorio',
    // Customer Name
    "customer_1": 'Cliente',
    "customer_2": 'Abonado',
    // Wifi Name
    "wifi_1": 'WiFi',
    "wifi_2": 'Wi-Fi',
    "wifi_3": 'Wifi',
    "wifi_4": 'WIFI',
    // Units
    "units_1": 'Pies',
    "units_2": 'Metros',
    // Misc
    "confirm": 'Confirmar',
    "units": 'Unidades',
    "region": 'Región',
    "edit": 'Edit',
    "modified": 'Modificada',
    "create": 'Crear',
    "created": 'Creada',
    "routethis_app": 'Aplicación RouteThis',
    "loading": 'Cargando…',
    "redirecting": 'Redirigiendo…',
    "error": 'Error',
    "close": 'Cerrar',
    "account_holder": 'Titular de la cuenta',
    "all": 'Todos',
    "dismiss": 'DESCARTAR',
    "search": 'Buscar',
    "unauthenticated_login_again": "No autenticado. Por favor, inicie sesión nuevamente.",
    // Languages
    "en": 'Inglés (Estados Unidos)',
    'en-GB': 'Inglés (Reino Unido)',
    "da": 'Danés',
    "fi": 'Finlandés',
    "fr": 'Francés',
    'fr-CA': 'Francés (Canadá)',
    "de": 'Alemán',
    "el": 'Griego',
    "it": 'Italiano',
    "pt": 'Portugués',
    'pt-BR': 'Portugués (Brasil)',
    "es": 'Español',
    'es-419': 'Español (Latinoamérica)',
    "sv": 'Sueco',
    // Client-side validation errors
    "incorrect_email_or_password": 'Correo electrónico o contraseña incorrectos, o cuenta desactivada. Inténtelo de nuevo o póngase en contacto con un administrador.',
    "invalid_reset_code": 'Código de restablecimiento no válido',
    "password_minimum_requirements": 'La contraseña debe tener un mínimo de 8 caracteres e incluir al menos una minúscula, una mayúscula y un número.',
    "password_minimum_requirements_shortened": "Mínimo 8 caracteres, una mayúscula y un número",
    "passwords_must_match": 'Las contraseñas deben coincidir',
    "must_include_new_password_email": 'Debe incluir una nueva contraseña y un correo electrónico de usuario',
    "must_include_new_password_confirmation_code": 'Debe incluir una nueva contraseña y un código de confirmación',
    "cannot_send_reset_code_without_email": 'No se puede enviar el código de restablecimiento sin correo electrónico',
    "must_enter_old_password": 'Debes ingresar tu antigua contraseña',
    "must_enter_reset_code": 'Debe introducir el código de reinicio',
    "must_enter_new_password": 'Debe introducir una nueva contraseña',
    "passwords_cannot_begin_or_end_with_spaces": 'Las contraseñas no pueden empezar ni terminar con espacios',
    // Server-side errors
    'User with that email already exists': "El usuario con ese correo electrónico ya existe",
    'Try another display name': "Pruebe con otro nombre de usuario",
    'Password cannot be a previously used password': "La contraseña no puede ser una contraseña utilizada anteriormente",
    'Invalid reset code': "Código de restablecimiento no válido",
    'Incorrect email or password, or disabled account. Try again or contact an administrator.': "Correo electrónico o contraseña incorrectos, o cuenta desactivada. Inténtelo de nuevo o póngase en contacto con un administrador.",
    'Invalid code provided, please request a code again.': 'El código proporcionado es inválido. Solicite un código de nuevo.',
    'Password cannot begin or end with spaces': "Las contraseñas no pueden empezar ni terminar con espacios",
    'LimitExceededException - Attempt limit exceeded, please try after some time.': "Ha excedido el límite de intentos permitidos. Vuelva a intentarlo más tarde.",
    'User is not Authorized': "Usuario no autorizado",
    'Your session timed out. Sign in again with your temporary password.': "Su sesión ha finalizado. Inicie sesión de nuevo con su contraseña temporal.",
    'Internal Service Failure - Cognito Unavailable': "Cognito no disponible",
    'Internal Service Failure - Unknown Failure': "Falla desconocida",
    'Must enter Reset Code': 'Debe introducir el código de reinicio',
    // Change Password Challenges
    "step_1_of_2": "Paso 1 de 2",
    "step_2_of_2": "Paso 2 de 2",
    "set_password_challenge": 'Por motivos de seguridad, debe establecer una nueva contraseña la primera vez que inicie sesión.',
    "reset_password_challenge": 'Hemos enviado un código de restablecimiento de contraseña a [EMAIL]. Introduzca ese código y una nueva contraseña.',
    "set_new_password_challenge": 'La política de su empresa requiere que su contraseña caduque después de un tiempo. Hemos enviado un código de restablecimiento de contraseña a [EMAIL]. Introduzca ese código y una nueva contraseña.',
    "change_your_password_challenge": 'Introduzca su contraseña actual y una nueva contraseña a continuación para cambiarla.',
    "change_password_challenge": 'Introduzca una nueva contraseña para el usuario',
    "reset_password_challenge_instructions": "Enviaremos al correo [EMAIL] un código de restablecimiento y más instrucciones para crear una nueva contraseña.",
    AF: 'Afganistán',
    AX: 'Islas Åland',
    AL: 'Albania',
    DZ: 'Argelia',
    AS: 'Samoa Americana',
    AD: 'Andorra',
    AO: 'Angola',
    AI: 'Anguila',
    AQ: 'Antártida',
    AG: 'Antigua y Barbuda',
    AR: 'Argentina',
    AM: 'Armenia',
    AW: 'Aruba',
    AU: 'Australia',
    AT: 'Austria',
    AZ: 'Azerbaiyán',
    BS: 'Bahamas',
    BH: 'Baréin',
    BD: 'Bangladés',
    BB: 'Barbados',
    BY: 'Bielorrusia',
    BE: 'Bélgica',
    BZ: 'Belice',
    BJ: 'Benín',
    BM: 'Bermudas',
    BT: 'Bután',
    BO: 'Bolivia (Estado Plurinacional de)',
    BQ: 'Bonaire, San Eustaquio y Saba',
    BA: 'Bosnia y Herzegovina',
    BW: 'Botsuana',
    BV: 'Isla Bouvet',
    BR: 'Brasil',
    IO: 'Territorio Británico del Océano Índico',
    BN: 'Brunéi',
    BG: 'Bulgaria',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    CV: 'Cabo Verde',
    KH: 'Camboya',
    CM: 'Camerún',
    CA: 'Canadá',
    KY: 'Islas Caimán',
    CF: 'República Centroafricana',
    TD: 'Chad',
    CL: 'Chile',
    CN: 'China',
    CX: 'Isla de Navidad',
    CC: 'Islas Cocos (Keeling)',
    CO: 'Colombia',
    KM: 'Comoras',
    CG: 'Congo',
    CD: 'Congo, República Democrática del',
    CK: 'Islas Cook',
    CR: 'Costa Rica',
    CI: 'Costa de Marfil',
    HR: 'Croacia',
    CU: 'Cuba',
    CW: 'Curazao',
    CY: 'Chipre',
    CZ: 'República Checa',
    DK: 'Dinamarca',
    DJ: 'Yibuti',
    DM: 'Dominica',
    DO: 'República Dominicana',
    EC: 'Ecuador',
    EG: 'Egipto',
    SV: 'El Salvador',
    GQ: 'Guinea Ecuatorial',
    ER: 'Eritrea',
    EE: 'Estonia',
    SZ: 'Suazilandia',
    ET: 'Etiopía',
    FK: 'Islas Malvinas',
    FO: 'Islas Feroe',
    FJ: 'Fiyi',
    FI: 'Finlandia',
    FR: 'Francia',
    GF: 'Guayana Francesa',
    PF: 'Polinesia Francesa',
    TF: 'Territorios Australes Franceses',
    GA: 'Gabón',
    GM: 'Gambia',
    GE: 'Georgia',
    DE: 'Alemania',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GR: 'Grecia',
    GL: 'Groenlandia',
    GD: 'Granada',
    GP: 'Guadalupe',
    GU: 'Guam',
    GT: 'Guatemala',
    GG: 'Guernsey',
    GN: 'Guinea',
    GW: 'Guinea-Bisáu',
    GY: 'Guyana',
    HT: 'Haití',
    HM: 'Isla Heard e Islas McDonald',
    VA: 'Santa Sede',
    HN: 'Honduras',
    HK: 'Hong Kong',
    HU: 'Hungría',
    IS: 'Islandia',
    IN: 'India',
    ID: 'Indonesia',
    IR: 'Irán (República Islámica de)',
    IQ: 'Irak',
    IE: 'Irlanda',
    IM: 'Isla de Man',
    IL: 'Israel',
    IT: 'Italia',
    JM: 'Jamaica',
    JP: 'Japón',
    JE: 'Jersey',
    JO: 'Jordania',
    KZ: 'Kazajistán',
    KE: 'Kenia',
    KI: 'Kiribati',
    KP: 'Corea (República Popular Democrática de)',
    KR: 'Corea, República de',
    KW: 'Kuwait',
    KG: 'Kirguistán',
    LA: 'República Democrática Popular Lao',
    LV: 'Letonia',
    LB: 'Líbano',
    LS: 'Lesoto',
    LR: 'Liberia',
    LY: 'Libia',
    LI: 'Liechtenstein',
    LT: 'Lituania',
    LU: 'Luxemburgo',
    MO: 'Macao',
    MG: 'Madagascar',
    MW: 'Malaui',
    MY: 'Malasia',
    MV: 'Maldivas',
    ML: 'Mali',
    MT: 'Malta',
    MH: 'Islas Marshall',
    MQ: 'Martinica',
    MR: 'Mauritania',
    MU: 'Mauricio',
    YT: 'Mayotte',
    MX: 'México',
    FM: 'Micronesia (Estados Federados de)',
    MD: 'Moldavia, República de',
    MC: 'Mónaco',
    MN: 'Mongolia',
    ME: 'Montenegro',
    MS: 'Montserrat',
    MA: 'Marruecos',
    MZ: 'Mozambique',
    MM: 'Birmania',
    NA: 'Namibia',
    NR: 'Nauru',
    NP: 'Nepal',
    NL: 'Países Bajos',
    NC: 'Nueva Caledonia',
    NZ: 'Nueva Zelanda',
    NI: 'Nicaragua',
    NE: 'Níger',
    NG: 'Nigeria',
    NU: 'Niue',
    NF: 'Isla de Norfolk',
    MK: 'Macedonia del Norte',
    MP: 'Islas Marianas del Norte',
    NO: 'Noruega',
    OM: 'Omán',
    PK: 'Pakistán',
    PW: 'Palaos',
    PS: 'Palestina, Estado de',
    PA: 'Panamá',
    PG: 'Papúa Nueva Guinea',
    PY: 'Paraguay',
    PE: 'Perú',
    PH: 'Filipinas',
    PN: 'Pitcairn',
    PL: 'Polonia',
    PT: 'Portugal',
    PR: 'Puerto Rico',
    QA: 'Catar',
    RE: 'Reunión',
    RO: 'Rumanía',
    RU: 'Federación de Rusia',
    RW: 'Ruanda',
    BL: 'San Bartolomé',
    SH: 'Santa Elena, Ascensión y Tristán da Acuña',
    KN: 'San Cristóbal y Nieves',
    LC: 'Santa Lucía',
    MF: 'San Martín (Francia)',
    PM: 'San Pedro y Miquelón',
    VC: 'San Vicente y las Granadinas',
    WS: 'Samoa',
    SM: 'San Marino',
    ST: 'Santo Tomé y Príncipe',
    SA: 'Arabia Saudí',
    SN: 'Senegal',
    RS: 'Serbia',
    SC: 'Seychelles',
    SL: 'Sierra Leona',
    SG: 'Singapur',
    SX: 'San Martín (Países Bajos)',
    SK: 'Eslovaquia',
    SI: 'Eslovenia',
    SB: 'Islas Salomón',
    SO: 'Somalia',
    ZA: 'Sudáfrica',
    GS: 'Islas Georgias del Sur y Sandwich del Sur',
    SS: 'Sudán del Sur',
    ES: 'España',
    LK: 'Sri Lanka',
    SD: 'Sudán',
    SR: 'Surinam',
    SJ: 'Svalbard y Jan Mayen',
    SE: 'Suecia',
    CH: 'Suiza',
    SY: 'República Árabe Siria',
    TW: 'Taiwán, provincia de China',
    TJ: 'Tayikistán',
    TZ: 'Tanzania, República Unida de',
    TH: 'Tailandia',
    TL: 'Timor Oriental',
    TG: 'Togo',
    TK: 'Tokelau',
    TO: 'Tonga',
    TT: 'Trinidad y Tobago',
    TN: 'Túnez',
    TR: 'Turquía',
    TM: 'Turkmenistán',
    TC: 'Islas Turcas y Caicos',
    TV: 'Tuvalu',
    UG: 'Uganda',
    UA: 'Ucrania',
    AE: 'Emiratos Árabes Unidos',
    GB: 'Reino Unido de Gran Bretaña e Irlanda del Norte',
    US: 'Estados Unidos de América',
    UM: 'Islas Ultramarinas Menores de los Estados Unidos',
    UY: 'Uruguay',
    UZ: 'Uzbekistán',
    VU: 'Vanuatu',
    VE: 'Venezuela (República Bolivariana de)',
    VN: 'Vietnam',
    VG: 'Islas Vírgenes Británicas',
    VI: 'Islas Vírgenes de los Estados Unidos',
    WF: 'Wallis y Futuna',
    EH: 'Sahara Occidental',
    YE: 'Yemen',
    ZM: 'Zambia',
    ZW: 'Zimbabue',
};

const fr = {
    // Login/Reset Password
    "email": 'Courriel',
    "password": 'Mot de passe',
    "sign_in": 'Se connecter',
    "continue": "Continuer",
    "forgot_password": 'Mot de passe oublié',
    "reset_password": 'Réinitialiser le mot de passe',
    "reset_password_instructions": "Pour réinitialiser votre mot de passe, entrez votre adresse courriel ci-dessus et nous vous enverrons des instructions, si le compte existe.",
    "sent_reset_password_code": 'Nous avons envoyé un code de réinitialisation de mot de passe à [email]. Entrez ce code et un nouveau mot de passe.',
    "invalid_login_credentials_error_message": 'Combinaison nom d\'utilisateur et mot de passe incorrecte ou l\'utilisateur n\'existe pas.',
    "reset_code": 'Code de réinitialisation',
    "new_password": 'Nouveau mot de passe',
    "reenter_new_password": 'Confirmez le nouveau mot de passe',
    "must_include_email": 'Vous devez inclure un courriel',
    "old_password": 'Ancien mot de passe',
    "set_new_password": 'Définir un nouveau mot de passe',
    "password_expired": 'Mot de passe expiré',
    "toggle_password_visibility": 'Afficher/masquer le mot de passe',
    "change_your_password": 'Changer votre mot de passe',
    "change_password": 'Changer le mot de passe',
    "set_password": 'Définir le mot de passe',
    "already_have_reset_code": 'J\'ai déjà un code de réinitialisation',
    "confirm_password": 'Confirmer le mot de passe',
    "idle_logged_out_warning": 'Vous êtes inactif et serez déconnecté dans 10 secondes',
    "logged_out": 'Vous avez été déconnecté',
    "login_title_text": "Connexion",
    "try_again": "Réessayer",
    "login_error_message": "Nous n'avons pas pu trouver votre utilisateur. Vous pouvez réessayer ou contacter votre gestionnaire de compte.",
    "enter_password_reset_code": "Veuillez entrer le code que nous avons envoyé au compte [email].",
    "repeat-new-password": "Répéter le Nouveau Mot de Passe",
    "send-code": "Envoyer le code",
    "okta-sign-in": "Se connecter avec Okta",
    "google-sign-in": "Se connecter avec Google",
    "microsoft-sign-in": "Se connecter avec Microsoft",
    "or": "OU",
    "contact_manager_for_account": "Pour les nouveaux comptes, veuillez contacter votre gestionnaire",
    // ListUsers
    "search_enter_4_chars": 'Veuillez entrer au moins 4 caractères pour rechercher',
    "user_search_placeholder_email": 'Rechercher le début d\'un courriel',
    "user_search_placeholder": 'Rechercher le début d\'un courriel, un gestionnaire ou un groupe',
    "no_users_found": 'Aucun utilisateur trouvé',
    // Sidebar
    "users": 'Utilisateurs',
    "main_settings": 'Paramètres principaux',
    "terminology": 'Terminologie',
    "equipment": 'Équipement',
    "security": 'Sécurité',
    "tenants": 'Locataires',
    "collapse": 'Réduire',
    // Users List
    "add_user": 'Ajouter un utilisateur',
    "edit_user": 'Modifier l\'utilisateur',
    "bulk_import": 'Importation en masse',
    "bulk_import_users": 'Importer des utilisateurs en masse',
    "add_group": 'Ajouter un groupe',
    "manage_users": 'Gérer les utilisateurs',
    "manage_groups": 'Gérer les groupes',
    "show_roles_list": 'Afficher la liste des rôles',
    "show_disabled_users": 'Afficher les utilisateurs désactivés',
    "name": 'Nom',
    "role": 'Rôle',
    "roles": 'Rôles',
    "role_name": 'Nom du rôle',
    "role_description": 'Description du rôle',
    "role_id": 'ID du rôle',
    "location": 'Emplacement',
    "routethis_group": 'Groupe RouteThis',
    "manager": 'Gestionnaire',
    "download_bulk_template": 'Télécharger le modèle en masse',
    "user_id_email": 'ID utilisateur (courriel)',
    "users_for": 'Utilisateurs pour :',
    // Valid User roles
    "user_role": 'utilisateur',
    "tenant_admin_role": 'AdminLocataire',
    "super_admin_role": 'SuperAdmin',
    "user": 'Utilisateur',
    "tenant_admin": 'Administrateur de locataire',
    "super_admin": 'Super administrateur',
    // Create/Edit User Modal
    "create_user": 'Créer un utilisateur',
    "email_required": 'Courriel (Obligatoire)',
    "first_name": 'Prénom',
    "last_name": 'Nom de famille',
    "force_password_reset": 'Forcer la réinitialisation du mot de passe',
    "resend_welcome_email": 'Renvoyer le courriel de bienvenue',
    "resend_validation_code": 'Renvoyer le code de validation',
    "enable_users": 'Activer les utilisateurs',
    "disable_users": 'Désactiver les utilisateurs',
    "certify": 'Certifier',
    "unverified": 'Non vérifié',
    "verified": 'Vérifié',
    "locked_out": 'Bloqué',
    "disabled": 'Désactivé',
    "save": 'Sauvegarder',
    "reset_user_password_confirmation": 'Êtes-vous sûr de vouloir réinitialiser le mot de passe de cet utilisateur ?',
    "resend_validation_code_confirmation": 'Êtes-vous sûr de vouloir renvoyer le code de validation ?',
    "cannot_disable_yourself": 'Impossible de vous désactiver vous-même',
    "cancel_changes": 'Annuler les modifications',
    "required": 'Requis',
    "password_email_template": 'Modèle de courriel de mot de passe',
    "include_in_resolve_usage_reports": 'Inclure dans les rapports d\'utilisation de Resolve',
    "delete_user": 'Supprimer l\'utilisateur',
    "delete_are_you_sure": 'Êtes-vous sûr de vouloir supprimer cet utilisateur ? ATTENTION : Cette action est irréversible.',
    "delete": 'Supprimer',
    // Create Edit Group modal
    "create_group": 'Créer un groupe',
    "edit_group": 'Modifier le groupe',
    "group_name": 'Nom du groupe',
    "group_type": 'Type de groupe',
    "search_by_group_name": 'Rechercher par nom de groupe',
    "search_by_role_name": 'Rechercher par nom de rôle',
    // Snackbar Messages
    "snackbar_disable_success": 'Utilisateur désactivé avec succès :',
    "snackbar_disable_error": 'Erreur lors de la désactivation de l\'utilisateur :',
    "snackbar_enable_success": 'Utilisateur activé avec succès :',
    "snackbar_enable_error": 'Erreur lors de l\'activation de l\'utilisateur :',
    "snackbar_password_reset_success": 'Mot de passe réinitialisé avec succès pour l\'utilisateur :',
    "snackbar_password_reset_error": 'Erreur lors de la réinitialisation du mot de passe de l\'utilisateur :',
    // Bulk Import Modal
    "csv_format_requirements": 'Votre fichier CSV doit être correctement formaté. Si vous n\'êtes pas sûr du format, vous pouvez également',
    "csv_format_download_link": 'télécharger un fichier modèle ici.',
    "csv_format_error": 'Nous n\'avons pas pu traiter votre fichier téléversé. Assurez-vous qu\'il est dans le format correct et inclut les en-têtes \'email\' et \'manager_0\'.',
    "select_csv": 'Parcourir un fichier CSV',
    "import": 'Importer',
    "file_too_large": 'Fichier trop volumineux (Maximum de IMPORT_LIMIT utilisateurs)',
    "required_headers_missing": 'En-têtes requis manquants : email',
    "user_import_starting": 'L\'importation des utilisateurs commence. Vous recevrez un courriel de résumé dans quelques minutes.',
    "change_file": 'Changer de fichier',
    "invalid_email_error": 'Le courriel contient des caractères invalides',
    // Bulk Import Messaging
    "bulk_processing_1": 'Nous traitons le fichier :',
    "bulk_processing_2": 'Dès que nous aurons terminé, nous vous enverrons un courriel avec tous les détails.',
    "bulk_complete_1": 'Terminé :',
    "bulk_complete_2": 'a été téléversé avec succès.',
    "bulk_error": 'Une erreur est survenue et votre fichier n\'a pas été téléversé sur le serveur. Veuillez vérifier votre courriel pour plus de détails.',
    "bulk_thanks_header": 'Merci d\'avoir téléversé votre fichier !',
    "bulk_thanks_content": 'Nous le traitons maintenant et dès que ce sera terminé, nous vous enverrons un courriel avec tous les détails. Vous pouvez aussi suivre l\'état du fichier dans l\'application.',
    // Tenant Main Settings
    "email_language": 'Langue des courriels',
    "country": 'Pays',
    "description_optional": 'Description (Optionnel)',
    "units_feet_meters": 'Unités (Pieds, Mètres)',
    "certify_id": 'ID Certify',
    "resolve_id": 'ID Resolve',
    "sms_from": 'SMS De',
    "sms_body": 'Texte du SMS',
    "default_sms_body": 'Votre installation Wi-Fi est terminée et a été certifiée par [NAME] ! \n Consultez votre certificat ici : [LINK]',
    "sms_body_helper_text": 'Certify enverra ce message par SMS au client. [LINK] sera remplacé par un lien vers le certificat (obligatoire). [NAME] sera remplacé par le contenu du champ Nom (optionnel).',
    "link_must_be_in_sms_body": '[LINK] doit être inclus dans le texte du SMS.',
    "update_successful": 'Mise à jour réussie',
    "creation_successful": 'Création réussie',
    // Tenant Terminology Settings
    "term": 'Terme',
    "example_usage": 'Exemple d\'utilisation',
    "customer_example_usage_1": 'En consultation avec le client, confirmez le bâtiment sélectionné ou retournez modifier l\'adresse.',
    "customer_example_usage_2": 'En consultation avec l\'abonné, confirmez le bâtiment sélectionné ou retournez modifier l\'adresse.',
    "router_example_usage_1": 'Touchez l\'emplacement proposé du routeur ci-dessous.',
    "router_example_usage_2": 'Touchez l\'emplacement proposé du modem ci-dessous.',
    "router_example_usage_3": 'Touchez l\'emplacement proposé de la passerelle ci-dessous.',
    "router_example_usage_4": 'Touchez l\'emplacement proposé du hub ci-dessous.',
    "router_example_usage_5": 'Touchez l\'emplacement proposé de la passerelle résidentielle ci-dessous.',
    "level_example_usage_1": 'Allez au niveau 2 et touchez votre emplacement.',
    "level_example_usage_2": 'Allez à l\'étage 2 et touchez votre emplacement.',
    "mesh_pod_example_usage_1": 'Estimation de la puissance du signal et de l\'emplacement optimal du pod maillé.',
    "mesh_pod_example_usage_2": 'Estimation de la puissance du signal et de l\'emplacement optimal du point d\'accès.',
    "mesh_pod_example_usage_3": 'Estimation de la puissance du signal et de l\'emplacement optimal du nœud maillé.',
    "mesh_pod_example_usage_4": 'Estimation de la puissance du signal et de l\'emplacement optimal du puck maillé.',
    "mesh_pod_example_usage_5": 'Estimation de la puissance du signal et de l\'emplacement optimal de la balise.',
    "mesh_pod_example_usage_6": 'Estimation de la puissance du signal et de l\'emplacement optimal de l\'extension de portée.',
    "wifi_example_usage_1": 'Cartographie Wi-Fi',
    "wifi_example_usage_2": 'Cartographie Wi-Fi',
    "wifi_example_usage_3": 'Cartographie Wifi',
    "wifi_example_usage_4": 'Cartographie WIFI',
    // Tenant Equipment Settings (Certify)
    "router_options_1": 'Options de routeur',
    "router_options_2": 'Options de modem',
    "router_options_3": 'Options de passerelle',
    "router_options_4": 'Options de hub',
    "router_options_5": 'Options de passerelle résidentielle',
    "new_router_options_1": 'Nouvelles options de routeur',
    "new_router_options_2": 'Nouvelles options de modem',
    "new_router_options_3": 'Nouvelles options de passerelle',
    "new_router_options_4": 'Nouvelles options de hub',
    "new_router_options_5": 'Nouvelles options de passerelle résidentielle',
    "mesh_pod_options_1": 'Options de pod maillé',
    "mesh_pod_options_2": 'Options de point d\'accès',
    "mesh_pod_options_3": 'Options de nœud maillé',
    "mesh_pod_options_4": 'Options de puck maillé',
    "mesh_pod_options_5": 'Options de balise',
    "mesh_pod_options_6": 'Options d\'extension de portée',
    "new_mesh_pod_options_1": 'Nouvelles options de pod maillé',
    "new_mesh_pod_options_2": 'Nouvelles options de point d\'accès',
    "new_mesh_pod_options_3": 'Nouvelles options de nœud maillé',
    "new_mesh_pod_options_4": 'Nouvelles options de puck maillé',
    "new_mesh_pod_options_5": 'Nouvelles options de balise',
    "new_mesh_pod_options_6": 'Nouvelles options d\'extension de portée',
    "missing_required_router_info_1": 'Informations requises sur le routeur manquantes',
    "missing_required_router_info_2": 'Informations requises sur le modem manquantes',
    "missing_required_router_info_3": 'Informations requises sur la passerelle manquantes',
    "missing_required_router_info_4": 'Informations requises sur le hub manquantes',
    "missing_required_router_info_5": 'Informations requises sur la passerelle résidentielle manquantes',
    "missing_required_mesh_pod_info_1": 'Informations requises sur le pod maillé manquantes',
    "missing_required_mesh_pod_info_2": 'Informations requises sur le point d\'accès manquantes',
    "missing_required_mesh_pod_info_3": 'Informations requises sur le nœud maillé manquantes',
    "missing_required_mesh_pod_info_4": 'Informations requises sur le puck maillé manquantes',
    "missing_required_mesh_pod_info_5": 'Informations requises sur la balise manquantes',
    "missing_required_mesh_pod_info_6": 'Informations requises sur l\'extension de portée manquantes',
    "display_name": 'Nom d\'affichage',
    "description": 'Description',
    "range_in_unit_1": 'Portée en pieds',
    "range_in_unit_2": 'Portée en mètres',
    "area_in_unit_1": 'Surface en pieds carrés',
    "area_in_unit_2": 'Surface en mètres carrés',
    "default_active": 'Activé par défaut',
    "average_range": 'Portée moyenne',
    "certify_default": 'Par défaut Certify',
    "default": 'Défaut',
    "active": 'Actif',
    "one_option_must_be_default": 'Une option doit être définie comme par défaut',
    "set_as_default": 'Définir comme par défaut',
    "default_option_must_be_active": 'L\'option par défaut doit être active',
    "deactivate": 'Désactiver',
    "activate": 'Activer',
    "name_is_required": 'Le nom est requis',
    "show_terminology_fields": 'Afficher les champs de terminologie de Certify',
    // Customer Name
    "customer_1": 'Client',
    "customer_2": 'Abonné',
    // Pod Name
    "pod_1": 'Pod maillé',
    "pod_2": 'Point d\'accès',
    "pod_3": 'Nœud maillé',
    "pod_4": 'Puck maillé',
    "pod_5": 'Balise',
    "pod_6": 'Extension de portée',
    "pod_7": 'Répartiteur Wi-Fi',
    "pods_1": 'Pods maillés',
    "pods_2": 'Points d\'accès',
    "pods_3": 'Nœuds maillés',
    "pods_4": 'Pucks maillés',
    "pods_5": 'Balises',
    "pods_6": 'Extensions de portée',
    "pods_7": 'Répartiteurs Wi-Fi',
    // Router Name
    "router_1": 'Routeur',
    "router_2": 'Modem',
    "router_3": 'Passerelle',
    "router_4": 'Hub',
    "router_5": 'Box Internet',
    // Level Name
    "level_1": 'Niveau',
    "level_2": 'Étage',
    "levels_1": 'Niveaux',
    "levels_2": 'Étages',
    // Wifi Name
    "wifi_1": 'WiFi',
    "wifi_2": 'Wi-Fi',
    "wifi_3": 'Wifi',
    "wifi_4": 'WIFI',
    // Units
    "units_1": 'Pieds',
    "units_2": 'Mètres',
    // Pod Info
    "recommended": 'Recommandé',
    "installed": 'Installé',
    "total": 'Total',
    // Platform Fields
    "platform": 'Plateforme',
    // Misc
    "confirm": 'Confirmer',
    "units": 'Unités',
    "region": 'Région',
    "edit": 'Modifier',
    "modified": 'Modifié',
    "create": 'Créer',
    "created": 'Créé',
    "routethis_app": 'Application RouteThis',
    "loading": 'Chargement...',
    "redirecting": 'Redirection...',
    "error": 'Erreur',
    "cancel": 'Annuler',
    "close": 'Fermer',
    "edit_user_x": 'Modifier l\'utilisateur [X]',
    "search": 'Rechercher',
    "all": 'Tous',
    "dismiss": 'Ignorer',
    "account_holder": 'Titulaire du compte',
    "unauthenticated_login_again": 'Non authentifié. Veuillez vous reconnecter.',
    // HelpDropdown
    "need_help": 'Besoin d\'aide ?',
    "knowledge_base": 'Base de connaissances',
    "contact_us": 'Nous contacter',
    // UserDropdown
    "hello": 'Bonjour',
    "sign_out": 'Se déconnecter',
    // Languages
    "en": 'Anglais (É.-U.)',
    'en-GB': 'Anglais (R.-U.)',
    "da": 'Danois',
    "fi": 'Finnois',
    "fr": 'Français',
    'fr-CA': 'Français (Canada)',
    "de": 'Allemand',
    "el": 'Grec',
    "it": 'Italien',
    "pt": 'Portugais',
    'pt-BR': 'Portugais (Brésil)',
    "es": 'Espagnol',
    'es-419': 'Espagnol (Amérique latine)',
    "sv": 'Suédois',
    // Client-side validation errors
    "incorrect_email_or_password": 'Courriel ou mot de passe incorrect, ou compte désactivé. Réessayez ou contactez un administrateur.',
    "invalid_reset_code": 'Code de réinitialisation invalide',
    "password_minimum_requirements": 'Votre mot de passe doit comporter au moins 8 caractères et inclure au moins une minuscule, une majuscule et un chiffre.',
    "password_minimum_requirements_shortened": "Minimum 8 caractères, une majuscule et un chiffre",
    "passwords_must_match": 'Les mots de passe doivent correspondre',
    "must_include_new_password_email": 'Vous devez inclure un nouveau mot de passe et un courriel d\'utilisateur',
    "must_include_new_password_confirmation_code": 'Vous devez inclure un nouveau mot de passe et un code de confirmation',
    "cannot_send_reset_code_without_email": 'Impossible d\'envoyer un code de réinitialisation sans courriel',
    "must_enter_old_password": 'Vous devez entrer l\'ancien mot de passe',
    "must_enter_reset_code": 'Vous devez entrer le code de réinitialisation',
    "must_enter_new_password": 'Vous devez entrer un nouveau mot de passe',
    "passwords_cannot_begin_or_end_with_spaces": 'Les mots de passe ne peuvent pas commencer ou se terminer par des espaces',
    // Server-side errors
    'User with that email already exists': 'Un utilisateur avec ce courriel existe déjà',
    'Try another display name': 'Essayez un autre nom d\'affichage',
    'Password cannot be a previously used password': 'Le mot de passe ne peut pas être un mot de passe déjà utilisé',
    'Invalid reset code': 'Code de réinitialisation invalide',
    'Incorrect email or password, or disabled account. Try again or contact an administrator.': 'Courriel ou mot de passe incorrect, ou compte désactivé. Réessayez ou contactez un administrateur.',
    'Invalid code provided, please request a code again.': 'Code invalide fourni, veuillez demander un nouveau code.',
    'Password cannot begin or end with spaces': 'Le mot de passe ne peut pas commencer ou se terminer par des espaces',
    'LimitExceededException - Attempt limit exceeded, please try after some time.': 'LimitExceededException - Limite de tentatives dépassée, veuillez réessayer plus tard.',
    'User is not Authorized': 'Utilisateur non autorisé',
    'Your session timed out. Sign in again with your temporary password.': 'Votre session a expiré. Connectez-vous à nouveau avec votre mot de passe temporaire.',
    'Internal Service Failure - Cognito Unavailable': 'Erreur de service interne - Cognito non disponible',
    'Internal Service Failure - Unknown Failure': 'Erreur de service interne - Échec inconnu',
    'Must enter Reset Code': 'Vous devez entrer un code de réinitialisation',
    // Change Password Challenges
    "step_1_of_2": "Étape 1 sur 2",
    "step_2_of_2": "Étape 2 sur 2",
    "set_password_challenge": 'Vous devez définir un nouveau mot de passe lors de votre première connexion pour des raisons de sécurité.',
    "reset_password_challenge": 'Nous avons envoyé un code de réinitialisation de mot de passe à [EMAIL]. Entrez ce code et un nouveau mot de passe.',
    "set_new_password_challenge": 'La politique de votre entreprise exige que votre mot de passe expire après un certain temps. Nous avons envoyé un code de réinitialisation de mot de passe à [EMAIL]. Entrez ce code et un nouveau mot de passe.',
    "change_your_password_challenge": 'Entrez votre mot de passe actuel et un nouveau mot de passe ci-dessous pour le changer.',
    "change_password_challenge": 'Entrez un nouveau mot de passe pour l\'utilisateur',
    "reset_password_challenge_instructions": "Nous enverrons au compte [EMAIL] un code de réinitialisation et des instructions supplémentaires pour créer un nouveau mot de passe.",
    // Country Codes
    AF: 'Afghanistan',
    AX: 'Îles Åland',
    AL: 'Albanie',
    DZ: 'Algérie',
    AS: 'Samoa américaines',
    AD: 'Andorre',
    AO: 'Angola',
    AI: 'Anguilla',
    AQ: 'Antarctique',
    AG: 'Antigua-et-Barbuda',
    AR: 'Argentine',
    AM: 'Arménie',
    AW: 'Aruba',
    AU: 'Australie',
    AT: 'Autriche',
    AZ: 'Azerbaïdjan',
    BS: 'Bahamas',
    BH: 'Bahreïn',
    BD: 'Bangladesh',
    BB: 'Barbade',
    BY: 'Bélarus',
    BE: 'Belgique',
    BZ: 'Belize',
    BJ: 'Bénin',
    BM: 'Bermudes',
    BT: 'Bhoutan',
    BO: 'Bolivie (État plurinational de)',
    BQ: 'Bonaire, Saint-Eustache et Saba',
    BA: 'Bosnie-Herzégovine',
    BW: 'Botswana',
    BV: 'Île Bouvet',
    BR: 'Brésil',
    IO: 'Territoire britannique de l\'océan Indien',
    BN: 'Brunei Darussalam',
    BG: 'Bulgarie',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    CV: 'Cap-Vert',
    KH: 'Cambodge',
    CM: 'Cameroun',
    CA: 'Canada',
    KY: 'Îles Caïmans',
    CF: 'République centrafricaine',
    TD: 'Tchad',
    CL: 'Chili',
    CN: 'Chine',
    CX: 'Île Christmas',
    CC: 'Îles Cocos (Keeling)',
    CO: 'Colombie',
    KM: 'Comores',
    CG: 'Congo',
    CD: 'Congo, République démocratique du',
    CK: 'Îles Cook',
    CR: 'Costa Rica',
    CI: 'Côte d\'Ivoire',
    HR: 'Croatie',
    CU: 'Cuba',
    CW: 'Curaçao',
    CY: 'Chypre',
    CZ: 'Tchéquie',
    DK: 'Danemark',
    DJ: 'Djibouti',
    DM: 'Dominique',
    DO: 'République dominicaine',
    EC: 'Équateur',
    EG: 'Égypte',
    SV: 'El Salvador',
    GQ: 'Guinée équatoriale',
    ER: 'Érythrée',
    EE: 'Estonie',
    SZ: 'Eswatini',
    ET: 'Éthiopie',
    FK: 'Îles Malouines',
    FO: 'Îles Féroé',
    FJ: 'Fidji',
    FI: 'Finlande',
    FR: 'France',
    GF: 'Guyane française',
    PF: 'Polynésie française',
    TF: 'Terres australes françaises',
    GA: 'Gabon',
    GM: 'Gambie',
    GE: 'Géorgie',
    DE: 'Allemagne',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GR: 'Grèce',
    GL: 'Groenland',
    GD: 'Grenade',
    GP: 'Guadeloupe',
    GU: 'Guam',
    GT: 'Guatemala',
    GG: 'Guernesey',
    GN: 'Guinée',
    GW: 'Guinée-Bissau',
    GY: 'Guyana',
    HT: 'Haïti',
    HM: 'Îles Heard-et-MacDonald',
    VA: 'Saint-Siège',
    HN: 'Honduras',
    HK: 'Hong Kong',
    HU: 'Hongrie',
    IS: 'Islande',
    IN: 'Inde',
    ID: 'Indonésie',
    IR: 'Iran (République islamique d\')',
    IQ: 'Irak',
    IE: 'Irlande',
    IM: 'Île de Man',
    IL: 'Israël',
    IT: 'Italie',
    JM: 'Jamaïque',
    JP: 'Japon',
    JE: 'Jersey',
    JO: 'Jordanie',
    KZ: 'Kazakhstan',
    KE: 'Kenya',
    KI: 'Kiribati',
    KP: 'Corée (République populaire démocratique de)',
    KR: 'Corée, République de',
    KW: 'Koweït',
    KG: 'Kirghizistan',
    LA: 'Lao (République démocratique populaire)',
    LV: 'Lettonie',
    LB: 'Liban',
    LS: 'Lesotho',
    LR: 'Libéria',
    LY: 'Libye',
    LI: 'Liechtenstein',
    LT: 'Lituanie',
    LU: 'Luxembourg',
    MO: 'Macao',
    MG: 'Madagascar',
    MW: 'Malawi',
    MY: 'Malaisie',
    MV: 'Maldives',
    ML: 'Mali',
    MT: 'Malte',
    MH: 'Îles Marshall',
    MQ: 'Martinique',
    MR: 'Mauritanie',
    MU: 'Maurice',
    YT: 'Mayotte',
    MX: 'Mexique',
    FM: 'Micronésie (États fédérés de)',
    MD: 'Moldova, République de',
    MC: 'Monaco',
    MN: 'Mongolie',
    ME: 'Monténégro',
    MS: 'Montserrat',
    MA: 'Maroc',
    MZ: 'Mozambique',
    MM: 'Myanmar',
    NA: 'Namibie',
    NR: 'Nauru',
    NP: 'Népal',
    NL: 'Pays-Bas',
    NC: 'Nouvelle-Calédonie',
    NZ: 'Nouvelle-Zélande',
    NI: 'Nicaragua',
    NE: 'Niger',
    NG: 'Nigeria',
    NU: 'Niue',
    NF: 'Île Norfolk',
    MK: 'Macédoine du Nord',
    MP: 'Îles Mariannes du Nord',
    NO: 'Norvège',
    OM: 'Oman',
    PK: 'Pakistan',
    PW: 'Palaos',
    PS: 'Palestine, État de',
    PA: 'Panama',
    PG: 'Papouasie-Nouvelle-Guinée',
    PY: 'Paraguay',
    PE: 'Pérou',
    PH: 'Philippines',
    PN: 'Pitcairn',
    PL: 'Pologne',
    PT: 'Portugal',
    PR: 'Porto Rico',
    QA: 'Qatar',
    RE: 'Réunion',
    RO: 'Roumanie',
    RU: 'Fédération de Russie',
    RW: 'Rwanda',
    BL: 'Saint-Barthélemy',
    SH: 'Sainte-Hélène, Ascension et Tristan da Cunha',
    KN: 'Saint-Kitts-et-Nevis',
    LC: 'Sainte-Lucie',
    MF: 'Saint-Martin (partie française)',
    PM: 'Saint-Pierre-et-Miquelon',
    VC: 'Saint-Vincent-et-les Grenadines',
    WS: 'Samoa',
    SM: 'Saint-Marin',
    ST: 'Sao Tomé-et-Principe',
    SA: 'Arabie saoudite',
    SN: 'Sénégal',
    RS: 'Serbie',
    SC: 'Seychelles',
    SL: 'Sierra Leone',
    SG: 'Singapour',
    SX: 'Saint-Martin (partie néerlandaise)',
    SK: 'Slovaquie',
    SI: 'Slovénie',
    SB: 'Îles Salomon',
    SO: 'Somalie',
    ZA: 'Afrique du Sud',
    GS: 'Géorgie du Sud et les îles Sandwich du Sud',
    SS: 'Soudan du Sud',
    ES: 'Espagne',
    LK: 'Sri Lanka',
    SD: 'Soudan',
    SR: 'Suriname',
    SJ: 'Svalbard et Jan Mayen',
    SE: 'Suède',
    CH: 'Suisse',
    SY: 'République arabe syrienne',
    TW: 'Taïwan, province de Chine',
    TJ: 'Tadjikistan',
    TZ: 'Tanzanie, République unie de',
    TH: 'Thaïlande',
    TL: 'Timor-Leste',
    TG: 'Togo',
    TK: 'Tokélaou',
    TO: 'Tonga',
    TT: 'Trinité-et-Tobago',
    TN: 'Tunisie',
    TR: 'Turquie',
    TM: 'Turkménistan',
    TC: 'Îles Turques-et-Caïques',
    TV: 'Tuvalu',
    UG: 'Ouganda',
    UA: 'Ukraine',
    AE: 'Émirats arabes unis',
    GB: 'Royaume-Uni de Grande-Bretagne et d\'Irlande du Nord',
    US: 'États-Unis d\'Amérique',
    UM: 'Îles mineures éloignées des États-Unis',
    UY: 'Uruguay',
    UZ: 'Ouzbékistan',
    VU: 'Vanuatu',
    VE: 'Venezuela (République bolivarienne du)',
    VN: 'Viet Nam',
    VG: 'Îles Vierges britanniques',
    VI: 'Îles Vierges des États-Unis',
    WF: 'Wallis-et-Futuna',
    EH: 'Sahara occidental',
    YE: 'Yémen',
    ZM: 'Zambie',
    ZW: 'Zimbabwe',
};

const fr_CA = {
    // Login/Reset Password
    "email": "Courriel",
    "password": "Mot de passe",
    "sign_in": "S'identifier",
    "continue": "Continuer",
    "forgot_password": "Oublier le mot de passe",
    "reset_password": "Réinitialiser le mot de passe",
    "reset_password_instructions": "Pour réinitialiser votre mot de passe, saisissez votre adresse courriel ci-dessus et nous vous enverrons des instructions, si le compte existe.",
    "sent_reset_password_code": "Nous avons envoyé un code de réinitialisation du mot de passe à [courriel] Saisissez ce code et un nouveau mot de passe.",
    "reset_code": "Code de réinitialisation",
    "new_password": "Nouveau mot de passe",
    "reenter_new_password": "Saisissez à nouveau le nouveau mot de passe",
    "must_include_email": "Vous devez indiquer votre courriel",
    "old_password": "Ancien mot de passe",
    "set_new_password": "Définir un nouveau mot de passe",
    "password_expired": "Mot de passe expiré",
    "toggle_password_visibility": "(Dés)activer la visibilité du mot de passe",
    "change_your_password": "Modifier votre mot de passe",
    "change_password": "Changer de mot de passe",
    "set_password": "Définir le mot de passe",
    "already_have_reset_code": "J'ai déjà un code de réinitialisation",
    "confirm_password": "Confirmer le mot de passe",
    "idle_logged_out_warning": 'Vous êtes inactif et serez déconnecté dans 10 secondes',
    "logged_out": "Vous avez été déconnecté",
    "login_title_text": "Connexion",
    "try_again": "Réessayez",
    "login_error_message": "Nous n'avons pas pu trouver votre utilisateur. Vous pouvez réessayer ou contacter votre gestionnaire de compte.",
    "invalid_login_credentials_error_message": "Combinaison de nom d'utilisateur et de mot de passe incorrecte ou l'utilisateur n'existe pas.",
    "enter_password_reset_code": "Veuillez entrer le code que nous avons envoyé au compte [email].",
    "repeat-new-password": "Répétez le Nouveau Mot de Passe",
    "send-code": "Envoyer le code",
    "okta-sign-in": "Se connecter avec Okta",
    "google-sign-in": "Se connecter avec Google",
    "microsoft-sign-in": "Se connecter avec Microsoft",
    "or": "OU",
    "contact_manager_for_account": "Pour les nouveaux comptes, veuillez contacter votre gestionnaire",
    // ListUsers
    "search_enter_4_chars": "Veuillez saisir au moins quatre caractères pour effectuer une recherche",
    "user_search_placeholder_email": "Rechercher le début d'un courriel",
    "user_search_placeholder": "Recherchez le début d'un courriel, d'un gestionnaire ou d'un groupe",
    "no_users_found": "Aucun utilisateur trouvé",
    // Sidebar
    "users": "Utilisateurs",
    "main_settings": "Paramètres principaux",
    "terminology": "Terminologie",
    "equipment": "Équipement",
    "security": "Sécurité",
    "tenants": "Locataires",
    "collapse": "Réduire",
    // Users List
    "add_user": "Ajouter un utilisateur",
    "edit_user": "Modifier un utilisateur",
    "bulk_import": "Importation en bloc",
    "bulk_import_users": "Importation en bloc d'utilisateurs",
    "add_group": 'Ajouter un groupe',
    "manage_users": 'Gérer les utilisateurs',
    "manage_groups": 'Gérer le groupe',
    "show_roles_list": 'Afficher les rôles',
    "show_disabled_users": "Afficher les utilisateurs désactivés",
    "name": "Nom",
    "role": "Rôle",
    "roles": "Rôles",
    "role_name": 'Nom du rôle',
    "role_description": 'Description du rôle',
    "role_id": 'ID de rôle',
    "location": "Emplacement",
    "routethis_group": "Groupe RouteThis",
    "manager": "Gestionnaire",
    "download_bulk_template": "Téléchargez le modèle d'envoi en masse",
    "user_id_email": "Identifiant de l'utilisateur (courriel)",
    "users_for": 'Utilisateurs pour:',
    // Valid User roles
    "user_role": "utilisateur",
    "tenant_admin_role": "Administrateur du locataire",
    "super_admin_role": "Super administrateur",
    "user": "Utilisateur",
    "tenant_admin": "Administrateur du locataire",
    "super_admin": "Super administrateur",
    // Create/Edit User Modal
    "create_user": 'Créer un utilisateur',
    "email_required": "Courriel (obligatoire)",
    "first_name": "Prénom",
    "last_name": "Nom de famille",
    "force_password_reset": "Forcer la réinitialisation du mot de passe",
    "resend_welcome_email": 'Renvoyer le courriel de bienvenue',
    "resend_validation_code": "Renvoyer le code de validation",
    "enable_users": 'Activer les utilisateurs',
    "disable_users": 'Désactiver les utilisateurs',
    "certify": "Certify",
    "unverified": "Non vérifié",
    "verified": "Vérifié",
    "locked_out": "Verrouillé",
    "disabled": "Désactivé",
    "save": "Sauvegarder",
    "reset_user_password_confirmation": "Êtes-vous sûr de vouloir réinitialiser le mot de passe de cet utilisateur?",
    "resend_validation_code_confirmation": "Êtes-vous sûr de vouloir renvoyer le code de validation?",
    "cannot_disable_yourself": "Vous ne pouvez pas vous désactiver",
    "cancel_changes": "Annuler les modifications",
    "required": "Requis",
    "password_email_template": 'Modèle de courriel pour le mot de passe',
    "include_in_resolve_usage_reports": "Inclure dans les rapports d'utilisation de Resolve",
    "delete_user": "Supprimer l'utilisateur.",
    "delete_are_you_sure": "Êtes-vous sûr de vouloir supprimer cet utilisateur? AVERTISSEMENT : Cette action est irréversible.",
    "delete": "Supprimer",
    // Create Edit Group modal
    "create_group": "Créer un groupe",
    "edit_group": "Modifier le groupe",
    "group_name": "Nom du groupe",
    "group_type": "Type de groupe",
    "search_by_group_name": "Rechercher par nom de groupe",
    "search_by_role_name": "Rechercher par nom de rôle",
    // Snackbar Messages
    "snackbar_disable_success": "L'utilisateur a été désactivé avec succès :",
    "snackbar_disable_error": "Erreur de désactivation de l'utilisateur :",
    "snackbar_enable_success": "Utilisateur activé avec succès :",
    "snackbar_enable_error": "Erreur d'activation de l'utilisateur :",
    "snackbar_password_reset_success": "Réinitialisation réussie du mot de passe de l'utilisateur :",
    "snackbar_password_reset_error": "Erreur de réinitialisation du mot de passe pour l'utilisateur :",
    // Bulk Import Modal
    "csv_format_requirements": "Votre format CSV doit être formaté correctement. Si vous n'êtes pas sûr du format, vous pouvez également",
    "csv_format_download_link": "télécharger un fichier modèle ici.",
    "csv_format_error": "Nous n'avons pas pu traiter votre fichier téléchargé, veuillez vous assurer que votre fichier est au bon format et qu'il contient les en-têtes « courriel » et « manager_0 ».",
    "select_csv": "Parcourir le fichier CSV",
    "import": "Importer",
    "file_too_large": "Fichier trop volumineux (maximum de IMPORT_LIMIT utilisateurs)",
    "required_headers_missing": "En-têtes requis manquants : courriel",
    "user_import_starting": "L'importation de l'utilisateur commence. Vous recevrez un courriel récapitulatif de l'importation dans quelques minutes.",
    "change_file": "Modifier le fichier",
    "invalid_email_error": "Le courriel contient des caractères non valides",
    // Bulk Import Messaging
    "bulk_processing_1": "Nous sommes en train de traiter le fichier :",
    "bulk_processing_2": "Dès que nous aurons terminé, nous vous enverrons un courriel avec tous les détails.",
    "bulk_complete_1": "Terminé :",
    "bulk_complete_2": "est maintenant téléchargé.",
    "bulk_error": "Une erreur s'est produite et votre fichier n'a pas été téléchargé sur le serveur. Veuillez consulter votre courriel pour plus de détails.",
    "bulk_thanks_header": "Merci d'avoir téléchargé votre fichier!",
    "bulk_thanks_content": "Nous sommes en train de le traiter et dès que nous aurons terminé, nous vous enverrons un courriel avec tous les détails. Vous pouvez également garder un œil sur l'application pour obtenir des mises à jour sur l'état de votre fichier.",
    // Tenant Main Settings
    "email_language": "Langue du courriel",
    "country": "Pays",
    "description_optional": "Description (optionnel)",
    "units_feet_meters": "Unités (pieds, mètres)",
    "certify_id": "Certifier l'identifiant",
    "resolve_id": "Résoudre l'identifiant",
    "sms_from": "SMS de",
    "sms_body": "Corps du SMS",
    "default_sms_body": "Votre installation Wi-Fi est terminée et a été certifiée par [NOM]! \\n Consultez votre certificat ici : [LIEN]",
    "sms_body_helper_text": "Certify enverra ce message au client. Le [LIEN] sera remplacé par un lien vers le certificat (obligatoire). Le [NOM] sera remplacé par le contenu du champ « Nom » (facultatif).",
    "link_must_be_in_sms_body": "[LINK] doit figurer dans le corps du SMS.",
    "update_successful": "Mise à jour réussie",
    "creation_successful": "Création réussie",
    // Tenant Terminology Settings
    "term": "Terme",
    "example_usage": "Exemple d'utilisation",
    "customer_example_usage_1": "En concertation avec le client, confirmez le bâtiment sélectionné ou revenez à la modification de l'adresse.",
    "customer_example_usage_2": "En concertation avec l'abonné, confirmez le bâtiment sélectionné ou revenez en arrière pour modifier l'adresse.",
    "router_example_usage_1": "Tapez sur l'emplacement proposé pour le routeur ci-dessous.",
    "router_example_usage_2": "Tapez sur l'emplacement proposé pour le modem ci-dessous.",
    "router_example_usage_3": "Tapez sur l'emplacement proposé pour la passerelle ci-dessous.",
    "router_example_usage_4": "Tapez sur l'emplacement du concentrateur proposé ci-dessous.",
    "router_example_usage_5": "Tapez sur l'emplacement de la passerelle résidentielle proposée ci-dessous.",
    "level_example_usage_1": "Allez au niveau 2 et tapez sur votre emplacement.",
    "level_example_usage_2": "Allez à l'étage 2 et tapez sur votre emplacement.",
    "mesh_pod_example_usage_1": "Estimation de la puissance du signal et placement optimal du pod maillé.",
    "mesh_pod_example_usage_2": "Estimation de la puissance du signal et placement optimal des points d'accès.",
    "mesh_pod_example_usage_3": "Estimation de l'intensité du signal et placement optimal des nœuds maillés.",
    "mesh_pod_example_usage_4": "Estimation de l'intensité du signal et placement optimal des rondelles maillées.",
    "mesh_pod_example_usage_5": "Estimation de l'intensité du signal et placement optimal des balises.",
    "mesh_pod_example_usage_6": "Estimation de l'intensité du signal et placement optimal d'un prolongateur de portée.",
    "wifi_example_usage_1": "Cartographie du Wi-Fi",
    "wifi_example_usage_2": "Cartographie du Wi-Fi",
    "wifi_example_usage_3": "Cartographie du Wi-Fi",
    "wifi_example_usage_4": "Cartographie du Wi-Fi",
    // Tenant Equipment Settings (Certify)
    "router_options_1": "Options du routeur",
    "router_options_2": "Options du modem",
    "router_options_3": "Options de la passerelle",
    "router_options_4": "Options du concentrateur",
    "router_options_5": "Options de la passerelle résidentielle",
    "new_router_options_1": "Nouvelles options de routeur",
    "new_router_options_2": "Nouvelles options de modem",
    "new_router_options_3": "Nouvelles options de passerelle",
    "new_router_options_4": "Nouvelles options de concentrateur",
    "new_router_options_5": "Nouvelles options de passerelle résidentielle",
    "mesh_pod_options_1": "Options de pods maillés",
    "mesh_pod_options_2": "Options de points d'accès",
    "mesh_pod_options_3": "Options de nœuds maillés",
    "mesh_pod_options_4": "Options de rondelles maillées",
    "mesh_pod_options_5": "Options de balises",
    "mesh_pod_options_6": "Options de prolongateur de portée",
    "new_mesh_pod_options_1": "Nouvelles options de pods maillés",
    "new_mesh_pod_options_2": "Nouvelles options de point d'accès",
    "new_mesh_pod_options_3": "Nouvelles options de nœuds maillés",
    "new_mesh_pod_options_4": "Nouvelles options de rondelles maillées",
    "new_mesh_pod_options_5": "Nouvelles options de balise",
    "new_mesh_pod_options_6": "Nouvelles options de prolongateur de portée",
    "missing_required_router_info_1": "Informations manquantes sur le routeur",
    "missing_required_router_info_2": "Informations manquantes sur le modem",
    "missing_required_router_info_3": "Informations manquantes sur la passerelle",
    "missing_required_router_info_4": "Informations manquantes sur le concentrateur",
    "missing_required_router_info_5": "Informations manquantes sur la passerelle résidentielle",
    "missing_required_mesh_pod_info_1": "Informations manquantes sur les pods maillés",
    "missing_required_mesh_pod_info_2": "Informations manquantes sur les point d'accès",
    "missing_required_mesh_pod_info_3": "Informations manquantes sur les nœuds maillés",
    "missing_required_mesh_pod_info_4": "Informations manquantes sur les rondelles maillées",
    "missing_required_mesh_pod_info_5": "Informations sur les balises manquantes",
    "missing_required_mesh_pod_info_6": "Informations sur le prolongateur de portée manquantes",
    "display_name": "Nom de l'affichage",
    "description": "Description",
    "range_in_unit_1": "Portée en pieds",
    "range_in_unit_2": "Portée en mètres",
    "area_in_unit_1": "Surface en pieds carrés",
    "area_in_unit_2": "Surface en mètres carrés",
    "default_active": "Actif par défaut",
    "average_range": "Moyenne de l'étendue",
    "certify_default": "Certifier la valeur par défaut",
    "default": "Défaut",
    "active": "Actif",
    "one_option_must_be_default": "Une option doit être par défaut",
    "set_as_default": "Définir par défaut",
    "default_option_must_be_active": "L'option par défaut doit être active",
    "deactivate": "Désactiver",
    "activate": "Activer",
    "name_is_required": "Le nom est obligatoire",
    "show_terminology_fields": "Afficher les champs terminologiques de la certification",
    // Customer Name
    "customer_1": "Client",
    "customer_2": "Abonné",
    // Pod Name
    "pod_1": "Pod maillé",
    "pod_2": "Point d'accès",
    "pod_3": "Nœud maillé",
    "pod_4": "Rondelle maillée",
    "pod_5": "Balise",
    "pod_6": "Prolongateur de portée",
    "pod_7": 'Répartiteur Wi-Fi',
    "pods_1": "Pods maillés",
    "pods_2": "Points d'accès",
    "pods_3": "Nœuds maillés",
    "pods_4": "Rondelles maillées",
    "pods_5": "Balises",
    "pods_6": "Prolongateurs de portée",
    "pods_7": 'Répartiteurs Wi-Fi',
    // Router Name
    "router_1": "Routeur",
    "router_2": "Modem",
    "router_3": "Passerelle",
    "router_4": "Concentrateur",
    "router_5": "Box Internet",
    // Level Name
    "level_1": "Niveau",
    "level_2": "Étage",
    "levels_1": "Niveaux",
    "levels_2": "Étages",
    // Wifi Name
    "wifi_1": "Wi-Fi",
    "wifi_2": "Wi-Fi",
    "wifi_3": "Wi-Fi",
    "wifi_4": "Wi-Fi",
    // Units
    "units_1": "Pieds",
    "units_2": "Mètres",
    // Pod Info
    "recommended": "Recommandé",
    "installed": "Installé",
    "total": "Total",
    // Platform Fields
    "platform": "Plate-forme",
    // Misc
    "confirm": "Confirmer",
    "units": "Unités",
    "region": "Région",
    "edit": "Modifier",
    "modified": "Modifié",
    "create": "Créer",
    "created": "Créé",
    "routethis_app": "Application RouteThis",
    "loading": "Chargement...",
    "redirecting": "Redirection...",
    "error": "Erreur",
    "cancel": "Annuler",
    "close": "Fermer",
    "edit_user_x": "Modifier l'utilisateur [X]",
    "search": "Rechercher",
    "all": "Tous",
    "dismiss": "IGNORER",
    "account_holder": "Titulaire de compte",
    "unauthenticated_login_again": "Non authentifié. Veuillez vous reconnecter.",
    // HelpDropdown
    "need_help": 'Besoin d’aide ?',
    "knowledge_base": 'Base de connaissances',
    "contact_us": 'Contactez-nous',
    // UserDropdown
    "hello": 'Bonjour',
    "sign_out": 'Se déconnecter',
    // Languages
    "en": "Anglais (États-Unis)",
    "en-GB": "Anglais (Royaume-Uni)",
    "da": "Danois",
    "fi": "Finlandais",
    "fr": "Français ",
    "fr-CA": "Français (Canada)",
    "de": "Allemand ",
    "el": "Grec",
    "it": "Italien",
    "pt": "Portugais ",
    "pt-BR": "Portugais (Brésil)",
    "es": "Espagnol",
    "es-419": "Espagnol (Amérique latine)",
    "sv": "Suédois",
    // Client-side validation errors
    "incorrect_email_or_password": "Courriel ou mot de passe incorrect, ou compte désactivé. Réessayez ou contactez un administrateur.",
    "invalid_reset_code": "Code de réinitialisation invalide",
    "password_minimum_requirements": "Votre mot de passe doit comporter un minimum de huit caractères, dont au moins une minuscule, une majuscule et un chiffre.",
    "password_minimum_requirements_shortened": "Minimum 8 caractères, une majuscule et un chiffre",
    "passwords_must_match": "Les mots de passe doivent correspondre",
    "must_include_new_password_email": "Doit inclure le nouveau mot de passe et le courriel de l'utilisateur",
    "must_include_new_password_confirmation_code": "Doit inclure le nouveau mot de passe et le code de confirmation",
    "cannot_send_reset_code_without_email": "Impossible d'envoyer un code de réinitialisation sans courriel",
    "must_enter_old_password": "Doit entrer l'ancien mot de passe",
    "must_enter_reset_code": "Doit entrer le code de réinitialisation",
    "must_enter_new_password": "Doit entrer le nouveau mot de passe",
    "passwords_cannot_begin_or_end_with_spaces": "Les mots de passe ne peuvent pas commencer ou se terminer par des espaces",
    // Server-side errors
    "User with that email already exists": "L'utilisateur ayant ce courriel existe déjà.",
    "Try another display name": "Essayez un autre nom d'affichage",
    "Password cannot be a previously used password": "Le mot de passe ne peut pas être un mot de passe déjà utilisé",
    "Invalid reset code": "Code de réinitialisation invalide",
    "Incorrect email or password, or disabled account. Try again or contact an administrator.": "Courriel ou mot de passe incorrect, ou compte désactivé. Réessayez ou contactez un administrateur.",
    "Invalid code provided, please request a code again.": "Le code fourni n'est pas valide, veuillez redemander un code.",
    "Password cannot begin or end with spaces": "Le mot de passe ne peut pas commencer ou se terminer par des espaces",
    "LimitExceededException - Attempt limit exceeded, please try after some time.": "LimitExceededException : la limite des tentatives a été dépassée, veuillez réessayer après un certain temps.",
    "User is not Authorized": "L'utilisateur n'est pas autorisé",
    "Your session timed out. Sign in again with your temporary password.": "Votre session a expiré. Reconnectez-vous avec votre mot de passe temporaire.",
    "Internal Service Failure - Cognito Unavailable": "Échec du service interne : cognito indisponible",
    "Internal Service Failure - Unknown Failure": "Échec du service interne : échec inconnu",
    "Must enter Reset Code": "Doit entrer le code de réinitialisation",
    // Change Password Challenges
    "step_1_of_2": "Étape 1 sur 2",
    "step_2_of_2": "Étape 2 sur 2",
    "set_password_challenge": "Pour des raisons de sécurité, vous devez définir un nouveau mot de passe la première fois que vous vous connectez.",
    "reset_password_challenge": "Nous avons envoyé un code de réinitialisation du mot de passe à [COURRIEL]. Saisissez ce code et un nouveau mot de passe.",
    "set_new_password_challenge": "La politique de votre entreprise exige que votre mot de passe expire après un certain temps. Nous avons envoyé un code de réinitialisation de mot de passe à [COURRIEL]. Saisissez ce code et un nouveau mot de passe.",
    "change_your_password_challenge": "Entrez votre mot de passe actuel et un nouveau mot de passe ci-dessous pour le modifier.",
    "change_password_challenge": "Entrez un nouveau mot de passe pour l'utilisateur",
    "reset_password_challenge_instructions": "Nous enverrons au compte [EMAIL] un code de réinitialisation et des instructions supplémentaires pour créer un nouveau mot de passe.",
    AF: "Afghanistan",
    AX: "Îles Åland",
    AL: "Albanie",
    DZ: "Algérie",
    AS: "Samoa américaines",
    AD: "Andorre",
    AO: "Angola",
    AI: "Anguilla",
    AQ: "Antarctique",
    AG: "Antigua et Barbuda",
    AR: "Argentine",
    AM: "Arménie",
    AW: "Aruba",
    AU: "Australie",
    AT: "Autriche",
    AZ: "Azerbaïdjan",
    BS: "Bahamas",
    BH: "Bahreïn",
    BD: "Bangladesh",
    BB: "Barbade",
    BY: "Biélorussie",
    BE: "Belgique",
    BZ: "Belize",
    BJ: "Bermudes",
    BM: "Bermudes",
    BT: "Bhoutan",
    BO: "Bolivie (État plurinational de)",
    BQ: "Bonaire, Sint Eustatius et Saba",
    BA: "Bosnie et Herzégovine",
    BW: "Botswana",
    BV: "Bouvet (Île)",
    BR: "Brésil",
    IO: "Territoire britannique de l'océan Indien",
    BN: "Brunei Darussalam",
    BG: "Bulgarie",
    BF: "Burkina Faso",
    BI: "Burundi",
    CV: "Cabo Verde",
    KH: "Cambodge",
    CM: "Cameroun",
    CA: "Canada",
    KY: "Îles Caïmans",
    CF: "République Centrafricaine",
    TD: "Tchad",
    CL: "Chili",
    CN: "Chine",
    CX: "Île Christmas",
    CC: "Îles Cocos (Keeling)",
    CO: "Colombie",
    KM: "Comores",
    CG: "Congo",
    CD: "Congo, République démocratique du",
    CK: "Îles Cook",
    CR: "Costa Rica",
    CI: "Côte d'Ivoire",
    HR: "Croatie",
    CU: "Côte d'Ivoire",
    CW: "Curaçao",
    CY: "Chypre",
    CZ: "Chypre",
    DK: "Danemark",
    DJ: "Djibouti",
    DM: "Dominique",
    DO: "République Dominicaine",
    EC: "Equateur",
    EG: "Égypte",
    SV: "El Salvador",
    GQ: "Guinée équatoriale",
    ER: "Erythrée",
    EE: "Estonie",
    SZ: "Eswatini",
    ET: "Éthiopie",
    FK: "Îles Malouines",
    FO: "Îles Féroé",
    FJ: "Fiji",
    FI: "Finlande",
    FR: "France",
    GF: "Guyane française",
    PF: "Polynésie française",
    TF: "Terres australes françaises",
    GA: "Gabon",
    GM: "Gambie",
    GE: "Géorgie",
    DE: "Allemagne",
    GH: "Ghana",
    GI: "Gibraltar",
    GR: "Grèce",
    GL: "Groenland",
    GD: "Grenade",
    GP: "Guadeloupe",
    GU: "Guam",
    GT: "Guatemala",
    GG: "Guernesey",
    GN: "Guinée",
    GW: "Guinée-Bissau",
    GY: "Guyana",
    HT: "Haïti",
    HM: "Île Heard et îles McDonald",
    VA: "Saint-Siège",
    HN: "Honduras",
    HK: "Hong Kong",
    HU: "Hongrie",
    IS: "Islande",
    IN: "Inde",
    ID: "Indonésie",
    IR: "Iran (République islamique d')",
    IQ: "Irak",
    IE: "Irlande",
    IM: "Île de Man",
    IL: "Israël",
    IT: "Italie",
    JM: "Jamaïque",
    JP: "Japon",
    JE: "Jersey",
    JO: "Jordanie",
    KZ: "Kazakhstan",
    KE: "Kenya",
    KI: "Kiribati",
    KP: "Corée (Peuple Démocratique)",
    KR: "Corée, République de",
    KW: "Koweït",
    KG: "Kyrgyzstan",
    LA: "République démocratique populaire lao",
    LV: "Lettonie",
    LB: "Liban",
    LS: "Lesotho",
    LR: "Libéria",
    LY: "Libye",
    LI: "Liechtenstein",
    LT: "Lituanie",
    LU: "Luxembourg",
    MO: "Macao",
    MG: "Madagascar",
    MW: "Malawi",
    MY: "Malaisie",
    MV: "Maldives",
    ML: "Mali",
    MT: "Malte",
    MH: "Îles Marshall",
    MQ: "Martinique",
    MR: "Mauritanie",
    MU: "Maurice",
    YT: "Mayotte",
    MX: "Mexique",
    FM: "Micronésie (États fédérés de)",
    MD: "Moldavie, République de",
    MC: "Monaco",
    MN: "Mongolie",
    ME: "Monténégro",
    MS: "Montserrat",
    MA: "Maroc",
    MZ: "Mozambique",
    MM: "Myanmar",
    NA: "Namibie",
    NR: "Nauru",
    NP: "Népal",
    NL: "Pays-Bas",
    NC: "Nouvelle Calédonie",
    NZ: "Nouvelle Zélande",
    NI: "Nicaragua",
    NE: "Niger",
    NG: "Nigéria",
    NU: "Niue",
    NF: "Île Norfolk",
    MK: "Macédoine du Nord",
    MP: "Îles Mariannes du Nord",
    NO: "Norvège",
    OM: "Oman",
    PK: "Pakistan",
    PW: "Palau",
    PS: "Palestine, État de",
    PA: "Panama",
    PG: "Papouasie-Nouvelle-Guinée",
    PY: "Paraguay",
    PE: "Pérou",
    PH: "Philippines",
    PN: "Pitcairn",
    PL: "Pologne",
    PT: "Portugal",
    PR: "Puerto Rico",
    QA: "Qatar",
    RE: "Réunion",
    RO: "Roumanie",
    RU: "Fédération de Russie",
    RW: "Rwanda",
    BL: "Saint Barthélemy",
    SH: "Sainte-Hélène, Ascension et Tristan da Cunha",
    KN: "Saint Kitts et Nevis",
    LC: "Sainte-Lucie",
    MF: "Saint-Martin (partie française)",
    PM: "Saint-Pierre-et-Miquelon",
    VC: "Saint-Vincent-et-les-Grenadines",
    WS: "Samoa",
    SM: "Saint-Marin",
    ST: "Sao Tomé-et-Principe",
    SA: "Arabie Saoudite",
    SN: "Sénégal",
    RS: "Serbie",
    SC: "Seychelles",
    SL: "Sierra Leone",
    SG: "Singapour",
    SX: "Sint Maarten (partie néerlandaise)",
    SK: "Slovaquie",
    SI: "Slovénie",
    SB: "Îles Salomon",
    SO: "Somalie",
    ZA: "Afrique du Sud",
    GS: "Géorgie du Sud et les îles Sandwich du Sud",
    SS: "Soudan du Sud",
    ES: "Espagne",
    LK: "Sri Lanka",
    SD: "Soudan",
    SR: "Suriname",
    SJ: "Svalbard et Jan Mayen",
    SE: "Suède",
    CH: "Suisse",
    SY: "République arabe syrienne",
    TW: "Taïwan, Province de Chine",
    TJ: "Tadjikistan",
    TZ: "Tanzanie, République Unie de",
    TH: "Thaïlande",
    TL: "Timor-Oriental",
    TG: "Togo",
    TK: "Tokelau",
    TO: "Tonga",
    TT: "Trinité et Tobago",
    TN: "Tunisie",
    TR: "Türkiye",
    TM: "Turkménistan",
    TC: "Îles Turks et Caicos",
    TV: "Tuvalu",
    UG: "Ouganda",
    UA: "Ukraine",
    AE: "Émirats arabes unis",
    GB: "Royaume-Uni de Grande-Bretagne et d'Irlande du Nord",
    US: "États-Unis d'Amérique",
    UM: "Îles mineures éloignées des États-Unis",
    UY: "Uruguay",
    UZ: "Ouzbékistan",
    VU: "Vanuatu",
    VE: "Venezuela (République bolivarienne du)",
    VN: "Viêt Nam",
    VG: "Îles Vierges (britanniques)",
    VI: "Îles Vierges (américaines)",
    WF: "Wallis et Futuna",
    EH: "Sahara occidental",
    YE: "Yémen",
    ZM: "Zambie",
    ZW: "Zimbabwe"
};

const it$1 = {};

const pt = {};

const pt_BR = {};

const sv = {};

const fi = {};

const nl = {
    // Login/Reset Password
    "email": 'E-mail',
    "password": 'Wachtwoord',
    "sign_in": 'Inloggen',
    "continue": "Doorgaan",
    "forgot_password": 'Wachtwoord vergeten',
    "reset_password": 'Wachtwoord resetten',
    "reset_password_instructions": "Om je wachtwoord te resetten, voer je hierboven je e-mailadres in en we sturen je instructies als het account bestaat.",
    "sent_reset_password_code": 'We hebben een code voor het resetten van je wachtwoord naar [email] gestuurd. Voer die code en een nieuw wachtwoord in.',
    "reset_code": 'Resetcode',
    "new_password": 'Nieuw wachtwoord',
    "reenter_new_password": 'Nieuw wachtwoord opnieuw invoeren',
    "must_include_email": 'E-mailadres is vereist',
    "old_password": 'Oud wachtwoord',
    "set_new_password": 'Nieuw wachtwoord instellen',
    "password_expired": 'Wachtwoord verlopen',
    "toggle_password_visibility": 'Wachtwoord weergeven/verbergen',
    "change_your_password": 'Wijzig je wachtwoord',
    "change_password": 'Wachtwoord wijzigen',
    "set_password": 'Wachtwoord instellen',
    "already_have_reset_code": 'Ik heb al een resetcode',
    "confirm_password": 'Bevestig wachtwoord',
    "idle_logged_out_warning": 'Je bent inactief en wordt over 10 seconden uitgelogd',
    "logged_out": 'Je bent uitgelogd',
    "login_title_text": "Inloggen",
    "try_again": "Probeer Opnieuw",
    "login_error_message": "We konden uw gebruiker niet vinden. U kunt het opnieuw proberen of contact opnemen met uw accountmanager.",
    "invalid_login_credentials_error_message": "Onjuiste combinatie van gebruikersnaam en wachtwoord of de gebruiker bestaat niet.",
    "enter_password_reset_code": "Voer de code in die we naar het account [email] hebben gestuurd.",
    "repeat-new-password": "Herhaal Nieuw Wachtwoord",
    "send-code": "Code versturen",
    "okta-sign-in": "Inloggen met Okta",
    "google-sign-in": "Inloggen met Google",
    "microsoft-sign-in": "Inloggen met Microsoft",
    "or": "OF",
    "contact_manager_for_account": "Voor nieuwe accounts neem contact op met uw manager",
    // ListUsers
    "search_enter_4_chars": 'Voer minimaal 4 tekens in om te zoeken',
    "user_search_placeholder_email": 'Zoek naar het begin van een e-mailadres',
    "user_search_placeholder": 'Zoek naar het begin van een e-mailadres, manager of groep',
    "no_users_found": 'Geen gebruikers gevonden',
    // Sidebar
    "users": 'Gebruikers',
    "main_settings": 'Hoofdinstellingen',
    "terminology": 'Terminologie',
    "equipment": 'Apparatuur',
    "security": 'Beveiliging',
    "tenants": 'Huurders',
    "collapse": 'Inklappen',
    // Users List
    "add_user": 'Gebruiker toevoegen',
    "edit_user": 'Gebruiker bewerken',
    "bulk_import": 'Bulkimport',
    "bulk_import_users": 'Gebruikers in bulk importeren',
    "add_group": 'Groep toevoegen',
    "manage_users": 'Gebruikers beheren',
    "manage_groups": 'Groepen beheren',
    "show_roles_list": 'Rollenlijst weergeven',
    "show_disabled_users": 'Uitgeschakelde gebruikers weergeven',
    "name": 'Naam',
    "role": 'Rol',
    "roles": 'Rollen',
    "role_name": 'Rolnaam',
    "role_description": 'Rolbeschrijving',
    "role_id": 'Rol-ID',
    "location": 'Locatie',
    "routethis_group": 'RouteThis Groep',
    "manager": 'Manager',
    "download_bulk_template": 'Bulksjabloon downloaden',
    "user_id_email": 'Gebruikers-ID (e-mail)',
    "users_for": 'Gebruikers voor:',
    // Valid User roles
    "user_role": 'gebruiker',
    "tenant_admin_role": 'Huurderbeheerder',
    "super_admin_role": 'Superbeheerder',
    "user": 'Gebruiker',
    "tenant_admin": 'Huurderbeheerder',
    "super_admin": 'Superbeheerder',
    // Create/Edit User Modal
    "create_user": 'Gebruiker aanmaken',
    "email_required": 'E-mail (verplicht)',
    "first_name": 'Voornaam',
    "last_name": 'Achternaam',
    "force_password_reset": 'Wachtwoordreset forceren',
    "resend_welcome_email": 'Welkomstmail opnieuw verzenden',
    "resend_validation_code": 'Validatiecode opnieuw verzenden',
    "enable_users": 'Gebruikers inschakelen',
    "disable_users": 'Gebruikers uitschakelen',
    "certify": 'Certificeren',
    "unverified": 'Niet geverifieerd',
    "verified": 'Geverifieerd',
    "locked_out": 'Geblokkeerd',
    "disabled": 'Uitgeschakeld',
    "save": 'Opslaan',
    "reset_user_password_confirmation": 'Weet je zeker dat je het wachtwoord van deze gebruiker wilt resetten?',
    "resend_validation_code_confirmation": 'Weet je zeker dat je de validatiecode opnieuw wilt verzenden?',
    "cannot_disable_yourself": 'Je kunt jezelf niet uitschakelen',
    "cancel_changes": 'Wijzigingen annuleren',
    "required": 'Vereist',
    "password_email_template": 'Wachtwoord-e-mailsjabloon',
    "include_in_resolve_usage_reports": 'Opnemen in Resolve-gebruiksrapporten',
    "delete_user": 'Gebruiker verwijderen',
    "delete_are_you_sure": 'Weet je zeker dat je deze gebruiker wilt verwijderen? WAARSCHUWING: Deze actie kan niet ongedaan worden gemaakt.',
    "delete": 'Verwijderen',
    // Create Edit Group modal
    "create_group": 'Groep aanmaken',
    "edit_group": 'Groep bewerken',
    "group_name": 'Groepsnaam',
    "group_type": 'Groeptype',
    "search_by_group_name": 'Zoeken op groepsnaam',
    "search_by_role_name": 'Zoeken op rolnaam',
    // Snackbar Messages
    "snackbar_disable_success": 'Gebruiker succesvol uitgeschakeld:',
    "snackbar_disable_error": 'Fout bij het uitschakelen van gebruiker:',
    "snackbar_enable_success": 'Gebruiker succesvol ingeschakeld:',
    "snackbar_enable_error": 'Fout bij het inschakelen van gebruiker:',
    "snackbar_password_reset_success": 'Wachtwoord succesvol gereset voor gebruiker:',
    "snackbar_password_reset_error": 'Fout bij het resetten van wachtwoord voor gebruiker:',
    // Bulk Import Modal
    "csv_format_requirements": 'Je CSV-bestand moet correct worden geformatteerd. Als je niet zeker weet hoe, kun je ook',
    "csv_format_download_link": 'een sjabloon hier downloaden.',
    "csv_format_error": 'We konden je geüploade bestand niet verwerken. Zorg ervoor dat je bestand correct is geformatteerd en de koppen \'email\' en \'manager_0\' bevat.',
    "select_csv": 'CSV-bestand doorzoeken',
    "import": 'Importeren',
    "file_too_large": 'Bestand te groot (Maximaal IMPORT_LIMIT gebruikers)',
    "required_headers_missing": 'Verplichte koppen ontbreken: email',
    "user_import_starting": 'Gebruikersimport wordt gestart. Je ontvangt een samenvattingsmail over enkele minuten.',
    "change_file": 'Bestand wijzigen',
    "invalid_email_error": 'E-mail bevat ongeldige tekens',
    // Bulk Import Messaging
    "bulk_processing_1": 'We verwerken het bestand:',
    "bulk_processing_2": 'Zodra we klaar zijn, sturen we je een e-mail met alle details.',
    "bulk_complete_1": 'Voltooid:',
    "bulk_complete_2": 'is succesvol geüpload.',
    "bulk_error": 'Er is een fout opgetreden en je bestand is niet naar de server geüpload. Controleer je e-mail voor meer informatie.',
    "bulk_thanks_header": 'Bedankt voor het uploaden van je bestand!',
    "bulk_thanks_content": 'We verwerken het nu en sturen je een e-mail zodra we klaar zijn. Je kunt ook de app controleren voor updates over de status van je bestand.',
    // Tenant Main Settings
    "email_language": 'E-mailtaal',
    "country": 'Land',
    "description_optional": 'Beschrijving (optioneel)',
    "units_feet_meters": 'Eenheden (Voet, Meter)',
    "certify_id": 'Certify-ID',
    "resolve_id": 'Resolve-ID',
    "sms_from": 'SMS van',
    "sms_body": 'SMS-tekst',
    "default_sms_body": 'Je WiFi-installatie is voltooid en gecertificeerd door [NAME]! \n Bekijk je certificaat hier: [LINK]',
    "sms_body_helper_text": 'Certify zal dit bericht via SMS naar de klant sturen. [LINK] wordt vervangen door een link naar het certificaat (verplicht). [NAME] wordt vervangen door de inhoud van het Naam-veld (optioneel).',
    "link_must_be_in_sms_body": '[LINK] moet in de SMS-tekst staan.',
    "update_successful": 'Succesvol bijgewerkt',
    "creation_successful": 'Succesvol aangemaakt',
    // Tenant Terminology Settings
    "term": 'Term',
    "example_usage": 'Voorbeeldgebruik',
    "customer_example_usage_1": 'In overleg met de klant, bevestig het geselecteerde gebouw of ga terug om het adres te bewerken.',
    "customer_example_usage_2": 'In overleg met de abonnee, bevestig het geselecteerde gebouw of ga terug om het adres te bewerken.',
    "router_example_usage_1": 'Tik op de voorgestelde locatie van de router hieronder.',
    "router_example_usage_2": 'Tik op de voorgestelde locatie van het modem hieronder.',
    "router_example_usage_3": 'Tik op de voorgestelde locatie van de gateway hieronder.',
    "router_example_usage_4": 'Tik op de voorgestelde locatie van de hub hieronder.',
    "router_example_usage_5": 'Tik op de voorgestelde locatie van de residentiële gateway hieronder.',
    "level_example_usage_1": 'Ga naar niveau 2 en tik op je locatie.',
    "level_example_usage_2": 'Ga naar verdieping 2 en tik op je locatie.',
    "mesh_pod_example_usage_1": 'Signaalsterkte en optimale plaatsing van de mesh-pod schatten.',
    "mesh_pod_example_usage_2": 'Signaalsterkte en optimale plaatsing van het toegangspunt schatten.',
    "mesh_pod_example_usage_3": 'Signaalsterkte en optimale plaatsing van de mesh-knoop schatten.',
    "mesh_pod_example_usage_4": 'Signaalsterkte en optimale plaatsing van de mesh-puck schatten.',
    "mesh_pod_example_usage_5": 'Signaalsterkte en optimale plaatsing van het baken schatten.',
    "mesh_pod_example_usage_6": 'Signaalsterkte en optimale plaatsing van de bereikvergroter schatten.',
    "wifi_example_usage_1": 'WiFi-kaart',
    "wifi_example_usage_2": 'Wi-Fi-kaart',
    "wifi_example_usage_3": 'Wifi-kaart',
    "wifi_example_usage_4": 'WIFI-kaart',
    // Tenant Equipment Settings (Certify)
    "router_options_1": 'Routeropties',
    "router_options_2": 'Modemopties',
    "router_options_3": 'Gatewayopties',
    "router_options_4": 'Hubopties',
    "router_options_5": 'Residentiële gatewayopties',
    "new_router_options_1": 'Nieuwe routeropties',
    "new_router_options_2": 'Nieuwe modemopties',
    "new_router_options_3": 'Nieuwe gatewayopties',
    "new_router_options_4": 'Nieuwe hubopties',
    "new_router_options_5": 'Nieuwe residentiële gatewayopties',
    "mesh_pod_options_1": 'Mesh-podopties',
    "mesh_pod_options_2": 'Toegangspuntopties',
    "mesh_pod_options_3": 'Mesh-knoopopties',
    "mesh_pod_options_4": 'Mesh-puckopties',
    "mesh_pod_options_5": 'Bakenopties',
    "mesh_pod_options_6": 'Bereikvergroteropties',
    "new_mesh_pod_options_1": 'Nieuwe mesh-podopties',
    "new_mesh_pod_options_2": 'Nieuwe toegangspuntopties',
    "new_mesh_pod_options_3": 'Nieuwe mesh-knoopopties',
    "new_mesh_pod_options_4": 'Nieuwe mesh-puckopties',
    "new_mesh_pod_options_5": 'Nieuwe bakenopties',
    "new_mesh_pod_options_6": 'Nieuwe bereikvergroteropties',
    "missing_required_router_info_1": 'Ontbrekende vereiste routerinformatie',
    "missing_required_router_info_2": 'Ontbrekende vereiste modeminformatie',
    "missing_required_router_info_3": 'Ontbrekende vereiste gatewayinformatie',
    "missing_required_router_info_4": 'Ontbrekende vereiste hubinformatie',
    "missing_required_router_info_5": 'Ontbrekende vereiste residentiële gatewayinformatie',
    "missing_required_mesh_pod_info_1": 'Ontbrekende vereiste mesh-podinformatie',
    "missing_required_mesh_pod_info_2": 'Ontbrekende vereiste toegangspuntinformatie',
    "missing_required_mesh_pod_info_3": 'Ontbrekende vereiste mesh-knoopinformatie',
    "missing_required_mesh_pod_info_4": 'Ontbrekende vereiste mesh-puckinformatie',
    "missing_required_mesh_pod_info_5": 'Ontbrekende vereiste bakeninformatie',
    "missing_required_mesh_pod_info_6": 'Ontbrekende vereiste bereikvergroterinformatie',
    "display_name": 'Weergavenaam',
    "description": 'Beschrijving',
    "range_in_unit_1": 'Bereik in voeten',
    "range_in_unit_2": 'Bereik in meters',
    "area_in_unit_1": 'Gebied in vierkante voeten',
    "area_in_unit_2": 'Gebied in vierkante meters',
    "default_active": 'Standaard actief',
    "average_range": 'Gemiddeld bereik',
    "certify_default": 'Standaard Certify',
    "default": 'Standaard',
    "active": 'Actief',
    "one_option_must_be_default": 'Één optie moet standaard zijn',
    "set_as_default": 'Instellen als standaard',
    "default_option_must_be_active": 'De standaardoptie moet actief zijn',
    "deactivate": 'Deactiveren',
    "activate": 'Activeren',
    "name_is_required": 'Naam is vereist',
    "show_terminology_fields": 'Certify-terminologievelden weergeven',
    // Customer Name
    "customer_1": 'Klant',
    "customer_2": 'Abonnee',
    // Pod Name
    "pod_1": 'Mesh-pod',
    "pod_2": 'Toegangspunt',
    "pod_3": 'Mesh-knoop',
    "pod_4": 'Mesh-puck',
    "pod_5": 'Baken',
    "pod_6": 'Bereikvergroter',
    "pod_7": 'Wifi-versterker',
    "pods_1": 'Mesh-pods',
    "pods_2": 'Toegangspunten',
    "pods_3": 'Mesh-knopen',
    "pods_4": 'Mesh-pucks',
    "pods_5": 'Bakens',
    "pods_6": 'Bereikvergroters',
    "pods_7": 'Wifi-versterkers',
    // Router Name
    "router_1": 'Router',
    "router_2": 'Modem',
    "router_3": 'Gateway',
    "router_4": 'Hub',
    "router_5": 'Internetmodem',
    // Level Name
    "level_1": 'Niveau',
    "level_2": 'Verdieping',
    "levels_1": 'Niveaus',
    "levels_2": 'Verdiepingen',
    // Wifi Name
    "wifi_1": 'WiFi',
    "wifi_2": 'Wi-Fi',
    "wifi_3": 'Wifi',
    "wifi_4": 'WIFI',
    // Units
    "units_1": 'Voeten',
    "units_2": 'Meters',
    // Pod Info
    "recommended": 'Aanbevolen',
    "installed": 'Geïnstalleerd',
    "total": 'Totaal',
    // Platform Fields
    "platform": 'Platform',
    // Misc
    "confirm": 'Bevestigen',
    "units": 'Eenheden',
    "region": 'Regio',
    "edit": 'Bewerken',
    "modified": 'Aangepast',
    "create": 'Aanmaken',
    "created": 'Aangemaakt',
    "routethis_app": 'RouteThis-app',
    "loading": 'Bezig met laden...',
    "redirecting": 'Doorsturen...',
    "error": 'Fout',
    "cancel": 'Annuleren',
    "close": 'Sluiten',
    "edit_user_x": 'Gebruiker [X] bewerken',
    "search": 'Zoeken',
    "all": 'Alles',
    "dismiss": 'Sluiten',
    "account_holder": 'Rekeninghouder',
    "unauthenticated_login_again": 'Niet geverifieerd. Log opnieuw in.',
    // HelpDropdown
    "need_help": 'Hulp nodig?',
    "knowledge_base": 'Kennisbank',
    "contact_us": 'Contacteer ons',
    // UserDropdown
    "hello": 'Hallo',
    "sign_out": 'Uitloggen',
    // Languages
    "en": 'Engels (VS)',
    'en-GB': 'Engels (GB)',
    "da": 'Deens',
    "fi": 'Fins',
    "fr": 'Frans',
    'fr-CA': 'Frans (Canada)',
    "de": 'Duits',
    "el": 'Grieks',
    "it": 'Italiaans',
    "pt": 'Portugees',
    'pt-BR': 'Portugees (Brazilië)',
    "es": 'Spaans',
    'es-419': 'Spaans (Latijns-Amerika)',
    "sv": 'Zweeds',
    // Client-side validation errors
    "incorrect_email_or_password": 'Onjuist e-mailadres of wachtwoord, of het account is uitgeschakeld. Probeer het opnieuw of neem contact op met een beheerder.',
    "invalid_reset_code": 'Ongeldige resetcode',
    "password_minimum_requirements": 'Je wachtwoord moet minimaal 8 tekens lang zijn en ten minste één kleine letter, één hoofdletter en één cijfer bevatten.',
    "password_minimum_requirements_shortened": "Minimaal 8 tekens, één hoofdletter en één cijfer",
    "passwords_must_match": 'Wachtwoorden moeten overeenkomen',
    "must_include_new_password_email": 'Je moet een nieuw wachtwoord en een gebruikers-e-mailadres opgeven',
    "must_include_new_password_confirmation_code": 'Je moet een nieuw wachtwoord en een bevestigingscode opgeven',
    "cannot_send_reset_code_without_email": 'Resetcode kan niet worden verzonden zonder e-mailadres',
    "must_enter_old_password": 'Je moet je oude wachtwoord invoeren',
    "must_enter_reset_code": 'Je moet de resetcode invoeren',
    "must_enter_new_password": 'Je moet een nieuw wachtwoord invoeren',
    "passwords_cannot_begin_or_end_with_spaces": 'Wachtwoorden mogen niet beginnen of eindigen met spaties',
    // Server-side errors
    'User with that email already exists': 'Er bestaat al een gebruiker met dat e-mailadres',
    'Try another display name': 'Probeer een andere weergavenaam',
    'Password cannot be a previously used password': 'Het wachtwoord mag geen eerder gebruikt wachtwoord zijn',
    'Invalid reset code': 'Ongeldige resetcode',
    'Incorrect email or password, or disabled account. Try again or contact an administrator.': 'Onjuist e-mailadres of wachtwoord, of het account is uitgeschakeld. Probeer het opnieuw of neem contact op met een beheerder.',
    'Invalid code provided, please request a code again.': 'Ongeldige code opgegeven, vraag alstublieft een nieuwe code aan.',
    'Password cannot begin or end with spaces': 'Wachtwoorden mogen niet beginnen of eindigen met spaties',
    'LimitExceededException - Attempt limit exceeded, please try after some time.': 'LimitExceededException - Pogingslimiet overschreden, probeer het later opnieuw.',
    'User is not Authorized': 'Gebruiker is niet gemachtigd',
    'Your session timed out. Sign in again with your temporary password.': 'Je sessie is verlopen. Log opnieuw in met je tijdelijke wachtwoord.',
    'Internal Service Failure - Cognito Unavailable': 'Interne servicefout - Cognito niet beschikbaar',
    'Internal Service Failure - Unknown Failure': 'Interne servicefout - Onbekende fout',
    'Must enter Reset Code': 'Je moet een resetcode invoeren',
    // Change Password Challenges
    "step_1_of_2": "Stap 1 van 2",
    "step_2_of_2": "Stap 2 van 2",
    "set_password_challenge": 'Je moet bij de eerste keer inloggen een nieuw wachtwoord instellen voor beveiligingsdoeleinden.',
    "reset_password_challenge": 'We hebben een resetcode naar [EMAIL] gestuurd. Voer die code en een nieuw wachtwoord in.',
    "set_new_password_challenge": 'Het beleid van je bedrijf vereist dat je wachtwoord na verloop van tijd verloopt. We hebben een resetcode naar [EMAIL] gestuurd. Voer die code en een nieuw wachtwoord in.',
    "change_your_password_challenge": 'Voer hieronder je huidige wachtwoord en een nieuw wachtwoord in om het te wijzigen.',
    "change_password_challenge": 'Voer een nieuw wachtwoord in voor de gebruiker',
    "reset_password_challenge_instructions": "We zullen naar het account [EMAIL] een resetcode en verdere instructies sturen om een nieuw wachtwoord aan te maken.",
    // Country Codes
    AF: 'Afghanistan',
    AX: 'Åland-eilanden',
    AL: 'Albanië',
    DZ: 'Algerije',
    AS: 'Amerikaans-Samoa',
    AD: 'Andorra',
    AO: 'Angola',
    AI: 'Anguilla',
    AQ: 'Antarctica',
    AG: 'Antigua en Barbuda',
    AR: 'Argentinië',
    AM: 'Armenië',
    AW: 'Aruba',
    AU: 'Australië',
    AT: 'Oostenrijk',
    AZ: 'Azerbeidzjan',
    BS: 'Bahama\'s',
    BH: 'Bahrein',
    BD: 'Bangladesh',
    BB: 'Barbados',
    BY: 'Wit-Rusland',
    BE: 'België',
    BZ: 'Belize',
    BJ: 'Benin',
    BM: 'Bermuda',
    BT: 'Bhutan',
    BO: 'Bolivia (Plurinationale Staat)',
    BQ: 'Bonaire, Sint Eustatius en Saba',
    BA: 'Bosnië en Herzegovina',
    BW: 'Botswana',
    BV: 'Bouvet',
    BR: 'Brazilië',
    IO: 'Brits Indische Oceaanterritorium',
    BN: 'Brunei Darussalam',
    BG: 'Bulgarije',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    CV: 'Kaapverdië',
    KH: 'Cambodja',
    CM: 'Kameroen',
    CA: 'Canada',
    KY: 'Kaaimaneilanden',
    CF: 'Centraal-Afrikaanse Republiek',
    TD: 'Tsjaad',
    CL: 'Chili',
    CN: 'China',
    CX: 'Christmaseiland',
    CC: 'Cocoseilanden',
    CO: 'Colombia',
    KM: 'Comoren',
    CG: 'Congo',
    CD: 'Congo, Democratische Republiek',
    CK: 'Cookeilanden',
    CR: 'Costa Rica',
    CI: 'Ivoorkust',
    HR: 'Kroatië',
    CU: 'Cuba',
    CW: 'Curaçao',
    CY: 'Cyprus',
    CZ: 'Tsjechië',
    DK: 'Denemarken',
    DJ: 'Djibouti',
    DM: 'Dominica',
    DO: 'Dominicaanse Republiek',
    EC: 'Ecuador',
    EG: 'Egypte',
    SV: 'El Salvador',
    GQ: 'Equatoriaal-Guinea',
    ER: 'Eritrea',
    EE: 'Estland',
    SZ: 'Eswatini',
    ET: 'Ethiopië',
    FK: 'Falklandeilanden',
    FO: 'Faeröer',
    FJ: 'Fiji',
    FI: 'Finland',
    FR: 'Frankrijk',
    GF: 'Frans-Guyana',
    PF: 'Frans-Polynesië',
    TF: 'Franse Zuidelijke Gebieden',
    GA: 'Gabon',
    GM: 'Gambia',
    GE: 'Georgië',
    DE: 'Duitsland',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GR: 'Griekenland',
    GL: 'Groenland',
    GD: 'Grenada',
    GP: 'Guadeloupe',
    GU: 'Guam',
    GT: 'Guatemala',
    GG: 'Guernsey',
    GN: 'Guinee',
    GW: 'Guinee-Bissau',
    GY: 'Guyana',
    HT: 'Haïti',
    HM: 'Heard en McDonaldeilanden',
    VA: 'Heilige Stoel',
    HN: 'Honduras',
    HK: 'Hongkong',
    HU: 'Hongarije',
    IS: 'IJsland',
    IN: 'India',
    ID: 'Indonesië',
    IR: 'Iran (Islamitische Republiek)',
    IQ: 'Irak',
    IE: 'Ierland',
    IM: 'Isle of Man',
    IL: 'Israël',
    IT: 'Italië',
    JM: 'Jamaica',
    JP: 'Japan',
    JE: 'Jersey',
    JO: 'Jordanië',
    KZ: 'Kazachstan',
    KE: 'Kenia',
    KI: 'Kiribati',
    KP: 'Noord-Korea',
    KR: 'Zuid-Korea',
    KW: 'Koeweit',
    KG: 'Kirgizië',
    LA: 'Lao Volksdemocratische Republiek',
    LV: 'Letland',
    LB: 'Libanon',
    LS: 'Lesotho',
    LR: 'Liberia',
    LY: 'Libië',
    LI: 'Liechtenstein',
    LT: 'Litouwen',
    LU: 'Luxemburg',
    MO: 'Macao',
    MG: 'Madagaskar',
    MW: 'Malawi',
    MY: 'Maleisië',
    MV: 'Maldiven',
    ML: 'Mali',
    MT: 'Malta',
    MH: 'Marshalleilanden',
    MQ: 'Martinique',
    MR: 'Mauritanië',
    MU: 'Mauritius',
    YT: 'Mayotte',
    MX: 'Mexico',
    FM: 'Micronesia (Federale Staten)',
    MD: 'Moldavië',
    MC: 'Monaco',
    MN: 'Mongolië',
    ME: 'Montenegro',
    MS: 'Montserrat',
    MA: 'Marokko',
    MZ: 'Mozambique',
    MM: 'Myanmar',
    NA: 'Namibië',
    NR: 'Nauru',
    NP: 'Nepal',
    NL: 'Nederland',
    NC: 'Nieuw-Caledonië',
    NZ: 'Nieuw-Zeeland',
    NI: 'Nicaragua',
    NE: 'Niger',
    NG: 'Nigeria',
    NU: 'Niue',
    NF: 'Norfolkeiland',
    MK: 'Noord-Macedonië',
    MP: 'Noordelijke Marianen',
    NO: 'Noorwegen',
    OM: 'Oman',
    PK: 'Pakistan',
    PW: 'Palau',
    PS: 'Palestina',
    PA: 'Panama',
    PG: 'Papoea-Nieuw-Guinea',
    PY: 'Paraguay',
    PE: 'Peru',
    PH: 'Filipijnen',
    PN: 'Pitcairn',
    PL: 'Polen',
    PT: 'Portugal',
    PR: 'Puerto Rico',
    QA: 'Qatar',
    RE: 'Réunion',
    RO: 'Roemenië',
    RU: 'Rusland',
    RW: 'Rwanda',
    BL: 'Saint-Barthélemy',
    SH: 'Sint-Helena, Ascension en Tristan da Cunha',
    KN: 'Saint Kitts en Nevis',
    LC: 'Saint Lucia',
    MF: 'Saint-Martin (Franse kant)',
    PM: 'Saint-Pierre en Miquelon',
    VC: 'Saint Vincent en de Grenadines',
    WS: 'Samoa',
    SM: 'San Marino',
    ST: 'Sao Tomé en Principe',
    SA: 'Saoedi-Arabië',
    SN: 'Senegal',
    RS: 'Servië',
    SC: 'Seychellen',
    SL: 'Sierra Leone',
    SG: 'Singapore',
    SX: 'Sint Maarten (Nederlandse kant)',
    SK: 'Slowakije',
    SI: 'Slovenië',
    SB: 'Salomonseilanden',
    SO: 'Somalië',
    ZA: 'Zuid-Afrika',
    GS: 'Zuid-Georgië en de Zuidelijke Sandwicheilanden',
    SS: 'Zuid-Soedan',
    ES: 'Spanje',
    LK: 'Sri Lanka',
    SD: 'Soedan',
    SR: 'Suriname',
    SJ: 'Spitsbergen en Jan Mayen',
    SE: 'Zweden',
    CH: 'Zwitserland',
    SY: 'Syrië',
    TW: 'Taiwan',
    TJ: 'Tadzjikistan',
    TZ: 'Tanzania',
    TH: 'Thailand',
    TL: 'Oost-Timor',
    TG: 'Togo',
    TK: 'Tokelau',
    TO: 'Tonga',
    TT: 'Trinidad en Tobago',
    TN: 'Tunesië',
    TR: 'Turkije',
    TM: 'Turkmenistan',
    TC: 'Turks- en Caicoseilanden',
    TV: 'Tuvalu',
    UG: 'Oeganda',
    UA: 'Oekraïne',
    AE: 'Verenigde Arabische Emiraten',
    GB: 'Verenigd Koninkrijk',
    US: 'Verenigde Staten',
    UM: 'Kleine afgelegen eilanden van de Verenigde Staten',
    UY: 'Uruguay',
    UZ: 'Oezbekistan',
    VU: 'Vanuatu',
    VE: 'Venezuela',
    VN: 'Vietnam',
    VG: 'Britse Maagdeneilanden',
    VI: 'Amerikaanse Maagdeneilanden',
    WF: 'Wallis en Futuna',
    EH: 'Westelijke Sahara',
    YE: 'Jemen',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
};

const nl_BL = {
    // Login/Reset Password
    "email": 'E-mailadres',
    "password": 'Wachtwoord',
    "sign_in": 'Inloggen',
    "continue": "Doorgaan",
    "forgot_password": 'Wachtwoord vergeten',
    "reset_password": 'Wachtwoord opnieuw instellen',
    "reset_password_instructions": "Om je wachtwoord opnieuw in te stellen, voer hierboven je e-mailadres in en we sturen je instructies als het account bestaat.",
    "sent_reset_password_code": 'We hebben een code voor het opnieuw instellen van je wachtwoord naar [email] gestuurd. Voer die code en een nieuw wachtwoord in.',
    "reset_code": 'Herstelcode',
    "new_password": 'Nieuw wachtwoord',
    "reenter_new_password": 'Nieuw wachtwoord opnieuw invoeren',
    "must_include_email": 'E-mailadres is verplicht',
    "old_password": 'Oud wachtwoord',
    "set_new_password": 'Nieuw wachtwoord instellen',
    "password_expired": 'Wachtwoord verlopen',
    "toggle_password_visibility": 'Wachtwoord tonen/verbergen',
    "change_your_password": 'Wijzig je wachtwoord',
    "change_password": 'Wachtwoord wijzigen',
    "set_password": 'Wachtwoord instellen',
    "already_have_reset_code": 'Ik heb al een herstelcode',
    "confirm_password": 'Bevestig wachtwoord',
    "idle_logged_out_warning": 'Je bent inactief en wordt over 10 seconden uitgelogd.',
    "logged_out": 'Je bent uitgelogd',
    "login_title_text": "Inloggen",
    "try_again": "Probeer Opnieuw",
    "login_error_message": "We konden uw gebruiker niet vinden. U kunt het opnieuw proberen of contact opnemen met uw accountmanager.",
    "invalid_login_credentials_error_message": "Onjuiste combinatie van gebruikersnaam en wachtwoord of de gebruiker bestaat niet.",
    "enter_password_reset_code": "Voer de code in die we naar het account [email] hebben gestuurd.",
    "repeat-new-password": "Herhaal Nieuw Wachtwoord",
    "send-code": "Code versturen",
    "okta-sign-in": "Inloggen met Okta",
    "google-sign-in": "Inloggen met Google",
    "microsoft-sign-in": "Inloggen met Microsoft",
    "or": "OF",
    "contact_manager_for_account": "Voor nieuwe accounts neem contact op met uw manager",
    // ListUsers
    "search_enter_4_chars": 'Voer minstens 4 tekens in om te zoeken',
    "user_search_placeholder_email": 'Zoek naar het begin van een e-mailadres',
    "user_search_placeholder": 'Zoek naar het begin van een e-mailadres, manager of groep',
    "no_users_found": 'Geen gebruikers gevonden',
    // Sidebar
    "users": 'Gebruikers',
    "main_settings": 'Hoofdinstellingen',
    "terminology": 'Terminologie',
    "equipment": 'Apparatuur',
    "security": 'Beveiliging',
    "tenants": 'Huurders',
    "collapse": 'Inklappen',
    // Users List
    "add_user": 'Gebruiker toevoegen',
    "edit_user": 'Gebruiker bewerken',
    "bulk_import": 'Bulkimport',
    "bulk_import_users": 'Gebruikers in bulk importeren',
    "add_group": 'Groep toevoegen',
    "manage_users": 'Gebruikers beheren',
    "manage_groups": 'Groepen beheren',
    "show_roles_list": 'Rollenlijst tonen',
    "show_disabled_users": 'Uitgeschakelde gebruikers tonen',
    "name": 'Naam',
    "role": 'Rol',
    "roles": 'Rollen',
    "role_name": 'Rolnaam',
    "role_description": 'Rolbeschrijving',
    "role_id": 'Rol-ID',
    "location": 'Locatie',
    "routethis_group": 'RouteThis-groep',
    "manager": 'Manager',
    "download_bulk_template": 'Bulktemplate downloaden',
    "user_id_email": 'Gebruikers-ID (e-mailadres)',
    "users_for": 'Gebruikers voor:',
    // Valid User roles
    "user_role": 'gebruiker',
    "tenant_admin_role": 'Huurderbeheerder',
    "super_admin_role": 'Superbeheerder',
    "user": 'Gebruiker',
    "tenant_admin": 'Huurderbeheerder',
    "super_admin": 'Superbeheerder',
    // Create/Edit User Modal
    "create_user": 'Gebruiker aanmaken',
    "email_required": 'E-mailadres (verplicht)',
    "first_name": 'Voornaam',
    "last_name": 'Achternaam',
    "force_password_reset": 'Wachtwoordherstel forceren',
    "resend_welcome_email": 'Welkomstmail opnieuw verzenden',
    "resend_validation_code": 'Validatiecode opnieuw verzenden',
    "enable_users": 'Gebruikers inschakelen',
    "disable_users": 'Gebruikers uitschakelen',
    "certify": 'Certificeren',
    "unverified": 'Niet geverifieerd',
    "verified": 'Geverifieerd',
    "locked_out": 'Geblokkeerd',
    "disabled": 'Uitgeschakeld',
    "save": 'Opslaan',
    "reset_user_password_confirmation": 'Weet je zeker dat je het wachtwoord van deze gebruiker wilt herstellen?',
    "resend_validation_code_confirmation": 'Weet je zeker dat je de validatiecode opnieuw wilt verzenden?',
    "cannot_disable_yourself": 'Je kunt jezelf niet uitschakelen',
    "cancel_changes": 'Wijzigingen annuleren',
    "required": 'Verplicht',
    "password_email_template": 'Wachtwoord-e-mailsjabloon',
    "include_in_resolve_usage_reports": 'Opnemen in Resolve-gebruiksrapporten',
    "delete_user": 'Gebruiker verwijderen',
    "delete_are_you_sure": 'Weet je zeker dat je deze gebruiker wilt verwijderen? WAARSCHUWING: Deze actie kan niet ongedaan worden gemaakt.',
    "delete": 'Verwijderen',
    // Create Edit Group modal
    "create_group": 'Groep aanmaken',
    "edit_group": 'Groep bewerken',
    "group_name": 'Groepsnaam',
    "group_type": 'Groeptype',
    "search_by_group_name": 'Zoek op groepsnaam',
    "search_by_role_name": 'Zoek op rolnaam',
    // Snackbar Messages
    "snackbar_disable_success": 'Gebruiker succesvol uitgeschakeld:',
    "snackbar_disable_error": 'Fout bij het uitschakelen van gebruiker:',
    "snackbar_enable_success": 'Gebruiker succesvol ingeschakeld:',
    "snackbar_enable_error": 'Fout bij het inschakelen van gebruiker:',
    "snackbar_password_reset_success": 'Wachtwoord succesvol hersteld voor gebruiker:',
    "snackbar_password_reset_error": 'Fout bij het herstellen van wachtwoord voor gebruiker:',
    // Bulk Import Modal
    "csv_format_requirements": 'Je CSV-bestand moet correct zijn opgemaakt. Als je niet zeker weet hoe, kun je ook',
    "csv_format_download_link": 'een sjabloon hier downloaden.',
    "csv_format_error": 'We konden je geüploade bestand niet verwerken. Zorg ervoor dat het bestand correct is opgemaakt en de koppen \'email\' en \'manager_0\' bevat.',
    "select_csv": 'CSV-bestand doorzoeken',
    "import": 'Importeren',
    "file_too_large": 'Bestand te groot (Maximaal IMPORT_LIMIT gebruikers)',
    "required_headers_missing": 'Verplichte koppen ontbreken: email',
    "user_import_starting": 'Gebruikersimport wordt gestart. Je ontvangt een samenvattingsmail over enkele minuten.',
    "change_file": 'Bestand wijzigen',
    "invalid_email_error": 'E-mailadres bevat ongeldige tekens',
    // Bulk Import Messaging
    "bulk_processing_1": 'We verwerken het bestand:',
    "bulk_processing_2": 'Zodra we klaar zijn, sturen we je een e-mail met alle details.',
    "bulk_complete_1": 'Voltooid:',
    "bulk_complete_2": 'is succesvol geüpload.',
    "bulk_error": 'Er is een fout opgetreden en je bestand is niet geüpload naar de server. Controleer je e-mail voor details.',
    "bulk_thanks_header": 'Bedankt voor het uploaden van je bestand!',
    "bulk_thanks_content": 'We verwerken het nu en sturen je een e-mail zodra we klaar zijn. Je kunt ook de app controleren voor updates over de status van je bestand.',
    // Tenant Main Settings
    "email_language": 'E-mailtaal',
    "country": 'Land',
    "description_optional": 'Beschrijving (optioneel)',
    "units_feet_meters": 'Eenheden (Voeten, Meter)',
    "certify_id": 'Certify-ID',
    "resolve_id": 'Resolve-ID',
    "sms_from": 'SMS van',
    "sms_body": 'SMS-tekst',
    "default_sms_body": 'Je WiFi-installatie is voltooid en gecertificeerd door [NAME]! \n Bekijk je certificaat hier: [LINK]',
    "sms_body_helper_text": 'Certify zal dit bericht via SMS naar de klant sturen. [LINK] wordt vervangen door een link naar het certificaat (verplicht). [NAME] wordt vervangen door de inhoud van het Naam-veld (optioneel).',
    "link_must_be_in_sms_body": '[LINK] moet in de SMS-tekst staan.',
    "update_successful": 'Succesvol bijgewerkt',
    "creation_successful": 'Succesvol aangemaakt',
    // Tenant Terminology Settings
    "term": 'Term',
    "example_usage": 'Voorbeeldgebruik',
    "customer_example_usage_1": 'In overleg met de klant, bevestig het geselecteerde gebouw of ga terug om het adres te bewerken.',
    "customer_example_usage_2": 'In overleg met de abonnee, bevestig het geselecteerde gebouw of ga terug om het adres te bewerken.',
    "router_example_usage_1": 'Tik op de voorgestelde routerlocatie hieronder.',
    "router_example_usage_2": 'Tik op de voorgestelde modemlocatie hieronder.',
    "router_example_usage_3": 'Tik op de voorgestelde gatewaylocatie hieronder.',
    "router_example_usage_4": 'Tik op de voorgestelde hublocatie hieronder.',
    "router_example_usage_5": 'Tik op de voorgestelde residentiële gatewaylocatie hieronder.',
    "level_example_usage_1": 'Ga naar niveau 2 en tik op je locatie.',
    "level_example_usage_2": 'Ga naar verdieping 2 en tik op je locatie.',
    "mesh_pod_example_usage_1": 'Signaalsterkte en optimale plaatsing van de mesh-pod schatten.',
    "mesh_pod_example_usage_2": 'Signaalsterkte en optimale plaatsing van het toegangspunt schatten.',
    "mesh_pod_example_usage_3": 'Signaalsterkte en optimale plaatsing van de mesh-knoop schatten.',
    "mesh_pod_example_usage_4": 'Signaalsterkte en optimale plaatsing van de mesh-puck schatten.',
    "mesh_pod_example_usage_5": 'Signaalsterkte en optimale plaatsing van de baken schatten.',
    "mesh_pod_example_usage_6": 'Signaalsterkte en optimale plaatsing van de bereikvergroter schatten.',
    "wifi_example_usage_1": 'WiFi-kaart',
    "wifi_example_usage_2": 'Wi-Fi-kaart',
    "wifi_example_usage_3": 'Wifi-kaart',
    "wifi_example_usage_4": 'WIFI-kaart',
    // Tenant Equipment Settings (Certify)
    "router_options_1": 'Routeropties',
    "router_options_2": 'Modemopties',
    "router_options_3": 'Gatewayopties',
    "router_options_4": 'Hubopties',
    "router_options_5": 'Residentiële gatewayopties',
    "new_router_options_1": 'Nieuwe routeropties',
    "new_router_options_2": 'Nieuwe modemopties',
    "new_router_options_3": 'Nieuwe gatewayopties',
    "new_router_options_4": 'Nieuwe hubopties',
    "new_router_options_5": 'Nieuwe residentiële gatewayopties',
    "mesh_pod_options_1": 'Mesh-podopties',
    "mesh_pod_options_2": 'Toegangspuntopties',
    "mesh_pod_options_3": 'Mesh-knoopopties',
    "mesh_pod_options_4": 'Mesh-puckopties',
    "mesh_pod_options_5": 'Bakenopties',
    "mesh_pod_options_6": 'Bereikvergroteropties',
    "new_mesh_pod_options_1": 'Nieuwe mesh-podopties',
    "new_mesh_pod_options_2": 'Nieuwe toegangspuntopties',
    "new_mesh_pod_options_3": 'Nieuwe mesh-knoopopties',
    "new_mesh_pod_options_4": 'Nieuwe mesh-puckopties',
    "new_mesh_pod_options_5": 'Nieuwe bakenopties',
    "new_mesh_pod_options_6": 'Nieuwe bereikvergroteropties',
    "missing_required_router_info_1": 'Ontbrekende vereiste routerinformatie',
    "missing_required_router_info_2": 'Ontbrekende vereiste modeminformatie',
    "missing_required_router_info_3": 'Ontbrekende vereiste gatewayinformatie',
    "missing_required_router_info_4": 'Ontbrekende vereiste hubinformatie',
    "missing_required_router_info_5": 'Ontbrekende vereiste residentiële gatewayinformatie',
    "missing_required_mesh_pod_info_1": 'Ontbrekende vereiste mesh-podinformatie',
    "missing_required_mesh_pod_info_2": 'Ontbrekende vereiste toegangspuntinformatie',
    "missing_required_mesh_pod_info_3": 'Ontbrekende vereiste mesh-knoopinformatie',
    "missing_required_mesh_pod_info_4": 'Ontbrekende vereiste mesh-puckinformatie',
    "missing_required_mesh_pod_info_5": 'Ontbrekende vereiste bakeninformatie',
    "missing_required_mesh_pod_info_6": 'Ontbrekende vereiste bereikvergroterinformatie',
    "display_name": 'Weergavenaam',
    "description": 'Beschrijving',
    "range_in_unit_1": 'Bereik in voeten',
    "range_in_unit_2": 'Bereik in meters',
    "area_in_unit_1": 'Oppervlakte in vierkante voeten',
    "area_in_unit_2": 'Oppervlakte in vierkante meters',
    "default_active": 'Standaard actief',
    "average_range": 'Gemiddeld bereik',
    "certify_default": 'Certify-standaard',
    "default": 'Standaard',
    "active": 'Actief',
    "one_option_must_be_default": 'Één optie moet standaard zijn',
    "set_as_default": 'Instellen als standaard',
    "default_option_must_be_active": 'De standaardoptie moet actief zijn',
    "deactivate": 'Deactiveren',
    "activate": 'Activeren',
    "name_is_required": 'Naam is verplicht',
    "show_terminology_fields": 'Certify-terminologievelden tonen',
    // Customer Name
    "customer_1": 'Klant',
    "customer_2": 'Abonnee',
    // Pod Name
    "pod_1": 'Mesh-pod',
    "pod_2": 'Toegangspunt',
    "pod_3": 'Mesh-knoop',
    "pod_4": 'Mesh-puck',
    "pod_5": 'Baken',
    "pod_6": 'Bereikvergroter',
    "pod_7": 'Wifi-versterker',
    "pods_1": 'Mesh-pods',
    "pods_2": 'Toegangspunten',
    "pods_3": 'Mesh-knopen',
    "pods_4": 'Mesh-pucks',
    "pods_5": 'Bakens',
    "pods_6": 'Bereikvergroters',
    "pods_7": 'Wifi-versterkers',
    // Router Name
    "router_1": 'Router',
    "router_2": 'Modem',
    "router_3": 'Gateway',
    "router_4": 'Hub',
    "router_5": 'Internetmodem',
    // Level Name
    "level_1": 'Niveau',
    "level_2": 'Verdieping',
    "levels_1": 'Niveaus',
    "levels_2": 'Verdiepingen',
    // Wifi Name
    "wifi_1": 'WiFi',
    "wifi_2": 'Wi-Fi',
    "wifi_3": 'Wifi',
    "wifi_4": 'WIFI',
    // Units
    "units_1": 'Voeten',
    "units_2": 'Meters',
    // Pod Info
    "recommended": 'Aanbevolen',
    "installed": 'Geïnstalleerd',
    "total": 'Totaal',
    // Platform Fields
    "platform": 'Platform',
    // Misc
    "confirm": 'Bevestigen',
    "units": 'Eenheden',
    "region": 'Regio',
    "edit": 'Bewerken',
    "modified": 'Aangepast',
    "create": 'Aanmaken',
    "created": 'Aangemaakt',
    "routethis_app": 'RouteThis-app',
    "loading": 'Bezig met laden...',
    "redirecting": 'Doorsturen...',
    "error": 'Fout',
    "cancel": 'Annuleren',
    "close": 'Sluiten',
    "edit_user_x": 'Gebruiker [X] bewerken',
    "search": 'Zoeken',
    "all": 'Alles',
    "dismiss": 'Verwerpen',
    "account_holder": 'Rekeninghouder',
    "unauthenticated_login_again": 'Niet geverifieerd. Log opnieuw in.',
    // HelpDropdown
    "need_help": 'Hulp nodig?',
    "knowledge_base": 'Kennisbank',
    "contact_us": 'Contacteer ons',
    // UserDropdown
    "hello": 'Hallo',
    "sign_out": 'Uitloggen',
    // Languages
    "en": 'Engels (VS)',
    'en-GB': 'Engels (GB)',
    "da": 'Deens',
    "fi": 'Fins',
    "fr": 'Frans',
    'fr-CA': 'Frans (Canada)',
    "de": 'Duits',
    "el": 'Grieks',
    "it": 'Italiaans',
    "pt": 'Portugees',
    'pt-BR': 'Portugees (Brazilië)',
    "es": 'Spaans',
    'es-419': 'Spaans (Latijns-Amerika)',
    "sv": 'Zweeds',
    // Client-side validation errors
    "incorrect_email_or_password": 'Onjuist e-mailadres of wachtwoord, of het account is uitgeschakeld. Probeer het opnieuw of neem contact op met een beheerder.',
    "invalid_reset_code": 'Ongeldige herstelcode',
    "password_minimum_requirements": 'Je wachtwoord moet minimaal 8 tekens lang zijn en minstens één kleine letter, één hoofdletter en één cijfer bevatten.',
    "password_minimum_requirements_shortened": "Minimaal 8 tekens, één hoofdletter en één cijfer",
    "passwords_must_match": 'Wachtwoorden moeten overeenkomen',
    "must_include_new_password_email": 'Je moet een nieuw wachtwoord en een gebruikers-e-mailadres opgeven',
    "must_include_new_password_confirmation_code": 'Je moet een nieuw wachtwoord en een bevestigingscode opgeven',
    "cannot_send_reset_code_without_email": 'Resetcode kan niet worden verzonden zonder e-mailadres',
    "must_enter_old_password": 'Je moet je oude wachtwoord invoeren',
    "must_enter_reset_code": 'Je moet de herstelcode invoeren',
    "must_enter_new_password": 'Je moet een nieuw wachtwoord invoeren',
    "passwords_cannot_begin_or_end_with_spaces": 'Wachtwoorden mogen niet beginnen of eindigen met spaties',
    // Server-side errors
    'User with that email already exists': 'Er bestaat al een gebruiker met dat e-mailadres',
    'Try another display name': 'Probeer een andere weergavenaam',
    'Password cannot be a previously used password': 'Het wachtwoord mag geen eerder gebruikt wachtwoord zijn',
    'Invalid reset code': 'Ongeldige herstelcode',
    'Incorrect email or password, or disabled account. Try again or contact an administrator.': 'Onjuist e-mailadres of wachtwoord, of het account is uitgeschakeld. Probeer het opnieuw of neem contact op met een beheerder.',
    'Invalid code provided, please request a code again.': 'Ongeldige code opgegeven, vraag alstublieft een nieuwe code aan.',
    'Password cannot begin or end with spaces': 'Wachtwoorden mogen niet beginnen of eindigen met spaties',
    'LimitExceededException - Attempt limit exceeded, please try after some time.': 'LimitExceededException - Pogingslimiet overschreden, probeer het later opnieuw.',
    'User is not Authorized': 'Gebruiker is niet gemachtigd',
    'Your session timed out. Sign in again with your temporary password.': 'Je sessie is verlopen. Log opnieuw in met je tijdelijke wachtwoord.',
    'Internal Service Failure - Cognito Unavailable': 'Interne servicefout - Cognito niet beschikbaar',
    'Internal Service Failure - Unknown Failure': 'Interne servicefout - Onbekende fout',
    'Must enter Reset Code': 'Je moet een herstelcode invoeren',
    // Change Password Challenges
    "step_1_of_2": "Stap 1 van 2",
    "step_2_of_2": "Stap 2 van 2",
    "set_password_challenge": 'Je moet bij de eerste keer inloggen een nieuw wachtwoord instellen voor veiligheidsdoeleinden.',
    "reset_password_challenge": 'We hebben een herstelcode naar [EMAIL] gestuurd. Voer die code en een nieuw wachtwoord in.',
    "set_new_password_challenge": 'Het beleid van je bedrijf vereist dat je wachtwoord na verloop van tijd verloopt. We hebben een herstelcode naar [EMAIL] gestuurd. Voer die code en een nieuw wachtwoord in.',
    "change_your_password_challenge": 'Voer hieronder je huidige wachtwoord en een nieuw wachtwoord in om het te wijzigen.',
    "change_password_challenge": 'Voer een nieuw wachtwoord in voor de gebruiker',
    "reset_password_challenge_instructions": "We zullen naar het account [EMAIL] een resetcode en verdere instructies sturen om een nieuw wachtwoord aan te maken.",
    // Country Codes
    AF: 'Afghanistan',
    AX: 'Åland-eilanden',
    AL: 'Albanië',
    DZ: 'Algerije',
    AS: 'Amerikaans-Samoa',
    AD: 'Andorra',
    AO: 'Angola',
    AI: 'Anguilla',
    AQ: 'Antarctica',
    AG: 'Antigua en Barbuda',
    AR: 'Argentinië',
    AM: 'Armenië',
    AW: 'Aruba',
    AU: 'Australië',
    AT: 'Oostenrijk',
    AZ: 'Azerbeidzjan',
    BS: 'Bahama\'s',
    BH: 'Bahrein',
    BD: 'Bangladesh',
    BB: 'Barbados',
    BY: 'Wit-Rusland',
    BE: 'België',
    BZ: 'Belize',
    BJ: 'Benin',
    BM: 'Bermuda',
    BT: 'Bhutan',
    BO: 'Bolivia (Plurinationale Staat)',
    BQ: 'Bonaire, Sint Eustatius en Saba',
    BA: 'Bosnië en Herzegovina',
    BW: 'Botswana',
    BV: 'Bouvet',
    BR: 'Brazilië',
    IO: 'Brits Indische Oceaanterritorium',
    BN: 'Brunei Darussalam',
    BG: 'Bulgarije',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    CV: 'Kaapverdië',
    KH: 'Cambodja',
    CM: 'Kameroen',
    CA: 'Canada',
    KY: 'Kaaimaneilanden',
    CF: 'Centraal-Afrikaanse Republiek',
    TD: 'Tsjaad',
    CL: 'Chili',
    CN: 'China',
    CX: 'Christmaseiland',
    CC: 'Cocoseilanden',
    CO: 'Colombia',
    KM: 'Comoren',
    CG: 'Congo',
    CD: 'Congo, Democratische Republiek',
    CK: 'Cookeilanden',
    CR: 'Costa Rica',
    CI: 'Ivoorkust',
    HR: 'Kroatië',
    CU: 'Cuba',
    CW: 'Curaçao',
    CY: 'Cyprus',
    CZ: 'Tsjechië',
    DK: 'Denemarken',
    DJ: 'Djibouti',
    DM: 'Dominica',
    DO: 'Dominicaanse Republiek',
    EC: 'Ecuador',
    EG: 'Egypte',
    SV: 'El Salvador',
    GQ: 'Equatoriaal-Guinea',
    ER: 'Eritrea',
    EE: 'Estland',
    SZ: 'Eswatini',
    ET: 'Ethiopië',
    FK: 'Falklandeilanden',
    FO: 'Faeröer',
    FJ: 'Fiji',
    FI: 'Finland',
    FR: 'Frankrijk',
    GF: 'Frans-Guyana',
    PF: 'Frans-Polynesië',
    TF: 'Franse Zuidelijke Gebieden',
    GA: 'Gabon',
    GM: 'Gambia',
    GE: 'Georgië',
    DE: 'Duitsland',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GR: 'Griekenland',
    GL: 'Groenland',
    GD: 'Grenada',
    GP: 'Guadeloupe',
    GU: 'Guam',
    GT: 'Guatemala',
    GG: 'Guernsey',
    GN: 'Guinee',
    GW: 'Guinee-Bissau',
    GY: 'Guyana',
    HT: 'Haïti',
    HM: 'Heard en McDonaldeilanden',
    VA: 'Heilige Stoel',
    HN: 'Honduras',
    HK: 'Hongkong',
    HU: 'Hongarije',
    IS: 'IJsland',
    IN: 'India',
    ID: 'Indonesië',
    IR: 'Iran (Islamitische Republiek)',
    IQ: 'Irak',
    IE: 'Ierland',
    IM: 'Isle of Man',
    IL: 'Israël',
    IT: 'Italië',
    JM: 'Jamaica',
    JP: 'Japan',
    JE: 'Jersey',
    JO: 'Jordanië',
    KZ: 'Kazachstan',
    KE: 'Kenia',
    KI: 'Kiribati',
    KP: 'Noord-Korea',
    KR: 'Zuid-Korea',
    KW: 'Koeweit',
    KG: 'Kirgizië',
    LA: 'Lao Volksdemocratische Republiek',
    LV: 'Letland',
    LB: 'Libanon',
    LS: 'Lesotho',
    LR: 'Liberia',
    LY: 'Libië',
    LI: 'Liechtenstein',
    LT: 'Litouwen',
    LU: 'Luxemburg',
    MO: 'Macao',
    MG: 'Madagaskar',
    MW: 'Malawi',
    MY: 'Maleisië',
    MV: 'Maldiven',
    ML: 'Mali',
    MT: 'Malta',
    MH: 'Marshalleilanden',
    MQ: 'Martinique',
    MR: 'Mauritanië',
    MU: 'Mauritius',
    YT: 'Mayotte',
    MX: 'Mexico',
    FM: 'Micronesia (Federale Staten)',
    MD: 'Moldavië',
    MC: 'Monaco',
    MN: 'Mongolië',
    ME: 'Montenegro',
    MS: 'Montserrat',
    MA: 'Marokko',
    MZ: 'Mozambique',
    MM: 'Myanmar',
    NA: 'Namibië',
    NR: 'Nauru',
    NP: 'Nepal',
    NL: 'Nederland',
    NC: 'Nieuw-Caledonië',
    NZ: 'Nieuw-Zeeland',
    NI: 'Nicaragua',
    NE: 'Niger',
    NG: 'Nigeria',
    NU: 'Niue',
    NF: 'Norfolkeiland',
    MK: 'Noord-Macedonië',
    MP: 'Noordelijke Marianen',
    NO: 'Noorwegen',
    OM: 'Oman',
    PK: 'Pakistan',
    PW: 'Palau',
    PS: 'Palestina',
    PA: 'Panama',
    PG: 'Papoea-Nieuw-Guinea',
    PY: 'Paraguay',
    PE: 'Peru',
    PH: 'Filipijnen',
    PN: 'Pitcairn',
    PL: 'Polen',
    PT: 'Portugal',
    PR: 'Puerto Rico',
    QA: 'Qatar',
    RE: 'Réunion',
    RO: 'Roemenië',
    RU: 'Rusland',
    RW: 'Rwanda',
    BL: 'Saint-Barthélemy',
    SH: 'Sint-Helena, Ascension en Tristan da Cunha',
    KN: 'Saint Kitts en Nevis',
    LC: 'Saint Lucia',
    MF: 'Saint-Martin (Franse kant)',
    PM: 'Saint-Pierre en Miquelon',
    VC: 'Saint Vincent en de Grenadines',
    WS: 'Samoa',
    SM: 'San Marino',
    ST: 'Sao Tomé en Principe',
    SA: 'Saoedi-Arabië',
    SN: 'Senegal',
    RS: 'Servië',
    SC: 'Seychellen',
    SL: 'Sierra Leone',
    SG: 'Singapore',
    SX: 'Sint Maarten (Nederlandse kant)',
    SK: 'Slowakije',
    SI: 'Slovenië',
    SB: 'Salomonseilanden',
    SO: 'Somalië',
    ZA: 'Zuid-Afrika',
    GS: 'Zuid-Georgië en de Zuidelijke Sandwicheilanden',
    SS: 'Zuid-Soedan',
    ES: 'Spanje',
    LK: 'Sri Lanka',
    SD: 'Soedan',
    SR: 'Suriname',
    SJ: 'Spitsbergen en Jan Mayen',
    SE: 'Zweden',
    CH: 'Zwitserland',
    SY: 'Syrië',
    TW: 'Taiwan',
    TJ: 'Tadzjikistan',
    TZ: 'Tanzania',
    TH: 'Thailand',
    TL: 'Oost-Timor',
    TG: 'Togo',
    TK: 'Tokelau',
    TO: 'Tonga',
    TT: 'Trinidad en Tobago',
    TN: 'Tunesië',
    TR: 'Turkije',
    TM: 'Turkmenistan',
    TC: 'Turks- en Caicoseilanden',
    TV: 'Tuvalu',
    UG: 'Oeganda',
    UA: 'Oekraïne',
    AE: 'Verenigde Arabische Emiraten',
    GB: 'Verenigd Koninkrijk',
    US: 'Verenigde Staten',
    UM: 'Kleine afgelegen eilanden van de Verenigde Staten',
    UY: 'Uruguay',
    UZ: 'Oezbekistan',
    VU: 'Vanuatu',
    VE: 'Venezuela',
    VN: 'Vietnam',
    VG: 'Britse Maagdeneilanden',
    VI: 'Amerikaanse Maagdeneilanden',
    WF: 'Wallis en Futuna',
    EH: 'Westelijke Sahara',
    YE: 'Jemen',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
};

const dictionary = {
    "da": da,
    "en-GB": en_GB,
    "en-XA": en_XA,
    "en": en,
    "fi": fi,
    "fr": fr,
    "fr-CA": fr_CA,
    "de": de$1,
    "el": el,
    "it": it$1,
    "pt": pt,
    "pt-BR": pt_BR,
    "es": es,
    "es-419": es_419,
    "sv": sv,
    "nl": nl,
    "nl-BL": nl_BL,
};
const generateResources = () => {
    const resources = {};
    Object.keys(dictionary).forEach((key) => {
        resources[key] = dictionary[key];
    });
    return resources;
};
class TranslationHelper {
    constructor(locale) {
        if (!locale) {
            locale = 'en';
        }
        const i18nObj = new I18n(generateResources());
        i18nObj.locale = locale;
        i18nObj.enableFallback = true;
        i18nObj.defaultLocale = 'en';
        this.t = i18nObj.t;
        this.i18n = i18nObj;
    }
    static getInstance(locale) {
        if (!TranslationHelper.instance || TranslationHelper.instance.i18n.locale !== locale) {
            TranslationHelper.instance = new TranslationHelper(locale);
        }
        return TranslationHelper.instance;
    }
}

const AuthContext = React__default.createContext({
    currentUser: blankUser,
    logout: () => { },
    i18n: TranslationHelper.getInstance().i18n,
    flags: {},
    ssoDetails: { microsoftClientId: '', googleClientId: '', oktaBaseURL: '', oktaClientId: '' }
});
const useAuth$1 = () => useContext(AuthContext);

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".gsi-material-button {\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  -webkit-appearance: none;\n  background-color: WHITE;\n  background-image: none;\n  border: 1px solid #747775;\n  -webkit-border-radius: 20px;\n  border-radius: 20px;\n  /* -webkit-box-sizing: border-box;\n  box-sizing: border-box; */\n  color: #1f1f1f;\n  cursor: pointer;\n  font-family: 'Roboto', arial, sans-serif;\n  font-size: 14px;\n  height: 40px;\n  letter-spacing: 0.25px;\n  outline: none;\n  overflow: hidden;\n  padding: 0 12px;\n  position: relative;\n  text-align: center;\n  -webkit-transition: background-color .218s, border-color .218s, box-shadow .218s;\n  transition: background-color .218s, border-color .218s, box-shadow .218s;\n  vertical-align: middle;\n  white-space: nowrap;\n  width: auto;\n  min-width: min-content;\n}\n\n.gsi-material-button .gsi-material-button-icon {\n  height: 20px;\n  margin-right: 12px;\n  min-width: 20px;\n  width: 20px;\n}\n\n.gsi-material-button .gsi-material-button-content-wrapper {\n  -webkit-align-items: center;\n  align-items: center;\n  display: flex;\n  -webkit-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  height: 100%;\n  justify-content: space-between;\n  position: relative;\n  width: 100%;\n}\n\n.gsi-material-button .gsi-material-button-contents {\n  -webkit-flex-grow: 1;\n  flex-grow: 1;\n  font-family: 'Roboto', arial, sans-serif;\n  font-weight: 500;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  vertical-align: top;\n}\n\n.gsi-material-button .gsi-material-button-state {\n  -webkit-transition: opacity .218s;\n  transition: opacity .218s;\n  bottom: 0;\n  left: 0;\n  opacity: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.gsi-material-button:disabled {\n  cursor: default;\n  background-color: #ffffff61;\n  border-color: #1f1f1f1f;\n}\n\n.gsi-material-button:disabled .gsi-material-button-contents {\n  opacity: 38%;\n}\n\n.gsi-material-button:disabled .gsi-material-button-icon {\n  opacity: 38%;\n}\n\n.gsi-material-button:not(:disabled):active .gsi-material-button-state, \n.gsi-material-button:not(:disabled):focus .gsi-material-button-state {\n  background-color: #303030;\n  opacity: 12%;\n}\n\n.gsi-material-button:not(:disabled):hover {\n  -webkit-box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .30), 0 1px 3px 1px rgba(60, 64, 67, .15);\n  box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .30), 0 1px 3px 1px rgba(60, 64, 67, .15);\n}\n\n.gsi-material-button:not(:disabled):hover .gsi-material-button-state {\n  background-color: #303030;\n  opacity: 8%;\n}\n";
styleInject(css_248z);

const MicrosoftLoginLogo = () => {
    const { i18n } = useAuth$1();
    return (React__default.createElement(Box, { className: "gsi-material-button", sx: { flexGrow: 1 } },
        React__default.createElement(Box, { className: "gsi-material-button-state" }),
        React__default.createElement(Box, { className: "gsi-material-button-content-wrapper" },
            React__default.createElement(Box, { className: "gsi-material-button-icon" },
                React__default.createElement("span", { dangerouslySetInnerHTML: { __html: `<svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21"><title>MS-SymbolLockup</title><rect x="1" y="1" width="9" height="9" fill="#f25022"/><rect x="1" y="11" width="9" height="9" fill="#00a4ef"/><rect x="11" y="1" width="9" height="9" fill="#7fba00"/><rect x="11" y="11" width="9" height="9" fill="#ffb900"/></svg>` } })),
            React__default.createElement(Typography, { className: "gsi-material-button-contents" }, i18n.t('microsoft-sign-in')),
            React__default.createElement(Typography, { sx: { display: "none" } }, i18n.t('microsoft-sign-in')))));
};

const GoogleLoginLogo = () => {
    const { i18n } = useAuth$1();
    return (React__default.createElement(Box, { className: "gsi-material-button", sx: { flexGrow: 1 } },
        React__default.createElement(Box, { className: "gsi-material-button-state" }),
        React__default.createElement(Box, { className: "gsi-material-button-content-wrapper" },
            React__default.createElement(Box, { className: "gsi-material-button-icon" },
                React__default.createElement("span", { dangerouslySetInnerHTML: {
                        __html: `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" xmlns:xlink="http://www.w3.org/1999/xlink" style="display: block;">
          <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
          <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
          <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
          <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
          <path fill="none" d="M0 0h48v48H0z"></path>
        </svg>`
                    } })),
            React__default.createElement(Typography, { sx: { flexGrow: 1 }, className: "gsi-material-button-contents" }, i18n.t('google-sign-in')))));
};

const OktaLoginLogo = () => {
    const { i18n } = useAuth$1();
    return (React__default.createElement(Box, { className: "gsi-material-button", sx: { flexGrow: 1 } },
        React__default.createElement(Box, { className: "gsi-material-button-state" }),
        React__default.createElement(Box, { className: "gsi-material-button-content-wrapper" },
            React__default.createElement(Box, { className: "gsi-material-button-icon" },
                React__default.createElement("img", { src: "https://route-this-cdn.s3.amazonaws.com/auth/oktaLogo.png", alt: "Okta Logo", width: "42px" })),
            React__default.createElement(Typography, { className: "gsi-material-button-contents" }, i18n.t('okta-sign-in')))));
};

const SSOProviders = ({ onLoginCompleteCallback, setLoading, apiUrl, ssoDetails }) => {
    const { googleClientId, microsoftClientId, oktaClientId, oktaBaseURL, ssoLoginURL } = ssoDetails;
    const handleSSOLogin = (providerData, provider) => __awaiter$1(void 0, void 0, void 0, function* () {
        setLoading(true); // Not needed for redirect flow, but can be used for popup flow
        // const res = await requestHelper.ssoLoginUser({ providerData, provider });
        // if (res.status === 200) {
        //   await onLoginCompleteCallback(providerData.credential || providerData.idToken);
        //   setLoading(false);
        //   return;
        // }
        // setError(res.data.message || "Something went wrong, please try again");
        setLoading(false);
    });
    const msftRedirectLogin = () => __awaiter$1(void 0, void 0, void 0, function* () {
        // generate random state code
        const state = Math.random().toString(36).substring(7);
        const url = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${microsoftClientId}&response_type=code&redirect_uri=${ssoLoginURL}&response_mode=query&scope=https://graph.microsoft.com/User.Read openid offline_access&state=microsoft|${state}`;
        window.location.href = url;
    });
    const oktaRedirectLogin = () => __awaiter$1(void 0, void 0, void 0, function* () {
        // generate random state code
        const state = Math.random().toString(36).substring(7);
        const url = `${oktaBaseURL}/oauth2/v1/authorize?client_id=${oktaClientId}&response_type=code&redirect_uri=${ssoLoginURL}&scope=openid email profile&state=okta|${state}&response_mode=query`;
        window.location.href = encodeURI(url);
    });
    return (React__default.createElement(Box, { sx: { display: 'flex',
            flexDirection: 'column',
            justifyContent: 'start',
            alignItems: 'stretch',
            marginTop: '30px',
        } },
        React__default.createElement(Box, { sx: { flexgrow: 1 } },
            React__default.createElement(GoogleOAuthProvider, { clientId: googleClientId },
                React__default.createElement(GoogleLoginBtn, { onSuccess: handleSSOLogin, ssoLoginURL: ssoLoginURL || '' }))),
        React__default.createElement(Button, { sx: { flexGrow: 1 }, variant: "text", onClick: () => msftRedirectLogin() },
            React__default.createElement(MicrosoftLoginLogo, null)),
        React__default.createElement(Button, { sx: { flexGrow: 1 }, variant: "text", onClick: () => oktaRedirectLogin() },
            React__default.createElement(OktaLoginLogo, null))));
};
const GoogleLoginBtn = ({ onSuccess, ssoLoginURL }) => {
    const state = Math.random().toString(36).substring(7);
    const googleLogin = useGoogleLogin({
        onSuccess: (response) => __awaiter$1(void 0, void 0, void 0, function* () {
            yield onSuccess(response, 'google');
        }),
        flow: 'auth-code',
        ux_mode: 'redirect',
        redirect_uri: ssoLoginURL,
        state: `google|${state}`,
    });
    return (React__default.createElement(Box, { sx: { display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexGrow: 1 } },
        React__default.createElement(Button, { sx: { flexGrow: 1 }, variant: "text", onClick: googleLogin },
            React__default.createElement(GoogleLoginLogo, null))));
};

const PasswordField = ({ password, setPassword, sx, label = "password", id }) => {
    // We need to do this because MUI Icon have some issue when a part of a component library
    const normalizeIcon = (Icon) => (Icon.default ? Icon.default : Icon);
    const [showPassword, setShowPassword] = useState(false);
    const { i18n } = useAuth$1();
    const formType = () => showPassword ? 'text' : 'password';
    const ShowIcon = normalizeIcon(Visibility);
    const HideIcon = normalizeIcon(VisibilityOff);
    return (React__default.createElement(FormControl, { sx: sx },
        React__default.createElement(InputLabel, { shrink: true, htmlFor: "password-field", sx: { pl: '17px', pr: '0px' } }, i18n.t(label)),
        React__default.createElement(OutlinedInput, { id: id || "password-field", label: i18n.t(label), name: i18n.t(label), type: formType(), value: password, onChange: event => setPassword(event.target.value), autoComplete: "current-password", notched: true, endAdornment: React__default.createElement(InputAdornment, { position: "end" },
                React__default.createElement(IconButton, { "aria-label": i18n.t('toggle_password_visibility'), onClick: () => setShowPassword(!showPassword), edge: "end" }, showPassword ? React__default.createElement(HideIcon, null) : React__default.createElement(ShowIcon, null))), sx: TextFieldStyling() })));
};

function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}

// utils is a library of generic helper functions non-specific to axios

const {toString} = Object.prototype;
const {getPrototypeOf} = Object;

const kindOf = (cache => thing => {
    const str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));

const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type
};

const typeOfTest = type => thing => typeof thing === type;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */
const {isArray} = Array;

/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */
const isUndefined = typeOfTest('undefined');

/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
const isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  let result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */
const isString = typeOfTest('string');

/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
const isFunction = typeOfTest('function');

/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */
const isNumber = typeOfTest('number');

/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */
const isObject = (thing) => thing !== null && typeof thing === 'object';

/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
const isBoolean = thing => thing === true || thing === false;

/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */
const isPlainObject$1 = (val) => {
  if (kindOf(val) !== 'object') {
    return false;
  }

  const prototype = getPrototypeOf(val);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};

/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */
const isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */
const isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */
const isStream = (val) => isObject(val) && isFunction(val.pipe);

/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */
const isFormData = (thing) => {
  let kind;
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) || (
      isFunction(thing.append) && (
        (kind = kindOf(thing)) === 'formdata' ||
        // detect form-data instance
        (kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]')
      )
    )
  )
};

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
const isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */
const trim = (str) => str.trim ?
  str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */
function forEach(obj, fn, {allOwnKeys = false} = {}) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  let i;
  let l;

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;

    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}

function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}

const _global = (() => {
  /*eslint no-undef:0*/
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : (typeof window !== 'undefined' ? window : global)
})();

const isContextDefined = (context) => !isUndefined(context) && context !== _global;

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  const {caseless} = isContextDefined(this) && this || {};
  const result = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result, key) || key;
    if (isPlainObject$1(result[targetKey]) && isPlainObject$1(val)) {
      result[targetKey] = merge(result[targetKey], val);
    } else if (isPlainObject$1(val)) {
      result[targetKey] = merge({}, val);
    } else if (isArray(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  };

  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */
const extend = (a, b, thisArg, {allOwnKeys}= {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, {allOwnKeys});
  return a;
};

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
};

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */
const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, 'super', {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
};

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */
const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
};

/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
};


/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */
const toArray = (thing) => {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
};

/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */
// eslint-disable-next-line func-names
const isTypedArray = (TypedArray => {
  // eslint-disable-next-line func-names
  return thing => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));

/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];

  const iterator = generator.call(obj);

  let result;

  while ((result = iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
};

/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
};

/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
const isHTMLForm = kindOfTest('HTMLFormElement');

const toCamelCase = str => {
  return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};

/* Creating a function that will check if an object has a property. */
const hasOwnProperty = (({hasOwnProperty}) => (obj, prop) => hasOwnProperty.call(obj, prop))(Object.prototype);

/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */
const isRegExp = kindOfTest('RegExp');

const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};

  forEach(descriptors, (descriptor, name) => {
    let ret;
    if ((ret = reducer(descriptor, name, obj)) !== false) {
      reducedDescriptors[name] = ret || descriptor;
    }
  });

  Object.defineProperties(obj, reducedDescriptors);
};

/**
 * Makes all methods read-only
 * @param {Object} obj
 */

const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    // skip restricted props in strict mode
    if (isFunction(obj) && ['arguments', 'caller', 'callee'].indexOf(name) !== -1) {
      return false;
    }

    const value = obj[name];

    if (!isFunction(value)) return;

    descriptor.enumerable = false;

    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }

    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error('Can not rewrite read-only method \'' + name + '\'');
      };
    }
  });
};

const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};

  const define = (arr) => {
    arr.forEach(value => {
      obj[value] = true;
    });
  };

  isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));

  return obj;
};

const noop$1 = () => {};

const toFiniteNumber = (value, defaultValue) => {
  value = +value;
  return Number.isFinite(value) ? value : defaultValue;
};

const ALPHA = 'abcdefghijklmnopqrstuvwxyz';

const DIGIT = '0123456789';

const ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
};

const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
  let str = '';
  const {length} = alphabet;
  while (size--) {
    str += alphabet[Math.random() * length|0];
  }

  return str;
};

/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}

const toJSONObject = (obj) => {
  const stack = new Array(10);

  const visit = (source, i) => {

    if (isObject(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }

      if(!('toJSON' in source)) {
        stack[i] = source;
        const target = isArray(source) ? [] : {};

        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });

        stack[i] = undefined;

        return target;
      }
    }

    return source;
  };

  return visit(obj, 0);
};

const isAsyncFn = kindOfTest('AsyncFunction');

const isThenable = (thing) =>
  thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);

var utils = {
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject: isPlainObject$1,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty,
  hasOwnProp: hasOwnProperty, // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop: noop$1,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable
};

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error()).stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

const prototype$1 = AxiosError.prototype;
const descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(code => {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype$1, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(prototype$1);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, prop => {
    return prop !== 'isAxiosError';
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

// eslint-disable-next-line strict
var httpAdapter = null;

/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */
function isVisitable(thing) {
  return utils.isPlainObject(thing) || utils.isArray(thing);
}

/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */
function removeBrackets(key) {
  return utils.endsWith(key, '[]') ? key.slice(0, -2) : key;
}

/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */
function isFlatArray(arr) {
  return utils.isArray(arr) && !arr.some(isVisitable);
}

const predicates = utils.toFlatObject(utils, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */
function toFormData(obj, formData, options) {
  if (!utils.isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (FormData)();

  // eslint-disable-next-line no-param-reassign
  options = utils.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !utils.isUndefined(source[option]);
  });

  const metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  const useBlob = _Blob && utils.isSpecCompliantForm(formData);

  if (!utils.isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && utils.isBlob(value)) {
      throw new AxiosError('Blob is not supported. Use a Buffer instead.');
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    let arr = value;

    if (value && !path && typeof value === 'object') {
      if (utils.endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (utils.isArray(value) && isFlatArray(value)) ||
        ((utils.isFileList(value) || utils.endsWith(key, '[]')) && (arr = utils.toArray(value))
        )) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !(utils.isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : (indexes === null ? key : key + '[]'),
            convertValue(el)
          );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  const stack = [];

  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });

  function build(value, path) {
    if (utils.isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    utils.forEach(value, function each(el, key) {
      const result = !(utils.isUndefined(el) || el === null) && visitor.call(
        formData, el, utils.isString(key) ? key.trim() : key, path, exposedHelpers
      );

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!utils.isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */
function encode$1(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */
function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && toFormData(params, this, options);
}

const prototype = AxiosURLSearchParams.prototype;

prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

prototype.toString = function toString(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode$1);
  } : encode$1;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */
function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 *
 * @returns {string} The formatted url
 */
function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }
  
  const _encode = options && options.encode || encode;

  const serializeFn = options && options.serialize;

  let serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils.isURLSearchParams(params) ?
      params.toString() :
      new AxiosURLSearchParams(params, options).toString(_encode);
  }

  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}

class InterceptorManager {
  constructor() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }

  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    utils.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}

var transitionalDefaults = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};

var URLSearchParams$1 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : AxiosURLSearchParams;

var FormData$1 = typeof FormData !== 'undefined' ? FormData : null;

var Blob$1 = typeof Blob !== 'undefined' ? Blob : null;

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */
const isStandardBrowserEnv = (() => {
  let product;
  if (typeof navigator !== 'undefined' && (
    (product = navigator.product) === 'ReactNative' ||
    product === 'NativeScript' ||
    product === 'NS')
  ) {
    return false;
  }

  return typeof window !== 'undefined' && typeof document !== 'undefined';
})();

/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */
 const isStandardBrowserWebWorkerEnv = (() => {
  return (
    typeof WorkerGlobalScope !== 'undefined' &&
    // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope &&
    typeof self.importScripts === 'function'
  );
})();


var platform = {
  isBrowser: true,
  classes: {
    URLSearchParams: URLSearchParams$1,
    FormData: FormData$1,
    Blob: Blob$1
  },
  isStandardBrowserEnv,
  isStandardBrowserWebWorkerEnv,
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
};

function toURLEncodedForm(data, options) {
  return toFormData(data, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (platform.isNode && utils.isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}

/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */
function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return utils.matchAll(/\w+|\[(\w*)]/g, name).map(match => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];
    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && utils.isArray(target) ? target.length : name;

    if (isLast) {
      if (utils.hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !utils.isObject(target[name])) {
      target[name] = [];
    }

    const result = buildPath(path, value, target[name], index);

    if (result && utils.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (utils.isFormData(formData) && utils.isFunction(formData.entries)) {
    const obj = {};

    utils.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */
function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

const defaults = {

  transitional: transitionalDefaults,

  adapter: platform.isNode ? 'http' : 'xhr',

  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || '';
    const hasJSONContentType = contentType.indexOf('application/json') > -1;
    const isObjectPayload = utils.isObject(data);

    if (isObjectPayload && utils.isHTMLForm(data)) {
      data = new FormData(data);
    }

    const isFormData = utils.isFormData(data);

    if (isFormData) {
      if (!hasJSONContentType) {
        return data;
      }
      return hasJSONContentType ? JSON.stringify(formDataToJSON(data)) : data;
    }

    if (utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }

    let isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }

      if ((isFileList = utils.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        const _FormData = this.env && this.env.FormData;

        return toFormData(
          isFileList ? {'files[]': data} : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }

    if (isObjectPayload || hasJSONContentType ) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    const transitional = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    const JSONRequested = this.responseType === 'json';

    if (data && utils.isString(data) && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
      const silentJSONParsing = transitional && transitional.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': undefined
    }
  }
};

utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch'], (method) => {
  defaults.headers[method] = {};
});

// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = utils.toObjectSet([
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
]);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
var parseHeaders = rawHeaders => {
  const parsed = {};
  let key;
  let val;
  let i;

  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();

    if (!key || (parsed[key] && ignoreDuplicateOf[key])) {
      return;
    }

    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
};

const $internals = Symbol('internals');

function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}

function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }

  return utils.isArray(value) ? value.map(normalizeValue) : String(value);
}

function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;

  while ((match = tokensRE.exec(str))) {
    tokens[match[1]] = match[2];
  }

  return tokens;
}

const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());

function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
  if (utils.isFunction(filter)) {
    return filter.call(this, value, header);
  }

  if (isHeaderNameFilter) {
    value = header;
  }

  if (!utils.isString(value)) return;

  if (utils.isString(filter)) {
    return value.indexOf(filter) !== -1;
  }

  if (utils.isRegExp(filter)) {
    return filter.test(value);
  }
}

function formatHeader(header) {
  return header.trim()
    .toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
      return char.toUpperCase() + str;
    });
}

function buildAccessors(obj, header) {
  const accessorName = utils.toCamelCase(' ' + header);

  ['get', 'set', 'has'].forEach(methodName => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}

class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }

  set(header, valueOrRewrite, rewrite) {
    const self = this;

    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);

      if (!lHeader) {
        throw new Error('header name must be a non-empty string');
      }

      const key = utils.findKey(self, lHeader);

      if(!key || self[key] === undefined || _rewrite === true || (_rewrite === undefined && self[key] !== false)) {
        self[key || _header] = normalizeValue(_value);
      }
    }

    const setHeaders = (headers, _rewrite) =>
      utils.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));

    if (utils.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite);
    } else if(utils.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }

    return this;
  }

  get(header, parser) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);

      if (key) {
        const value = this[key];

        if (!parser) {
          return value;
        }

        if (parser === true) {
          return parseTokens(value);
        }

        if (utils.isFunction(parser)) {
          return parser.call(this, value, key);
        }

        if (utils.isRegExp(parser)) {
          return parser.exec(value);
        }

        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }

  has(header, matcher) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);

      return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }

    return false;
  }

  delete(header, matcher) {
    const self = this;
    let deleted = false;

    function deleteHeader(_header) {
      _header = normalizeHeader(_header);

      if (_header) {
        const key = utils.findKey(self, _header);

        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];

          deleted = true;
        }
      }
    }

    if (utils.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }

    return deleted;
  }

  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;

    while (i--) {
      const key = keys[i];
      if(!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }

    return deleted;
  }

  normalize(format) {
    const self = this;
    const headers = {};

    utils.forEach(this, (value, header) => {
      const key = utils.findKey(headers, header);

      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }

      const normalized = format ? formatHeader(header) : String(header).trim();

      if (normalized !== header) {
        delete self[header];
      }

      self[normalized] = normalizeValue(value);

      headers[normalized] = true;
    });

    return this;
  }

  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }

  toJSON(asStrings) {
    const obj = Object.create(null);

    utils.forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && utils.isArray(value) ? value.join(', ') : value);
    });

    return obj;
  }

  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }

  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ': ' + value).join('\n');
  }

  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }

  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }

  static concat(first, ...targets) {
    const computed = new this(first);

    targets.forEach((target) => computed.set(target));

    return computed;
  }

  static accessor(header) {
    const internals = this[$internals] = (this[$internals] = {
      accessors: {}
    });

    const accessors = internals.accessors;
    const prototype = this.prototype;

    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);

      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }

    utils.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);

    return this;
  }
}

AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']);

// reserved names hotfix
utils.reduceDescriptors(AxiosHeaders.prototype, ({value}, key) => {
  let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
  return {
    get: () => value,
    set(headerValue) {
      this[mapped] = headerValue;
    }
  }
});

utils.freezeMethods(AxiosHeaders);

/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */
function transformData(fns, response) {
  const config = this || defaults;
  const context = response || config;
  const headers = AxiosHeaders.from(context.headers);
  let data = context.data;

  utils.forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });

  headers.normalize();

  return data;
}

function isCancel(value) {
  return !!(value && value.__CANCEL__);
}

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */
function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
      'Request failed with status code ' + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}

var cookies = platform.isStandardBrowserEnv ?

// Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        const cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

// Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })();

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */
function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
}

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}

var isURLSameOrigin = platform.isStandardBrowserEnv ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement('a');
    let originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      let href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
          urlParsingNode.pathname :
          '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      const parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
          parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })();

function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}

/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;

  min = min !== undefined ? min : 1000;

  return function push(chunkLength) {
    const now = Date.now();

    const startedAt = timestamps[tail];

    if (!firstSampleTS) {
      firstSampleTS = now;
    }

    bytes[head] = chunkLength;
    timestamps[head] = now;

    let i = tail;
    let bytesCount = 0;

    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }

    head = (head + 1) % samplesCount;

    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }

    if (now - firstSampleTS < min) {
      return;
    }

    const passed = startedAt && now - startedAt;

    return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}

function progressEventReducer(listener, isDownloadStream) {
  let bytesNotified = 0;
  const _speedometer = speedometer(50, 250);

  return e => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;

    bytesNotified = loaded;

    const data = {
      loaded,
      total,
      progress: total ? (loaded / total) : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e
    };

    data[isDownloadStream ? 'download' : 'upload'] = true;

    listener(data);
  };
}

const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';

var xhrAdapter = isXHRAdapterSupported && function (config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    let requestData = config.data;
    const requestHeaders = AxiosHeaders.from(config.headers).normalize();
    const responseType = config.responseType;
    let onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData)) {
      if (platform.isStandardBrowserEnv || platform.isStandardBrowserWebWorkerEnv) {
        requestHeaders.setContentType(false); // Let the browser set it
      } else {
        requestHeaders.setContentType('multipart/form-data;', false); // mobile/desktop app frameworks
      }
    }

    let request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      const username = config.auth.username || '';
      const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.set('Authorization', 'Basic ' + btoa(username + ':' + password));
    }

    const fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      const responseHeaders = AxiosHeaders.from(
        'getAllResponseHeaders' in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === 'text' || responseType === 'json' ?
        request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      const transitional = config.transitional || transitionalDefaults;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (platform.isStandardBrowserEnv) {
      // Add xsrf header
      const xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath))
        && config.xsrfCookieName && cookies.read(config.xsrfCookieName);

      if (xsrfValue) {
        requestHeaders.set(config.xsrfHeaderName, xsrfValue);
      }
    }

    // Remove Content-Type if data is undefined
    requestData === undefined && requestHeaders.setContentType(null);

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', progressEventReducer(config.onDownloadProgress, true));
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', progressEventReducer(config.onUploadProgress));
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = cancel => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    const protocol = parseProtocol(fullPath);

    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData || null);
  });
};

const knownAdapters = {
  http: httpAdapter,
  xhr: xhrAdapter
};

utils.forEach(knownAdapters, (fn, value) => {
  if(fn) {
    try {
      Object.defineProperty(fn, 'name', {value});
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
    Object.defineProperty(fn, 'adapterName', {value});
  }
});

var adapters = {
  getAdapter: (adapters) => {
    adapters = utils.isArray(adapters) ? adapters : [adapters];

    const {length} = adapters;
    let nameOrAdapter;
    let adapter;

    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      if((adapter = utils.isString(nameOrAdapter) ? knownAdapters[nameOrAdapter.toLowerCase()] : nameOrAdapter)) {
        break;
      }
    }

    if (!adapter) {
      if (adapter === false) {
        throw new AxiosError(
          `Adapter ${nameOrAdapter} is not supported by the environment`,
          'ERR_NOT_SUPPORT'
        );
      }

      throw new Error(
        utils.hasOwnProp(knownAdapters, nameOrAdapter) ?
          `Adapter '${nameOrAdapter}' is not available in the build` :
          `Unknown adapter '${nameOrAdapter}'`
      );
    }

    if (!utils.isFunction(adapter)) {
      throw new TypeError('adapter is not a function');
    }

    return adapter;
  },
  adapters: knownAdapters
};

/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError(null, config);
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */
function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  config.headers = AxiosHeaders.from(config.headers);

  // Transform request data
  config.data = transformData.call(
    config,
    config.transformRequest
  );

  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }

  const adapter = adapters.getAdapter(config.adapter || defaults.adapter);

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      config.transformResponse,
      response
    );

    response.headers = AxiosHeaders.from(response.headers);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = AxiosHeaders.from(reason.response.headers);
      }
    }

    return Promise.reject(reason);
  });
}

const headersToObject = (thing) => thing instanceof AxiosHeaders ? thing.toJSON() : thing;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */
function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  const config = {};

  function getMergedValue(target, source, caseless) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge.call({caseless}, target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(a, b, caseless) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(a, b, caseless);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a, caseless);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(undefined, a);
    }
  }

  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b) => mergeDeepProperties(headersToObject(a), headersToObject(b), true)
  };

  utils.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
    const merge = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge(config1[prop], config2[prop], prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
}

const VERSION = "1.5.0";

const validators$1 = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators$1[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

const deprecatedWarnings = {};

/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */
validators$1.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return (value, opt, opts) => {
    if (validator === false) {
      throw new AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator = schema[opt];
    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

var validator = {
  assertOptions,
  validators: validators$1
};

const validators = validator.validators;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new InterceptorManager(),
      response: new InterceptorManager()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }

    config = mergeConfig(this.defaults, config);

    const {transitional, paramsSerializer, headers} = config;

    if (transitional !== undefined) {
      validator.assertOptions(transitional, {
        silentJSONParsing: validators.transitional(validators.boolean),
        forcedJSONParsing: validators.transitional(validators.boolean),
        clarifyTimeoutError: validators.transitional(validators.boolean)
      }, false);
    }

    if (paramsSerializer != null) {
      if (utils.isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        };
      } else {
        validator.assertOptions(paramsSerializer, {
          encode: validators.function,
          serialize: validators.function
        }, true);
      }
    }

    // Set config.method
    config.method = (config.method || this.defaults.method || 'get').toLowerCase();

    // Flatten headers
    let contextHeaders = headers && utils.merge(
      headers.common,
      headers[config.method]
    );

    headers && utils.forEach(
      ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
      (method) => {
        delete headers[method];
      }
    );

    config.headers = AxiosHeaders.concat(contextHeaders, headers);

    // filter out skipped interceptors
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }

      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });

    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });

    let promise;
    let i = 0;
    let len;

    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), undefined];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;

      promise = Promise.resolve(config);

      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }

      return promise;
    }

    len = requestInterceptorChain.length;

    let newConfig = config;

    i = 0;

    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }

    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }

    i = 0;
    len = responseInterceptorChain.length;

    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }

    return promise;
  }

  getUri(config) {
    config = mergeConfig(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
}

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url,
        data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */
class CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    let resolvePromise;

    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });

    const token = this;

    // eslint-disable-next-line func-names
    this.promise.then(cancel => {
      if (!token._listeners) return;

      let i = token._listeners.length;

      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = onfulfilled => {
      let _resolve;
      // eslint-disable-next-line func-names
      const promise = new Promise(resolve => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };

      return promise;
    };

    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new CanceledError(message, config, request);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }

  /**
   * Subscribe to the cancel signal
   */

  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }

    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }

  /**
   * Unsubscribe from the cancel signal
   */

  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
}

const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
};

Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  const context = new Axios(defaultConfig);
  const instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context, {allOwnKeys: true});

  // Copy context to instance
  utils.extend(instance, context, null, {allOwnKeys: true});

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
const axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.CanceledError = CanceledError;
axios.CancelToken = CancelToken;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = toFormData;

// Expose AxiosError class
axios.AxiosError = AxiosError;

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};

axios.spread = spread;

// Expose isAxiosError
axios.isAxiosError = isAxiosError;

// Expose mergeConfig
axios.mergeConfig = mergeConfig;

axios.AxiosHeaders = AxiosHeaders;

axios.formToJSON = thing => formDataToJSON(utils.isHTMLForm(thing) ? new FormData(thing) : thing);

axios.getAdapter = adapters.getAdapter;

axios.HttpStatusCode = HttpStatusCode;

axios.default = axios;

class RequestHelper {
    constructor(authUrl) {
        this.authUrl = '';
        this.makingCodeLogin = false;
        this.makingBlockingRequest = false;
        this.listUsersPreviousToken = '';
        this.listUsersNextToken = '';
        this.authUrl = authUrl;
    }
    static getInstance(authUrl) {
        if (!RequestHelper.instance) {
            RequestHelper.instance = new RequestHelper(authUrl);
        }
        return RequestHelper.instance;
    }
    refreshToken() {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/browserLogin`;
            const res = yield axios(url, { withCredentials: true, method: 'post', validateStatus: () => true });
            return res;
        });
    }
    makeRequest({ requestFn }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            if (this.makingBlockingRequest) {
                return;
            }
            try {
                const res = yield requestFn();
                this.makingBlockingRequest = false;
                return res;
            }
            catch (_e) {
                yield this.refreshToken();
                const res2 = yield requestFn();
                this.makingBlockingRequest = false;
                return res2;
            }
        });
    }
    makeAuthenticatedRequest({ requestFn, setError }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            if (this.makingBlockingRequest) {
                return false;
            }
            let res = yield requestFn();
            if (res.status === 401) { // refresh token
                res = yield this.refreshToken();
                if (res.status === 401) {
                    if (setError) {
                        setError('Unauthenticated. Please log in again.');
                    }
                    return false;
                }
                res = yield requestFn();
            }
            if (res.status > 299) {
                if (setError) {
                    setError(res.data.message);
                }
                return false;
            }
            return res.data;
        });
    }
    loginUser({ email, password }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/browserLogin`;
            const res = yield axios(url, { method: 'post', data: { email, password }, validateStatus: () => true, headers: { 'Access-Control-Allow-Origin': true } });
            return res;
        });
    }
    loginUserCode({ email, password, csrfToken }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/browserLogin`;
            const res = yield axios(url, { method: 'post', data: { email, password, csrfToken, requireCode: true }, validateStatus: () => true });
            return res;
        });
    }
    // async ssoLoginUser({ providerData, provider }:{ providerData:{ [Key:string]:any }, provider:string }) {
    //   const url = `${this.authUrl}/sso/login`;
    //   const res = await axios(url, { method : 'post', data : { providerData, provider }, validateStatus : () => true });
    //   return res;
    // }
    changePassword({ oldPassword, newPassword }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/change-password`;
            const res = yield axios(url, { method: 'post', data: { oldPassword, newPassword }, validateStatus: () => true });
            return res;
        });
    }
    forgotPassword({ email }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/forgot-password`;
            const res = yield axios(url, { method: 'post', data: { email }, validateStatus: () => true });
            return res;
        });
    }
    confirmForgotPassword({ email, code, newPassword }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/confirm-forgot-password`;
            const res = yield axios(url, { method: 'post', data: { email, confirmationCode: code, password: newPassword }, validateStatus: () => true });
            return res;
        });
    }
    challengeResponse({ email, newPassword, sessionToken }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/browser-challenge-response`;
            const res = yield axios(url, { method: 'post', data: { email, newPassword, session: sessionToken }, validateStatus: () => true });
            return res;
        });
    }
    checkSSOProvider({ email, redirectUrl }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/sso/provider-for-user`;
            const res = yield axios(url, { method: 'post', validateStatus: () => true, data: { email, redirectUrl } });
            return res;
        });
    }
    getSSOGlobal({ tenantId }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/sso/tenants/${tenantId}/get-sso-global`;
            const res = yield axios(url, { method: 'get', data: {} });
            return res;
        });
    }
    addSSOProvider(_a) {
        var { tenantId } = _a, data = __rest$1(_a, ["tenantId"]);
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/sso/tenants/${tenantId}/add-sso-config`;
            const res = yield axios(url, { method: 'post', data: Object.assign({}, data) });
            return res;
        });
    }
    removeSSOProvider({ tenantId, Sort }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/sso/tenants/${tenantId}/remove-sso-config`;
            const res = yield axios(url, { method: 'delete', data: { Sort } });
            return res;
        });
    }
    updateSSOProvider(_a) {
        var { tenantId, Sort } = _a, config = __rest$1(_a, ["tenantId", "Sort"]);
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/sso/tenants/${tenantId}/update-sso-config`;
            const res = yield axios(url, { method: 'post', data: Object.assign({ Sort }, config) });
            return res;
        });
    }
    codeLogin({ code, state }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            if (this.makingCodeLogin) {
                return { status: 400, data: { error: 'Already making code login' } };
            }
            this.makingCodeLogin = true;
            const url = `${this.authUrl}/sso/code-login`;
            const res = yield axios(url, { method: 'post', data: { code, state }, headers: { 'Content-Type': 'application/json' }, validateStatus: () => true });
            this.makingCodeLogin = false;
            return res;
        });
    }
    logoutUserFN() {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/browserLogout`;
            const res = yield axios(url, { method: 'post', validateStatus: () => true });
            return res;
        });
    }
    getAPITokensFN({ TenantId }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/tenants/${TenantId}/tenantTokens`;
            const res = yield axios(url, { method: 'get', validateStatus: status => true });
            return res;
        });
    }
    revokeAPITokenFN({ TenantId, tokenJTI }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/tenants/${TenantId}/tenantTokens/${tokenJTI}/revoke`;
            const res = yield axios(url, { method: 'post', validateStatus: status => true });
            return res;
        });
    }
    addAPITokenFN({ TenantId }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/tenants/${TenantId}/tenantTokens/create`;
            const res = yield axios(url, { method: 'post', validateStatus: status => true });
            return res;
        });
    }
    getTenantFN({ TenantId }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/tenants/${TenantId}`;
            const res = yield axios(url, { method: 'get', validateStatus: status => true });
            return res;
        });
    }
    updateTenantFN({ TenantId, TenantParams }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/tenants/${TenantId}/update`;
            const res = yield axios(url, { method: 'patch', data: TenantParams, validateStatus: () => true });
            return res;
        });
    }
    createTenantFN({ TenantParams }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/create-tenant`;
            const res = yield axios(url, { method: 'post', data: Object.assign(Object.assign({}, TenantParams), { createCertifyTenant: true }), validateStatus: () => true });
            return res;
        });
    }
    listTenantsFN() {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/tenants`;
            const res = yield axios(url, { method: 'get', validateStatus: status => true });
            return res;
        });
    }
    getUserFN({ email }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            // base64 encode email
            const encodedEmail = btoa(email);
            const url = `${this.authUrl}/admin-get-user/${encodedEmail}`;
            const res = yield axios(url, { method: 'get', validateStatus: status => true });
            return res;
        });
    }
    createUserFN({ userParams }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/create-user`;
            const res = yield axios(url, { method: 'post', data: userParams, validateStatus: status => true });
            return res;
        });
    }
    updateUserFN({ userParams }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/admin-update-user`;
            const res = yield axios(url, { method: 'patch', data: userParams, validateStatus: status => true });
            return res;
        });
    }
    enableUserFN({ email }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/enable-user`;
            const res = yield axios(url, { method: 'post', data: { email }, validateStatus: status => true });
            return res;
        });
    }
    disableUserFN({ email }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/disable-user`;
            const res = yield axios(url, { method: 'delete', data: { email }, validateStatus: status => true });
            return res;
        });
    }
    deleteUserFN({ email }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/delete-user`;
            const res = yield axios(url, { method: 'delete', data: { email }, validateStatus: status => true });
            return res;
        });
    }
    getCurrentUserWithTenantFN() {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/get-current-user-with-tenant`;
            const res = yield axios(url, { method: 'get', validateStatus: status => true });
            return res;
        });
    }
    getUsersForTenantFN({ TenantId, NextToken }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/tenants/${TenantId}/users?hydrateGroups=true${NextToken ? `&NextToken=${encodeURIComponent(NextToken)}` : ''}`;
            const res = yield axios(url, { method: 'get', withCredentials: true, validateStatus: status => true });
            return res;
        });
    }
    findUserFromTenantFN({ TenantId, email }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/tenants/${TenantId}/findUser`;
            const res = yield axios(url, { method: 'post', data: { email }, validateStatus: status => true });
            return res;
        });
    }
    bulkImportFN({ TenantId, userData, locale, userApp }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/tenants/${TenantId}/bulk-create`;
            const res = yield axios(url, { method: 'post', data: { userData, locale, userApp }, validateStatus: status => true });
            return res;
        });
    }
    getRolesForTenantFN({ TenantId }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/tenants/${TenantId}/rolesets`;
            const res = yield axios(url, { method: 'get', validateStatus: status => true });
            return res;
        });
    }
    getRolesForUserFN({ email, TenantId }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const encodedEmail = encodeURIComponent(email);
            const url = `${this.authUrl}/tenants/${TenantId}/users/${encodedEmail}/rolesets`;
            const res = yield axios(url, { method: 'get', validateStatus: status => true });
            return res;
        });
    }
    addRoleSetToUserFN({ email, TenantId, roleSetId }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const encodedEmail = encodeURIComponent(email);
            const url = `${this.authUrl}/tenants/${TenantId}/users/${encodedEmail}/addroleset`;
            const res = yield axios(url, { method: 'post', data: { roleSetId }, validateStatus: status => true });
            return res;
        });
    }
    removeRoleSetFromUserFN({ email, TenantId, roleSetId }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const encodedEmail = encodeURIComponent(email);
            const url = `${this.authUrl}/tenants/${TenantId}/users/${encodedEmail}/removeroleset`;
            const res = yield axios(url, { method: 'post', data: { roleSetId }, validateStatus: status => true });
            return res;
        });
    }
    forceResetPasswordFN({ email, tenantId }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/reset-password`;
            const res = yield axios(url, { method: 'post', data: { email, tenant: tenantId }, validateStatus: status => true });
            return res;
        });
    }
    addGroupsToUsersFN({ TenantId, emails, groupIds }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/tenants/${TenantId}/users/addgroups`;
            const res = yield axios(url, { method: 'post', data: { emails, groupIds }, validateStatus: status => true });
            return res;
        });
    }
    removeGroupFromUserFN({ TenantId, email, groupId }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/tenants/${TenantId}/users/${email}/removegroup`;
            const res = yield axios(url, { method: 'post', data: { groupId }, validateStatus: status => true });
            return res;
        });
    }
    listGroupsForUserFN({ TenantId, email }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/tenants/${TenantId}/users/${email}/groups`;
            const res = yield axios(url, { method: 'get', validateStatus: status => true });
            return res;
        });
    }
    listGroupsForTenantFN({ TenantId }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/tenants/${TenantId}/groups`;
            const res = yield axios(url, { method: 'get', validateStatus: status => true });
            return res;
        });
    }
    getGroupFN({ TenantId, GroupId }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/tenants/${TenantId}/groups/${GroupId}`;
            const res = yield axios(url, { method: 'get', validateStatus: status => true });
            return res;
        });
    }
    createGroupFN({ TenantId, group }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/tenants/${TenantId}/groups/create`;
            const res = yield axios(url, { method: 'post', data: group, validateStatus: status => true });
            return res;
        });
    }
    deleteGroupFN({ TenantId, groupId }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/tenants/${TenantId}/groups/${groupId}`;
            const res = yield axios(url, { method: 'delete', validateStatus: status => true });
            return res;
        });
    }
    disableGroupFN({ TenantId, GroupId }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/tenants/${TenantId}/groups/${GroupId}/disable`;
            const res = yield axios(url, { method: 'patch', validateStatus: status => true });
            return res;
        });
    }
    enableGroupFN({ TenantId, GroupId }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/tenants/${TenantId}/groups/${GroupId}/enable`;
            const res = yield axios(url, { method: 'patch', validateStatus: status => true });
            return res;
        });
    }
    updateGroupFN({ TenantId, GroupId, group }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/tenants/${TenantId}/groups/${GroupId}`;
            const res = yield axios(url, { method: 'patch', data: group, validateStatus: status => true });
            return res;
        });
    }
    globalUserSearchFN({ email }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/global-find-users/${email}`;
            const res = yield axios(url, { method: 'get', validateStatus: status => true });
            return res;
        });
    }
    addTenantSSOConfigFN({ TenantId, tenantSSOConfig }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/sso/tenants/${TenantId}/add-sso-config`;
            const res = yield axios(url, { method: 'post', data: tenantSSOConfig, validateStatus: status => true });
            return res;
        });
    }
    updateTenantSSOConfigFN({ TenantId, tenantSSOConfig }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/sso/tenants/${TenantId}/update-sso-config`;
            const res = yield axios(url, { method: 'post', data: tenantSSOConfig, validateStatus: status => true });
            return res;
        });
    }
    removeTenantSSOConfigFN({ TenantId, Sort }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const url = `${this.authUrl}/sso/tenants/${TenantId}/remove-sso-config`;
            const res = yield axios(url, { method: 'delete', data: { Sort }, validateStatus: status => true });
            return res;
        });
    }
    logOutUser() {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.makeAuthenticatedRequest({ requestFn: () => __awaiter$1(this, void 0, void 0, function* () { return this.logoutUserFN(); }) });
        });
    }
    getAPITokens({ TenantId, setError }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.makeAuthenticatedRequest({ setError, requestFn: () => __awaiter$1(this, void 0, void 0, function* () { return this.getAPITokensFN({ TenantId }); }) });
        });
    }
    revokeAPIToken({ TenantId, tokenJTI, setError }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.makeAuthenticatedRequest({ setError, requestFn: () => __awaiter$1(this, void 0, void 0, function* () { return this.revokeAPITokenFN({ TenantId, tokenJTI }); }) });
        });
    }
    addAPIToken({ TenantId, setError }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.makeAuthenticatedRequest({ setError, requestFn: () => __awaiter$1(this, void 0, void 0, function* () { return this.addAPITokenFN({ TenantId }); }) });
        });
    }
    getTenant({ TenantId, setError }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.makeAuthenticatedRequest({ setError, requestFn: () => __awaiter$1(this, void 0, void 0, function* () { return this.getTenantFN({ TenantId }); }) });
        });
    }
    ;
    updateTenant({ TenantId, setError, TenantParams }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.makeAuthenticatedRequest({ setError, requestFn: () => __awaiter$1(this, void 0, void 0, function* () { return this.updateTenantFN({ TenantId, TenantParams }); }) });
        });
    }
    createTenant({ TenantParams, setError }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.makeAuthenticatedRequest({ setError, requestFn: () => __awaiter$1(this, void 0, void 0, function* () { return this.createTenantFN({ TenantParams }); }) });
        });
    }
    listTenants({ setError }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.makeAuthenticatedRequest({ setError, requestFn: () => __awaiter$1(this, void 0, void 0, function* () { return this.listTenantsFN(); }) });
        });
    }
    getUser({ email, setError }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.makeAuthenticatedRequest({ setError, requestFn: () => __awaiter$1(this, void 0, void 0, function* () { return this.getUserFN({ email }); }) });
        });
    }
    createUser({ userParams, setError }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.makeAuthenticatedRequest({ setError, requestFn: () => __awaiter$1(this, void 0, void 0, function* () { return this.createUserFN({ userParams }); }) });
        });
    }
    updateUser({ userParams, setError }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.makeAuthenticatedRequest({ setError, requestFn: () => __awaiter$1(this, void 0, void 0, function* () { return this.updateUserFN({ userParams }); }) });
        });
    }
    enableUser({ email, setError }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.makeAuthenticatedRequest({ setError, requestFn: () => __awaiter$1(this, void 0, void 0, function* () { return this.enableUserFN({ email }); }) });
        });
    }
    disableUser({ email, setError }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.makeAuthenticatedRequest({ setError, requestFn: () => __awaiter$1(this, void 0, void 0, function* () { return this.disableUserFN({ email }); }) });
        });
    }
    deleteUser({ email, setError }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.makeAuthenticatedRequest({ setError, requestFn: () => __awaiter$1(this, void 0, void 0, function* () { return this.deleteUserFN({ email }); }) });
        });
    }
    getCurrentUserWithTenant() {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.makeAuthenticatedRequest({ requestFn: () => __awaiter$1(this, void 0, void 0, function* () { return this.getCurrentUserWithTenantFN(); }) });
        });
    }
    bulkImport({ TenantId, userData, locale, userApp, setError }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.makeAuthenticatedRequest({ setError, requestFn: () => __awaiter$1(this, void 0, void 0, function* () { return this.bulkImportFN({ TenantId, userData, locale, userApp }); }) });
        });
    }
    getRolesForTenant({ TenantId, setError }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.makeAuthenticatedRequest({ setError, requestFn: () => __awaiter$1(this, void 0, void 0, function* () { return this.getRolesForTenantFN({ TenantId }); }) });
        });
    }
    getRolesForUser({ email, TenantId, setError }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.makeAuthenticatedRequest({ setError, requestFn: () => __awaiter$1(this, void 0, void 0, function* () { return this.getRolesForUserFN({ email, TenantId }); }) });
        });
    }
    addRoleSetToUser({ email, TenantId, roleSetId, setError }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.makeAuthenticatedRequest({ setError, requestFn: () => __awaiter$1(this, void 0, void 0, function* () { return this.addRoleSetToUserFN({ email, TenantId, roleSetId }); }) });
        });
    }
    removeRoleSetFromUser({ email, TenantId, roleSetId, setError }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.makeAuthenticatedRequest({ setError, requestFn: () => __awaiter$1(this, void 0, void 0, function* () { return this.removeRoleSetFromUserFN({ email, TenantId, roleSetId }); }) });
        });
    }
    forceResetPassword({ email, tenantId, setError }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.makeAuthenticatedRequest({ setError, requestFn: () => __awaiter$1(this, void 0, void 0, function* () { return this.forceResetPasswordFN({ email, tenantId }); }) });
        });
    }
    addGroupsToUsers({ TenantId, emails, groupIds, setError }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.makeAuthenticatedRequest({ setError, requestFn: () => __awaiter$1(this, void 0, void 0, function* () { return this.addGroupsToUsersFN({ TenantId, emails, groupIds }); }) });
        });
    }
    removeGroupFromUser({ TenantId, email, groupId, setError }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.makeAuthenticatedRequest({ setError, requestFn: () => __awaiter$1(this, void 0, void 0, function* () { return this.removeGroupFromUserFN({ TenantId, email, groupId }); }) });
        });
    }
    listGroupsForUser({ TenantId, email, setError }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.makeAuthenticatedRequest({ setError, requestFn: () => __awaiter$1(this, void 0, void 0, function* () { return this.listGroupsForUserFN({ TenantId, email }); }) });
        });
    }
    listGroupsForTenant({ TenantId, setError }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.makeAuthenticatedRequest({ setError, requestFn: () => __awaiter$1(this, void 0, void 0, function* () { return this.listGroupsForTenantFN({ TenantId }); }) });
        });
    }
    getGroup({ TenantId, GroupId, setError }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.makeAuthenticatedRequest({ setError, requestFn: () => __awaiter$1(this, void 0, void 0, function* () { return this.getGroupFN({ TenantId, GroupId }); }) });
        });
    }
    createGroup({ TenantId, group, setError }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.makeAuthenticatedRequest({ setError, requestFn: () => __awaiter$1(this, void 0, void 0, function* () { return this.createGroupFN({ TenantId, group }); }) });
        });
    }
    deleteGroup({ TenantId, groupId, setError }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.makeAuthenticatedRequest({ setError, requestFn: () => __awaiter$1(this, void 0, void 0, function* () { return this.deleteGroupFN({ TenantId, groupId }); }) });
        });
    }
    disableGroup({ TenantId, GroupId, setError }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.makeAuthenticatedRequest({ setError, requestFn: () => __awaiter$1(this, void 0, void 0, function* () { return this.disableGroupFN({ TenantId, GroupId }); }) });
        });
    }
    enableGroup({ TenantId, GroupId, setError }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.makeAuthenticatedRequest({ setError, requestFn: () => __awaiter$1(this, void 0, void 0, function* () { return this.enableGroupFN({ TenantId, GroupId }); }) });
        });
    }
    updateGroup({ TenantId, GroupId, group, setError }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.makeAuthenticatedRequest({ setError, requestFn: () => __awaiter$1(this, void 0, void 0, function* () { return this.updateGroupFN({ TenantId, GroupId, group }); }) });
        });
    }
    getUsersForTenant({ TenantId, NextToken, setError }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            const res = yield this.makeAuthenticatedRequest({ setError, requestFn: () => __awaiter$1(this, void 0, void 0, function* () { return this.getUsersForTenantFN({ TenantId, NextToken }); }) });
            if (res) {
                this.listUsersPreviousToken = NextToken || '';
                this.listUsersNextToken = res.NextToken || '';
            }
            return res;
        });
    }
    findUserFromTenant({ TenantId, email, setError }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.makeAuthenticatedRequest({ setError, requestFn: () => __awaiter$1(this, void 0, void 0, function* () { return this.findUserFromTenantFN({ TenantId, email: email.toLowerCase() }); }) });
        });
    }
    globalUserSearch({ email, setError }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.makeAuthenticatedRequest({ setError, requestFn: () => __awaiter$1(this, void 0, void 0, function* () { return this.globalUserSearchFN({ email }); }) });
        });
    }
    addTenantSSOConfig({ TenantId, tenantSSOConfig, setError }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.makeAuthenticatedRequest({ setError, requestFn: () => __awaiter$1(this, void 0, void 0, function* () { return this.addTenantSSOConfigFN({ TenantId, tenantSSOConfig }); }) });
        });
    }
    updateTenantSSOConfig({ TenantId, tenantSSOConfig, setError }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.makeAuthenticatedRequest({ setError, requestFn: () => __awaiter$1(this, void 0, void 0, function* () { return this.updateTenantSSOConfigFN({ TenantId, tenantSSOConfig }); }) });
        });
    }
    removeTenantSSOConfig({ TenantId, Sort, setError }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.makeAuthenticatedRequest({ setError, requestFn: () => __awaiter$1(this, void 0, void 0, function* () { return this.removeTenantSSOConfigFN({ TenantId, Sort }); }) });
        });
    }
    hasMoreUsersToLoad() {
        return !!this.listUsersNextToken;
    }
    getNextUsersForTenant({ TenantId, setError }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.getUsersForTenant({ TenantId, NextToken: this.listUsersNextToken, setError });
        });
    }
    getPreviousUsersForTenant({ TenantId, setError }) {
        return __awaiter$1(this, void 0, void 0, function* () {
            return this.getUsersForTenant({ TenantId, NextToken: this.listUsersPreviousToken, setError });
        });
    }
}

const generateQueryParams = (paramsData) => {
    const params = Object.entries(paramsData)
        .filter((param) => {
        return param[1] !== undefined;
    })
        .map(([key, value]) => [key, value.toString()]);
    if (!params.length)
        return '';
    return `?${new URLSearchParams(params).toString()}`;
};
const generateUrl = (origin, params) => {
    return `${origin}${generateQueryParams(params)}`;
};

const ActiveAlert = ({ message }) => {
    return (React__default.createElement(Box$1, { id: "login-error", sx: { display: 'flex',
            padding: '8px',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '8px',
            alignSelf: 'stretch',
            background: '#A7353D',
            color: 'white',
            pointerEvents: 'none',
            borderRadius: '10px',
            userSelect: 'none' } },
        React__default.createElement(Box$1, { sx: { display: 'flex',
                alignItems: 'center' } },
            React__default.createElement(ReportProblemIcon, null)),
        React__default.createElement(Typography, { sx: { flexGrow: 1 } }, message)));
};

const LoginPassword = ({ setLoading, setCurrentState, email, setEmail, onLoginCompleteCallback, showSSO, ssoDetails, setSessionToken, apiUrl, }) => {
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loginSubmitted, setLoginSubmitted] = useState(false);
    const { i18n } = useAuth$1();
    const requestHelper = RequestHelper.getInstance(apiUrl);
    const { requireCode, csrfToken, redirectURL } = ssoDetails;
    const handleSubmit = (event) => __awaiter$1(void 0, void 0, void 0, function* () {
        event.preventDefault();
        setLoginSubmitted(true);
        let loginRes;
        if (requireCode) {
            loginRes = yield requestHelper.loginUserCode({ email, password, csrfToken: csrfToken || '' });
        }
        else {
            loginRes = yield requestHelper.loginUser({ email, password });
        }
        if (loginRes.status === 200) {
            if (loginRes.data.ChallengeRequired && loginRes.data.SessionToken) {
                setSessionToken(loginRes.data.SessionToken);
                setCurrentState('NEW_PASSWORD_REQUIRED');
                setLoginSubmitted(false);
                return;
            }
            if (loginRes.data.ChallengeRequired && loginRes.data.ChallengeRequired === 'FORCE_RESET_PASSWORD') {
                setCurrentState('CONFIRM_FORGOT_PASSWORD');
                setLoginSubmitted(false);
                return;
            }
            if (loginRes.data.ChallengeRequired && loginRes.data.ChallengeRequired === 'EXPIRED_PASSWORD') {
                setCurrentState('CONFIRM_FORGOT_PASSWORD');
                setLoginSubmitted(false);
                return;
            }
            const queryParams = loginRes.data.Code ? {
                code: loginRes.data.Code,
                callback: redirectURL,
                state: `routethis|${Math.random().toString(36).substring(7)}`
            } : {};
            // append the code to the current url
            window.location.href = generateUrl(window.location.href.split('?')[0], queryParams);
            yield onLoginCompleteCallback();
            setLoginSubmitted(false);
            return;
        }
        setError(i18n.t('invalid_login_credentials_error_message'));
        setLoginSubmitted(false);
    });
    return (React__default.createElement(Box$2, { sx: { width: '100%' } },
        React__default.createElement("form", { onSubmit: handleSubmit, id: "loginForm" },
            React__default.createElement(FormGroup, { sx: { alignItems: 'center', width: '100%' } },
                React__default.createElement(Typography, { variant: "h3", sx: {
                        mb: '32px',
                        mt: '40px',
                        fontSize: '24px',
                        textAlign: 'left',
                        width: '100%',
                        display: { xs: 'none', sm: 'none', md: 'block' }
                    } }, i18n.t('login_title_text')),
                error && React__default.createElement(ActiveAlert, { message: error }),
                React__default.createElement(TextField, { label: i18n.t('email'), id: "email", variant: "outlined", value: email === null || email === void 0 ? void 0 : email.trim(), onChange: event => setEmail(event.target.value), sx: Object.assign({}, TextFieldStyling({
                        mt: '12px',
                        mb: '12px',
                        width: '100%',
                        lineHeight: '1',
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderColor: error ? 'red' : 'default',
                                borderRadius: '5px', // Set border radius to 5px
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: 'default',
                            },
                        },
                    })) }),
                React__default.createElement(PasswordField, { password: password, setPassword: setPassword, sx: Object.assign({}, TextFieldStyling({ mt: '12px',
                        mb: '16px',
                        width: '100%',
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderColor: error ? 'red' : 'default',
                                borderRadius: '5px', // Set border radius to 5px
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: 'default',
                            },
                        }, })) }),
                React__default.createElement(RTButton, { id: 'forgot-password-button', type: "secondary", text: i18n.t('forgot_password'), onClick: () => setCurrentState('FORGOT_PASSWORD'), sx: { mt: '6px', mb: '6px', width: '100%' } }),
                React__default.createElement(RTButton, { id: 'sign-in-button', disabled: loginSubmitted, isSubmit: true, type: "primary", text: error ? i18n.t('try_again') : i18n.t('sign_in'), isLoading: loginSubmitted, sx: { mt: '6px', mb: '6px', width: '100%' } }))),
        showSSO &&
            React__default.createElement(Box$2, null,
                React__default.createElement(Box$2, null,
                    React__default.createElement(Box$2, { sx: { display: 'flex', alignItems: 'center', width: '100%', my: '16px' } },
                        React__default.createElement(Box$2, { sx: { flex: 1, height: '1px', bgcolor: 'grey.500' } }),
                        React__default.createElement(Box$2, { sx: { mx: '16px', fontSize: '14px', color: 'grey.700' } }, i18n.t('or')),
                        React__default.createElement(Box$2, { sx: { flex: 1, height: '1px', bgcolor: 'grey.500' } }))),
                React__default.createElement(SSOProviders, { ssoDetails: ssoDetails, apiUrl: apiUrl, onLoginCompleteCallback: onLoginCompleteCallback, setLoading: setLoading }),
                React__default.createElement(Typography, { align: "center", sx: { flexgrow: 1, fontSize: '16px', mt: '10px', color: colors.slate10 } }, i18n.t('contact_manager_for_account')))));
};

const ErrorPrompt = (_a) => {
    var { message = '', successMessage = '', id = '' } = _a, props = __rest$1(_a, ["message", "successMessage", "id"]);
    const isError = message.length > 0;
    const iconToShow = isError ? React__default.createElement(ErrorIcon, null) : React__default.createElement(CheckCircleOutlineIcon, null);
    const colorToShow = isError ? colors.sweetBrown : colors.primary10;
    const messageToShow = isError ? message : successMessage;
    return (React__default.createElement(React__default.Fragment, null, message.length === 0 && successMessage.length === 0 ? '' :
        React__default.createElement(Box, Object.assign({ sx: {
                display: 'flex',
                justifyContent: 'flex-start',
                alignSelf: 'flex-start',
                alignItems: 'center',
                fontSize: '14px',
                letterSpacing: '0.25px',
                ml: '4px',
                mt: '5px',
                color: colorToShow,
            } }, props),
            props.noIcon ? '' : iconToShow,
            React__default.createElement(Typography, Object.assign({ style: {
                    margin: '0 0 0 10px',
                    textAlign: 'start',
                    alignSelf: 'center',
                    color: colorToShow,
                } }, (id ? { id } : {})), messageToShow))));
};

const ForgotPassword = ({ setEmail, email, setCurrentState, apiUrl, }) => {
    const [error, setError] = useState('');
    const [loginSubmitted, setLoginSubmitted] = useState(false);
    const { i18n } = useAuth$1();
    const requestHelper = RequestHelper.getInstance(apiUrl);
    const handleForgotPassword = (event) => __awaiter$1(void 0, void 0, void 0, function* () {
        event.preventDefault();
        setLoginSubmitted(true);
        const res = yield requestHelper.forgotPassword({ email });
        if (res.status === 200) {
            setLoginSubmitted(false);
            setCurrentState('CONFIRM_FORGOT_PASSWORD');
            return;
        }
        setLoginSubmitted(false);
        setError(res.data.message || "Something went wrong, please try again");
    });
    return (React__default.createElement("div", null,
        React__default.createElement("form", { onSubmit: handleForgotPassword },
            React__default.createElement("div", { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', margin: '0 0 16px 0' } },
                React__default.createElement(Typography, { align: "left", sx: { width: '50%', fontSize: '24px', color: colors.slate10 } }, i18n.t('reset_password')),
                React__default.createElement(Typography, { align: "right", sx: { width: '50%', fontSize: '14px', color: colors.slate10 } }, i18n.t('step_1_of_2'))),
            React__default.createElement(FormGroup, { sx: { alignItems: 'center', width: '100%' } },
                React__default.createElement(Typography, { align: "left", sx: { width: '100%', fontSize: '14px', mt: '12px', mb: '24px', color: colors.slate10 } },
                    React__default.createElement("span", { dangerouslySetInnerHTML: { __html: i18n.t('reset_password_challenge_instructions').replace('[EMAIL]', `<strong>${email}</strong>`) } })),
                React__default.createElement(ErrorPrompt, { message: error, id: "login-error", noIcon: true, sx: { maxWidth: '260px', marginTop: '10px' } }),
                React__default.createElement(RTButton, { id: 'reset-password-button', type: 'primary', text: i18n.t('send-code'), isLoading: loginSubmitted, isSubmit: true, sx: { mt: '30px', mb: '4px', width: '100%' } }),
                React__default.createElement(RTButton, { id: 'already-have-code-button', type: 'secondary', onClick: () => setCurrentState('CONFIRM_FORGOT_PASSWORD'), sx: { mt: '4px', mb: '4px', width: '100%' }, text: i18n.t('already_have_reset_code') }),
                React__default.createElement(RTButton, { id: 'cancel-button', type: 'secondary', onClick: () => setCurrentState('LOGIN'), sx: { mt: '12px', mb: '16px', width: '100%' }, text: i18n.t('cancel') })))));
};

const ConfirmForgotPassword = ({ apiUrl, email, setEmail, setCurrentState, }) => {
    const [error, setError] = useState('');
    const [code, setCode] = useState('');
    const [password, setPassword] = useState('');
    const [confirmedPassword, setConfirmedPassword] = useState('');
    const [submittedNewPassword, setSubmittedNewPassword] = useState(false);
    const { i18n } = useAuth$1();
    const requestHelper = RequestHelper.getInstance(apiUrl);
    const handleConfirmForgotPassword = (event) => __awaiter$1(void 0, void 0, void 0, function* () {
        event.preventDefault();
        setSubmittedNewPassword(true);
        if (!code || code.length === 0) {
            setError(i18n.t('must_enter_reset_code'));
            setSubmittedNewPassword(false);
            return;
        }
        if (!password || password.length === 0) {
            setError(i18n.t('must_enter_new_password'));
            setSubmittedNewPassword(false);
            return;
        }
        if (password.trim().length < 8 ||
            !/[A-Z]/.test(password) ||
            !/[0-9]/.test(password)) {
            setError(i18n.t('password_minimum_requirements_shortened'));
            setSubmittedNewPassword(false);
            return;
        }
        if (password !== confirmedPassword) {
            setError(i18n.t('passwords_must_match'));
            setSubmittedNewPassword(false);
            return;
        }
        const res = yield requestHelper.confirmForgotPassword({ email, code, newPassword: password });
        if (res.status === 200) {
            setCurrentState('LOGIN');
            setSubmittedNewPassword(false);
            return;
        }
        if (!res.data.message) {
            setError(i18n.t('error'));
            setSubmittedNewPassword(false);
            return;
        }
        if (res.data.message.includes('ExpiredCodeException') || res.data.message.includes('Invalid reset code')) {
            setError(i18n.t('invalid_reset_code'));
            setSubmittedNewPassword(false);
            return;
        }
        setError(i18n.t(res.data.message));
        setSubmittedNewPassword(false);
    });
    return (React__default.createElement(Box, { sx: { alignItems: 'center', width: '100%' } },
        React__default.createElement("form", { onSubmit: handleConfirmForgotPassword },
            React__default.createElement(FormControl, { sx: { alignItems: 'center', width: '100%' } },
                React__default.createElement("div", { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', margin: '0 0 16px 0' } },
                    React__default.createElement(Typography, { align: "left", sx: { width: '50%', fontSize: '20px', fontWeight: 'bold', paddingBottom: '10px', color: colors.slate10 } }, i18n.t('reset_password')),
                    React__default.createElement(Typography, { align: "right", sx: { width: '50%', fontSize: '14px', color: colors.slate10 } }, i18n.t('step_2_of_2'))),
                React__default.createElement(Typography, { align: "left", sx: { width: '100%', mb: '24px', fontSize: '14px', color: colors.slate10 } },
                    React__default.createElement("span", { dangerouslySetInnerHTML: { __html: i18n.t('enter_password_reset_code').replace('[email]', `<strong>${email}</strong>`) } })),
                React__default.createElement(TextField, { label: i18n.t('reset_code'), id: "code-field", variant: "outlined", value: code, onChange: event => setCode(event.target.value), sx: Object.assign({}, TextFieldStyling({ mb: '24px',
                        width: '100%',
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderColor: error ? 'red' : 'default',
                                borderRadius: '5px', // Set border radius to 5px
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: 'default',
                            },
                        }, })) }),
                React__default.createElement(PasswordField, { id: 'new-password', password: password, setPassword: setPassword, sx: Object.assign({}, TextFieldStyling({ mb: '5px',
                        width: '100%',
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderColor: error ? 'red' : 'default',
                                borderRadius: '5px', // Set border radius to 5px
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: 'default',
                            },
                        }, })) }),
                React__default.createElement(Typography, { align: "center", sx: { width: '100%', mb: '24px', fontSize: '14px', color: colors.slate10 } }, i18n.t('password_minimum_requirements_shortened')),
                React__default.createElement(PasswordField, { id: 'confirm-new-password', password: confirmedPassword, setPassword: setConfirmedPassword, label: "repeat-new-password", sx: Object.assign({}, TextFieldStyling({ mb: '24px',
                        width: '100%',
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderColor: error ? 'red' : 'default',
                                borderRadius: '5px', // Set border radius to 5px
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: 'default',
                            },
                        }, })) }),
                React__default.createElement(ErrorPrompt, { message: error, id: "login-error", noIcon: true, sx: { maxWidth: '260px', marginTop: '10px' } }),
                React__default.createElement(RTButton, { id: 'set-password-button', disabled: submittedNewPassword, isSubmit: true, type: "primary", text: i18n.t('reset_password'), isLoading: submittedNewPassword, sx: { marginTop: '40px' } }),
                React__default.createElement(RTButton, { id: 'cancel-button', type: "secondary", onClick: () => setCurrentState('LOGIN'), sx: { marginTop: '10px' }, text: i18n.t('cancel') })))));
};

const themeStyles = {
    palette: {
        primary: {
            main: colors.primary80Black,
            light: colors.primaryLight,
            dark: colors.primaryDark,
        },
        secondary: {
            main: colors.secondaryMain,
            light: colors.secondaryLight,
            dark: colors.secondaryDark,
        },
        error: {
            main: colors.error,
        },
        warning: {
            main: colors.warningYellow,
        },
        info: {
            main: colors.infoBlue,
        },
        success: {
            main: colors.successGreen,
        },
        common: Object.assign({}, colors),
    },
    typography: {
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            'Segoe UI',
            'Oxygen',
            'Ubuntu',
            'Cantarell',
            'Fira Sans',
            'Droid Sans',
            'Helvetica Neue',
            'sans-serif',
        ].join(','),
        display1: {
            fontSize: '64px',
            letterSpacing: '-0.5px',
            fontWeight: 400,
            lineHeight: '76px',
        },
        display2: {
            fontSize: '57px',
            letterSpacing: '-0.25px',
            fontWeight: 400,
            lineHeight: '64px',
        },
        display3: {
            fontSize: '45px',
            fontWeight: 400,
            lineHeight: '52px',
            letterSpacing: '0px',
        },
        h1: {
            fontSize: '36px',
            fontWeight: 400,
            lineHeight: '44px',
            letterSpacing: '0px',
        },
        h2: {
            fontSize: '32px',
            fontWeight: 400,
            lineHeight: '40px',
            letterSpacing: '0px',
        },
        h3: {
            fontSize: '28px',
            letterSpacing: '-0.01em',
            fontWeight: 400,
            lineHeight: '36px',
        },
        h4: {
            fontSize: '24px',
            fontWeight: 400,
            lineHeight: '32px',
            letterSpacing: '0px',
        },
        h5: {
            fontSize: '22px',
            fontWeight: 400,
            lineHeight: '28px',
            letterSpacing: '0px',
        },
        h6: {
            fontSize: '18px',
            fontWeight: 400,
            lineHeight: '24px',
            letterSpacing: '0px',
        },
        subhead1: {
            fontSize: '16px',
            letterSpacing: '0.1px',
            fontWeight: 600,
            lineHeight: '24px',
        },
        subhead2: {
            fontSize: '14px',
            letterSpacing: '0.1px',
            fontWeight: 600,
            lineHeight: '20px',
        },
        button: {
            fontSize: '14px',
            letterSpacing: '0.1px',
            fontWeight: 600,
            lineHeight: '20px',
            textTransform: 'none',
        },
        bodyOne: {
            fontSize: '16px',
            letterSpacing: '0.5px',
            fontWeight: 400,
            lineHeight: '24px',
        },
        bodyTwo: {
            fontSize: '14px',
            letterSpacing: '0.25px',
            fontWeight: 400,
            lineHeight: '20px',
        },
        caption: {
            fontSize: '12px',
            letterSpacing: '0.4px',
            fontWeight: 400,
            lineHeight: '16px',
        },
        tableHeader: {
            fontSize: '16px',
            fontWeight: 600,
            lineHeight: '24px',
            fontStretch: '85%',
            letterSpacing: '0px',
        },
        tableCell: {
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '24px',
            fontStretch: '85%',
            letterSpacing: '0px',
        },
        overline: {
            fontSize: '12px',
            letterSpacing: '0.5px',
            fontWeight: 600,
            lineHeight: '16px',
        },
        labelSmall: {
            fontSize: '11px',
            letterSpacing: '0.5px',
            fontWeight: 600,
            lineHeight: '16px',
        },
        displayL: {
            fontSize: '57px',
            letterSpacing: '-2px',
            fontWeight: 400,
            lineHeight: '64px',
        },
        displayM: {
            fontSize: '45px',
            letterSpacing: '-1px',
            fontWeight: 400,
            lineHeight: '52px',
        },
        displayS: {
            fontSize: '36px',
            letterSpacing: '-0.01em',
            fontWeight: 400,
            lineHeight: '44px',
        },
        headlineL: {
            fontSize: '32px',
            letterSpace: '-0.02em',
            fontWeight: 700,
            lineHeight: '40px',
        },
        headlineM: {
            fontSize: '28px',
            letterSpace: '-0.01em',
            fontWeight: 700,
            lineHeight: '36px',
        },
        headlineS: {
            fontSize: '24px',
            letterSpace: '-0.005em',
            fontWeight: 700,
            lineHeight: '32px',
        },
        titleL: {
            fontSize: '22px',
            letterSpace: '-0.15em',
            fontWeight: 600,
            lineHeight: '28px',
        },
        titleM: {
            fontSize: '16px',
            fontWeight: 600,
            letterSpacing: '0.1px',
            lineHeight: '24px',
        },
        titleS: {
            fontSize: '14px',
            fontWeight: 600,
            letterSpacing: '0.1px',
            lineHeight: '20px',
        },
        labelL: {
            fontSize: '14px',
            fontWeight: 600,
            letterSpacing: '0.1px',
            lineHeight: '20px',
        },
        labelM: {
            fontSize: '12px',
            fontWeight: 600,
            letterSpacing: '0.25px',
            lineHeight: '16px',
        },
        labelS: {
            fontSize: '11px',
            fontWeight: 600,
            letterSpacing: '0.4px',
            lineHeight: '16px',
        },
        bodyL: {
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '24px',
            letterSpacing: '0px',
        },
        bodyM: {
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '20px',
            letterSpacing: '0px',
        },
        bodyS: {
            fontSize: '12px',
            fontWeight: 400,
            letterSpacing: '0.25px',
            lineHeight: '16px',
        },
    },
    components: {
        MuiMenu: {
            styleOverrides: {
                list: {
                    '&[role="menu"]': {
                        backgroundColor: colors.primary90
                    }
                }
            }
        },
    }
};
const theme = createTheme(themeStyles);

var cssUnit = {
    cm: true,
    mm: true,
    in: true,
    px: true,
    pt: true,
    pc: true,
    em: true,
    ex: true,
    ch: true,
    rem: true,
    vw: true,
    vh: true,
    vmin: true,
    vmax: true,
    "%": true,
};
/**
 * If size is a number, append px to the value as default unit.
 * If size is a string, validate against list of valid units.
 * If unit is valid, return size as is.
 * If unit is invalid, console warn issue, replace with px as the unit.
 *
 * @param {(number | string)} size
 * @return {LengthObject} LengthObject
 */
function parseLengthAndUnit(size) {
    if (typeof size === "number") {
        return {
            value: size,
            unit: "px",
        };
    }
    var value;
    var valueString = (size.match(/^[0-9.]*/) || "").toString();
    if (valueString.includes(".")) {
        value = parseFloat(valueString);
    }
    else {
        value = parseInt(valueString, 10);
    }
    var unit = (size.match(/[^0-9]*$/) || "").toString();
    if (cssUnit[unit]) {
        return {
            value: value,
            unit: unit,
        };
    }
    console.warn("React Spinners: ".concat(size, " is not a valid css value. Defaulting to ").concat(value, "px."));
    return {
        value: value,
        unit: "px",
    };
}
/**
 * Take value as an input and return valid css value
 *
 * @param {(number | string)} value
 * @return {string} valid css value
 */
function cssValue(value) {
    var lengthWithunit = parseLengthAndUnit(value);
    return "".concat(lengthWithunit.value).concat(lengthWithunit.unit);
}

var createAnimation = function (loaderName, frames, suffix) {
    var animationName = "react-spinners-".concat(loaderName, "-").concat(suffix);
    if (typeof window == "undefined" || !window.document) {
        return animationName;
    }
    var styleEl = document.createElement("style");
    document.head.appendChild(styleEl);
    var styleSheet = styleEl.sheet;
    var keyFrames = "\n    @keyframes ".concat(animationName, " {\n      ").concat(frames, "\n    }\n  ");
    if (styleSheet) {
        styleSheet.insertRule(keyFrames, 0);
    }
    return animationName;
};

var BasicColors;
(function (BasicColors) {
    BasicColors["maroon"] = "#800000";
    BasicColors["red"] = "#FF0000";
    BasicColors["orange"] = "#FFA500";
    BasicColors["yellow"] = "#FFFF00";
    BasicColors["olive"] = "#808000";
    BasicColors["green"] = "#008000";
    BasicColors["purple"] = "#800080";
    BasicColors["fuchsia"] = "#FF00FF";
    BasicColors["lime"] = "#00FF00";
    BasicColors["teal"] = "#008080";
    BasicColors["aqua"] = "#00FFFF";
    BasicColors["blue"] = "#0000FF";
    BasicColors["navy"] = "#000080";
    BasicColors["black"] = "#000000";
    BasicColors["gray"] = "#808080";
    BasicColors["silver"] = "#C0C0C0";
    BasicColors["white"] = "#FFFFFF";
})(BasicColors || (BasicColors = {}));

var __assign$m = (undefined && undefined.__assign) || function () {
    __assign$m = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$m.apply(this, arguments);
};
(undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
createAnimation("BarLoader", "0% {left: -35%;right: 100%} 60% {left: 100%;right: -90%} 100% {left: 100%;right: -90%}", "long");
createAnimation("BarLoader", "0% {left: -200%;right: 100%} 60% {left: 107%;right: -8%} 100% {left: 107%;right: -8%}", "short");

var __assign$l = (undefined && undefined.__assign) || function () {
    __assign$l = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$l.apply(this, arguments);
};
(undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
createAnimation("BeatLoader", "50% {transform: scale(0.75);opacity: 0.2} 100% {transform: scale(1);opacity: 1}", "beat");

var __assign$k = (undefined && undefined.__assign) || function () {
    __assign$k = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$k.apply(this, arguments);
};
(undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
createAnimation("BounceLoader", "0% {transform: scale(0)} 50% {transform: scale(1.0)} 100% {transform: scale(0)}", "bounce");

var __assign$j = (undefined && undefined.__assign) || function () {
    __assign$j = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$j.apply(this, arguments);
};
(undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
createAnimation("CircleLoader", "0% {transform: rotate(0deg)} 50% {transform: rotate(180deg)} 100% {transform: rotate(360deg)}", "circle");

var __assign$i = (undefined && undefined.__assign) || function () {
    __assign$i = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$i.apply(this, arguments);
};
(undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
createAnimation("ClimbingBoxLoader", "0% {transform:translate(0, -1em) rotate(-45deg)}\n  5% {transform:translate(0, -1em) rotate(-50deg)}\n  20% {transform:translate(1em, -2em) rotate(47deg)}\n  25% {transform:translate(1em, -2em) rotate(45deg)}\n  30% {transform:translate(1em, -2em) rotate(40deg)}\n  45% {transform:translate(2em, -3em) rotate(137deg)}\n  50% {transform:translate(2em, -3em) rotate(135deg)}\n  55% {transform:translate(2em, -3em) rotate(130deg)}\n  70% {transform:translate(3em, -4em) rotate(217deg)}\n  75% {transform:translate(3em, -4em) rotate(220deg)}\n  100% {transform:translate(0, -1em) rotate(-225deg)}", "climbingBox");

var __assign$h = (undefined && undefined.__assign) || function () {
    __assign$h = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$h.apply(this, arguments);
};
(undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
createAnimation("ClipLoader", "0% {transform: rotate(0deg) scale(1)} 50% {transform: rotate(180deg) scale(0.8)} 100% {transform: rotate(360deg) scale(1)}", "clip");

var __assign$g = (undefined && undefined.__assign) || function () {
    __assign$g = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$g.apply(this, arguments);
};
(undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
createAnimation("ClockLoader", "100% { transform: rotate(360deg) }", "rotate");

var __assign$f = (undefined && undefined.__assign) || function () {
    __assign$f = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$f.apply(this, arguments);
};
(undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
createAnimation("DotLoader", "100% {transform: rotate(360deg)}", "rotate");
createAnimation("DotLoader", "0%, 100% {transform: scale(0)} 50% {transform: scale(1.0)}", "bounce");

var __assign$e = (undefined && undefined.__assign) || function () {
    __assign$e = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$e.apply(this, arguments);
};
(undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
createAnimation("FadeLoader", "50% {opacity: 0.3} 100% {opacity: 1}", "fade");

var __assign$d = (undefined && undefined.__assign) || function () {
    __assign$d = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$d.apply(this, arguments);
};
(undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
createAnimation("GridLoader", "0% {transform: scale(1)} 50% {transform: scale(0.5); opacity: 0.7} 100% {transform: scale(1); opacity: 1}", "grid");

var __assign$c = (undefined && undefined.__assign) || function () {
    __assign$c = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$c.apply(this, arguments);
};
(undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};

var __assign$b = (undefined && undefined.__assign) || function () {
    __assign$b = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$b.apply(this, arguments);
};
(undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
createAnimation("MoonLoader", "100% {transform: rotate(360deg)}", "moon");

var __assign$a = (undefined && undefined.__assign) || function () {
    __assign$a = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$a.apply(this, arguments);
};
(undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
[
    createAnimation("PacmanLoader", "0% {transform: rotate(0deg)} 50% {transform: rotate(-44deg)}", "pacman-1"),
    createAnimation("PacmanLoader", "0% {transform: rotate(0deg)} 50% {transform: rotate(44deg)}", "pacman-2"),
];

var __assign$9 = (undefined && undefined.__assign) || function () {
    __assign$9 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$9.apply(this, arguments);
};
(undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// 1.5 4.5 7.5
var distance = [1, 3, 5];
[
    createAnimation("PropagateLoader", "25% {transform: translateX(-".concat(distance[0], "rem) scale(0.75)}\n    50% {transform: translateX(-").concat(distance[1], "rem) scale(0.6)}\n    75% {transform: translateX(-").concat(distance[2], "rem) scale(0.5)}\n    95% {transform: translateX(0rem) scale(1)}"), "propogate-0"),
    createAnimation("PropagateLoader", "25% {transform: translateX(-".concat(distance[0], "rem) scale(0.75)}\n    50% {transform: translateX(-").concat(distance[1], "rem) scale(0.6)}\n    75% {transform: translateX(-").concat(distance[1], "rem) scale(0.6)}\n    95% {transform: translateX(0rem) scale(1)}"), "propogate-1"),
    createAnimation("PropagateLoader", "25% {transform: translateX(-".concat(distance[0], "rem) scale(0.75)}\n    75% {transform: translateX(-").concat(distance[0], "rem) scale(0.75)}\n    95% {transform: translateX(0rem) scale(1)}"), "propogate-2"),
    createAnimation("PropagateLoader", "25% {transform: translateX(".concat(distance[0], "rem) scale(0.75)}\n    75% {transform: translateX(").concat(distance[0], "rem) scale(0.75)}\n    95% {transform: translateX(0rem) scale(1)}"), "propogate-3"),
    createAnimation("PropagateLoader", "25% {transform: translateX(".concat(distance[0], "rem) scale(0.75)}\n    50% {transform: translateX(").concat(distance[1], "rem) scale(0.6)}\n    75% {transform: translateX(").concat(distance[1], "rem) scale(0.6)}\n    95% {transform: translateX(0rem) scale(1)}"), "propogate-4"),
    createAnimation("PropagateLoader", "25% {transform: translateX(".concat(distance[0], "rem) scale(0.75)}\n    50% {transform: translateX(").concat(distance[1], "rem) scale(0.6)}\n    75% {transform: translateX(").concat(distance[2], "rem) scale(0.5)}\n    95% {transform: translateX(0rem) scale(1)}"), "propogate-5"),
];

var __assign$8 = (undefined && undefined.__assign) || function () {
    __assign$8 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$8.apply(this, arguments);
};
(undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
createAnimation("PulseLoader", "0% {transform: scale(1); opacity: 1} 45% {transform: scale(0.1); opacity: 0.7} 80% {transform: scale(1); opacity: 1}", "pulse");

var __assign$7 = (undefined && undefined.__assign) || function () {
    __assign$7 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$7.apply(this, arguments);
};
(undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
[
    createAnimation("PuffLoader", "0% {transform: scale(0)} 100% {transform: scale(1.0)}", "puff-1"),
    createAnimation("PuffLoader", "0% {opacity: 1} 100% {opacity: 0}", "puff-2"),
];

var __assign$6 = (undefined && undefined.__assign) || function () {
    __assign$6 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$6.apply(this, arguments);
};
(undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
createAnimation("RingLoader", "0% {transform: rotateX(0deg) rotateY(0deg) rotateZ(0deg)} 100% {transform: rotateX(180deg) rotateY(360deg) rotateZ(360deg)}", "right");
createAnimation("RingLoader", "0% {transform: rotateX(0deg) rotateY(0deg) rotateZ(0deg)} 100% {transform: rotateX(360deg) rotateY(180deg) rotateZ(360deg)}", "left");

var __assign$5 = (undefined && undefined.__assign) || function () {
    __assign$5 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$5.apply(this, arguments);
};
(undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};

var __assign$4 = (undefined && undefined.__assign) || function () {
    __assign$4 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$4.apply(this, arguments);
};
(undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
createAnimation("RotateLoader", "0% {transform: rotate(0deg)} 50% {transform: rotate(180deg)} 100% {transform: rotate(360deg)}", "rotate");

var __assign$3 = (undefined && undefined.__assign) || function () {
    __assign$3 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$3.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var scale = createAnimation("ScaleLoader", "0% {transform: scaley(1.0)} 50% {transform: scaley(0.4)} 100% {transform: scaley(1.0)}", "scale");
function ScaleLoader(_a) {
    var _b = _a.loading, loading = _b === void 0 ? true : _b, _c = _a.color, color = _c === void 0 ? "#000000" : _c, _d = _a.speedMultiplier, speedMultiplier = _d === void 0 ? 1 : _d, _e = _a.cssOverride, cssOverride = _e === void 0 ? {} : _e, _f = _a.height, height = _f === void 0 ? 35 : _f, _g = _a.width, width = _g === void 0 ? 4 : _g, _h = _a.radius, radius = _h === void 0 ? 2 : _h, _j = _a.margin, margin = _j === void 0 ? 2 : _j, additionalprops = __rest(_a, ["loading", "color", "speedMultiplier", "cssOverride", "height", "width", "radius", "margin"]);
    var wrapper = __assign$3({ display: "inherit" }, cssOverride);
    var style = function (i) {
        return {
            backgroundColor: color,
            width: cssValue(width),
            height: cssValue(height),
            margin: cssValue(margin),
            borderRadius: cssValue(radius),
            display: "inline-block",
            animation: "".concat(scale, " ").concat(1 / speedMultiplier, "s ").concat(i * 0.1, "s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08)"),
            animationFillMode: "both",
        };
    };
    if (!loading) {
        return null;
    }
    return (React.createElement("span", __assign$3({ style: wrapper }, additionalprops),
        React.createElement("span", { style: style(1) }),
        React.createElement("span", { style: style(2) }),
        React.createElement("span", { style: style(3) }),
        React.createElement("span", { style: style(4) }),
        React.createElement("span", { style: style(5) })));
}

var __assign$2 = (undefined && undefined.__assign) || function () {
    __assign$2 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$2.apply(this, arguments);
};
(undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
createAnimation("SkewLoader", "25% {transform: perspective(100px) rotateX(180deg) rotateY(0)} 50% {transform: perspective(100px) rotateX(180deg) rotateY(180deg)} 75% {transform: perspective(100px) rotateX(0) rotateY(180deg)} 100% {transform: perspective(100px) rotateX(0) rotateY(0)}", "skew");

var __assign$1 = (undefined && undefined.__assign) || function () {
    __assign$1 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};
(undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
createAnimation("SquareLoader", "25% {transform: rotateX(180deg) rotateY(0)}\n  50% {transform: rotateX(180deg) rotateY(180deg)} \n  75% {transform: rotateX(0) rotateY(180deg)} \n  100% {transform: rotateX(0) rotateY(0)}", "square");

var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
(undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
createAnimation("SyncLoader", "33% {transform: translateY(10px)}\n  66% {transform: translateY(-10px)}\n  100% {transform: translateY(0)}", "sync");

const LogoFull = ({ sx }) => (React__default.createElement(Box, { sx: sx },
    React__default.createElement("span", { dangerouslySetInnerHTML: { __html: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="Layer_1" data-name="Layer 1" viewBox="0 0 605.35 152.71"><defs><style>.cls-1{fill:none;clip-rule:evenodd;}.cls-2{fill:#58dbb9;fill-rule:evenodd;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#4ebba1;}.cls-5{fill:#474242;}</style><clipPath id="clip-path"><path class="cls-1" d="M70.08,2.91h1.64c.42.08.85.16,1.26.26a8.53,8.53,0,0,1,6.42,8.32q0,18.48,0,37v.46H90.29v-.46q0-8.21,0-16.41a12.23,12.23,0,0,1,.08-1.48,8.39,8.39,0,0,1,16.69,1.31q0,20.33,0,40.64V73h11v-.46q0-10.64,0-21.26a9.57,9.57,0,0,1,.16-1.85A8.53,8.53,0,0,1,134.51,48a20.94,20.94,0,0,1,.61,2.36v50.35c-.05.25-.1.5-.14.76A8.54,8.54,0,0,1,118,99.8V78h-11v.51q0,20.26,0,40.54a10.5,10.5,0,0,1-.09,1.48,8.39,8.39,0,0,1-16.69-1.4V53.87H79.4v85.6a8.53,8.53,0,0,1-6.71,8.46l-1,.2H70.08c-.33-.06-.66-.11-1-.18a8.55,8.55,0,0,1-6.78-8.46V108.17H50.69v.46q0,5.25,0,10.48a8.93,8.93,0,0,1-.09,1.37,8.39,8.39,0,0,1-16.68-1.33q0-25.65,0-51.3v-.47H22.42v.5q0,15.93,0,31.84a9.78,9.78,0,0,1-.14,1.71,8.53,8.53,0,0,1-16.48,1.2c-.2-.63-.3-1.29-.45-1.94V50.34c0-.25.1-.5.14-.75a8.54,8.54,0,0,1,16.94,1.65V62.41H33.9v-.5q0-14.92,0-29.87c0-.41,0-.82.06-1.22a8.39,8.39,0,0,1,16.72,1.05V103.2H62.32V11.54a8.49,8.49,0,0,1,5.5-8.06A18.68,18.68,0,0,1,70.08,2.91Z"></path></clipPath></defs><title>logo-full</title><path class="cls-2" d="M70.08,2.91h1.64c.42.08.85.16,1.26.26a8.53,8.53,0,0,1,6.42,8.32q0,18.48,0,37v.46H90.29v-.46q0-8.21,0-16.41a12.23,12.23,0,0,1,.08-1.48,8.39,8.39,0,0,1,16.69,1.31q0,20.33,0,40.64V73h11v-.46q0-10.64,0-21.26a9.57,9.57,0,0,1,.16-1.85A8.53,8.53,0,0,1,134.51,48a20.94,20.94,0,0,1,.61,2.36v50.35c-.05.25-.1.5-.14.76A8.54,8.54,0,0,1,118,99.8V78h-11v.51q0,20.26,0,40.54a10.5,10.5,0,0,1-.09,1.48,8.39,8.39,0,0,1-16.69-1.4V53.87H79.4v85.6a8.53,8.53,0,0,1-6.71,8.46l-1,.2H70.08c-.33-.06-.66-.11-1-.18a8.55,8.55,0,0,1-6.78-8.46V108.17H50.69v.46q0,5.25,0,10.48a8.93,8.93,0,0,1-.09,1.37,8.39,8.39,0,0,1-16.68-1.33q0-25.65,0-51.3v-.47H22.42v.5q0,15.93,0,31.84a9.78,9.78,0,0,1-.14,1.71,8.53,8.53,0,0,1-16.48,1.2c-.2-.63-.3-1.29-.45-1.94V50.34c0-.25.1-.5.14-.75a8.54,8.54,0,0,1,16.94,1.65V62.41H33.9v-.5q0-14.92,0-29.87c0-.41,0-.82.06-1.22a8.39,8.39,0,0,1,16.72,1.05V103.2H62.32V11.54a8.49,8.49,0,0,1,5.5-8.06A18.68,18.68,0,0,1,70.08,2.91Z"></path><g class="cls-3"><rect class="cls-4" x="-115.66" y="74.16" width="306.67" height="133.33" transform="translate(75.46 0.03) rotate(30)"></rect></g><path class="cls-5" d="M183.18,76.05H168.27v36.28a4.43,4.43,0,0,1-8.85,0V32.82a5.84,5.84,0,0,1,5.94-5.94h22.5q11,0,17.7,6.7,6.94,7,6.95,18.33,0,9.74-5.31,16a22.45,22.45,0,0,1-14.41,7.71l19.59,34.64a4,4,0,0,1,.51,2,4.3,4.3,0,0,1-.57,2.15,4.54,4.54,0,0,1-1.58,1.65,4,4,0,0,1-5.81-1.65Zm4.43-8.47c5,0,9-1.34,11.88-4s4.17-6.49,4.17-11.63A21.6,21.6,0,0,0,202.59,45a13.47,13.47,0,0,0-3.23-5.31q-4.29-4.3-11.75-4.3H168.27V67.58Z"></path><path class="cls-5" d="M271.54,92.36a26.82,26.82,0,0,1-1.77,9.92,22.62,22.62,0,0,1-4.93,7.71,21.63,21.63,0,0,1-7.64,5,28.71,28.71,0,0,1-19.85,0,21.76,21.76,0,0,1-7.65-5,22.62,22.62,0,0,1-4.93-7.71A26.82,26.82,0,0,1,223,92.36V75.3a26.83,26.83,0,0,1,1.77-9.93,22.81,22.81,0,0,1,4.93-7.71,21.74,21.74,0,0,1,7.65-5,28.71,28.71,0,0,1,19.85,0,21.61,21.61,0,0,1,7.64,5,22.81,22.81,0,0,1,4.93,7.71,26.83,26.83,0,0,1,1.77,9.93ZM263,74.66q0-7.45-4.11-11.63t-11.57-4.17q-7.46,0-11.56,4.17T231.6,74.66V93q0,7.47,4.11,11.63t11.56,4.17q7.46,0,11.57-4.17T263,93Z"></path><path class="cls-5" d="M319.2,55.2a4.3,4.3,0,0,1,8.6,0V108a5.89,5.89,0,0,1-3.92,5.56,64.06,64.06,0,0,1-9.36,2.34,58.44,58.44,0,0,1-9.73.82q-10.76,0-16.94-6.26t-6.19-16.88V55.2a4.3,4.3,0,1,1,8.59,0V94.26q0,6.83,3.86,10.68t10.68,3.85a49.09,49.09,0,0,0,14.41-2.15Z"></path><path class="cls-5" d="M340.44,29.91a4.3,4.3,0,0,1,8.59,0V52.16h14.54a4.1,4.1,0,0,1,4.17,4.17,3.84,3.84,0,0,1-1.2,2.91,4.15,4.15,0,0,1-3,1.14H349V99.69a8.63,8.63,0,0,0,2.34,6.39,7.66,7.66,0,0,0,5.63,2.33,30.9,30.9,0,0,0,3.53-.25,29.72,29.72,0,0,1,3.17-.25,4.31,4.31,0,0,1,2.71,1.07,3.61,3.61,0,0,1,1.33,3,4.27,4.27,0,0,1-.95,2.72,3.92,3.92,0,0,1-2.59,1.46c-1.18.16-2.38.31-3.6.44s-2.42.19-3.6.19a16.46,16.46,0,0,1-6.45-1.27A15.6,15.6,0,0,1,345.3,112a17.31,17.31,0,0,1-3.54-5.49,18.36,18.36,0,0,1-1.32-7Z"></path><path class="cls-5" d="M385.18,86.55v7.07q0,6.84,3.86,11t10.68,4.17a27.08,27.08,0,0,0,7.4-1,49.66,49.66,0,0,0,7-2.53,4.5,4.5,0,0,1,1.77-.37,4.39,4.39,0,0,1,3,1.13,3.75,3.75,0,0,1,1.26,2.91,3.9,3.9,0,0,1-2.4,3.79,36.17,36.17,0,0,1-8.79,3.1,45,45,0,0,1-9.29,1,25.39,25.39,0,0,1-9.48-1.71,21.37,21.37,0,0,1-7.33-4.74,20.64,20.64,0,0,1-4.68-7.27,25.73,25.73,0,0,1-1.64-9.42V74a25.8,25.8,0,0,1,1.64-9.42,20.82,20.82,0,0,1,4.68-7.27,21.37,21.37,0,0,1,7.33-4.74,25.59,25.59,0,0,1,9.48-1.7,25.16,25.16,0,0,1,9.42,1.7,21.7,21.7,0,0,1,7.27,4.74,20.8,20.8,0,0,1,4.67,7.27A25.8,25.8,0,0,1,422.73,74V80.6a5.84,5.84,0,0,1-5.94,6ZM414.13,73.4q0-6.83-3.79-10.68t-10.62-3.86q-6.83,0-10.68,3.86T385.18,73.4v5.18h28.95Z"></path><path class="cls-5" d="M440.8,35.35H420a4.24,4.24,0,0,1-3-1.2,3.94,3.94,0,0,1-1.26-3,4.3,4.3,0,0,1,4.3-4.3h50.69a4.3,4.3,0,0,1,4.29,4.3,3.94,3.94,0,0,1-1.26,3,4.24,4.24,0,0,1-3,1.2h-21v77a4.55,4.55,0,0,1-4.42,4.43,4.55,4.55,0,0,1-4.43-4.43Z"></path><path class="cls-5" d="M522.59,73.4q0-6.83-3.79-10.68t-10.62-3.86a20.53,20.53,0,0,0-14.54,5.69v47.91a4.3,4.3,0,0,1-8.59,0V29.91a4.3,4.3,0,0,1,8.59,0V54.69a33,33,0,0,1,7-2.78,28.52,28.52,0,0,1,7.58-1,25.16,25.16,0,0,1,9.42,1.7,21.7,21.7,0,0,1,7.27,4.74,20.8,20.8,0,0,1,4.67,7.27A25.8,25.8,0,0,1,531.19,74v38.43a4.3,4.3,0,0,1-8.6,0Z"></path><path class="cls-5" d="M547,37.12a5.41,5.41,0,0,1-4-1.71,5.72,5.72,0,0,1-1.64-4.11,5.69,5.69,0,1,1,11.38,0A5.69,5.69,0,0,1,551,35.41,5.37,5.37,0,0,1,547,37.12Zm-4.3,18.08a4.3,4.3,0,0,1,8.6,0v57.26a4.3,4.3,0,0,1-8.6,0Z"></path><path class="cls-5" d="M573.79,84.14a21.44,21.44,0,0,1-7.72-5.62q-3.29-3.73-3.28-10.43A15.2,15.2,0,0,1,564.43,61a17.24,17.24,0,0,1,4.43-5.44,19.72,19.72,0,0,1,6.51-3.47,25.61,25.61,0,0,1,7.9-1.2,36.48,36.48,0,0,1,8.4.88,43.71,43.71,0,0,1,7,2.28,4.21,4.21,0,0,1,2.65,4A3.57,3.57,0,0,1,600.08,61a4.54,4.54,0,0,1-3,1.07,4.09,4.09,0,0,1-1.65-.38,30.66,30.66,0,0,0-13.14-2.78,14.6,14.6,0,0,0-3.8.51A12.14,12.14,0,0,0,575,60.88a7.81,7.81,0,0,0-3.61,6.83,7.71,7.71,0,0,0,2.09,5.81,13.62,13.62,0,0,0,4.23,2.91l11.89,4.81a21.8,21.8,0,0,1,9.16,6.63,15.85,15.85,0,0,1,3.48,10.18,18,18,0,0,1-5.75,13.27,20,20,0,0,1-6.45,4,21.9,21.9,0,0,1-8,1.46,39.44,39.44,0,0,1-9-1,36.93,36.93,0,0,1-7.71-2.72,4,4,0,0,1-2.53-3.92,3.8,3.8,0,0,1,1.2-2.9,4.31,4.31,0,0,1,3.1-1.14,2.93,2.93,0,0,1,.88.12c.25.09.55.22.89.38a39.22,39.22,0,0,0,6.38,2.28,27.82,27.82,0,0,0,7.14.88,13.08,13.08,0,0,0,7.84-2.46,8,8,0,0,0,3.41-6.89,9.36,9.36,0,0,0-2-6.32,16.65,16.65,0,0,0-6-4.05Z"></path></svg>` } })));

const LoginBox = ({ children, isLoading }) => (React.createElement(ThemeProvider, { theme: theme },
    React.createElement(Box, { sx: {
            backgroundColor: 'white',
            width: '650px',
            minHeight: '375px',
            borderRadius: 17,
            boxShadow: '0 2px 2.62px black',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            mr: '16px',
            ml: '16px',
            pl: { xs: '16px', sm: '16px', md: '96px' },
            pr: { xs: '16px', sm: '16px', md: '96px' },
            pt: { xs: '80px', sm: '80px', md: '80px' },
            pb: { xs: '80px', sm: '80px', md: '80px' }
        } }, isLoading ? React.createElement(ScaleLoader, { color: colors.primary80 }) :
        React.createElement(FormGroup, { sx: { flexGrow: '1' } },
            React.createElement(Box, null,
                React.createElement(LogoFull, { sx: { maxWidth: 180,
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        marginBottom: '53px',
                        display: 'block' } })),
            children))));

function castLoginComponents(components) {
    return components;
}
function useLogin(apiUrl, { userCallback, defaultCurrentState, loginComponents, locale }) {
    // the creation of loginComponents should always be a global variable (created outside of react) and should not change
    // to ensure this we cache the initial value, just in case some accidentally creates the object inside react
    const LoginComponents = useMemo(() => loginComponents, [loginComponents]);
    const requestHelper = RequestHelper.getInstance(apiUrl);
    const [loading, setLoading] = useState(false);
    const [currentState, setCurrentState] = useState('');
    const [email, setEmail] = useState('');
    const [sessionToken, setSessionToken] = useState('');
    const onLoginCallback = useCallback((info) => {
        if (currentState === '') {
            // should never be called in default state
            return;
        }
        // TODO: not sure why typescript is not inferring the exclusion of '' here
        userCallback(currentState, info);
    }, [userCallback, currentState]);
    useEffect(() => {
        TranslationHelper.getInstance(locale);
        if (currentState === '') {
            setCurrentState(defaultCurrentState);
        }
    }, [locale, currentState, defaultCurrentState]);
    const loginApi = useMemo(() => ({
        setLoading,
        requestHelper,
        setCurrentState,
        setEmail,
        email,
        sessionToken,
        setSessionToken
    }), [
        setLoading,
        requestHelper,
        setCurrentState,
        setEmail,
        email,
        sessionToken,
        setSessionToken
    ]);
    const StateComponent = LoginComponents[currentState];
    // this function is for typing so we'll memoize the function as it will never change
    const createProps = useCallback((props) => props, []);
    return {
        loginApi,
        loading,
        currentState,
        onLoginCallback,
        StateComponent,
        createProps
    };
}

const ForceChangePassword = ({ setCurrentState, email, apiUrl, onLoginCompleteCallback, sessionToken, }) => {
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');
    const [error, setError] = useState('');
    const [passwordFormSubmitted, setPasswordFormSubmitted] = useState(false);
    const { i18n } = useAuth$1();
    const requestHelper = RequestHelper.getInstance(apiUrl);
    const handleSubmit = (event) => __awaiter$1(void 0, void 0, void 0, function* () {
        event.preventDefault();
        setPasswordFormSubmitted(true);
        if (!newPassword || newPassword.length === 0) {
            setError(i18n.t('must_enter_new_password'));
            setPasswordFormSubmitted(false);
            return;
        }
        if (newPassword.trim().length < 8 ||
            !/[A-Z]/.test(newPassword) ||
            !/[0-9]/.test(newPassword)) {
            setError(i18n.t('password_minimum_requirements_shortened'));
            setPasswordFormSubmitted(false);
            return;
        }
        if (newPassword !== confirmNewPassword) {
            setError(i18n.t('passwords_must_match'));
            setPasswordFormSubmitted(false);
            return;
        }
        const loginRes = yield requestHelper.challengeResponse({ email, newPassword, sessionToken });
        if (loginRes.status === 200) {
            yield onLoginCompleteCallback();
            setPasswordFormSubmitted(false);
            setCurrentState('LOGIN');
            return;
        }
        setError(loginRes.data.message || "Something went wrong, please try again");
        setPasswordFormSubmitted(false);
    });
    const handleCancel = () => __awaiter$1(void 0, void 0, void 0, function* () {
        yield onLoginCompleteCallback();
        setPasswordFormSubmitted(false);
        setCurrentState('LOGIN');
    });
    return (React__default.createElement(Box$2, { sx: { alignItems: 'center', width: '100%' } },
        React__default.createElement("form", { onSubmit: handleSubmit },
            React__default.createElement(Typography, { sx: { fontSize: '20px', fontWeight: 'bold', marginBottom: '30px', textAlign: 'left' } }, i18n.t('set_new_password')),
            React__default.createElement(FormGroup, { sx: { alignItems: 'center', width: '100%' } },
                React__default.createElement(PasswordField, { id: 'new-password', password: newPassword, setPassword: setNewPassword, label: "new_password", sx: { paddingBottom: '10px', width: '100%', } }),
                React__default.createElement(PasswordField, { id: 'new-password-confirm', password: confirmNewPassword, setPassword: setConfirmNewPassword, label: "confirm_password", sx: { width: '100%', } }),
                error && React__default.createElement(ErrorPrompt, { message: error, id: "change-password-error", noIcon: true, sx: { maxWidth: '260px', marginTop: '10px' } }),
                React__default.createElement(RTButton, { id: 'set-password-button', disabled: passwordFormSubmitted, isSubmit: true, type: "primary", isLoading: passwordFormSubmitted, text: i18n.t('set_password') }))),
        React__default.createElement(RTButton, { id: 'cancel-button', type: "secondary", text: i18n.t('cancel'), onClick: () => handleCancel() })));
};

const LoginComponents = castLoginComponents({
    "": ScaleLoader,
    CONFIRM_FORGOT_PASSWORD: ConfirmForgotPassword,
    FORGOT_PASSWORD: ForgotPassword,
    LOGIN: LoginPassword,
    NEW_PASSWORD_REQUIRED: ForceChangePassword
});
const RTLogin$1 = ({ apiUrl, noBox, onLoginCompleteCallback: userCallback, showSSO, ssoDetails, locale }) => {
    const { currentState, loading, onLoginCallback, loginApi, StateComponent, createProps } = useLogin(apiUrl, {
        userCallback,
        loginComponents: LoginComponents,
        defaultCurrentState: 'LOGIN',
        locale
    });
    const props = createProps({
        "": {
            color: colors.primary80
        },
        CONFIRM_FORGOT_PASSWORD: Object.assign(Object.assign({}, loginApi), { apiUrl,
            showSSO,
            ssoDetails }),
        FORGOT_PASSWORD: Object.assign(Object.assign({}, loginApi), { apiUrl,
            showSSO,
            ssoDetails }),
        LOGIN: Object.assign(Object.assign({}, loginApi), { showSSO,
            ssoDetails,
            apiUrl, onLoginCompleteCallback: onLoginCallback }),
        NEW_PASSWORD_REQUIRED: Object.assign(Object.assign({}, loginApi), { showSSO,
            ssoDetails,
            apiUrl, onLoginCompleteCallback: onLoginCallback })
    });
    if (noBox) {
        return (React__default.createElement(React__default.Fragment, null, loading ? React__default.createElement(ScaleLoader, { color: colors.primary10 }) : React__default.createElement(ThemeProvider, { theme: theme },
            React__default.createElement(StateComponent, Object.assign({}, props[currentState])))));
    }
    return (React__default.createElement(LoginBox, { isLoading: loading },
        React__default.createElement(React__default.Fragment, null,
            React__default.createElement(StateComponent, Object.assign({}, props[currentState])))));
};

const ChangePasswordForm = ({ error, changePasswordHandler, onPasswordChangeCompleteCallback }) => {
    const { i18n } = useAuth$1();
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');
    const [passwordFormSubmitted, setPasswordFormSubmitted] = useState(false);
    const changePassword = (event) => __awaiter$1(void 0, void 0, void 0, function* () {
        setPasswordFormSubmitted(true);
        event.preventDefault();
        yield changePasswordHandler(newPassword, confirmNewPassword, currentPassword);
        setPasswordFormSubmitted(false);
    });
    return (React__default.createElement(Box$2, { sx: { width: '100%' } },
        React__default.createElement("form", { onSubmit: changePassword },
            React__default.createElement(Typography, { sx: { marginBottom: '30px', textAlign: 'center', width: '100%' } }, i18n.t('set_new_password')),
            React__default.createElement(FormGroup, { sx: { width: '100%' } },
                React__default.createElement(PasswordField, { id: "current-password-field", password: currentPassword, setPassword: setCurrentPassword, label: "old_password", sx: { paddingBottom: '10px', width: '100%' } }),
                React__default.createElement(PasswordField, { id: "new-password-field", password: newPassword, setPassword: setNewPassword, label: "new_password", sx: { paddingBottom: '10px', width: '100%' } }),
                React__default.createElement(PasswordField, { id: "confirm-password-field", password: confirmNewPassword, setPassword: setConfirmNewPassword, label: "confirm_password", sx: { width: '100%' } }),
                React__default.createElement(ErrorPrompt, { message: error, id: "change-password-error", noIcon: true, sx: { width: '100%', marginTop: '10px' } }),
                React__default.createElement(RTButton, { id: "change-password-submit-button", disabled: passwordFormSubmitted, isSubmit: true, type: "error", isLoading: passwordFormSubmitted, text: i18n.t('change_password') }))),
        React__default.createElement(RTButton, { id: "change-password-cancel-button", type: "secondary", text: i18n.t('cancel'), onClick: () => onPasswordChangeCompleteCallback() })));
};

const RTChangePassword$1 = ({ apiUrl, onPasswordChangeCompleteCallback, noBox }) => {
    const [error, setError] = useState('');
    const [currentState, setCurrentState] = useState('');
    const requestHelper = RequestHelper.getInstance(apiUrl);
    const { i18n } = useAuth$1();
    useEffect(() => {
        if (currentState === '') {
            setCurrentState('CHANGE_PASSWORD');
        }
    }, [currentState]);
    const changePasswordHandler = (newPassword, confirmNewPassword, currentPassword) => __awaiter$1(void 0, void 0, void 0, function* () {
        if (newPassword !== confirmNewPassword) {
            setError(i18n.t('passwords_must_match'));
            return;
        }
        if (newPassword.trim().length < 8) {
            setError(i18n.t('password_minimum_requirements_shortened'));
            return;
        }
        const res = yield requestHelper.changePassword({ oldPassword: currentPassword, newPassword });
        if (res.status !== 200) {
            setError(i18n.t('password_minimum_requirements_shortened'));
            return;
        }
        yield onPasswordChangeCompleteCallback();
    });
    const renderCurrentState = () => {
        if (currentState === 'CHANGE_PASSWORD') {
            return React__default.createElement(ChangePasswordForm, { error: error, changePasswordHandler: changePasswordHandler, onPasswordChangeCompleteCallback: onPasswordChangeCompleteCallback });
        }
        return React__default.createElement(ScaleLoader, { color: colors.primary80 });
    };
    if (noBox) {
        return (React__default.createElement(React__default.Fragment, null, renderCurrentState()));
    }
    return (React__default.createElement(LoginBox, { isLoading: false },
        React__default.createElement(React__default.Fragment, null, renderCurrentState())));
};

const CheckProvider = ({ setCurrentState, email, setEmail, onLoginCompleteCallback, showSSO, ssoDetails, apiUrl, }) => {
    const [error, setError] = useState('');
    const { i18n } = useAuth$1();
    const [loading, setLoading] = useState(false);
    const requestHelper = RequestHelper.getInstance(apiUrl);
    const handleSubmit = (event) => __awaiter$1(void 0, void 0, void 0, function* () {
        event.preventDefault();
        setLoading(true);
        const loginRes = yield requestHelper.checkSSOProvider({ email, redirectUrl: ssoDetails.postLoginRedirect || '' });
        if (loginRes.status === 200) {
            if (loginRes.data.ssoProvider.name === 'RouteThis') {
                setCurrentState('LOGIN');
                setLoading(false);
                return;
            }
            if (['Google', 'Microsoft'].includes(loginRes.data.ssoProvider.name)) {
                setCurrentState('OAUTH');
                setLoading(false);
                return;
            }
            window.location.href = loginRes.data.ssoProvider.url;
            setLoading(false);
            return;
        }
        setError(i18n.t('login_error_message'));
        setLoading(false);
    });
    return (React__default.createElement(Box$2, null,
        React__default.createElement("form", { onSubmit: handleSubmit },
            React__default.createElement(FormGroup, { sx: { alignItems: 'center', width: '100%' } },
                React__default.createElement(Typography, { variant: "h3", sx: {
                        mb: '32px',
                        mt: '40px',
                        fontSize: '24px',
                        textAlign: 'left',
                        width: '100%',
                        display: { xs: 'none', sm: 'none', md: 'block' }
                    } }, i18n.t('login_title_text')),
                error && React__default.createElement(ActiveAlert, { message: error }),
                React__default.createElement(TextField, { label: i18n.t('email'), id: "email-field", variant: "outlined", value: email === null || email === void 0 ? void 0 : email.trim(), disabled: loading, onChange: event => setEmail(event.target.value), sx: Object.assign({}, TextFieldStyling({
                        mt: '16px',
                        mb: '12px',
                        width: '100%',
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderColor: error ? 'red' : 'default',
                                borderRadius: '5px',
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: 'default',
                                borderRadius: '5px',
                            },
                        },
                    })) }),
                React__default.createElement(RTButton, { id: 'sign-in-button', isLoading: loading, isSubmit: true, type: "primary", text: error ? i18n.t('try_again') : i18n.t('continue'), sx: { mt: '12px', mb: '16px', width: '100%' } }))),
        showSSO &&
            React__default.createElement(Box$2, null,
                React__default.createElement(Box$2, null,
                    React__default.createElement(Box$2, { sx: { display: 'flex', alignItems: 'center', width: '100%', my: '16px' } },
                        React__default.createElement(Box$2, { sx: { flex: 1, height: '1px', bgcolor: 'grey.500' } }),
                        React__default.createElement(Box$2, { sx: { mx: '16px', fontSize: '14px', color: 'grey.700' } }, i18n.t('or')),
                        React__default.createElement(Box$2, { sx: { flex: 1, height: '1px', bgcolor: 'grey.500' } }))),
                React__default.createElement(SSOProviders, { apiUrl: apiUrl, ssoDetails: ssoDetails, onLoginCompleteCallback: onLoginCompleteCallback, setLoading: setLoading }))));
};

const RTLoginSSOFlow$1 = ({ apiUrl, onLoginCompleteCallback: userCallback, noBox, locale, ssoDetails, showSSO }) => {
    const LoginComponents = castLoginComponents({
        "": ScaleLoader,
        CONFIRM_FORGOT_PASSWORD: ConfirmForgotPassword,
        FORGOT_PASSWORD: ForgotPassword,
        LOGIN: LoginPassword,
        CHECK_PROVIDER: CheckProvider,
        NEW_PASSWORD_REQUIRED: ForceChangePassword,
        OAUTH: SSOProviders
    });
    const { currentState, loading, onLoginCallback, loginApi, StateComponent, createProps, } = useLogin(apiUrl, {
        userCallback,
        loginComponents: LoginComponents,
        defaultCurrentState: 'CHECK_PROVIDER',
        locale
    });
    const props = createProps({
        "": {
            color: colors.primary80
        },
        CONFIRM_FORGOT_PASSWORD: Object.assign(Object.assign({}, loginApi), { ssoDetails,
            showSSO,
            apiUrl }),
        FORGOT_PASSWORD: Object.assign(Object.assign({}, loginApi), { apiUrl,
            ssoDetails,
            showSSO }),
        LOGIN: Object.assign(Object.assign({}, loginApi), { showSSO,
            ssoDetails,
            apiUrl, onLoginCompleteCallback: onLoginCallback }),
        CHECK_PROVIDER: Object.assign(Object.assign({}, loginApi), { ssoDetails,
            apiUrl,
            showSSO, onLoginCompleteCallback: onLoginCallback }),
        OAUTH: {
            apiUrl,
            setLoading: loginApi.setLoading,
            ssoDetails: ssoDetails,
            onLoginCompleteCallback: onLoginCallback,
        },
        NEW_PASSWORD_REQUIRED: Object.assign(Object.assign({}, loginApi), { showSSO,
            ssoDetails,
            apiUrl, onLoginCompleteCallback: onLoginCallback })
    });
    if (noBox) {
        return (React__default.createElement(Box$2, null, loading ? React__default.createElement(ScaleLoader, { color: colors.primary10 }) : React__default.createElement(StateComponent, Object.assign({}, props[currentState]))));
    }
    return (React__default.createElement(LoginBox, { isLoading: loading },
        React__default.createElement(React__default.Fragment, null,
            React__default.createElement(StateComponent, Object.assign({}, props[currentState])))));
};

const RTAPIToken$1 = ({ apiUrl, TenantId }) => {
    const requestHelper = RequestHelper.getInstance(apiUrl);
    const { currentUser } = useAuth$1();
    const [tokens, setTokens] = useState([]);
    const [tokensLoaded, setTokensLoaded] = useState(false);
    const [loading, setLoading] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [curJWT, setCurJWT] = useState('');
    const [copyToClipboardText, setCopyToClipboardText] = useState('Copy to clipboard');
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [error, setError] = useState('');
    // const [ successMessage, setSuccessMessage ]           = useState<string>('');
    const getTokens = () => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!loading && !tokensLoaded) {
            setLoading(true);
            const res = yield requestHelper.getAPITokens({ TenantId, setError });
            setTokens(res);
            setTokensLoaded(true);
            setLoading(false);
        }
    });
    useEffect(() => {
        getTokens();
    });
    const revokeToken = (tokenJTI) => __awaiter$1(void 0, void 0, void 0, function* () {
        setLoading(true);
        yield requestHelper.revokeAPIToken({ TenantId, tokenJTI, setError });
        setTokensLoaded(false);
        setLoading(false);
    });
    const addToken = () => __awaiter$1(void 0, void 0, void 0, function* () {
        setLoading(true);
        const res = yield requestHelper.addAPIToken({ TenantId, setError });
        setCurJWT(res.token);
        setModalOpen(true);
        setTokensLoaded(false);
        setLoading(false);
    });
    const getTokenStatusText = (token) => {
        if (token.disabled) {
            return 'Revoked';
        }
        if (token.expiresAt < nowAsUnixTimestamp()) {
            return 'Expired';
        }
        return React__default.createElement(RTButton, { text: "Revoke", onClick: () => revokeToken(token.tokenJTI), type: "error", sx: { marginTop: 0 } });
    };
    const modalStyle = {
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        height: '100%',
        boxShadow: 24,
        p: 4,
        borderRadius: '10px',
        padding: 0,
    };
    const copyToClipBoard = (text) => {
        navigator.clipboard.writeText(text);
        setCopyToClipboardText('Copied!');
        setTimeout(() => setCopyToClipboardText('Copy to clipboard'), 2000);
    };
    const nowAsUnixTimestamp = () => Math.round((new Date()).getTime() / 1000);
    const canView = () => {
        if (!currentUser || !TenantId)
            return false;
        return checkRoles(currentUser, [`canGenerateServerToServerToken:${TenantId}`]);
    };
    return (React__default.createElement(ThemeProvider, { theme: theme }, currentUser && canView() &&
        React__default.createElement(Box, { sx: { backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center' } },
            loading ? React__default.createElement(ScaleLoader, { color: colors.primary10 })
                :
                    React__default.createElement(Box, null,
                        React__default.createElement(Box, { sx: { display: 'flex', width: '100%', marginBottom: '10px' } },
                            React__default.createElement(Typography, { variant: "h5" }, " Manage Server To Server Tokens "),
                            React__default.createElement(RTButton, { text: "Add Token", onClick: addToken, type: "primary", sx: { maxWidth: '120px', marginLeft: 'auto', marginTop: 0, alignSelf: 'end' } })),
                        !tokens || tokens.length === 0 ? React__default.createElement(Box, null, "No tokens found")
                            :
                                React__default.createElement(TableContainer, { component: Paper },
                                    React__default.createElement(Table, { "sx-": { minWidth: 650 }, "aria-label": "simple table" },
                                        React__default.createElement(TableHead, null,
                                            React__default.createElement(TableRow, null,
                                                React__default.createElement(TableCell, null, "Token ID"),
                                                React__default.createElement(TableCell, null, "Expires"),
                                                React__default.createElement(TableCell, null, "Status"))),
                                        React__default.createElement(TableBody, null, (tokens || []).map(token => React__default.createElement(TableRow, { key: token.tokenJTI },
                                            React__default.createElement(TableCell, null, token.tokenJTI),
                                            React__default.createElement(TableCell, null, (new Date(token.expiresAt * 1000).toLocaleString())),
                                            React__default.createElement(TableCell, null, getTokenStatusText(token)))))))),
            React__default.createElement(Modal, { hideBackdrop: false, sx: modalStyle, open: modalOpen, onClose: () => setModalOpen(false), "aria-labelledby": "modal-modal-title", "aria-describedby": "modal-modal-description" },
                React__default.createElement(Box, { sx: { background: 'white', padding: '10px', borderRadius: '10px', width: '750px', margin: 'auto', marginTop: '20px' } },
                    React__default.createElement(Typography, { sx: { background: 'white ', marginBottom: '10px', textAlign: 'center' } }, "Here's your new API token, store this token securely. You will not be able to retrieve it from here later."),
                    React__default.createElement(Box, { sx: { width: '675px', maxHeight: '60vh', margin: 'auto', marginTop: '20px', borderRadius: '40px', display: 'flex' } },
                        React__default.createElement(Tooltip, { title: copyToClipboardText, placement: "bottom" },
                            React__default.createElement(Typography, { onClick: () => copyToClipBoard(curJWT), sx: { background: 'white', border: '1px solid black', wordWrap: 'break-word', height: '220px', overflow: 'auto', "&:hover": { background: colors.primary50, cursor: 'grab' } } }, curJWT)),
                        React__default.createElement(Tooltip, { title: copyToClipboardText, placement: "top" },
                            React__default.createElement(IconButton, { onClick: () => copyToClipBoard(curJWT), sx: { margin: 'auto', height: '40px', marginLeft: '10px', "&:hover": { background: colors.primary50 } } },
                                React__default.createElement(ContentCopyIcon, null)))))))));
};

const countries = [
    { code: 'AD', label: 'Andorra', phone: '376' },
    {
        code: 'AE',
        label: 'United Arab Emirates',
        phone: '971',
    },
    { code: 'AF', label: 'Afghanistan', phone: '93' },
    {
        code: 'AG',
        label: 'Antigua and Barbuda',
        phone: '1-268',
    },
    { code: 'AI', label: 'Anguilla', phone: '1-264' },
    { code: 'AL', label: 'Albania', phone: '355' },
    { code: 'AM', label: 'Armenia', phone: '374' },
    { code: 'AO', label: 'Angola', phone: '244' },
    { code: 'AQ', label: 'Antarctica', phone: '672' },
    { code: 'AR', label: 'Argentina', phone: '54' },
    { code: 'AS', label: 'American Samoa', phone: '1-684' },
    { code: 'AT', label: 'Austria', phone: '43' },
    {
        code: 'AU',
        label: 'Australia',
        phone: '61',
        suggested: true,
    },
    { code: 'AW', label: 'Aruba', phone: '297' },
    { code: 'AX', label: 'Alland Islands', phone: '358' },
    { code: 'AZ', label: 'Azerbaijan', phone: '994' },
    {
        code: 'BA',
        label: 'Bosnia and Herzegovina',
        phone: '387',
    },
    { code: 'BB', label: 'Barbados', phone: '1-246' },
    { code: 'BD', label: 'Bangladesh', phone: '880' },
    { code: 'BE', label: 'Belgium', phone: '32' },
    { code: 'BF', label: 'Burkina Faso', phone: '226' },
    { code: 'BG', label: 'Bulgaria', phone: '359' },
    { code: 'BH', label: 'Bahrain', phone: '973' },
    { code: 'BI', label: 'Burundi', phone: '257' },
    { code: 'BJ', label: 'Benin', phone: '229' },
    { code: 'BL', label: 'Saint Barthelemy', phone: '590' },
    { code: 'BM', label: 'Bermuda', phone: '1-441' },
    { code: 'BN', label: 'Brunei Darussalam', phone: '673' },
    { code: 'BO', label: 'Bolivia', phone: '591' },
    { code: 'BR', label: 'Brazil', phone: '55' },
    { code: 'BS', label: 'Bahamas', phone: '1-242' },
    { code: 'BT', label: 'Bhutan', phone: '975' },
    { code: 'BV', label: 'Bouvet Island', phone: '47' },
    { code: 'BW', label: 'Botswana', phone: '267' },
    { code: 'BY', label: 'Belarus', phone: '375' },
    { code: 'BZ', label: 'Belize', phone: '501' },
    {
        code: 'CA',
        label: 'Canada',
        phone: '1',
        suggested: true,
    },
    {
        code: 'CC',
        label: 'Cocos (Keeling) Islands',
        phone: '61',
    },
    {
        code: 'CD',
        label: 'Congo, Democratic Republic of the',
        phone: '243',
    },
    {
        code: 'CF',
        label: 'Central African Republic',
        phone: '236',
    },
    {
        code: 'CG',
        label: 'Congo, Republic of the',
        phone: '242',
    },
    { code: 'CH', label: 'Switzerland', phone: '41' },
    { code: 'CI', label: "Cote d'Ivoire", phone: '225' },
    { code: 'CK', label: 'Cook Islands', phone: '682' },
    { code: 'CL', label: 'Chile', phone: '56' },
    { code: 'CM', label: 'Cameroon', phone: '237' },
    { code: 'CN', label: 'China', phone: '86' },
    { code: 'CO', label: 'Colombia', phone: '57' },
    { code: 'CR', label: 'Costa Rica', phone: '506' },
    { code: 'CU', label: 'Cuba', phone: '53' },
    { code: 'CV', label: 'Cape Verde', phone: '238' },
    { code: 'CW', label: 'Curacao', phone: '599' },
    { code: 'CX', label: 'Christmas Island', phone: '61' },
    { code: 'CY', label: 'Cyprus', phone: '357' },
    { code: 'CZ', label: 'Czech Republic', phone: '420' },
    {
        code: 'DE',
        label: 'Germany',
        phone: '49',
        suggested: true,
    },
    { code: 'DJ', label: 'Djibouti', phone: '253' },
    { code: 'DK', label: 'Denmark', phone: '45' },
    { code: 'DM', label: 'Dominica', phone: '1-767' },
    {
        code: 'DO',
        label: 'Dominican Republic',
        phone: '1-809',
    },
    { code: 'DZ', label: 'Algeria', phone: '213' },
    { code: 'EC', label: 'Ecuador', phone: '593' },
    { code: 'EE', label: 'Estonia', phone: '372' },
    { code: 'EG', label: 'Egypt', phone: '20' },
    { code: 'EH', label: 'Western Sahara', phone: '212' },
    { code: 'ER', label: 'Eritrea', phone: '291' },
    { code: 'ES', label: 'Spain', phone: '34' },
    { code: 'ET', label: 'Ethiopia', phone: '251' },
    { code: 'FI', label: 'Finland', phone: '358' },
    { code: 'FJ', label: 'Fiji', phone: '679' },
    {
        code: 'FK',
        label: 'Falkland Islands (Malvinas)',
        phone: '500',
    },
    {
        code: 'FM',
        label: 'Micronesia, Federated States of',
        phone: '691',
    },
    { code: 'FO', label: 'Faroe Islands', phone: '298' },
    {
        code: 'FR',
        label: 'France',
        phone: '33',
        suggested: true,
    },
    { code: 'GA', label: 'Gabon', phone: '241' },
    { code: 'GB', label: 'United Kingdom', phone: '44' },
    { code: 'GD', label: 'Grenada', phone: '1-473' },
    { code: 'GE', label: 'Georgia', phone: '995' },
    { code: 'GF', label: 'French Guiana', phone: '594' },
    { code: 'GG', label: 'Guernsey', phone: '44' },
    { code: 'GH', label: 'Ghana', phone: '233' },
    { code: 'GI', label: 'Gibraltar', phone: '350' },
    { code: 'GL', label: 'Greenland', phone: '299' },
    { code: 'GM', label: 'Gambia', phone: '220' },
    { code: 'GN', label: 'Guinea', phone: '224' },
    { code: 'GP', label: 'Guadeloupe', phone: '590' },
    { code: 'GQ', label: 'Equatorial Guinea', phone: '240' },
    { code: 'GR', label: 'Greece', phone: '30' },
    {
        code: 'GS',
        label: 'South Georgia and the South Sandwich Islands',
        phone: '500',
    },
    { code: 'GT', label: 'Guatemala', phone: '502' },
    { code: 'GU', label: 'Guam', phone: '1-671' },
    { code: 'GW', label: 'Guinea-Bissau', phone: '245' },
    { code: 'GY', label: 'Guyana', phone: '592' },
    { code: 'HK', label: 'Hong Kong', phone: '852' },
    {
        code: 'HM',
        label: 'Heard Island and McDonald Islands',
        phone: '672',
    },
    { code: 'HN', label: 'Honduras', phone: '504' },
    { code: 'HR', label: 'Croatia', phone: '385' },
    { code: 'HT', label: 'Haiti', phone: '509' },
    { code: 'HU', label: 'Hungary', phone: '36' },
    { code: 'ID', label: 'Indonesia', phone: '62' },
    { code: 'IE', label: 'Ireland', phone: '353' },
    { code: 'IL', label: 'Israel', phone: '972' },
    { code: 'IM', label: 'Isle of Man', phone: '44' },
    { code: 'IN', label: 'India', phone: '91' },
    {
        code: 'IO',
        label: 'British Indian Ocean Territory',
        phone: '246',
    },
    { code: 'IQ', label: 'Iraq', phone: '964' },
    {
        code: 'IR',
        label: 'Iran, Islamic Republic of',
        phone: '98',
    },
    { code: 'IS', label: 'Iceland', phone: '354' },
    { code: 'IT', label: 'Italy', phone: '39' },
    { code: 'JE', label: 'Jersey', phone: '44' },
    { code: 'JM', label: 'Jamaica', phone: '1-876' },
    { code: 'JO', label: 'Jordan', phone: '962' },
    {
        code: 'JP',
        label: 'Japan',
        phone: '81',
        suggested: true,
    },
    { code: 'KE', label: 'Kenya', phone: '254' },
    { code: 'KG', label: 'Kyrgyzstan', phone: '996' },
    { code: 'KH', label: 'Cambodia', phone: '855' },
    { code: 'KI', label: 'Kiribati', phone: '686' },
    { code: 'KM', label: 'Comoros', phone: '269' },
    {
        code: 'KN',
        label: 'Saint Kitts and Nevis',
        phone: '1-869',
    },
    {
        code: 'KP',
        label: "Korea, Democratic People's Republic of",
        phone: '850',
    },
    { code: 'KR', label: 'Korea, Republic of', phone: '82' },
    { code: 'KW', label: 'Kuwait', phone: '965' },
    { code: 'KY', label: 'Cayman Islands', phone: '1-345' },
    { code: 'KZ', label: 'Kazakhstan', phone: '7' },
    {
        code: 'LA',
        label: "Lao People's Democratic Republic",
        phone: '856',
    },
    { code: 'LB', label: 'Lebanon', phone: '961' },
    { code: 'LC', label: 'Saint Lucia', phone: '1-758' },
    { code: 'LI', label: 'Liechtenstein', phone: '423' },
    { code: 'LK', label: 'Sri Lanka', phone: '94' },
    { code: 'LR', label: 'Liberia', phone: '231' },
    { code: 'LS', label: 'Lesotho', phone: '266' },
    { code: 'LT', label: 'Lithuania', phone: '370' },
    { code: 'LU', label: 'Luxembourg', phone: '352' },
    { code: 'LV', label: 'Latvia', phone: '371' },
    { code: 'LY', label: 'Libya', phone: '218' },
    { code: 'MA', label: 'Morocco', phone: '212' },
    { code: 'MC', label: 'Monaco', phone: '377' },
    {
        code: 'MD',
        label: 'Moldova, Republic of',
        phone: '373',
    },
    { code: 'ME', label: 'Montenegro', phone: '382' },
    {
        code: 'MF',
        label: 'Saint Martin (French part)',
        phone: '590',
    },
    { code: 'MG', label: 'Madagascar', phone: '261' },
    { code: 'MH', label: 'Marshall Islands', phone: '692' },
    {
        code: 'MK',
        label: 'Macedonia, the Former Yugoslav Republic of',
        phone: '389',
    },
    { code: 'ML', label: 'Mali', phone: '223' },
    { code: 'MM', label: 'Myanmar', phone: '95' },
    { code: 'MN', label: 'Mongolia', phone: '976' },
    { code: 'MO', label: 'Macao', phone: '853' },
    {
        code: 'MP',
        label: 'Northern Mariana Islands',
        phone: '1-670',
    },
    { code: 'MQ', label: 'Martinique', phone: '596' },
    { code: 'MR', label: 'Mauritania', phone: '222' },
    { code: 'MS', label: 'Montserrat', phone: '1-664' },
    { code: 'MT', label: 'Malta', phone: '356' },
    { code: 'MU', label: 'Mauritius', phone: '230' },
    { code: 'MV', label: 'Maldives', phone: '960' },
    { code: 'MW', label: 'Malawi', phone: '265' },
    { code: 'MX', label: 'Mexico', phone: '52' },
    { code: 'MY', label: 'Malaysia', phone: '60' },
    { code: 'MZ', label: 'Mozambique', phone: '258' },
    { code: 'NA', label: 'Namibia', phone: '264' },
    { code: 'NC', label: 'New Caledonia', phone: '687' },
    { code: 'NE', label: 'Niger', phone: '227' },
    { code: 'NF', label: 'Norfolk Island', phone: '672' },
    { code: 'NG', label: 'Nigeria', phone: '234' },
    { code: 'NI', label: 'Nicaragua', phone: '505' },
    { code: 'NL', label: 'Netherlands', phone: '31' },
    { code: 'NO', label: 'Norway', phone: '47' },
    { code: 'NP', label: 'Nepal', phone: '977' },
    { code: 'NR', label: 'Nauru', phone: '674' },
    { code: 'NU', label: 'Niue', phone: '683' },
    { code: 'NZ', label: 'New Zealand', phone: '64' },
    { code: 'OM', label: 'Oman', phone: '968' },
    { code: 'PA', label: 'Panama', phone: '507' },
    { code: 'PE', label: 'Peru', phone: '51' },
    { code: 'PF', label: 'French Polynesia', phone: '689' },
    { code: 'PG', label: 'Papua New Guinea', phone: '675' },
    { code: 'PH', label: 'Philippines', phone: '63' },
    { code: 'PK', label: 'Pakistan', phone: '92' },
    { code: 'PL', label: 'Poland', phone: '48' },
    {
        code: 'PM',
        label: 'Saint Pierre and Miquelon',
        phone: '508',
    },
    { code: 'PN', label: 'Pitcairn', phone: '870' },
    { code: 'PR', label: 'Puerto Rico', phone: '1' },
    {
        code: 'PS',
        label: 'Palestine, State of',
        phone: '970',
    },
    { code: 'PT', label: 'Portugal', phone: '351' },
    { code: 'PW', label: 'Palau', phone: '680' },
    { code: 'PY', label: 'Paraguay', phone: '595' },
    { code: 'QA', label: 'Qatar', phone: '974' },
    { code: 'RE', label: 'Reunion', phone: '262' },
    { code: 'RO', label: 'Romania', phone: '40' },
    { code: 'RS', label: 'Serbia', phone: '381' },
    { code: 'RU', label: 'Russian Federation', phone: '7' },
    { code: 'RW', label: 'Rwanda', phone: '250' },
    { code: 'SA', label: 'Saudi Arabia', phone: '966' },
    { code: 'SB', label: 'Solomon Islands', phone: '677' },
    { code: 'SC', label: 'Seychelles', phone: '248' },
    { code: 'SD', label: 'Sudan', phone: '249' },
    { code: 'SE', label: 'Sweden', phone: '46' },
    { code: 'SG', label: 'Singapore', phone: '65' },
    { code: 'SH', label: 'Saint Helena', phone: '290' },
    { code: 'SI', label: 'Slovenia', phone: '386' },
    {
        code: 'SJ',
        label: 'Svalbard and Jan Mayen',
        phone: '47',
    },
    { code: 'SK', label: 'Slovakia', phone: '421' },
    { code: 'SL', label: 'Sierra Leone', phone: '232' },
    { code: 'SM', label: 'San Marino', phone: '378' },
    { code: 'SN', label: 'Senegal', phone: '221' },
    { code: 'SO', label: 'Somalia', phone: '252' },
    { code: 'SR', label: 'Suriname', phone: '597' },
    { code: 'SS', label: 'South Sudan', phone: '211' },
    {
        code: 'ST',
        label: 'Sao Tome and Principe',
        phone: '239',
    },
    { code: 'SV', label: 'El Salvador', phone: '503' },
    {
        code: 'SX',
        label: 'Sint Maarten (Dutch part)',
        phone: '1-721',
    },
    {
        code: 'SY',
        label: 'Syrian Arab Republic',
        phone: '963',
    },
    { code: 'SZ', label: 'Swaziland', phone: '268' },
    {
        code: 'TC',
        label: 'Turks and Caicos Islands',
        phone: '1-649',
    },
    { code: 'TD', label: 'Chad', phone: '235' },
    {
        code: 'TF',
        label: 'French Southern Territories',
        phone: '262',
    },
    { code: 'TG', label: 'Togo', phone: '228' },
    { code: 'TH', label: 'Thailand', phone: '66' },
    { code: 'TJ', label: 'Tajikistan', phone: '992' },
    { code: 'TK', label: 'Tokelau', phone: '690' },
    { code: 'TL', label: 'Timor-Leste', phone: '670' },
    { code: 'TM', label: 'Turkmenistan', phone: '993' },
    { code: 'TN', label: 'Tunisia', phone: '216' },
    { code: 'TO', label: 'Tonga', phone: '676' },
    { code: 'TR', label: 'Turkey', phone: '90' },
    {
        code: 'TT',
        label: 'Trinidad and Tobago',
        phone: '1-868',
    },
    { code: 'TV', label: 'Tuvalu', phone: '688' },
    {
        code: 'TW',
        label: 'Taiwan, Province of China',
        phone: '886',
    },
    {
        code: 'TZ',
        label: 'United Republic of Tanzania',
        phone: '255',
    },
    { code: 'UA', label: 'Ukraine', phone: '380' },
    { code: 'UG', label: 'Uganda', phone: '256' },
    {
        code: 'US',
        label: 'United States',
        phone: '1',
        suggested: true,
    },
    { code: 'UY', label: 'Uruguay', phone: '598' },
    { code: 'UZ', label: 'Uzbekistan', phone: '998' },
    {
        code: 'VA',
        label: 'Holy See (Vatican City State)',
        phone: '379',
    },
    {
        code: 'VC',
        label: 'Saint Vincent and the Grenadines',
        phone: '1-784',
    },
    { code: 'VE', label: 'Venezuela', phone: '58' },
    {
        code: 'VG',
        label: 'British Virgin Islands',
        phone: '1-284',
    },
    {
        code: 'VI',
        label: 'US Virgin Islands',
        phone: '1-340',
    },
    { code: 'VN', label: 'Vietnam', phone: '84' },
    { code: 'VU', label: 'Vanuatu', phone: '678' },
    { code: 'WF', label: 'Wallis and Futuna', phone: '681' },
    { code: 'WS', label: 'Samoa', phone: '685' },
    { code: 'XK', label: 'Kosovo', phone: '383' },
    { code: 'YE', label: 'Yemen', phone: '967' },
    { code: 'YT', label: 'Mayotte', phone: '262' },
    { code: 'ZA', label: 'South Africa', phone: '27' },
    { code: 'ZM', label: 'Zambia', phone: '260' },
    { code: 'ZW', label: 'Zimbabwe', phone: '263' },
];

const CountrySelect = ({ selectedCountry = '', setSelectedCountry, i18n }) => {
    const updateSelectedCountry = (event, _child) => {
        setSelectedCountry(event.target.value);
    };
    return (React__default.createElement(FormControl, { sx: TextFieldStyling({ width: '33%', marginRight: '3px' }) },
        React__default.createElement(InputLabel, { id: "country-select-label" }, i18n.t('country')),
        React__default.createElement(Select, { label: i18n.t('country'), labelId: "country-select-label", id: "country-select", value: selectedCountry, onChange: updateSelectedCountry }, countries.map((country) => (React__default.createElement(MenuItem, { key: country.code, value: country.code },
            React__default.createElement(ListItemIcon, { sx: { align: 'left' } },
                React__default.createElement(Box, { component: "img", src: `https://flagcdn.com/w20/${country.code.toLowerCase()}.png`, alt: i18n.t(country.code) })),
            React__default.createElement("span", null, i18n.t(country.code))))))));
};

const languages = [
    { name: 'English (US)', code: 'en' },
    { name: 'English (GB)', code: 'en-GB' },
    { name: 'Danish', code: 'da' },
    { name: 'Finnish', code: 'fi' },
    { name: 'French', code: 'fr' },
    { name: 'French (Canada)', code: 'fr-CA' },
    { name: 'German', code: 'de' },
    { name: 'Greek', code: 'el' },
    { name: 'Italian', code: 'it' },
    { name: 'Portuguese', code: 'pt' },
    { name: 'Portuguese (Brazil)', code: 'pt-BR' },
    { name: 'Spanish', code: 'es' },
    { name: 'Spanish (Latin America)', code: 'es-419' },
    { name: 'Swedish', code: 'sv' },
];

const LanguageSelect = ({ selectedLanguage, setSelectedLanguage, i18n }) => {
    const updateSelectedLanguage = (event, _child) => {
        setSelectedLanguage(event.target.value);
    };
    return (React__default.createElement(FormControl, { sx: TextFieldStyling({ width: '33%', marginRight: '3px' }) },
        React__default.createElement(InputLabel, { id: "language-select-label" }, i18n.t('email_language')),
        React__default.createElement(Select, { label: i18n.t('email_language'), labelId: "language-select-label", id: "language-select", value: selectedLanguage, onChange: updateSelectedLanguage }, languages.map((language) => (React__default.createElement(MenuItem, { key: language.code, value: language.code }, i18n.t(language.code)))))));
};

const FieldsSection = ({ children, apiUrl, TenantId, TenantDetails, successCallback }) => {
    const { currentUser, i18n } = useAuth$1();
    const requestHelper = RequestHelper.getInstance(apiUrl);
    const [loading, setLoading] = useState(false);
    const [tenant, setTenant] = useState(TenantDetails);
    const [tenantLoaded, setTenantLoaded] = useState(false);
    const [error, setError] = useState(''); // TODO: add error displaying
    const [successMessage, setSuccessMessage] = useState('');
    const getTenantFn = () => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!loading && !tenantLoaded) {
            setLoading(true);
            const res = yield requestHelper.getTenant({ TenantId, setError });
            setTenant(res);
            setTenantLoaded(true);
            setLoading(false);
        }
    });
    const getTenant = useCallback(getTenantFn, [TenantId, loading, tenantLoaded, requestHelper]);
    const updateAttribute = (attribute, value) => {
        if (!tenant) {
            return;
        }
        setTenant(Object.assign(Object.assign({}, tenant), { [attribute]: value }));
    };
    const updateTenant = (event) => __awaiter$1(void 0, void 0, void 0, function* () {
        event.preventDefault();
        if (!tenant) {
            return;
        }
        setLoading(true);
        let res;
        if (!tenant.TenantId) {
            res = yield requestHelper.createTenant({ TenantParams: tenant, setError });
        }
        else {
            res = yield requestHelper.updateTenant({ TenantId, TenantParams: tenant, setError });
        }
        if (res) {
            setTenant(res);
            setSuccessMessage(i18n.t('update_successful'));
            setError('');
            if (successCallback) {
                successCallback(res);
            }
        }
        setLoading(false);
    });
    useEffect(() => {
        if (TenantDetails) {
            setTenantLoaded(true);
        }
        getTenant();
    }, [TenantDetails, getTenant]);
    return (React__default.createElement(Box, { sx: { backgroundColor: 'white', width: '100%' } },
        React__default.createElement("form", { onSubmit: updateTenant },
            React__default.createElement(Box, { sx: { width: '100%' } },
                children({ tenant, updateAttribute, apiUrl, currentUser }),
                " "),
            React__default.createElement(Box, { sx: { width: '40%', marginLeft: 'auto' } },
                React__default.createElement(RTButton, { id: 'edit-tenant-submit-button', text: (tenant === null || tenant === void 0 ? void 0 : tenant.TenantId) ? `${i18n.t('save')} ${tenant === null || tenant === void 0 ? void 0 : tenant.displayName}` : 'Create Tenant', type: "primary", isSubmit: true, isLoading: loading })),
            React__default.createElement(ErrorPrompt, { message: error, successMessage: successMessage, id: "error-success-box" }))));
};

const RTSelect = ({ selectedOption, setSelectedOption, selectName, options, open, setOpen, sx, i18n, helperText, error, disabled, id }) => {
    const updateSelectedOption = (event, _child) => {
        setSelectedOption(event.target.value);
    };
    const showOptionDisplayName = (option) => {
        if (Array.isArray(option))
            return i18n ? i18n.t(option[1]) : option[0];
        return i18n ? i18n.t(option) : option;
    };
    return (React__default.createElement(FormControl, { sx: Object.assign({}, sx), error: error, id: id },
        React__default.createElement(InputLabel, { id: `${selectName}-select-label` }, selectName),
        React__default.createElement(Select, { label: selectName, labelId: `${selectName}-select-label`, id: `${selectName}-select`, value: selectedOption, onChange: updateSelectedOption, open: open, onClose: () => setOpen && setOpen(false), onOpen: () => setOpen && setOpen(true), disabled: disabled }, Object.keys(options).map((key) => React__default.createElement(MenuItem, { key: key, value: key }, showOptionDisplayName(options[key])))),
        React__default.createElement(FormHelperText, null, helperText)));
};

const configOptions = {
    customerName: {
        '1': ['Customer', 'customer_1'],
        '2': ['Subscriber', 'customer_2'],
    },
    routerName: {
        '1': ['Router', 'router_1'],
        '2': ['Modem', 'router_2'],
        '3': ['Gateway', 'router_3'],
        '4': ['Hub', 'router_4'],
    },
    levelName: {
        '1': ['Level', 'level_1'],
        '2': ['Floor', 'level_2'],
    },
    podName: {
        '1': ['Mesh Pods', 'pod_1'],
        '2': ['Access Points', 'pod_2'],
        '3': ['Mesh Nodes', 'pod_3'],
        '4': ['Mesh Pucks', 'pod_4'],
        '5': ['Beacons', 'pod_5'],
        '6': ['Range Extenders', 'pod_6'],
    },
    wifiName: {
        '1': ['WiFi', 'wifi_1'],
        '2': ['Wi-Fi', 'wifi_2'],
        '3': ['Wifi', 'wifi_3'],
        '4': ['WIFI', 'wifi_4'],
    },
    areaUnits: {
        '1': ['Feet', 'units_1'],
        '2': ['Metres', 'units_2'],
    },
    region: {
        'us-east': ['US East'],
        'eu-west': ['EU West'],
    }
};

const CoreFieldsComp = ({ tenant, updateAttribute }) => {
    var _a;
    const { currentUser, i18n } = useAuth$1();
    const canView = () => {
        if (!currentUser)
            return false;
        if (!(tenant === null || tenant === void 0 ? void 0 : tenant.TenantId))
            return checkRoles(currentUser, ['canCreateTenant:*']);
        return checkRoles(currentUser, [`canEditTenant:${tenant.TenantId}`]);
    };
    const canSetDisplayName = () => {
        if (!currentUser)
            return false;
        if (!(tenant === null || tenant === void 0 ? void 0 : tenant.TenantId))
            return checkRoles(currentUser, ['canCreateTenant:*']);
        return checkRoles(currentUser, ['canEditTenantDisplayName:*']);
    };
    return (React__default.createElement(React__default.Fragment, null, canView() &&
        React__default.createElement(FormGroup, { sx: { width: '100%', padding: '10px', display: 'flex', alignItems: 'center', flexDirection: 'row' }, id: 'core-fields-form' },
            "        ",
            React__default.createElement(Typography, { variant: "h5", sx: { marginBottom: '15px', width: '100%' } }, i18n.t('main_settings')),
            canSetDisplayName() && React__default.createElement(FormControl, { sx: { marginBottom: '15px', width: '100%' } },
                React__default.createElement(TextField, { value: (tenant === null || tenant === void 0 ? void 0 : tenant.displayName) || '', onChange: event => updateAttribute('displayName', event.target.value), label: i18n.t('display_name'), variant: "outlined", sx: TextFieldStyling({ marginBottom: '10px' }), id: 'display-name' })),
            React__default.createElement(CountrySelect, { selectedCountry: (tenant === null || tenant === void 0 ? void 0 : tenant.countryCode) || 'US', setSelectedCountry: (value) => updateAttribute('countryCode', value), i18n: i18n }),
            React__default.createElement(LanguageSelect, { selectedLanguage: (tenant === null || tenant === void 0 ? void 0 : tenant.localeCode) || 'en', setSelectedLanguage: (value) => updateAttribute('localeCode', value), i18n: i18n }),
            React__default.createElement(RTSelect, { selectedOption: ((_a = tenant === null || tenant === void 0 ? void 0 : tenant.areaUnits) === null || _a === void 0 ? void 0 : _a.toString()) || "1", setSelectedOption: (value) => updateAttribute('areaUnits', value), options: configOptions.areaUnits, selectName: i18n.t('units'), sx: TextFieldStyling({ width: '33%' }), i18n: i18n }),
            React__default.createElement(Box, { sx: { marginTop: '10px', width: '100%' } }, (tenant === null || tenant === void 0 ? void 0 : tenant.TenantId) ? '' :
                React__default.createElement(RTSelect, { selectedOption: (tenant === null || tenant === void 0 ? void 0 : tenant.region) || Object.keys(configOptions.region)[0][0], setSelectedOption: (value) => updateAttribute('region', value), options: configOptions.region, selectName: "Region", sx: TextFieldStyling({ width: '50%' }) })))));
};
const RTTenantCoreFields$1 = ({ apiUrl, TenantId, TenantDetails }) => {
    return (React__default.createElement(FieldsSection, { apiUrl: apiUrl, TenantId: TenantId, TenantDetails: TenantDetails }, CoreFieldsComp));
};

const CustomerFieldsComp = ({ tenant, updateAttribute }) => {
    var _a, _b, _c, _d, _e;
    const { currentUser, i18n } = useAuth$1();
    const canView = () => {
        if (!currentUser)
            return false;
        if (!(tenant === null || tenant === void 0 ? void 0 : tenant.TenantId))
            return checkRoles(currentUser, ['canCreateTenant:*']);
        return checkRoles(currentUser, [`canEditTenant:${tenant.TenantId}`]);
    };
    return (React__default.createElement(React__default.Fragment, null, canView() &&
        React__default.createElement(FormGroup, { sx: { width: '100%', padding: '10px' }, id: 'customer-fields-form' },
            React__default.createElement(Typography, { variant: "h5", sx: { marginBottom: '15px' } }, i18n.t('terminology')),
            React__default.createElement(TableContainer, null,
                React__default.createElement(Table, null,
                    React__default.createElement(TableHead, null,
                        React__default.createElement(TableRow, null,
                            React__default.createElement(TableCell, { id: "term-header" }, i18n.t('term')),
                            React__default.createElement(TableCell, { id: "example-header" }, i18n.t('example_usage')))),
                    React__default.createElement(TableBody, null,
                        React__default.createElement(TableRow, null,
                            React__default.createElement(TableCell, null,
                                React__default.createElement(RTSelect, { selectName: i18n.t(`customer_${(tenant === null || tenant === void 0 ? void 0 : tenant.customerName) || '1'}`), selectedOption: ((_a = tenant === null || tenant === void 0 ? void 0 : tenant.customerName) === null || _a === void 0 ? void 0 : _a.toString()) || '1', setSelectedOption: (value) => updateAttribute('customerName', value), options: configOptions.customerName, sx: TextFieldStyling({ width: '100%' }), i18n: i18n, id: "customer-rt-select" })),
                            React__default.createElement(TableCell, { id: "customer-example-usage" }, i18n.t(`customer_example_usage_${(tenant === null || tenant === void 0 ? void 0 : tenant.customerName) || '1'}`))),
                        React__default.createElement(TableRow, null,
                            React__default.createElement(TableCell, null,
                                React__default.createElement(RTSelect, { selectName: i18n.t(`router_${(tenant === null || tenant === void 0 ? void 0 : tenant.routerName) || '1'}`), selectedOption: ((_b = tenant === null || tenant === void 0 ? void 0 : tenant.routerName) === null || _b === void 0 ? void 0 : _b.toString()) || '1', setSelectedOption: (value) => updateAttribute('routerName', value), options: configOptions.routerName, sx: TextFieldStyling({ width: '100%' }), i18n: i18n, id: "router-rt-select" })),
                            React__default.createElement(TableCell, { id: "router-example-usage" }, i18n.t(`router_example_usage_${(tenant === null || tenant === void 0 ? void 0 : tenant.routerName) || '1'}`))),
                        React__default.createElement(TableRow, null,
                            React__default.createElement(TableCell, null,
                                React__default.createElement(RTSelect, { selectName: i18n.t(`level_${(tenant === null || tenant === void 0 ? void 0 : tenant.levelName) || '1'}`), selectedOption: ((_c = tenant === null || tenant === void 0 ? void 0 : tenant.levelName) === null || _c === void 0 ? void 0 : _c.toString()) || '1', setSelectedOption: (value) => updateAttribute('levelName', value), options: configOptions.levelName, sx: TextFieldStyling({ width: '100%' }), i18n: i18n, id: "level-rt-select" })),
                            React__default.createElement(TableCell, { id: "level-example-usage" }, i18n.t(`level_example_usage_${(tenant === null || tenant === void 0 ? void 0 : tenant.levelName) || '1'}`))),
                        React__default.createElement(TableRow, null,
                            React__default.createElement(TableCell, null,
                                React__default.createElement(RTSelect, { selectName: i18n.t(`pod_${(tenant === null || tenant === void 0 ? void 0 : tenant.podName) || '1'}`), selectedOption: ((_d = tenant === null || tenant === void 0 ? void 0 : tenant.podName) === null || _d === void 0 ? void 0 : _d.toString()) || '1', setSelectedOption: (value) => updateAttribute('podName', value), options: configOptions.podName, sx: TextFieldStyling({ width: '100%' }), i18n: i18n, id: "pod-rt-select" })),
                            React__default.createElement(TableCell, { id: "mesh-pod-example-usage" }, i18n.t(`mesh_pod_example_usage_${(tenant === null || tenant === void 0 ? void 0 : tenant.podName) || '1'}`))),
                        React__default.createElement(TableRow, null,
                            React__default.createElement(TableCell, null,
                                React__default.createElement(RTSelect, { selectName: i18n.t(`wifi_${(tenant === null || tenant === void 0 ? void 0 : tenant.wifiName) || '1'}`), selectedOption: ((_e = tenant === null || tenant === void 0 ? void 0 : tenant.wifiName) === null || _e === void 0 ? void 0 : _e.toString()) || '1', setSelectedOption: (value) => updateAttribute('wifiName', value), options: configOptions.wifiName, sx: TextFieldStyling({ width: '100%' }), i18n: i18n, id: "wifi-rt-select" })),
                            React__default.createElement(TableCell, { id: "wifi-example-usage" }, i18n.t(`wifi_example_usage_${(tenant === null || tenant === void 0 ? void 0 : tenant.wifiName) || '1'}`)))))))));
};
const RTTenantCustomerFields$1 = ({ apiUrl, TenantId, TenantDetails }) => {
    return (React__default.createElement(FieldsSection, { apiUrl: apiUrl, TenantId: TenantId, TenantDetails: TenantDetails }, CustomerFieldsComp));
};

const PlatformFieldsComp = ({ tenant, updateAttribute }) => {
    var _a;
    const { currentUser, i18n } = useAuth$1();
    return (React__default.createElement(React__default.Fragment, null, currentUser && checkRoles(currentUser, ['createTenant:*']) &&
        React__default.createElement(FormGroup, { sx: { width: '100%', padding: '10px' }, id: 'platform-fields' },
            React__default.createElement(Typography, { variant: "h5", sx: { marginBottom: '15px' } }, i18n.t('platform')),
            React__default.createElement(FormControl, { sx: { marginBottom: '15px', width: '100%' } },
                React__default.createElement(TextField, { value: (tenant === null || tenant === void 0 ? void 0 : tenant.resolveId) || '', onChange: event => updateAttribute('resolveId', event.target.value), label: "Resolve Id", variant: "outlined", id: 'resolve-id', sx: TextFieldStyling({ marginBottom: '10px' }) })),
            tenant && ((_a = tenant === null || tenant === void 0 ? void 0 : tenant.TenantId) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                React__default.createElement(FormControl, { sx: { marginBottom: '15px', width: '100%' } },
                    React__default.createElement(TextField, { value: (tenant === null || tenant === void 0 ? void 0 : tenant.certifyId) || '', onChange: event => updateAttribute('certifyId', event.target.value), label: "Certify Id", variant: "outlined", id: 'certify-id', sx: TextFieldStyling({ marginBottom: '10px' }) })))));
};
const RTTenantPlatformFields$1 = ({ apiUrl, TenantId, TenantDetails }) => {
    return (React__default.createElement(FieldsSection, { apiUrl: apiUrl, TenantId: TenantId, TenantDetails: TenantDetails }, PlatformFieldsComp));
};

const SecurityFieldsComp = ({ tenant, updateAttribute }) => {
    const { currentUser } = useAuth$1();
    return (React__default.createElement(React__default.Fragment, null, currentUser && checkRoles(currentUser, ['createTenant:*']) &&
        React__default.createElement(FormGroup, { sx: { width: '100%', padding: '10px', display: 'flex', alignItems: 'center', flexDirection: 'row' }, id: 'security-fields' },
            React__default.createElement(Typography, { variant: "h5", sx: { marginBottom: '15px', width: '100%' } }, "Security Fields"),
            React__default.createElement(FormControl, { sx: { marginBottom: '15px', marginRight: '5px', width: '49%', } },
                React__default.createElement(TextField, { type: "number", value: (tenant === null || tenant === void 0 ? void 0 : tenant.maxPasswordAge) || 0, onChange: event => updateAttribute('maxPasswordAge', Number(event.target.value)), label: "Maximum Password Age (Days)", variant: "outlined", sx: TextFieldStyling({ marginBottom: '10px' }), id: 'max-password-age', helperText: !(tenant === null || tenant === void 0 ? void 0 : tenant.maxPasswordAge) ? '0 means no expiration' : '' })),
            React__default.createElement(FormControl, { sx: { marginBottom: '15px', marginRight: '5px', width: '49%', } },
                React__default.createElement(TextField, { value: (tenant === null || tenant === void 0 ? void 0 : tenant.maxDaysBetweenLogins) || 0, onChange: event => updateAttribute('maxDaysBetweenLogins', Number(event.target.value)), label: "Maximum Days Between Logins", variant: "outlined", sx: TextFieldStyling({ marginBottom: '10px' }), id: 'max-days-between-logins', helperText: !(tenant === null || tenant === void 0 ? void 0 : tenant.maxDaysBetweenLogins) ? '0 means unlimited' : '' })),
            React__default.createElement(FormControl, { sx: { marginBottom: '15px', marginRight: '5px', width: '49%', } },
                React__default.createElement(TextField, { value: (tenant === null || tenant === void 0 ? void 0 : tenant.maxLoginAttempts) || 0, onChange: event => updateAttribute('maxLoginAttempts', Number(event.target.value)), label: "Maximum Login Attempts", variant: "outlined", type: "number", sx: TextFieldStyling({ marginBottom: '10px' }), id: 'max-login-attempts', helperText: !(tenant === null || tenant === void 0 ? void 0 : tenant.maxLoginAttempts) ? '0 means unlimited' : '' })),
            React__default.createElement(FormControl, { sx: { marginBottom: '15px', marginRight: '5px', width: '49%', } },
                React__default.createElement(TextField, { value: (tenant === null || tenant === void 0 ? void 0 : tenant.loginTimeoutSeconds) || 0, onChange: event => updateAttribute('loginTimeoutSeconds', Number(event.target.value)), label: "Login Timeout (Seconds)", variant: "outlined", type: "number", sx: TextFieldStyling({ marginBottom: '10px' }), id: 'login-timeout-seconds', helperText: !(tenant === null || tenant === void 0 ? void 0 : tenant.loginTimeoutSeconds) ? '0 means no timeout' : '' })),
            React__default.createElement(FormControl, { sx: { marginBottom: '15px', marginRight: '5px', width: '49%', } },
                React__default.createElement(TextField, { inputProps: { inputMode: 'numeric', pattern: '[0-9]*' }, value: (tenant === null || tenant === void 0 ? void 0 : tenant.idleTimeoutSeconds) || 0, onChange: event => updateAttribute('idleTimeoutSeconds', Number(event.target.value)), label: "Idle Timeout (Seconds)", variant: "outlined", type: "number", sx: TextFieldStyling({ marginBottom: '10px' }), id: 'idle-timeout-seconds', helperText: !(tenant === null || tenant === void 0 ? void 0 : tenant.idleTimeoutSeconds) ? '0 means no timeout' : '' })),
            React__default.createElement(FormControl, { sx: { marginBottom: '15px', marginRight: '5px', width: '49%', } },
                React__default.createElement(TextField, { value: (tenant === null || tenant === void 0 ? void 0 : tenant.numberOfOldPasswords) || 0, onChange: event => updateAttribute('numberOfOldPasswords', Number(event.target.value)), label: "Number of Old Passwords", variant: "outlined", type: "number", sx: TextFieldStyling({ marginBottom: '10px' }), id: 'number-of-old-passwords', helperText: !(tenant === null || tenant === void 0 ? void 0 : tenant.numberOfOldPasswords) ? '0 means disabled' : '' })))));
};
const RTTenantSecurityFields$1 = ({ apiUrl, TenantId, TenantDetails }) => {
    return (React__default.createElement(FieldsSection, { apiUrl: apiUrl, TenantId: TenantId, TenantDetails: TenantDetails }, SecurityFieldsComp));
};

const ConfirmationDialog = ({ onCancel, onConfirm, message, title, open, cancelMessage, confirmMessage }) => {
    const [openDialog, setOpenDialog] = useState(open);
    const onClose = onCancel || (() => setOpenDialog(false));
    useEffect(() => {
        setOpenDialog(open);
    }, [open]);
    return (React__default.createElement(Dialog, { open: openDialog, onClose: onClose, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", id: "confirmation-dialog" },
        React__default.createElement(DialogTitle, { id: "alert-dialog-title" }, title),
        React__default.createElement(DialogContent, null,
            React__default.createElement(DialogContentText, { id: "alert-dialog-description" }, message)),
        React__default.createElement(DialogActions, null,
            React__default.createElement(Button, { onClick: onClose, color: "primary" }, cancelMessage || 'Cancel'),
            React__default.createElement(Button, { onClick: onConfirm, color: "primary", autoFocus: true }, confirmMessage || 'Confirm'))));
};

const SSOFields = ({ apiUrl, TenantId, TenantDetails }) => {
    var _a, _b;
    const requestHelper = RequestHelper.getInstance(apiUrl);
    const [ssoInfo, setSSOInfo] = React__default.useState({});
    const [error, setError] = React__default.useState('');
    const [successMessage, setSuccessMessage] = React__default.useState('');
    const [tenantSSOConfigs, setTenantSSOConfigs] = React__default.useState(TenantDetails.tenantSSOConfigs);
    const [loading, setLoading] = React__default.useState(false);
    useEffect(() => {
        const fetchSSOInfo = () => __awaiter$1(void 0, void 0, void 0, function* () {
            const response = yield requestHelper.getSSOGlobal({ tenantId: TenantDetails.TenantId });
            setSSOInfo(response);
        });
        if (ssoInfo.data === undefined) {
            fetchSSOInfo();
        }
    }, [TenantDetails.TenantId, requestHelper, ssoInfo]);
    const onUpdate = (ssoConfig) => __awaiter$1(void 0, void 0, void 0, function* () {
        setLoading(true);
        if (ssoConfig.new) {
            const res = yield requestHelper.addTenantSSOConfig({ TenantId, tenantSSOConfig: ssoConfig, setError });
            if (res) {
                setSuccessMessage('SSO Provider Added Successfully');
                setLoading(false);
                ssoConfig.Sort = res.tenantSSOConfig.Sort;
            }
            setLoading(false);
            return ssoConfig;
        }
        const res = yield requestHelper.updateTenantSSOConfig({ TenantId, tenantSSOConfig: ssoConfig, setError });
        if (res) {
            setSuccessMessage('SSO Provider Updated Successfully');
        }
        setLoading(false);
        return ssoConfig;
    });
    const onDelete = (ssoConfig) => __awaiter$1(void 0, void 0, void 0, function* () {
        setLoading(true);
        if (!ssoConfig.Sort) {
            setError('Cannot delete SSO Provider');
            setLoading(false);
            return;
        }
        const res = yield requestHelper.removeTenantSSOConfig({ TenantId, Sort: ssoConfig.Sort, setError });
        if (res) {
            setSuccessMessage('SSO Provider Deleted Successfully');
            setTenantSSOConfigs(tenantSSOConfigs.filter((config) => config.Sort !== ssoConfig.Sort));
            TenantDetails.tenantSSOConfigs = tenantSSOConfigs.filter((config) => config.Sort !== ssoConfig.Sort);
        }
        setLoading(false);
    });
    const addBlankTenantSSOConfig = () => {
        const blankConfig = structuredClone(blankTenantSSOConfig);
        setTenantSSOConfigs([...TenantDetails.tenantSSOConfigs, blankConfig]);
        TenantDetails.tenantSSOConfigs = [...tenantSSOConfigs, blankConfig];
    };
    return (React__default.createElement(Box, null,
        React__default.createElement(Typography, { variant: "h5", sx: { marginBottom: '15px', width: '100%' } }, "Single Sign On Settings"),
        React__default.createElement(TextField, { label: 'ACS Url', variant: "outlined", sx: TextFieldStyling({ width: '100%' }), value: ((_a = ssoInfo.data) === null || _a === void 0 ? void 0 : _a.samlInfo.acsUrl) || '', disabled: true }),
        React__default.createElement(TextField, { label: 'SP Entity Id', variant: "outlined", sx: TextFieldStyling({ width: '100%', marginTop: '10px' }), value: ((_b = ssoInfo.data) === null || _b === void 0 ? void 0 : _b.samlInfo.spEntityId) || '', disabled: true }),
        loading ? React__default.createElement(ScaleLoader, { color: colors.primary20 }) :
            React__default.createElement(Box, null,
                tenantSSOConfigs.length > 0 &&
                    React__default.createElement(SSOProviderForm, { ssoConfig: tenantSSOConfigs[0], onUpdate: onUpdate, onDelete: onDelete }),
                tenantSSOConfigs.length === 0 &&
                    React__default.createElement(RTButton, { type: 'primary', variant: 'contained', sx: { marginTop: '20px', width: '100%' }, onClick: addBlankTenantSSOConfig, text: 'Add SSO Provider' }),
                React__default.createElement(ErrorPrompt, { message: error, successMessage: successMessage }))));
};
const SSOProviderForm = ({ ssoConfig, onUpdate, onDelete }) => {
    var _a, _b;
    const metadataURL = (_b = (_a = ssoConfig.SAMLConfig.cognitoIdentityProvider) === null || _a === void 0 ? void 0 : _a.ProviderDetails) === null || _b === void 0 ? void 0 : _b.MetadataURL;
    const [tabIndex, setTabIndex] = React__default.useState(0);
    const [deleteDialogOpen, setDeleteDialogOpen] = React__default.useState(false);
    const [saveDisabled, setSaveDisabled] = React__default.useState(true);
    const [config, setConfig] = React__default.useState(ssoConfig);
    const [attributeMapping, setAttributeMapping] = React__default.useState({});
    const [providerDetails, setProviderDetails] = React__default.useState({});
    useEffect(() => {
        setConfig(ssoConfig);
        setAttributeMapping(ssoConfig.SAMLConfig.cognitoIdentityProvider.AttributeMapping);
        setProviderDetails(ssoConfig.SAMLConfig.cognitoIdentityProvider.ProviderDetails);
    }, [ssoConfig, ssoConfig.Sort]);
    const submit = (event) => __awaiter$1(void 0, void 0, void 0, function* () {
        event.preventDefault();
        const updatedConfig = yield onUpdate(ssoConfig);
        setConfig(updatedConfig);
        checkSaveDisabled();
    });
    const checkSaveDisabled = () => {
        const metadataXML = providerDetails.MetadataFile;
        const metadataURL = providerDetails.MetadataURL;
        const emailMapping = attributeMapping.email;
        if (emailMapping && (metadataURL || metadataXML)) {
            setSaveDisabled(false);
        }
    };
    const onAttrUpdate = (value, attrName) => {
        const providerDetailsAttrs = ['MetadataURL', 'MetadataFile'];
        const attributeMappingAttrs = ['email', 'given_name', 'family_name'];
        if (providerDetailsAttrs.includes(attrName)) {
            const ProviderDetails = providerDetails || {};
            ProviderDetails[attrName] = value;
            ssoConfig.SAMLConfig.cognitoIdentityProvider.ProviderDetails = ProviderDetails;
            setProviderDetails(Object.assign(Object.assign({}, ProviderDetails), { [attrName]: value }));
            checkSaveDisabled();
            return;
        }
        if (attributeMappingAttrs.includes(attrName)) {
            const AttributeMapping = attributeMapping || {};
            AttributeMapping[attrName] = value;
            ssoConfig.SAMLConfig.cognitoIdentityProvider.AttributeMapping = AttributeMapping;
            setAttributeMapping(Object.assign(Object.assign({}, AttributeMapping), { [attrName]: value }));
            checkSaveDisabled();
            return;
        }
        ssoConfig[attrName] = value;
        setConfig(Object.assign(Object.assign({}, config), { [attrName]: value }));
        checkSaveDisabled();
    };
    useEffect(() => {
        if (metadataURL) {
            setTabIndex(1);
        }
    }, [metadataURL]);
    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
    };
    return (React__default.createElement("form", { onSubmit: submit },
        React__default.createElement(FormControlLabel, { control: React__default.createElement(Switch, { checked: config.ssoAllowSelfSignup, onChange: () => onAttrUpdate(!config.ssoAllowSelfSignup, 'ssoAllowSelfSignup') }), label: "Allow Self Signup (JIT)" }),
        config.ssoAllowSelfSignup &&
            React__default.createElement(TextField, { label: "JIT Email Domain", value: config.ssoEmailDomain, onChange: (e) => onAttrUpdate(e.target.value, 'ssoEmailDomain'), sx: TextFieldStyling({ width: '100%', marginTop: '10px' }) }),
        React__default.createElement(Tabs, { value: tabIndex, onChange: handleTabChange },
            React__default.createElement(Tab, { label: "Metadata XML", sx: {} }),
            React__default.createElement(Tab, { label: "Metadata URL" })),
        tabIndex === 0 &&
            React__default.createElement(TextField, { label: "Metadata XML", value: providerDetails.MetadataFile, rows: 10, multiline: true, onChange: (e) => onAttrUpdate(e.target.value, 'MetadataFile'), sx: TextFieldStyling({ width: '100%', marginTop: '20px' }) }),
        tabIndex === 1 &&
            React__default.createElement(TextField, { label: "Metadata URL", value: providerDetails.MetadataURL, hidden: tabIndex !== 1, onChange: (e) => onAttrUpdate(e.target.value, 'MetadataURL'), sx: TextFieldStyling({ width: '100%', marginTop: '20px' }) }),
        React__default.createElement(Typography, { sx: { paddingTop: '20px' } }, "Attribute Mappings"),
        React__default.createElement(TextField, { label: "Email (Required)", value: attributeMapping.email, onChange: (e) => onAttrUpdate(e.target.value, 'email'), required: true, sx: TextFieldStyling({ width: '100%', marginTop: '10px' }) }),
        React__default.createElement(TextField, { label: "Given Name (Optional)", value: attributeMapping.given_name, onChange: (e) => onAttrUpdate(e.target.value, 'given_name'), sx: TextFieldStyling({ width: '100%', marginTop: '10px' }) }),
        React__default.createElement(TextField, { label: "Family Name (Optional)", value: attributeMapping.family_name, onChange: (e) => onAttrUpdate(e.target.value, 'family_name'), sx: TextFieldStyling({ width: '100%', marginTop: '10px' }) }),
        React__default.createElement(RTButton, { type: "primary", variant: "contained", disabled: saveDisabled, isSubmit: true, sx: { marginTop: '20px', width: '47%' }, text: "Save" }),
        React__default.createElement(RTButton, { type: "delete", variant: "contained", disabled: !ssoConfig.Sort, onClick: () => setDeleteDialogOpen(true), sx: { marginTop: '20px', marginLeft: '10px', width: '47%', float: 'right' }, text: "Delete" }),
        React__default.createElement(ConfirmationDialog, { title: "Delete SSO Provider", message: "Are you sure you want to delete this SSO Provider?", open: deleteDialogOpen, onCancel: () => setDeleteDialogOpen(false), onConfirm: () => onDelete(ssoConfig) })));
};

const RTRavaSettings = ({ ravaApiUrl, ravaApiUrlEU, apiUrl, TenantDetails }) => {
    const requestHelper = RequestHelper.getInstance(apiUrl);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [kinesisDetails, setKinesisDetails] = useState(blankRavaKinesisDetails);
    const [saveDisabled, setSaveDisabled] = useState(true);
    const [ravaUrl, setRavaUrl] = useState('');
    const checkSaveDisabled = () => {
        if (ravaUrl === '') {
            return;
        }
        if (kinesisDetails.role_arn === '' || kinesisDetails.role_session_name === '') {
            setSaveDisabled(true);
        }
        else {
            setSaveDisabled(false);
        }
    };
    useEffect(() => {
        if (TenantDetails) {
            if (TenantDetails.region.startsWith('eu-west')) {
                setRavaUrl(ravaApiUrlEU);
            }
            else {
                setRavaUrl(ravaApiUrl);
            }
        }
    }, [TenantDetails, ravaApiUrl, ravaApiUrlEU]);
    const getTenantKinesisDetailsFN = () => __awaiter$1(void 0, void 0, void 0, function* () {
        setLoading(true);
        const res = yield requestHelper.makeAuthenticatedRequest({ requestFn: () => __awaiter$1(void 0, void 0, void 0, function* () {
                const url = `${ravaUrl}/${TenantDetails === null || TenantDetails === void 0 ? void 0 : TenantDetails.TenantId}`;
                const res2 = yield axios(url, { method: 'get', validateStatus: (status) => true });
                return res2;
            }), setError });
        if (res) {
            console.log(res);
            setKinesisDetails(res);
            if (!res.tenant_id) {
                setKinesisDetails(Object.assign(Object.assign({}, kinesisDetails), { tenant_id: (TenantDetails === null || TenantDetails === void 0 ? void 0 : TenantDetails.TenantId) || '' }));
            }
        }
        if (!res && kinesisDetails.tenant_id === '') {
            setKinesisDetails(Object.assign(Object.assign({}, kinesisDetails), { tenant_id: (TenantDetails === null || TenantDetails === void 0 ? void 0 : TenantDetails.TenantId) || '' }));
        }
        setLoading(false);
    });
    const getTenantKinesisDetails = useCallback(getTenantKinesisDetailsFN, [TenantDetails, kinesisDetails, ravaUrl, requestHelper]);
    const addUpdateKinesisDetails = () => __awaiter$1(void 0, void 0, void 0, function* () {
        setLoading(true);
        const res = yield requestHelper.makeAuthenticatedRequest({ requestFn: () => __awaiter$1(void 0, void 0, void 0, function* () {
                const url = `${ravaUrl}/${kinesisDetails.tenant_id}/add-kinesis-details`;
                const res = yield axios(url, { method: 'post', data: kinesisDetails, validateStatus: (status) => true });
                return res;
            }), setError });
        if (res) {
            setSuccessMessage('Kinesis details updated successfully');
        }
        setLoading(false);
    });
    const handleValueUpdated = (value, attrName) => {
        setKinesisDetails(Object.assign(Object.assign({}, kinesisDetails), { [attrName]: value }));
        checkSaveDisabled();
    };
    const handleFormSubmit = (event) => {
        event.preventDefault();
        addUpdateKinesisDetails();
    };
    useEffect(() => {
        if (kinesisDetails.tenant_id === '' && ravaUrl !== '') {
            getTenantKinesisDetails();
        }
    }, [getTenantKinesisDetails, kinesisDetails, ravaUrl]);
    return (React__default.createElement(Box, null,
        React__default.createElement(Typography, { variant: "h5", sx: { marginBottom: '15px', width: '100%' } }, "Rava Kinesis Settings"),
        loading ? React__default.createElement(ScaleLoader, { color: colors.primary20 }) :
            React__default.createElement("form", { onSubmit: handleFormSubmit },
                React__default.createElement(TextField, { label: "Role Arn (Required)", value: kinesisDetails.role_arn, onChange: (e) => handleValueUpdated(e.target.value, 'role_arn'), required: true, sx: TextFieldStyling({ width: '100%', marginTop: '10px' }) }),
                React__default.createElement(TextField, { label: "Role Session Name (Required)", value: kinesisDetails.role_session_name, onChange: (e) => handleValueUpdated(e.target.value, 'role_session_name'), required: true, sx: TextFieldStyling({ width: '100%', marginTop: '10px' }) }),
                React__default.createElement(TextField, { label: "Custom Issue Detection Prompt", value: kinesisDetails.custom_issue_detection_prompt, onChange: (e) => handleValueUpdated(e.target.value, 'custom_issue_detection_prompt'), rows: 20, multiline: true, sx: TextFieldStyling({ width: '100%', marginTop: '10px' }) }),
                React__default.createElement(RTButton, { type: "primary", variant: "contained", disabled: saveDisabled, isSubmit: true, sx: { marginTop: '20px', width: '47%' }, text: "Save" })),
        React__default.createElement(ErrorPrompt, { error: error, message: error, successMessage: successMessage })));
};

const RTEditTenantFields = ({ apiUrl, TenantId, ravaApiUrl, ravaApiUrlEU, TenantDetails, hideTokens, successCallback }) => {
    const requestHelper = RequestHelper.getInstance(apiUrl);
    const { currentUser, i18n, flags } = useAuth$1();
    const [loading, setLoading] = useState(false);
    const [updateLoading, setUpdateLoading] = useState(false);
    const [tenant, setTenant] = useState(undefined);
    const [tenantLoaded, setTenantLoaded] = useState(false);
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [showCustomerFields, setShowCustomerFields] = useState(false);
    const [tabIndex, setTabIndex] = useState(0);
    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
    };
    const getTenantFn = () => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!loading && !tenantLoaded) {
            setLoading(true);
            const res = yield requestHelper.getTenant({ TenantId, setError });
            setTenant(res);
            setTenantLoaded(true);
            setLoading(false);
        }
    });
    const getTenant = useCallback(getTenantFn, [TenantId, loading, tenantLoaded, requestHelper]);
    const updateTenant = (event) => __awaiter$1(void 0, void 0, void 0, function* () {
        event.preventDefault();
        if (!tenant) {
            return;
        }
        setUpdateLoading(true);
        let res;
        if (!tenant.TenantId) {
            res = yield requestHelper.createTenant({ TenantParams: tenant, setError });
        }
        else {
            res = yield requestHelper.updateTenant({ TenantId, TenantParams: tenant, setError });
        }
        if (res) {
            setTenant(res);
            setSuccessMessage(i18n.t('update_successful'));
            setError('');
            if (successCallback) {
                successCallback(res);
            }
        }
        setUpdateLoading(false);
    });
    const updateAttribute = (attribute, value) => {
        if (!tenant) {
            return;
        }
        if (TenantNumericFields.includes(attribute) && typeof value === 'string') {
            setTenant(Object.assign(Object.assign({}, tenant), { [attribute]: Number(value) }));
            return;
        }
        setTenant(Object.assign(Object.assign({}, tenant), { [attribute]: value }));
    };
    useEffect(() => {
        if (TenantDetails) {
            setTenant(TenantDetails);
            setTenantLoaded(true);
            return;
        }
        getTenant();
    }, [TenantDetails, getTenant]);
    const currentUserCanEditSSOSettings = checkRoles(currentUser || {}, [`canCreateSamlConfig:${tenant === null || tenant === void 0 ? void 0 : tenant.TenantId}`]);
    const currentUserCanEditRavaSettings = checkRoles(currentUser || {}, [`canCreateRavaConfig:${tenant === null || tenant === void 0 ? void 0 : tenant.TenantId}`]);
    return (React__default.createElement(ThemeProvider, { theme: theme },
        React__default.createElement(Box, { sx: { backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', minWidth: '750px', flexWrap: 'wrap', marginBottom: '30px' } }, loading || !tenantLoaded ? React__default.createElement(ScaleLoader, { color: colors.primary20 }) : React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Box, { sx: { width: '750px' } },
                React__default.createElement(Typography, { variant: "h4", sx: { marginBottom: '20px', textAlign: 'right' } }, (tenant === null || tenant === void 0 ? void 0 : tenant.TenantId) ? `${i18n.t('edit')} ${tenant === null || tenant === void 0 ? void 0 : tenant.displayName}` : 'Create Tenant'),
                React__default.createElement(Tabs, { value: tabIndex, onChange: handleTabChange, "aria-label": "simple tabs example" },
                    React__default.createElement(Tab, { label: "Tenant Settings" }),
                    currentUserCanEditSSOSettings && React__default.createElement(Tab, { label: "SSO Config" }),
                    ravaApiUrl && ravaApiUrlEU && currentUserCanEditRavaSettings && React__default.createElement(Tab, { label: "RAVA Config" })),
                React__default.createElement("form", { onSubmit: updateTenant, id: 'edit-tenant', hidden: tabIndex !== 0 },
                    React__default.createElement(CoreFieldsComp, { tenant: tenant, updateAttribute: updateAttribute, currentUser: currentUser }),
                    React__default.createElement(FormControlLabel, { control: React__default.createElement(Switch, { checked: showCustomerFields, onChange: (event) => setShowCustomerFields(event.target.checked) }), label: i18n.t('show_terminology_fields') }),
                    showCustomerFields && React__default.createElement(CustomerFieldsComp, { tenant: tenant, updateAttribute: updateAttribute, currentUser: currentUser }),
                    React__default.createElement(PlatformFieldsComp, { tenant: tenant, updateAttribute: updateAttribute, currentUser: currentUser }),
                    React__default.createElement(SecurityFieldsComp, { tenant: tenant, updateAttribute: updateAttribute, currentUser: currentUser }),
                    React__default.createElement(ErrorPrompt, { id: "error-success-box", message: error, successMessage: successMessage }),
                    React__default.createElement(Box, { sx: { marginBottom: '20px', width: '40%', marginLeft: 'auto' } },
                        React__default.createElement(RTButton, { id: "edit-tenant-submit-button", text: (tenant === null || tenant === void 0 ? void 0 : tenant.TenantId) ? `${i18n.t('save')} ${tenant === null || tenant === void 0 ? void 0 : tenant.displayName}` : 'Create Tenant', type: "primary", isSubmit: true, isLoading: updateLoading })),
                    (tenant === null || tenant === void 0 ? void 0 : tenant.TenantId) && tenant.TenantId.length > 0 && !hideTokens && React__default.createElement(RTAPIToken$1, { apiUrl: apiUrl, TenantId: TenantId })),
                flags.showSSOSettings && checkRoles(currentUser || {}, [`canCreateSamlConfig:${tenant === null || tenant === void 0 ? void 0 : tenant.TenantId}`]) && tabIndex === 1 && React__default.createElement(SSOFields, { TenantDetails: tenant, apiUrl: apiUrl, TenantId: TenantId }),
                ravaApiUrl && ravaApiUrlEU && tabIndex === 2 && React__default.createElement(RTRavaSettings, { apiUrl: apiUrl, ravaApiUrl: ravaApiUrl, ravaApiUrlEU: ravaApiUrlEU, TenantDetails: tenant }))))));
};

class Subscribable {
  constructor() {
    this.listeners = new Set();
    this.subscribe = this.subscribe.bind(this);
  }

  subscribe(listener) {
    const identity = {
      listener
    };
    this.listeners.add(identity);
    this.onSubscribe();
    return () => {
      this.listeners.delete(identity);
      this.onUnsubscribe();
    };
  }

  hasListeners() {
    return this.listeners.size > 0;
  }

  onSubscribe() {// Do nothing
  }

  onUnsubscribe() {// Do nothing
  }

}

// TYPES
// UTILS
const isServer = typeof window === 'undefined' || 'Deno' in window;
function noop() {
  return undefined;
}
function functionalUpdate(updater, input) {
  return typeof updater === 'function' ? updater(input) : updater;
}
function isValidTimeout(value) {
  return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function timeUntilStale(updatedAt, staleTime) {
  return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function parseQueryArgs(arg1, arg2, arg3) {
  if (!isQueryKey(arg1)) {
    return arg1;
  }

  if (typeof arg2 === 'function') {
    return { ...arg3,
      queryKey: arg1,
      queryFn: arg2
    };
  }

  return { ...arg2,
    queryKey: arg1
  };
}
function parseFilterArgs(arg1, arg2, arg3) {
  return isQueryKey(arg1) ? [{ ...arg2,
    queryKey: arg1
  }, arg3] : [arg1 || {}, arg2];
}
function matchQuery(filters, query) {
  const {
    type = 'all',
    exact,
    fetchStatus,
    predicate,
    queryKey,
    stale
  } = filters;

  if (isQueryKey(queryKey)) {
    if (exact) {
      if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) {
        return false;
      }
    } else if (!partialMatchKey(query.queryKey, queryKey)) {
      return false;
    }
  }

  if (type !== 'all') {
    const isActive = query.isActive();

    if (type === 'active' && !isActive) {
      return false;
    }

    if (type === 'inactive' && isActive) {
      return false;
    }
  }

  if (typeof stale === 'boolean' && query.isStale() !== stale) {
    return false;
  }

  if (typeof fetchStatus !== 'undefined' && fetchStatus !== query.state.fetchStatus) {
    return false;
  }

  if (predicate && !predicate(query)) {
    return false;
  }

  return true;
}
function matchMutation(filters, mutation) {
  const {
    exact,
    fetching,
    predicate,
    mutationKey
  } = filters;

  if (isQueryKey(mutationKey)) {
    if (!mutation.options.mutationKey) {
      return false;
    }

    if (exact) {
      if (hashQueryKey(mutation.options.mutationKey) !== hashQueryKey(mutationKey)) {
        return false;
      }
    } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) {
      return false;
    }
  }

  if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) {
    return false;
  }

  if (predicate && !predicate(mutation)) {
    return false;
  }

  return true;
}
function hashQueryKeyByOptions(queryKey, options) {
  const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || hashQueryKey;
  return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 * Hashes the value into a stable hash.
 */

function hashQueryKey(queryKey) {
  return JSON.stringify(queryKey, (_, val) => isPlainObject(val) ? Object.keys(val).sort().reduce((result, key) => {
    result[key] = val[key];
    return result;
  }, {}) : val);
}
/**
 * Checks if key `b` partially matches with key `a`.
 */

function partialMatchKey(a, b) {
  return partialDeepEqual(a, b);
}
/**
 * Checks if `b` partially matches with `a`.
 */

function partialDeepEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (typeof a !== typeof b) {
    return false;
  }

  if (a && b && typeof a === 'object' && typeof b === 'object') {
    return !Object.keys(b).some(key => !partialDeepEqual(a[key], b[key]));
  }

  return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */

function replaceEqualDeep(a, b) {
  if (a === b) {
    return a;
  }

  const array = isPlainArray(a) && isPlainArray(b);

  if (array || isPlainObject(a) && isPlainObject(b)) {
    const aSize = array ? a.length : Object.keys(a).length;
    const bItems = array ? b : Object.keys(b);
    const bSize = bItems.length;
    const copy = array ? [] : {};
    let equalItems = 0;

    for (let i = 0; i < bSize; i++) {
      const key = array ? i : bItems[i];
      copy[key] = replaceEqualDeep(a[key], b[key]);

      if (copy[key] === a[key]) {
        equalItems++;
      }
    }

    return aSize === bSize && equalItems === aSize ? a : copy;
  }

  return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */

function shallowEqualObjects(a, b) {
  if (a && !b || b && !a) {
    return false;
  }

  for (const key in a) {
    if (a[key] !== b[key]) {
      return false;
    }
  }

  return true;
}
function isPlainArray(value) {
  return Array.isArray(value) && value.length === Object.keys(value).length;
} // Copied from: https://github.com/jonschlinkert/is-plain-object

function isPlainObject(o) {
  if (!hasObjectPrototype(o)) {
    return false;
  } // If has modified constructor


  const ctor = o.constructor;

  if (typeof ctor === 'undefined') {
    return true;
  } // If has modified prototype


  const prot = ctor.prototype;

  if (!hasObjectPrototype(prot)) {
    return false;
  } // If constructor does not have an Object-specific method


  if (!prot.hasOwnProperty('isPrototypeOf')) {
    return false;
  } // Most likely a plain Object


  return true;
}

function hasObjectPrototype(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

function isQueryKey(value) {
  return Array.isArray(value);
}
function sleep(timeout) {
  return new Promise(resolve => {
    setTimeout(resolve, timeout);
  });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */

function scheduleMicrotask(callback) {
  sleep(0).then(callback);
}
function getAbortController() {
  if (typeof AbortController === 'function') {
    return new AbortController();
  }

  return;
}
function replaceData(prevData, data, options) {
  // Use prev data if an isDataEqual function is defined and returns `true`
  if (options.isDataEqual != null && options.isDataEqual(prevData, data)) {
    return prevData;
  } else if (typeof options.structuralSharing === 'function') {
    return options.structuralSharing(prevData, data);
  } else if (options.structuralSharing !== false) {
    // Structurally share data between prev and new data if needed
    return replaceEqualDeep(prevData, data);
  }

  return data;
}

class FocusManager extends Subscribable {
  constructor() {
    super();

    this.setup = onFocus => {
      // addEventListener does not exist in React Native, but window does
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      if (!isServer && window.addEventListener) {
        const listener = () => onFocus(); // Listen to visibillitychange and focus


        window.addEventListener('visibilitychange', listener, false);
        window.addEventListener('focus', listener, false);
        return () => {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('visibilitychange', listener);
          window.removeEventListener('focus', listener);
        };
      }

      return;
    };
  }

  onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  }

  onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  }

  setEventListener(setup) {
    var _this$cleanup2;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(focused => {
      if (typeof focused === 'boolean') {
        this.setFocused(focused);
      } else {
        this.onFocus();
      }
    });
  }

  setFocused(focused) {
    const changed = this.focused !== focused;

    if (changed) {
      this.focused = focused;
      this.onFocus();
    }
  }

  onFocus() {
    this.listeners.forEach(({
      listener
    }) => {
      listener();
    });
  }

  isFocused() {
    if (typeof this.focused === 'boolean') {
      return this.focused;
    } // document global can be unavailable in react native


    if (typeof document === 'undefined') {
      return true;
    }

    return [undefined, 'visible', 'prerender'].includes(document.visibilityState);
  }

}
const focusManager = new FocusManager();

const onlineEvents = ['online', 'offline'];
class OnlineManager extends Subscribable {
  constructor() {
    super();

    this.setup = onOnline => {
      // addEventListener does not exist in React Native, but window does
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      if (!isServer && window.addEventListener) {
        const listener = () => onOnline(); // Listen to online


        onlineEvents.forEach(event => {
          window.addEventListener(event, listener, false);
        });
        return () => {
          // Be sure to unsubscribe if a new handler is set
          onlineEvents.forEach(event => {
            window.removeEventListener(event, listener);
          });
        };
      }

      return;
    };
  }

  onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  }

  onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  }

  setEventListener(setup) {
    var _this$cleanup2;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(online => {
      if (typeof online === 'boolean') {
        this.setOnline(online);
      } else {
        this.onOnline();
      }
    });
  }

  setOnline(online) {
    const changed = this.online !== online;

    if (changed) {
      this.online = online;
      this.onOnline();
    }
  }

  onOnline() {
    this.listeners.forEach(({
      listener
    }) => {
      listener();
    });
  }

  isOnline() {
    if (typeof this.online === 'boolean') {
      return this.online;
    }

    if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') {
      return true;
    }

    return navigator.onLine;
  }

}
const onlineManager = new OnlineManager();

function defaultRetryDelay(failureCount) {
  return Math.min(1000 * 2 ** failureCount, 30000);
}

function canFetch(networkMode) {
  return (networkMode != null ? networkMode : 'online') === 'online' ? onlineManager.isOnline() : true;
}
class CancelledError {
  constructor(options) {
    this.revert = options == null ? void 0 : options.revert;
    this.silent = options == null ? void 0 : options.silent;
  }

}
function isCancelledError(value) {
  return value instanceof CancelledError;
}
function createRetryer(config) {
  let isRetryCancelled = false;
  let failureCount = 0;
  let isResolved = false;
  let continueFn;
  let promiseResolve;
  let promiseReject;
  const promise = new Promise((outerResolve, outerReject) => {
    promiseResolve = outerResolve;
    promiseReject = outerReject;
  });

  const cancel = cancelOptions => {
    if (!isResolved) {
      reject(new CancelledError(cancelOptions));
      config.abort == null ? void 0 : config.abort();
    }
  };

  const cancelRetry = () => {
    isRetryCancelled = true;
  };

  const continueRetry = () => {
    isRetryCancelled = false;
  };

  const shouldPause = () => !focusManager.isFocused() || config.networkMode !== 'always' && !onlineManager.isOnline();

  const resolve = value => {
    if (!isResolved) {
      isResolved = true;
      config.onSuccess == null ? void 0 : config.onSuccess(value);
      continueFn == null ? void 0 : continueFn();
      promiseResolve(value);
    }
  };

  const reject = value => {
    if (!isResolved) {
      isResolved = true;
      config.onError == null ? void 0 : config.onError(value);
      continueFn == null ? void 0 : continueFn();
      promiseReject(value);
    }
  };

  const pause = () => {
    return new Promise(continueResolve => {
      continueFn = value => {
        const canContinue = isResolved || !shouldPause();

        if (canContinue) {
          continueResolve(value);
        }

        return canContinue;
      };

      config.onPause == null ? void 0 : config.onPause();
    }).then(() => {
      continueFn = undefined;

      if (!isResolved) {
        config.onContinue == null ? void 0 : config.onContinue();
      }
    });
  }; // Create loop function


  const run = () => {
    // Do nothing if already resolved
    if (isResolved) {
      return;
    }

    let promiseOrValue; // Execute query

    try {
      promiseOrValue = config.fn();
    } catch (error) {
      promiseOrValue = Promise.reject(error);
    }

    Promise.resolve(promiseOrValue).then(resolve).catch(error => {
      var _config$retry, _config$retryDelay;

      // Stop if the fetch is already resolved
      if (isResolved) {
        return;
      } // Do we need to retry the request?


      const retry = (_config$retry = config.retry) != null ? _config$retry : 3;
      const retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : defaultRetryDelay;
      const delay = typeof retryDelay === 'function' ? retryDelay(failureCount, error) : retryDelay;
      const shouldRetry = retry === true || typeof retry === 'number' && failureCount < retry || typeof retry === 'function' && retry(failureCount, error);

      if (isRetryCancelled || !shouldRetry) {
        // We are done if the query does not need to be retried
        reject(error);
        return;
      }

      failureCount++; // Notify on fail

      config.onFail == null ? void 0 : config.onFail(failureCount, error); // Delay

      sleep(delay) // Pause if the document is not visible or when the device is offline
      .then(() => {
        if (shouldPause()) {
          return pause();
        }

        return;
      }).then(() => {
        if (isRetryCancelled) {
          reject(error);
        } else {
          run();
        }
      });
    });
  }; // Start loop


  if (canFetch(config.networkMode)) {
    run();
  } else {
    pause().then(run);
  }

  return {
    promise,
    cancel,
    continue: () => {
      const didContinue = continueFn == null ? void 0 : continueFn();
      return didContinue ? promise : Promise.resolve();
    },
    cancelRetry,
    continueRetry
  };
}

const defaultLogger = console;

function createNotifyManager() {
  let queue = [];
  let transactions = 0;

  let notifyFn = callback => {
    callback();
  };

  let batchNotifyFn = callback => {
    callback();
  };

  const batch = callback => {
    let result;
    transactions++;

    try {
      result = callback();
    } finally {
      transactions--;

      if (!transactions) {
        flush();
      }
    }

    return result;
  };

  const schedule = callback => {
    if (transactions) {
      queue.push(callback);
    } else {
      scheduleMicrotask(() => {
        notifyFn(callback);
      });
    }
  };
  /**
   * All calls to the wrapped function will be batched.
   */


  const batchCalls = callback => {
    return (...args) => {
      schedule(() => {
        callback(...args);
      });
    };
  };

  const flush = () => {
    const originalQueue = queue;
    queue = [];

    if (originalQueue.length) {
      scheduleMicrotask(() => {
        batchNotifyFn(() => {
          originalQueue.forEach(callback => {
            notifyFn(callback);
          });
        });
      });
    }
  };
  /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */


  const setNotifyFunction = fn => {
    notifyFn = fn;
  };
  /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */


  const setBatchNotifyFunction = fn => {
    batchNotifyFn = fn;
  };

  return {
    batch,
    batchCalls,
    schedule,
    setNotifyFunction,
    setBatchNotifyFunction
  };
} // SINGLETON

const notifyManager = createNotifyManager();

class Removable {
  destroy() {
    this.clearGcTimeout();
  }

  scheduleGc() {
    this.clearGcTimeout();

    if (isValidTimeout(this.cacheTime)) {
      this.gcTimeout = setTimeout(() => {
        this.optionalRemove();
      }, this.cacheTime);
    }
  }

  updateCacheTime(newCacheTime) {
    // Default to 5 minutes (Infinity for server-side) if no cache time is set
    this.cacheTime = Math.max(this.cacheTime || 0, newCacheTime != null ? newCacheTime : isServer ? Infinity : 5 * 60 * 1000);
  }

  clearGcTimeout() {
    if (this.gcTimeout) {
      clearTimeout(this.gcTimeout);
      this.gcTimeout = undefined;
    }
  }

}

// CLASS
class Query extends Removable {
  constructor(config) {
    super();
    this.abortSignalConsumed = false;
    this.defaultOptions = config.defaultOptions;
    this.setOptions(config.options);
    this.observers = [];
    this.cache = config.cache;
    this.logger = config.logger || defaultLogger;
    this.queryKey = config.queryKey;
    this.queryHash = config.queryHash;
    this.initialState = config.state || getDefaultState$1(this.options);
    this.state = this.initialState;
    this.scheduleGc();
  }

  get meta() {
    return this.options.meta;
  }

  setOptions(options) {
    this.options = { ...this.defaultOptions,
      ...options
    };
    this.updateCacheTime(this.options.cacheTime);
  }

  optionalRemove() {
    if (!this.observers.length && this.state.fetchStatus === 'idle') {
      this.cache.remove(this);
    }
  }

  setData(newData, options) {
    const data = replaceData(this.state.data, newData, this.options); // Set data and mark it as cached

    this.dispatch({
      data,
      type: 'success',
      dataUpdatedAt: options == null ? void 0 : options.updatedAt,
      manual: options == null ? void 0 : options.manual
    });
    return data;
  }

  setState(state, setStateOptions) {
    this.dispatch({
      type: 'setState',
      state,
      setStateOptions
    });
  }

  cancel(options) {
    var _this$retryer;

    const promise = this.promise;
    (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.cancel(options);
    return promise ? promise.then(noop).catch(noop) : Promise.resolve();
  }

  destroy() {
    super.destroy();
    this.cancel({
      silent: true
    });
  }

  reset() {
    this.destroy();
    this.setState(this.initialState);
  }

  isActive() {
    return this.observers.some(observer => observer.options.enabled !== false);
  }

  isDisabled() {
    return this.getObserversCount() > 0 && !this.isActive();
  }

  isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(observer => observer.getCurrentResult().isStale);
  }

  isStaleByTime(staleTime = 0) {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || !timeUntilStale(this.state.dataUpdatedAt, staleTime);
  }

  onFocus() {
    var _this$retryer2;

    const observer = this.observers.find(x => x.shouldFetchOnWindowFocus());

    if (observer) {
      observer.refetch({
        cancelRefetch: false
      });
    } // Continue fetch if currently paused


    (_this$retryer2 = this.retryer) == null ? void 0 : _this$retryer2.continue();
  }

  onOnline() {
    var _this$retryer3;

    const observer = this.observers.find(x => x.shouldFetchOnReconnect());

    if (observer) {
      observer.refetch({
        cancelRefetch: false
      });
    } // Continue fetch if currently paused


    (_this$retryer3 = this.retryer) == null ? void 0 : _this$retryer3.continue();
  }

  addObserver(observer) {
    if (!this.observers.includes(observer)) {
      this.observers.push(observer); // Stop the query from being garbage collected

      this.clearGcTimeout();
      this.cache.notify({
        type: 'observerAdded',
        query: this,
        observer
      });
    }
  }

  removeObserver(observer) {
    if (this.observers.includes(observer)) {
      this.observers = this.observers.filter(x => x !== observer);

      if (!this.observers.length) {
        // If the transport layer does not support cancellation
        // we'll let the query continue so the result can be cached
        if (this.retryer) {
          if (this.abortSignalConsumed) {
            this.retryer.cancel({
              revert: true
            });
          } else {
            this.retryer.cancelRetry();
          }
        }

        this.scheduleGc();
      }

      this.cache.notify({
        type: 'observerRemoved',
        query: this,
        observer
      });
    }
  }

  getObserversCount() {
    return this.observers.length;
  }

  invalidate() {
    if (!this.state.isInvalidated) {
      this.dispatch({
        type: 'invalidate'
      });
    }
  }

  fetch(options, fetchOptions) {
    var _this$options$behavio, _context$fetchOptions;

    if (this.state.fetchStatus !== 'idle') {
      if (this.state.dataUpdatedAt && fetchOptions != null && fetchOptions.cancelRefetch) {
        // Silently cancel current fetch if the user wants to cancel refetches
        this.cancel({
          silent: true
        });
      } else if (this.promise) {
        var _this$retryer4;

        // make sure that retries that were potentially cancelled due to unmounts can continue
        (_this$retryer4 = this.retryer) == null ? void 0 : _this$retryer4.continueRetry(); // Return current promise if we are already fetching

        return this.promise;
      }
    } // Update config if passed, otherwise the config from the last execution is used


    if (options) {
      this.setOptions(options);
    } // Use the options from the first observer with a query function if no function is found.
    // This can happen when the query is hydrated or created with setQueryData.


    if (!this.options.queryFn) {
      const observer = this.observers.find(x => x.options.queryFn);

      if (observer) {
        this.setOptions(observer.options);
      }
    }

    if (process.env.NODE_ENV !== 'production') {
      if (!Array.isArray(this.options.queryKey)) {
        this.logger.error("As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']");
      }
    }

    const abortController = getAbortController(); // Create query function context

    const queryFnContext = {
      queryKey: this.queryKey,
      pageParam: undefined,
      meta: this.meta
    }; // Adds an enumerable signal property to the object that
    // which sets abortSignalConsumed to true when the signal
    // is read.

    const addSignalProperty = object => {
      Object.defineProperty(object, 'signal', {
        enumerable: true,
        get: () => {
          if (abortController) {
            this.abortSignalConsumed = true;
            return abortController.signal;
          }

          return undefined;
        }
      });
    };

    addSignalProperty(queryFnContext); // Create fetch function

    const fetchFn = () => {
      if (!this.options.queryFn) {
        return Promise.reject("Missing queryFn for queryKey '" + this.options.queryHash + "'");
      }

      this.abortSignalConsumed = false;
      return this.options.queryFn(queryFnContext);
    }; // Trigger behavior hook


    const context = {
      fetchOptions,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn
    };
    addSignalProperty(context);
    (_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch(context); // Store state in case the current fetch needs to be reverted

    this.revertState = this.state; // Set to fetching state if not already in it

    if (this.state.fetchStatus === 'idle' || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
      var _context$fetchOptions2;

      this.dispatch({
        type: 'fetch',
        meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
      });
    }

    const onError = error => {
      // Optimistically update state if needed
      if (!(isCancelledError(error) && error.silent)) {
        this.dispatch({
          type: 'error',
          error: error
        });
      }

      if (!isCancelledError(error)) {
        var _this$cache$config$on, _this$cache$config, _this$cache$config$on2, _this$cache$config2;

        // Notify cache callback
        (_this$cache$config$on = (_this$cache$config = this.cache.config).onError) == null ? void 0 : _this$cache$config$on.call(_this$cache$config, error, this);
        (_this$cache$config$on2 = (_this$cache$config2 = this.cache.config).onSettled) == null ? void 0 : _this$cache$config$on2.call(_this$cache$config2, this.state.data, error, this);

        if (process.env.NODE_ENV !== 'production') {
          this.logger.error(error);
        }
      }

      if (!this.isFetchingOptimistic) {
        // Schedule query gc after fetching
        this.scheduleGc();
      }

      this.isFetchingOptimistic = false;
    }; // Try to fetch the data


    this.retryer = createRetryer({
      fn: context.fetchFn,
      abort: abortController == null ? void 0 : abortController.abort.bind(abortController),
      onSuccess: data => {
        var _this$cache$config$on3, _this$cache$config3, _this$cache$config$on4, _this$cache$config4;

        if (typeof data === 'undefined') {
          if (process.env.NODE_ENV !== 'production') {
            this.logger.error("Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: " + this.queryHash);
          }

          onError(new Error(this.queryHash + " data is undefined"));
          return;
        }

        this.setData(data); // Notify cache callback

        (_this$cache$config$on3 = (_this$cache$config3 = this.cache.config).onSuccess) == null ? void 0 : _this$cache$config$on3.call(_this$cache$config3, data, this);
        (_this$cache$config$on4 = (_this$cache$config4 = this.cache.config).onSettled) == null ? void 0 : _this$cache$config$on4.call(_this$cache$config4, data, this.state.error, this);

        if (!this.isFetchingOptimistic) {
          // Schedule query gc after fetching
          this.scheduleGc();
        }

        this.isFetchingOptimistic = false;
      },
      onError,
      onFail: (failureCount, error) => {
        this.dispatch({
          type: 'failed',
          failureCount,
          error
        });
      },
      onPause: () => {
        this.dispatch({
          type: 'pause'
        });
      },
      onContinue: () => {
        this.dispatch({
          type: 'continue'
        });
      },
      retry: context.options.retry,
      retryDelay: context.options.retryDelay,
      networkMode: context.options.networkMode
    });
    this.promise = this.retryer.promise;
    return this.promise;
  }

  dispatch(action) {
    const reducer = state => {
      var _action$meta, _action$dataUpdatedAt;

      switch (action.type) {
        case 'failed':
          return { ...state,
            fetchFailureCount: action.failureCount,
            fetchFailureReason: action.error
          };

        case 'pause':
          return { ...state,
            fetchStatus: 'paused'
          };

        case 'continue':
          return { ...state,
            fetchStatus: 'fetching'
          };

        case 'fetch':
          return { ...state,
            fetchFailureCount: 0,
            fetchFailureReason: null,
            fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
            fetchStatus: canFetch(this.options.networkMode) ? 'fetching' : 'paused',
            ...(!state.dataUpdatedAt && {
              error: null,
              status: 'loading'
            })
          };

        case 'success':
          return { ...state,
            data: action.data,
            dataUpdateCount: state.dataUpdateCount + 1,
            dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
            error: null,
            isInvalidated: false,
            status: 'success',
            ...(!action.manual && {
              fetchStatus: 'idle',
              fetchFailureCount: 0,
              fetchFailureReason: null
            })
          };

        case 'error':
          const error = action.error;

          if (isCancelledError(error) && error.revert && this.revertState) {
            return { ...this.revertState,
              fetchStatus: 'idle'
            };
          }

          return { ...state,
            error: error,
            errorUpdateCount: state.errorUpdateCount + 1,
            errorUpdatedAt: Date.now(),
            fetchFailureCount: state.fetchFailureCount + 1,
            fetchFailureReason: error,
            fetchStatus: 'idle',
            status: 'error'
          };

        case 'invalidate':
          return { ...state,
            isInvalidated: true
          };

        case 'setState':
          return { ...state,
            ...action.state
          };
      }
    };

    this.state = reducer(this.state);
    notifyManager.batch(() => {
      this.observers.forEach(observer => {
        observer.onQueryUpdate(action);
      });
      this.cache.notify({
        query: this,
        type: 'updated',
        action
      });
    });
  }

}

function getDefaultState$1(options) {
  const data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
  const hasData = typeof data !== 'undefined';
  const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
  return {
    data,
    dataUpdateCount: 0,
    dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: false,
    status: hasData ? 'success' : 'loading',
    fetchStatus: 'idle'
  };
}

// CLASS
class QueryCache extends Subscribable {
  constructor(config) {
    super();
    this.config = config || {};
    this.queries = [];
    this.queriesMap = {};
  }

  build(client, options, state) {
    var _options$queryHash;

    const queryKey = options.queryKey;
    const queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : hashQueryKeyByOptions(queryKey, options);
    let query = this.get(queryHash);

    if (!query) {
      query = new Query({
        cache: this,
        logger: client.getLogger(),
        queryKey,
        queryHash,
        options: client.defaultQueryOptions(options),
        state,
        defaultOptions: client.getQueryDefaults(queryKey)
      });
      this.add(query);
    }

    return query;
  }

  add(query) {
    if (!this.queriesMap[query.queryHash]) {
      this.queriesMap[query.queryHash] = query;
      this.queries.push(query);
      this.notify({
        type: 'added',
        query
      });
    }
  }

  remove(query) {
    const queryInMap = this.queriesMap[query.queryHash];

    if (queryInMap) {
      query.destroy();
      this.queries = this.queries.filter(x => x !== query);

      if (queryInMap === query) {
        delete this.queriesMap[query.queryHash];
      }

      this.notify({
        type: 'removed',
        query
      });
    }
  }

  clear() {
    notifyManager.batch(() => {
      this.queries.forEach(query => {
        this.remove(query);
      });
    });
  }

  get(queryHash) {
    return this.queriesMap[queryHash];
  }

  getAll() {
    return this.queries;
  }

  find(arg1, arg2) {
    const [filters] = parseFilterArgs(arg1, arg2);

    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.queries.find(query => matchQuery(filters, query));
  }

  findAll(arg1, arg2) {
    const [filters] = parseFilterArgs(arg1, arg2);
    return Object.keys(filters).length > 0 ? this.queries.filter(query => matchQuery(filters, query)) : this.queries;
  }

  notify(event) {
    notifyManager.batch(() => {
      this.listeners.forEach(({
        listener
      }) => {
        listener(event);
      });
    });
  }

  onFocus() {
    notifyManager.batch(() => {
      this.queries.forEach(query => {
        query.onFocus();
      });
    });
  }

  onOnline() {
    notifyManager.batch(() => {
      this.queries.forEach(query => {
        query.onOnline();
      });
    });
  }

}

// CLASS
class Mutation extends Removable {
  constructor(config) {
    super();
    this.defaultOptions = config.defaultOptions;
    this.mutationId = config.mutationId;
    this.mutationCache = config.mutationCache;
    this.logger = config.logger || defaultLogger;
    this.observers = [];
    this.state = config.state || getDefaultState();
    this.setOptions(config.options);
    this.scheduleGc();
  }

  setOptions(options) {
    this.options = { ...this.defaultOptions,
      ...options
    };
    this.updateCacheTime(this.options.cacheTime);
  }

  get meta() {
    return this.options.meta;
  }

  setState(state) {
    this.dispatch({
      type: 'setState',
      state
    });
  }

  addObserver(observer) {
    if (!this.observers.includes(observer)) {
      this.observers.push(observer); // Stop the mutation from being garbage collected

      this.clearGcTimeout();
      this.mutationCache.notify({
        type: 'observerAdded',
        mutation: this,
        observer
      });
    }
  }

  removeObserver(observer) {
    this.observers = this.observers.filter(x => x !== observer);
    this.scheduleGc();
    this.mutationCache.notify({
      type: 'observerRemoved',
      mutation: this,
      observer
    });
  }

  optionalRemove() {
    if (!this.observers.length) {
      if (this.state.status === 'loading') {
        this.scheduleGc();
      } else {
        this.mutationCache.remove(this);
      }
    }
  }

  continue() {
    var _this$retryer$continu, _this$retryer;

    return (_this$retryer$continu = (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.continue()) != null ? _this$retryer$continu : this.execute();
  }

  async execute() {
    const executeMutation = () => {
      var _this$options$retry;

      this.retryer = createRetryer({
        fn: () => {
          if (!this.options.mutationFn) {
            return Promise.reject('No mutationFn found');
          }

          return this.options.mutationFn(this.state.variables);
        },
        onFail: (failureCount, error) => {
          this.dispatch({
            type: 'failed',
            failureCount,
            error
          });
        },
        onPause: () => {
          this.dispatch({
            type: 'pause'
          });
        },
        onContinue: () => {
          this.dispatch({
            type: 'continue'
          });
        },
        retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
        retryDelay: this.options.retryDelay,
        networkMode: this.options.networkMode
      });
      return this.retryer.promise;
    };

    const restored = this.state.status === 'loading';

    try {
      var _this$mutationCache$c3, _this$mutationCache$c4, _this$options$onSucce, _this$options2, _this$mutationCache$c5, _this$mutationCache$c6, _this$options$onSettl, _this$options3;

      if (!restored) {
        var _this$mutationCache$c, _this$mutationCache$c2, _this$options$onMutat, _this$options;

        this.dispatch({
          type: 'loading',
          variables: this.options.variables
        }); // Notify cache callback

        await ((_this$mutationCache$c = (_this$mutationCache$c2 = this.mutationCache.config).onMutate) == null ? void 0 : _this$mutationCache$c.call(_this$mutationCache$c2, this.state.variables, this));
        const context = await ((_this$options$onMutat = (_this$options = this.options).onMutate) == null ? void 0 : _this$options$onMutat.call(_this$options, this.state.variables));

        if (context !== this.state.context) {
          this.dispatch({
            type: 'loading',
            context,
            variables: this.state.variables
          });
        }
      }

      const data = await executeMutation(); // Notify cache callback

      await ((_this$mutationCache$c3 = (_this$mutationCache$c4 = this.mutationCache.config).onSuccess) == null ? void 0 : _this$mutationCache$c3.call(_this$mutationCache$c4, data, this.state.variables, this.state.context, this));
      await ((_this$options$onSucce = (_this$options2 = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options2, data, this.state.variables, this.state.context)); // Notify cache callback

      await ((_this$mutationCache$c5 = (_this$mutationCache$c6 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c5.call(_this$mutationCache$c6, data, null, this.state.variables, this.state.context, this));
      await ((_this$options$onSettl = (_this$options3 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options3, data, null, this.state.variables, this.state.context));
      this.dispatch({
        type: 'success',
        data
      });
      return data;
    } catch (error) {
      try {
        var _this$mutationCache$c7, _this$mutationCache$c8, _this$options$onError, _this$options4, _this$mutationCache$c9, _this$mutationCache$c10, _this$options$onSettl2, _this$options5;

        // Notify cache callback
        await ((_this$mutationCache$c7 = (_this$mutationCache$c8 = this.mutationCache.config).onError) == null ? void 0 : _this$mutationCache$c7.call(_this$mutationCache$c8, error, this.state.variables, this.state.context, this));

        if (process.env.NODE_ENV !== 'production') {
          this.logger.error(error);
        }

        await ((_this$options$onError = (_this$options4 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options4, error, this.state.variables, this.state.context)); // Notify cache callback

        await ((_this$mutationCache$c9 = (_this$mutationCache$c10 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c9.call(_this$mutationCache$c10, undefined, error, this.state.variables, this.state.context, this));
        await ((_this$options$onSettl2 = (_this$options5 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options5, undefined, error, this.state.variables, this.state.context));
        throw error;
      } finally {
        this.dispatch({
          type: 'error',
          error: error
        });
      }
    }
  }

  dispatch(action) {
    const reducer = state => {
      switch (action.type) {
        case 'failed':
          return { ...state,
            failureCount: action.failureCount,
            failureReason: action.error
          };

        case 'pause':
          return { ...state,
            isPaused: true
          };

        case 'continue':
          return { ...state,
            isPaused: false
          };

        case 'loading':
          return { ...state,
            context: action.context,
            data: undefined,
            failureCount: 0,
            failureReason: null,
            error: null,
            isPaused: !canFetch(this.options.networkMode),
            status: 'loading',
            variables: action.variables
          };

        case 'success':
          return { ...state,
            data: action.data,
            failureCount: 0,
            failureReason: null,
            error: null,
            status: 'success',
            isPaused: false
          };

        case 'error':
          return { ...state,
            data: undefined,
            error: action.error,
            failureCount: state.failureCount + 1,
            failureReason: action.error,
            isPaused: false,
            status: 'error'
          };

        case 'setState':
          return { ...state,
            ...action.state
          };
      }
    };

    this.state = reducer(this.state);
    notifyManager.batch(() => {
      this.observers.forEach(observer => {
        observer.onMutationUpdate(action);
      });
      this.mutationCache.notify({
        mutation: this,
        type: 'updated',
        action
      });
    });
  }

}
function getDefaultState() {
  return {
    context: undefined,
    data: undefined,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: false,
    status: 'idle',
    variables: undefined
  };
}

// CLASS
class MutationCache extends Subscribable {
  constructor(config) {
    super();
    this.config = config || {};
    this.mutations = [];
    this.mutationId = 0;
  }

  build(client, options, state) {
    const mutation = new Mutation({
      mutationCache: this,
      logger: client.getLogger(),
      mutationId: ++this.mutationId,
      options: client.defaultMutationOptions(options),
      state,
      defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined
    });
    this.add(mutation);
    return mutation;
  }

  add(mutation) {
    this.mutations.push(mutation);
    this.notify({
      type: 'added',
      mutation
    });
  }

  remove(mutation) {
    this.mutations = this.mutations.filter(x => x !== mutation);
    this.notify({
      type: 'removed',
      mutation
    });
  }

  clear() {
    notifyManager.batch(() => {
      this.mutations.forEach(mutation => {
        this.remove(mutation);
      });
    });
  }

  getAll() {
    return this.mutations;
  }

  find(filters) {
    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.mutations.find(mutation => matchMutation(filters, mutation));
  }

  findAll(filters) {
    return this.mutations.filter(mutation => matchMutation(filters, mutation));
  }

  notify(event) {
    notifyManager.batch(() => {
      this.listeners.forEach(({
        listener
      }) => {
        listener(event);
      });
    });
  }

  resumePausedMutations() {
    var _this$resuming;

    this.resuming = ((_this$resuming = this.resuming) != null ? _this$resuming : Promise.resolve()).then(() => {
      const pausedMutations = this.mutations.filter(x => x.state.isPaused);
      return notifyManager.batch(() => pausedMutations.reduce((promise, mutation) => promise.then(() => mutation.continue().catch(noop)), Promise.resolve()));
    }).then(() => {
      this.resuming = undefined;
    });
    return this.resuming;
  }

}

function infiniteQueryBehavior() {
  return {
    onFetch: context => {
      context.fetchFn = () => {
        var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;

        const refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
        const fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
        const pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
        const isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
        const isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
        const oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
        const oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
        let newPageParams = oldPageParams;
        let cancelled = false;

        const addSignalProperty = object => {
          Object.defineProperty(object, 'signal', {
            enumerable: true,
            get: () => {
              var _context$signal;

              if ((_context$signal = context.signal) != null && _context$signal.aborted) {
                cancelled = true;
              } else {
                var _context$signal2;

                (_context$signal2 = context.signal) == null ? void 0 : _context$signal2.addEventListener('abort', () => {
                  cancelled = true;
                });
              }

              return context.signal;
            }
          });
        }; // Get query function


        const queryFn = context.options.queryFn || (() => Promise.reject("Missing queryFn for queryKey '" + context.options.queryHash + "'"));

        const buildNewPages = (pages, param, page, previous) => {
          newPageParams = previous ? [param, ...newPageParams] : [...newPageParams, param];
          return previous ? [page, ...pages] : [...pages, page];
        }; // Create function to fetch a page


        const fetchPage = (pages, manual, param, previous) => {
          if (cancelled) {
            return Promise.reject('Cancelled');
          }

          if (typeof param === 'undefined' && !manual && pages.length) {
            return Promise.resolve(pages);
          }

          const queryFnContext = {
            queryKey: context.queryKey,
            pageParam: param,
            meta: context.options.meta
          };
          addSignalProperty(queryFnContext);
          const queryFnResult = queryFn(queryFnContext);
          const promise = Promise.resolve(queryFnResult).then(page => buildNewPages(pages, param, page, previous));
          return promise;
        };

        let promise; // Fetch first page?

        if (!oldPages.length) {
          promise = fetchPage([]);
        } // Fetch next page?
        else if (isFetchingNextPage) {
          const manual = typeof pageParam !== 'undefined';
          const param = manual ? pageParam : getNextPageParam(context.options, oldPages);
          promise = fetchPage(oldPages, manual, param);
        } // Fetch previous page?
        else if (isFetchingPreviousPage) {
          const manual = typeof pageParam !== 'undefined';
          const param = manual ? pageParam : getPreviousPageParam(context.options, oldPages);
          promise = fetchPage(oldPages, manual, param, true);
        } // Refetch pages
        else {
          newPageParams = [];
          const manual = typeof context.options.getNextPageParam === 'undefined';
          const shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page

          promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages

          for (let i = 1; i < oldPages.length; i++) {
            promise = promise.then(pages => {
              const shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;

              if (shouldFetchNextPage) {
                const param = manual ? oldPageParams[i] : getNextPageParam(context.options, pages);
                return fetchPage(pages, manual, param);
              }

              return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
            });
          }
        }

        const finalPromise = promise.then(pages => ({
          pages,
          pageParams: newPageParams
        }));
        return finalPromise;
      };
    }
  };
}
function getNextPageParam(options, pages) {
  return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function getPreviousPageParam(options, pages) {
  return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}

// CLASS
class QueryClient {
  constructor(config = {}) {
    this.queryCache = config.queryCache || new QueryCache();
    this.mutationCache = config.mutationCache || new MutationCache();
    this.logger = config.logger || defaultLogger;
    this.defaultOptions = config.defaultOptions || {};
    this.queryDefaults = [];
    this.mutationDefaults = [];
    this.mountCount = 0;

    if (process.env.NODE_ENV !== 'production' && config.logger) {
      this.logger.error("Passing a custom logger has been deprecated and will be removed in the next major version.");
    }
  }

  mount() {
    this.mountCount++;
    if (this.mountCount !== 1) return;
    this.unsubscribeFocus = focusManager.subscribe(() => {
      if (focusManager.isFocused()) {
        this.resumePausedMutations();
        this.queryCache.onFocus();
      }
    });
    this.unsubscribeOnline = onlineManager.subscribe(() => {
      if (onlineManager.isOnline()) {
        this.resumePausedMutations();
        this.queryCache.onOnline();
      }
    });
  }

  unmount() {
    var _this$unsubscribeFocu, _this$unsubscribeOnli;

    this.mountCount--;
    if (this.mountCount !== 0) return;
    (_this$unsubscribeFocu = this.unsubscribeFocus) == null ? void 0 : _this$unsubscribeFocu.call(this);
    this.unsubscribeFocus = undefined;
    (_this$unsubscribeOnli = this.unsubscribeOnline) == null ? void 0 : _this$unsubscribeOnli.call(this);
    this.unsubscribeOnline = undefined;
  }

  isFetching(arg1, arg2) {
    const [filters] = parseFilterArgs(arg1, arg2);
    filters.fetchStatus = 'fetching';
    return this.queryCache.findAll(filters).length;
  }

  isMutating(filters) {
    return this.mutationCache.findAll({ ...filters,
      fetching: true
    }).length;
  }

  getQueryData(queryKey, filters) {
    var _this$queryCache$find;

    return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
  }

  ensureQueryData(arg1, arg2, arg3) {
    const parsedOptions = parseQueryArgs(arg1, arg2, arg3);
    const cachedData = this.getQueryData(parsedOptions.queryKey);
    return cachedData ? Promise.resolve(cachedData) : this.fetchQuery(parsedOptions);
  }

  getQueriesData(queryKeyOrFilters) {
    return this.getQueryCache().findAll(queryKeyOrFilters).map(({
      queryKey,
      state
    }) => {
      const data = state.data;
      return [queryKey, data];
    });
  }

  setQueryData(queryKey, updater, options) {
    const query = this.queryCache.find(queryKey);
    const prevData = query == null ? void 0 : query.state.data;
    const data = functionalUpdate(updater, prevData);

    if (typeof data === 'undefined') {
      return undefined;
    }

    const parsedOptions = parseQueryArgs(queryKey);
    const defaultedOptions = this.defaultQueryOptions(parsedOptions);
    return this.queryCache.build(this, defaultedOptions).setData(data, { ...options,
      manual: true
    });
  }

  setQueriesData(queryKeyOrFilters, updater, options) {
    return notifyManager.batch(() => this.getQueryCache().findAll(queryKeyOrFilters).map(({
      queryKey
    }) => [queryKey, this.setQueryData(queryKey, updater, options)]));
  }

  getQueryState(queryKey, filters) {
    var _this$queryCache$find2;

    return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
  }

  removeQueries(arg1, arg2) {
    const [filters] = parseFilterArgs(arg1, arg2);
    const queryCache = this.queryCache;
    notifyManager.batch(() => {
      queryCache.findAll(filters).forEach(query => {
        queryCache.remove(query);
      });
    });
  }

  resetQueries(arg1, arg2, arg3) {
    const [filters, options] = parseFilterArgs(arg1, arg2, arg3);
    const queryCache = this.queryCache;
    const refetchFilters = {
      type: 'active',
      ...filters
    };
    return notifyManager.batch(() => {
      queryCache.findAll(filters).forEach(query => {
        query.reset();
      });
      return this.refetchQueries(refetchFilters, options);
    });
  }

  cancelQueries(arg1, arg2, arg3) {
    const [filters, cancelOptions = {}] = parseFilterArgs(arg1, arg2, arg3);

    if (typeof cancelOptions.revert === 'undefined') {
      cancelOptions.revert = true;
    }

    const promises = notifyManager.batch(() => this.queryCache.findAll(filters).map(query => query.cancel(cancelOptions)));
    return Promise.all(promises).then(noop).catch(noop);
  }

  invalidateQueries(arg1, arg2, arg3) {
    const [filters, options] = parseFilterArgs(arg1, arg2, arg3);
    return notifyManager.batch(() => {
      var _ref, _filters$refetchType;

      this.queryCache.findAll(filters).forEach(query => {
        query.invalidate();
      });

      if (filters.refetchType === 'none') {
        return Promise.resolve();
      }

      const refetchFilters = { ...filters,
        type: (_ref = (_filters$refetchType = filters.refetchType) != null ? _filters$refetchType : filters.type) != null ? _ref : 'active'
      };
      return this.refetchQueries(refetchFilters, options);
    });
  }

  refetchQueries(arg1, arg2, arg3) {
    const [filters, options] = parseFilterArgs(arg1, arg2, arg3);
    const promises = notifyManager.batch(() => this.queryCache.findAll(filters).filter(query => !query.isDisabled()).map(query => {
      var _options$cancelRefetc;

      return query.fetch(undefined, { ...options,
        cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
        meta: {
          refetchPage: filters.refetchPage
        }
      });
    }));
    let promise = Promise.all(promises).then(noop);

    if (!(options != null && options.throwOnError)) {
      promise = promise.catch(noop);
    }

    return promise;
  }

  fetchQuery(arg1, arg2, arg3) {
    const parsedOptions = parseQueryArgs(arg1, arg2, arg3);
    const defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652

    if (typeof defaultedOptions.retry === 'undefined') {
      defaultedOptions.retry = false;
    }

    const query = this.queryCache.build(this, defaultedOptions);
    return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
  }

  prefetchQuery(arg1, arg2, arg3) {
    return this.fetchQuery(arg1, arg2, arg3).then(noop).catch(noop);
  }

  fetchInfiniteQuery(arg1, arg2, arg3) {
    const parsedOptions = parseQueryArgs(arg1, arg2, arg3);
    parsedOptions.behavior = infiniteQueryBehavior();
    return this.fetchQuery(parsedOptions);
  }

  prefetchInfiniteQuery(arg1, arg2, arg3) {
    return this.fetchInfiniteQuery(arg1, arg2, arg3).then(noop).catch(noop);
  }

  resumePausedMutations() {
    return this.mutationCache.resumePausedMutations();
  }

  getQueryCache() {
    return this.queryCache;
  }

  getMutationCache() {
    return this.mutationCache;
  }

  getLogger() {
    return this.logger;
  }

  getDefaultOptions() {
    return this.defaultOptions;
  }

  setDefaultOptions(options) {
    this.defaultOptions = options;
  }

  setQueryDefaults(queryKey, options) {
    const result = this.queryDefaults.find(x => hashQueryKey(queryKey) === hashQueryKey(x.queryKey));

    if (result) {
      result.defaultOptions = options;
    } else {
      this.queryDefaults.push({
        queryKey,
        defaultOptions: options
      });
    }
  }

  getQueryDefaults(queryKey) {
    if (!queryKey) {
      return undefined;
    } // Get the first matching defaults


    const firstMatchingDefaults = this.queryDefaults.find(x => partialMatchKey(queryKey, x.queryKey)); // Additional checks and error in dev mode

    if (process.env.NODE_ENV !== 'production') {
      // Retrieve all matching defaults for the given key
      const matchingDefaults = this.queryDefaults.filter(x => partialMatchKey(queryKey, x.queryKey)); // It is ok not having defaults, but it is error prone to have more than 1 default for a given key

      if (matchingDefaults.length > 1) {
        this.logger.error("[QueryClient] Several query defaults match with key '" + JSON.stringify(queryKey) + "'. The first matching query defaults are used. Please check how query defaults are registered. Order does matter here. cf. https://react-query.tanstack.com/reference/QueryClient#queryclientsetquerydefaults.");
      }
    }

    return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
  }

  setMutationDefaults(mutationKey, options) {
    const result = this.mutationDefaults.find(x => hashQueryKey(mutationKey) === hashQueryKey(x.mutationKey));

    if (result) {
      result.defaultOptions = options;
    } else {
      this.mutationDefaults.push({
        mutationKey,
        defaultOptions: options
      });
    }
  }

  getMutationDefaults(mutationKey) {
    if (!mutationKey) {
      return undefined;
    } // Get the first matching defaults


    const firstMatchingDefaults = this.mutationDefaults.find(x => partialMatchKey(mutationKey, x.mutationKey)); // Additional checks and error in dev mode

    if (process.env.NODE_ENV !== 'production') {
      // Retrieve all matching defaults for the given key
      const matchingDefaults = this.mutationDefaults.filter(x => partialMatchKey(mutationKey, x.mutationKey)); // It is ok not having defaults, but it is error prone to have more than 1 default for a given key

      if (matchingDefaults.length > 1) {
        this.logger.error("[QueryClient] Several mutation defaults match with key '" + JSON.stringify(mutationKey) + "'. The first matching mutation defaults are used. Please check how mutation defaults are registered. Order does matter here. cf. https://react-query.tanstack.com/reference/QueryClient#queryclientsetmutationdefaults.");
      }
    }

    return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
  }

  defaultQueryOptions(options) {
    if (options != null && options._defaulted) {
      return options;
    }

    const defaultedOptions = { ...this.defaultOptions.queries,
      ...this.getQueryDefaults(options == null ? void 0 : options.queryKey),
      ...options,
      _defaulted: true
    };

    if (!defaultedOptions.queryHash && defaultedOptions.queryKey) {
      defaultedOptions.queryHash = hashQueryKeyByOptions(defaultedOptions.queryKey, defaultedOptions);
    } // dependent default values


    if (typeof defaultedOptions.refetchOnReconnect === 'undefined') {
      defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== 'always';
    }

    if (typeof defaultedOptions.useErrorBoundary === 'undefined') {
      defaultedOptions.useErrorBoundary = !!defaultedOptions.suspense;
    }

    return defaultedOptions;
  }

  defaultMutationOptions(options) {
    if (options != null && options._defaulted) {
      return options;
    }

    return { ...this.defaultOptions.mutations,
      ...this.getMutationDefaults(options == null ? void 0 : options.mutationKey),
      ...options,
      _defaulted: true
    };
  }

  clear() {
    this.queryCache.clear();
    this.mutationCache.clear();
  }

}

class QueryObserver extends Subscribable {
  constructor(client, options) {
    super();
    this.client = client;
    this.options = options;
    this.trackedProps = new Set();
    this.selectError = null;
    this.bindMethods();
    this.setOptions(options);
  }

  bindMethods() {
    this.remove = this.remove.bind(this);
    this.refetch = this.refetch.bind(this);
  }

  onSubscribe() {
    if (this.listeners.size === 1) {
      this.currentQuery.addObserver(this);

      if (shouldFetchOnMount(this.currentQuery, this.options)) {
        this.executeFetch();
      }

      this.updateTimers();
    }
  }

  onUnsubscribe() {
    if (!this.hasListeners()) {
      this.destroy();
    }
  }

  shouldFetchOnReconnect() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
  }

  shouldFetchOnWindowFocus() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
  }

  destroy() {
    this.listeners = new Set();
    this.clearStaleTimeout();
    this.clearRefetchInterval();
    this.currentQuery.removeObserver(this);
  }

  setOptions(options, notifyOptions) {
    const prevOptions = this.options;
    const prevQuery = this.currentQuery;
    this.options = this.client.defaultQueryOptions(options);

    if (process.env.NODE_ENV !== 'production' && typeof (options == null ? void 0 : options.isDataEqual) !== 'undefined') {
      this.client.getLogger().error("The isDataEqual option has been deprecated and will be removed in the next major version. You can achieve the same functionality by passing a function as the structuralSharing option");
    }

    if (!shallowEqualObjects(prevOptions, this.options)) {
      this.client.getQueryCache().notify({
        type: 'observerOptionsUpdated',
        query: this.currentQuery,
        observer: this
      });
    }

    if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') {
      throw new Error('Expected enabled to be a boolean');
    } // Keep previous query key if the user does not supply one


    if (!this.options.queryKey) {
      this.options.queryKey = prevOptions.queryKey;
    }

    this.updateQuery();
    const mounted = this.hasListeners(); // Fetch if there are subscribers

    if (mounted && shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) {
      this.executeFetch();
    } // Update result


    this.updateResult(notifyOptions); // Update stale interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) {
      this.updateStaleTimeout();
    }

    const nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) {
      this.updateRefetchInterval(nextRefetchInterval);
    }
  }

  getOptimisticResult(options) {
    const query = this.client.getQueryCache().build(this.client, options);
    const result = this.createResult(query, options);

    if (shouldAssignObserverCurrentProperties(this, result, options)) {
      // this assigns the optimistic result to the current Observer
      // because if the query function changes, useQuery will be performing
      // an effect where it would fetch again.
      // When the fetch finishes, we perform a deep data cloning in order
      // to reuse objects references. This deep data clone is performed against
      // the `observer.currentResult.data` property
      // When QueryKey changes, we refresh the query and get new `optimistic`
      // result, while we leave the `observer.currentResult`, so when new data
      // arrives, it finds the old `observer.currentResult` which is related
      // to the old QueryKey. Which means that currentResult and selectData are
      // out of sync already.
      // To solve this, we move the cursor of the currentResult everytime
      // an observer reads an optimistic value.
      // When keeping the previous data, the result doesn't change until new
      // data arrives.
      this.currentResult = result;
      this.currentResultOptions = this.options;
      this.currentResultState = this.currentQuery.state;
    }

    return result;
  }

  getCurrentResult() {
    return this.currentResult;
  }

  trackResult(result) {
    const trackedResult = {};
    Object.keys(result).forEach(key => {
      Object.defineProperty(trackedResult, key, {
        configurable: false,
        enumerable: true,
        get: () => {
          this.trackedProps.add(key);
          return result[key];
        }
      });
    });
    return trackedResult;
  }

  getCurrentQuery() {
    return this.currentQuery;
  }

  remove() {
    this.client.getQueryCache().remove(this.currentQuery);
  }

  refetch({
    refetchPage,
    ...options
  } = {}) {
    return this.fetch({ ...options,
      meta: {
        refetchPage
      }
    });
  }

  fetchOptimistic(options) {
    const defaultedOptions = this.client.defaultQueryOptions(options);
    const query = this.client.getQueryCache().build(this.client, defaultedOptions);
    query.isFetchingOptimistic = true;
    return query.fetch().then(() => this.createResult(query, defaultedOptions));
  }

  fetch(fetchOptions) {
    var _fetchOptions$cancelR;

    return this.executeFetch({ ...fetchOptions,
      cancelRefetch: (_fetchOptions$cancelR = fetchOptions.cancelRefetch) != null ? _fetchOptions$cancelR : true
    }).then(() => {
      this.updateResult();
      return this.currentResult;
    });
  }

  executeFetch(fetchOptions) {
    // Make sure we reference the latest query as the current one might have been removed
    this.updateQuery(); // Fetch

    let promise = this.currentQuery.fetch(this.options, fetchOptions);

    if (!(fetchOptions != null && fetchOptions.throwOnError)) {
      promise = promise.catch(noop);
    }

    return promise;
  }

  updateStaleTimeout() {
    this.clearStaleTimeout();

    if (isServer || this.currentResult.isStale || !isValidTimeout(this.options.staleTime)) {
      return;
    }

    const time = timeUntilStale(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
    // To mitigate this issue we always add 1 ms to the timeout.

    const timeout = time + 1;
    this.staleTimeoutId = setTimeout(() => {
      if (!this.currentResult.isStale) {
        this.updateResult();
      }
    }, timeout);
  }

  computeRefetchInterval() {
    var _this$options$refetch;

    return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
  }

  updateRefetchInterval(nextInterval) {
    this.clearRefetchInterval();
    this.currentRefetchInterval = nextInterval;

    if (isServer || this.options.enabled === false || !isValidTimeout(this.currentRefetchInterval) || this.currentRefetchInterval === 0) {
      return;
    }

    this.refetchIntervalId = setInterval(() => {
      if (this.options.refetchIntervalInBackground || focusManager.isFocused()) {
        this.executeFetch();
      }
    }, this.currentRefetchInterval);
  }

  updateTimers() {
    this.updateStaleTimeout();
    this.updateRefetchInterval(this.computeRefetchInterval());
  }

  clearStaleTimeout() {
    if (this.staleTimeoutId) {
      clearTimeout(this.staleTimeoutId);
      this.staleTimeoutId = undefined;
    }
  }

  clearRefetchInterval() {
    if (this.refetchIntervalId) {
      clearInterval(this.refetchIntervalId);
      this.refetchIntervalId = undefined;
    }
  }

  createResult(query, options) {
    const prevQuery = this.currentQuery;
    const prevOptions = this.options;
    const prevResult = this.currentResult;
    const prevResultState = this.currentResultState;
    const prevResultOptions = this.currentResultOptions;
    const queryChange = query !== prevQuery;
    const queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
    const prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
    const {
      state
    } = query;
    let {
      dataUpdatedAt,
      error,
      errorUpdatedAt,
      fetchStatus,
      status
    } = state;
    let isPreviousData = false;
    let isPlaceholderData = false;
    let data; // Optimistically set result in fetching state if needed

    if (options._optimisticResults) {
      const mounted = this.hasListeners();
      const fetchOnMount = !mounted && shouldFetchOnMount(query, options);
      const fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);

      if (fetchOnMount || fetchOptionally) {
        fetchStatus = canFetch(query.options.networkMode) ? 'fetching' : 'paused';

        if (!dataUpdatedAt) {
          status = 'loading';
        }
      }

      if (options._optimisticResults === 'isRestoring') {
        fetchStatus = 'idle';
      }
    } // Keep previous data if needed


    if (options.keepPreviousData && !state.dataUpdatedAt && prevQueryResult != null && prevQueryResult.isSuccess && status !== 'error') {
      data = prevQueryResult.data;
      dataUpdatedAt = prevQueryResult.dataUpdatedAt;
      status = prevQueryResult.status;
      isPreviousData = true;
    } // Select data if needed
    else if (options.select && typeof state.data !== 'undefined') {
      // Memoize select result
      if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) {
        data = this.selectResult;
      } else {
        try {
          this.selectFn = options.select;
          data = options.select(state.data);
          data = replaceData(prevResult == null ? void 0 : prevResult.data, data, options);
          this.selectResult = data;
          this.selectError = null;
        } catch (selectError) {
          if (process.env.NODE_ENV !== 'production') {
            this.client.getLogger().error(selectError);
          }

          this.selectError = selectError;
        }
      }
    } // Use query data
    else {
      data = state.data;
    } // Show placeholder data if needed


    if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && status === 'loading') {
      let placeholderData; // Memoize placeholder data

      if (prevResult != null && prevResult.isPlaceholderData && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) {
        placeholderData = prevResult.data;
      } else {
        placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;

        if (options.select && typeof placeholderData !== 'undefined') {
          try {
            placeholderData = options.select(placeholderData);
            this.selectError = null;
          } catch (selectError) {
            if (process.env.NODE_ENV !== 'production') {
              this.client.getLogger().error(selectError);
            }

            this.selectError = selectError;
          }
        }
      }

      if (typeof placeholderData !== 'undefined') {
        status = 'success';
        data = replaceData(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
        isPlaceholderData = true;
      }
    }

    if (this.selectError) {
      error = this.selectError;
      data = this.selectResult;
      errorUpdatedAt = Date.now();
      status = 'error';
    }

    const isFetching = fetchStatus === 'fetching';
    const isLoading = status === 'loading';
    const isError = status === 'error';
    const result = {
      status,
      fetchStatus,
      isLoading,
      isSuccess: status === 'success',
      isError,
      isInitialLoading: isLoading && isFetching,
      data,
      dataUpdatedAt,
      error,
      errorUpdatedAt,
      failureCount: state.fetchFailureCount,
      failureReason: state.fetchFailureReason,
      errorUpdateCount: state.errorUpdateCount,
      isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
      isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
      isFetching,
      isRefetching: isFetching && !isLoading,
      isLoadingError: isError && state.dataUpdatedAt === 0,
      isPaused: fetchStatus === 'paused',
      isPlaceholderData,
      isPreviousData,
      isRefetchError: isError && state.dataUpdatedAt !== 0,
      isStale: isStale(query, options),
      refetch: this.refetch,
      remove: this.remove
    };
    return result;
  }

  updateResult(notifyOptions) {
    const prevResult = this.currentResult;
    const nextResult = this.createResult(this.currentQuery, this.options);
    this.currentResultState = this.currentQuery.state;
    this.currentResultOptions = this.options; // Only notify and update result if something has changed

    if (shallowEqualObjects(nextResult, prevResult)) {
      return;
    }

    this.currentResult = nextResult; // Determine which callbacks to trigger

    const defaultNotifyOptions = {
      cache: true
    };

    const shouldNotifyListeners = () => {
      if (!prevResult) {
        return true;
      }

      const {
        notifyOnChangeProps
      } = this.options;
      const notifyOnChangePropsValue = typeof notifyOnChangeProps === 'function' ? notifyOnChangeProps() : notifyOnChangeProps;

      if (notifyOnChangePropsValue === 'all' || !notifyOnChangePropsValue && !this.trackedProps.size) {
        return true;
      }

      const includedProps = new Set(notifyOnChangePropsValue != null ? notifyOnChangePropsValue : this.trackedProps);

      if (this.options.useErrorBoundary) {
        includedProps.add('error');
      }

      return Object.keys(this.currentResult).some(key => {
        const typedKey = key;
        const changed = this.currentResult[typedKey] !== prevResult[typedKey];
        return changed && includedProps.has(typedKey);
      });
    };

    if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) {
      defaultNotifyOptions.listeners = true;
    }

    this.notify({ ...defaultNotifyOptions,
      ...notifyOptions
    });
  }

  updateQuery() {
    const query = this.client.getQueryCache().build(this.client, this.options);

    if (query === this.currentQuery) {
      return;
    }

    const prevQuery = this.currentQuery;
    this.currentQuery = query;
    this.currentQueryInitialState = query.state;
    this.previousQueryResult = this.currentResult;

    if (this.hasListeners()) {
      prevQuery == null ? void 0 : prevQuery.removeObserver(this);
      query.addObserver(this);
    }
  }

  onQueryUpdate(action) {
    const notifyOptions = {};

    if (action.type === 'success') {
      notifyOptions.onSuccess = !action.manual;
    } else if (action.type === 'error' && !isCancelledError(action.error)) {
      notifyOptions.onError = true;
    }

    this.updateResult(notifyOptions);

    if (this.hasListeners()) {
      this.updateTimers();
    }
  }

  notify(notifyOptions) {
    notifyManager.batch(() => {
      // First trigger the configuration callbacks
      if (notifyOptions.onSuccess) {
        var _this$options$onSucce, _this$options, _this$options$onSettl, _this$options2;

        (_this$options$onSucce = (_this$options = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options, this.currentResult.data);
        (_this$options$onSettl = (_this$options2 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options2, this.currentResult.data, null);
      } else if (notifyOptions.onError) {
        var _this$options$onError, _this$options3, _this$options$onSettl2, _this$options4;

        (_this$options$onError = (_this$options3 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options3, this.currentResult.error);
        (_this$options$onSettl2 = (_this$options4 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options4, undefined, this.currentResult.error);
      } // Then trigger the listeners


      if (notifyOptions.listeners) {
        this.listeners.forEach(({
          listener
        }) => {
          listener(this.currentResult);
        });
      } // Then the cache listeners


      if (notifyOptions.cache) {
        this.client.getQueryCache().notify({
          query: this.currentQuery,
          type: 'observerResultsUpdated'
        });
      }
    });
  }

}

function shouldLoadOnMount(query, options) {
  return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}

function shouldFetchOnMount(query, options) {
  return shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && shouldFetchOn(query, options, options.refetchOnMount);
}

function shouldFetchOn(query, options, field) {
  if (options.enabled !== false) {
    const value = typeof field === 'function' ? field(query) : field;
    return value === 'always' || value !== false && isStale(query, options);
  }

  return false;
}

function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
  return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error') && isStale(query, options);
}

function isStale(query, options) {
  return query.isStaleByTime(options.staleTime);
} // this function would decide if we will update the observer's 'current'
// properties after an optimistic reading via getOptimisticResult


function shouldAssignObserverCurrentProperties(observer, optimisticResult, options) {
  // it is important to keep this condition like this for three reasons:
  // 1. It will get removed in the v5
  // 2. it reads: don't update the properties if we want to keep the previous
  // data.
  // 3. The opposite condition (!options.keepPreviousData) would fallthrough
  // and will result in a bad decision
  if (options.keepPreviousData) {
    return false;
  } // this means we want to put some placeholder data when pending and queryKey
  // changed.


  if (options.placeholderData !== undefined) {
    // re-assign properties only if current data is placeholder data
    // which means that data did not arrive yet, so, if there is some cached data
    // we need to "prepare" to receive it
    return optimisticResult.isPlaceholderData;
  } // if the newly created result isn't what the observer is holding as current,
  // then we'll need to update the properties as well


  if (!shallowEqualObjects(observer.getCurrentResult(), optimisticResult)) {
    return true;
  } // basically, just keep previous properties if nothing changed


  return false;
}

var shim = {exports: {}};

var useSyncExternalStoreShim_production_min = {};

/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredUseSyncExternalStoreShim_production_min;

function requireUseSyncExternalStoreShim_production_min () {
	if (hasRequiredUseSyncExternalStoreShim_production_min) return useSyncExternalStoreShim_production_min;
	hasRequiredUseSyncExternalStoreShim_production_min = 1;
var e=React__default;function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c});},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c});})},[a]);p(d);return d}
	function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return !k(a,d)}catch(f){return !0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;useSyncExternalStoreShim_production_min.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;
	return useSyncExternalStoreShim_production_min;
}

var useSyncExternalStoreShim_development = {};

/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredUseSyncExternalStoreShim_development;

function requireUseSyncExternalStoreShim_development () {
	if (hasRequiredUseSyncExternalStoreShim_development) return useSyncExternalStoreShim_development;
	hasRequiredUseSyncExternalStoreShim_development = 1;

	if (process.env.NODE_ENV !== "production") {
	  (function() {

	/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	if (
	  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' &&
	  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart ===
	    'function'
	) {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
	}
	          var React = React__default;

	var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

	function error(format) {
	  {
	    {
	      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }

	      printWarning('error', format, args);
	    }
	  }
	}

	function printWarning(level, format, args) {
	  // When changing this logic, you might want to also
	  // update consoleWithStackDev.www.js as well.
	  {
	    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
	    var stack = ReactDebugCurrentFrame.getStackAddendum();

	    if (stack !== '') {
	      format += '%s';
	      args = args.concat([stack]);
	    } // eslint-disable-next-line react-internal/safe-string-coercion


	    var argsWithFormat = args.map(function (item) {
	      return String(item);
	    }); // Careful: RN currently depends on this prefix

	    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
	    // breaks IE9: https://github.com/facebook/react/issues/13610
	    // eslint-disable-next-line react-internal/no-production-logging

	    Function.prototype.apply.call(console[level], console, argsWithFormat);
	  }
	}

	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
	  ;
	}

	var objectIs = typeof Object.is === 'function' ? Object.is : is;

	// dispatch for CommonJS interop named imports.

	var useState = React.useState,
	    useEffect = React.useEffect,
	    useLayoutEffect = React.useLayoutEffect,
	    useDebugValue = React.useDebugValue;
	var didWarnOld18Alpha = false;
	var didWarnUncachedGetSnapshot = false; // Disclaimer: This shim breaks many of the rules of React, and only works
	// because of a very particular set of implementation details and assumptions
	// -- change any one of them and it will break. The most important assumption
	// is that updates are always synchronous, because concurrent rendering is
	// only available in versions of React that also have a built-in
	// useSyncExternalStore API. And we only use this shim when the built-in API
	// does not exist.
	//
	// Do not assume that the clever hacks used by this hook also work in general.
	// The point of this shim is to replace the need for hacks by other libraries.

	function useSyncExternalStore(subscribe, getSnapshot, // Note: The shim does not use getServerSnapshot, because pre-18 versions of
	// React do not expose a way to check if we're hydrating. So users of the shim
	// will need to track that themselves and return the correct value
	// from `getSnapshot`.
	getServerSnapshot) {
	  {
	    if (!didWarnOld18Alpha) {
	      if (React.startTransition !== undefined) {
	        didWarnOld18Alpha = true;

	        error('You are using an outdated, pre-release alpha of React 18 that ' + 'does not support useSyncExternalStore. The ' + 'use-sync-external-store shim will not work correctly. Upgrade ' + 'to a newer pre-release.');
	      }
	    }
	  } // Read the current snapshot from the store on every render. Again, this
	  // breaks the rules of React, and only works here because of specific
	  // implementation details, most importantly that updates are
	  // always synchronous.


	  var value = getSnapshot();

	  {
	    if (!didWarnUncachedGetSnapshot) {
	      var cachedValue = getSnapshot();

	      if (!objectIs(value, cachedValue)) {
	        error('The result of getSnapshot should be cached to avoid an infinite loop');

	        didWarnUncachedGetSnapshot = true;
	      }
	    }
	  } // Because updates are synchronous, we don't queue them. Instead we force a
	  // re-render whenever the subscribed state changes by updating an some
	  // arbitrary useState hook. Then, during render, we call getSnapshot to read
	  // the current value.
	  //
	  // Because we don't actually use the state returned by the useState hook, we
	  // can save a bit of memory by storing other stuff in that slot.
	  //
	  // To implement the early bailout, we need to track some things on a mutable
	  // object. Usually, we would put that in a useRef hook, but we can stash it in
	  // our useState hook instead.
	  //
	  // To force a re-render, we call forceUpdate({inst}). That works because the
	  // new object always fails an equality check.


	  var _useState = useState({
	    inst: {
	      value: value,
	      getSnapshot: getSnapshot
	    }
	  }),
	      inst = _useState[0].inst,
	      forceUpdate = _useState[1]; // Track the latest getSnapshot function with a ref. This needs to be updated
	  // in the layout phase so we can access it during the tearing check that
	  // happens on subscribe.


	  useLayoutEffect(function () {
	    inst.value = value;
	    inst.getSnapshot = getSnapshot; // Whenever getSnapshot or subscribe changes, we need to check in the
	    // commit phase if there was an interleaved mutation. In concurrent mode
	    // this can happen all the time, but even in synchronous mode, an earlier
	    // effect may have mutated the store.

	    if (checkIfSnapshotChanged(inst)) {
	      // Force a re-render.
	      forceUpdate({
	        inst: inst
	      });
	    }
	  }, [subscribe, value, getSnapshot]);
	  useEffect(function () {
	    // Check for changes right before subscribing. Subsequent changes will be
	    // detected in the subscription handler.
	    if (checkIfSnapshotChanged(inst)) {
	      // Force a re-render.
	      forceUpdate({
	        inst: inst
	      });
	    }

	    var handleStoreChange = function () {
	      // TODO: Because there is no cross-renderer API for batching updates, it's
	      // up to the consumer of this library to wrap their subscription event
	      // with unstable_batchedUpdates. Should we try to detect when this isn't
	      // the case and print a warning in development?
	      // The store changed. Check if the snapshot changed since the last time we
	      // read from the store.
	      if (checkIfSnapshotChanged(inst)) {
	        // Force a re-render.
	        forceUpdate({
	          inst: inst
	        });
	      }
	    }; // Subscribe to the store and return a clean-up function.


	    return subscribe(handleStoreChange);
	  }, [subscribe]);
	  useDebugValue(value);
	  return value;
	}

	function checkIfSnapshotChanged(inst) {
	  var latestGetSnapshot = inst.getSnapshot;
	  var prevValue = inst.value;

	  try {
	    var nextValue = latestGetSnapshot();
	    return !objectIs(prevValue, nextValue);
	  } catch (error) {
	    return true;
	  }
	}

	function useSyncExternalStore$1(subscribe, getSnapshot, getServerSnapshot) {
	  // Note: The shim does not use getServerSnapshot, because pre-18 versions of
	  // React do not expose a way to check if we're hydrating. So users of the shim
	  // will need to track that themselves and return the correct value
	  // from `getSnapshot`.
	  return getSnapshot();
	}

	var canUseDOM = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');

	var isServerEnvironment = !canUseDOM;

	var shim = isServerEnvironment ? useSyncExternalStore$1 : useSyncExternalStore;
	var useSyncExternalStore$2 = React.useSyncExternalStore !== undefined ? React.useSyncExternalStore : shim;

	useSyncExternalStoreShim_development.useSyncExternalStore = useSyncExternalStore$2;
	          /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	if (
	  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' &&
	  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop ===
	    'function'
	) {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
	}
	        
	  })();
	}
	return useSyncExternalStoreShim_development;
}

if (process.env.NODE_ENV === 'production') {
  shim.exports = requireUseSyncExternalStoreShim_production_min();
} else {
  shim.exports = requireUseSyncExternalStoreShim_development();
}

var shimExports = shim.exports;

const useSyncExternalStore = shimExports.useSyncExternalStore;

const defaultContext = /*#__PURE__*/React.createContext(undefined);
const QueryClientSharingContext = /*#__PURE__*/React.createContext(false); // If we are given a context, we will use it.
// Otherwise, if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.

function getQueryClientContext(context, contextSharing) {
  if (context) {
    return context;
  }

  if (contextSharing && typeof window !== 'undefined') {
    if (!window.ReactQueryClientContext) {
      window.ReactQueryClientContext = defaultContext;
    }

    return window.ReactQueryClientContext;
  }

  return defaultContext;
}

const useQueryClient = ({
  context
} = {}) => {
  const queryClient = React.useContext(getQueryClientContext(context, React.useContext(QueryClientSharingContext)));

  if (!queryClient) {
    throw new Error('No QueryClient set, use QueryClientProvider to set one');
  }

  return queryClient;
};
const QueryClientProvider = ({
  client,
  children,
  context,
  contextSharing = false
}) => {
  React.useEffect(() => {
    client.mount();
    return () => {
      client.unmount();
    };
  }, [client]);

  if (process.env.NODE_ENV !== 'production' && contextSharing) {
    client.getLogger().error("The contextSharing option has been deprecated and will be removed in the next major version");
  }

  const Context = getQueryClientContext(context, contextSharing);
  return /*#__PURE__*/React.createElement(QueryClientSharingContext.Provider, {
    value: !context && contextSharing
  }, /*#__PURE__*/React.createElement(Context.Provider, {
    value: client
  }, children));
};

const IsRestoringContext = /*#__PURE__*/React.createContext(false);
const useIsRestoring = () => React.useContext(IsRestoringContext);
IsRestoringContext.Provider;

function createValue() {
  let isReset = false;
  return {
    clearReset: () => {
      isReset = false;
    },
    reset: () => {
      isReset = true;
    },
    isReset: () => {
      return isReset;
    }
  };
}

const QueryErrorResetBoundaryContext = /*#__PURE__*/React.createContext(createValue()); // HOOK

const useQueryErrorResetBoundary = () => React.useContext(QueryErrorResetBoundaryContext); // COMPONENT

function shouldThrowError(_useErrorBoundary, params) {
  // Allow useErrorBoundary function to override throwing behavior on a per-error basis
  if (typeof _useErrorBoundary === 'function') {
    return _useErrorBoundary(...params);
  }

  return !!_useErrorBoundary;
}

const ensurePreventErrorBoundaryRetry = (options, errorResetBoundary) => {
  if (options.suspense || options.useErrorBoundary) {
    // Prevent retrying failed query if the error boundary has not been reset yet
    if (!errorResetBoundary.isReset()) {
      options.retryOnMount = false;
    }
  }
};
const useClearResetErrorBoundary = errorResetBoundary => {
  React.useEffect(() => {
    errorResetBoundary.clearReset();
  }, [errorResetBoundary]);
};
const getHasError = ({
  result,
  errorResetBoundary,
  useErrorBoundary,
  query
}) => {
  return result.isError && !errorResetBoundary.isReset() && !result.isFetching && shouldThrowError(useErrorBoundary, [result.error, query]);
};

const ensureStaleTime = defaultedOptions => {
  if (defaultedOptions.suspense) {
    // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    if (typeof defaultedOptions.staleTime !== 'number') {
      defaultedOptions.staleTime = 1000;
    }
  }
};
const willFetch = (result, isRestoring) => result.isLoading && result.isFetching && !isRestoring;
const shouldSuspend = (defaultedOptions, result, isRestoring) => (defaultedOptions == null ? void 0 : defaultedOptions.suspense) && willFetch(result, isRestoring);
const fetchOptimistic = (defaultedOptions, observer, errorResetBoundary) => observer.fetchOptimistic(defaultedOptions).then(({
  data
}) => {
  defaultedOptions.onSuccess == null ? void 0 : defaultedOptions.onSuccess(data);
  defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(data, null);
}).catch(error => {
  errorResetBoundary.clearReset();
  defaultedOptions.onError == null ? void 0 : defaultedOptions.onError(error);
  defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(undefined, error);
});

function useBaseQuery(options, Observer) {
  const queryClient = useQueryClient({
    context: options.context
  });
  const isRestoring = useIsRestoring();
  const errorResetBoundary = useQueryErrorResetBoundary();
  const defaultedOptions = queryClient.defaultQueryOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options

  defaultedOptions._optimisticResults = isRestoring ? 'isRestoring' : 'optimistic'; // Include callbacks in batch renders

  if (defaultedOptions.onError) {
    defaultedOptions.onError = notifyManager.batchCalls(defaultedOptions.onError);
  }

  if (defaultedOptions.onSuccess) {
    defaultedOptions.onSuccess = notifyManager.batchCalls(defaultedOptions.onSuccess);
  }

  if (defaultedOptions.onSettled) {
    defaultedOptions.onSettled = notifyManager.batchCalls(defaultedOptions.onSettled);
  }

  ensureStaleTime(defaultedOptions);
  ensurePreventErrorBoundaryRetry(defaultedOptions, errorResetBoundary);
  useClearResetErrorBoundary(errorResetBoundary);
  const [observer] = React.useState(() => new Observer(queryClient, defaultedOptions));
  const result = observer.getOptimisticResult(defaultedOptions);
  useSyncExternalStore(React.useCallback(onStoreChange => {
    const unsubscribe = isRestoring ? () => undefined : observer.subscribe(notifyManager.batchCalls(onStoreChange)); // Update result to make sure we did not miss any query updates
    // between creating the observer and subscribing to it.

    observer.updateResult();
    return unsubscribe;
  }, [observer, isRestoring]), () => observer.getCurrentResult(), () => observer.getCurrentResult());
  React.useEffect(() => {
    // Do not notify on updates because of changes in the options because
    // these changes should already be reflected in the optimistic result.
    observer.setOptions(defaultedOptions, {
      listeners: false
    });
  }, [defaultedOptions, observer]); // Handle suspense

  if (shouldSuspend(defaultedOptions, result, isRestoring)) {
    throw fetchOptimistic(defaultedOptions, observer, errorResetBoundary);
  } // Handle error boundary


  if (getHasError({
    result,
    errorResetBoundary,
    useErrorBoundary: defaultedOptions.useErrorBoundary,
    query: observer.getCurrentQuery()
  })) {
    throw result.error;
  } // Handle result property usage tracking


  return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}

function useQuery(arg1, arg2, arg3) {
  const parsedOptions = parseQueryArgs(arg1, arg2, arg3);
  return useBaseQuery(parsedOptions, QueryObserver);
}

const RTEditUserRoles = ({ apiUrl, userDetails, onSuccess, setError, setSuccessMessage, sx }) => {
    const requestHelper = RequestHelper.getInstance(apiUrl);
    const [loading, setLoading] = useState(false);
    const [tenantLoaded, setTenantLoaded] = useState(false);
    const [userLoaded, setUserLoaded] = useState(false);
    const [tenantRoles, setTenantRoles] = useState([]);
    const [userRoles, setUserRoles] = useState([]);
    const [roleSetLoading, setRoleSetLoading] = useState('');
    const [hasMergedRoles, setHasMergedRoles] = useState(false);
    const getTenantRolesFN = () => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!loading && !tenantLoaded) {
            setLoading(true);
            const tenantRes = yield requestHelper.getRolesForTenant({ TenantId: userDetails.TenantId, setError });
            setTenantRoles(tenantRes.filter((rs) => !rs.disabled).sort((a, b) => a.name.localeCompare(b.name)));
            setTenantLoaded(true);
            setLoading(false);
            return tenantRes;
        }
        return [];
    });
    const getUserRolesFN = () => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!loading && !userLoaded && userDetails.email) {
            setLoading(true);
            const res = yield requestHelper.getRolesForUser({ email: userDetails.email, TenantId: userDetails.TenantId, setError });
            setUserRoles(res.roleSets);
            setUserLoaded(true);
            setLoading(false);
            return res;
        }
        return [];
    });
    useQuery({
        queryKey: ['roles', userDetails.TenantId],
        queryFn: () => getTenantRolesFN(),
    });
    useQuery({
        queryKey: ['userRoles', userDetails.TenantId, userDetails.email],
        queryFn: () => getUserRolesFN(),
    });
    const hasRoleOnUserRoles = (roleSetId) => {
        if (!userRoles || !userRoles.length) {
            return false;
        }
        return !!userRoles.find(role => role.roleSetId === roleSetId);
    };
    useEffect(() => {
        if (tenantRoles.length && userRoles.length && !hasMergedRoles) {
            const disabledRolesUserHas = userRoles.filter((rs) => rs.disabled);
            setTenantRoles([...tenantRoles, ...disabledRolesUserHas]);
            setHasMergedRoles(true);
        }
    }, [userRoles, tenantRoles, hasMergedRoles]);
    const handleAddRemoveRole = (roleSetId, add) => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!userDetails || !userDetails.TenantId) {
            return;
        }
        setRoleSetLoading(roleSetId);
        let res;
        if (add) {
            res = yield requestHelper.addRoleSetToUser({ email: userDetails.email, roleSetId, TenantId: userDetails.TenantId, setError });
        }
        else {
            res = yield requestHelper.removeRoleSetFromUser({ email: userDetails.email, roleSetId, TenantId: userDetails.TenantId, setError });
        }
        if (res) {
            if (add) {
                setUserRoles([...userRoles, res]);
            }
            else {
                setUserRoles(userRoles.filter(role => role.roleSetId !== roleSetId));
            }
            setSuccessMessage('User roles updated successfully');
            onSuccess && onSuccess(res);
        }
        setRoleSetLoading('');
    });
    return (React__default.createElement(React__default.Fragment, null, tenantRoles && tenantRoles.length > 0 &&
        React__default.createElement(Box$2, { sx: Object.assign({ maxHeight: '420px', height: '40vh', background: colors.primary90 }, sx) },
            React__default.createElement(Typography, { variant: "h5", sx: { paddingLeft: '20px', paddingTop: '10px' } }, "Permissions"),
            loading || !tenantLoaded || !userLoaded ? React__default.createElement(ScaleLoader, { color: colors.primary10 }) : React__default.createElement(List, { sx: { maxHeight: '360px', height: '30vh', borderRadius: '10px', overflow: 'auto' } }, tenantRoles && tenantRoles.map((role) => (React__default.createElement(ListItem, { sx: { borderBottom: '1px black solid', width: '95%', margin: 'auto' }, key: role.roleSetId, id: role.roleSetId },
                React__default.createElement(ListItemText, { primary: role.name, secondary: role.description }),
                role.disabled && React__default.createElement(Tooltip, { title: "Disabled Role, Can only be removed from user" },
                    React__default.createElement(WarningIcon, { color: "error" })),
                roleSetLoading === role.roleSetId ?
                    React__default.createElement(ScaleLoader, { color: colors.primary10 }) :
                    React__default.createElement(Checkbox, { id: `${role.roleSetId}-checkbox`, checked: hasRoleOnUserRoles(role.roleSetId), onChange: (event) => handleAddRemoveRole(role.roleSetId, event.target.checked) }))))))));
};

const RTEnableDisableUserSwitch = ({ user, apiUrl, setError, showLabel = false, callback, sx }) => {
    const requestHelper = RequestHelper.getInstance(apiUrl);
    const { currentUser } = useAuth$1();
    const [loading, setLoading] = useState(false);
    const [disabled, setDisabled] = useState(user.disabled);
    const handleEnableDisableUser = (event) => __awaiter$1(void 0, void 0, void 0, function* () {
        event.preventDefault();
        setLoading(true);
        if (user.disabled) {
            yield requestHelper.enableUser({ email: user.email, setError });
            user.disabled = false;
        }
        else {
            yield requestHelper.disableUser({ email: user.email, setError });
            user.disabled = true;
        }
        setDisabled(!disabled);
        setLoading(false);
        callback && callback(user);
    });
    const getTooltipText = () => {
        if (currentUser.disabled) {
            return 'Enable User';
        }
        if ((currentUser === null || currentUser === void 0 ? void 0 : currentUser.email) === user.email) {
            return 'You cannot disable yourself';
        }
        return 'Disable User';
    };
    return (React__default.createElement(React__default.Fragment, null, user.TenantId && loading ? React__default.createElement(ScaleLoader, { color: colors.primary10 }) :
        React__default.createElement(Box$2, { sx: sx, id: 'disable-enable-switch' },
            React__default.createElement(Tooltip, { title: getTooltipText(), arrow: true },
                React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(Switch, { disabled: (currentUser === null || currentUser === void 0 ? void 0 : currentUser.email) === user.email, checked: !disabled, onChange: handleEnableDisableUser, inputProps: { 'aria-label': 'controlled' } }),
                    showLabel && React__default.createElement("span", null,
                        disabled ? 'Enable' : 'Disable',
                        " User"))))));
};

const ColorAvatar = ({ sx, firstName, lastName }) => {
    const stringToColor = (string) => {
        let hash = 0;
        let i;
        for (i = 0; i < string.length; i += 1) {
            hash = string.charCodeAt(i) + ((hash << 5) - hash);
        }
        let color = '#';
        for (i = 0; i < 3; i += 1) {
            const value = (hash >> (i * 8)) & 0xff;
            color += `00${value.toString(16)}`.slice(-2);
        }
        return color;
    };
    const stringAvatar = () => {
        const name = `${firstName} ${lastName}`.trim();
        if (!name || name.length === 0) {
            return {
                sx: Object.assign({ bgcolor: colors.primary10 }, sx),
                children: React.createElement(PersonIcon, null),
            };
        }
        return {
            sx: Object.assign({ bgcolor: stringToColor(name) }, sx),
            children: `${firstName[0] || ''}${lastName[0] || ''}`,
        };
    };
    return React.createElement(Avatar, Object.assign({ id: "user-avatar" }, stringAvatar()));
};

const requiredFields = ['email', 'userApp'];
const RTEditUser$1 = ({ apiUrl, email, userDetails, onSuccess, isNew }) => {
    const requestHelper = RequestHelper.getInstance(apiUrl);
    const { currentUser, i18n, flags } = useAuth$1();
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [user, setUser] = useState(undefined);
    const [userLoaded, setUserLoaded] = useState(false);
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [missingFields, setMissingFields] = useState([]);
    const [isNewUser, setIsNewUser] = useState(isNew);
    const getUserFn = () => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!loading && !userLoaded && !isNew) {
            setLoading(true);
            const res = yield requestHelper.getUser({ email, setError });
            setUser(res);
            setUserLoaded(true);
            setLoading(false);
        }
    });
    const getUser = useCallback(getUserFn, [email, loading, userLoaded, requestHelper, isNew]);
    const checkRequiredFields = () => {
        const missing = requiredFields.filter((field) => {
            if (!user) {
                return field;
            }
            if (!user[field]) {
                return field;
            }
            if (typeof user[field] === 'string' && user[field].length === 0) {
                return field;
            }
            return false;
        });
        setMissingFields(missing);
        return missing;
    };
    const updateUser = (event) => __awaiter$1(void 0, void 0, void 0, function* () {
        event.preventDefault();
        if (!user) {
            return;
        }
        if (checkRequiredFields().length > 0) {
            setError('Please fill in all required fields');
            return;
        }
        setSaving(true);
        let res;
        if (isNewUser) {
            res = yield requestHelper.createUser({ userParams: user, setError });
        }
        else {
            res = yield requestHelper.updateUser({ userParams: user, setError });
        }
        if (res) {
            setUser(res);
            setSuccessMessage(`User ${isNewUser ? 'created' : 'updated'} successfully`);
            setSaving(false);
            if (!isNewUser) {
                onSuccess && onSuccess(res);
                return;
            }
            onSuccess && onSuccess(res, undefined, false);
            setIsNewUser(false);
        }
        setSaving(false);
    });
    const updateAttribute = (attribute, event) => {
        if (attribute === 'email' && event.target.value.includes('#')) {
            setError('Email cannot contain "#"');
            return;
        }
        if (!user) {
            return;
        }
        setUser(Object.assign(Object.assign({}, user), { [attribute]: event.target.value }));
    };
    const handleForceResetPassword = () => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!user) {
            return;
        }
        setLoading(true);
        const res = yield requestHelper.forceResetPassword({ email: user.email, tenantId: user.TenantId, setError });
        if (res) {
            setSuccessMessage(user.emailVerified ? 'Password reset email sent successfully' : 'Welcome email sent successfully');
        }
        setLoading(false);
    });
    const handleDeleteUser = () => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!user) {
            return;
        }
        setLoading(true);
        const res = yield requestHelper.deleteUser({ email: user.email, setError });
        if (res) {
            setSuccessMessage('User deleted successfully');
            res.deleted = true;
            onSuccess && onSuccess(res, `User ${user.email} deleted successfully`);
        }
        setLoading(false);
    });
    const handleDisableEnableUser = (user) => __awaiter$1(void 0, void 0, void 0, function* () {
        setUser(user);
        onSuccess && onSuccess(user, undefined, false);
    });
    useEffect(() => {
        if (userDetails) {
            setUser(userDetails);
            setUserLoaded(true);
        }
        getUser();
    }, [userDetails, getUser]);
    const isAdmin = () => checkRoles(currentUser || {}, ['*:*']);
    const availableRoles = () => isAdmin() ? { 'SuperAdmin': 'RT Admin', "TenantAdmin": "Tenant Admin", 'user': 'User' } : { "TenantAdmin": "Tenant Admin", 'user': 'User' };
    return (React__default.createElement(ThemeProvider, { theme: theme },
        React__default.createElement(Box, { id: 'edit-user-box', sx: { backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', minWidth: '650px', flexWrap: 'wrap', marginBottom: '20px', height: '100%', borderRadius: '40px', overflow: 'hidden' } }, loading || !userLoaded ? React__default.createElement(ScaleLoader, { color: colors.primary20 }) :
            React__default.createElement(Box, { sx: { width: '90%', paddingTop: '20px', paddingBottom: '10px' } },
                React__default.createElement(Typography, { variant: "h4", sx: { marginBottom: '20px', textAlign: 'left', color: colors.neutral30 } }, isNewUser ? i18n.t('create_user') : i18n.t('edit_user')),
                !isNewUser && user && React__default.createElement(Box, { sx: { display: 'flex', paddingBottom: '20px' } },
                    React__default.createElement(ColorAvatar, { firstName: user.firstName, lastName: user.lastName, sx: { marginTop: '10px' } }),
                    React__default.createElement(Box, { sx: { paddingLeft: '10px' } },
                        React__default.createElement(Typography, { id: 'user-name' }, user.firstName + ' ' + user.lastName),
                        React__default.createElement(Typography, { id: 'user-email', sx: { color: colors.neutral40 } }, user.email))),
                React__default.createElement("form", { onSubmit: updateUser, id: "edit-user" },
                    React__default.createElement(FormGroup, { sx: { width: '100%', display: 'flex', alignItems: 'center', flexDirection: 'row' } },
                        isNewUser && React__default.createElement(TextField, { required: true, value: (user === null || user === void 0 ? void 0 : user.email) || '', onChange: event => updateAttribute('email', event), label: i18n.t('email'), variant: "outlined", helperText: i18n.t('required'), error: missingFields.includes('email'), id: "email", sx: TextFieldStyling({ marginBottom: '15px', marginRight: '5px', width: '100%' }) }),
                        React__default.createElement(TextField, { value: (user === null || user === void 0 ? void 0 : user.firstName) || '', onChange: event => updateAttribute('firstName', event), label: i18n.t('first_name'), variant: "outlined", id: "firstName", sx: TextFieldStyling({ marginBottom: '15px', width: '100%' }) }),
                        React__default.createElement(TextField, { value: (user === null || user === void 0 ? void 0 : user.lastName) || '', onChange: event => updateAttribute('lastName', event), label: i18n.t('last_name'), variant: "outlined", id: "lastName", sx: TextFieldStyling({ marginBottom: '15px', width: '100%' }) }),
                        React__default.createElement(RTSelect, { id: "role-select", selectedOption: (user === null || user === void 0 ? void 0 : user.role) || '', setSelectedOption: (value) => updateAttribute('role', { target: { value } }), options: availableRoles(), selectName: i18n.t('role'), sx: TextFieldStyling({ width: '100%', marginBottom: '15px' }) }),
                        React__default.createElement(RTSelect, { id: "userApp-select", selectedOption: (user === null || user === void 0 ? void 0 : user.userApp) || '', setSelectedOption: (value) => updateAttribute('userApp', { target: { value } }), options: { 'resolve': 'Support Centre Agent', 'certify': 'Field Technician' }, selectName: i18n.t('password_email_template'), helperText: i18n.t('required'), error: missingFields.includes('userApp'), sx: TextFieldStyling({ width: '100%' }) }),
                        !flags.hideUserPermissions && userDetails && !isNewUser && React__default.createElement(RTEditUserRoles, { sx: { width: '100%', marginTop: '10px', borderRadius: '10px' }, apiUrl: apiUrl, userDetails: user, setError: setError, setSuccessMessage: setSuccessMessage }),
                        React__default.createElement(FormControlLabel, { control: React__default.createElement(Switch, { id: "ignore-usage-switch", checked: !(user === null || user === void 0 ? void 0 : user.ignoreUsage) || false, onChange: event => updateAttribute('ignoreUsage', { target: { value: !event.target.checked } }), inputProps: { 'aria-label': 'controlled' } }), label: i18n.t('include_in_resolve_usage_reports'), sx: { width: '100%', marginLeft: '0px' } }),
                        !isNewUser && React__default.createElement(RTEnableDisableUserSwitch, { callback: handleDisableEnableUser, user: user, apiUrl: apiUrl, setError: setError, showLabel: true, sx: { marginTop: '10px', width: '100%' } })),
                    !isNewUser && React__default.createElement(RTButton, { disabled: user && user.disabled, id: 'force-password-reset-button', sx: { width: '220px' }, type: "secondary", variant: "outlined", text: (user === null || user === void 0 ? void 0 : user.emailVerified) ? i18n.t('force_password_reset') : i18n.t('resend_welcome_email'), onClick: handleForceResetPassword, startIcon: React__default.createElement(VpnKey, null) }),
                    React__default.createElement(ErrorPrompt, { id: "edit-user-errors", message: error, successMessage: successMessage }),
                    React__default.createElement(Box, { sx: { marginBottom: '10px', width: '60%', marginLeft: 'auto', height: '36px' } },
                        !isNewUser && (user === null || user === void 0 ? void 0 : user.email) !== (currentUser === null || currentUser === void 0 ? void 0 : currentUser.email) && checkRoles(currentUser || {}, [`canDeleteUsers:${user === null || user === void 0 ? void 0 : user.TenantId}`]) && React__default.createElement(RTButton, { text: i18n.t('delete_user'), type: "delete", onClick: () => setDeleteDialogOpen(true), sx: { width: '49%', marginRight: '4px', marginTop: 0 } }),
                        React__default.createElement(RTButton, { id: 'edit-user-submit-button', text: isNewUser ? i18n.t('create') : i18n.t('save'), type: "save", isSubmit: true, isLoading: saving, sx: { width: '49%', marginTop: 0, float: 'right' } }))))),
        React__default.createElement(ConfirmationDialog, { onConfirm: handleDeleteUser, title: i18n.t('delete_user'), message: i18n.t('delete_are_you_sure'), open: deleteDialogOpen, confirmMessage: `${i18n.t('delete')} ${user === null || user === void 0 ? void 0 : user.email}`, onCancel: () => setDeleteDialogOpen(false) })));
};

const RTUserSearch = ({ apiUrl, TenantId, setUsers, sx, i18n, global }) => {
    const requestHelper = RequestHelper.getInstance(apiUrl);
    const [loading, setLoading] = useState(false);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [error, setError] = useState('');
    const [currentSearch, setCurrentSearch] = useState('');
    const [timer, setTimer] = useState(null);
    const [helperText, setHelperText] = useState(global ? 'Search for the start of an email' : i18n.t('user_search_placeholder'));
    const onChange = (e) => {
        const value = e.target.value;
        setCurrentSearch(value);
        if (value.length < 4 && value.length > 0) {
            setHelperText(i18n.t('search_enter_4_chars'));
            return;
        }
        if (value.length === 0) {
            setHelperText(i18n.t(global ? 'Search for the start of an email' : i18n.t('user_search_placeholder')));
        }
        handleChange(value);
    };
    const handleChange = (searchValue, delay = 2000) => {
        if (searchValue === currentSearch) {
            return;
        }
        setCurrentSearch(searchValue);
        clearTimeout(timer);
        const newTimer = setTimeout(() => {
            performSearch(searchValue);
        }, delay);
        setTimer(newTimer);
    };
    const performSearch = (email) => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!loading) {
            setLoading(true);
            const res = email.length > 0 ? yield handleSearch(email) : { users: [] };
            setUsers(res.users);
            setLoading(false);
            if (res.users.length > 0) {
                setHelperText(global ? i18n.t('user_search_placeholder_email') : i18n.t('user_search_placeholder'));
                return;
            }
            setHelperText(i18n.t('no_users_found'));
        }
    });
    const handleSearch = (searchValue) => __awaiter$1(void 0, void 0, void 0, function* () {
        if (TenantId) {
            return requestHelper.findUserFromTenant({ TenantId, email: searchValue, setError });
        }
        if (global) {
            return requestHelper.globalUserSearch({ email: searchValue, setError });
        }
    });
    return (React__default.createElement(Box$2, { sx: sx }, loading ? React__default.createElement(ScaleLoader, { color: colors.primary10 }) :
        React__default.createElement(TextField, { sx: { width: '100%' }, id: "user-search-field", label: i18n.t('search'), variant: "outlined", onChange: onChange, value: currentSearch, placeholder: i18n.t('search'), InputProps: {
                startAdornment: (React__default.createElement(InputAdornment, { position: "start" },
                    React__default.createElement(SearchIcon, null))),
                endAdornment: (React__default.createElement(InputAdornment, { position: "end", onClick: () => handleChange('', 0) },
                    React__default.createElement(ClearIcon, { sx: { 'cursor': 'pointer' } }))),
            }, helperText: helperText })));
};

const RTEditUserMenu = ({ user, apiUrl, setSelectedUsers, setEditUserModalOpen, setGroupsModalOpen, setUserBeingEdited }) => {
    const { currentUser } = useAuth$1();
    const [anchorEl, setAnchorEl] = React__default.useState(null);
    const open = Boolean(anchorEl);
    const openEditUserModal = () => {
        if (!setEditUserModalOpen || !setUserBeingEdited) {
            return;
        }
        setEditUserModalOpen(true);
        setUserBeingEdited(user);
    };
    const openGroupsModal = () => {
        setSelectedUsers && setSelectedUsers([user]);
        setGroupsModalOpen && setGroupsModalOpen(true);
    };
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Button, { onClick: handleClick, "aria-controls": open ? `user-menu-${user.email}` : undefined, variant: 'text', disableElevation: true, "aria-expanded": open ? 'true' : undefined, id: `open-menu-button-${user.email}`, className: "open-edit-user-menu-button", "aria-haspopup": "true" }, "..."),
        React__default.createElement(Menu, { open: open, onClick: handleClose, id: `user-menu-${user.email}`, anchorEl: anchorEl, sx: { color: colors.primary10 } },
            React__default.createElement(MenuItem, { onClick: openEditUserModal, id: 'edit-user-button' },
                React__default.createElement(EditIcon, { sx: { paddingRight: '10px' } }),
                "Edit User"),
            currentUser && checkRoles(currentUser, ['*:*']) && React__default.createElement(MenuItem, { id: 'delete-user-button' },
                React__default.createElement(DeleteIcon, { sx: { paddingRight: '10px' } }),
                "Delete User"),
            currentUser && checkRoles(currentUser, [`canAddGroupToUser:${user.TenantId}`]) && React__default.createElement(MenuItem, { id: 'add-groups-button', onClick: openGroupsModal },
                React__default.createElement(AddCircleOutlineIcon, { sx: { paddingRight: '10px' } }),
                "Assign Groups"))));
};

const RTEditGroup = ({ apiUrl, TenantId, GroupId, GroupDetails, onSuccess, isNew }) => {
    const requestHelper = RequestHelper.getInstance(apiUrl);
    const { i18n, currentUser } = useAuth$1();
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [group, setGroup] = useState(undefined);
    const [groupLoaded, setGroupLoaded] = useState(false);
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [missingFields, setMissingFields] = useState([]);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const requiredFields = ['name'];
    const getGroupFN = () => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!loading && !groupLoaded && !isNew) {
            setLoading(true);
            const group = yield requestHelper.getGroup({ TenantId, GroupId, setError });
            setGroup(group);
            setGroupLoaded(true);
            setLoading(false);
        }
    });
    const getGroup = useCallback(getGroupFN, [loading, groupLoaded, isNew, requestHelper, TenantId, GroupId]);
    const checkRequiredFields = () => {
        const missing = requiredFields.filter((field) => {
            if (!group) {
                return field;
            }
            if (!group[field]) {
                return field;
            }
            if (typeof group[field] === 'string' && group[field].length === 0) {
                return field;
            }
            return false;
        });
        setMissingFields(missing);
        return missing;
    };
    const updateGroup = (event) => __awaiter$1(void 0, void 0, void 0, function* () {
        event.preventDefault();
        if (!checkRequiredFields() || !group) {
            setError('Please fill in all required fields');
            return;
        }
        setSaving(true);
        let updatedGroup;
        if (isNew) {
            updatedGroup = yield requestHelper.createGroup({ TenantId, group, setError });
        }
        else {
            updatedGroup = yield requestHelper.updateGroup({ TenantId, GroupId, group, setError });
        }
        setGroup(updatedGroup);
        setSaving(false);
        setSuccessMessage(i18n.t('Group updated successfully'));
        if (onSuccess) {
            onSuccess(updatedGroup);
        }
    });
    const deleteGroup = () => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!group || !group.groupId) {
            return;
        }
        setLoading(true);
        setDeleteDialogOpen(false);
        const res = yield requestHelper.deleteGroup({ TenantId, groupId: group.groupId, setError });
        if (res) {
            setSuccessMessage(i18n.t('Group deleted successfully'));
            group.deleted = true;
            onSuccess && onSuccess(group);
        }
        setLoading(false);
    });
    const updateAttribute = (attribute, event) => {
        if (!group) {
            return;
        }
        setGroup(Object.assign(Object.assign({}, group), { [attribute]: event.target.value }));
    };
    useEffect(() => {
        if (GroupDetails) {
            setGroup(GroupDetails);
            setGroupLoaded(true);
        }
        if (isNew) {
            setGroup({ name: '', description: '', groupType: 'Region' });
            setGroupLoaded(true);
        }
        getGroup();
    }, [GroupDetails, getGroup, isNew]);
    return (React__default.createElement(ThemeProvider, { theme: theme },
        React__default.createElement(Box, { sx: { backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', minWidth: '650px', flexWrap: 'wrap', marginBottom: '20px', height: '100%', borderRadius: '40px', overflow: 'hidden' } }, loading || !groupLoaded ? React__default.createElement(ScaleLoader, { color: colors.primary20 }) :
            React__default.createElement(Box, { sx: { width: '90%', paddingTop: '20px', paddingBottom: '10px' } },
                React__default.createElement(Typography, { variant: "h4", sx: { marginBottom: '20px', textAlign: 'left', color: colors.neutral30 } }, isNew ? i18n.t('create_group') : i18n.t('edit_group')),
                React__default.createElement("form", { onSubmit: updateGroup, id: 'edit-group' },
                    React__default.createElement(FormGroup, { sx: { width: '100%', display: 'flex', alignItems: 'center', flexDirection: 'row' } },
                        React__default.createElement(RTSelect, { options: { 'Region': 'Location', 'Manager': 'Manager', 'Resolve': 'Resolve & Core' }, selectedOption: (group === null || group === void 0 ? void 0 : group.groupType) || 'Region', setSelectedOption: (value) => updateAttribute('groupType', { target: { value } }), selectName: i18n.t('group_type'), disabled: !isNew, sx: TextFieldStyling({ width: '100%', marginBottom: '15px' }) }),
                        React__default.createElement(TextField, { required: true, id: "name", label: i18n.t('name'), value: group === null || group === void 0 ? void 0 : group.name, onChange: event => updateAttribute('name', event), error: missingFields.includes('name'), helperText: i18n.t('required'), sx: TextFieldStyling({ width: '100%', marginBottom: '15px' }) }),
                        React__default.createElement(TextField, { id: "description", label: i18n.t('description'), value: group === null || group === void 0 ? void 0 : group.description, onChange: event => updateAttribute('description', event), multiline: true, rows: 4, sx: { width: '100%', marginBottom: '15px' } })),
                    currentUser && checkRoles(currentUser, [`canDeleteGroup:${TenantId}`]) && !isNew && React__default.createElement(RTButton, { text: 'Delete Group', type: "delete", onClick: () => setDeleteDialogOpen(true), sx: { width: '49%', marginRight: '4px', marginTop: 0 } }),
                    React__default.createElement(RTButton, { id: 'edit-group-submit-button', text: isNew ? i18n.t('create') : i18n.t('save'), type: "save", isSubmit: true, isLoading: saving, sx: { width: '30%', marginTop: 0, float: 'right' } })),
                React__default.createElement(ErrorPrompt, { error: error, successMessage: successMessage }))),
        React__default.createElement(ConfirmationDialog, { onConfirm: deleteGroup, title: "Delete Group", message: "Are you sure you want to delete this group?", open: deleteDialogOpen, confirmMessage: `Delete ${group === null || group === void 0 ? void 0 : group.name}`, onCancel: (() => setDeleteDialogOpen(false)) })));
};

var papaparse_min = {exports: {}};

/* @license
Papa Parse
v5.4.1
https://github.com/mholt/PapaParse
License: MIT
*/

(function (module, exports) {
	!function(e,t){module.exports=t();}(commonjsGlobal,function s(){var f="undefined"!=typeof self?self:"undefined"!=typeof window?window:void 0!==f?f:{};var n=!f.document&&!!f.postMessage,o=f.IS_PAPA_WORKER||!1,a={},u=0,b={parse:function(e,t){var r=(t=t||{}).dynamicTyping||!1;J(r)&&(t.dynamicTypingFunction=r,r={});if(t.dynamicTyping=r,t.transform=!!J(t.transform)&&t.transform,t.worker&&b.WORKERS_SUPPORTED){var i=function(){if(!b.WORKERS_SUPPORTED)return !1;var e=(r=f.URL||f.webkitURL||null,i=s.toString(),b.BLOB_URL||(b.BLOB_URL=r.createObjectURL(new Blob(["var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ","(",i,")();"],{type:"text/javascript"})))),t=new f.Worker(e);var r,i;return t.onmessage=_,t.id=u++,a[t.id]=t}();return i.userStep=t.step,i.userChunk=t.chunk,i.userComplete=t.complete,i.userError=t.error,t.step=J(t.step),t.chunk=J(t.chunk),t.complete=J(t.complete),t.error=J(t.error),delete t.worker,void i.postMessage({input:e,config:t,workerId:i.id})}var n=null;b.NODE_STREAM_INPUT,"string"==typeof e?(e=function(e){if(65279===e.charCodeAt(0))return e.slice(1);return e}(e),n=t.download?new l(t):new p(t)):!0===e.readable&&J(e.read)&&J(e.on)?n=new g(t):(f.File&&e instanceof File||e instanceof Object)&&(n=new c(t));return n.stream(e)},unparse:function(e,t){var n=!1,_=!0,m=",",y="\r\n",s='"',a=s+s,r=!1,i=null,o=!1;!function(){if("object"!=typeof t)return;"string"!=typeof t.delimiter||b.BAD_DELIMITERS.filter(function(e){return -1!==t.delimiter.indexOf(e)}).length||(m=t.delimiter);("boolean"==typeof t.quotes||"function"==typeof t.quotes||Array.isArray(t.quotes))&&(n=t.quotes);"boolean"!=typeof t.skipEmptyLines&&"string"!=typeof t.skipEmptyLines||(r=t.skipEmptyLines);"string"==typeof t.newline&&(y=t.newline);"string"==typeof t.quoteChar&&(s=t.quoteChar);"boolean"==typeof t.header&&(_=t.header);if(Array.isArray(t.columns)){if(0===t.columns.length)throw new Error("Option columns is empty");i=t.columns;}void 0!==t.escapeChar&&(a=t.escapeChar+s);("boolean"==typeof t.escapeFormulae||t.escapeFormulae instanceof RegExp)&&(o=t.escapeFormulae instanceof RegExp?t.escapeFormulae:/^[=+\-@\t\r].*$/);}();var u=new RegExp(Q(s),"g");"string"==typeof e&&(e=JSON.parse(e));if(Array.isArray(e)){if(!e.length||Array.isArray(e[0]))return h(null,e,r);if("object"==typeof e[0])return h(i||Object.keys(e[0]),e,r)}else if("object"==typeof e)return "string"==typeof e.data&&(e.data=JSON.parse(e.data)),Array.isArray(e.data)&&(e.fields||(e.fields=e.meta&&e.meta.fields||i),e.fields||(e.fields=Array.isArray(e.data[0])?e.fields:"object"==typeof e.data[0]?Object.keys(e.data[0]):[]),Array.isArray(e.data[0])||"object"==typeof e.data[0]||(e.data=[e.data])),h(e.fields||[],e.data||[],r);throw new Error("Unable to serialize unrecognized input");function h(e,t,r){var i="";"string"==typeof e&&(e=JSON.parse(e)),"string"==typeof t&&(t=JSON.parse(t));var n=Array.isArray(e)&&0<e.length,s=!Array.isArray(t[0]);if(n&&_){for(var a=0;a<e.length;a++)0<a&&(i+=m),i+=v(e[a],a);0<t.length&&(i+=y);}for(var o=0;o<t.length;o++){var u=n?e.length:t[o].length,h=!1,f=n?0===Object.keys(t[o]).length:0===t[o].length;if(r&&!n&&(h="greedy"===r?""===t[o].join("").trim():1===t[o].length&&0===t[o][0].length),"greedy"===r&&n){for(var d=[],l=0;l<u;l++){var c=s?e[l]:l;d.push(t[o][c]);}h=""===d.join("").trim();}if(!h){for(var p=0;p<u;p++){0<p&&!f&&(i+=m);var g=n&&s?e[p]:p;i+=v(t[o][g],p);}o<t.length-1&&(!r||0<u&&!f)&&(i+=y);}}return i}function v(e,t){if(null==e)return "";if(e.constructor===Date)return JSON.stringify(e).slice(1,25);var r=!1;o&&"string"==typeof e&&o.test(e)&&(e="'"+e,r=!0);var i=e.toString().replace(u,a);return (r=r||!0===n||"function"==typeof n&&n(e,t)||Array.isArray(n)&&n[t]||function(e,t){for(var r=0;r<t.length;r++)if(-1<e.indexOf(t[r]))return !0;return !1}(i,b.BAD_DELIMITERS)||-1<i.indexOf(m)||" "===i.charAt(0)||" "===i.charAt(i.length-1))?s+i+s:i}}};if(b.RECORD_SEP=String.fromCharCode(30),b.UNIT_SEP=String.fromCharCode(31),b.BYTE_ORDER_MARK="\ufeff",b.BAD_DELIMITERS=["\r","\n",'"',b.BYTE_ORDER_MARK],b.WORKERS_SUPPORTED=!n&&!!f.Worker,b.NODE_STREAM_INPUT=1,b.LocalChunkSize=10485760,b.RemoteChunkSize=5242880,b.DefaultDelimiter=",",b.Parser=E,b.ParserHandle=r,b.NetworkStreamer=l,b.FileStreamer=c,b.StringStreamer=p,b.ReadableStreamStreamer=g,f.jQuery){var d=f.jQuery;d.fn.parse=function(o){var r=o.config||{},u=[];return this.each(function(e){if(!("INPUT"===d(this).prop("tagName").toUpperCase()&&"file"===d(this).attr("type").toLowerCase()&&f.FileReader)||!this.files||0===this.files.length)return !0;for(var t=0;t<this.files.length;t++)u.push({file:this.files[t],inputElem:this,instanceConfig:d.extend({},r)});}),e(),this;function e(){if(0!==u.length){var e,t,r,i,n=u[0];if(J(o.before)){var s=o.before(n.file,n.inputElem);if("object"==typeof s){if("abort"===s.action)return e="AbortError",t=n.file,r=n.inputElem,i=s.reason,void(J(o.error)&&o.error({name:e},t,r,i));if("skip"===s.action)return void h();"object"==typeof s.config&&(n.instanceConfig=d.extend(n.instanceConfig,s.config));}else if("skip"===s)return void h()}var a=n.instanceConfig.complete;n.instanceConfig.complete=function(e){J(a)&&a(e,n.file,n.inputElem),h();},b.parse(n.file,n.instanceConfig);}else J(o.complete)&&o.complete();}function h(){u.splice(0,1),e();}};}function h(e){this._handle=null,this._finished=!1,this._completed=!1,this._halted=!1,this._input=null,this._baseIndex=0,this._partialLine="",this._rowCount=0,this._start=0,this._nextChunk=null,this.isFirstChunk=!0,this._completeResults={data:[],errors:[],meta:{}},function(e){var t=w(e);t.chunkSize=parseInt(t.chunkSize),e.step||e.chunk||(t.chunkSize=null);this._handle=new r(t),(this._handle.streamer=this)._config=t;}.call(this,e),this.parseChunk=function(e,t){if(this.isFirstChunk&&J(this._config.beforeFirstChunk)){var r=this._config.beforeFirstChunk(e);void 0!==r&&(e=r);}this.isFirstChunk=!1,this._halted=!1;var i=this._partialLine+e;this._partialLine="";var n=this._handle.parse(i,this._baseIndex,!this._finished);if(!this._handle.paused()&&!this._handle.aborted()){var s=n.meta.cursor;this._finished||(this._partialLine=i.substring(s-this._baseIndex),this._baseIndex=s),n&&n.data&&(this._rowCount+=n.data.length);var a=this._finished||this._config.preview&&this._rowCount>=this._config.preview;if(o)f.postMessage({results:n,workerId:b.WORKER_ID,finished:a});else if(J(this._config.chunk)&&!t){if(this._config.chunk(n,this._handle),this._handle.paused()||this._handle.aborted())return void(this._halted=!0);n=void 0,this._completeResults=void 0;}return this._config.step||this._config.chunk||(this._completeResults.data=this._completeResults.data.concat(n.data),this._completeResults.errors=this._completeResults.errors.concat(n.errors),this._completeResults.meta=n.meta),this._completed||!a||!J(this._config.complete)||n&&n.meta.aborted||(this._config.complete(this._completeResults,this._input),this._completed=!0),a||n&&n.meta.paused||this._nextChunk(),n}this._halted=!0;},this._sendError=function(e){J(this._config.error)?this._config.error(e):o&&this._config.error&&f.postMessage({workerId:b.WORKER_ID,error:e,finished:!1});};}function l(e){var i;(e=e||{}).chunkSize||(e.chunkSize=b.RemoteChunkSize),h.call(this,e),this._nextChunk=n?function(){this._readChunk(),this._chunkLoaded();}:function(){this._readChunk();},this.stream=function(e){this._input=e,this._nextChunk();},this._readChunk=function(){if(this._finished)this._chunkLoaded();else {if(i=new XMLHttpRequest,this._config.withCredentials&&(i.withCredentials=this._config.withCredentials),n||(i.onload=v(this._chunkLoaded,this),i.onerror=v(this._chunkError,this)),i.open(this._config.downloadRequestBody?"POST":"GET",this._input,!n),this._config.downloadRequestHeaders){var e=this._config.downloadRequestHeaders;for(var t in e)i.setRequestHeader(t,e[t]);}if(this._config.chunkSize){var r=this._start+this._config.chunkSize-1;i.setRequestHeader("Range","bytes="+this._start+"-"+r);}try{i.send(this._config.downloadRequestBody);}catch(e){this._chunkError(e.message);}n&&0===i.status&&this._chunkError();}},this._chunkLoaded=function(){4===i.readyState&&(i.status<200||400<=i.status?this._chunkError():(this._start+=this._config.chunkSize?this._config.chunkSize:i.responseText.length,this._finished=!this._config.chunkSize||this._start>=function(e){var t=e.getResponseHeader("Content-Range");if(null===t)return -1;return parseInt(t.substring(t.lastIndexOf("/")+1))}(i),this.parseChunk(i.responseText)));},this._chunkError=function(e){var t=i.statusText||e;this._sendError(new Error(t));};}function c(e){var i,n;(e=e||{}).chunkSize||(e.chunkSize=b.LocalChunkSize),h.call(this,e);var s="undefined"!=typeof FileReader;this.stream=function(e){this._input=e,n=e.slice||e.webkitSlice||e.mozSlice,s?((i=new FileReader).onload=v(this._chunkLoaded,this),i.onerror=v(this._chunkError,this)):i=new FileReaderSync,this._nextChunk();},this._nextChunk=function(){this._finished||this._config.preview&&!(this._rowCount<this._config.preview)||this._readChunk();},this._readChunk=function(){var e=this._input;if(this._config.chunkSize){var t=Math.min(this._start+this._config.chunkSize,this._input.size);e=n.call(e,this._start,t);}var r=i.readAsText(e,this._config.encoding);s||this._chunkLoaded({target:{result:r}});},this._chunkLoaded=function(e){this._start+=this._config.chunkSize,this._finished=!this._config.chunkSize||this._start>=this._input.size,this.parseChunk(e.target.result);},this._chunkError=function(){this._sendError(i.error);};}function p(e){var r;h.call(this,e=e||{}),this.stream=function(e){return r=e,this._nextChunk()},this._nextChunk=function(){if(!this._finished){var e,t=this._config.chunkSize;return t?(e=r.substring(0,t),r=r.substring(t)):(e=r,r=""),this._finished=!r,this.parseChunk(e)}};}function g(e){h.call(this,e=e||{});var t=[],r=!0,i=!1;this.pause=function(){h.prototype.pause.apply(this,arguments),this._input.pause();},this.resume=function(){h.prototype.resume.apply(this,arguments),this._input.resume();},this.stream=function(e){this._input=e,this._input.on("data",this._streamData),this._input.on("end",this._streamEnd),this._input.on("error",this._streamError);},this._checkIsFinished=function(){i&&1===t.length&&(this._finished=!0);},this._nextChunk=function(){this._checkIsFinished(),t.length?this.parseChunk(t.shift()):r=!0;},this._streamData=v(function(e){try{t.push("string"==typeof e?e:e.toString(this._config.encoding)),r&&(r=!1,this._checkIsFinished(),this.parseChunk(t.shift()));}catch(e){this._streamError(e);}},this),this._streamError=v(function(e){this._streamCleanUp(),this._sendError(e);},this),this._streamEnd=v(function(){this._streamCleanUp(),i=!0,this._streamData("");},this),this._streamCleanUp=v(function(){this._input.removeListener("data",this._streamData),this._input.removeListener("end",this._streamEnd),this._input.removeListener("error",this._streamError);},this);}function r(m){var a,o,u,i=Math.pow(2,53),n=-i,s=/^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/,h=/^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/,t=this,r=0,f=0,d=!1,e=!1,l=[],c={data:[],errors:[],meta:{}};if(J(m.step)){var p=m.step;m.step=function(e){if(c=e,_())g();else {if(g(),0===c.data.length)return;r+=e.data.length,m.preview&&r>m.preview?o.abort():(c.data=c.data[0],p(c,t));}};}function y(e){return "greedy"===m.skipEmptyLines?""===e.join("").trim():1===e.length&&0===e[0].length}function g(){return c&&u&&(k("Delimiter","UndetectableDelimiter","Unable to auto-detect delimiting character; defaulted to '"+b.DefaultDelimiter+"'"),u=!1),m.skipEmptyLines&&(c.data=c.data.filter(function(e){return !y(e)})),_()&&function(){if(!c)return;function e(e,t){J(m.transformHeader)&&(e=m.transformHeader(e,t)),l.push(e);}if(Array.isArray(c.data[0])){for(var t=0;_()&&t<c.data.length;t++)c.data[t].forEach(e);c.data.splice(0,1);}else c.data.forEach(e);}(),function(){if(!c||!m.header&&!m.dynamicTyping&&!m.transform)return c;function e(e,t){var r,i=m.header?{}:[];for(r=0;r<e.length;r++){var n=r,s=e[r];m.header&&(n=r>=l.length?"__parsed_extra":l[r]),m.transform&&(s=m.transform(s,n)),s=v(n,s),"__parsed_extra"===n?(i[n]=i[n]||[],i[n].push(s)):i[n]=s;}return m.header&&(r>l.length?k("FieldMismatch","TooManyFields","Too many fields: expected "+l.length+" fields but parsed "+r,f+t):r<l.length&&k("FieldMismatch","TooFewFields","Too few fields: expected "+l.length+" fields but parsed "+r,f+t)),i}var t=1;!c.data.length||Array.isArray(c.data[0])?(c.data=c.data.map(e),t=c.data.length):c.data=e(c.data,0);m.header&&c.meta&&(c.meta.fields=l);return f+=t,c}()}function _(){return m.header&&0===l.length}function v(e,t){return r=e,m.dynamicTypingFunction&&void 0===m.dynamicTyping[r]&&(m.dynamicTyping[r]=m.dynamicTypingFunction(r)),!0===(m.dynamicTyping[r]||m.dynamicTyping)?"true"===t||"TRUE"===t||"false"!==t&&"FALSE"!==t&&(function(e){if(s.test(e)){var t=parseFloat(e);if(n<t&&t<i)return !0}return !1}(t)?parseFloat(t):h.test(t)?new Date(t):""===t?null:t):t;var r;}function k(e,t,r,i){var n={type:e,code:t,message:r};void 0!==i&&(n.row=i),c.errors.push(n);}this.parse=function(e,t,r){var i=m.quoteChar||'"';if(m.newline||(m.newline=function(e,t){e=e.substring(0,1048576);var r=new RegExp(Q(t)+"([^]*?)"+Q(t),"gm"),i=(e=e.replace(r,"")).split("\r"),n=e.split("\n"),s=1<n.length&&n[0].length<i[0].length;if(1===i.length||s)return "\n";for(var a=0,o=0;o<i.length;o++)"\n"===i[o][0]&&a++;return a>=i.length/2?"\r\n":"\r"}(e,i)),u=!1,m.delimiter)J(m.delimiter)&&(m.delimiter=m.delimiter(e),c.meta.delimiter=m.delimiter);else {var n=function(e,t,r,i,n){var s,a,o,u;n=n||[",","\t","|",";",b.RECORD_SEP,b.UNIT_SEP];for(var h=0;h<n.length;h++){var f=n[h],d=0,l=0,c=0;o=void 0;for(var p=new E({comments:i,delimiter:f,newline:t,preview:10}).parse(e),g=0;g<p.data.length;g++)if(r&&y(p.data[g]))c++;else {var _=p.data[g].length;l+=_,void 0!==o?0<_&&(d+=Math.abs(_-o),o=_):o=_;}0<p.data.length&&(l/=p.data.length-c),(void 0===a||d<=a)&&(void 0===u||u<l)&&1.99<l&&(a=d,s=f,u=l);}return {successful:!!(m.delimiter=s),bestDelimiter:s}}(e,m.newline,m.skipEmptyLines,m.comments,m.delimitersToGuess);n.successful?m.delimiter=n.bestDelimiter:(u=!0,m.delimiter=b.DefaultDelimiter),c.meta.delimiter=m.delimiter;}var s=w(m);return m.preview&&m.header&&s.preview++,a=e,o=new E(s),c=o.parse(a,t,r),g(),d?{meta:{paused:!0}}:c||{meta:{paused:!1}}},this.paused=function(){return d},this.pause=function(){d=!0,o.abort(),a=J(m.chunk)?"":a.substring(o.getCharIndex());},this.resume=function(){t.streamer._halted?(d=!1,t.streamer.parseChunk(a,!0)):setTimeout(t.resume,3);},this.aborted=function(){return e},this.abort=function(){e=!0,o.abort(),c.meta.aborted=!0,J(m.complete)&&m.complete(c),a="";};}function Q(e){return e.replace(/[.*+?^${}()|[\]\\]/g,"\\$&")}function E(j){var z,M=(j=j||{}).delimiter,P=j.newline,U=j.comments,q=j.step,N=j.preview,B=j.fastMode,K=z=void 0===j.quoteChar||null===j.quoteChar?'"':j.quoteChar;if(void 0!==j.escapeChar&&(K=j.escapeChar),("string"!=typeof M||-1<b.BAD_DELIMITERS.indexOf(M))&&(M=","),U===M)throw new Error("Comment character same as delimiter");!0===U?U="#":("string"!=typeof U||-1<b.BAD_DELIMITERS.indexOf(U))&&(U=!1),"\n"!==P&&"\r"!==P&&"\r\n"!==P&&(P="\n");var W=0,H=!1;this.parse=function(i,t,r){if("string"!=typeof i)throw new Error("Input must be a string");var n=i.length,e=M.length,s=P.length,a=U.length,o=J(q),u=[],h=[],f=[],d=W=0;if(!i)return L();if(j.header&&!t){var l=i.split(P)[0].split(M),c=[],p={},g=!1;for(var _ in l){var m=l[_];J(j.transformHeader)&&(m=j.transformHeader(m,_));var y=m,v=p[m]||0;for(0<v&&(g=!0,y=m+"_"+v),p[m]=v+1;c.includes(y);)y=y+"_"+v;c.push(y);}if(g){var k=i.split(P);k[0]=c.join(M),i=k.join(P);}}if(B||!1!==B&&-1===i.indexOf(z)){for(var b=i.split(P),E=0;E<b.length;E++){if(f=b[E],W+=f.length,E!==b.length-1)W+=P.length;else if(r)return L();if(!U||f.substring(0,a)!==U){if(o){if(u=[],I(f.split(M)),F(),H)return L()}else I(f.split(M));if(N&&N<=E)return u=u.slice(0,N),L(!0)}}return L()}for(var w=i.indexOf(M,W),R=i.indexOf(P,W),C=new RegExp(Q(K)+Q(z),"g"),S=i.indexOf(z,W);;)if(i[W]!==z)if(U&&0===f.length&&i.substring(W,W+a)===U){if(-1===R)return L();W=R+s,R=i.indexOf(P,W),w=i.indexOf(M,W);}else if(-1!==w&&(w<R||-1===R))f.push(i.substring(W,w)),W=w+e,w=i.indexOf(M,W);else {if(-1===R)break;if(f.push(i.substring(W,R)),D(R+s),o&&(F(),H))return L();if(N&&u.length>=N)return L(!0)}else for(S=W,W++;;){if(-1===(S=i.indexOf(z,S+1)))return r||h.push({type:"Quotes",code:"MissingQuotes",message:"Quoted field unterminated",row:u.length,index:W}),T();if(S===n-1)return T(i.substring(W,S).replace(C,z));if(z!==K||i[S+1]!==K){if(z===K||0===S||i[S-1]!==K){-1!==w&&w<S+1&&(w=i.indexOf(M,S+1)),-1!==R&&R<S+1&&(R=i.indexOf(P,S+1));var O=A(-1===R?w:Math.min(w,R));if(i.substr(S+1+O,e)===M){f.push(i.substring(W,S).replace(C,z)),i[W=S+1+O+e]!==z&&(S=i.indexOf(z,W)),w=i.indexOf(M,W),R=i.indexOf(P,W);break}var x=A(R);if(i.substring(S+1+x,S+1+x+s)===P){if(f.push(i.substring(W,S).replace(C,z)),D(S+1+x+s),w=i.indexOf(M,W),S=i.indexOf(z,W),o&&(F(),H))return L();if(N&&u.length>=N)return L(!0);break}h.push({type:"Quotes",code:"InvalidQuotes",message:"Trailing quote on quoted field is malformed",row:u.length,index:W}),S++;}}else S++;}return T();function I(e){u.push(e),d=W;}function A(e){var t=0;if(-1!==e){var r=i.substring(S+1,e);r&&""===r.trim()&&(t=r.length);}return t}function T(e){return r||(void 0===e&&(e=i.substring(W)),f.push(e),W=n,I(f),o&&F()),L()}function D(e){W=e,I(f),f=[],R=i.indexOf(P,W);}function L(e){return {data:u,errors:h,meta:{delimiter:M,linebreak:P,aborted:H,truncated:!!e,cursor:d+(t||0)}}}function F(){q(L()),u=[],h=[];}},this.abort=function(){H=!0;},this.getCharIndex=function(){return W};}function _(e){var t=e.data,r=a[t.workerId],i=!1;if(t.error)r.userError(t.error,t.file);else if(t.results&&t.results.data){var n={abort:function(){i=!0,m(t.workerId,{data:[],errors:[],meta:{aborted:!0}});},pause:y,resume:y};if(J(r.userStep)){for(var s=0;s<t.results.data.length&&(r.userStep({data:t.results.data[s],errors:t.results.errors,meta:t.results.meta},n),!i);s++);delete t.results;}else J(r.userChunk)&&(r.userChunk(t.results,n,t.file),delete t.results);}t.finished&&!i&&m(t.workerId,t.results);}function m(e,t){var r=a[e];J(r.userComplete)&&r.userComplete(t),r.terminate(),delete a[e];}function y(){throw new Error("Not implemented.")}function w(e){if("object"!=typeof e||null===e)return e;var t=Array.isArray(e)?[]:{};for(var r in e)t[r]=w(e[r]);return t}function v(e,t){return function(){e.apply(t,arguments);}}function J(e){return "function"==typeof e}return o&&(f.onmessage=function(e){var t=e.data;void 0===b.WORKER_ID&&t&&(b.WORKER_ID=t.workerId);if("string"==typeof t.input)f.postMessage({workerId:b.WORKER_ID,results:b.parse(t.input,t.config),finished:!0});else if(f.File&&t.input instanceof File||t.input instanceof Object){var r=b.parse(t.input,t.config);r&&f.postMessage({workerId:b.WORKER_ID,results:r,finished:!0});}}),(l.prototype=Object.create(h.prototype)).constructor=l,(c.prototype=Object.create(h.prototype)).constructor=c,(p.prototype=Object.create(p.prototype)).constructor=p,(g.prototype=Object.create(h.prototype)).constructor=g,b}); 
} (papaparse_min));

var papaparse_minExports = papaparse_min.exports;
var e$1 = /*@__PURE__*/getDefaultExportFromCjs(papaparse_minExports);

"function"==typeof SuppressedError&&SuppressedError;function P$1(n,t){return e$1.parse(n,t)}function x(n,t){e$1.parse(n,Object.assign({},{download:!0},t));}function O$1(n,t){return void 0===t&&(t={}),e$1.unparse(n,t)}function S$1(){return {readString:P$1,readRemoteFile:x,jsonToCSV:O$1}}e$1.BAD_DELIMITERS;e$1.RECORD_SEP;e$1.UNIT_SEP;e$1.WORKERS_SUPPORTED;e$1.LocalChunkSize;e$1.DefaultDelimiter;

const RTBulkUpload = ({ apiUrl, TenantId, sx, handleClose, overrideUserApp }) => {
    var _a, _b;
    const { readString } = S$1();
    const reader = new FileReader();
    const fileRef = useRef(null);
    const requestHelper = RequestHelper.getInstance(apiUrl);
    const { i18n } = useAuth$1();
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [usersDetails, setUsersDetails] = useState(null);
    const [userApp, setUserApp] = useState(overrideUserApp || 'certify');
    const [isFileSelected, setIsFileSelected] = useState(false);
    const IMPORT_LIMIT = 5000;
    const onFileChange = (event) => {
        setLoading(true);
        const file = event.target.files[0];
        reader.addEventListener('load', () => {
            parseCsv();
        });
        if (file) {
            reader.readAsText(file);
            setIsFileSelected(true);
        }
        setLoading(false);
    };
    const parseCsv = () => {
        if (!reader.result) {
            return;
        }
        readString(reader.result.toString(), { worker: true, complete: fileParsed, skipEmptyLines: true });
    };
    const fileParsed = (results) => {
        setError('');
        const requiredFields = ['email', 'manager_0'];
        const headerRow = results.data[0];
        const hasAllRequiredFields = requiredFields.every(field => headerRow.includes(field));
        const withinImportLimits = results.data.length <= IMPORT_LIMIT + 1; // allow 1 more row for header row
        const emailIndex = headerRow.indexOf('email');
        // Check if any emails contain banned chars: '#'
        const invalidEmails = [];
        console.log(results.data);
        for (const row of results.data) {
            if (row[emailIndex] && row[emailIndex].includes('#')) {
                invalidEmails.push(row[emailIndex]);
            }
        }
        console.log(invalidEmails);
        if (hasAllRequiredFields && withinImportLimits && invalidEmails.length === 0) {
            setUsersDetails(results);
        }
        else if (!withinImportLimits) {
            setError(i18n.t('file_too_large').replace('IMPORT_LIMIT', `${IMPORT_LIMIT}`));
        }
        else if (!hasAllRequiredFields) {
            setError(i18n.t('csv_format_error'));
        }
        else if (invalidEmails.length > 0) {
            setError(i18n.t('invalid_email_error'));
        }
        setLoading(false);
    };
    const handleEnterOrSpaceKeyDown = (e, callback) => {
        if (e.key === 'Enter' || e.key === ' ') {
            callback();
        }
    };
    const submitCSVUpload = () => __awaiter$1(void 0, void 0, void 0, function* () {
        setSubmitted(true);
        const userData = usersDetails.data;
        const locale = localStorage.getItem('i18nextLng') || 'en';
        requestHelper.bulkImport({ TenantId, userData, locale, userApp, setError });
        setSuccess(i18n.t('bulk_thanks_content'));
        setTimeout(() => {
            handleClose();
            setSubmitted(false);
        }, 4000);
    });
    const UploadedIcon = useMemo(() => {
        if (!isFileSelected)
            return null;
        if (error) {
            return (React__default.createElement(HighlightOffIcon, { color: "error" }));
        }
        else {
            return (React__default.createElement(CheckCircleOutlineIcon, { color: "success" }));
        }
    }, [isFileSelected, error]);
    return (React__default.createElement(ThemeProvider, { theme: theme },
        React__default.createElement(Box$2, { sx: { background: 'white', minHeight: '400px', padding: '20px', borderRadius: '40px' }, id: 'bulk-upload' },
            React__default.createElement(DialogContent, { sx: { p: 0 } },
                React__default.createElement(Typography, { variant: "h4", sx: { paddingBottom: '20px', paddingTop: '20px' } }, i18n.t('bulk_import')),
                React__default.createElement(Box$2, { sx: { mb: '30px' } },
                    React__default.createElement(Typography, { variant: "bodyM" }, `${i18n.t('csv_format_requirements')}`),
                    ' ',
                    React__default.createElement("a", { href: "https://route-this-cdn.s3.amazonaws.com/auth/RouteThisBulkUploadExamplev2.csv" },
                        React__default.createElement(Typography, { variant: "bodyM", sx: { color: theme => theme.palette.primary.main, textDecoration: 'underline' } }, `${i18n.t('csv_format_download_link')}`))),
                React__default.createElement(Box$2, { sx: { mb: '30px', display: 'flex', flexDirection: 'column' } },
                    React__default.createElement(Box$2, { sx: { display: 'flex', flexDirection: 'column', mb: '30px' } },
                        React__default.createElement(Box$2, { sx: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: '10px' } },
                            React__default.createElement(Box$2, { sx: { display: 'flex', alignItems: 'center' } },
                                React__default.createElement(Button, { size: "small", id: "csv-upload-button", sx: {
                                        mr: '10px',
                                        color: theme => theme.palette.primary.main,
                                    }, onClick: () => fileRef.current && fileRef.current.click(), onKeyUp: (e) => handleEnterOrSpaceKeyDown(e, () => fileRef.current && fileRef.current.click()), startIcon: React__default.createElement(PlusIcon, null) },
                                    isFileSelected ? i18n.t('change_file') : i18n.t('select_csv'),
                                    React__default.createElement("label", { htmlFor: "csv-upload", hidden: true, className: "visuallyHidden" }, i18n.t('select_csv')),
                                    React__default.createElement("input", { hidden: true, type: "file", id: "csv-upload", name: "csv-upload", accept: "text/csv", onChange: onFileChange, ref: fileRef })),
                                isFileSelected && React__default.createElement(Typography, { variant: "titleM" }, ((_a = fileRef.current) === null || _a === void 0 ? void 0 : _a.files) && fileRef.current.files[0].name)),
                            UploadedIcon),
                        React__default.createElement(ErrorPrompt, { message: error, successMessage: success })),
                    !overrideUserApp &&
                        React__default.createElement(RTSelect, { selectedOption: userApp, setSelectedOption: setUserApp, options: { 'certify': 'Certify', 'resolve': 'Resolve' }, selectName: i18n.t('routethis_app'), sx: TextFieldStyling({ marginBottom: '30px' }) }),
                    React__default.createElement(Box$2, { sx: { display: 'flex', justifyContent: 'right' } },
                        React__default.createElement(Button, { onClick: submitCSVUpload, variant: "outlined", "data-testid": "csvUploadSubmit", disabled: !!error || !((_b = usersDetails === null || usersDetails === void 0 ? void 0 : usersDetails.data) === null || _b === void 0 ? void 0 : _b.length) || submitted, id: 'csv-upload-submit-button', startIcon: React__default.createElement(FileUploadIcon, null), sx: {
                                width: '100%',
                                marginTop: '25px',
                                borderRadius: '100px',
                                height: '48px',
                                fontSize: '14px',
                                backgroundColor: colors.primary10,
                                color: 'white',
                                boxShadow: 0,
                                "&:hover": {
                                    backgroundColor: colors.primary20,
                                },
                            } }, i18n.t('import')))),
                React__default.createElement(ScaleLoader, { color: colors.primary10, loading: loading })))));
};

const RTModal = ({ sx, open, onClose, width, children }) => {
    const modalStyle = Object.assign({ top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '100%', height: '100%', boxShadow: 24, p: 4, borderRadius: '10px', padding: 0 }, sx);
    const widthPx = width === 'wide' ? 1250 : width === 'narrow' ? 450 : 675;
    return (React__default.createElement(Modal, { hideBackdrop: false, sx: modalStyle, open: open, onClose: onClose },
        React__default.createElement(Box, { sx: Object.assign({ backgroundColor: 'white', width: `${widthPx}px`, maxHeight: '99vh', margin: 'auto', marginTop: '5px', borderRadius: '40px', overflowX: 'hidden', overflowY: 'auto' }, sx) },
            React__default.createElement(Button, { onClick: onClose, sx: { color: colors.primary10, height: '0px', position: 'relative', left: `${widthPx - 75}px`, top: '40px' } },
                React__default.createElement(CloseIcon, null)),
            children)));
};

const RTGroupsListSM = ({ apiUrl, TenantId, setSelected, selectedIds, selectDisabled, setError, filterGroupType, sx }) => {
    const requestHelper = RequestHelper.getInstance(apiUrl);
    const [filteredGroups, setFilteredGroups] = useState([]);
    const [selectedGroups, setSelectedGroups] = useState([]);
    const { i18n } = useAuth$1();
    const getGroupsFN = () => __awaiter$1(void 0, void 0, void 0, function* () {
        const res = yield requestHelper.listGroupsForTenant({ TenantId, setError });
        setFilteredGroups(res.slice(0, 1000).filter((g) => !filterGroupType || g.groupType === filterGroupType));
        setSelectedGroups(res.filter((g) => selectedIds.includes(g.groupId || '')));
        return res;
    });
    const { data: groups, isLoading: loading } = useQuery({
        queryKey: ['groups', TenantId],
        queryFn: () => getGroupsFN(),
    });
    const handleGroupSelected = (group) => {
        if (selectedGroups.find(g => g.groupId === group.groupId)) {
            const selGroups = selectedGroups.filter(g => g.groupId !== group.groupId);
            setSelectedGroups(selGroups);
            setSelected(selGroups);
        }
        else {
            setSelectedGroups([...selectedGroups, group]);
            setSelected([...selectedGroups, group]);
        }
    };
    const handleSearchChange = (event) => {
        const search = event.target.value.toLowerCase();
        setFilteredGroups(groups.filter(g => g.name.toLowerCase().includes(search)));
    };
    const groupTypeToPrettyName = (groupType) => {
        if (groupType === 'Resolve') {
            return 'Resolve & Core';
        }
        return groupType;
    };
    return (React__default.createElement(Box$2, { sx: Object.assign({ maxHeight: '420px', height: '40vh', background: colors.primary90 }, sx), id: 'groups-list-small' },
        React__default.createElement(Typography, { variant: "h5", sx: { paddingLeft: '20px', paddingTop: '10px', fontSize: '16px', fontWeight: '600', color: colors.primary80Black } }, "Available Groups"),
        loading ? React__default.createElement(ScaleLoader, { color: colors.primary10 }) : React__default.createElement(List, { sx: { borderRadius: '10px', height: '85%', marginBottom: '40px', overflow: 'auto' } },
            React__default.createElement(ListItem, { sx: { borderBottom: '1px black solid', width: '95%', margin: 'auto' } },
                React__default.createElement(ListItemText, { sx: { width: "100%" }, primary: React__default.createElement(TextField, { sx: { width: '100%', background: 'white' }, type: "text", placeholder: i18n.t('search'), onChange: handleSearchChange, InputProps: { startAdornment: (React__default.createElement(InputAdornment, { position: "start" },
                                React__default.createElement(SearchIcon, null))) } }) })),
            filteredGroups && filteredGroups.map((group) => (React__default.createElement(ListItem, { sx: { borderBottom: '1px black solid', width: '95%', margin: 'auto' }, key: group.groupId },
                React__default.createElement(ListItemText, { primary: React__default.createElement(React__default.Fragment, null,
                        React__default.createElement(Typography, { variant: 'h6' }, group.name),
                        React__default.createElement(Typography, { variant: "bodyS" }, groupTypeToPrettyName(group.groupType))), secondary: group.description, sx: { width: '85%' } }),
                !selectDisabled && React__default.createElement(Checkbox, { checked: selectedGroups.includes(group), onChange: () => handleGroupSelected(group) })))),
            groups.length > 1000 && React__default.createElement(Typography, { sx: { paddingTop: '5px' } }, `... and ${groups.length - 1000} more, use search to narrow things down`))));
};

const RTAssignGroups = ({ apiUrl, TenantId, users, filterGroupType, onSuccess }) => {
    const requestHelper = RequestHelper.getInstance(apiUrl);
    const [selectedGroups, setSelectedGroups] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const selectedIds = users.length === 1 ? users[0].groupUsers.map(gu => gu.groupId) : [];
    const assignGroups = () => __awaiter$1(void 0, void 0, void 0, function* () {
        if (users.length === 1) {
            return updateGroupsForSingleUser();
        }
        setLoading(true);
        const groupIds = selectedGroups.map(g => g.groupId || '');
        const emails = users.map(u => u.email || '');
        const res = yield requestHelper.addGroupsToUsers({ TenantId, groupIds, emails, setError });
        if (res) {
            onSuccess && onSuccess();
        }
        setLoading(false);
    });
    const updateGroupsForSingleUser = () => __awaiter$1(void 0, void 0, void 0, function* () {
        if (users.length !== 1) {
            return;
        }
        setLoading(true);
        const user = users[0];
        const currentGroupIds = user.groupUsers.map(gu => gu.groupId);
        const newGroupIds = selectedGroups.map(g => g.groupId || '');
        const groupIDsToRemove = currentGroupIds.filter(g => !newGroupIds.includes(g));
        const groupIDsToAdd = newGroupIds.filter(g => !currentGroupIds.includes(g));
        for (const groupId of groupIDsToRemove) {
            yield requestHelper.removeGroupFromUser({ TenantId, email: user.email || '', groupId, setError });
        }
        const res = yield requestHelper.addGroupsToUsers({ TenantId, groupIds: groupIDsToAdd, emails: [user.email || ''], setError });
        if (res) {
            onSuccess && onSuccess();
        }
        setLoading(false);
    });
    return (React__default.createElement(ThemeProvider, { theme: theme },
        React__default.createElement(Box, { id: 'assign-groups', sx: { backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', minWidth: '650px', flexWrap: 'wrap', marginBottom: '20px', height: '100%', borderRadius: '40px', overflow: 'hidden' } }, loading ? React__default.createElement(ScaleLoader, { color: colors.primary10 }) :
            React__default.createElement(Box, { sx: { width: '90%', paddingTop: '20px', paddingBottom: '10px' } },
                React__default.createElement(Typography, { variant: "h4", sx: { marginBottom: '20px', textAlign: 'left', color: colors.neutral30 } }, "Assign Groups"),
                users.length === 1 ?
                    React__default.createElement(Box, { sx: { display: 'flex', paddingBottom: '20px', width: '100%' } },
                        React__default.createElement(ColorAvatar, { firstName: users[0].firstName, lastName: users[0].lastName, sx: { marginTop: '10px' } }),
                        React__default.createElement(Box, { sx: { paddingLeft: '10px' } },
                            React__default.createElement(Typography, null, users[0].firstName + ' ' + users[0].lastName),
                            React__default.createElement(Typography, { sx: { color: colors.neutral40 } }, users[0].email))) :
                    React__default.createElement(Typography, { variant: "h6", sx: { margin: '20px 0' } },
                        "Assigning Groups to ",
                        users.length,
                        " Selected Users"),
                React__default.createElement(RTGroupsListSM, { apiUrl: apiUrl, TenantId: TenantId, setError: () => { }, sx: { width: '100%' }, filterGroupType: filterGroupType, setSelected: setSelectedGroups, selectedIds: selectedIds }),
                React__default.createElement(Box, { sx: { float: 'right' } },
                    React__default.createElement(RTButton, { type: "save", onClick: assignGroups, sx: { margin: '20px 0 0 0', width: '100px' }, text: "Save" })),
                React__default.createElement(ErrorPrompt, { error: error })))));
};

const RTListRoleSets = ({ apiUrl, TenantId, setError, setAlertMessage, sx }) => {
    const requestHelper = RequestHelper.getInstance(apiUrl);
    const [filteredRoleSets, setFilteredRoleSets] = useState([]);
    const [copyToClipboardText, setCopyToClipboardText] = useState('Copy ID to clipboard');
    const [currentSearch, setCurrentSearch] = useState('');
    const { i18n } = useAuth$1();
    const getRoleSetsFN = () => __awaiter$1(void 0, void 0, void 0, function* () {
        const res = yield requestHelper.getRolesForTenant({ TenantId, setError });
        setFilteredRoleSets(res.filter((r) => !r.disabled).sort((a, b) => a.name.localeCompare(b.name)));
        return res;
    });
    const handleSearchChange = (event) => {
        const search = event.target.value.toLowerCase();
        setCurrentSearch(search);
    };
    const { data: roleSets, isLoading: loading } = useQuery({
        queryKey: ['roleSets', TenantId],
        queryFn: getRoleSetsFN,
    });
    const copyToClipBoard = (text) => {
        navigator.clipboard.writeText(text);
        setCopyToClipboardText('Copied!');
        setAlertMessage('ID copied to clipboard');
        setTimeout(() => setCopyToClipboardText('Copy ID to clipboard'), 2000);
    };
    useEffect(() => {
        if (roleSets && roleSets.length > 0) {
            setFilteredRoleSets(roleSets.filter(r => r.name.toLowerCase().includes(currentSearch) && !r.disabled));
        }
    }, [roleSets, currentSearch]);
    return (React__default.createElement(ThemeProvider$1, { theme: theme },
        React__default.createElement(Box$2, { sx: sx, id: "role-sets-list-small" },
            !loading && React__default.createElement(Box$2, { sx: { width: '325px', float: 'right', top: '-15px', position: 'relative' } },
                React__default.createElement(TextField, { helperText: i18n.t('search_by_role_name'), sx: { width: '100%', background: 'white' }, type: "text", placeholder: i18n.t('search'), value: currentSearch, onChange: handleSearchChange, InputProps: {
                        startAdornment: (React__default.createElement(InputAdornment, { position: "start" },
                            React__default.createElement(SearchIcon, null))),
                        endAdornment: (React__default.createElement(InputAdornment, { position: "end", onClick: () => setCurrentSearch('') },
                            React__default.createElement(ClearIcon, { sx: { 'cursor': 'pointer' } }))),
                    } })),
            React__default.createElement(TableContainer, { component: Paper, sx: { maxHeight: '80%' } },
                React__default.createElement(Table, { "aria-label": "roles", stickyHeader: true },
                    React__default.createElement(TableHead, null,
                        React__default.createElement(TableRow, null,
                            React__default.createElement(TableCell, { sx: { padding: "4px" } }, i18n.t('role_name')),
                            React__default.createElement(TableCell, { sx: { padding: "4px" } }, i18n.t('role_description')),
                            React__default.createElement(TableCell, { sx: { padding: "4px" } }, i18n.t('role_id')))),
                    React__default.createElement(TableBody, null,
                        loading && React__default.createElement(React__default.Fragment, null,
                            React__default.createElement(TableRow, null,
                                React__default.createElement(ScaleLoader, { color: colors.primary10 }))),
                        !loading && filteredRoleSets.map((roleSet) => (React__default.createElement(TableRow, { key: roleSet.roleSetId, sx: { ':hover': { background: colors.primary90 } } },
                            React__default.createElement(TableCell, { sx: { padding: "4px" } }, roleSet.name),
                            React__default.createElement(TableCell, { sx: { padding: "4px" } }, roleSet.description),
                            React__default.createElement(TableCell, { sx: { padding: "4px", minWidth: '300px' } },
                                React__default.createElement(Tooltip, { title: copyToClipboardText, placement: "top" },
                                    React__default.createElement(Link, { sx: { 'cursor': 'pointer' }, onClick: () => copyToClipBoard(roleSet.roleSetId) },
                                        roleSet.roleSetId,
                                        React__default.createElement(ContentCopyIcon, null)))))))))))));
};

const RTGroupsList = ({ apiUrl, TenantId, filterGroupType, setError, sx }) => {
    const requestHelper = RequestHelper.getInstance(apiUrl);
    const [filteredGroups, setFilteredGroups] = useState([]);
    const [currentSearch, setCurrentSearch] = useState('');
    const [currentGroupBeingEdited, setCurrentGroupBeingEdited] = useState('');
    const [editGroupModalOpen, setEditGroupModalOpen] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const { i18n } = useAuth$1();
    const getGroupsFN = () => __awaiter$1(void 0, void 0, void 0, function* () {
        const res = yield requestHelper.listGroupsForTenant({ TenantId, setError });
        setFilteredGroups(res.slice(0, 1000).filter((g) => !filterGroupType || g.groupType === filterGroupType));
        return res;
    });
    const { data: groups, isLoading: loading } = useQuery({
        queryKey: ['groups', TenantId],
        queryFn: () => getGroupsFN(),
    });
    const handleSearchChange = (event) => {
        const search = event.target.value.toLowerCase();
        setCurrentSearch(search);
    };
    const groupTypeToPrettyName = (groupType) => {
        if (groupType === 'Resolve') {
            return 'Resolve & Core';
        }
        return groupType;
    };
    const handleGroupUpdated = (group) => {
        if (group.deleted) {
            setFilteredGroups(filteredGroups.filter(g => g.groupId !== group.groupId));
        }
        else {
            setFilteredGroups(filteredGroups.map(g => g.groupId === group.groupId ? group : g));
        }
        setEditGroupModalOpen(false);
    };
    useEffect(() => {
        if (groups && groups.length > 0) {
            setFilteredGroups(groups.filter(g => g.name.toLowerCase().includes(currentSearch)));
        }
    }, [groups, currentSearch]);
    const handleEditGroup = (group) => {
        setCurrentGroupBeingEdited(group.groupId || '');
        setEditGroupModalOpen(true);
    };
    const EnableDisableSwitch = ({ group }) => {
        const requestHelper = RequestHelper.getInstance(apiUrl);
        const [switchLoading, setSwitchLoading] = useState(false);
        const handleEnableDisableGroup = () => __awaiter$1(void 0, void 0, void 0, function* () {
            setSwitchLoading(true);
            if (!(group === null || group === void 0 ? void 0 : group.groupId)) {
                setSwitchLoading(false);
                return;
            }
            if (group.disabled) {
                yield requestHelper.enableGroup({ TenantId, GroupId: group.groupId, setError });
            }
            else {
                yield requestHelper.disableGroup({ TenantId, GroupId: group.groupId, setError });
            }
            group.disabled = !group.disabled;
            setSwitchLoading(false);
        });
        return (React__default.createElement(React__default.Fragment, null, group.groupId && switchLoading ? React__default.createElement(ScaleLoader, { color: colors.primary10 }) :
            React__default.createElement(Box$2, null,
                React__default.createElement(Tooltip, { title: group.disabled ? 'Enable Group' : 'Disable Group', arrow: true },
                    React__default.createElement(React__default.Fragment, null,
                        React__default.createElement(Switch, { checked: !group.disabled, onChange: handleEnableDisableGroup, inputProps: { 'aria-label': 'controlled' } }))))));
    };
    function TablePaginationActions(props) {
        const theme = useTheme();
        const { count, page, rowsPerPage, onPageChange } = props;
        const onLastPage = () => {
            return page >= Math.ceil(count / rowsPerPage) - 1;
        };
        const handleFirstPageButtonClick = (event) => {
            onPageChange(event, 0);
        };
        const handleBackButtonClick = (event) => {
            onPageChange(event, page - 1);
        };
        const handleNextButtonClick = (event) => __awaiter$1(this, void 0, void 0, function* () {
            onPageChange(event, page + 1);
        });
        const handleLastPageButtonClick = (event) => {
            onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
        };
        return (React__default.createElement(Box$2, { sx: { minWidth: '225px', alignContent: 'center' } },
            React__default.createElement(Box$2, { sx: { flexShrink: 0, ml: 2.5 } },
                React__default.createElement(IconButton, { onClick: handleFirstPageButtonClick, disabled: page === 0, "aria-label": "first page" }, theme.direction === 'rtl' ? React__default.createElement(LastPageIcon, null) : React__default.createElement(FirstPageIcon, null)),
                React__default.createElement(IconButton, { onClick: handleBackButtonClick, disabled: page === 0, "aria-label": "previous page" }, theme.direction === 'rtl' ? React__default.createElement(KeyboardArrowRight, null) : React__default.createElement(KeyboardArrowLeft, null)),
                React__default.createElement(IconButton, { onClick: handleNextButtonClick, disabled: onLastPage() && !requestHelper.hasMoreUsersToLoad(), "aria-label": "next page" }, theme.direction === 'rtl' ? React__default.createElement(KeyboardArrowLeft, null) : React__default.createElement(KeyboardArrowRight, null)),
                React__default.createElement(IconButton, { onClick: handleLastPageButtonClick, disabled: onLastPage(), "aria-label": "last page" }, theme.direction === 'rtl' ? React__default.createElement(FirstPageIcon, null) : React__default.createElement(LastPageIcon, null)))));
    }
    return (React__default.createElement(ThemeProvider$1, { theme: theme },
        React__default.createElement(Box$2, { sx: Object.assign(Object.assign({}, sx), { height: '100%' }), id: 'groups-list' },
            !loading && React__default.createElement(Box$2, { sx: { width: '325px', float: 'right', top: '-15px', position: 'relative' } },
                React__default.createElement(TextField, { helperText: i18n.t('search_by_group_name'), sx: { width: '100%', background: 'white' }, type: "text", placeholder: i18n.t('search'), value: currentSearch, onChange: handleSearchChange, InputProps: {
                        startAdornment: (React__default.createElement(InputAdornment, { position: "start" },
                            React__default.createElement(SearchIcon, null))),
                        endAdornment: (React__default.createElement(InputAdornment, { position: "end", onClick: () => setCurrentSearch('') },
                            React__default.createElement(ClearIcon, { sx: { 'cursor': 'pointer' } }))),
                    } })),
            React__default.createElement(TableContainer, { component: Paper, sx: { maxHeight: '80%' } },
                React__default.createElement(Table, { "aria-label": "groups", stickyHeader: true },
                    React__default.createElement(TableHead, null,
                        React__default.createElement("tr", null,
                            React__default.createElement(TableCell, { sx: { padding: '4px', width: '25%' } }, i18n.t('group_name')),
                            React__default.createElement(TableCell, { sx: { padding: '4px', width: '15%' } }, i18n.t('group_type')),
                            React__default.createElement(TableCell, { sx: { padding: '4px' } }, i18n.t('description')),
                            React__default.createElement(TableCell, { sx: { padding: '4px', paddingRight: '20px' }, align: 'right' }, i18n.t('disabled')))),
                    React__default.createElement(TableBody, null,
                        loading && React__default.createElement(React__default.Fragment, null,
                            React__default.createElement(TableRow, null,
                                React__default.createElement(ScaleLoader, { color: colors.primary10 }))),
                        !loading && (rowsPerPage > 0 ? filteredGroups.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : filteredGroups).map((group) => (React__default.createElement(TableRow, { key: group.groupId, sx: { ':hover': { background: colors.primary90 } } },
                            React__default.createElement(TableCell, { sx: { padding: '4px' } },
                                React__default.createElement(Link, { onClick: () => handleEditGroup(group), sx: { ':hover': { cursor: 'pointer' } } }, group.name)),
                            React__default.createElement(TableCell, { sx: { padding: '4px' } }, groupTypeToPrettyName(group.groupType)),
                            React__default.createElement(TableCell, { sx: { padding: '4px' } }, group.description),
                            React__default.createElement(TableCell, { sx: { padding: '4px', paddingRight: '20px' }, align: 'right' },
                                React__default.createElement(EnableDisableSwitch, { group: group })))))),
                    React__default.createElement(TableFooter, null,
                        React__default.createElement(TableRow, null,
                            React__default.createElement(TablePagination, { count: filteredGroups.length, page: page, colSpan: 4, onPageChange: (event, newPage) => setPage(newPage), rowsPerPage: rowsPerPage, rowsPerPageOptions: [25, 50, 100, 250, 1000], ActionsComponent: TablePaginationActions, onRowsPerPageChange: (event) => setRowsPerPage(parseInt(event.target.value, 10)), SelectProps: {
                                    inputProps: {
                                        'aria-label': 'rows per page',
                                    },
                                    native: true,
                                } })))))),
        React__default.createElement(RTModal, { open: editGroupModalOpen, onClose: () => setEditGroupModalOpen(false) },
            React__default.createElement(RTEditGroup, { apiUrl: apiUrl, isNew: false, GroupId: currentGroupBeingEdited, TenantId: TenantId, onSuccess: handleGroupUpdated }))));
};

const RTListUsers$1 = ({ apiUrl, TenantId, resultsPerPage = 100, overrideUserApp, showTenantName, sx }) => {
    const requestHelper = RequestHelper.getInstance(apiUrl);
    const { i18n } = useAuth$1();
    const userStates = [i18n.t('all'), i18n.t('active'), i18n.t('disabled')];
    const verifiedStates = [i18n.t('all'), i18n.t('verified'), i18n.t('unverified')];
    const [loading, setLoading] = useState(false);
    const [multiSelectBarLoading, setMultiSelectBarLoading] = useState(false);
    const [usersLoaded, setUsersLoaded] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const [error, setError] = useState('');
    const [users, setUsers] = useState([]);
    const [searchedUsers, setSearchedUsers] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [editUserModalOpen, setEditUserModalOpen] = useState(false);
    const [bulkUploadModalOpen, setBulkUploadModalOpen] = useState(false);
    const [editGroupModalOpen, setEditGroupModalOpen] = useState(false);
    const [userBeingEdited, setUserBeingEdited] = useState(undefined);
    const [page, setPage] = useState(0);
    const [oldPage, setOldPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(resultsPerPage);
    const [creatingNewUser, setCreatingNewUser] = useState(false);
    const [currentAlertMessage, setCurrentAlertMessage] = useState('');
    const [showUsersOfState, setShowUsersOfState] = useState(1);
    const [showVerifiedState, setShowVerifiedState] = useState(0);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [assignGroupsModalOpen, setAssignGroupsModalOpen] = useState(false);
    const [assignGroupsType, setAssignGroupsType] = useState('');
    const [activePane, setActivePane] = useState('users');
    const [tenant, setTenant] = useState(undefined);
    const getUsersFN = () => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!loading && !usersLoaded) {
            setLoading(true);
            const res = yield requestHelper.getUsersForTenant({ TenantId, setError });
            setUsers(res.users);
            setUsersLoaded(true);
            setLoading(false);
            return res;
        }
        return [];
    });
    const getTenantFN = () => __awaiter$1(void 0, void 0, void 0, function* () {
        const res = yield requestHelper.getTenant({ TenantId, setError });
        setTenant(res);
        return res;
    });
    useQuery({
        queryKey: ['users', TenantId],
        queryFn: getUsersFN,
    });
    useQuery({
        queryKey: ['tenant', TenantId],
        queryFn: getTenantFN,
    });
    const loadNextPage = () => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!loading && !loadingMore) {
            setLoadingMore(true);
            const res = yield requestHelper.getNextUsersForTenant({ TenantId, setError });
            setUsers([...users, ...res.users]);
            setLoadingMore(false);
        }
    });
    const loadAllUsers = () => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!loading && !loadingMore) {
            setLoadingMore(true);
            let loadedUsers = [];
            while (requestHelper.hasMoreUsersToLoad()) {
                const res = yield requestHelper.getNextUsersForTenant({ TenantId, setError });
                loadedUsers = [...loadedUsers, ...res.users];
            }
            setUsers([...users, ...loadedUsers]);
            setLoadingMore(false);
        }
    });
    const getManagerForUser = (user) => {
        var _a, _b, _c;
        if (user.groups && user.groups.length) {
            return (_a = user.groups.filter(group => group.groupType === 'Manager')[0]) === null || _a === void 0 ? void 0 : _a.name;
        }
        return (_c = (_b = user.groupUsers) === null || _b === void 0 ? void 0 : _b.filter(group => group.groupType === 'Manager').sort((a, b) => a.rank - b.rank)[0]) === null || _c === void 0 ? void 0 : _c.name;
    };
    const getLocationForUser = (user) => {
        var _a, _b, _c;
        if (user.groups && user.groups.length) {
            return (_a = user.groups.filter(group => group.groupType === 'Region')[0]) === null || _a === void 0 ? void 0 : _a.name;
        }
        return (_c = (_b = user.groupUsers) === null || _b === void 0 ? void 0 : _b.filter(group => group.groupType === 'Region').sort((a, b) => a.rank - b.rank)[0]) === null || _c === void 0 ? void 0 : _c.name;
    };
    const getResolveGroupForUser = (user) => {
        var _a, _b, _c;
        if (user.groups && user.groups.length) {
            return (_a = user.groups.filter(group => group.groupType === 'Resolve')[0]) === null || _a === void 0 ? void 0 : _a.name;
        }
        return (_c = (_b = user.groupUsers) === null || _b === void 0 ? void 0 : _b.filter(group => group.groupType === 'Resolve').sort((a, b) => a.rank - b.rank)[0]) === null || _c === void 0 ? void 0 : _c.name;
    };
    const handleUserUpdate = (updatedUser, message, closeModal = true) => {
        let userIsNew = users.findIndex(user => user.email === updatedUser.email) === -1;
        const updatedUserList = users;
        if (userIsNew) {
            updatedUserList.push(updatedUser);
        }
        else if (updatedUser.deleted) {
            updatedUserList.splice(updatedUserList.indexOf(updatedUser), 1);
        }
        else {
            const updatedUserIndex = updatedUserList.findIndex(user => user.email === updatedUser.email);
            updatedUserList[updatedUserIndex] = updatedUser;
        }
        setUsers(updatedUserList.sort((a, b) => a.email.localeCompare(b.email)));
        filterUsers();
        if (closeModal) {
            handleClose();
        }
        setCurrentAlertMessage(message || '');
    };
    const handleChangeOfUserState = () => {
        setShowUsersOfState((showUsersOfState + 1) % 3);
        setPage(0);
        setOldPage(0);
    };
    const handleChangeOfVerifiedState = () => {
        setShowVerifiedState((showVerifiedState + 1) % 3);
        setPage(0);
        setOldPage(0);
    };
    const handleGroupUpdate = (group, message) => {
        handleClose();
    };
    const handleGroupUserUpdate = () => __awaiter$1(void 0, void 0, void 0, function* () {
        handleClose();
        for (const selectedUser of selectedUsers) {
            const updatedUser = yield requestHelper.getUser({ email: selectedUser.email, setError });
            if (updatedUser) {
                handleUserUpdate(updatedUser, '', false);
            }
        }
        setCurrentAlertMessage(`${selectedUsers.length} Users updated`);
        setSelectedUsers([]);
    });
    const filterUsersFN = () => {
        const usersToFilerBase = searchedUsers.length > 0 ? searchedUsers : users;
        let filteredUsers = usersToFilerBase;
        if (showUsersOfState > 0) {
            const stateFilteredUsers = usersToFilerBase.filter(user => {
                if (showUsersOfState === 2) {
                    return user.disabled;
                }
                return !user.disabled;
            });
            filteredUsers = stateFilteredUsers;
        }
        if (showVerifiedState > 0) {
            const verifiedFilteredUsers = filteredUsers.filter(user => {
                if (showVerifiedState === 2) {
                    return !user.emailVerified;
                }
                return user.emailVerified;
            });
            filteredUsers = verifiedFilteredUsers;
        }
        setFilteredUsers(filteredUsers);
    };
    const handleSearchedUserChange = (users) => {
        setSearchedUsers(users);
        setPage(0);
        if (users.length === 0) {
            console.log(oldPage);
            setPage(oldPage);
        }
    };
    const filterUsers = useCallback(filterUsersFN, [searchedUsers, showUsersOfState, showVerifiedState, users]);
    useEffect(() => {
        filterUsers();
    }, [filterUsers, showUsersOfState, showVerifiedState, users]);
    const handleOpenModal = (user) => {
        if (user) {
            setUserBeingEdited(user);
            setCreatingNewUser(false);
        }
        else {
            setCreatingNewUser(true);
            setUserBeingEdited({ role: 'user', TenantId, userApp: overrideUserApp || '' });
        }
        setEditUserModalOpen(true);
    };
    const handleClose = () => {
        setEditUserModalOpen(false);
        setBulkUploadModalOpen(false);
        setEditGroupModalOpen(false);
        setAssignGroupsModalOpen(false);
    };
    const handleOpenBulkUploadModal = () => {
        setBulkUploadModalOpen(true);
    };
    const handleOpenGroupModal = () => {
        setEditGroupModalOpen(true);
    };
    const handleOpenAssignGroupsModal = (type = '') => {
        setAssignGroupsType(type);
        setAssignGroupsModalOpen(true);
    };
    const handleDisableManyUsers = () => __awaiter$1(void 0, void 0, void 0, function* () {
        setMultiSelectBarLoading(true);
        for (const user of selectedUsers) {
            if (user.disabled)
                continue;
            yield requestHelper.disableUser({ email: user.email, setError });
        }
        yield handleGroupUserUpdate();
        setSelectedUsers([]);
        setMultiSelectBarLoading(false);
    });
    const handleEnableManyUsers = () => __awaiter$1(void 0, void 0, void 0, function* () {
        setMultiSelectBarLoading(true);
        for (const user of selectedUsers) {
            if (!user.disabled)
                continue;
            yield requestHelper.enableUser({ email: user.email, setError });
        }
        yield handleGroupUserUpdate();
        setSelectedUsers([]);
        setMultiSelectBarLoading(false);
    });
    const enableDisableButtonToShow = () => {
        const selectionHasActiveUsers = selectedUsers.filter(user => !user.disabled).length > 0;
        if (selectionHasActiveUsers) {
            return React__default.createElement(Button, { onClick: handleDisableManyUsers, sx: { fontWeight: 700, width: '200px', float: 'right', marginRight: '20px', height: '50px', borderRadius: '25px', backgroundColor: colors.primary70 } },
                React__default.createElement(PersonOffIcon, null),
                " ",
                i18n.t('disable_users'));
        }
        return React__default.createElement(Button, { onClick: handleEnableManyUsers, sx: { fontWeight: 700, width: '200px', float: 'right', marginRight: '20px', height: '50px', borderRadius: '25px', backgroundColor: colors.primary70 } },
            React__default.createElement(PersonIcon, null),
            " ",
            i18n.t('enable_users'));
    };
    const handleSelectUser = (user) => {
        if (selectedUsers.includes(user)) {
            setSelectedUsers(selectedUsers.filter(u => u.email !== user.email));
        }
        else {
            setSelectedUsers([...selectedUsers, user]);
        }
    };
    const usersToDisplay = filteredUsers;
    function TablePaginationActions(props) {
        const theme = useTheme$1();
        const { count, page, rowsPerPage, onPageChange } = props;
        const onLastPage = () => {
            return page >= Math.ceil(count / rowsPerPage) - 1;
        };
        const handleFirstPageButtonClick = (event) => {
            onPageChange(event, 0);
        };
        const handleBackButtonClick = (event) => {
            onPageChange(event, page - 1);
        };
        const handleNextButtonClick = (event) => __awaiter$1(this, void 0, void 0, function* () {
            if (onLastPage() && requestHelper.hasMoreUsersToLoad()) {
                yield loadNextPage();
            }
            onPageChange(event, page + 1);
        });
        const handleLastPageButtonClick = (event) => {
            onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
        };
        return (React__default.createElement(Box$2, { sx: { minWidth: '225px', alignContent: 'center' } }, loadingMore ? React__default.createElement(Box$2, { sx: { width: '50px', margin: 'auto' } },
            React__default.createElement(ScaleLoader, { color: colors.primary10 })) :
            React__default.createElement(Box$2, { sx: { flexShrink: 0, ml: 2.5 } },
                React__default.createElement(IconButton, { onClick: handleFirstPageButtonClick, disabled: page === 0, "aria-label": "first page" }, theme.direction === 'rtl' ? React__default.createElement(LastPageIcon, null) : React__default.createElement(FirstPageIcon, null)),
                React__default.createElement(IconButton, { onClick: handleBackButtonClick, disabled: page === 0, "aria-label": "previous page" }, theme.direction === 'rtl' ? React__default.createElement(KeyboardArrowRight, null) : React__default.createElement(KeyboardArrowLeft, null)),
                React__default.createElement(IconButton, { onClick: handleNextButtonClick, disabled: onLastPage() && !requestHelper.hasMoreUsersToLoad(), "aria-label": "next page" }, theme.direction === 'rtl' ? React__default.createElement(KeyboardArrowLeft, null) : React__default.createElement(KeyboardArrowRight, null)),
                React__default.createElement(IconButton, { onClick: handleLastPageButtonClick, disabled: onLastPage(), "aria-label": "last page" }, theme.direction === 'rtl' ? React__default.createElement(FirstPageIcon, null) : React__default.createElement(LastPageIcon, null)),
                requestHelper.hasMoreUsersToLoad() && React__default.createElement(Tooltip, { title: "Load All Users" },
                    React__default.createElement(IconButton, { onClick: loadAllUsers },
                        React__default.createElement(SyncIcon, null))))));
    }
    function renderUsersTable() {
        return (React__default.createElement(TableContainer, { component: Paper, sx: { maxHeight: '80%' } },
            React__default.createElement(Table, { sx: { minWidth: 650 }, "aria-label": "users", stickyHeader: true },
                React__default.createElement(TableHead, null,
                    React__default.createElement(TableRow, null,
                        React__default.createElement(TableCell, null),
                        React__default.createElement(TableCell, { id: "users-list-header-email", sx: { padding: '4px', width: '300px' } }, i18n.t('user_id_email')),
                        React__default.createElement(TableCell, { id: "users-list-header-verified", sx: { padding: '4px' } },
                            React__default.createElement(Button, { id: "verified-unverified-switch", sx: { padding: '0' }, endIcon: React__default.createElement(SwapHorizIcon, null), onClick: handleChangeOfVerifiedState }, verifiedStates[showVerifiedState])),
                        React__default.createElement(TableCell, { id: "users-list-header-first-name", sx: { padding: '4px' } }, i18n.t('first_name')),
                        React__default.createElement(TableCell, { id: "users-list-header-last-name", sx: { padding: '4px' } }, i18n.t('last_name')),
                        React__default.createElement(TableCell, { id: "users-list-header-manager", sx: { padding: '4px' } }, i18n.t('manager')),
                        React__default.createElement(TableCell, { id: "users-list-header-location", sx: { padding: '4px' } }, i18n.t('location')),
                        React__default.createElement(TableCell, { id: "users-list-header-rt-group", sx: { padding: '4px' } }, i18n.t('routethis_group')),
                        React__default.createElement(TableCell, { id: "users-list-header-role", sx: { padding: '4px' } }, i18n.t('role')),
                        React__default.createElement(TableCell, { id: "users-list-header-active", sx: { padding: '4px' } },
                            React__default.createElement(Button, { id: "active-inactive-switch", endIcon: React__default.createElement(SwapHorizIcon, null), onClick: handleChangeOfUserState }, userStates[showUsersOfState])),
                        React__default.createElement(TableCell, { id: "users-list-header-options", sx: { padding: '4px' } }))),
                React__default.createElement(TableBody, null,
                    loading && React__default.createElement(React__default.Fragment, null,
                        React__default.createElement(TableRow, null,
                            React__default.createElement(TableCell, null,
                                React__default.createElement(ScaleLoader, { color: colors.primary10 })))),
                    !loading && usersToDisplay && (rowsPerPage > 0 ? usersToDisplay.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : usersToDisplay).map((user) => (React__default.createElement(TableRow, { key: user.email, sx: { background: selectedUsers.includes(user) ? colors.primary95 : 'white', ':hover': { background: colors.primary90 } } },
                        React__default.createElement(TableCell, null,
                            React__default.createElement(Checkbox, { checked: selectedUsers.includes(user), onChange: () => handleSelectUser(user), sx: { padding: '0' } })),
                        React__default.createElement(TableCell, { sx: { padding: '4px', width: '300px', overflow: 'hidden', textOverflow: 'ellipsis' } },
                            React__default.createElement(Link, { className: "user-edit-link", sx: { display: 'flex', alignItems: 'center', ":hover": { cursor: 'pointer' } }, onClick: () => handleOpenModal(user) }, user.email)),
                        React__default.createElement(TableCell, { sx: { padding: '4px', textAlign: 'left' } }, user.emailVerified ? i18n.t('verified') : i18n.t('unverified')),
                        React__default.createElement(TableCell, { sx: { padding: '4px', textAlign: '' } }, user.firstName),
                        React__default.createElement(TableCell, { sx: { padding: '4px', textAlign: '' } }, user.lastName),
                        React__default.createElement(TableCell, { sx: { padding: '4px', textAlign: '' } }, getManagerForUser(user)),
                        React__default.createElement(TableCell, { sx: { padding: '4px', textAlign: '' } }, getLocationForUser(user)),
                        React__default.createElement(TableCell, { sx: { padding: '4px', textAlign: '' } }, getResolveGroupForUser(user)),
                        React__default.createElement(TableCell, { sx: { padding: '4px', textAlign: '' } }, user.role),
                        React__default.createElement(TableCell, { sx: { padding: '4px', textAlign: '' } },
                            React__default.createElement(RTEnableDisableUserSwitch, { callback: handleUserUpdate, apiUrl: apiUrl, user: user, setError: setError })),
                        React__default.createElement(TableCell, { sx: { padding: '4px', textAlign: '' } },
                            React__default.createElement(RTEditUserMenu, { apiUrl: apiUrl, user: user, setGroupsModalOpen: setAssignGroupsModalOpen, setSelectedUsers: setSelectedUsers, setEditUserModalOpen: setEditUserModalOpen, setUserBeingEdited: setUserBeingEdited })))))),
                React__default.createElement(TableFooter, null,
                    React__default.createElement(TableRow, null,
                        React__default.createElement(TablePagination, { rowsPerPageOptions: [10, 50, 100, 250, 1000], colSpan: 11, count: (usersToDisplay === null || usersToDisplay === void 0 ? void 0 : usersToDisplay.length) || 0, rowsPerPage: rowsPerPage, page: page, SelectProps: {
                                inputProps: {
                                    'aria-label': 'rows per page',
                                },
                                native: true,
                            }, onPageChange: (event, newPage) => {
                                setPage(newPage);
                                setOldPage(newPage);
                            }, onRowsPerPageChange: (event) => {
                                setRowsPerPage(parseInt(event.target.value, 10));
                                setPage(0);
                                setOldPage(0);
                            }, ActionsComponent: TablePaginationActions }))))));
    }
    const renderActivePane = () => {
        if (activePane === 'users') {
            return renderUsersTable();
        }
        if (activePane === 'groups') {
            return React__default.createElement(RTGroupsList, { apiUrl: apiUrl, TenantId: TenantId, setError: setError, sx: { padding: '20px 0px' } });
        }
        if (activePane === 'roles') {
            return React__default.createElement(RTListRoleSets, { apiUrl: apiUrl, TenantId: TenantId, setError: setError, setAlertMessage: setCurrentAlertMessage, sx: { padding: '20px 0px' } });
        }
    };
    return (React__default.createElement(ThemeProvider, { theme: theme },
        React__default.createElement(ErrorPrompt, { message: error }),
        React__default.createElement(Box$2, { sx: Object.assign({ overflow: 'hidden' }, sx), id: "list-users" },
            React__default.createElement(Box$2, { sx: { width: '100%', textAlign: 'center', marginTop: '20px', marginBottom: '20px' } }, currentAlertMessage ? React__default.createElement(Alert, { sx: { width: '95%', margin: 'auto' }, severity: "info", action: React__default.createElement(Button, { onClick: () => setCurrentAlertMessage('') }, i18n.t('dismiss')) }, currentAlertMessage) : ''),
            React__default.createElement(Box$2, { sx: { width: '100%', paddingBottom: '10px' } }, (tenant === null || tenant === void 0 ? void 0 : tenant.displayName) && showTenantName && React__default.createElement(Typography, { variant: "h2", color: colors.primaryDark },
                i18n.t('users_for'),
                " ",
                tenant.displayName)),
            React__default.createElement(Box$2, { sx: { width: '100%' } },
                React__default.createElement(Button, { id: "create-user-button", variant: "outlined", onClick: () => handleOpenModal(undefined), sx: { fontWeight: 700, float: 'left', marginLeft: '20px', height: '50px', borderRadius: '25px' } },
                    React__default.createElement(PlusIcon, null),
                    " ",
                    i18n.t('add_user')),
                React__default.createElement(Button, { id: "bulk-upload-button", variant: "outlined", onClick: () => handleOpenBulkUploadModal(), sx: { fontWeight: 700, float: 'left', marginLeft: '20px', height: '50px', borderRadius: '25px' } },
                    React__default.createElement(PlusIcon, null),
                    " ",
                    i18n.t('bulk_import_users')),
                React__default.createElement(Button, { id: "add-group-modal", variant: "outlined", onClick: () => handleOpenGroupModal(), sx: { fontWeight: 700, float: 'left', marginLeft: '20px', height: '50px', borderRadius: '25px' } },
                    React__default.createElement(PlusIcon, null),
                    " ",
                    i18n.t('add_group')),
                React__default.createElement(Button, { id: "manage-users-button", disabled: activePane === 'users', variant: "outlined", onClick: () => setActivePane('users'), sx: { fontWeight: 700, float: 'left', marginLeft: '20px', height: '50px', borderRadius: '25px' } },
                    React__default.createElement(PersonIcon, null),
                    " ",
                    i18n.t('manage_users')),
                React__default.createElement(Button, { id: "manage-groups-button", disabled: activePane === 'groups', variant: "outlined", onClick: () => setActivePane('groups'), sx: { fontWeight: 700, float: 'left', marginLeft: '20px', height: '50px', borderRadius: '25px' } },
                    React__default.createElement(GroupsIcon, null),
                    " ",
                    i18n.t('manage_groups')),
                React__default.createElement(Button, { id: "show-roles-button", disabled: activePane === 'roles', variant: "outlined", onClick: () => setActivePane('roles'), sx: { fontWeight: 700, float: 'left', marginLeft: '20px', height: '50px', borderRadius: '25px' } },
                    React__default.createElement(FormatListBulletedIcon, null),
                    " ",
                    i18n.t('show_roles_list')),
                activePane === 'users' && React__default.createElement(RTUserSearch, { apiUrl: apiUrl, TenantId: TenantId, setUsers: handleSearchedUserChange, sx: { float: 'right', marginRight: '20px', width: '340px' }, i18n: i18n })),
            renderActivePane(),
            selectedUsers.length > 0 && activePane === 'users' && React__default.createElement(Alert, { icon: false, sx: { borderRadius: '50px', height: '100px', width: '95%', margin: 'auto', marginTop: '20px', ".MuiAlert-message": { display: 'flex', width: '100%' } }, severity: "info" },
                React__default.createElement(Box$2, { sx: { width: '325px', display: 'flex', alignItems: 'center', height: '100%', paddingLeft: '40px', fontSize: "20px", fontWeight: '500' } },
                    React__default.createElement(Box$2, { sx: { borderRight: '2px solid rgba(0,0,0,0.2)', width: '100%' } },
                        React__default.createElement(Button, { onClick: () => setSelectedUsers([]), sx: { color: colors.primary80Black } },
                            React__default.createElement(Tooltip, { title: "Clear" },
                                React__default.createElement(CloseIcon, null))),
                        selectedUsers.length,
                        " Users selected")),
                React__default.createElement(Box$2, { sx: { width: '80%', display: 'flex', alignItems: 'center', height: '100%', paddingLeft: '40px', fontSize: "20px", fontWeight: '500' } }, multiSelectBarLoading ? React__default.createElement(ScaleLoader, { color: colors.primary10 }) : React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(Button, { onClick: () => handleOpenAssignGroupsModal('Manager'), sx: { fontWeight: 700, width: '200px', float: 'right', marginRight: '20px', height: '50px', borderRadius: '25px', backgroundColor: colors.primary70 } },
                        React__default.createElement(AssignmentIndIcon, null),
                        " Assign Managers"),
                    React__default.createElement(Button, { onClick: () => handleOpenAssignGroupsModal('Region'), sx: { fontWeight: 700, width: '200px', float: 'right', marginRight: '20px', height: '50px', borderRadius: '25px', backgroundColor: colors.primary70 } },
                        React__default.createElement(PinDropIcon, null),
                        " Assign Location"),
                    React__default.createElement(Button, { onClick: () => handleOpenAssignGroupsModal('Resolve'), sx: { fontWeight: 700, width: '200px', float: 'right', marginRight: '20px', height: '50px', borderRadius: '25px', backgroundColor: colors.primary70 } },
                        React__default.createElement(SupportAgentIcon, null),
                        " Assign RT Group"),
                    enableDisableButtonToShow())),
                React__default.createElement(Box$2, { sx: { width: '250px', display: 'flex', alignItems: 'center', height: '100%', paddingLeft: '40px', fontSize: "20px", fontWeight: '500' } }))),
        React__default.createElement("div", null,
            React__default.createElement(RTModal, { open: editUserModalOpen, onClose: handleClose },
                React__default.createElement(RTEditUser$1, { apiUrl: apiUrl, userDetails: userBeingEdited, email: (userBeingEdited === null || userBeingEdited === void 0 ? void 0 : userBeingEdited.email) || '', onSuccess: handleUserUpdate, isNew: creatingNewUser })),
            React__default.createElement(RTModal, { open: bulkUploadModalOpen, onClose: handleClose },
                React__default.createElement(RTBulkUpload, { apiUrl: apiUrl, TenantId: TenantId, handleClose: handleClose, overrideUserApp: overrideUserApp })),
            React__default.createElement(RTModal, { open: editGroupModalOpen, onClose: handleClose },
                React__default.createElement(RTEditGroup, { apiUrl: apiUrl, GroupId: '', TenantId: TenantId, onSuccess: handleGroupUpdate, isNew: true })),
            React__default.createElement(RTModal, { open: assignGroupsModalOpen, onClose: handleClose },
                React__default.createElement(RTAssignGroups, { apiUrl: apiUrl, TenantId: TenantId, users: selectedUsers, filterGroupType: assignGroupsType, onSuccess: handleGroupUserUpdate })))));
};

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;
    const onLastPage = () => {
        return page >= Math.ceil(count / rowsPerPage) - 1;
    };
    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };
    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };
    const handleNextButtonClick = (event) => __awaiter$1(this, void 0, void 0, function* () {
        onPageChange(event, page + 1);
    });
    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    return (React__default.createElement(Box$2, { sx: { minWidth: '225px', alignContent: 'center' } },
        React__default.createElement(Box$2, { sx: { flexShrink: 0, ml: 2.5 } },
            React__default.createElement(IconButton, { onClick: handleFirstPageButtonClick, disabled: page === 0, "aria-label": "first page" }, theme.direction === 'rtl' ? React__default.createElement(LastPageIcon, null) : React__default.createElement(FirstPageIcon, null)),
            React__default.createElement(IconButton, { onClick: handleBackButtonClick, disabled: page === 0, "aria-label": "previous page" }, theme.direction === 'rtl' ? React__default.createElement(KeyboardArrowRight, null) : React__default.createElement(KeyboardArrowLeft, null)),
            React__default.createElement(IconButton, { onClick: handleNextButtonClick, disabled: onLastPage(), "aria-label": "next page" }, theme.direction === 'rtl' ? React__default.createElement(KeyboardArrowLeft, null) : React__default.createElement(KeyboardArrowRight, null)),
            React__default.createElement(IconButton, { onClick: handleLastPageButtonClick, disabled: onLastPage(), "aria-label": "last page" }, theme.direction === 'rtl' ? React__default.createElement(FirstPageIcon, null) : React__default.createElement(LastPageIcon, null)))));
}

const RTGlobalSearch$1 = ({ apiUrl, tenantBaseUrl, sx }) => {
    const { currentUser, i18n } = useAuth$1();
    const [users, setUsers] = useState([]);
    const [error, setError] = useState('');
    const [editUserModalOpen, setEditUserModalOpen] = useState(false);
    const [userBeingEdited, setUserBeingEdited] = useState(undefined);
    const [alertMessage, setAlertMessage] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    const handleOpenModal = (user) => {
        setUserBeingEdited(user);
        setEditUserModalOpen(true);
    };
    const handleSetUsers = (users) => {
        if (users.length > 5000) {
            setAlertMessage('Large number of users returned, search refinement may be needed');
        }
        setUsers(users);
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(ThemeProvider$1, { theme: theme }, !checkRoles(currentUser, ['canGlobalUserSearch:*']) ? React__default.createElement(Box$2, null, "Access Denied") :
            React__default.createElement(Box$2, { sx: Object.assign(Object.assign({}, sx), { overflow: 'auto' }) },
                alertMessage && React__default.createElement(Alert, { sx: { paddingBottom: '10px' }, severity: "info" }, alertMessage),
                React__default.createElement(RTUserSearch, { apiUrl: apiUrl, setUsers: handleSetUsers, global: true, i18n: i18n, sx: { paddingTop: '10px', paddingBottom: '10px', maxWidth: '400px' } }),
                React__default.createElement(TableContainer, null,
                    React__default.createElement(Table, { sx: { minWidth: 650 }, "aria-label": "users", stickyHeader: true },
                        React__default.createElement(TableHead, null,
                            React__default.createElement(TableRow, null,
                                React__default.createElement(TableCell, { sx: { padding: '4px', textAlign: '' } }, i18n.t('email')),
                                React__default.createElement(TableCell, { sx: { padding: '4px', textAlign: '' } }, i18n.t('verified')),
                                React__default.createElement(TableCell, { sx: { padding: '4px', textAlign: '' } }, i18n.t('name')),
                                React__default.createElement(TableCell, { sx: { padding: '4px', textAlign: '' } }, "Tenant"),
                                React__default.createElement(TableCell, { sx: { padding: '4px', textAlign: '' } }, "Role"),
                                React__default.createElement(TableCell, { sx: { padding: '4px', textAlign: '' } }, "Active"))),
                        React__default.createElement(TableBody, null, (rowsPerPage > 0 ? users.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : users).map((user) => {
                            return (React__default.createElement(TableRow, { key: user.email },
                                React__default.createElement(TableCell, { sx: { padding: '4px', width: '300px', overflow: 'hidden', textOverflow: 'ellipsis' } },
                                    React__default.createElement(Link, { sx: { display: 'flex', alignItems: 'center', ":hover": { cursor: 'pointer' } }, onClick: () => handleOpenModal(user) }, user.email)),
                                React__default.createElement(TableCell, { sx: { padding: '4px', textAlign: '' } }, user.emailVerified ? 'Yes' : 'No'),
                                React__default.createElement(TableCell, { sx: { padding: '4px', textAlign: '' } }, user.firstName + '' + user.lastName),
                                React__default.createElement(TableCell, { sx: { padding: '4px', textAlign: '' } },
                                    React__default.createElement(Link, { href: `${tenantBaseUrl}/${user.TenantId}` }, user.TenantId)),
                                React__default.createElement(TableCell, { sx: { padding: '4px', textAlign: '' } }, user.role),
                                React__default.createElement(TableCell, { sx: { padding: '4px', textAlign: '' } },
                                    React__default.createElement(RTEnableDisableUserSwitch, { apiUrl: apiUrl, user: user, setError: setError }))));
                        })),
                        React__default.createElement(TableFooter, null,
                            React__default.createElement(TableRow, null,
                                React__default.createElement(TablePagination, { count: users.length, page: page, colSpan: 6, onPageChange: (event, newPage) => setPage(newPage), rowsPerPage: rowsPerPage, rowsPerPageOptions: [25, 50, 100, 250, 1000], ActionsComponent: TablePaginationActions, onRowsPerPageChange: (event) => setRowsPerPage(parseInt(event.target.value, 10)), SelectProps: {
                                        inputProps: {
                                            'aria-label': 'rows per page',
                                        },
                                        native: true,
                                    } }))))),
                React__default.createElement(ErrorPrompt, { error: error }),
                React__default.createElement(RTModal, { open: editUserModalOpen, onClose: () => setEditUserModalOpen(false) },
                    React__default.createElement(RTEditUser$1, { apiUrl: apiUrl, userDetails: userBeingEdited, email: (userBeingEdited === null || userBeingEdited === void 0 ? void 0 : userBeingEdited.email) || '', onSuccess: () => setAlertMessage('updated successful'), isNew: false }))))));
};

const RTDropdown$1 = ({ buttonContents, id, variant, children, sx }) => {
    const [anchorEl, setAnchorEl] = React__default.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (React__default.createElement(ThemeProvider, { theme: theme },
        React__default.createElement(Box, { sx: sx, id: id },
            React__default.createElement(Box, null,
                React__default.createElement(Button, { className: 'rt-dropdown-button', variant: variant || 'outlined', onClick: handleClick, "aria-controls": open ? id : undefined, "aria-haspopup": "true", "aria-expanded": open ? 'true' : undefined, sx: { borderRadius: '100px', height: '40px' } },
                    buttonContents,
                    open ? React__default.createElement(ArrowDropUpIcon, null) : React__default.createElement(ArrowDropDownIcon, null)),
                React__default.createElement(Menu, { anchorEl: anchorEl, open: open, onClose: handleClose, MenuListProps: {
                        'aria-labelledby': 'button',
                    } }, children)))));
};

const RTUserDropdown$1 = ({ sx, redirectUrl, apiUrl }) => {
    const { i18n, currentUser, logout } = useAuth$1();
    const [changePwModalOpen, setChangePwModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const handleSignOut = () => __awaiter$1(void 0, void 0, void 0, function* () {
        setLoading(true);
        yield logout();
        setLoading(false);
        window.location.href = redirectUrl;
    });
    const handleChangePwModalOpen = () => {
        setChangePwModalOpen(true);
    };
    const handleChangePwModalClose = () => {
        setChangePwModalOpen(false);
    };
    return (React__default.createElement(ThemeProvider, { theme: theme },
        currentUser &&
            React__default.createElement(RTDropdown$1, { id: "user-dropdown", sx: sx, buttonContents: React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(PersonIcon, null),
                    " ",
                    i18n.t('hello') + ' ' + currentUser.firstName,
                    " "), variant: 'contained' },
                React__default.createElement(MenuItem, { id: "sign-out-dropdown-button", onClick: handleSignOut, disabled: loading },
                    React__default.createElement(Link, { underline: "none", sx: { display: 'flex', alignItems: 'center' } },
                        React__default.createElement(ExitToAppIcon, { sx: { marginRight: '20px' } }),
                        i18n.t('sign_out'))),
                React__default.createElement(MenuItem, { id: "change-password-dropdown-button", onClick: handleChangePwModalOpen, disabled: loading },
                    React__default.createElement(Link, { underline: "none", sx: { display: 'flex', alignItems: 'center' } },
                        React__default.createElement(VpnKey, { sx: { marginRight: '20px' } }),
                        i18n.t('change_password')))),
        React__default.createElement(RTModal, { open: changePwModalOpen, onClose: handleChangePwModalClose },
            React__default.createElement(Box, { sx: { padding: '20px' } },
                React__default.createElement(RTChangePassword$1, { apiUrl: apiUrl, onPasswordChangeCompleteCallback: handleChangePwModalClose, noBox: true })))));
};

const RTHelpDropdown$1 = ({ sx }) => {
    const { i18n } = useAuth$1();
    return (React__default.createElement(RTDropdown$1, { buttonContents: i18n.t('need_help'), id: 'help-dropdown', sx: { sx } },
        React__default.createElement(MenuItem, { id: 'contact-us' },
            React__default.createElement(Link, { underline: "none", href: "mailto:success@routethis.com", sx: { display: 'flex', alignItems: 'center' } },
                React__default.createElement(MailIcon, { sx: { marginRight: '20px' } }),
                i18n.t('contact_us')))));
};

const RTListTenants$1 = ({ apiUrl, ravaApiUrl, ravaApiUrlEU, listUsersBaseUrl, sx }) => {
    const requestHelper = RequestHelper.getInstance(apiUrl);
    const [filteredTenants, setFilteredTenants] = useState([]);
    const [currentSearch, setCurrentSearch] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [tokenModalOpen, setTokenModalOpen] = useState(false);
    const [tenantBeingEdited, setTenantBeingEdited] = useState('');
    const [error, setError] = useState('');
    const getTenantsFN = () => __awaiter$1(void 0, void 0, void 0, function* () {
        const res = yield requestHelper.listTenants({ setError });
        setFilteredTenants(res.tenants.sort((a, b) => a.displayName.localeCompare(b.displayName)));
        return res.tenants;
    });
    const handleSearchChange = (event) => {
        const search = event.target.value.toLowerCase();
        setCurrentSearch(search);
    };
    const { data: tenants, isLoading: loading } = useQuery({
        queryKey: ['tenants'],
        queryFn: getTenantsFN,
    });
    useEffect(() => {
        if (tenants && tenants.length > 0) {
            setFilteredTenants(tenants.filter(r => r.displayName.toLowerCase().includes(currentSearch)));
        }
    }, [tenants, currentSearch]);
    const handleEditModalOpen = () => {
        setEditModalOpen(true);
    };
    const handleTokenModalOpen = () => {
        setTokenModalOpen(true);
    };
    const handleEditModalClose = () => {
        setEditModalOpen(false);
    };
    const handleTenantEditComplete = (tenant) => {
        setEditModalOpen(false);
        setAlertMessage(`${tenant.displayName} updated`);
        // Replace the tenant in the list
        const updatedTenants = tenants.map((t) => t.TenantId === tenant.TenantId ? tenant : t);
        setFilteredTenants(updatedTenants.sort((a, b) => a.displayName.localeCompare(b.displayName)));
    };
    const EnableDisableSwitch = ({ tenant }) => {
        const [loading, setLoading] = useState(false);
        const toggleTenant = () => __awaiter$1(void 0, void 0, void 0, function* () {
            setLoading(true);
            const res = yield requestHelper.updateTenant({ TenantId: tenant.TenantId, TenantParams: Object.assign(Object.assign({}, tenant), { disabled: !tenant.disabled }), setError });
            if (res) {
                setAlertMessage(`${tenant.displayName} is now ${tenant.disabled ? 'enabled' : 'disabled'}`);
                tenant.disabled = !tenant.disabled;
            }
            setLoading(false);
        });
        return (React__default.createElement(React__default.Fragment, null, loading ? React__default.createElement(ScaleLoader, { color: colors.primary10 }) :
            React__default.createElement(Tooltip, { title: tenant.disabled ? 'Enable' : 'Disable' },
                React__default.createElement(Switch, { checked: !tenant.disabled, onChange: toggleTenant, disabled: loading }))));
    };
    const unixTimeStampToDate = (ts) => {
        return new Date(ts * 1000).toLocaleString();
    };
    return (React__default.createElement(ThemeProvider$1, { theme: theme },
        alertMessage && React__default.createElement(Alert, { severity: "success", sx: { marginBottom: '20px' } }, alertMessage),
        React__default.createElement(ErrorPrompt, { message: error, id: "error" }),
        React__default.createElement(Box$2, { sx: sx },
            !loading && React__default.createElement(Box$2, { sx: { width: '325px', float: 'right', top: '-15px', position: 'relative' } },
                React__default.createElement(TextField, { helperText: "Search By Tenant Name", sx: { width: '100%', background: 'white' }, type: "text", placeholder: "Search", value: currentSearch, onChange: handleSearchChange, InputProps: {
                        startAdornment: (React__default.createElement(InputAdornment, { position: "start" },
                            React__default.createElement(SearchIcon, null))),
                        endAdornment: (React__default.createElement(InputAdornment, { position: "end", onClick: () => setCurrentSearch('') },
                            React__default.createElement(ClearIcon, { sx: { 'cursor': 'pointer' } }))),
                    } })),
            React__default.createElement(TableContainer, { component: Paper, sx: { maxHeight: '80%' } },
                React__default.createElement(Table, { "aria-label": "roles", stickyHeader: true },
                    React__default.createElement(TableHead, null,
                        React__default.createElement(TableRow, null,
                            React__default.createElement(TableCell, { sx: { padding: "4px" } }, "Tenant Name"),
                            React__default.createElement(TableCell, { sx: { padding: "4px" } }, "API Tokens"),
                            React__default.createElement(TableCell, { sx: { padding: "4px" } }, "Users"),
                            React__default.createElement(TableCell, { sx: { padding: "4px" } }, "Region"),
                            React__default.createElement(TableCell, { sx: { padding: "4px" } }, "ResolveId"),
                            React__default.createElement(TableCell, { sx: { padding: "4px" } }, "Created At"),
                            React__default.createElement(TableCell, { sx: { padding: "4px" } }, "Modified At"),
                            React__default.createElement(TableCell, { sx: { padding: "4px" } }, "Active"))),
                    React__default.createElement(TableBody, null,
                        loading && React__default.createElement(React__default.Fragment, null,
                            React__default.createElement(TableRow, null,
                                React__default.createElement(ScaleLoader, { color: colors.primary10 }))),
                        !loading && (rowsPerPage > 0 ? filteredTenants.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : filteredTenants).map((tenant) => (React__default.createElement(TableRow, { key: tenant.TenantId, sx: { ':hover': { background: colors.primary90 } } },
                            React__default.createElement(TableCell, { sx: { padding: "4px" } },
                                React__default.createElement(Tooltip, { title: "Edit" },
                                    React__default.createElement(Link, { underline: "none", sx: { ':hover': { cursor: 'pointer' } }, onClick: () => { handleEditModalOpen(); setTenantBeingEdited(tenant.TenantId); } },
                                        tenant.displayName,
                                        " "))),
                            React__default.createElement(TableCell, { sx: { padding: "4px" } },
                                React__default.createElement(Link, { underline: "none", sx: { ':hover': { cursor: 'pointer' } }, onClick: () => { handleTokenModalOpen(); setTenantBeingEdited(tenant.TenantId); } }, " API Tokens ")),
                            React__default.createElement(TableCell, { sx: { padding: "4px" } },
                                React__default.createElement(Link, { underline: "none", href: `${listUsersBaseUrl}/${tenant.TenantId}` }, " Users List ")),
                            React__default.createElement(TableCell, { sx: { padding: "4px" } }, tenant.region),
                            React__default.createElement(TableCell, { sx: { padding: "4px" } }, tenant.resolveId),
                            React__default.createElement(TableCell, { sx: { padding: "4px" } }, unixTimeStampToDate(tenant.createdAt)),
                            React__default.createElement(TableCell, { sx: { padding: "4px" } }, unixTimeStampToDate(tenant.updatedAt)),
                            React__default.createElement(TableCell, { sx: { padding: "4px" } },
                                React__default.createElement(EnableDisableSwitch, { tenant: tenant })))))),
                    React__default.createElement(TableFooter, null,
                        React__default.createElement(TableRow, null,
                            React__default.createElement(TablePagination, { count: filteredTenants.length, page: page, colSpan: 4, onPageChange: (event, newPage) => setPage(newPage), rowsPerPage: rowsPerPage, rowsPerPageOptions: [25, 50, 100, 250, 1000], ActionsComponent: TablePaginationActions, onRowsPerPageChange: (event) => setRowsPerPage(parseInt(event.target.value, 10)), SelectProps: {
                                    inputProps: {
                                        'aria-label': 'rows per page',
                                    },
                                    native: true,
                                } })))))),
        React__default.createElement(RTModal, { width: "wide", open: editModalOpen, onClose: handleEditModalClose },
            React__default.createElement(RTEditTenantFields, { apiUrl: apiUrl, ravaApiUrl: ravaApiUrl, ravaApiUrlEU: ravaApiUrlEU, TenantId: tenantBeingEdited, hideTokens: true, successCallback: handleTenantEditComplete })),
        React__default.createElement(RTModal, { width: "wide", open: tokenModalOpen, onClose: () => setTokenModalOpen(false) },
            React__default.createElement(RTAPIToken$1, { apiUrl: apiUrl, TenantId: tenantBeingEdited }))));
};

var Et=Object.create;var Ye=Object.defineProperty;var bt=Object.getOwnPropertyDescriptor;var gt=Object.getOwnPropertyNames;var yt=Object.getPrototypeOf,wt=Object.prototype.hasOwnProperty;var Lt=(n,e)=>()=>(e||n((e={exports:{}}).exports,e),e.exports);var Pt=(n,e,r,i)=>{if(e&&typeof e=="object"||typeof e=="function")for(let o of gt(e))!wt.call(n,o)&&o!==r&&Ye(n,o,{get:()=>e[o],enumerable:!(i=bt(e,o))||i.enumerable});return n};var St=(n,e,r)=>(r=n!=null?Et(yt(n)):{},Pt(e||!n||!n.__esModule?Ye(r,"default",{value:n,enumerable:!0}):r,n));var je=Lt((he,Je)=>{(function(n,e){typeof he=="object"&&typeof Je<"u"?e(he):typeof define=="function"&&define.amd?define(["exports"],e):(n=typeof globalThis<"u"?globalThis:n||self,e(n.fastUniqueNumbers={}));})(he,function(n){var e=function(l){return function(p){var f=l(p);return p.add(f),f}},r=function(l){return function(p,f){return l.set(p,f),f}},i=Number.MAX_SAFE_INTEGER===void 0?9007199254740991:Number.MAX_SAFE_INTEGER,o=536870912,u=o*2,g=function(l,p){return function(f){var B=p.get(f),y=B===void 0?f.size:B<u?B+1:0;if(!f.has(y))return l(f,y);if(f.size<o){for(;f.has(y);)y=Math.floor(Math.random()*u);return l(f,y)}if(f.size>i)throw new Error("Congratulations, you created a collection of unique numbers which uses all available integers!");for(;f.has(y);)y=Math.floor(Math.random()*i);return l(f,y)}},O=new WeakMap,W=r(O),m=g(W,O),a=e(m);n.addUniqueNumber=a,n.generateUniqueNumber=m;});});St(je());var M$1=(typeof window>"u"?"undefined":typeof window)=="object";var I$1={setTimeout:M$1?setTimeout.bind(window):setTimeout,clearTimeout:M$1?clearTimeout.bind(window):clearTimeout,setInterval:M$1?setInterval.bind(window):setInterval,clearInterval:M$1?clearInterval.bind(window):clearInterval};function it(n){I$1.setTimeout=n.setTimeout,I$1.clearTimeout=n.clearTimeout,I$1.setInterval=n.setInterval,I$1.clearInterval=n.clearInterval;}var Q$1={},Ae$1=class Ae{name;closed=!1;mc=new MessageChannel;constructor(e){this.name=e,Q$1[e]=Q$1[e]||[],Q$1[e].push(this),this.mc.port1.start(),this.mc.port2.start(),this.onStorage=this.onStorage.bind(this),window.addEventListener("storage",this.onStorage);}onStorage(e){if(e.storageArea!==window.localStorage||e.key.substring(0,this.name.length)!==this.name||e.newValue===null)return;let r=JSON.parse(e.newValue);this.mc.port2.postMessage(r);}postMessage(e){if(this.closed)throw new Error("InvalidStateError");let r=JSON.stringify(e),i=`${this.name}:${String(Date.now())}${String(Math.random())}`;window.localStorage.setItem(i,r),I$1.setTimeout(()=>{window.localStorage.removeItem(i);},500),Q$1[this.name].forEach(o=>{o!==this&&o.mc.port2.postMessage(JSON.parse(r));});}close(){if(this.closed)return;this.closed=!0,this.mc.port1.close(),this.mc.port2.close(),window.removeEventListener("storage",this.onStorage);let e=Q$1[this.name].indexOf(this);Q$1[this.name].splice(e,1);}get onmessage(){return this.mc.port1.onmessage}set onmessage(e){this.mc.port1.onmessage=e;}get onmessageerror(){return this.mc.port1.onmessageerror}set onmessageerror(e){this.mc.port1.onmessageerror=e;}addEventListener(e,r){return this.mc.port1.addEventListener(e,r)}removeEventListener(e,r){return this.mc.port1.removeEventListener(e,r)}dispatchEvent(e){return this.mc.port1.dispatchEvent(e)}},st=typeof window>"u"?void 0:typeof window.BroadcastChannel=="function"?window.BroadcastChannel:Ae$1;function ot(n=0){return new Promise(e=>I$1.setTimeout(e,n))}function Te$1(){return Math.random().toString(36).substring(2)}var Ie$1=class Ie{options;channel;token=Te$1();isLeader=!1;isDead=!1;isApplying=!1;reApply=!1;intervals=[];listeners=[];deferred;constructor(e,r){this.channel=e,this.options=r,this.apply=this.apply.bind(this),this.awaitLeadership=this.awaitLeadership.bind(this),this.sendAction=this.sendAction.bind(this);}async apply(){if(this.isLeader||this.isDead)return !1;if(this.isApplying)return this.reApply=!0,!1;this.isApplying=!0;let e=!1,r=i=>{let{token:o,action:u}=i.data;o!==this.token&&(u===0&&o>this.token&&(e=!0),u===1&&(e=!0));};this.channel.addEventListener("message",r);try{return this.sendAction(0),await ot(this.options.responseTime),this.channel.removeEventListener("message",r),this.isApplying=!1,e?this.reApply?this.apply():!1:(this.assumeLead(),!0)}catch{return !1}}awaitLeadership(){if(this.isLeader)return Promise.resolve();let e=!1,r=null;return new Promise(i=>{let o=()=>{if(e)return;e=!0;try{I$1.clearInterval(r);}catch{}let g=this.intervals.indexOf(r);g>=0&&this.intervals.splice(g,1),this.channel.removeEventListener("message",u),i();};r=I$1.setInterval(()=>{this.apply().then(()=>{this.isLeader&&o();});},this.options.fallbackInterval),this.intervals.push(r);let u=g=>{let{action:O}=g.data;O===2&&this.apply().then(()=>{this.isLeader&&o();});};this.channel.addEventListener("message",u);})}sendAction(e){this.channel.postMessage({action:e,token:this.token});}assumeLead(){this.isLeader=!0;let e=r=>{let{action:i}=r.data;i===0&&this.sendAction(1);};return this.channel.addEventListener("message",e),this.listeners.push(e),this.sendAction(1)}waitForLeadership(){return this.deferred?this.deferred:(this.deferred=this.awaitLeadership(),this.deferred)}close(){if(!this.isDead){this.isDead=!0,this.isLeader=!1,this.sendAction(2);try{this.listeners.forEach(e=>this.channel.removeEventListener("message",e)),this.intervals.forEach(e=>I$1.clearInterval(e));}catch{}}}};var Ee$1=class Ee{channel;options;elector;token=Te$1();registry=new Map;allIdle=!1;isLastActive=!1;constructor(e){let{channelName:r}=e;if(this.options=e,this.channel=new st(r),this.registry.set(this.token,1),e.leaderElection){let i={fallbackInterval:2e3,responseTime:100};this.elector=new Ie$1(this.channel,i),this.elector.waitForLeadership();}this.channel.addEventListener("message",i=>{let{action:o,token:u,data:g}=i.data;switch(o){case 3:this.registry.set(u,2);break;case 4:this.registry.delete(u);break;case 5:this.idle(u);break;case 6:this.active(u);break;case 7:this.prompt(u);break;case 8:this.start(u);break;case 9:this.reset(u);break;case 10:this.activate(u);break;case 11:this.pause(u);break;case 12:this.resume(u);break;case 13:this.options.onMessage(g);break}}),this.send(3);}get isLeader(){if(!this.elector)throw new Error('\u274C Leader election is not enabled. To Enable it set the "leaderElection" property to true.');return this.elector.isLeader}prompt(e=this.token){this.registry.set(e,0);let r=[...this.registry.values()].every(i=>i===0);e===this.token&&this.send(7),r&&this.options.onPrompt();}idle(e=this.token){this.registry.set(e,2);let r=[...this.registry.values()].every(i=>i===2);e===this.token&&this.send(5),!this.allIdle&&r&&(this.allIdle=!0,this.options.onIdle());}active(e=this.token){this.allIdle=!1,this.registry.set(e,1);let r=[...this.registry.values()].some(i=>i===1);e===this.token&&this.send(6),r&&this.options.onActive(),this.isLastActive=e===this.token;}start(e=this.token){this.allIdle=!1,this.registry.set(e,1),e===this.token?this.send(8):this.options.start(!0),this.isLastActive=e===this.token;}reset(e=this.token){this.allIdle=!1,this.registry.set(e,1),e===this.token?this.send(9):this.options.reset(!0),this.isLastActive=e===this.token;}activate(e=this.token){this.allIdle=!1,this.registry.set(e,1),e===this.token?this.send(10):this.options.activate(!0),this.isLastActive=e===this.token;}pause(e=this.token){e===this.token?this.send(11):this.options.pause(!0);}resume(e=this.token){e===this.token?this.send(12):this.options.resume(!0);}message(e){try{this.channel.postMessage({action:13,token:this.token,data:e});}catch{}}send(e){try{this.channel.postMessage({action:e,token:this.token});}catch{}}close(){this.options.leaderElection&&this.elector.close(),this.send(4),this.channel.close();}};var at=M$1?document:null,xe$1=["mousemove","keydown","wheel","DOMMouseScroll","mousewheel","mousedown","touchstart","touchmove","MSPointerDown","MSPointerMove","visibilitychange","focus"];function ct(n,e){let r;function i(...o){r&&clearTimeout(r),r=setTimeout(()=>{n(...o),r=null;},e);}return i.cancel=function(){clearTimeout(r);},i}function be$1(n,e){let r=0;return function(...i){let o=new Date().getTime();if(!(o-r<e))return r=o,n(...i)}}var v$1=()=>Date.now();var Z$1=2147483647;function se$1({timeout:n=1e3*60*20,promptTimeout:e=0,promptBeforeIdle:r=0,element:i=at,events:o=xe$1,timers:u=void 0,immediateEvents:g=[],onPresenceChange:O=()=>{},onPrompt:W=()=>{},onIdle:m=()=>{},onActive:a=()=>{},onAction:d=()=>{},onMessage:l=()=>{},debounce:p=0,throttle:f=0,eventsThrottle:B=200,startOnMount:y=!0,startManually:D=!1,stopOnIdle:ce=!1,crossTab:j=!1,name:Oe="idle-timer",syncTimers:ee=0,leaderElection:Ce=!1,disabled:C=!1}={}){let De=useRef(v$1()),ue=useRef(v$1()),w=useRef(null),R=useRef(null),F=useRef(0),te=useRef(0),N=useRef(0),S=useRef(0),h=useRef(!1),E=useRef(!1),H=useRef(!1),_=useRef(!0),re=useRef(!1),U=useRef(null),s=useRef(null),k=useRef(n),G=useRef(0);useEffect(()=>{if(e&&console.warn("\u26A0\uFE0F IdleTimer -- The `promptTimeout` property has been deprecated in favor of `promptBeforeIdle`. It will be removed in the next major release."),r&&e)throw new Error("\u274C Both promptTimeout and promptBeforeIdle can not be set. The promptTimeout property will be deprecated in a future version.");if(n>=Z$1)throw new Error(`\u274C The value for the timeout property must fit in a 32 bit signed integer, ${Z$1}.`);if(e>=Z$1)throw new Error(`\u274C The value for the promptTimeout property must fit in a 32 bit signed integer, ${Z$1}.`);if(r>=Z$1)throw new Error(`\u274C The value for the promptBeforeIdle property must fit in a 32 bit signed integer, ${Z$1}.`);if(r>=n)throw new Error(`\u274C The value for the promptBeforeIdle property must be less than the timeout property, ${n}.`);if(r?(k.current=n-r,G.current=r):(k.current=n,G.current=e),!_.current){if(D||C)return;h.current&&(X.current(null,L),s.current&&s.current.active()),J();}},[n,e,r,D,C]);let Ne=useRef(ce);useEffect(()=>{Ne.current=ce;},[ce]);let He=useRef(g),ne=useRef(i),ye=useRef([...new Set([...o,...g]).values()]),A=useRef(C);useEffect(()=>{A.current=C,!_.current&&(C?fe():D||J());},[C]);let ie=useRef(O);useEffect(()=>{ie.current=O;},[O]);let le=useRef(W);useEffect(()=>{le.current=W;},[W]);let me=useRef(m);useEffect(()=>{me.current=m;},[m]);let X=useRef(a);useEffect(()=>{X.current=a;},[a]);let de=useRef(d);useEffect(()=>{de.current=d;},[d]);let z=useRef(l);useEffect(()=>{z.current=l;},[l]);let q=useMemo(()=>{let t=(P,K)=>de.current(P,K);return p>0?ct(t,p):f>0?be$1(t,f):t},[f,p]),_e=useRef();useEffect(()=>{j&&ee&&(_e.current=be$1(()=>{s.current.active();},ee));},[j,ee]);let x=()=>{U.current!==null&&(I$1.clearTimeout(U.current),U.current=null);},$=(t,P=!0)=>{x(),U.current=I$1.setTimeout(Le,t||k.current),P&&(R.current=v$1());},Ue=t=>{!E.current&&!h.current&&(le.current(t,L),ie.current({type:"active",prompted:!0},L)),S.current=0,N.current=v$1(),E.current=!0,$(G.current,!1);},Fe=()=>{x(),h.current||(me.current(null,L),ie.current({type:"idle"},L)),h.current=!0,w.current=v$1(),Ne.current?Y():E.current&&(N.current=0,E.current=!1);},we=t=>{x(),(h.current||E.current)&&(X.current(t,L),ie.current({type:"active",prompted:!1},L)),E.current=!1,N.current=0,h.current=!1,F.current+=v$1()-w.current,te.current+=v$1()-w.current,V(),$();},Le=t=>{if(!h.current){q.cancel&&q.cancel();let K=v$1()-R.current;if(!(k.current+G.current<K)&&G.current>0&&!E.current){s.current?s.current.prompt():Ue(t);return}s.current?s.current.idle():Fe();return}s.current?s.current.active():we(t);},Pe=t=>{if(!y&&!R.current&&(R.current=v$1(),X.current(null,L)),q(t,L),E.current)return;if(x(),!h.current&&He.current.includes(t.type)){Le(t);return}let P=v$1()-R.current;if(h.current&&!ce||!h.current&&P>=k.current){Le(t);return}H.current=!1,S.current=0,N.current=0,$(),j&&ee&&_e.current();},pe=useRef(Pe);useEffect(()=>{let t=re.current;t&&Y(),B>0?pe.current=be$1(Pe,B):pe.current=Pe,t&&V();},[B,f,p,de,j,ee]);let V=()=>{M$1&&ne.current&&(re.current||(ye.current.forEach(t=>{ne.current.addEventListener(t,pe.current,{capture:!0,passive:!0});}),re.current=!0));},Y=(t=!1)=>{M$1&&ne.current&&(re.current||t)&&(ye.current.forEach(P=>{ne.current.removeEventListener(P,pe.current,{capture:!0});}),re.current=!1);},J=useCallback(t=>A.current?!1:(x(),V(),h.current=!1,E.current=!1,H.current=!1,S.current=0,N.current=0,s.current&&!t&&s.current.start(),$(),!0),[U,h,A,k,s]),Se=useCallback(t=>A.current?!1:(x(),V(),ue.current=v$1(),F.current+=v$1()-w.current,te.current+=v$1()-w.current,F.current=0,h.current=!1,E.current=!1,H.current=!1,S.current=0,N.current=0,s.current&&!t&&s.current.reset(),D||$(),!0),[U,h,k,D,A,s]),Ve=useCallback(t=>A.current?!1:(x(),V(),(h.current||E.current)&&we(),h.current=!1,E.current=!1,H.current=!1,S.current=0,N.current=0,ue.current=v$1(),s.current&&!t&&s.current.activate(),$(),!0),[U,h,E,A,k,s]),fe=useCallback((t=!1)=>A.current||H.current?!1:(S.current=We(),H.current=!0,Y(),x(),s.current&&!t&&s.current.pause(),!0),[U,A,s]),Me=useCallback((t=!1)=>A.current||!H.current?!1:(H.current=!1,E.current||V(),h.current||$(S.current),N.current&&(N.current=v$1()),s.current&&!t&&s.current.resume(),!0),[U,k,A,S,s]),ut=useCallback((t,P)=>(s.current?(P&&z.current(t,L),s.current.message(t)):P&&z.current(t,L),!0),[l]),lt=useCallback(()=>h.current,[h]),mt=useCallback(()=>E.current,[E]),dt=useCallback(()=>s.current?s.current.isLeader:null,[s]),pt=useCallback(()=>s.current?s.current.isLastActive:null,[s]),ft=useCallback(()=>s.current?s.current.token:null,[s]),We=useCallback(()=>{if(H.current)return S.current;let t=S.current?S.current:G.current+k.current,P=R.current?v$1()-R.current:0,K=Math.floor(t-P);return K<0?0:Math.abs(K)},[k,G,E,S,R]),Be=useCallback(()=>Math.round(v$1()-ue.current),[ue]),Ge=useCallback(()=>Math.round(v$1()-De.current),[De]),ht=useCallback(()=>w.current?new Date(w.current):null,[w]),vt=useCallback(()=>R.current?new Date(R.current):null,[R]),qe=useCallback(()=>h.current?Math.round(v$1()-w.current+F.current):Math.round(F.current),[w,F]),$e=useCallback(()=>h.current?Math.round(v$1()-w.current+te.current):Math.round(te.current),[w,te]),Tt=useCallback(()=>{let t=Math.round(Be()-qe());return t>=0?t:0},[w,F]),It=useCallback(()=>{let t=Math.round(Ge()-$e());return t>=0?t:0},[w,F]);useEffect(()=>{if(p>0&&f>0)throw new Error("\u274C onAction can either be throttled or debounced, not both.");u&&it(u);let t=()=>{s.current&&s.current.close(),q.cancel&&q.cancel(),x(),Y(!0);};return M$1&&window.addEventListener("beforeunload",t),()=>{M$1&&window.removeEventListener("beforeunload",t),s.current&&s.current.close(),q.cancel&&q.cancel(),x(),Y(!0);}},[]),useEffect(()=>{s.current&&s.current.close(),j?s.current=new Ee$1({channelName:Oe,leaderElection:Ce,onPrompt:()=>{Ue();},onIdle:()=>{Fe();},onActive:()=>{we();},onMessage:t=>{z.current(t,L);},start:J,reset:Se,activate:Ve,pause:fe,resume:Me}):s.current=null;},[j,Oe,Ce,le,me,X,z,J,Se,fe,Me]),useEffect(()=>{_.current||(x(),Y(!0)),!(D||C)&&(y?J():V());},[D,y,C,_]),useEffect(()=>{if(!_.current){let t=[...new Set([...o,...g]).values()];if(Y(),ye.current=t,ne.current=i,He.current=g,D||C)return;y?J():V();}},[i,JSON.stringify(o),JSON.stringify(g),_,C,D,y]),useEffect(()=>{_.current&&(_.current=!1);},[_]);let L={message:ut,start:J,reset:Se,activate:Ve,pause:fe,resume:Me,isIdle:lt,isPrompted:mt,isLeader:dt,isLastActiveTab:pt,getTabId:ft,getRemainingTime:We,getElapsedTime:Be,getTotalElapsedTime:Ge,getLastIdleTime:ht,getLastActiveTime:vt,getIdleTime:qe,getTotalIdleTime:$e,getActiveTime:Tt,getTotalActiveTime:It,setOnPresenceChange:t=>{O=t,ie.current=t;},setOnPrompt:t=>{W=t,le.current=t;},setOnIdle:t=>{m=t,me.current=t;},setOnActive:t=>{a=t,X.current=t;},setOnAction:t=>{d=t,de.current=t;},setOnMessage:t=>{l=t,z.current=t;}};return L}var ge$1=createContext(null);ge$1.Consumer;

let e={data:""},t=t=>"object"==typeof window?((t?t.querySelector("#_goober"):window._goober)||Object.assign((t||document.head).appendChild(document.createElement("style")),{innerHTML:" ",id:"_goober"})).firstChild:t||e,l=/(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g,a=/\/\*[^]*?\*\/|  +/g,n$1=/\n+/g,o=(e,t)=>{let r="",l="",a="";for(let n in e){let c=e[n];"@"==n[0]?"i"==n[1]?r=n+" "+c+";":l+="f"==n[1]?o(c,n):n+"{"+o(c,"k"==n[1]?"":t)+"}":"object"==typeof c?l+=o(c,t?t.replace(/([^,])+/g,e=>n.replace(/(^:.*)|([^,])+/g,t=>/&/.test(t)?t.replace(/&/g,e):e?e+" "+t:t)):n):null!=c&&(n=/^--/.test(n)?n:n.replace(/[A-Z]/g,"-$&").toLowerCase(),a+=o.p?o.p(n,c):n+":"+c+";");}return r+(t&&a?t+"{"+a+"}":a)+l},c={},s=e=>{if("object"==typeof e){let t="";for(let r in e)t+=r+s(e[r]);return t}return e},i=(e,t,r,i,p)=>{let u=s(e),d=c[u]||(c[u]=(e=>{let t=0,r=11;for(;t<e.length;)r=101*r+e.charCodeAt(t++)>>>0;return "go"+r})(u));if(!c[d]){let t=u!==e?e:(e=>{let t,r,o=[{}];for(;t=l.exec(e.replace(a,""));)t[4]?o.shift():t[3]?(r=t[3].replace(n$1," ").trim(),o.unshift(o[0][r]=o[0][r]||{})):o[0][t[1]]=t[2].replace(n$1," ").trim();return o[0]})(e);c[d]=o(p?{["@keyframes "+d]:t}:t,r?"":"."+d);}let f=r&&c.g?c.g:null;return r&&(c.g=c[d]),((e,t,r,l)=>{l?t.data=t.data.replace(l,e):-1===t.data.indexOf(e)&&(t.data=r?e+t.data:t.data+e);})(c[d],t,i,f),d},p=(e,t,r)=>e.reduce((e,l,a)=>{let n=t[a];if(n&&n.call){let e=n(r),t=e&&e.props&&e.props.className||/^go/.test(e)&&e;n=t?"."+t:e&&"object"==typeof e?e.props?"":o(e,""):!1===e?"":e;}return e+l+(null==n?"":n)},"");function u$1(e){let r=this||{},l=e.call?e(r.p):e;return i(l.unshift?l.raw?p(l,[].slice.call(arguments,1),r.p):l.reduce((e,t)=>Object.assign(e,t&&t.call?t(r.p):t),{}):l,t(r.target),r.g,r.o,r.k)}let d,f,g;u$1.bind({g:1});let h$1=u$1.bind({k:1});function m(e,t,r,l){o.p=t,d=e,f=r,g=l;}function j(e,t){let r=this||{};return function(){let l=arguments;function a(n,o){let c=Object.assign({},n),s=c.className||a.className;r.p=Object.assign({theme:f&&f()},c),r.o=/ *go\d+/.test(s),c.className=u$1.apply(r,l)+(s?" "+s:""),t&&(c.ref=o);let i=e;return e[0]&&(i=c.as||e,delete c.as),g&&i[0]&&g(c),d(i,c)}return t?t(a):a}}

var W=e=>typeof e=="function",T=(e,t)=>W(e)?e(t):e;var U=(()=>{let e=0;return ()=>(++e).toString()})(),b=(()=>{let e;return ()=>{if(e===void 0&&typeof window<"u"){let t=matchMedia("(prefers-reduced-motion: reduce)");e=!t||t.matches;}return e}})();var Q=20;var S=new Map,X=1e3,$=e=>{if(S.has(e))return;let t=setTimeout(()=>{S.delete(e),u({type:4,toastId:e});},X);S.set(e,t);},J=e=>{let t=S.get(e);t&&clearTimeout(t);},v=(e,t)=>{switch(t.type){case 0:return {...e,toasts:[t.toast,...e.toasts].slice(0,Q)};case 1:return t.toast.id&&J(t.toast.id),{...e,toasts:e.toasts.map(r=>r.id===t.toast.id?{...r,...t.toast}:r)};case 2:let{toast:o}=t;return e.toasts.find(r=>r.id===o.id)?v(e,{type:1,toast:o}):v(e,{type:0,toast:o});case 3:let{toastId:s}=t;return s?$(s):e.toasts.forEach(r=>{$(r.id);}),{...e,toasts:e.toasts.map(r=>r.id===s||s===void 0?{...r,visible:!1}:r)};case 4:return t.toastId===void 0?{...e,toasts:[]}:{...e,toasts:e.toasts.filter(r=>r.id!==t.toastId)};case 5:return {...e,pausedAt:t.time};case 6:let a=t.time-(e.pausedAt||0);return {...e,pausedAt:void 0,toasts:e.toasts.map(r=>({...r,pauseDuration:r.pauseDuration+a}))}}},A=[],P={toasts:[],pausedAt:void 0},u=e=>{P=v(P,e),A.forEach(t=>{t(P);});},Y={blank:4e3,error:4e3,success:2e3,loading:1/0,custom:4e3},I=(e={})=>{let[t,o]=useState(P);useEffect(()=>(A.push(o),()=>{let a=A.indexOf(o);a>-1&&A.splice(a,1);}),[t]);let s=t.toasts.map(a=>{var r,c;return {...e,...e[a.type],...a,duration:a.duration||((r=e[a.type])==null?void 0:r.duration)||(e==null?void 0:e.duration)||Y[a.type],style:{...e.style,...(c=e[a.type])==null?void 0:c.style,...a.style}}});return {...t,toasts:s}};var G=(e,t="blank",o)=>({createdAt:Date.now(),visible:!0,type:t,ariaProps:{role:"status","aria-live":"polite"},message:e,pauseDuration:0,...o,id:(o==null?void 0:o.id)||U()}),h=e=>(t,o)=>{let s=G(t,e,o);return u({type:2,toast:s}),s.id},n=(e,t)=>h("blank")(e,t);n.error=h("error");n.success=h("success");n.loading=h("loading");n.custom=h("custom");n.dismiss=e=>{u({type:3,toastId:e});};n.remove=e=>u({type:4,toastId:e});n.promise=(e,t,o)=>{let s=n.loading(t.loading,{...o,...o==null?void 0:o.loading});return e.then(a=>(n.success(T(t.success,a),{id:s,...o,...o==null?void 0:o.success}),a)).catch(a=>{n.error(T(t.error,a),{id:s,...o,...o==null?void 0:o.error});}),e};var Z=(e,t)=>{u({type:1,toast:{id:e,height:t}});},ee=()=>{u({type:5,time:Date.now()});},D=e=>{let{toasts:t,pausedAt:o}=I(e);useEffect(()=>{if(o)return;let r=Date.now(),c=t.map(i=>{if(i.duration===1/0)return;let d=(i.duration||0)+i.pauseDuration-(r-i.createdAt);if(d<0){i.visible&&n.dismiss(i.id);return}return setTimeout(()=>n.dismiss(i.id),d)});return ()=>{c.forEach(i=>i&&clearTimeout(i));}},[t,o]);let s=useCallback(()=>{o&&u({type:6,time:Date.now()});},[o]),a=useCallback((r,c)=>{let{reverseOrder:i=!1,gutter:d=8,defaultPosition:p}=c||{},g=t.filter(m=>(m.position||p)===(r.position||p)&&m.height),E=g.findIndex(m=>m.id===r.id),x=g.filter((m,R)=>R<E&&m.visible).length;return g.filter(m=>m.visible).slice(...i?[x+1]:[0,x]).reduce((m,R)=>m+(R.height||0)+d,0)},[t]);return {toasts:t,handlers:{updateHeight:Z,startPause:ee,endPause:s,calculateOffset:a}}};var oe=h$1`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`,re=h$1`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`,se=h$1`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`,_=j("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${e=>e.primary||"#ff4b4b"};
  position: relative;
  transform: rotate(45deg);

  animation: ${oe} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${re} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${e=>e.secondary||"#fff"};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${se} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`;var ne=h$1`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`,V=j("div")`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${e=>e.secondary||"#e0e0e0"};
  border-right-color: ${e=>e.primary||"#616161"};
  animation: ${ne} 1s linear infinite;
`;var pe=h$1`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`,de=h$1`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`,w=j("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${e=>e.primary||"#61d345"};
  position: relative;
  transform: rotate(45deg);

  animation: ${pe} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${de} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${e=>e.secondary||"#fff"};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`;var ue=j("div")`
  position: absolute;
`,le=j("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`,Te=h$1`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`,fe=j("div")`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${Te} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`,M=({toast:e})=>{let{icon:t,type:o,iconTheme:s}=e;return t!==void 0?typeof t=="string"?React.createElement(fe,null,t):t:o==="blank"?null:React.createElement(le,null,React.createElement(V,{...s}),o!=="loading"&&React.createElement(ue,null,o==="error"?React.createElement(_,{...s}):React.createElement(w,{...s})))};var ye=e=>`
0% {transform: translate3d(0,${e*-200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`,ge=e=>`
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${e*-150}%,-1px) scale(.6); opacity:0;}
`,he="0%{opacity:0;} 100%{opacity:1;}",xe="0%{opacity:1;} 100%{opacity:0;}",be=j("div")`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`,Se=j("div")`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`,Ae=(e,t)=>{let s=e.includes("top")?1:-1,[a,r]=b()?[he,xe]:[ye(s),ge(s)];return {animation:t?`${h$1(a)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards`:`${h$1(r)} 0.4s forwards cubic-bezier(.06,.71,.55,1)`}},F=React.memo(({toast:e,position:t,style:o,children:s})=>{let a=e.height?Ae(e.position||t||"top-center",e.visible):{opacity:0},r=React.createElement(M,{toast:e}),c=React.createElement(Se,{...e.ariaProps},T(e.message,e));return React.createElement(be,{className:e.className,style:{...a,...o,...e.style}},typeof s=="function"?s({icon:r,message:c}):React.createElement(React.Fragment,null,r,c))});m(React.createElement);var Ee=({id:e,className:t,style:o,onHeightUpdate:s,children:a})=>{let r=React.useCallback(c=>{if(c){let i=()=>{let d=c.getBoundingClientRect().height;s(e,d);};i(),new MutationObserver(i).observe(c,{subtree:!0,childList:!0,characterData:!0});}},[e,s]);return React.createElement("div",{ref:r,className:t,style:o},a)},Re=(e,t)=>{let o=e.includes("top"),s=o?{top:0}:{bottom:0},a=e.includes("center")?{justifyContent:"center"}:e.includes("right")?{justifyContent:"flex-end"}:{};return {left:0,right:0,display:"flex",position:"absolute",transition:b()?void 0:"all 230ms cubic-bezier(.21,1.02,.73,1)",transform:`translateY(${t*(o?1:-1)}px)`,...s,...a}},ve=u$1`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`,O=16,Ie=({reverseOrder:e,position:t="top-center",toastOptions:o,gutter:s,children:a,containerStyle:r,containerClassName:c})=>{let{toasts:i,handlers:d}=D(o);return React.createElement("div",{style:{position:"fixed",zIndex:9999,top:O,left:O,right:O,bottom:O,pointerEvents:"none",...r},className:c,onMouseEnter:d.startPause,onMouseLeave:d.endPause},i.map(p=>{let g=p.position||t,E=d.calculateOffset(p,{reverseOrder:e,gutter:s,defaultPosition:t}),x=Re(g,E);return React.createElement(Ee,{id:p.id,key:p.id,onHeightUpdate:d.updateHeight,className:p.visible?ve:"",style:x},p.type==="custom"?T(p.message,p):a?a(p):React.createElement(F,{toast:p,position:g}))}))};var _t=n;

const queryClient = new QueryClient();
const RTAuthWrapperBase = ({ apiUrl, children, locale, loginParams, showSSO, flags, mockData }) => {
    const [i18n, setI18n] = useState(TranslationHelper.getInstance(locale).i18n);
    const requestHelper = RequestHelper.getInstance(apiUrl);
    const [currentUser, setCurrentUser] = useState(blankUser);
    const [currentTenant, setCurrentTenant] = useState(undefined);
    const [loginModalOpen, setLoginModalOpen] = useState(false);
    const [idleTime, setIdleTime] = useState(10000000);
    const inactiveRef = React__default.useRef(false);
    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const code = queryParams.get('code');
        const state = queryParams.get('state') || '';
        console.log('code', code);
        if (code) {
            performCodeLogin(code, state);
            // Strip the code from the url
            window.history.replaceState({}, document.title, window.location.pathname);
        }
    });
    const performCodeLogin = (code, state) => __awaiter$1(void 0, void 0, void 0, function* () {
        const res = yield requestHelper.codeLogin({ code, state });
        if (res) {
            const body = yield res.data;
            if (body.redirectUrl && body.redirectUrl.length > 0) {
                window.location.href = generateUrl(body.redirectUrl, { loginSuccessful: 'true' });
            }
            setLoginModalOpen(false);
            refetch();
        }
    });
    const onIdle = () => {
        _t(i18n.t('idle_logged_out_warning'), { icon: '👋', duration: 11000, position: 'bottom-right' });
        inactiveRef.current = true;
        setTimeout(() => {
            onIdleLogout(inactiveRef.current);
        }, 10000);
    };
    const onActive = () => {
        inactiveRef.current = false;
        idleTimer.reset();
        _t.dismiss();
    };
    const onIdleLogout = (isActive) => {
        if (isActive) {
            logout();
            _t.dismiss();
            _t(i18n.t('logged_out'), { icon: '👋', duration: 10000000, position: 'bottom-right' });
            idleTimer.pause();
        }
    };
    const idleTimer = se$1({ onIdle, onActive, throttle: 200, timeout: idleTime, crossTab: true, syncTimers: 1, startManually: true });
    const getCurrentUserFN = () => __awaiter$1(void 0, void 0, void 0, function* () {
        if (mockData) {
            setCurrentUser(mockData.user);
            setCurrentTenant(mockData.tenant);
            return mockData.user;
        }
        const curUser = yield requestHelper.getCurrentUserWithTenant();
        if (!curUser) {
            throw new Error('No user found');
        }
        setCurrentUser(curUser.user);
        setCurrentTenant(curUser.tenant);
        return curUser;
    });
    const { isLoading: loading, isLoadingError, error: currentUserError, isError, refetch } = useQuery({
        queryKey: ['currentUser'],
        queryFn: getCurrentUserFN,
        retry: 1,
        retryOnMount: false,
        refetchOnWindowFocus: false
    });
    const logout = () => __awaiter$1(void 0, void 0, void 0, function* () {
        yield requestHelper.logOutUser();
        setCurrentUser(blankUser);
        setCurrentTenant(undefined);
        if (loginParams) {
            setLoginModalOpen(true);
        }
    });
    useEffect(() => {
        setI18n(TranslationHelper.getInstance(locale).i18n);
    }, [locale]);
    useEffect(() => {
        if (currentTenant && currentTenant.idleTimeoutSeconds) {
            setIdleTime(currentTenant.idleTimeoutSeconds * 1000);
            idleTimer.start();
            _t.dismiss();
        }
    }, [currentTenant, idleTimer]);
    useEffect(() => {
        if (loginParams && currentUserError) {
            handleLoginModalOpen();
        }
    }, [currentUserError, loginParams, isError]);
    const handleLoginModalOpen = () => {
        setLoginModalOpen(true);
    };
    const handleLoginModalClose = () => {
        setLoginModalOpen(false);
    };
    const loginComplete = () => {
        handleLoginModalClose();
        refetch();
    };
    const ssoDetails = loginParams || { microsoftClientId: '', googleClientId: '', oktaBaseURL: '', oktaClientId: '' };
    return (React__default.createElement(ThemeProvider, { theme: theme },
        React__default.createElement(QueryClientProvider, { client: queryClient },
            React__default.createElement(AuthContext.Provider, { value: { currentUser, i18n, logout, flags: flags || {}, ssoDetails } },
                React__default.createElement(React__default.Fragment, null,
                    loading || (isLoadingError && loginParams) ?
                        React__default.createElement(ScaleLoader, { role: 'auth-loading', className: "auth-wrapper-loading", color: colors.primary10 }) : React__default.createElement(React__default.Fragment, null, children),
                    React__default.createElement(Ie, null),
                    loginParams && React__default.createElement(RTModal, { open: loginModalOpen, onClose: handleLoginModalClose, width: "narrow" },
                        React__default.createElement(Box, { sx: { padding: '50px 20px 20px 20px' } }, loginParams &&
                            React__default.createElement(RTLoginSSOFlow$1, { apiUrl: apiUrl, showSSO: showSSO || false, ssoDetails: ssoDetails, onLoginCompleteCallback: loginComplete, noBox: true, locale: locale || 'en' }))))))));
};
const RTAuthWrapper$1 = (props) => {
    return (React__default.createElement(QueryClientProvider, { client: queryClient },
        React__default.createElement(RTAuthWrapperBase, Object.assign({}, props))));
};

const RTLogin = RTLogin$1;
const RTChangePassword = RTChangePassword$1;
const RTLoginSSOFlow = RTLoginSSOFlow$1;
const RTAPIToken = RTAPIToken$1;
const RTEditTenant = RTEditTenantFields;
const RTEditUser = RTEditUser$1;
const RTListUsers = RTListUsers$1;
const RTTenantCustomerFields = RTTenantCustomerFields$1;
const RTTenantPlatformFields = RTTenantPlatformFields$1;
const RTTenantCoreFields = RTTenantCoreFields$1;
const RTTenantSecurityFields = RTTenantSecurityFields$1;
const RTGlobalSearch = RTGlobalSearch$1;
const RTUserDropdown = RTUserDropdown$1;
const RTHelpDropdown = RTHelpDropdown$1;
const RTListTenants = RTListTenants$1;
const RTDropdown = RTDropdown$1;
const RTAuthWrapper = RTAuthWrapper$1;
const useAuth = useAuth$1;

export { FieldControlStyling, PasswordFieldStyling, RTAPIToken, RTAuthWrapper, RTChangePassword, RTDropdown, RTEditTenant, RTEditUser, RTGlobalSearch, RTHelpDropdown, RTListTenants, RTListUsers, RTLogin, RTLoginSSOFlow, RTTenantCoreFields, RTTenantCustomerFields, RTTenantPlatformFields, RTTenantSecurityFields, RTUserDropdown, TextFieldStyling, useAuth };
//# sourceMappingURL=index.js.map
